interface ZipcodeDatabase {
  [zipcode: string]: number;
}

const zipcodeDatabase: ZipcodeDatabase = {
  10001: 0,
  10002: 0,
  10003: 0,
  10004: 0,
  10005: 0,
  10006: 0,
  10007: 0,
  10008: 0,
  10009: 0,
  10010: 0,
  10011: 0,
  10012: 0,
  10013: 0,
  10014: 0,
  10015: 0,
  10016: 0,
  10017: 0,
  10018: 0,
  10019: 0,
  10020: 0,
  10021: 0,
  10022: 0,
  10023: 0,
  10024: 0,
  10025: 0,
  10026: 0,
  10027: 0,
  10028: 0,
  10029: 0,
  10030: 0,
  10031: 0,
  10032: 0,
  10033: 0,
  10034: 0,
  10035: 0,
  10036: 0,
  10037: 0,
  10038: 0,
  10039: 0,
  10040: 0,
  10041: 0,
  10043: 0,
  10044: 0,
  10045: 0,
  10046: 0,
  10047: 0,
  10048: 0,
  10055: 0,
  10060: 0,
  10065: 0,
  10069: 0,
  10072: 0,
  10075: 0,
  10079: 0,
  10080: 0,
  10081: 0,
  10082: 0,
  10087: 0,
  10090: 0,
  10094: 0,
  10095: 0,
  10096: 0,
  10098: 0,
  10099: 0,
  10101: 0,
  10102: 0,
  10103: 0,
  10104: 0,
  10105: 0,
  10106: 0,
  10107: 0,
  10108: 0,
  10109: 0,
  10110: 0,
  10111: 0,
  10112: 0,
  10113: 0,
  10114: 0,
  10115: 0,
  10116: 0,
  10117: 0,
  10118: 0,
  10119: 0,
  10120: 0,
  10121: 0,
  10122: 0,
  10123: 0,
  10124: 0,
  10125: 0,
  10126: 0,
  10128: 0,
  10129: 0,
  10130: 0,
  10131: 0,
  10132: 0,
  10133: 0,
  10138: 0,
  10149: 0,
  10150: 0,
  10151: 0,
  10152: 0,
  10153: 0,
  10154: 0,
  10155: 0,
  10156: 0,
  10157: 0,
  10158: 0,
  10159: 0,
  10160: 0,
  10161: 0,
  10162: 0,
  10163: 0,
  10164: 0,
  10165: 0,
  10166: 0,
  10167: 0,
  10168: 0,
  10169: 0,
  10170: 0,
  10171: 0,
  10172: 0,
  10173: 0,
  10174: 0,
  10175: 0,
  10176: 0,
  10177: 0,
  10178: 0,
  10179: 0,
  10184: 0,
  10185: 0,
  10196: 0,
  10197: 0,
  10199: 0,
  10203: 0,
  10211: 0,
  10212: 0,
  10213: 0,
  10242: 0,
  10249: 0,
  10256: 0,
  10257: 0,
  10258: 0,
  10259: 0,
  10260: 0,
  10261: 0,
  10265: 0,
  10268: 0,
  10269: 0,
  10270: 0,
  10271: 0,
  10272: 0,
  10273: 0,
  10274: 0,
  10275: 0,
  10276: 0,
  10277: 0,
  10278: 0,
  10279: 0,
  10280: 0,
  10281: 0,
  10282: 0,
  10285: 0,
  10286: 0,
  10292: 0,
  10301: 0,
  10302: 0,
  10303: 0,
  10304: 0,
  10305: 0,
  10306: 0,
  10307: 0,
  10308: 0,
  10309: 0,
  10310: 0,
  10311: 0,
  10312: 0,
  10313: 0,
  10314: 0,
  10451: 0,
  10452: 0,
  10453: 0,
  10454: 0,
  10455: 0,
  10456: 0,
  10457: 0,
  10458: 0,
  10459: 0,
  10460: 0,
  10461: 0,
  10462: 0,
  10463: 0,
  10464: 0,
  10465: 0,
  10466: 0,
  10467: 0,
  10468: 0,
  10469: 0,
  10470: 0,
  10471: 0,
  10472: 0,
  10473: 0,
  10474: 0,
  10475: 0,
  10499: 0,
  10501: 0,
  10502: 0,
  10503: 0,
  10504: 0,
  10505: 0,
  10506: 0,
  10507: 0,
  10509: 0,
  10510: 0,
  10511: 0,
  10512: 0,
  10514: 0,
  10516: 0,
  10517: 0,
  10518: 0,
  10519: 0,
  10520: 0,
  10521: 0,
  10522: 0,
  10523: 0,
  10524: 0,
  10526: 0,
  10527: 0,
  10528: 0,
  10530: 0,
  10532: 0,
  10533: 0,
  10535: 0,
  10536: 0,
  10537: 0,
  10538: 0,
  10540: 0,
  10541: 0,
  10542: 0,
  10543: 0,
  10545: 0,
  10546: 0,
  10547: 0,
  10548: 0,
  10549: 0,
  10550: 0,
  10551: 0,
  10552: 0,
  10553: 0,
  10557: 0,
  10558: 0,
  10560: 0,
  10562: 0,
  10566: 0,
  10567: 0,
  10570: 0,
  10571: 0,
  10572: 0,
  10573: 0,
  10576: 0,
  10577: 0,
  10578: 0,
  10579: 0,
  10580: 0,
  10583: 0,
  10587: 0,
  10588: 0,
  10589: 0,
  10590: 0,
  10591: 0,
  10594: 0,
  10595: 0,
  10596: 0,
  10597: 0,
  10598: 0,
  10601: 0,
  10602: 0,
  10603: 0,
  10604: 0,
  10605: 0,
  10606: 0,
  10607: 0,
  10610: 0,
  10650: 0,
  10701: 0,
  10702: 0,
  10703: 0,
  10704: 0,
  10705: 0,
  10706: 0,
  10707: 0,
  10708: 0,
  10709: 0,
  10710: 0,
  10801: 0,
  10802: 0,
  10803: 0,
  10804: 0,
  10805: 0,
  10901: 0,
  10910: 0,
  10911: 0,
  10912: 0,
  10913: 0,
  10914: 0,
  10915: 0,
  10916: 0,
  10917: 0,
  10918: 0,
  10919: 0,
  10920: 0,
  10921: 0,
  10922: 0,
  10923: 0,
  10924: 0,
  10925: 0,
  10926: 0,
  10927: 0,
  10928: 0,
  10930: 0,
  10931: 0,
  10932: 0,
  10933: 0,
  10940: 0,
  10941: 0,
  10943: 0,
  10949: 0,
  10950: 0,
  10952: 0,
  10953: 0,
  10954: 0,
  10956: 0,
  10958: 0,
  10959: 0,
  10960: 0,
  10962: 0,
  10963: 0,
  10964: 0,
  10965: 0,
  10968: 0,
  10969: 0,
  10970: 0,
  10973: 0,
  10974: 0,
  10975: 0,
  10976: 0,
  10977: 0,
  10979: 0,
  10980: 0,
  10981: 0,
  10982: 0,
  10983: 0,
  10984: 0,
  10985: 0,
  10986: 0,
  10987: 0,
  10988: 0,
  10989: 0,
  10990: 0,
  10992: 0,
  10993: 0,
  10994: 0,
  10996: 0,
  10997: 0,
  10998: 0,
  11001: 0,
  11002: 0,
  11003: 0,
  11004: 0,
  11005: 0,
  11010: 0,
  11020: 0,
  11021: 0,
  11022: 0,
  11023: 0,
  11024: 0,
  11025: 0,
  11026: 0,
  11027: 0,
  11030: 0,
  11040: 0,
  11041: 0,
  11042: 0,
  11043: 0,
  11044: 0,
  11050: 0,
  11051: 0,
  11052: 0,
  11053: 0,
  11054: 0,
  11055: 0,
  11096: 0,
  11099: 0,
  11101: 0,
  11102: 0,
  11103: 0,
  11104: 0,
  11105: 0,
  11106: 0,
  11109: 0,
  11120: 0,
  11201: 0,
  11202: 0,
  11203: 0,
  11204: 0,
  11205: 0,
  11206: 0,
  11207: 0,
  11208: 0,
  11209: 0,
  11210: 0,
  11211: 0,
  11212: 0,
  11213: 0,
  11214: 0,
  11215: 0,
  11216: 0,
  11217: 0,
  11218: 0,
  11219: 0,
  11220: 0,
  11221: 0,
  11222: 0,
  11223: 0,
  11224: 0,
  11225: 0,
  11226: 0,
  11228: 0,
  11229: 0,
  11230: 0,
  11231: 0,
  11232: 0,
  11233: 0,
  11234: 0,
  11235: 0,
  11236: 0,
  11237: 0,
  11238: 0,
  11239: 0,
  11240: 0,
  11241: 0,
  11242: 0,
  11243: 0,
  11244: 0,
  11245: 0,
  11247: 0,
  11248: 0,
  11249: 0,
  11251: 0,
  11252: 0,
  11254: 0,
  11255: 0,
  11256: 0,
  11351: 0,
  11352: 0,
  11354: 0,
  11355: 0,
  11356: 0,
  11357: 0,
  11358: 0,
  11359: 0,
  11360: 0,
  11361: 0,
  11362: 0,
  11363: 0,
  11364: 0,
  11365: 0,
  11366: 0,
  11367: 0,
  11368: 0,
  11369: 0,
  11370: 0,
  11371: 0,
  11372: 0,
  11373: 0,
  11374: 0,
  11375: 0,
  11377: 0,
  11378: 0,
  11379: 0,
  11380: 0,
  11381: 0,
  11385: 0,
  11386: 0,
  11390: 0,
  11405: 0,
  11411: 0,
  11412: 0,
  11413: 0,
  11414: 0,
  11415: 0,
  11416: 0,
  11417: 0,
  11418: 0,
  11419: 0,
  11420: 0,
  11421: 0,
  11422: 0,
  11423: 0,
  11424: 0,
  11425: 0,
  11426: 0,
  11427: 0,
  11428: 0,
  11429: 0,
  11430: 0,
  11431: 0,
  11432: 0,
  11433: 0,
  11434: 0,
  11435: 0,
  11436: 0,
  11439: 0,
  11451: 0,
  11484: 0,
  11499: 0,
  11501: 0,
  11507: 0,
  11509: 0,
  11510: 0,
  11514: 0,
  11516: 0,
  11518: 0,
  11520: 0,
  11530: 0,
  11531: 0,
  11535: 0,
  11536: 0,
  11542: 0,
  11545: 0,
  11547: 0,
  11548: 0,
  11549: 0,
  11550: 0,
  11551: 0,
  11552: 0,
  11553: 0,
  11554: 0,
  11555: 0,
  11556: 0,
  11557: 0,
  11558: 0,
  11559: 0,
  11560: 0,
  11561: 0,
  11563: 0,
  11564: 0,
  11565: 0,
  11566: 0,
  11568: 0,
  11569: 0,
  11570: 0,
  11571: 0,
  11572: 0,
  11575: 0,
  11576: 0,
  11577: 0,
  11579: 0,
  11580: 0,
  11581: 0,
  11582: 0,
  11583: 0,
  11588: 0,
  11590: 0,
  11592: 0,
  11593: 0,
  11594: 0,
  11595: 0,
  11596: 0,
  11597: 0,
  11598: 0,
  11599: 0,
  11690: 0,
  11691: 0,
  11692: 0,
  11693: 0,
  11694: 0,
  11695: 0,
  11697: 0,
  11701: 0,
  11702: 0,
  11703: 0,
  11704: 0,
  11705: 0,
  11706: 0,
  11707: 0,
  11708: 0,
  11709: 0,
  11710: 0,
  11713: 0,
  11714: 0,
  11715: 0,
  11716: 0,
  11717: 0,
  11718: 0,
  11719: 0,
  11720: 0,
  11721: 0,
  11722: 0,
  11724: 0,
  11725: 0,
  11726: 0,
  11727: 0,
  11729: 0,
  11730: 0,
  11731: 0,
  11732: 0,
  11733: 0,
  11735: 0,
  11736: 0,
  11737: 0,
  11738: 0,
  11739: 0,
  11740: 0,
  11741: 0,
  11742: 0,
  11743: 0,
  11745: 0,
  11746: 0,
  11747: 0,
  11749: 0,
  11750: 0,
  11751: 0,
  11752: 0,
  11753: 0,
  11754: 0,
  11755: 0,
  11756: 0,
  11757: 0,
  11758: 0,
  11760: 0,
  11762: 0,
  11763: 0,
  11764: 0,
  11765: 0,
  11766: 0,
  11767: 0,
  11768: 0,
  11769: 0,
  11770: 0,
  11771: 0,
  11772: 0,
  11773: 0,
  11774: 0,
  11775: 0,
  11776: 0,
  11777: 0,
  11778: 0,
  11779: 0,
  11780: 0,
  11782: 0,
  11783: 0,
  11784: 0,
  11786: 0,
  11787: 0,
  11788: 0,
  11789: 0,
  11790: 0,
  11791: 0,
  11792: 0,
  11793: 0,
  11794: 0,
  11795: 0,
  11796: 0,
  11797: 0,
  11798: 0,
  11801: 0,
  11802: 0,
  11803: 0,
  11804: 0,
  11805: 0,
  11815: 0,
  11819: 0,
  11853: 0,
  11854: 0,
  11855: 0,
  11901: 0,
  11930: 0,
  11931: 0,
  11932: 0,
  11933: 0,
  11934: 0,
  11935: 0,
  11937: 0,
  11939: 0,
  11940: 0,
  11941: 0,
  11942: 0,
  11944: 0,
  11946: 0,
  11947: 0,
  11948: 0,
  11949: 0,
  11950: 0,
  11951: 0,
  11952: 0,
  11953: 0,
  11954: 0,
  11955: 0,
  11956: 0,
  11957: 0,
  11958: 0,
  11959: 0,
  11960: 0,
  11961: 0,
  11962: 0,
  11963: 0,
  11964: 0,
  11965: 0,
  11967: 0,
  11968: 0,
  11969: 0,
  11970: 0,
  11971: 0,
  11972: 0,
  11973: 0,
  11975: 0,
  11976: 0,
  11977: 0,
  11978: 0,
  11980: 0,
  12007: 0,
  12008: 0,
  12009: 0,
  12010: 0,
  12015: 0,
  12016: 0,
  12017: 0,
  12018: 0,
  12019: 0,
  12020: 0,
  12022: 0,
  12023: 0,
  12024: 0,
  12025: 0,
  12027: 0,
  12028: 0,
  12029: 0,
  12031: 0,
  12032: 0,
  12033: 0,
  12035: 0,
  12036: 0,
  12037: 0,
  12040: 0,
  12041: 0,
  12042: 0,
  12043: 0,
  12045: 0,
  12046: 0,
  12047: 0,
  12050: 0,
  12051: 0,
  12052: 0,
  12053: 0,
  12054: 0,
  12055: 0,
  12056: 0,
  12057: 0,
  12058: 0,
  12059: 0,
  12060: 0,
  12061: 0,
  12062: 0,
  12063: 0,
  12064: 0,
  12065: 0,
  12066: 0,
  12067: 0,
  12068: 0,
  12069: 0,
  12070: 0,
  12071: 0,
  12072: 0,
  12073: 0,
  12074: 0,
  12075: 0,
  12076: 0,
  12077: 0,
  12078: 0,
  12082: 0,
  12083: 0,
  12084: 0,
  12085: 0,
  12086: 0,
  12087: 0,
  12089: 0,
  12090: 0,
  12092: 0,
  12094: 0,
  12095: 0,
  12106: 0,
  12107: 0,
  12108: 0,
  12110: 0,
  12111: 0,
  12115: 0,
  12116: 0,
  12117: 0,
  12118: 0,
  12120: 0,
  12121: 0,
  12122: 0,
  12123: 0,
  12124: 0,
  12125: 0,
  12128: 0,
  12130: 0,
  12131: 0,
  12132: 0,
  12133: 0,
  12134: 0,
  12136: 0,
  12137: 0,
  12138: 0,
  12139: 0,
  12140: 0,
  12141: 0,
  12143: 0,
  12144: 0,
  12147: 0,
  12148: 0,
  12149: 0,
  12150: 0,
  12151: 0,
  12153: 0,
  12154: 0,
  12155: 0,
  12156: 0,
  12157: 0,
  12158: 0,
  12159: 0,
  12160: 0,
  12161: 0,
  12164: 0,
  12165: 0,
  12166: 0,
  12167: 0,
  12168: 0,
  12169: 0,
  12170: 0,
  12172: 0,
  12173: 0,
  12174: 0,
  12175: 0,
  12176: 0,
  12177: 0,
  12179: 0,
  12180: 0,
  12181: 0,
  12182: 0,
  12183: 0,
  12184: 0,
  12185: 0,
  12186: 0,
  12187: 0,
  12188: 0,
  12189: 0,
  12190: 0,
  12192: 0,
  12193: 0,
  12194: 0,
  12195: 0,
  12196: 0,
  12197: 0,
  12198: 0,
  12201: 0,
  12202: 0,
  12203: 0,
  12204: 0,
  12205: 0,
  12206: 0,
  12207: 0,
  12208: 0,
  12209: 0,
  12210: 0,
  12211: 0,
  12212: 0,
  12214: 0,
  12220: 0,
  12222: 0,
  12223: 0,
  12224: 0,
  12225: 0,
  12226: 0,
  12227: 0,
  12228: 0,
  12229: 0,
  12230: 0,
  12231: 0,
  12232: 0,
  12233: 0,
  12234: 0,
  12235: 0,
  12236: 0,
  12237: 0,
  12238: 0,
  12239: 0,
  12240: 0,
  12241: 0,
  12242: 0,
  12243: 0,
  12244: 0,
  12245: 0,
  12246: 0,
  12247: 0,
  12248: 0,
  12249: 0,
  12250: 0,
  12252: 0,
  12255: 0,
  12256: 0,
  12257: 0,
  12260: 0,
  12261: 0,
  12262: 0,
  12288: 0,
  12301: 0,
  12302: 0,
  12303: 0,
  12304: 0,
  12305: 0,
  12306: 0,
  12307: 0,
  12308: 0,
  12309: 0,
  12325: 0,
  12345: 0,
  12401: 0,
  12402: 0,
  12404: 0,
  12405: 0,
  12406: 0,
  12407: 0,
  12410: 0,
  12411: 0,
  12412: 0,
  12413: 0,
  12414: 0,
  12416: 0,
  12417: 0,
  12418: 0,
  12419: 0,
  12420: 0,
  12421: 0,
  12422: 0,
  12423: 0,
  12424: 0,
  12427: 0,
  12428: 0,
  12429: 0,
  12430: 0,
  12431: 0,
  12432: 0,
  12433: 0,
  12434: 0,
  12435: 0,
  12436: 0,
  12438: 0,
  12439: 0,
  12440: 0,
  12441: 0,
  12442: 0,
  12443: 0,
  12444: 0,
  12446: 0,
  12448: 0,
  12449: 0,
  12450: 0,
  12451: 0,
  12452: 0,
  12453: 0,
  12454: 0,
  12455: 0,
  12456: 0,
  12457: 0,
  12458: 0,
  12459: 0,
  12460: 0,
  12461: 0,
  12463: 0,
  12464: 0,
  12465: 0,
  12466: 0,
  12468: 0,
  12469: 0,
  12470: 0,
  12471: 0,
  12472: 0,
  12473: 0,
  12474: 0,
  12475: 0,
  12477: 0,
  12480: 0,
  12481: 0,
  12482: 0,
  12483: 0,
  12484: 0,
  12485: 0,
  12486: 0,
  12487: 0,
  12489: 0,
  12490: 0,
  12491: 0,
  12492: 0,
  12493: 0,
  12494: 0,
  12495: 0,
  12496: 0,
  12498: 0,
  12501: 0,
  12502: 0,
  12503: 0,
  12504: 0,
  12506: 0,
  12507: 0,
  12508: 0,
  12510: 0,
  12511: 0,
  12512: 0,
  12513: 0,
  12514: 0,
  12515: 0,
  12516: 0,
  12517: 0,
  12518: 0,
  12520: 0,
  12521: 0,
  12522: 0,
  12523: 0,
  12524: 0,
  12525: 0,
  12526: 0,
  12527: 0,
  12528: 0,
  12529: 0,
  12530: 0,
  12531: 0,
  12533: 0,
  12534: 0,
  12537: 0,
  12538: 0,
  12540: 0,
  12541: 0,
  12542: 0,
  12543: 0,
  12544: 0,
  12545: 0,
  12546: 0,
  12547: 0,
  12548: 0,
  12549: 0,
  12550: 0,
  12551: 0,
  12552: 0,
  12553: 0,
  12555: 0,
  12561: 0,
  12563: 0,
  12564: 0,
  12565: 0,
  12566: 0,
  12567: 0,
  12568: 0,
  12569: 0,
  12570: 0,
  12571: 0,
  12572: 0,
  12574: 0,
  12575: 0,
  12577: 0,
  12578: 0,
  12580: 0,
  12581: 0,
  12582: 0,
  12583: 0,
  12584: 0,
  12585: 0,
  12586: 0,
  12588: 0,
  12589: 0,
  12590: 0,
  12592: 0,
  12593: 0,
  12594: 0,
  12601: 0,
  12602: 0,
  12603: 0,
  12604: 0,
  12701: 0,
  12719: 0,
  12720: 0,
  12721: 0,
  12722: 0,
  12723: 0,
  12724: 0,
  12725: 0,
  12726: 0,
  12727: 0,
  12729: 0,
  12732: 0,
  12733: 0,
  12734: 0,
  12736: 0,
  12737: 0,
  12738: 0,
  12740: 0,
  12741: 0,
  12742: 0,
  12743: 0,
  12745: 0,
  12746: 0,
  12747: 0,
  12748: 0,
  12749: 0,
  12750: 0,
  12751: 0,
  12752: 0,
  12754: 0,
  12758: 0,
  12759: 0,
  12760: 0,
  12762: 0,
  12763: 0,
  12764: 0,
  12765: 0,
  12766: 0,
  12767: 0,
  12768: 0,
  12769: 0,
  12770: 0,
  12771: 0,
  12775: 0,
  12776: 0,
  12777: 0,
  12778: 0,
  12779: 0,
  12780: 0,
  12781: 0,
  12782: 0,
  12783: 0,
  12784: 0,
  12785: 0,
  12786: 0,
  12787: 0,
  12788: 0,
  12789: 0,
  12790: 0,
  12791: 0,
  12792: 0,
  12801: 0,
  12803: 0,
  12804: 0,
  12808: 0,
  12809: 0,
  12810: 0,
  12811: 0,
  12812: 0,
  12814: 0,
  12815: 0,
  12816: 0,
  12817: 0,
  12819: 0,
  12820: 0,
  12821: 0,
  12822: 0,
  12823: 0,
  12824: 0,
  12827: 0,
  12828: 0,
  12831: 0,
  12832: 0,
  12833: 0,
  12834: 0,
  12835: 0,
  12836: 0,
  12837: 0,
  12838: 0,
  12839: 0,
  12841: 0,
  12842: 0,
  12843: 0,
  12844: 0,
  12845: 0,
  12846: 0,
  12847: 0,
  12848: 0,
  12849: 0,
  12850: 0,
  12851: 0,
  12852: 0,
  12853: 0,
  12854: 0,
  12855: 0,
  12856: 0,
  12857: 0,
  12858: 0,
  12859: 0,
  12860: 0,
  12861: 0,
  12862: 0,
  12863: 0,
  12864: 0,
  12865: 0,
  12866: 0,
  12870: 0,
  12871: 0,
  12872: 0,
  12873: 0,
  12874: 0,
  12878: 0,
  12879: 0,
  12883: 0,
  12884: 0,
  12885: 0,
  12886: 0,
  12887: 0,
  12901: 0,
  12903: 0,
  12910: 0,
  12911: 0,
  12912: 0,
  12913: 0,
  12914: 0,
  12915: 0,
  12916: 0,
  12917: 0,
  12918: 0,
  12919: 0,
  12920: 0,
  12921: 0,
  12922: 0,
  12923: 0,
  12924: 0,
  12926: 0,
  12927: 0,
  12928: 0,
  12929: 0,
  12930: 0,
  12932: 0,
  12933: 0,
  12934: 0,
  12935: 0,
  12936: 0,
  12937: 0,
  12939: 0,
  12941: 0,
  12942: 0,
  12943: 0,
  12944: 0,
  12945: 0,
  12946: 0,
  12949: 0,
  12950: 0,
  12952: 0,
  12953: 0,
  12955: 0,
  12956: 0,
  12957: 0,
  12958: 0,
  12959: 0,
  12960: 0,
  12961: 0,
  12962: 0,
  12964: 0,
  12965: 0,
  12966: 0,
  12967: 0,
  12969: 0,
  12970: 0,
  12972: 0,
  12973: 0,
  12974: 0,
  12975: 0,
  12976: 0,
  12977: 0,
  12978: 0,
  12979: 0,
  12980: 0,
  12981: 0,
  12983: 0,
  12985: 0,
  12986: 0,
  12987: 0,
  12989: 0,
  12992: 0,
  12993: 0,
  12995: 0,
  12996: 0,
  12997: 0,
  12998: 0,
  13020: 0,
  13021: 0,
  13022: 0,
  13024: 0,
  13026: 0,
  13027: 0,
  13028: 0,
  13029: 0,
  13030: 0,
  13031: 0,
  13032: 0,
  13033: 0,
  13034: 0,
  13035: 0,
  13036: 0,
  13037: 0,
  13039: 0,
  13040: 0,
  13041: 0,
  13042: 0,
  13043: 0,
  13044: 0,
  13045: 0,
  13051: 0,
  13052: 0,
  13053: 0,
  13054: 0,
  13056: 0,
  13057: 0,
  13060: 0,
  13061: 0,
  13062: 0,
  13063: 0,
  13064: 0,
  13065: 0,
  13066: 0,
  13068: 0,
  13069: 0,
  13071: 0,
  13072: 0,
  13073: 0,
  13074: 0,
  13076: 0,
  13077: 0,
  13078: 0,
  13080: 0,
  13081: 0,
  13082: 0,
  13083: 0,
  13084: 0,
  13087: 0,
  13088: 0,
  13089: 0,
  13090: 0,
  13092: 0,
  13093: 0,
  13101: 0,
  13102: 0,
  13103: 0,
  13104: 0,
  13107: 0,
  13108: 0,
  13110: 0,
  13111: 0,
  13112: 0,
  13113: 0,
  13114: 0,
  13115: 0,
  13116: 0,
  13117: 0,
  13118: 0,
  13119: 0,
  13120: 0,
  13121: 0,
  13122: 0,
  13123: 0,
  13124: 0,
  13126: 0,
  13129: 0,
  13131: 0,
  13132: 0,
  13134: 0,
  13135: 0,
  13136: 0,
  13137: 0,
  13138: 0,
  13139: 0,
  13140: 0,
  13141: 0,
  13142: 0,
  13143: 0,
  13144: 0,
  13145: 0,
  13146: 0,
  13147: 0,
  13148: 0,
  13152: 0,
  13153: 0,
  13154: 0,
  13155: 0,
  13156: 0,
  13157: 0,
  13158: 0,
  13159: 0,
  13160: 0,
  13162: 0,
  13163: 0,
  13164: 0,
  13165: 0,
  13166: 0,
  13167: 0,
  13201: 0,
  13202: 0,
  13203: 0,
  13204: 0,
  13205: 0,
  13206: 0,
  13207: 0,
  13208: 0,
  13209: 0,
  13210: 0,
  13211: 0,
  13212: 0,
  13214: 0,
  13215: 0,
  13217: 0,
  13218: 0,
  13219: 0,
  13220: 0,
  13221: 0,
  13224: 0,
  13225: 0,
  13235: 0,
  13244: 0,
  13250: 0,
  13251: 0,
  13252: 0,
  13260: 0,
  13261: 0,
  13290: 0,
  13301: 0,
  13302: 0,
  13303: 0,
  13304: 0,
  13305: 0,
  13308: 0,
  13309: 0,
  13310: 0,
  13312: 0,
  13313: 0,
  13314: 0,
  13315: 0,
  13316: 0,
  13317: 0,
  13318: 0,
  13319: 0,
  13320: 0,
  13321: 0,
  13322: 0,
  13323: 0,
  13324: 0,
  13325: 0,
  13326: 0,
  13327: 0,
  13328: 0,
  13329: 0,
  13331: 0,
  13332: 0,
  13333: 0,
  13334: 0,
  13335: 0,
  13337: 0,
  13338: 0,
  13339: 0,
  13340: 0,
  13341: 0,
  13342: 0,
  13343: 0,
  13345: 0,
  13346: 0,
  13348: 0,
  13350: 0,
  13352: 0,
  13353: 0,
  13354: 0,
  13355: 0,
  13357: 0,
  13360: 0,
  13361: 0,
  13362: 0,
  13363: 0,
  13364: 0,
  13365: 0,
  13367: 0,
  13368: 0,
  13401: 0,
  13402: 0,
  13403: 0,
  13404: 0,
  13406: 0,
  13407: 0,
  13408: 0,
  13409: 0,
  13410: 0,
  13411: 0,
  13413: 0,
  13415: 0,
  13416: 0,
  13417: 0,
  13418: 0,
  13420: 0,
  13421: 0,
  13424: 0,
  13425: 0,
  13426: 0,
  13428: 0,
  13431: 0,
  13433: 0,
  13435: 0,
  13436: 0,
  13437: 0,
  13438: 0,
  13439: 0,
  13440: 0,
  13441: 0,
  13442: 0,
  13449: 0,
  13450: 0,
  13452: 0,
  13454: 0,
  13455: 0,
  13456: 0,
  13457: 0,
  13459: 0,
  13460: 0,
  13461: 0,
  13464: 0,
  13465: 0,
  13468: 0,
  13469: 0,
  13470: 0,
  13471: 0,
  13472: 0,
  13473: 0,
  13475: 0,
  13476: 0,
  13477: 0,
  13478: 0,
  13479: 0,
  13480: 0,
  13482: 0,
  13483: 0,
  13484: 0,
  13485: 0,
  13486: 0,
  13488: 0,
  13489: 0,
  13490: 0,
  13491: 0,
  13492: 0,
  13493: 0,
  13494: 0,
  13495: 0,
  13501: 0,
  13502: 0,
  13503: 0,
  13504: 0,
  13505: 0,
  13599: 0,
  13601: 0,
  13602: 0,
  13603: 0,
  13605: 0,
  13606: 0,
  13607: 0,
  13608: 0,
  13611: 0,
  13612: 0,
  13613: 0,
  13614: 0,
  13615: 0,
  13616: 0,
  13617: 0,
  13618: 0,
  13619: 0,
  13620: 0,
  13621: 0,
  13622: 0,
  13623: 0,
  13624: 0,
  13625: 0,
  13626: 0,
  13627: 0,
  13628: 0,
  13630: 0,
  13631: 0,
  13632: 0,
  13633: 0,
  13634: 0,
  13635: 0,
  13636: 0,
  13637: 0,
  13638: 0,
  13639: 0,
  13640: 0,
  13641: 0,
  13642: 0,
  13643: 0,
  13645: 0,
  13646: 0,
  13647: 0,
  13648: 0,
  13649: 0,
  13650: 0,
  13651: 0,
  13652: 0,
  13654: 0,
  13655: 0,
  13656: 0,
  13657: 0,
  13658: 0,
  13659: 0,
  13660: 0,
  13661: 0,
  13662: 0,
  13664: 0,
  13665: 0,
  13666: 0,
  13667: 0,
  13668: 0,
  13669: 0,
  13670: 0,
  13671: 0,
  13672: 0,
  13673: 0,
  13674: 0,
  13675: 0,
  13676: 0,
  13677: 0,
  13678: 0,
  13679: 0,
  13680: 0,
  13681: 0,
  13682: 0,
  13683: 0,
  13684: 0,
  13685: 0,
  13687: 0,
  13690: 0,
  13691: 0,
  13692: 0,
  13693: 0,
  13694: 0,
  13695: 0,
  13696: 0,
  13697: 0,
  13699: 0,
  13730: 0,
  13731: 0,
  13732: 0,
  13733: 0,
  13734: 0,
  13736: 0,
  13737: 0,
  13738: 0,
  13739: 0,
  13740: 0,
  13743: 0,
  13744: 0,
  13745: 0,
  13746: 0,
  13747: 0,
  13748: 0,
  13749: 0,
  13750: 0,
  13751: 0,
  13752: 0,
  13753: 0,
  13754: 0,
  13755: 0,
  13756: 0,
  13757: 0,
  13758: 0,
  13760: 0,
  13761: 0,
  13762: 0,
  13763: 0,
  13774: 0,
  13775: 0,
  13776: 0,
  13777: 0,
  13778: 0,
  13780: 0,
  13782: 0,
  13783: 0,
  13784: 0,
  13786: 0,
  13787: 0,
  13788: 0,
  13790: 0,
  13794: 0,
  13795: 0,
  13796: 0,
  13797: 0,
  13801: 0,
  13802: 0,
  13803: 0,
  13804: 0,
  13806: 0,
  13807: 0,
  13808: 0,
  13809: 0,
  13810: 0,
  13811: 0,
  13812: 0,
  13813: 0,
  13814: 0,
  13815: 0,
  13820: 0,
  13825: 0,
  13826: 0,
  13827: 0,
  13830: 0,
  13832: 0,
  13833: 0,
  13834: 0,
  13835: 0,
  13837: 0,
  13838: 0,
  13839: 0,
  13840: 0,
  13841: 0,
  13842: 0,
  13843: 0,
  13844: 0,
  13845: 0,
  13846: 0,
  13847: 0,
  13848: 0,
  13849: 0,
  13850: 0,
  13851: 0,
  13856: 0,
  13859: 0,
  13860: 0,
  13861: 0,
  13862: 0,
  13863: 0,
  13864: 0,
  13865: 0,
  13901: 0,
  13902: 0,
  13903: 0,
  13904: 0,
  13905: 0,
  14001: 0,
  14004: 0,
  14005: 0,
  14006: 0,
  14008: 0,
  14009: 0,
  14010: 0,
  14011: 0,
  14012: 0,
  14013: 0,
  14020: 0,
  14021: 0,
  14024: 0,
  14025: 0,
  14026: 0,
  14027: 0,
  14028: 0,
  14029: 0,
  14030: 0,
  14031: 0,
  14032: 0,
  14033: 0,
  14034: 0,
  14035: 0,
  14036: 0,
  14037: 0,
  14038: 0,
  14039: 0,
  14040: 0,
  14041: 0,
  14042: 0,
  14043: 0,
  14047: 0,
  14048: 0,
  14051: 0,
  14052: 0,
  14054: 0,
  14055: 0,
  14056: 0,
  14057: 0,
  14058: 0,
  14059: 0,
  14060: 0,
  14061: 0,
  14062: 0,
  14063: 0,
  14065: 0,
  14066: 0,
  14067: 0,
  14068: 0,
  14069: 0,
  14070: 0,
  14072: 0,
  14075: 0,
  14080: 0,
  14081: 0,
  14082: 0,
  14083: 0,
  14085: 0,
  14086: 0,
  14091: 0,
  14092: 0,
  14094: 0,
  14095: 0,
  14098: 0,
  14101: 0,
  14102: 0,
  14103: 0,
  14105: 0,
  14107: 0,
  14108: 0,
  14109: 0,
  14110: 0,
  14111: 0,
  14112: 0,
  14113: 0,
  14120: 0,
  14125: 0,
  14126: 0,
  14127: 0,
  14129: 0,
  14130: 0,
  14131: 0,
  14132: 0,
  14133: 0,
  14134: 0,
  14135: 0,
  14136: 0,
  14138: 0,
  14139: 0,
  14140: 0,
  14141: 0,
  14143: 0,
  14144: 0,
  14145: 0,
  14150: 0,
  14151: 0,
  14166: 0,
  14167: 0,
  14168: 0,
  14169: 0,
  14170: 0,
  14171: 0,
  14172: 0,
  14173: 0,
  14174: 0,
  14201: 0,
  14202: 0,
  14203: 0,
  14204: 0,
  14205: 0,
  14206: 0,
  14207: 0,
  14208: 0,
  14209: 0,
  14210: 0,
  14211: 0,
  14212: 0,
  14213: 0,
  14214: 0,
  14215: 0,
  14216: 0,
  14217: 0,
  14218: 0,
  14219: 0,
  14220: 0,
  14221: 0,
  14222: 0,
  14223: 0,
  14224: 0,
  14225: 0,
  14226: 0,
  14227: 0,
  14228: 0,
  14231: 0,
  14233: 0,
  14240: 0,
  14241: 0,
  14260: 0,
  14261: 0,
  14263: 0,
  14264: 0,
  14265: 0,
  14267: 0,
  14269: 0,
  14270: 0,
  14272: 0,
  14273: 0,
  14276: 0,
  14280: 0,
  14301: 0,
  14302: 0,
  14303: 0,
  14304: 0,
  14305: 0,
  14410: 0,
  14411: 0,
  14413: 0,
  14414: 0,
  14415: 0,
  14416: 0,
  14418: 0,
  14420: 0,
  14422: 0,
  14423: 0,
  14424: 0,
  14425: 0,
  14427: 0,
  14428: 0,
  14429: 0,
  14430: 0,
  14432: 0,
  14433: 0,
  14435: 0,
  14437: 0,
  14441: 0,
  14443: 0,
  14445: 0,
  14449: 0,
  14450: 0,
  14452: 0,
  14453: 0,
  14454: 0,
  14456: 0,
  14461: 0,
  14462: 0,
  14463: 0,
  14464: 0,
  14466: 0,
  14467: 0,
  14468: 0,
  14469: 0,
  14470: 0,
  14471: 0,
  14472: 0,
  14475: 0,
  14476: 0,
  14477: 0,
  14478: 0,
  14479: 0,
  14480: 0,
  14481: 0,
  14482: 0,
  14485: 0,
  14486: 0,
  14487: 0,
  14488: 0,
  14489: 0,
  14502: 0,
  14504: 0,
  14505: 0,
  14506: 0,
  14507: 0,
  14508: 0,
  14510: 0,
  14511: 0,
  14512: 0,
  14513: 0,
  14514: 0,
  14515: 0,
  14516: 0,
  14517: 0,
  14518: 0,
  14519: 0,
  14520: 0,
  14521: 0,
  14522: 0,
  14525: 0,
  14526: 0,
  14527: 0,
  14529: 0,
  14530: 0,
  14532: 0,
  14533: 0,
  14534: 0,
  14536: 0,
  14537: 0,
  14538: 0,
  14539: 0,
  14541: 0,
  14542: 0,
  14543: 0,
  14544: 0,
  14545: 0,
  14546: 0,
  14547: 0,
  14548: 0,
  14549: 0,
  14550: 0,
  14551: 0,
  14555: 0,
  14556: 0,
  14557: 0,
  14558: 0,
  14559: 0,
  14560: 0,
  14561: 0,
  14563: 0,
  14564: 0,
  14568: 0,
  14569: 0,
  14571: 0,
  14572: 0,
  14580: 0,
  14585: 0,
  14586: 0,
  14588: 0,
  14589: 0,
  14590: 0,
  14591: 0,
  14592: 0,
  14600: 0,
  14602: 0,
  14603: 0,
  14604: 0,
  14605: 0,
  14606: 0,
  14607: 0,
  14608: 0,
  14609: 0,
  14610: 0,
  14611: 0,
  14612: 0,
  14613: 0,
  14614: 0,
  14615: 0,
  14616: 0,
  14617: 0,
  14618: 0,
  14619: 0,
  14620: 0,
  14621: 0,
  14622: 0,
  14623: 0,
  14624: 0,
  14625: 0,
  14626: 0,
  14627: 0,
  14638: 0,
  14639: 0,
  14642: 0,
  14643: 0,
  14644: 0,
  14645: 0,
  14646: 0,
  14647: 0,
  14649: 0,
  14650: 0,
  14651: 0,
  14652: 0,
  14653: 0,
  14664: 0,
  14673: 0,
  14683: 0,
  14692: 0,
  14694: 0,
  14701: 0,
  14702: 0,
  14703: 0,
  14704: 0,
  14706: 0,
  14707: 0,
  14708: 0,
  14709: 0,
  14710: 0,
  14711: 0,
  14712: 0,
  14714: 0,
  14715: 0,
  14716: 0,
  14717: 0,
  14718: 0,
  14719: 0,
  14720: 0,
  14721: 0,
  14722: 0,
  14723: 0,
  14724: 0,
  14726: 0,
  14727: 0,
  14728: 0,
  14729: 0,
  14730: 0,
  14731: 0,
  14732: 0,
  14733: 0,
  14735: 0,
  14736: 0,
  14737: 0,
  14738: 0,
  14739: 0,
  14740: 0,
  14741: 0,
  14742: 0,
  14743: 0,
  14744: 0,
  14745: 0,
  14747: 0,
  14748: 0,
  14750: 0,
  14751: 0,
  14752: 0,
  14753: 0,
  14754: 0,
  14755: 0,
  14756: 0,
  14757: 0,
  14758: 0,
  14760: 0,
  14766: 0,
  14767: 0,
  14769: 0,
  14770: 0,
  14772: 0,
  14774: 0,
  14775: 0,
  14777: 0,
  14778: 0,
  14779: 0,
  14781: 0,
  14782: 0,
  14783: 0,
  14784: 0,
  14785: 0,
  14786: 0,
  14787: 0,
  14788: 0,
  14801: 0,
  14802: 0,
  14803: 0,
  14804: 0,
  14805: 0,
  14806: 0,
  14807: 0,
  14808: 0,
  14809: 0,
  14810: 0,
  14812: 0,
  14813: 0,
  14814: 0,
  14815: 0,
  14816: 0,
  14817: 0,
  14818: 0,
  14819: 0,
  14820: 0,
  14821: 0,
  14822: 0,
  14823: 0,
  14824: 0,
  14825: 0,
  14826: 0,
  14827: 0,
  14830: 0,
  14831: 0,
  14836: 0,
  14837: 0,
  14838: 0,
  14839: 0,
  14840: 0,
  14841: 0,
  14842: 0,
  14843: 0,
  14844: 0,
  14845: 0,
  14846: 0,
  14847: 0,
  14850: 0,
  14851: 0,
  14852: 0,
  14853: 0,
  14854: 0,
  14855: 0,
  14856: 0,
  14857: 0,
  14858: 0,
  14859: 0,
  14860: 0,
  14861: 0,
  14863: 0,
  14864: 0,
  14865: 0,
  14867: 0,
  14869: 0,
  14870: 0,
  14871: 0,
  14872: 0,
  14873: 0,
  14874: 0,
  14876: 0,
  14877: 0,
  14878: 0,
  14879: 0,
  14880: 0,
  14881: 0,
  14882: 0,
  14883: 0,
  14884: 0,
  14885: 0,
  14886: 0,
  14887: 0,
  14889: 0,
  14891: 0,
  14892: 0,
  14893: 0,
  14894: 0,
  14895: 0,
  14897: 0,
  14898: 0,
  14901: 0,
  14902: 0,
  14903: 0,
  14904: 0,
  14905: 0,
  14925: 0,
  15001: 0,
  15003: 0,
  15004: 0,
  15005: 0,
  15006: 0,
  15007: 0,
  15009: 0,
  15010: 0,
  15012: 0,
  15014: 0,
  15015: 0,
  15017: 0,
  15018: 0,
  15019: 0,
  15020: 0,
  15021: 0,
  15022: 0,
  15024: 0,
  15025: 0,
  15026: 0,
  15027: 0,
  15028: 0,
  15030: 0,
  15031: 0,
  15032: 0,
  15033: 0,
  15034: 0,
  15035: 0,
  15036: 0,
  15037: 0,
  15038: 0,
  15042: 0,
  15043: 0,
  15044: 0,
  15045: 0,
  15046: 0,
  15047: 0,
  15049: 0,
  15050: 0,
  15051: 0,
  15052: 0,
  15053: 0,
  15054: 0,
  15055: 0,
  15056: 0,
  15057: 0,
  15059: 0,
  15060: 0,
  15061: 0,
  15062: 0,
  15063: 0,
  15064: 0,
  15065: 0,
  15066: 0,
  15067: 0,
  15068: 0,
  15069: 0,
  15071: 0,
  15072: 0,
  15074: 0,
  15075: 0,
  15076: 0,
  15077: 0,
  15078: 0,
  15081: 0,
  15082: 0,
  15083: 0,
  15084: 0,
  15085: 0,
  15086: 0,
  15087: 0,
  15088: 0,
  15089: 0,
  15090: 0,
  15091: 0,
  15095: 0,
  15096: 0,
  15101: 0,
  15102: 0,
  15104: 0,
  15106: 0,
  15108: 0,
  15110: 0,
  15112: 0,
  15116: 0,
  15120: 0,
  15122: 0,
  15123: 0,
  15126: 0,
  15127: 0,
  15129: 0,
  15130: 0,
  15131: 0,
  15132: 0,
  15133: 0,
  15134: 0,
  15135: 0,
  15136: 0,
  15137: 0,
  15139: 0,
  15140: 0,
  15142: 0,
  15143: 0,
  15144: 0,
  15145: 0,
  15146: 0,
  15147: 0,
  15148: 0,
  15189: 0,
  15201: 0,
  15202: 0,
  15203: 0,
  15204: 0,
  15205: 0,
  15206: 0,
  15207: 0,
  15208: 0,
  15209: 0,
  15210: 0,
  15211: 0,
  15212: 0,
  15213: 0,
  15214: 0,
  15215: 0,
  15216: 0,
  15217: 0,
  15218: 0,
  15219: 0,
  15220: 0,
  15221: 0,
  15222: 0,
  15223: 0,
  15224: 0,
  15225: 0,
  15226: 0,
  15227: 0,
  15228: 0,
  15229: 0,
  15230: 0,
  15231: 0,
  15232: 0,
  15233: 0,
  15234: 0,
  15235: 0,
  15236: 0,
  15237: 0,
  15238: 0,
  15239: 0,
  15240: 0,
  15241: 0,
  15242: 0,
  15243: 0,
  15244: 0,
  15250: 0,
  15251: 0,
  15252: 0,
  15253: 0,
  15254: 0,
  15255: 0,
  15257: 0,
  15258: 0,
  15259: 0,
  15260: 0,
  15261: 0,
  15262: 0,
  15263: 0,
  15264: 0,
  15265: 0,
  15267: 0,
  15268: 0,
  15270: 0,
  15272: 0,
  15274: 0,
  15275: 0,
  15276: 0,
  15277: 0,
  15278: 0,
  15279: 0,
  15281: 0,
  15282: 0,
  15283: 0,
  15285: 0,
  15286: 0,
  15289: 0,
  15290: 0,
  15295: 0,
  15301: 0,
  15310: 0,
  15311: 0,
  15312: 0,
  15313: 0,
  15314: 0,
  15315: 0,
  15316: 0,
  15317: 0,
  15320: 0,
  15321: 0,
  15322: 0,
  15323: 0,
  15324: 0,
  15325: 0,
  15327: 0,
  15329: 0,
  15330: 0,
  15331: 0,
  15332: 0,
  15333: 0,
  15334: 0,
  15336: 0,
  15337: 0,
  15338: 0,
  15339: 0,
  15340: 0,
  15341: 0,
  15342: 0,
  15344: 0,
  15345: 0,
  15346: 0,
  15347: 0,
  15348: 0,
  15349: 0,
  15350: 0,
  15351: 0,
  15352: 0,
  15353: 0,
  15354: 0,
  15357: 0,
  15358: 0,
  15359: 0,
  15360: 0,
  15361: 0,
  15362: 0,
  15363: 0,
  15364: 0,
  15365: 0,
  15366: 0,
  15367: 0,
  15368: 0,
  15370: 0,
  15376: 0,
  15377: 0,
  15378: 0,
  15379: 0,
  15380: 0,
  15401: 0,
  15410: 0,
  15411: 0,
  15412: 0,
  15413: 0,
  15415: 0,
  15416: 0,
  15417: 0,
  15419: 0,
  15420: 0,
  15421: 0,
  15422: 0,
  15423: 0,
  15424: 0,
  15425: 0,
  15427: 0,
  15428: 0,
  15429: 0,
  15430: 0,
  15431: 0,
  15432: 0,
  15433: 0,
  15434: 0,
  15435: 0,
  15436: 0,
  15437: 0,
  15438: 0,
  15439: 0,
  15440: 0,
  15442: 0,
  15443: 0,
  15444: 0,
  15445: 0,
  15446: 0,
  15447: 0,
  15448: 0,
  15449: 0,
  15450: 0,
  15451: 0,
  15454: 0,
  15455: 0,
  15456: 0,
  15458: 0,
  15459: 0,
  15460: 0,
  15461: 0,
  15462: 0,
  15463: 0,
  15464: 0,
  15465: 0,
  15466: 0,
  15467: 0,
  15468: 0,
  15469: 0,
  15470: 0,
  15472: 0,
  15473: 0,
  15474: 0,
  15475: 0,
  15476: 0,
  15477: 0,
  15478: 0,
  15479: 0,
  15480: 0,
  15482: 0,
  15483: 0,
  15484: 0,
  15485: 0,
  15486: 0,
  15488: 0,
  15489: 0,
  15490: 0,
  15492: 0,
  15501: 0,
  15502: 0,
  15510: 0,
  15520: 0,
  15521: 0,
  15522: 0,
  15530: 0,
  15531: 0,
  15532: 0,
  15533: 0,
  15534: 0,
  15535: 0,
  15536: 0,
  15537: 0,
  15538: 0,
  15539: 0,
  15540: 0,
  15541: 0,
  15542: 0,
  15544: 0,
  15545: 0,
  15546: 0,
  15547: 0,
  15548: 0,
  15549: 0,
  15550: 0,
  15551: 0,
  15552: 0,
  15553: 0,
  15554: 0,
  15555: 0,
  15557: 0,
  15558: 0,
  15559: 0,
  15560: 0,
  15561: 0,
  15562: 0,
  15563: 0,
  15564: 0,
  15565: 0,
  15601: 0,
  15605: 0,
  15606: 0,
  15610: 0,
  15611: 0,
  15612: 0,
  15613: 0,
  15615: 0,
  15616: 0,
  15617: 0,
  15618: 0,
  15619: 0,
  15620: 0,
  15621: 0,
  15622: 0,
  15623: 0,
  15624: 0,
  15625: 0,
  15626: 0,
  15627: 0,
  15628: 0,
  15629: 0,
  15631: 0,
  15632: 0,
  15633: 0,
  15634: 0,
  15635: 0,
  15636: 0,
  15637: 0,
  15638: 0,
  15639: 0,
  15640: 0,
  15641: 0,
  15642: 0,
  15644: 0,
  15646: 0,
  15647: 0,
  15650: 0,
  15655: 0,
  15656: 0,
  15658: 0,
  15660: 0,
  15661: 0,
  15662: 0,
  15663: 0,
  15664: 0,
  15665: 0,
  15666: 0,
  15668: 0,
  15670: 0,
  15671: 0,
  15672: 0,
  15673: 0,
  15674: 0,
  15675: 0,
  15676: 0,
  15677: 0,
  15678: 0,
  15679: 0,
  15680: 0,
  15681: 0,
  15682: 0,
  15683: 0,
  15684: 0,
  15685: 0,
  15686: 0,
  15687: 0,
  15688: 0,
  15689: 0,
  15690: 0,
  15691: 0,
  15692: 0,
  15693: 0,
  15695: 0,
  15696: 0,
  15697: 0,
  15698: 0,
  15701: 0,
  15705: 0,
  15710: 0,
  15711: 0,
  15712: 0,
  15713: 0,
  15714: 0,
  15715: 0,
  15716: 0,
  15717: 0,
  15720: 0,
  15721: 0,
  15722: 0,
  15723: 0,
  15724: 0,
  15725: 0,
  15727: 0,
  15728: 0,
  15729: 0,
  15730: 0,
  15731: 0,
  15732: 0,
  15733: 0,
  15734: 0,
  15736: 0,
  15737: 0,
  15738: 0,
  15739: 0,
  15740: 0,
  15741: 0,
  15742: 0,
  15744: 0,
  15745: 0,
  15746: 0,
  15747: 0,
  15748: 0,
  15750: 0,
  15752: 0,
  15753: 0,
  15754: 0,
  15756: 0,
  15757: 0,
  15758: 0,
  15759: 0,
  15760: 0,
  15761: 0,
  15762: 0,
  15763: 0,
  15764: 0,
  15765: 0,
  15767: 0,
  15770: 0,
  15771: 0,
  15772: 0,
  15773: 0,
  15774: 0,
  15775: 0,
  15776: 0,
  15777: 0,
  15778: 0,
  15779: 0,
  15780: 0,
  15781: 0,
  15783: 0,
  15784: 0,
  15801: 0,
  15821: 0,
  15822: 0,
  15823: 0,
  15824: 0,
  15825: 0,
  15827: 0,
  15828: 0,
  15829: 0,
  15831: 0,
  15832: 0,
  15834: 0,
  15840: 0,
  15841: 0,
  15845: 0,
  15846: 0,
  15847: 0,
  15848: 0,
  15849: 0,
  15851: 0,
  15853: 0,
  15856: 0,
  15857: 0,
  15860: 0,
  15861: 0,
  15863: 0,
  15864: 0,
  15865: 0,
  15866: 0,
  15868: 0,
  15870: 0,
  15901: 0,
  15902: 0,
  15904: 0,
  15905: 0,
  15906: 0,
  15907: 0,
  15909: 0,
  15915: 0,
  15920: 0,
  15921: 0,
  15922: 0,
  15923: 0,
  15924: 0,
  15925: 0,
  15926: 0,
  15927: 0,
  15928: 0,
  15929: 0,
  15930: 0,
  15931: 0,
  15934: 0,
  15935: 0,
  15936: 0,
  15937: 0,
  15938: 0,
  15940: 0,
  15942: 0,
  15943: 0,
  15944: 0,
  15945: 0,
  15946: 0,
  15948: 0,
  15949: 0,
  15951: 0,
  15952: 0,
  15953: 0,
  15954: 0,
  15955: 0,
  15956: 0,
  15957: 0,
  15958: 0,
  15959: 0,
  15960: 0,
  15961: 0,
  15962: 0,
  15963: 0,
  16001: 0,
  16002: 0,
  16003: 0,
  16016: 0,
  16017: 0,
  16018: 0,
  16020: 0,
  16021: 0,
  16022: 0,
  16023: 0,
  16024: 0,
  16025: 0,
  16027: 0,
  16028: 0,
  16029: 0,
  16030: 0,
  16033: 0,
  16034: 0,
  16035: 0,
  16036: 0,
  16037: 0,
  16038: 0,
  16039: 0,
  16040: 0,
  16041: 0,
  16045: 0,
  16046: 0,
  16048: 0,
  16049: 0,
  16050: 0,
  16051: 0,
  16052: 0,
  16053: 0,
  16054: 0,
  16055: 0,
  16056: 0,
  16057: 0,
  16058: 0,
  16059: 0,
  16061: 0,
  16063: 0,
  16066: 0,
  16101: 0,
  16102: 0,
  16103: 0,
  16105: 0,
  16107: 0,
  16108: 0,
  16110: 0,
  16111: 0,
  16112: 0,
  16113: 0,
  16114: 0,
  16115: 0,
  16116: 0,
  16117: 0,
  16120: 0,
  16121: 0,
  16123: 0,
  16124: 0,
  16125: 0,
  16127: 0,
  16130: 0,
  16131: 0,
  16132: 0,
  16133: 0,
  16134: 0,
  16136: 0,
  16137: 0,
  16140: 0,
  16141: 0,
  16142: 0,
  16143: 0,
  16145: 0,
  16146: 0,
  16148: 0,
  16150: 0,
  16151: 0,
  16153: 0,
  16154: 0,
  16155: 0,
  16156: 0,
  16157: 0,
  16159: 0,
  16160: 0,
  16161: 0,
  16172: 0,
  16201: 0,
  16210: 0,
  16211: 0,
  16212: 0,
  16213: 0,
  16214: 0,
  16215: 0,
  16217: 0,
  16218: 0,
  16220: 0,
  16221: 0,
  16222: 0,
  16223: 0,
  16224: 0,
  16225: 0,
  16226: 0,
  16228: 0,
  16229: 0,
  16230: 0,
  16232: 0,
  16233: 0,
  16234: 0,
  16235: 0,
  16236: 0,
  16238: 0,
  16239: 0,
  16240: 0,
  16242: 0,
  16244: 0,
  16245: 0,
  16246: 0,
  16248: 0,
  16249: 0,
  16250: 0,
  16253: 0,
  16254: 0,
  16255: 0,
  16256: 0,
  16257: 0,
  16258: 0,
  16259: 0,
  16260: 0,
  16261: 0,
  16262: 0,
  16263: 0,
  16301: 0,
  16311: 0,
  16312: 0,
  16313: 0,
  16314: 0,
  16316: 0,
  16317: 0,
  16319: 0,
  16321: 0,
  16322: 0,
  16323: 0,
  16326: 0,
  16327: 0,
  16328: 0,
  16329: 0,
  16331: 0,
  16332: 0,
  16333: 0,
  16334: 0,
  16335: 0,
  16340: 0,
  16341: 0,
  16342: 0,
  16343: 0,
  16344: 0,
  16345: 0,
  16346: 0,
  16347: 0,
  16350: 0,
  16351: 0,
  16352: 0,
  16353: 0,
  16354: 0,
  16360: 0,
  16361: 0,
  16362: 0,
  16364: 0,
  16365: 0,
  16366: 0,
  16367: 0,
  16368: 0,
  16369: 0,
  16370: 0,
  16371: 0,
  16372: 0,
  16373: 0,
  16374: 0,
  16375: 0,
  16388: 0,
  16401: 0,
  16402: 0,
  16403: 0,
  16404: 0,
  16405: 0,
  16406: 0,
  16407: 0,
  16410: 0,
  16411: 0,
  16412: 0,
  16413: 0,
  16415: 0,
  16416: 0,
  16417: 0,
  16420: 0,
  16421: 0,
  16422: 0,
  16423: 0,
  16424: 0,
  16426: 0,
  16427: 0,
  16428: 0,
  16430: 0,
  16432: 0,
  16433: 0,
  16434: 0,
  16435: 0,
  16436: 0,
  16438: 0,
  16440: 0,
  16441: 0,
  16442: 0,
  16443: 0,
  16444: 0,
  16475: 0,
  16501: 0,
  16502: 0,
  16503: 0,
  16504: 0,
  16505: 0,
  16506: 0,
  16507: 0,
  16508: 0,
  16509: 0,
  16510: 0,
  16511: 0,
  16512: 0,
  16514: 0,
  16515: 0,
  16522: 0,
  16530: 0,
  16531: 0,
  16532: 0,
  16533: 0,
  16534: 0,
  16538: 0,
  16541: 0,
  16544: 0,
  16546: 0,
  16550: 0,
  16553: 0,
  16554: 0,
  16563: 0,
  16565: 0,
  16601: 0,
  16602: 0,
  16603: 0,
  16611: 0,
  16613: 0,
  16616: 0,
  16617: 0,
  16619: 0,
  16620: 0,
  16621: 0,
  16622: 0,
  16623: 0,
  16624: 0,
  16625: 0,
  16627: 0,
  16629: 0,
  16630: 0,
  16631: 0,
  16633: 0,
  16634: 0,
  16635: 0,
  16636: 0,
  16637: 0,
  16638: 0,
  16639: 0,
  16640: 0,
  16641: 0,
  16644: 0,
  16645: 0,
  16646: 0,
  16647: 0,
  16648: 0,
  16650: 0,
  16651: 0,
  16652: 0,
  16654: 0,
  16655: 0,
  16656: 0,
  16657: 0,
  16659: 0,
  16660: 0,
  16661: 0,
  16662: 0,
  16663: 0,
  16664: 0,
  16665: 0,
  16666: 0,
  16667: 0,
  16668: 0,
  16669: 0,
  16670: 0,
  16671: 0,
  16672: 0,
  16673: 0,
  16674: 0,
  16675: 0,
  16677: 0,
  16678: 0,
  16679: 0,
  16680: 0,
  16681: 0,
  16682: 0,
  16683: 0,
  16684: 0,
  16685: 0,
  16686: 0,
  16689: 0,
  16691: 0,
  16692: 0,
  16693: 0,
  16694: 0,
  16695: 0,
  16698: 0,
  16699: 0,
  16701: 0,
  16720: 0,
  16724: 0,
  16725: 0,
  16726: 0,
  16727: 0,
  16728: 0,
  16729: 0,
  16730: 0,
  16731: 0,
  16732: 0,
  16733: 0,
  16734: 0,
  16735: 0,
  16738: 0,
  16740: 0,
  16743: 0,
  16744: 0,
  16745: 0,
  16746: 0,
  16748: 0,
  16749: 0,
  16750: 0,
  16801: 0,
  16802: 0,
  16803: 0,
  16804: 0,
  16805: 0,
  16820: 0,
  16821: 0,
  16822: 0,
  16823: 0,
  16825: 0,
  16826: 0,
  16827: 0,
  16828: 0,
  16829: 0,
  16830: 0,
  16832: 0,
  16833: 0,
  16834: 0,
  16835: 0,
  16836: 0,
  16837: 0,
  16838: 0,
  16839: 0,
  16840: 0,
  16841: 0,
  16843: 0,
  16844: 0,
  16845: 0,
  16847: 0,
  16848: 0,
  16849: 0,
  16850: 0,
  16851: 0,
  16852: 0,
  16853: 0,
  16854: 0,
  16855: 0,
  16856: 0,
  16858: 0,
  16859: 0,
  16860: 0,
  16861: 0,
  16863: 0,
  16864: 0,
  16865: 0,
  16866: 0,
  16868: 0,
  16870: 0,
  16871: 0,
  16872: 0,
  16873: 0,
  16874: 0,
  16875: 0,
  16876: 0,
  16877: 0,
  16878: 0,
  16879: 0,
  16881: 0,
  16882: 0,
  16901: 0,
  16910: 0,
  16911: 0,
  16912: 0,
  16914: 0,
  16915: 0,
  16917: 0,
  16918: 0,
  16920: 0,
  16921: 0,
  16922: 0,
  16923: 0,
  16925: 0,
  16926: 0,
  16927: 0,
  16928: 0,
  16929: 0,
  16930: 0,
  16932: 0,
  16933: 0,
  16935: 0,
  16936: 0,
  16937: 0,
  16938: 0,
  16939: 0,
  16940: 0,
  16941: 0,
  16942: 0,
  16943: 0,
  16945: 0,
  16946: 0,
  16947: 0,
  16948: 0,
  16950: 0,
  17001: 0,
  17002: 0,
  17003: 0,
  17004: 0,
  17005: 0,
  17006: 0,
  17007: 0,
  17008: 0,
  17009: 0,
  17010: 0,
  17011: 0,
  17012: 0,
  17013: 0,
  17014: 0,
  17015: 0,
  17016: 0,
  17017: 0,
  17018: 0,
  17019: 0,
  17020: 0,
  17021: 0,
  17022: 0,
  17023: 0,
  17024: 0,
  17025: 0,
  17026: 0,
  17027: 0,
  17028: 0,
  17029: 0,
  17030: 0,
  17032: 0,
  17033: 0,
  17034: 0,
  17035: 0,
  17036: 0,
  17037: 0,
  17038: 0,
  17039: 0,
  17040: 0,
  17041: 0,
  17042: 0,
  17043: 0,
  17044: 0,
  17045: 0,
  17046: 0,
  17047: 0,
  17048: 0,
  17049: 0,
  17050: 0,
  17051: 0,
  17052: 0,
  17053: 0,
  17054: 0,
  17055: 0,
  17056: 0,
  17057: 0,
  17058: 0,
  17059: 0,
  17060: 0,
  17061: 0,
  17062: 0,
  17063: 0,
  17064: 0,
  17065: 0,
  17066: 0,
  17067: 0,
  17068: 0,
  17069: 0,
  17070: 0,
  17071: 0,
  17072: 0,
  17073: 0,
  17074: 0,
  17075: 0,
  17076: 0,
  17077: 0,
  17078: 0,
  17080: 0,
  17081: 0,
  17082: 0,
  17083: 0,
  17084: 0,
  17085: 0,
  17086: 0,
  17087: 0,
  17088: 0,
  17089: 0,
  17090: 0,
  17091: 0,
  17093: 0,
  17094: 0,
  17097: 0,
  17098: 0,
  17099: 0,
  17101: 0,
  17102: 0,
  17103: 0,
  17104: 0,
  17105: 0,
  17106: 0,
  17107: 0,
  17108: 0,
  17109: 0,
  17110: 0,
  17111: 0,
  17112: 0,
  17113: 0,
  17120: 0,
  17121: 0,
  17122: 0,
  17123: 0,
  17124: 0,
  17125: 0,
  17126: 0,
  17127: 0,
  17128: 0,
  17129: 0,
  17130: 0,
  17140: 0,
  17177: 0,
  17201: 0,
  17202: 0,
  17210: 0,
  17211: 0,
  17212: 0,
  17213: 0,
  17214: 0,
  17215: 0,
  17217: 0,
  17219: 0,
  17220: 0,
  17221: 0,
  17222: 0,
  17223: 0,
  17224: 0,
  17225: 0,
  17228: 0,
  17229: 0,
  17231: 0,
  17232: 0,
  17233: 0,
  17235: 0,
  17236: 0,
  17237: 0,
  17238: 0,
  17239: 0,
  17240: 0,
  17241: 0,
  17243: 0,
  17244: 0,
  17246: 0,
  17247: 0,
  17249: 0,
  17250: 0,
  17251: 0,
  17252: 0,
  17253: 0,
  17254: 0,
  17255: 0,
  17256: 0,
  17257: 0,
  17260: 0,
  17261: 0,
  17262: 0,
  17263: 0,
  17264: 0,
  17265: 0,
  17266: 0,
  17267: 0,
  17268: 0,
  17270: 0,
  17271: 0,
  17272: 0,
  17301: 0,
  17302: 0,
  17303: 0,
  17304: 0,
  17306: 0,
  17307: 0,
  17309: 0,
  17310: 0,
  17311: 0,
  17312: 0,
  17313: 0,
  17314: 0,
  17315: 0,
  17316: 0,
  17317: 0,
  17318: 0,
  17319: 0,
  17320: 0,
  17321: 0,
  17322: 0,
  17323: 0,
  17324: 0,
  17325: 0,
  17326: 0,
  17327: 0,
  17329: 0,
  17331: 0,
  17332: 0,
  17333: 0,
  17334: 0,
  17335: 0,
  17337: 0,
  17339: 0,
  17340: 0,
  17342: 0,
  17343: 0,
  17344: 0,
  17345: 0,
  17347: 0,
  17349: 0,
  17350: 0,
  17352: 0,
  17353: 0,
  17354: 0,
  17355: 0,
  17356: 0,
  17358: 0,
  17360: 0,
  17361: 0,
  17362: 0,
  17363: 0,
  17364: 0,
  17365: 0,
  17366: 0,
  17368: 0,
  17370: 0,
  17371: 0,
  17372: 0,
  17375: 0,
  17401: 0,
  17402: 0,
  17403: 0,
  17404: 0,
  17405: 0,
  17406: 0,
  17407: 0,
  17408: 0,
  17415: 0,
  17501: 0,
  17502: 0,
  17503: 0,
  17504: 0,
  17505: 0,
  17506: 0,
  17507: 0,
  17508: 0,
  17509: 0,
  17512: 0,
  17516: 0,
  17517: 0,
  17518: 0,
  17519: 0,
  17520: 0,
  17521: 0,
  17522: 0,
  17527: 0,
  17528: 0,
  17529: 0,
  17532: 0,
  17533: 0,
  17534: 0,
  17535: 0,
  17536: 0,
  17537: 0,
  17538: 0,
  17540: 0,
  17543: 0,
  17545: 0,
  17547: 0,
  17549: 0,
  17550: 0,
  17551: 0,
  17552: 0,
  17554: 0,
  17555: 0,
  17557: 0,
  17560: 0,
  17562: 0,
  17563: 0,
  17564: 0,
  17565: 0,
  17566: 0,
  17567: 0,
  17568: 0,
  17569: 0,
  17570: 0,
  17572: 0,
  17573: 0,
  17575: 0,
  17576: 0,
  17577: 0,
  17578: 0,
  17579: 0,
  17580: 0,
  17581: 0,
  17582: 0,
  17583: 0,
  17584: 0,
  17585: 0,
  17601: 0,
  17602: 0,
  17603: 0,
  17604: 0,
  17605: 0,
  17606: 0,
  17607: 0,
  17608: 0,
  17611: 0,
  17622: 0,
  17699: 0,
  17701: 0,
  17702: 0,
  17703: 0,
  17705: 0,
  17720: 0,
  17721: 0,
  17722: 0,
  17723: 0,
  17724: 0,
  17726: 0,
  17727: 0,
  17728: 0,
  17729: 0,
  17730: 0,
  17731: 0,
  17735: 0,
  17737: 0,
  17738: 0,
  17739: 0,
  17740: 0,
  17742: 0,
  17744: 0,
  17745: 0,
  17747: 0,
  17748: 0,
  17749: 0,
  17750: 0,
  17751: 0,
  17752: 0,
  17754: 0,
  17756: 0,
  17758: 0,
  17759: 0,
  17760: 0,
  17762: 0,
  17763: 0,
  17764: 0,
  17765: 0,
  17767: 0,
  17768: 0,
  17769: 0,
  17771: 0,
  17772: 0,
  17773: 0,
  17774: 0,
  17776: 0,
  17777: 0,
  17778: 0,
  17779: 0,
  17801: 0,
  17810: 0,
  17812: 0,
  17813: 0,
  17814: 0,
  17815: 0,
  17820: 0,
  17821: 0,
  17822: 0,
  17823: 0,
  17824: 0,
  17827: 0,
  17829: 0,
  17830: 0,
  17831: 0,
  17832: 0,
  17833: 0,
  17834: 0,
  17835: 0,
  17836: 0,
  17837: 0,
  17839: 0,
  17840: 0,
  17841: 0,
  17842: 0,
  17843: 0,
  17844: 0,
  17845: 0,
  17846: 0,
  17847: 0,
  17850: 0,
  17851: 0,
  17853: 0,
  17855: 0,
  17856: 0,
  17857: 0,
  17858: 0,
  17859: 0,
  17860: 0,
  17861: 0,
  17862: 0,
  17864: 0,
  17865: 0,
  17866: 0,
  17867: 0,
  17868: 0,
  17870: 0,
  17872: 0,
  17876: 0,
  17877: 0,
  17878: 0,
  17880: 0,
  17881: 0,
  17882: 0,
  17883: 0,
  17884: 0,
  17885: 0,
  17886: 0,
  17887: 0,
  17888: 0,
  17889: 0,
  17901: 0,
  17920: 0,
  17921: 0,
  17922: 0,
  17923: 0,
  17925: 0,
  17929: 0,
  17930: 0,
  17931: 0,
  17932: 0,
  17933: 0,
  17934: 0,
  17935: 0,
  17936: 0,
  17938: 0,
  17941: 0,
  17942: 0,
  17943: 0,
  17944: 0,
  17945: 0,
  17946: 0,
  17948: 0,
  17949: 0,
  17951: 0,
  17952: 0,
  17953: 0,
  17954: 0,
  17957: 0,
  17959: 0,
  17960: 0,
  17961: 0,
  17963: 0,
  17964: 0,
  17965: 0,
  17966: 0,
  17967: 0,
  17968: 0,
  17970: 0,
  17972: 0,
  17974: 0,
  17976: 0,
  17978: 0,
  17979: 0,
  17980: 0,
  17981: 0,
  17982: 0,
  17983: 0,
  17985: 0,
  18001: 0,
  18002: 0,
  18003: 0,
  18010: 0,
  18011: 0,
  18012: 0,
  18013: 0,
  18014: 0,
  18015: 0,
  18016: 0,
  18017: 0,
  18018: 0,
  18020: 0,
  18025: 0,
  18030: 0,
  18031: 0,
  18032: 0,
  18034: 0,
  18035: 0,
  18036: 0,
  18037: 0,
  18038: 0,
  18039: 0,
  18040: 0,
  18041: 0,
  18042: 0,
  18043: 0,
  18044: 0,
  18045: 0,
  18046: 0,
  18049: 0,
  18050: 0,
  18051: 0,
  18052: 0,
  18053: 0,
  18054: 0,
  18055: 0,
  18056: 0,
  18058: 0,
  18059: 0,
  18060: 0,
  18062: 0,
  18063: 0,
  18064: 0,
  18065: 0,
  18066: 0,
  18067: 0,
  18068: 0,
  18069: 0,
  18070: 0,
  18071: 0,
  18072: 0,
  18073: 0,
  18074: 0,
  18076: 0,
  18077: 0,
  18078: 0,
  18079: 0,
  18080: 0,
  18081: 0,
  18083: 0,
  18084: 0,
  18085: 0,
  18086: 0,
  18087: 0,
  18088: 0,
  18091: 0,
  18092: 0,
  18098: 0,
  18099: 0,
  18101: 0,
  18102: 0,
  18103: 0,
  18104: 0,
  18105: 0,
  18106: 0,
  18109: 0,
  18175: 0,
  18195: 0,
  18201: 0,
  18202: 0,
  18210: 0,
  18211: 0,
  18212: 0,
  18214: 0,
  18216: 0,
  18218: 0,
  18219: 0,
  18220: 0,
  18221: 0,
  18222: 0,
  18223: 0,
  18224: 0,
  18225: 0,
  18229: 0,
  18230: 0,
  18231: 0,
  18232: 0,
  18234: 0,
  18235: 0,
  18237: 0,
  18239: 0,
  18240: 0,
  18241: 0,
  18242: 0,
  18244: 0,
  18245: 0,
  18246: 0,
  18247: 0,
  18248: 0,
  18249: 0,
  18250: 0,
  18251: 0,
  18252: 0,
  18254: 0,
  18255: 0,
  18256: 0,
  18301: 0,
  18302: 0,
  18320: 0,
  18321: 0,
  18322: 0,
  18323: 0,
  18324: 0,
  18325: 0,
  18326: 0,
  18327: 0,
  18328: 0,
  18330: 0,
  18331: 0,
  18332: 0,
  18333: 0,
  18334: 0,
  18335: 0,
  18336: 0,
  18337: 0,
  18340: 0,
  18341: 0,
  18342: 0,
  18343: 0,
  18344: 0,
  18346: 0,
  18347: 0,
  18348: 0,
  18349: 0,
  18350: 0,
  18351: 0,
  18352: 0,
  18353: 0,
  18354: 0,
  18355: 0,
  18356: 0,
  18357: 0,
  18360: 0,
  18370: 0,
  18371: 0,
  18372: 0,
  18373: 0,
  18401: 0,
  18403: 0,
  18405: 0,
  18407: 0,
  18410: 0,
  18411: 0,
  18413: 0,
  18414: 0,
  18415: 0,
  18416: 0,
  18417: 0,
  18419: 0,
  18420: 0,
  18421: 0,
  18424: 0,
  18425: 0,
  18426: 0,
  18427: 0,
  18428: 0,
  18430: 0,
  18431: 0,
  18433: 0,
  18434: 0,
  18435: 0,
  18436: 0,
  18437: 0,
  18438: 0,
  18439: 0,
  18440: 0,
  18441: 0,
  18443: 0,
  18444: 0,
  18445: 0,
  18446: 0,
  18447: 0,
  18448: 0,
  18449: 0,
  18451: 0,
  18452: 0,
  18453: 0,
  18454: 0,
  18455: 0,
  18456: 0,
  18457: 0,
  18458: 0,
  18459: 0,
  18460: 0,
  18461: 0,
  18462: 0,
  18463: 0,
  18464: 0,
  18465: 0,
  18466: 0,
  18469: 0,
  18470: 0,
  18471: 0,
  18472: 0,
  18473: 0,
  18501: 0,
  18502: 0,
  18503: 0,
  18504: 0,
  18505: 0,
  18507: 0,
  18508: 0,
  18509: 0,
  18510: 0,
  18512: 0,
  18514: 0,
  18515: 0,
  18517: 0,
  18518: 0,
  18519: 0,
  18522: 0,
  18540: 0,
  18577: 0,
  18601: 0,
  18602: 0,
  18603: 0,
  18610: 0,
  18611: 0,
  18612: 0,
  18614: 0,
  18615: 0,
  18616: 0,
  18617: 0,
  18618: 0,
  18619: 0,
  18621: 0,
  18622: 0,
  18623: 0,
  18624: 0,
  18625: 0,
  18626: 0,
  18627: 0,
  18628: 0,
  18629: 0,
  18630: 0,
  18631: 0,
  18632: 0,
  18634: 0,
  18635: 0,
  18636: 0,
  18640: 0,
  18641: 0,
  18642: 0,
  18643: 0,
  18644: 0,
  18651: 0,
  18653: 0,
  18654: 0,
  18655: 0,
  18656: 0,
  18657: 0,
  18660: 0,
  18661: 0,
  18690: 0,
  18701: 0,
  18702: 0,
  18703: 0,
  18704: 0,
  18705: 0,
  18706: 0,
  18707: 0,
  18708: 0,
  18709: 0,
  18710: 0,
  18711: 0,
  18762: 0,
  18764: 0,
  18765: 0,
  18766: 0,
  18767: 0,
  18769: 0,
  18773: 0,
  18801: 0,
  18810: 0,
  18812: 0,
  18813: 0,
  18814: 0,
  18815: 0,
  18816: 0,
  18817: 0,
  18818: 0,
  18820: 0,
  18821: 0,
  18822: 0,
  18823: 0,
  18824: 0,
  18825: 0,
  18826: 0,
  18827: 0,
  18828: 0,
  18829: 0,
  18830: 0,
  18831: 0,
  18832: 0,
  18833: 0,
  18834: 0,
  18837: 0,
  18840: 0,
  18842: 0,
  18843: 0,
  18844: 0,
  18845: 0,
  18846: 0,
  18847: 0,
  18848: 0,
  18850: 0,
  18851: 0,
  18853: 0,
  18854: 0,
  18901: 0,
  18902: 0,
  18910: 0,
  18911: 0,
  18912: 0,
  18913: 0,
  18914: 0,
  18915: 0,
  18916: 0,
  18917: 0,
  18918: 0,
  18920: 0,
  18921: 0,
  18922: 0,
  18923: 0,
  18924: 0,
  18925: 0,
  18926: 0,
  18927: 0,
  18928: 0,
  18929: 0,
  18930: 0,
  18931: 0,
  18932: 0,
  18933: 0,
  18934: 0,
  18935: 0,
  18936: 0,
  18938: 0,
  18940: 0,
  18942: 0,
  18943: 0,
  18944: 0,
  18946: 0,
  18947: 0,
  18949: 0,
  18950: 0,
  18951: 0,
  18953: 0,
  18954: 0,
  18955: 0,
  18956: 0,
  18957: 0,
  18958: 0,
  18960: 0,
  18962: 0,
  18963: 0,
  18964: 0,
  18966: 0,
  18968: 0,
  18969: 0,
  18970: 0,
  18971: 0,
  18972: 0,
  18974: 0,
  18976: 0,
  18977: 0,
  18979: 0,
  18980: 0,
  18981: 0,
  18991: 0,
  19001: 0,
  19002: 0,
  19003: 0,
  19004: 0,
  19006: 0,
  19007: 0,
  19008: 0,
  19009: 0,
  19010: 0,
  19012: 0,
  19013: 0,
  19014: 0,
  19015: 0,
  19016: 0,
  19017: 0,
  19018: 0,
  19019: 0,
  19020: 0,
  19021: 0,
  19022: 0,
  19023: 0,
  19025: 0,
  19026: 0,
  19027: 0,
  19028: 0,
  19029: 0,
  19030: 0,
  19031: 0,
  19032: 0,
  19033: 0,
  19034: 0,
  19035: 0,
  19036: 0,
  19037: 0,
  19038: 0,
  19039: 0,
  19040: 0,
  19041: 0,
  19043: 0,
  19044: 0,
  19046: 0,
  19047: 0,
  19048: 0,
  19049: 0,
  19050: 0,
  19052: 0,
  19053: 0,
  19054: 0,
  19055: 0,
  19056: 0,
  19057: 0,
  19058: 0,
  19059: 0,
  19060: 0,
  19061: 0,
  19063: 0,
  19064: 0,
  19065: 0,
  19066: 0,
  19067: 0,
  19070: 0,
  19072: 0,
  19073: 0,
  19074: 0,
  19075: 0,
  19076: 0,
  19078: 0,
  19079: 0,
  19080: 0,
  19081: 0,
  19082: 0,
  19083: 0,
  19085: 0,
  19086: 0,
  19087: 0,
  19088: 0,
  19089: 0,
  19090: 0,
  19091: 0,
  19092: 0,
  19093: 0,
  19094: 0,
  19095: 0,
  19096: 0,
  19098: 0,
  19099: 0,
  19101: 0,
  19102: 0,
  19103: 0,
  19104: 0,
  19105: 0,
  19106: 0,
  19107: 0,
  19108: 0,
  19109: 0,
  19110: 0,
  19111: 0,
  19112: 0,
  19113: 0,
  19114: 0,
  19115: 0,
  19116: 0,
  19118: 0,
  19119: 0,
  19120: 0,
  19121: 0,
  19122: 0,
  19123: 0,
  19124: 0,
  19125: 0,
  19126: 0,
  19127: 0,
  19128: 0,
  19129: 0,
  19130: 0,
  19131: 0,
  19132: 0,
  19133: 0,
  19134: 0,
  19135: 0,
  19136: 0,
  19137: 0,
  19138: 0,
  19139: 0,
  19140: 0,
  19141: 0,
  19142: 0,
  19143: 0,
  19144: 0,
  19145: 0,
  19146: 0,
  19147: 0,
  19148: 0,
  19149: 0,
  19150: 0,
  19151: 0,
  19152: 0,
  19153: 0,
  19154: 0,
  19155: 0,
  19160: 0,
  19161: 0,
  19162: 0,
  19170: 0,
  19171: 0,
  19172: 0,
  19173: 0,
  19175: 0,
  19176: 0,
  19177: 0,
  19178: 0,
  19179: 0,
  19181: 0,
  19182: 0,
  19183: 0,
  19184: 0,
  19185: 0,
  19187: 0,
  19188: 0,
  19190: 0,
  19191: 0,
  19192: 0,
  19193: 0,
  19194: 0,
  19195: 0,
  19196: 0,
  19197: 0,
  19244: 0,
  19255: 0,
  19301: 0,
  19310: 0,
  19311: 0,
  19312: 0,
  19316: 0,
  19317: 0,
  19318: 0,
  19319: 0,
  19320: 0,
  19330: 0,
  19331: 0,
  19333: 0,
  19335: 0,
  19339: 0,
  19340: 0,
  19341: 0,
  19342: 0,
  19343: 0,
  19344: 0,
  19345: 0,
  19346: 0,
  19347: 0,
  19348: 0,
  19350: 0,
  19351: 0,
  19352: 0,
  19353: 0,
  19354: 0,
  19355: 0,
  19357: 0,
  19358: 0,
  19360: 0,
  19362: 0,
  19363: 0,
  19365: 0,
  19366: 0,
  19367: 0,
  19369: 0,
  19371: 0,
  19372: 0,
  19373: 0,
  19374: 0,
  19375: 0,
  19376: 0,
  19380: 0,
  19381: 0,
  19382: 0,
  19383: 0,
  19388: 0,
  19390: 0,
  19395: 0,
  19397: 0,
  19398: 0,
  19399: 0,
  19401: 0,
  19403: 0,
  19404: 0,
  19405: 0,
  19406: 0,
  19407: 0,
  19408: 0,
  19409: 0,
  19415: 0,
  19420: 0,
  19421: 0,
  19422: 0,
  19423: 0,
  19424: 0,
  19425: 0,
  19426: 0,
  19428: 0,
  19429: 0,
  19430: 0,
  19432: 0,
  19435: 0,
  19436: 0,
  19437: 0,
  19438: 0,
  19440: 0,
  19441: 0,
  19442: 0,
  19443: 0,
  19444: 0,
  19446: 0,
  19450: 0,
  19451: 0,
  19453: 0,
  19454: 0,
  19455: 0,
  19456: 0,
  19457: 0,
  19460: 0,
  19462: 0,
  19464: 0,
  19465: 0,
  19468: 0,
  19470: 0,
  19472: 0,
  19473: 0,
  19474: 0,
  19475: 0,
  19477: 0,
  19478: 0,
  19480: 0,
  19481: 0,
  19482: 0,
  19483: 0,
  19484: 0,
  19485: 0,
  19486: 0,
  19487: 0,
  19488: 0,
  19489: 0,
  19490: 0,
  19492: 0,
  19493: 0,
  19494: 0,
  19495: 0,
  19496: 0,
  19501: 0,
  19503: 0,
  19504: 0,
  19505: 0,
  19506: 0,
  19507: 0,
  19508: 0,
  19510: 0,
  19511: 0,
  19512: 0,
  19516: 0,
  19518: 0,
  19519: 0,
  19520: 0,
  19522: 0,
  19523: 0,
  19525: 0,
  19526: 0,
  19529: 0,
  19530: 0,
  19533: 0,
  19534: 0,
  19535: 0,
  19536: 0,
  19538: 0,
  19539: 0,
  19540: 0,
  19541: 0,
  19542: 0,
  19543: 0,
  19544: 0,
  19545: 0,
  19547: 0,
  19548: 0,
  19549: 0,
  19550: 0,
  19551: 0,
  19554: 0,
  19555: 0,
  19557: 0,
  19559: 0,
  19560: 0,
  19562: 0,
  19564: 0,
  19565: 0,
  19567: 0,
  19601: 0,
  19602: 0,
  19603: 0,
  19604: 0,
  19605: 0,
  19606: 0,
  19607: 0,
  19608: 0,
  19609: 0,
  19610: 0,
  19611: 0,
  19612: 0,
  19640: 0,
  19701: 0,
  19702: 0,
  19703: 0,
  19706: 0,
  19707: 0,
  19708: 0,
  19709: 0,
  19710: 0,
  19711: 0,
  19712: 0,
  19713: 0,
  19714: 0,
  19715: 0,
  19716: 0,
  19717: 0,
  19718: 0,
  19720: 0,
  19721: 0,
  19725: 0,
  19726: 0,
  19730: 0,
  19731: 0,
  19732: 0,
  19733: 0,
  19734: 0,
  19735: 0,
  19736: 0,
  19801: 0,
  19802: 0,
  19803: 0,
  19804: 0,
  19805: 0,
  19806: 0,
  19807: 0,
  19808: 0,
  19809: 0,
  19810: 0,
  19850: 0,
  19880: 0,
  19884: 0,
  19885: 0,
  19886: 0,
  19887: 0,
  19889: 0,
  19890: 0,
  19891: 0,
  19892: 0,
  19893: 0,
  19894: 0,
  19895: 0,
  19896: 0,
  19897: 0,
  19898: 0,
  19899: 0,
  19901: 0,
  19902: 0,
  19903: 0,
  19904: 0,
  19905: 0,
  19906: 0,
  19930: 0,
  19931: 0,
  19933: 0,
  19934: 0,
  19936: 0,
  19938: 0,
  19939: 0,
  19940: 0,
  19941: 0,
  19943: 0,
  19944: 0,
  19945: 0,
  19946: 0,
  19947: 0,
  19950: 0,
  19951: 0,
  19952: 0,
  19953: 0,
  19954: 0,
  19955: 0,
  19956: 0,
  19958: 0,
  19960: 0,
  19961: 0,
  19962: 0,
  19963: 0,
  19964: 0,
  19966: 0,
  19967: 0,
  19968: 0,
  19969: 0,
  19970: 0,
  19971: 0,
  19973: 0,
  19975: 0,
  19977: 0,
  19979: 0,
  19980: 0,
  20001: 0,
  20002: 0,
  20003: 0,
  20004: 0,
  20005: 0,
  20006: 0,
  20007: 0,
  20008: 0,
  20009: 0,
  20010: 0,
  20011: 0,
  20012: 0,
  20013: 0,
  20015: 0,
  20016: 0,
  20017: 0,
  20018: 0,
  20019: 0,
  20020: 0,
  20022: 0,
  20023: 0,
  20024: 0,
  20026: 0,
  20027: 0,
  20029: 0,
  20030: 0,
  20032: 0,
  20033: 0,
  20035: 0,
  20036: 0,
  20037: 0,
  20038: 0,
  20039: 0,
  20040: 0,
  20041: 0,
  20042: 0,
  20043: 0,
  20044: 0,
  20045: 0,
  20046: 0,
  20047: 0,
  20049: 0,
  20050: 0,
  20051: 0,
  20052: 0,
  20053: 0,
  20055: 0,
  20056: 0,
  20057: 0,
  20058: 0,
  20059: 0,
  20060: 0,
  20061: 0,
  20062: 0,
  20063: 0,
  20064: 0,
  20065: 0,
  20066: 0,
  20067: 0,
  20068: 0,
  20069: 0,
  20070: 0,
  20071: 0,
  20073: 0,
  20074: 0,
  20075: 0,
  20076: 0,
  20077: 0,
  20078: 0,
  20080: 0,
  20081: 0,
  20082: 0,
  20088: 0,
  20090: 0,
  20091: 0,
  20097: 0,
  20098: 0,
  20099: 0,
  20101: 0,
  20102: 0,
  20103: 0,
  20104: 0,
  20105: 0,
  20106: 0,
  20107: 0,
  20108: 0,
  20109: 0,
  20110: 0,
  20111: 0,
  20112: 0,
  20113: 0,
  20115: 0,
  20116: 0,
  20117: 0,
  20118: 0,
  20119: 0,
  20120: 0,
  20121: 0,
  20122: 0,
  20124: 0,
  20128: 0,
  20129: 0,
  20130: 0,
  20131: 0,
  20132: 0,
  20134: 0,
  20135: 0,
  20136: 0,
  20137: 0,
  20138: 0,
  20139: 0,
  20140: 0,
  20141: 0,
  20142: 0,
  20143: 0,
  20144: 0,
  20146: 0,
  20147: 0,
  20148: 0,
  20149: 0,
  20151: 0,
  20152: 0,
  20153: 0,
  20155: 0,
  20156: 0,
  20158: 0,
  20159: 0,
  20160: 0,
  20163: 0,
  20164: 0,
  20165: 0,
  20166: 0,
  20167: 0,
  20168: 0,
  20169: 0,
  20170: 0,
  20171: 0,
  20172: 0,
  20175: 0,
  20176: 0,
  20177: 0,
  20178: 0,
  20180: 0,
  20181: 0,
  20182: 0,
  20184: 0,
  20185: 0,
  20186: 0,
  20187: 0,
  20188: 0,
  20189: 0,
  20190: 0,
  20191: 0,
  20192: 0,
  20193: 0,
  20194: 0,
  20195: 0,
  20196: 0,
  20197: 0,
  20198: 0,
  20199: 0,
  20201: 0,
  20202: 0,
  20203: 0,
  20204: 0,
  20206: 0,
  20207: 0,
  20208: 0,
  20210: 0,
  20211: 0,
  20212: 0,
  20213: 0,
  20214: 0,
  20215: 0,
  20216: 0,
  20217: 0,
  20218: 0,
  20219: 0,
  20220: 0,
  20221: 0,
  20222: 0,
  20223: 0,
  20224: 0,
  20226: 0,
  20227: 0,
  20228: 0,
  20229: 0,
  20230: 0,
  20231: 0,
  20232: 0,
  20233: 0,
  20235: 0,
  20237: 0,
  20238: 0,
  20239: 0,
  20240: 0,
  20241: 0,
  20242: 0,
  20244: 0,
  20245: 0,
  20250: 0,
  20251: 0,
  20254: 0,
  20260: 0,
  20261: 0,
  20262: 0,
  20265: 0,
  20266: 0,
  20268: 0,
  20270: 0,
  20277: 0,
  20289: 0,
  20299: 0,
  20301: 0,
  20303: 0,
  20306: 0,
  20307: 0,
  20310: 0,
  20314: 0,
  20315: 0,
  20317: 0,
  20318: 0,
  20319: 0,
  20330: 0,
  20332: 0,
  20336: 0,
  20337: 0,
  20338: 0,
  20340: 0,
  20350: 0,
  20355: 0,
  20370: 0,
  20372: 0,
  20373: 0,
  20374: 0,
  20375: 0,
  20376: 0,
  20380: 0,
  20388: 0,
  20389: 0,
  20390: 0,
  20391: 0,
  20392: 0,
  20393: 0,
  20394: 0,
  20395: 0,
  20398: 0,
  20401: 0,
  20402: 0,
  20403: 0,
  20404: 0,
  20405: 0,
  20406: 0,
  20407: 0,
  20408: 0,
  20409: 0,
  20410: 0,
  20411: 0,
  20412: 0,
  20413: 0,
  20414: 0,
  20415: 0,
  20416: 0,
  20418: 0,
  20419: 0,
  20420: 0,
  20421: 0,
  20422: 0,
  20423: 0,
  20424: 0,
  20425: 0,
  20426: 0,
  20427: 0,
  20428: 0,
  20429: 0,
  20431: 0,
  20433: 0,
  20434: 0,
  20435: 0,
  20436: 0,
  20437: 0,
  20439: 0,
  20440: 0,
  20441: 0,
  20442: 0,
  20444: 0,
  20447: 0,
  20451: 0,
  20453: 0,
  20456: 0,
  20460: 0,
  20463: 0,
  20468: 0,
  20469: 0,
  20470: 0,
  20472: 0,
  20500: 0,
  20501: 0,
  20502: 0,
  20503: 0,
  20504: 0,
  20505: 0,
  20506: 0,
  20507: 0,
  20508: 0,
  20509: 0,
  20510: 0,
  20511: 0,
  20515: 0,
  20520: 0,
  20521: 0,
  20522: 0,
  20523: 0,
  20524: 0,
  20525: 0,
  20526: 0,
  20527: 0,
  20528: 0,
  20529: 0,
  20530: 0,
  20531: 0,
  20532: 0,
  20533: 0,
  20534: 0,
  20535: 0,
  20536: 0,
  20537: 0,
  20538: 0,
  20539: 0,
  20540: 0,
  20541: 0,
  20542: 0,
  20543: 0,
  20544: 0,
  20546: 0,
  20547: 0,
  20548: 0,
  20549: 0,
  20550: 0,
  20551: 0,
  20552: 0,
  20553: 0,
  20554: 0,
  20555: 0,
  20557: 0,
  20558: 0,
  20559: 0,
  20560: 0,
  20565: 0,
  20566: 0,
  20570: 0,
  20571: 0,
  20572: 0,
  20573: 0,
  20575: 0,
  20576: 0,
  20577: 0,
  20578: 0,
  20579: 0,
  20580: 0,
  20581: 0,
  20585: 0,
  20586: 0,
  20588: 0,
  20590: 0,
  20591: 0,
  20593: 0,
  20594: 0,
  20597: 0,
  20598: 0,
  20599: 0,
  20601: 0,
  20602: 0,
  20603: 0,
  20604: 0,
  20606: 0,
  20607: 0,
  20608: 0,
  20609: 0,
  20610: 0,
  20611: 0,
  20612: 0,
  20613: 0,
  20615: 0,
  20616: 0,
  20617: 0,
  20618: 0,
  20619: 0,
  20620: 0,
  20621: 0,
  20622: 0,
  20623: 0,
  20624: 0,
  20625: 0,
  20626: 0,
  20627: 0,
  20628: 0,
  20629: 0,
  20630: 0,
  20632: 0,
  20634: 0,
  20635: 0,
  20636: 0,
  20637: 0,
  20639: 0,
  20640: 0,
  20643: 0,
  20645: 0,
  20646: 0,
  20650: 0,
  20653: 0,
  20656: 0,
  20657: 0,
  20658: 0,
  20659: 0,
  20660: 0,
  20661: 0,
  20662: 0,
  20664: 0,
  20667: 0,
  20670: 0,
  20674: 0,
  20675: 0,
  20676: 0,
  20677: 0,
  20678: 0,
  20680: 0,
  20682: 0,
  20684: 0,
  20685: 0,
  20686: 0,
  20687: 0,
  20688: 0,
  20689: 0,
  20690: 0,
  20692: 0,
  20693: 0,
  20695: 0,
  20697: 0,
  20701: 0,
  20703: 0,
  20704: 0,
  20705: 0,
  20706: 0,
  20707: 0,
  20708: 0,
  20709: 0,
  20710: 0,
  20711: 0,
  20712: 0,
  20714: 0,
  20715: 0,
  20716: 0,
  20717: 0,
  20718: 0,
  20719: 0,
  20720: 0,
  20721: 0,
  20722: 0,
  20723: 0,
  20724: 0,
  20725: 0,
  20726: 0,
  20731: 0,
  20732: 0,
  20733: 0,
  20735: 0,
  20736: 0,
  20737: 0,
  20738: 0,
  20740: 0,
  20741: 0,
  20742: 0,
  20743: 0,
  20744: 0,
  20745: 0,
  20746: 0,
  20747: 0,
  20748: 0,
  20749: 0,
  20750: 0,
  20751: 0,
  20752: 0,
  20753: 0,
  20754: 0,
  20755: 0,
  20757: 0,
  20758: 0,
  20759: 0,
  20762: 0,
  20763: 0,
  20764: 0,
  20765: 0,
  20768: 0,
  20769: 0,
  20770: 0,
  20771: 0,
  20772: 0,
  20773: 0,
  20774: 0,
  20775: 0,
  20776: 0,
  20777: 0,
  20778: 0,
  20779: 0,
  20781: 0,
  20782: 0,
  20783: 0,
  20784: 0,
  20785: 0,
  20787: 0,
  20788: 0,
  20790: 0,
  20791: 0,
  20792: 0,
  20794: 0,
  20797: 0,
  20799: 0,
  20810: 0,
  20811: 0,
  20812: 0,
  20813: 0,
  20814: 0,
  20815: 0,
  20816: 0,
  20817: 0,
  20818: 0,
  20824: 0,
  20825: 0,
  20827: 0,
  20830: 0,
  20832: 0,
  20833: 0,
  20837: 0,
  20838: 0,
  20839: 0,
  20841: 0,
  20842: 0,
  20847: 0,
  20848: 0,
  20849: 0,
  20850: 0,
  20851: 0,
  20852: 0,
  20853: 0,
  20854: 0,
  20855: 0,
  20857: 0,
  20859: 0,
  20860: 0,
  20861: 0,
  20862: 0,
  20866: 0,
  20868: 0,
  20871: 0,
  20872: 0,
  20874: 0,
  20875: 0,
  20876: 0,
  20877: 0,
  20878: 0,
  20879: 0,
  20880: 0,
  20882: 0,
  20883: 0,
  20884: 0,
  20885: 0,
  20886: 0,
  20889: 0,
  20891: 0,
  20892: 0,
  20894: 0,
  20895: 0,
  20896: 0,
  20897: 0,
  20898: 0,
  20899: 0,
  20901: 0,
  20902: 0,
  20903: 0,
  20904: 0,
  20905: 0,
  20906: 0,
  20907: 0,
  20908: 0,
  20910: 0,
  20911: 0,
  20912: 0,
  20913: 0,
  20914: 0,
  20915: 0,
  20916: 0,
  20918: 0,
  20993: 0,
  20997: 0,
  21001: 0,
  21005: 0,
  21009: 0,
  21010: 0,
  21012: 0,
  21013: 0,
  21014: 0,
  21015: 0,
  21017: 0,
  21018: 0,
  21020: 0,
  21022: 0,
  21023: 0,
  21027: 0,
  21028: 0,
  21029: 0,
  21030: 0,
  21031: 0,
  21032: 0,
  21034: 0,
  21035: 0,
  21036: 0,
  21037: 0,
  21040: 0,
  21041: 0,
  21042: 0,
  21043: 0,
  21044: 0,
  21045: 0,
  21046: 0,
  21047: 0,
  21048: 0,
  21050: 0,
  21051: 0,
  21052: 0,
  21053: 0,
  21054: 0,
  21055: 0,
  21056: 0,
  21057: 0,
  21060: 0,
  21061: 0,
  21062: 0,
  21065: 0,
  21071: 0,
  21074: 0,
  21075: 0,
  21076: 0,
  21077: 0,
  21078: 0,
  21082: 0,
  21084: 0,
  21085: 0,
  21087: 0,
  21088: 0,
  21090: 0,
  21092: 0,
  21093: 0,
  21094: 0,
  21098: 0,
  21102: 0,
  21104: 0,
  21105: 0,
  21106: 0,
  21108: 0,
  21111: 0,
  21113: 0,
  21114: 0,
  21117: 0,
  21120: 0,
  21122: 0,
  21123: 0,
  21128: 0,
  21130: 0,
  21131: 0,
  21132: 0,
  21133: 0,
  21136: 0,
  21139: 0,
  21140: 0,
  21144: 0,
  21146: 0,
  21150: 0,
  21152: 0,
  21153: 0,
  21154: 0,
  21155: 0,
  21156: 0,
  21157: 0,
  21158: 0,
  21160: 0,
  21161: 0,
  21162: 0,
  21163: 0,
  21201: 0,
  21202: 0,
  21203: 0,
  21204: 0,
  21205: 0,
  21206: 0,
  21207: 0,
  21208: 0,
  21209: 0,
  21210: 0,
  21211: 0,
  21212: 0,
  21213: 0,
  21214: 0,
  21215: 0,
  21216: 0,
  21217: 0,
  21218: 0,
  21219: 0,
  21220: 0,
  21221: 0,
  21222: 0,
  21223: 0,
  21224: 0,
  21225: 0,
  21226: 0,
  21227: 0,
  21228: 0,
  21229: 0,
  21230: 0,
  21231: 0,
  21233: 0,
  21234: 0,
  21235: 0,
  21236: 0,
  21237: 0,
  21239: 0,
  21240: 0,
  21241: 0,
  21244: 0,
  21250: 0,
  21251: 0,
  21252: 0,
  21260: 0,
  21261: 0,
  21263: 0,
  21264: 0,
  21265: 0,
  21268: 0,
  21270: 0,
  21273: 0,
  21274: 0,
  21275: 0,
  21278: 0,
  21279: 0,
  21280: 0,
  21281: 0,
  21282: 0,
  21283: 0,
  21284: 0,
  21285: 0,
  21286: 0,
  21287: 0,
  21288: 0,
  21289: 0,
  21290: 0,
  21297: 0,
  21298: 0,
  21401: 0,
  21402: 0,
  21403: 0,
  21404: 0,
  21405: 0,
  21409: 0,
  21411: 0,
  21412: 0,
  21501: 0,
  21502: 0,
  21503: 0,
  21504: 0,
  21505: 0,
  21520: 0,
  21521: 0,
  21522: 0,
  21523: 0,
  21524: 0,
  21528: 0,
  21529: 0,
  21530: 0,
  21531: 0,
  21532: 0,
  21536: 0,
  21538: 0,
  21539: 0,
  21540: 0,
  21541: 0,
  21542: 0,
  21543: 0,
  21545: 0,
  21550: 0,
  21555: 0,
  21556: 0,
  21557: 0,
  21560: 0,
  21561: 0,
  21562: 0,
  21601: 0,
  21606: 0,
  21607: 0,
  21609: 0,
  21610: 0,
  21612: 0,
  21613: 0,
  21617: 0,
  21619: 0,
  21620: 0,
  21622: 0,
  21623: 0,
  21624: 0,
  21625: 0,
  21626: 0,
  21627: 0,
  21628: 0,
  21629: 0,
  21631: 0,
  21632: 0,
  21634: 0,
  21635: 0,
  21636: 0,
  21638: 0,
  21639: 0,
  21640: 0,
  21641: 0,
  21643: 0,
  21644: 0,
  21645: 0,
  21647: 0,
  21648: 0,
  21649: 0,
  21650: 0,
  21651: 0,
  21652: 0,
  21653: 0,
  21654: 0,
  21655: 0,
  21656: 0,
  21657: 0,
  21658: 0,
  21659: 0,
  21660: 0,
  21661: 0,
  21662: 0,
  21663: 0,
  21664: 0,
  21665: 0,
  21666: 0,
  21667: 0,
  21668: 0,
  21669: 0,
  21670: 0,
  21671: 0,
  21672: 0,
  21673: 0,
  21675: 0,
  21676: 0,
  21677: 0,
  21678: 0,
  21679: 0,
  21681: 0,
  21682: 0,
  21683: 0,
  21684: 0,
  21685: 0,
  21686: 0,
  21687: 0,
  21688: 0,
  21690: 0,
  21701: 0,
  21702: 0,
  21703: 0,
  21704: 0,
  21705: 0,
  21709: 0,
  21710: 0,
  21711: 0,
  21713: 0,
  21714: 0,
  21715: 0,
  21716: 0,
  21717: 0,
  21718: 0,
  21719: 0,
  21720: 0,
  21721: 0,
  21722: 0,
  21723: 0,
  21727: 0,
  21733: 0,
  21734: 0,
  21737: 0,
  21738: 0,
  21740: 0,
  21741: 0,
  21742: 0,
  21746: 0,
  21747: 0,
  21748: 0,
  21749: 0,
  21750: 0,
  21754: 0,
  21755: 0,
  21756: 0,
  21757: 0,
  21758: 0,
  21759: 0,
  21762: 0,
  21765: 0,
  21766: 0,
  21767: 0,
  21769: 0,
  21770: 0,
  21771: 0,
  21773: 0,
  21774: 0,
  21775: 0,
  21776: 0,
  21777: 0,
  21778: 0,
  21779: 0,
  21780: 0,
  21781: 0,
  21782: 0,
  21783: 0,
  21784: 0,
  21787: 0,
  21788: 0,
  21790: 0,
  21791: 0,
  21792: 0,
  21793: 0,
  21794: 0,
  21795: 0,
  21797: 0,
  21798: 0,
  21801: 0,
  21802: 0,
  21803: 0,
  21804: 0,
  21810: 0,
  21811: 0,
  21813: 0,
  21814: 0,
  21817: 0,
  21821: 0,
  21822: 0,
  21824: 0,
  21826: 0,
  21829: 0,
  21830: 0,
  21835: 0,
  21836: 0,
  21837: 0,
  21838: 0,
  21840: 0,
  21841: 0,
  21842: 0,
  21843: 0,
  21849: 0,
  21850: 0,
  21851: 0,
  21852: 0,
  21853: 0,
  21856: 0,
  21857: 0,
  21861: 0,
  21862: 0,
  21863: 0,
  21864: 0,
  21865: 0,
  21866: 0,
  21867: 0,
  21869: 0,
  21870: 0,
  21871: 0,
  21872: 0,
  21874: 0,
  21875: 0,
  21890: 0,
  21901: 0,
  21902: 0,
  21903: 0,
  21904: 0,
  21911: 0,
  21912: 0,
  21913: 0,
  21914: 0,
  21915: 0,
  21916: 0,
  21917: 0,
  21918: 0,
  21919: 0,
  21920: 0,
  21921: 0,
  21922: 0,
  21930: 0,
  22003: 0,
  22009: 0,
  22015: 0,
  22025: 0,
  22026: 0,
  22027: 0,
  22030: 0,
  22031: 0,
  22032: 0,
  22033: 0,
  22034: 0,
  22035: 0,
  22036: 0,
  22037: 0,
  22038: 0,
  22039: 0,
  22040: 0,
  22041: 0,
  22042: 0,
  22043: 0,
  22044: 0,
  22046: 0,
  22047: 0,
  22060: 0,
  22066: 0,
  22067: 0,
  22079: 0,
  22081: 0,
  22082: 0,
  22092: 0,
  22093: 0,
  22095: 0,
  22096: 0,
  22101: 0,
  22102: 0,
  22103: 0,
  22106: 0,
  22107: 0,
  22108: 0,
  22109: 0,
  22116: 0,
  22118: 0,
  22119: 0,
  22120: 0,
  22121: 0,
  22122: 0,
  22124: 0,
  22125: 0,
  22134: 0,
  22135: 0,
  22150: 0,
  22151: 0,
  22152: 0,
  22153: 0,
  22156: 0,
  22158: 0,
  22159: 0,
  22160: 0,
  22161: 0,
  22172: 0,
  22180: 0,
  22181: 0,
  22182: 0,
  22183: 0,
  22184: 0,
  22185: 0,
  22191: 0,
  22192: 0,
  22193: 0,
  22194: 0,
  22195: 0,
  22199: 0,
  22201: 0,
  22202: 0,
  22203: 0,
  22204: 0,
  22205: 0,
  22206: 0,
  22207: 0,
  22209: 0,
  22210: 0,
  22211: 0,
  22212: 0,
  22213: 0,
  22214: 0,
  22215: 0,
  22216: 0,
  22217: 0,
  22218: 0,
  22219: 0,
  22222: 0,
  22223: 0,
  22225: 0,
  22226: 0,
  22227: 0,
  22229: 0,
  22230: 0,
  22234: 0,
  22240: 0,
  22241: 0,
  22242: 0,
  22243: 0,
  22244: 0,
  22245: 0,
  22246: 0,
  22301: 0,
  22302: 0,
  22303: 0,
  22304: 0,
  22305: 0,
  22306: 0,
  22307: 0,
  22308: 0,
  22309: 0,
  22310: 0,
  22311: 0,
  22312: 0,
  22313: 0,
  22314: 0,
  22315: 0,
  22320: 0,
  22321: 0,
  22331: 0,
  22332: 0,
  22333: 0,
  22334: 0,
  22336: 0,
  22401: 0,
  22402: 0,
  22403: 0,
  22404: 0,
  22405: 0,
  22406: 0,
  22407: 0,
  22408: 0,
  22412: 0,
  22427: 0,
  22428: 0,
  22430: 0,
  22432: 0,
  22433: 0,
  22435: 0,
  22436: 0,
  22437: 0,
  22438: 0,
  22442: 0,
  22443: 0,
  22446: 0,
  22448: 0,
  22451: 0,
  22454: 0,
  22456: 0,
  22460: 0,
  22463: 0,
  22469: 0,
  22471: 0,
  22472: 0,
  22473: 0,
  22476: 0,
  22480: 0,
  22481: 0,
  22482: 0,
  22485: 0,
  22488: 0,
  22501: 0,
  22503: 0,
  22504: 0,
  22507: 0,
  22508: 0,
  22509: 0,
  22511: 0,
  22513: 0,
  22514: 0,
  22517: 0,
  22520: 0,
  22523: 0,
  22524: 0,
  22526: 0,
  22528: 0,
  22529: 0,
  22530: 0,
  22534: 0,
  22535: 0,
  22538: 0,
  22539: 0,
  22542: 0,
  22544: 0,
  22545: 0,
  22546: 0,
  22547: 0,
  22548: 0,
  22551: 0,
  22552: 0,
  22553: 0,
  22554: 0,
  22555: 0,
  22556: 0,
  22558: 0,
  22560: 0,
  22565: 0,
  22567: 0,
  22570: 0,
  22572: 0,
  22576: 0,
  22577: 0,
  22578: 0,
  22579: 0,
  22580: 0,
  22581: 0,
  22601: 0,
  22602: 0,
  22603: 0,
  22604: 0,
  22610: 0,
  22611: 0,
  22620: 0,
  22622: 0,
  22623: 0,
  22624: 0,
  22625: 0,
  22626: 0,
  22627: 0,
  22630: 0,
  22637: 0,
  22638: 0,
  22639: 0,
  22640: 0,
  22641: 0,
  22642: 0,
  22643: 0,
  22644: 0,
  22645: 0,
  22646: 0,
  22649: 0,
  22650: 0,
  22652: 0,
  22654: 0,
  22655: 0,
  22656: 0,
  22657: 0,
  22660: 0,
  22663: 0,
  22664: 0,
  22701: 0,
  22709: 0,
  22711: 0,
  22712: 0,
  22713: 0,
  22714: 0,
  22715: 0,
  22716: 0,
  22718: 0,
  22719: 0,
  22720: 0,
  22721: 0,
  22722: 0,
  22723: 0,
  22724: 0,
  22725: 0,
  22726: 0,
  22727: 0,
  22728: 0,
  22729: 0,
  22730: 0,
  22731: 0,
  22732: 0,
  22733: 0,
  22734: 0,
  22735: 0,
  22736: 0,
  22737: 0,
  22738: 0,
  22739: 0,
  22740: 0,
  22741: 0,
  22742: 0,
  22743: 0,
  22746: 0,
  22747: 0,
  22748: 0,
  22749: 0,
  22801: 0,
  22802: 0,
  22803: 0,
  22807: 0,
  22810: 0,
  22811: 0,
  22812: 0,
  22815: 0,
  22820: 0,
  22821: 0,
  22824: 0,
  22827: 0,
  22830: 0,
  22831: 0,
  22832: 0,
  22833: 0,
  22834: 0,
  22835: 0,
  22840: 0,
  22841: 0,
  22842: 0,
  22843: 0,
  22844: 0,
  22845: 0,
  22846: 0,
  22847: 0,
  22848: 0,
  22849: 0,
  22850: 0,
  22851: 0,
  22853: 0,
  22901: 0,
  22902: 0,
  22903: 0,
  22904: 0,
  22905: 0,
  22906: 0,
  22907: 0,
  22908: 0,
  22909: 0,
  22910: 0,
  22911: 0,
  22920: 0,
  22922: 0,
  22923: 0,
  22924: 0,
  22931: 0,
  22932: 0,
  22935: 0,
  22936: 0,
  22937: 0,
  22938: 0,
  22939: 0,
  22940: 0,
  22942: 0,
  22943: 0,
  22945: 0,
  22946: 0,
  22947: 0,
  22948: 0,
  22949: 0,
  22952: 0,
  22954: 0,
  22957: 0,
  22958: 0,
  22959: 0,
  22960: 0,
  22963: 0,
  22964: 0,
  22965: 0,
  22967: 0,
  22968: 0,
  22969: 0,
  22971: 0,
  22972: 0,
  22973: 0,
  22974: 0,
  22976: 0,
  22980: 0,
  22987: 0,
  22989: 0,
  23001: 0,
  23002: 0,
  23003: 0,
  23004: 0,
  23005: 0,
  23009: 0,
  23011: 0,
  23014: 0,
  23015: 0,
  23017: 0,
  23018: 0,
  23021: 0,
  23022: 0,
  23023: 0,
  23024: 0,
  23025: 0,
  23027: 0,
  23030: 0,
  23031: 0,
  23032: 0,
  23035: 0,
  23038: 0,
  23039: 0,
  23040: 0,
  23043: 0,
  23045: 0,
  23047: 0,
  23050: 0,
  23055: 0,
  23056: 0,
  23058: 0,
  23059: 0,
  23060: 0,
  23061: 0,
  23062: 0,
  23063: 0,
  23064: 0,
  23065: 0,
  23066: 0,
  23067: 0,
  23068: 0,
  23069: 0,
  23070: 0,
  23071: 0,
  23072: 0,
  23075: 0,
  23076: 0,
  23079: 0,
  23081: 0,
  23083: 0,
  23084: 0,
  23085: 0,
  23086: 0,
  23089: 0,
  23090: 0,
  23091: 0,
  23092: 0,
  23093: 0,
  23101: 0,
  23102: 0,
  23103: 0,
  23105: 0,
  23106: 0,
  23107: 0,
  23108: 0,
  23109: 0,
  23110: 0,
  23111: 0,
  23112: 0,
  23113: 0,
  23114: 0,
  23115: 0,
  23116: 0,
  23117: 0,
  23119: 0,
  23120: 0,
  23123: 0,
  23124: 0,
  23125: 0,
  23126: 0,
  23127: 0,
  23128: 0,
  23129: 0,
  23130: 0,
  23131: 0,
  23138: 0,
  23139: 0,
  23140: 0,
  23141: 0,
  23146: 0,
  23147: 0,
  23148: 0,
  23149: 0,
  23150: 0,
  23153: 0,
  23154: 0,
  23155: 0,
  23156: 0,
  23160: 0,
  23161: 0,
  23162: 0,
  23163: 0,
  23168: 0,
  23169: 0,
  23170: 0,
  23173: 0,
  23175: 0,
  23176: 0,
  23177: 0,
  23178: 0,
  23180: 0,
  23181: 0,
  23183: 0,
  23184: 0,
  23185: 0,
  23186: 0,
  23187: 0,
  23188: 0,
  23190: 0,
  23191: 0,
  23192: 0,
  23218: 0,
  23219: 0,
  23220: 0,
  23221: 0,
  23222: 0,
  23223: 0,
  23224: 0,
  23225: 0,
  23226: 0,
  23227: 0,
  23228: 0,
  23229: 0,
  23230: 0,
  23231: 0,
  23232: 0,
  23233: 0,
  23234: 0,
  23235: 0,
  23236: 0,
  23237: 0,
  23238: 0,
  23240: 0,
  23241: 0,
  23242: 0,
  23249: 0,
  23250: 0,
  23255: 0,
  23260: 0,
  23261: 0,
  23269: 0,
  23270: 0,
  23272: 0,
  23273: 0,
  23274: 0,
  23275: 0,
  23276: 0,
  23278: 0,
  23279: 0,
  23280: 0,
  23282: 0,
  23284: 0,
  23285: 0,
  23286: 0,
  23288: 0,
  23289: 0,
  23290: 0,
  23291: 0,
  23292: 0,
  23293: 0,
  23294: 0,
  23295: 0,
  23297: 0,
  23298: 0,
  23301: 0,
  23302: 0,
  23304: 0,
  23306: 0,
  23307: 0,
  23308: 0,
  23310: 0,
  23313: 0,
  23314: 0,
  23315: 0,
  23316: 0,
  23320: 0,
  23321: 0,
  23322: 0,
  23323: 0,
  23324: 0,
  23325: 0,
  23326: 0,
  23327: 0,
  23328: 0,
  23336: 0,
  23337: 0,
  23341: 0,
  23345: 0,
  23347: 0,
  23350: 0,
  23354: 0,
  23356: 0,
  23357: 0,
  23358: 0,
  23359: 0,
  23389: 0,
  23395: 0,
  23396: 0,
  23397: 0,
  23398: 0,
  23399: 0,
  23401: 0,
  23404: 0,
  23405: 0,
  23407: 0,
  23408: 0,
  23409: 0,
  23410: 0,
  23412: 0,
  23413: 0,
  23414: 0,
  23415: 0,
  23416: 0,
  23417: 0,
  23418: 0,
  23419: 0,
  23420: 0,
  23421: 0,
  23422: 0,
  23423: 0,
  23424: 0,
  23426: 0,
  23427: 0,
  23429: 0,
  23430: 0,
  23431: 0,
  23432: 0,
  23433: 0,
  23434: 0,
  23435: 0,
  23436: 0,
  23437: 0,
  23438: 0,
  23439: 0,
  23440: 0,
  23441: 0,
  23442: 0,
  23443: 0,
  23450: 0,
  23451: 0,
  23452: 0,
  23453: 0,
  23454: 0,
  23455: 0,
  23456: 0,
  23457: 0,
  23458: 0,
  23459: 0,
  23460: 0,
  23461: 0,
  23462: 0,
  23463: 0,
  23464: 0,
  23465: 0,
  23466: 0,
  23467: 0,
  23468: 0,
  23471: 0,
  23479: 0,
  23480: 0,
  23482: 0,
  23483: 0,
  23486: 0,
  23487: 0,
  23488: 0,
  23500: 0,
  23501: 0,
  23502: 0,
  23503: 0,
  23504: 0,
  23505: 0,
  23506: 0,
  23507: 0,
  23508: 0,
  23509: 0,
  23510: 0,
  23511: 0,
  23512: 0,
  23513: 0,
  23514: 0,
  23515: 0,
  23517: 0,
  23518: 0,
  23519: 0,
  23520: 0,
  23521: 0,
  23523: 0,
  23529: 0,
  23530: 0,
  23541: 0,
  23551: 0,
  23600: 0,
  23601: 0,
  23602: 0,
  23603: 0,
  23604: 0,
  23605: 0,
  23606: 0,
  23607: 0,
  23608: 0,
  23609: 0,
  23612: 0,
  23628: 0,
  23630: 0,
  23631: 0,
  23651: 0,
  23653: 0,
  23661: 0,
  23662: 0,
  23663: 0,
  23664: 0,
  23665: 0,
  23666: 0,
  23667: 0,
  23668: 0,
  23669: 0,
  23670: 0,
  23681: 0,
  23690: 0,
  23691: 0,
  23692: 0,
  23693: 0,
  23694: 0,
  23696: 0,
  23701: 0,
  23702: 0,
  23703: 0,
  23704: 0,
  23705: 0,
  23707: 0,
  23708: 0,
  23709: 0,
  23801: 0,
  23803: 0,
  23804: 0,
  23805: 0,
  23806: 0,
  23821: 0,
  23822: 0,
  23824: 0,
  23825: 0,
  23827: 0,
  23828: 0,
  23829: 0,
  23830: 0,
  23831: 0,
  23832: 0,
  23833: 0,
  23834: 0,
  23836: 0,
  23837: 0,
  23838: 0,
  23839: 0,
  23840: 0,
  23841: 0,
  23842: 0,
  23843: 0,
  23844: 0,
  23845: 0,
  23846: 0,
  23847: 0,
  23850: 0,
  23851: 0,
  23856: 0,
  23857: 0,
  23860: 0,
  23866: 0,
  23867: 0,
  23868: 0,
  23870: 0,
  23872: 0,
  23873: 0,
  23874: 0,
  23875: 0,
  23876: 0,
  23878: 0,
  23879: 0,
  23881: 0,
  23882: 0,
  23883: 0,
  23884: 0,
  23885: 0,
  23887: 0,
  23888: 0,
  23889: 0,
  23890: 0,
  23891: 0,
  23893: 0,
  23894: 0,
  23897: 0,
  23898: 0,
  23899: 0,
  23901: 0,
  23909: 0,
  23915: 0,
  23917: 0,
  23919: 0,
  23920: 0,
  23921: 0,
  23922: 0,
  23923: 0,
  23924: 0,
  23927: 0,
  23930: 0,
  23934: 0,
  23936: 0,
  23937: 0,
  23938: 0,
  23939: 0,
  23941: 0,
  23942: 0,
  23943: 0,
  23944: 0,
  23947: 0,
  23950: 0,
  23952: 0,
  23954: 0,
  23955: 0,
  23958: 0,
  23959: 0,
  23960: 0,
  23962: 0,
  23963: 0,
  23964: 0,
  23966: 0,
  23967: 0,
  23968: 0,
  23970: 0,
  23974: 0,
  23976: 0,
  24001: 0,
  24002: 0,
  24003: 0,
  24004: 0,
  24005: 0,
  24006: 0,
  24007: 0,
  24008: 0,
  24009: 0,
  24010: 0,
  24011: 0,
  24012: 0,
  24013: 0,
  24014: 0,
  24015: 0,
  24016: 0,
  24017: 0,
  24018: 0,
  24019: 0,
  24020: 0,
  24022: 0,
  24023: 0,
  24024: 0,
  24025: 0,
  24026: 0,
  24027: 0,
  24028: 0,
  24029: 0,
  24030: 0,
  24031: 0,
  24032: 0,
  24033: 0,
  24034: 0,
  24035: 0,
  24036: 0,
  24037: 0,
  24038: 0,
  24040: 0,
  24042: 0,
  24043: 0,
  24044: 0,
  24045: 0,
  24048: 0,
  24050: 0,
  24053: 0,
  24054: 0,
  24055: 0,
  24058: 0,
  24059: 0,
  24060: 0,
  24061: 0,
  24062: 0,
  24063: 0,
  24064: 0,
  24065: 0,
  24066: 0,
  24067: 0,
  24068: 0,
  24069: 0,
  24070: 0,
  24072: 0,
  24073: 0,
  24076: 0,
  24077: 0,
  24078: 0,
  24079: 0,
  24082: 0,
  24083: 0,
  24084: 0,
  24085: 0,
  24086: 0,
  24087: 0,
  24088: 0,
  24089: 0,
  24090: 0,
  24091: 0,
  24092: 0,
  24093: 0,
  24094: 0,
  24095: 0,
  24101: 0,
  24102: 0,
  24104: 0,
  24105: 0,
  24111: 0,
  24112: 0,
  24113: 0,
  24114: 0,
  24115: 0,
  24120: 0,
  24121: 0,
  24122: 0,
  24124: 0,
  24126: 0,
  24127: 0,
  24128: 0,
  24129: 0,
  24130: 0,
  24131: 0,
  24132: 0,
  24133: 0,
  24134: 0,
  24136: 0,
  24137: 0,
  24138: 0,
  24139: 0,
  24141: 0,
  24142: 0,
  24143: 0,
  24146: 0,
  24147: 0,
  24148: 0,
  24149: 0,
  24150: 0,
  24151: 0,
  24153: 0,
  24155: 0,
  24156: 0,
  24157: 0,
  24161: 0,
  24162: 0,
  24165: 0,
  24167: 0,
  24168: 0,
  24171: 0,
  24174: 0,
  24175: 0,
  24176: 0,
  24177: 0,
  24178: 0,
  24179: 0,
  24184: 0,
  24185: 0,
  24201: 0,
  24202: 0,
  24203: 0,
  24205: 0,
  24209: 0,
  24210: 0,
  24211: 0,
  24212: 0,
  24215: 0,
  24216: 0,
  24217: 0,
  24218: 0,
  24219: 0,
  24220: 0,
  24221: 0,
  24224: 0,
  24225: 0,
  24226: 0,
  24228: 0,
  24230: 0,
  24236: 0,
  24237: 0,
  24239: 0,
  24243: 0,
  24244: 0,
  24245: 0,
  24246: 0,
  24248: 0,
  24250: 0,
  24251: 0,
  24256: 0,
  24258: 0,
  24260: 0,
  24263: 0,
  24265: 0,
  24266: 0,
  24269: 0,
  24270: 0,
  24271: 0,
  24272: 0,
  24273: 0,
  24277: 0,
  24279: 0,
  24280: 0,
  24281: 0,
  24282: 0,
  24283: 0,
  24290: 0,
  24292: 0,
  24293: 0,
  24301: 0,
  24311: 0,
  24312: 0,
  24313: 0,
  24314: 0,
  24315: 0,
  24316: 0,
  24317: 0,
  24318: 0,
  24319: 0,
  24322: 0,
  24323: 0,
  24324: 0,
  24325: 0,
  24326: 0,
  24327: 0,
  24328: 0,
  24330: 0,
  24333: 0,
  24340: 0,
  24343: 0,
  24347: 0,
  24348: 0,
  24350: 0,
  24351: 0,
  24352: 0,
  24354: 0,
  24360: 0,
  24361: 0,
  24363: 0,
  24366: 0,
  24368: 0,
  24370: 0,
  24374: 0,
  24375: 0,
  24377: 0,
  24378: 0,
  24380: 0,
  24381: 0,
  24382: 0,
  24401: 0,
  24402: 0,
  24407: 0,
  24411: 0,
  24412: 0,
  24413: 0,
  24415: 0,
  24416: 0,
  24421: 0,
  24422: 0,
  24426: 0,
  24430: 0,
  24431: 0,
  24432: 0,
  24433: 0,
  24435: 0,
  24437: 0,
  24438: 0,
  24439: 0,
  24440: 0,
  24441: 0,
  24442: 0,
  24445: 0,
  24448: 0,
  24450: 0,
  24457: 0,
  24458: 0,
  24459: 0,
  24460: 0,
  24463: 0,
  24464: 0,
  24465: 0,
  24467: 0,
  24468: 0,
  24469: 0,
  24471: 0,
  24472: 0,
  24473: 0,
  24474: 0,
  24476: 0,
  24477: 0,
  24479: 0,
  24482: 0,
  24483: 0,
  24484: 0,
  24485: 0,
  24486: 0,
  24487: 0,
  24501: 0,
  24502: 0,
  24503: 0,
  24504: 0,
  24505: 0,
  24506: 0,
  24512: 0,
  24513: 0,
  24514: 0,
  24515: 0,
  24517: 0,
  24520: 0,
  24521: 0,
  24522: 0,
  24523: 0,
  24526: 0,
  24527: 0,
  24528: 0,
  24529: 0,
  24530: 0,
  24531: 0,
  24533: 0,
  24534: 0,
  24535: 0,
  24536: 0,
  24538: 0,
  24539: 0,
  24540: 0,
  24541: 0,
  24543: 0,
  24544: 0,
  24549: 0,
  24550: 0,
  24551: 0,
  24553: 0,
  24554: 0,
  24555: 0,
  24556: 0,
  24557: 0,
  24558: 0,
  24562: 0,
  24563: 0,
  24565: 0,
  24566: 0,
  24569: 0,
  24570: 0,
  24571: 0,
  24572: 0,
  24574: 0,
  24576: 0,
  24577: 0,
  24578: 0,
  24579: 0,
  24580: 0,
  24581: 0,
  24585: 0,
  24586: 0,
  24588: 0,
  24589: 0,
  24590: 0,
  24592: 0,
  24593: 0,
  24594: 0,
  24595: 0,
  24597: 0,
  24598: 0,
  24599: 0,
  24601: 0,
  24602: 0,
  24603: 0,
  24604: 0,
  24605: 0,
  24606: 0,
  24607: 0,
  24608: 0,
  24609: 0,
  24612: 0,
  24613: 0,
  24614: 0,
  24618: 0,
  24619: 0,
  24620: 0,
  24622: 0,
  24624: 0,
  24627: 0,
  24628: 0,
  24630: 0,
  24631: 0,
  24634: 0,
  24635: 0,
  24637: 0,
  24639: 0,
  24640: 0,
  24641: 0,
  24646: 0,
  24647: 0,
  24649: 0,
  24651: 0,
  24656: 0,
  24657: 0,
  24658: 0,
  24701: 0,
  24712: 0,
  24714: 0,
  24715: 0,
  24716: 0,
  24719: 0,
  24724: 0,
  24726: 0,
  24729: 0,
  24731: 0,
  24732: 0,
  24733: 0,
  24736: 0,
  24737: 0,
  24738: 0,
  24739: 0,
  24740: 0,
  24747: 0,
  24751: 0,
  24801: 0,
  24808: 0,
  24811: 0,
  24813: 0,
  24815: 0,
  24816: 0,
  24817: 0,
  24818: 0,
  24820: 0,
  24821: 0,
  24822: 0,
  24823: 0,
  24824: 0,
  24825: 0,
  24826: 0,
  24827: 0,
  24828: 0,
  24829: 0,
  24830: 0,
  24831: 0,
  24834: 0,
  24836: 0,
  24839: 0,
  24842: 0,
  24843: 0,
  24844: 0,
  24845: 0,
  24846: 0,
  24847: 0,
  24848: 0,
  24849: 0,
  24850: 0,
  24851: 0,
  24852: 0,
  24853: 0,
  24854: 0,
  24855: 0,
  24856: 0,
  24857: 0,
  24859: 0,
  24860: 0,
  24861: 0,
  24862: 0,
  24866: 0,
  24867: 0,
  24868: 0,
  24869: 0,
  24870: 0,
  24871: 0,
  24872: 0,
  24873: 0,
  24874: 0,
  24878: 0,
  24879: 0,
  24880: 0,
  24881: 0,
  24882: 0,
  24884: 0,
  24887: 0,
  24888: 0,
  24892: 0,
  24894: 0,
  24895: 0,
  24896: 0,
  24897: 0,
  24898: 0,
  24899: 0,
  24901: 0,
  24902: 0,
  24910: 0,
  24915: 0,
  24916: 0,
  24917: 0,
  24918: 0,
  24920: 0,
  24924: 0,
  24925: 0,
  24927: 0,
  24931: 0,
  24934: 0,
  24935: 0,
  24936: 0,
  24938: 0,
  24941: 0,
  24943: 0,
  24944: 0,
  24945: 0,
  24946: 0,
  24950: 0,
  24951: 0,
  24954: 0,
  24957: 0,
  24961: 0,
  24962: 0,
  24963: 0,
  24966: 0,
  24970: 0,
  24974: 0,
  24976: 0,
  24977: 0,
  24981: 0,
  24983: 0,
  24984: 0,
  24985: 0,
  24986: 0,
  24991: 0,
  24993: 0,
  25002: 0,
  25003: 0,
  25004: 0,
  25005: 0,
  25007: 0,
  25008: 0,
  25009: 0,
  25010: 0,
  25011: 0,
  25015: 0,
  25019: 0,
  25021: 0,
  25022: 0,
  25024: 0,
  25025: 0,
  25026: 0,
  25028: 0,
  25030: 0,
  25031: 0,
  25033: 0,
  25035: 0,
  25036: 0,
  25039: 0,
  25040: 0,
  25043: 0,
  25044: 0,
  25045: 0,
  25046: 0,
  25047: 0,
  25048: 0,
  25049: 0,
  25051: 0,
  25053: 0,
  25054: 0,
  25057: 0,
  25059: 0,
  25060: 0,
  25061: 0,
  25062: 0,
  25063: 0,
  25064: 0,
  25067: 0,
  25070: 0,
  25071: 0,
  25075: 0,
  25076: 0,
  25079: 0,
  25081: 0,
  25082: 0,
  25083: 0,
  25085: 0,
  25086: 0,
  25088: 0,
  25090: 0,
  25093: 0,
  25102: 0,
  25103: 0,
  25106: 0,
  25107: 0,
  25108: 0,
  25109: 0,
  25110: 0,
  25111: 0,
  25112: 0,
  25113: 0,
  25114: 0,
  25115: 0,
  25118: 0,
  25119: 0,
  25121: 0,
  25123: 0,
  25124: 0,
  25125: 0,
  25126: 0,
  25130: 0,
  25132: 0,
  25133: 0,
  25134: 0,
  25136: 0,
  25139: 0,
  25140: 0,
  25141: 0,
  25142: 0,
  25143: 0,
  25147: 0,
  25148: 0,
  25149: 0,
  25150: 0,
  25152: 0,
  25154: 0,
  25156: 0,
  25159: 0,
  25160: 0,
  25161: 0,
  25162: 0,
  25164: 0,
  25165: 0,
  25168: 0,
  25169: 0,
  25173: 0,
  25174: 0,
  25177: 0,
  25180: 0,
  25181: 0,
  25183: 0,
  25185: 0,
  25186: 0,
  25187: 0,
  25193: 0,
  25201: 0,
  25202: 0,
  25203: 0,
  25204: 0,
  25205: 0,
  25206: 0,
  25208: 0,
  25209: 0,
  25211: 0,
  25213: 0,
  25214: 0,
  25231: 0,
  25234: 0,
  25235: 0,
  25239: 0,
  25241: 0,
  25243: 0,
  25244: 0,
  25245: 0,
  25247: 0,
  25248: 0,
  25251: 0,
  25252: 0,
  25253: 0,
  25259: 0,
  25260: 0,
  25261: 0,
  25262: 0,
  25264: 0,
  25265: 0,
  25266: 0,
  25267: 0,
  25268: 0,
  25270: 0,
  25271: 0,
  25275: 0,
  25276: 0,
  25279: 0,
  25281: 0,
  25285: 0,
  25286: 0,
  25287: 0,
  25301: 0,
  25302: 0,
  25303: 0,
  25304: 0,
  25305: 0,
  25306: 0,
  25309: 0,
  25311: 0,
  25312: 0,
  25313: 0,
  25314: 0,
  25315: 0,
  25317: 0,
  25320: 0,
  25321: 0,
  25322: 0,
  25323: 0,
  25324: 0,
  25325: 0,
  25326: 0,
  25327: 0,
  25328: 0,
  25329: 0,
  25330: 0,
  25331: 0,
  25332: 0,
  25333: 0,
  25334: 0,
  25335: 0,
  25336: 0,
  25337: 0,
  25338: 0,
  25339: 0,
  25350: 0,
  25356: 0,
  25357: 0,
  25358: 0,
  25360: 0,
  25361: 0,
  25362: 0,
  25364: 0,
  25365: 0,
  25375: 0,
  25387: 0,
  25389: 0,
  25392: 0,
  25396: 0,
  25401: 0,
  25402: 0,
  25403: 0,
  25404: 0,
  25405: 0,
  25410: 0,
  25411: 0,
  25413: 0,
  25414: 0,
  25419: 0,
  25420: 0,
  25421: 0,
  25422: 0,
  25423: 0,
  25425: 0,
  25427: 0,
  25428: 0,
  25429: 0,
  25430: 0,
  25431: 0,
  25432: 0,
  25434: 0,
  25437: 0,
  25438: 0,
  25440: 0,
  25441: 0,
  25442: 0,
  25443: 0,
  25444: 0,
  25446: 0,
  25501: 0,
  25502: 0,
  25503: 0,
  25504: 0,
  25505: 0,
  25506: 0,
  25507: 0,
  25508: 0,
  25510: 0,
  25511: 0,
  25512: 0,
  25514: 0,
  25515: 0,
  25517: 0,
  25520: 0,
  25521: 0,
  25523: 0,
  25524: 0,
  25526: 0,
  25529: 0,
  25530: 0,
  25534: 0,
  25535: 0,
  25537: 0,
  25540: 0,
  25541: 0,
  25544: 0,
  25545: 0,
  25547: 0,
  25550: 0,
  25555: 0,
  25557: 0,
  25559: 0,
  25560: 0,
  25562: 0,
  25564: 0,
  25565: 0,
  25567: 0,
  25569: 0,
  25570: 0,
  25571: 0,
  25572: 0,
  25573: 0,
  25601: 0,
  25606: 0,
  25607: 0,
  25608: 0,
  25611: 0,
  25612: 0,
  25614: 0,
  25617: 0,
  25621: 0,
  25624: 0,
  25625: 0,
  25628: 0,
  25630: 0,
  25632: 0,
  25634: 0,
  25635: 0,
  25636: 0,
  25637: 0,
  25638: 0,
  25639: 0,
  25644: 0,
  25646: 0,
  25647: 0,
  25649: 0,
  25650: 0,
  25651: 0,
  25652: 0,
  25653: 0,
  25654: 0,
  25661: 0,
  25665: 0,
  25666: 0,
  25667: 0,
  25669: 0,
  25670: 0,
  25671: 0,
  25672: 0,
  25674: 0,
  25676: 0,
  25678: 0,
  25682: 0,
  25685: 0,
  25686: 0,
  25687: 0,
  25688: 0,
  25690: 0,
  25691: 0,
  25692: 0,
  25694: 0,
  25696: 0,
  25697: 0,
  25699: 0,
  25701: 0,
  25702: 0,
  25703: 0,
  25704: 0,
  25705: 0,
  25706: 0,
  25707: 0,
  25708: 0,
  25709: 0,
  25710: 0,
  25711: 0,
  25712: 0,
  25713: 0,
  25714: 0,
  25715: 0,
  25716: 0,
  25717: 0,
  25718: 0,
  25719: 0,
  25720: 0,
  25721: 0,
  25722: 0,
  25723: 0,
  25724: 0,
  25725: 0,
  25726: 0,
  25727: 0,
  25728: 0,
  25729: 0,
  25755: 0,
  25770: 0,
  25771: 0,
  25772: 0,
  25773: 0,
  25774: 0,
  25775: 0,
  25776: 0,
  25777: 0,
  25778: 0,
  25779: 0,
  25801: 0,
  25802: 0,
  25810: 0,
  25811: 0,
  25812: 0,
  25813: 0,
  25816: 0,
  25817: 0,
  25818: 0,
  25820: 0,
  25823: 0,
  25825: 0,
  25826: 0,
  25827: 0,
  25831: 0,
  25832: 0,
  25833: 0,
  25836: 0,
  25837: 0,
  25839: 0,
  25840: 0,
  25841: 0,
  25843: 0,
  25844: 0,
  25845: 0,
  25846: 0,
  25847: 0,
  25848: 0,
  25849: 0,
  25851: 0,
  25853: 0,
  25854: 0,
  25855: 0,
  25856: 0,
  25857: 0,
  25859: 0,
  25860: 0,
  25862: 0,
  25864: 0,
  25865: 0,
  25866: 0,
  25868: 0,
  25870: 0,
  25871: 0,
  25873: 0,
  25875: 0,
  25876: 0,
  25878: 0,
  25879: 0,
  25880: 0,
  25882: 0,
  25901: 0,
  25902: 0,
  25904: 0,
  25906: 0,
  25907: 0,
  25908: 0,
  25909: 0,
  25911: 0,
  25913: 0,
  25914: 0,
  25915: 0,
  25916: 0,
  25917: 0,
  25918: 0,
  25919: 0,
  25920: 0,
  25921: 0,
  25922: 0,
  25926: 0,
  25927: 0,
  25928: 0,
  25931: 0,
  25932: 0,
  25934: 0,
  25936: 0,
  25938: 0,
  25942: 0,
  25943: 0,
  25951: 0,
  25958: 0,
  25961: 0,
  25962: 0,
  25965: 0,
  25966: 0,
  25967: 0,
  25969: 0,
  25971: 0,
  25972: 0,
  25976: 0,
  25977: 0,
  25978: 0,
  25979: 0,
  25981: 0,
  25984: 0,
  25985: 0,
  25986: 0,
  25989: 0,
  26003: 0,
  26030: 0,
  26031: 0,
  26032: 0,
  26033: 0,
  26034: 0,
  26035: 0,
  26036: 0,
  26037: 0,
  26038: 0,
  26039: 0,
  26040: 0,
  26041: 0,
  26047: 0,
  26050: 0,
  26055: 0,
  26056: 0,
  26058: 0,
  26059: 0,
  26060: 0,
  26062: 0,
  26070: 0,
  26074: 0,
  26075: 0,
  26101: 0,
  26102: 0,
  26103: 0,
  26104: 0,
  26105: 0,
  26106: 0,
  26120: 0,
  26121: 0,
  26133: 0,
  26134: 0,
  26136: 0,
  26137: 0,
  26138: 0,
  26141: 0,
  26142: 0,
  26143: 0,
  26146: 0,
  26147: 0,
  26148: 0,
  26149: 0,
  26150: 0,
  26151: 0,
  26152: 0,
  26155: 0,
  26159: 0,
  26160: 0,
  26161: 0,
  26162: 0,
  26164: 0,
  26167: 0,
  26169: 0,
  26170: 0,
  26173: 0,
  26175: 0,
  26178: 0,
  26180: 0,
  26181: 0,
  26184: 0,
  26186: 0,
  26187: 0,
  26201: 0,
  26202: 0,
  26203: 0,
  26205: 0,
  26206: 0,
  26208: 0,
  26209: 0,
  26210: 0,
  26215: 0,
  26217: 0,
  26218: 0,
  26219: 0,
  26222: 0,
  26224: 0,
  26228: 0,
  26229: 0,
  26230: 0,
  26234: 0,
  26236: 0,
  26237: 0,
  26238: 0,
  26241: 0,
  26250: 0,
  26253: 0,
  26254: 0,
  26257: 0,
  26259: 0,
  26260: 0,
  26261: 0,
  26263: 0,
  26264: 0,
  26266: 0,
  26267: 0,
  26268: 0,
  26269: 0,
  26270: 0,
  26271: 0,
  26273: 0,
  26275: 0,
  26276: 0,
  26278: 0,
  26280: 0,
  26282: 0,
  26283: 0,
  26285: 0,
  26287: 0,
  26288: 0,
  26289: 0,
  26291: 0,
  26292: 0,
  26293: 0,
  26294: 0,
  26296: 0,
  26298: 0,
  26301: 0,
  26302: 0,
  26306: 0,
  26320: 0,
  26321: 0,
  26323: 0,
  26325: 0,
  26327: 0,
  26330: 0,
  26332: 0,
  26334: 0,
  26335: 0,
  26337: 0,
  26338: 0,
  26339: 0,
  26342: 0,
  26343: 0,
  26346: 0,
  26347: 0,
  26348: 0,
  26349: 0,
  26351: 0,
  26354: 0,
  26361: 0,
  26362: 0,
  26366: 0,
  26369: 0,
  26372: 0,
  26374: 0,
  26376: 0,
  26377: 0,
  26378: 0,
  26384: 0,
  26385: 0,
  26386: 0,
  26404: 0,
  26405: 0,
  26408: 0,
  26410: 0,
  26411: 0,
  26412: 0,
  26415: 0,
  26416: 0,
  26419: 0,
  26421: 0,
  26422: 0,
  26424: 0,
  26425: 0,
  26426: 0,
  26430: 0,
  26431: 0,
  26434: 0,
  26435: 0,
  26436: 0,
  26437: 0,
  26438: 0,
  26440: 0,
  26443: 0,
  26444: 0,
  26447: 0,
  26448: 0,
  26451: 0,
  26452: 0,
  26456: 0,
  26461: 0,
  26463: 0,
  26501: 0,
  26502: 0,
  26504: 0,
  26505: 0,
  26506: 0,
  26507: 0,
  26508: 0,
  26519: 0,
  26520: 0,
  26521: 0,
  26524: 0,
  26525: 0,
  26527: 0,
  26529: 0,
  26531: 0,
  26534: 0,
  26537: 0,
  26541: 0,
  26542: 0,
  26543: 0,
  26544: 0,
  26546: 0,
  26547: 0,
  26554: 0,
  26555: 0,
  26559: 0,
  26560: 0,
  26561: 0,
  26562: 0,
  26563: 0,
  26566: 0,
  26568: 0,
  26570: 0,
  26571: 0,
  26572: 0,
  26574: 0,
  26575: 0,
  26576: 0,
  26578: 0,
  26581: 0,
  26582: 0,
  26585: 0,
  26586: 0,
  26587: 0,
  26588: 0,
  26590: 0,
  26591: 0,
  26601: 0,
  26610: 0,
  26611: 0,
  26615: 0,
  26617: 0,
  26619: 0,
  26621: 0,
  26623: 0,
  26624: 0,
  26627: 0,
  26629: 0,
  26631: 0,
  26636: 0,
  26638: 0,
  26639: 0,
  26641: 0,
  26651: 0,
  26656: 0,
  26660: 0,
  26662: 0,
  26667: 0,
  26671: 0,
  26674: 0,
  26675: 0,
  26676: 0,
  26678: 0,
  26679: 0,
  26680: 0,
  26681: 0,
  26684: 0,
  26690: 0,
  26691: 0,
  26704: 0,
  26705: 0,
  26707: 0,
  26710: 0,
  26711: 0,
  26714: 0,
  26716: 0,
  26717: 0,
  26719: 0,
  26720: 0,
  26722: 0,
  26726: 0,
  26731: 0,
  26739: 0,
  26743: 0,
  26750: 0,
  26753: 0,
  26755: 0,
  26757: 0,
  26761: 0,
  26763: 0,
  26764: 0,
  26767: 0,
  26801: 0,
  26802: 0,
  26804: 0,
  26807: 0,
  26808: 0,
  26810: 0,
  26812: 0,
  26814: 0,
  26815: 0,
  26817: 0,
  26818: 0,
  26823: 0,
  26824: 0,
  26833: 0,
  26836: 0,
  26838: 0,
  26845: 0,
  26847: 0,
  26851: 0,
  26852: 0,
  26855: 0,
  26865: 0,
  26866: 0,
  26884: 0,
  26886: 0,
  27006: 0,
  27007: 0,
  27009: 0,
  27010: 0,
  27011: 0,
  27012: 0,
  27013: 0,
  27014: 0,
  27016: 0,
  27017: 0,
  27018: 0,
  27019: 0,
  27020: 0,
  27021: 0,
  27022: 0,
  27023: 0,
  27024: 0,
  27025: 0,
  27027: 0,
  27028: 0,
  27030: 0,
  27031: 0,
  27040: 0,
  27041: 0,
  27042: 0,
  27043: 0,
  27045: 0,
  27046: 0,
  27047: 0,
  27048: 0,
  27049: 0,
  27050: 0,
  27051: 0,
  27052: 0,
  27053: 0,
  27054: 0,
  27055: 0,
  27094: 0,
  27098: 0,
  27099: 0,
  27101: 0,
  27102: 0,
  27103: 0,
  27104: 0,
  27105: 0,
  27106: 0,
  27107: 0,
  27108: 0,
  27109: 0,
  27110: 0,
  27111: 0,
  27113: 0,
  27114: 0,
  27115: 0,
  27116: 0,
  27117: 0,
  27120: 0,
  27127: 0,
  27130: 0,
  27150: 0,
  27151: 0,
  27152: 0,
  27155: 0,
  27156: 0,
  27157: 0,
  27198: 0,
  27199: 0,
  27201: 0,
  27202: 0,
  27203: 0,
  27204: 0,
  27205: 0,
  27207: 0,
  27208: 0,
  27209: 0,
  27212: 0,
  27213: 0,
  27214: 0,
  27215: 0,
  27216: 0,
  27217: 0,
  27220: 0,
  27228: 0,
  27229: 0,
  27230: 0,
  27231: 0,
  27233: 0,
  27235: 0,
  27237: 0,
  27239: 0,
  27242: 0,
  27243: 0,
  27244: 0,
  27247: 0,
  27248: 0,
  27249: 0,
  27252: 0,
  27253: 0,
  27256: 0,
  27258: 0,
  27259: 0,
  27260: 0,
  27261: 0,
  27262: 0,
  27263: 0,
  27264: 0,
  27265: 0,
  27278: 0,
  27281: 0,
  27282: 0,
  27283: 0,
  27284: 0,
  27285: 0,
  27288: 0,
  27289: 0,
  27291: 0,
  27292: 0,
  27293: 0,
  27294: 0,
  27295: 0,
  27298: 0,
  27299: 0,
  27301: 0,
  27302: 0,
  27305: 0,
  27306: 0,
  27310: 0,
  27311: 0,
  27312: 0,
  27313: 0,
  27314: 0,
  27315: 0,
  27316: 0,
  27317: 0,
  27320: 0,
  27321: 0,
  27322: 0,
  27323: 0,
  27325: 0,
  27326: 0,
  27330: 0,
  27331: 0,
  27332: 0,
  27340: 0,
  27341: 0,
  27342: 0,
  27343: 0,
  27344: 0,
  27349: 0,
  27350: 0,
  27351: 0,
  27355: 0,
  27356: 0,
  27357: 0,
  27358: 0,
  27359: 0,
  27360: 0,
  27361: 0,
  27370: 0,
  27371: 0,
  27373: 0,
  27374: 0,
  27375: 0,
  27376: 0,
  27377: 0,
  27379: 0,
  27395: 0,
  27401: 0,
  27402: 0,
  27403: 0,
  27404: 0,
  27405: 0,
  27406: 0,
  27407: 0,
  27408: 0,
  27409: 0,
  27410: 0,
  27411: 0,
  27412: 0,
  27413: 0,
  27415: 0,
  27416: 0,
  27417: 0,
  27419: 0,
  27420: 0,
  27425: 0,
  27427: 0,
  27429: 0,
  27435: 0,
  27438: 0,
  27455: 0,
  27480: 0,
  27495: 0,
  27497: 0,
  27498: 0,
  27499: 0,
  27501: 0,
  27502: 0,
  27503: 0,
  27504: 0,
  27505: 0,
  27506: 0,
  27507: 0,
  27508: 0,
  27509: 0,
  27510: 0,
  27511: 0,
  27512: 0,
  27513: 0,
  27514: 0,
  27515: 0,
  27516: 0,
  27517: 0,
  27518: 0,
  27519: 0,
  27520: 0,
  27521: 0,
  27522: 0,
  27523: 0,
  27524: 0,
  27525: 0,
  27526: 0,
  27527: 0,
  27528: 0,
  27529: 0,
  27530: 0,
  27531: 0,
  27532: 0,
  27533: 0,
  27534: 0,
  27536: 0,
  27537: 0,
  27539: 0,
  27540: 0,
  27541: 0,
  27542: 0,
  27543: 0,
  27544: 0,
  27545: 0,
  27546: 0,
  27549: 0,
  27551: 0,
  27552: 0,
  27553: 0,
  27555: 0,
  27556: 0,
  27557: 0,
  27559: 0,
  27560: 0,
  27562: 0,
  27563: 0,
  27564: 0,
  27565: 0,
  27568: 0,
  27569: 0,
  27570: 0,
  27571: 0,
  27572: 0,
  27573: 0,
  27574: 0,
  27576: 0,
  27577: 0,
  27581: 0,
  27582: 0,
  27583: 0,
  27584: 0,
  27586: 0,
  27587: 0,
  27588: 0,
  27589: 0,
  27591: 0,
  27592: 0,
  27593: 0,
  27594: 0,
  27596: 0,
  27597: 0,
  27599: 0,
  27601: 0,
  27602: 0,
  27603: 0,
  27604: 0,
  27605: 0,
  27606: 0,
  27607: 0,
  27608: 0,
  27609: 0,
  27610: 0,
  27611: 0,
  27612: 0,
  27613: 0,
  27614: 0,
  27615: 0,
  27616: 0,
  27617: 0,
  27619: 0,
  27620: 0,
  27621: 0,
  27622: 0,
  27623: 0,
  27624: 0,
  27625: 0,
  27626: 0,
  27627: 0,
  27628: 0,
  27629: 0,
  27634: 0,
  27635: 0,
  27636: 0,
  27640: 0,
  27650: 0,
  27656: 0,
  27658: 0,
  27661: 0,
  27668: 0,
  27675: 0,
  27676: 0,
  27690: 0,
  27695: 0,
  27697: 0,
  27698: 0,
  27699: 0,
  27701: 0,
  27702: 0,
  27703: 0,
  27704: 0,
  27705: 0,
  27706: 0,
  27707: 0,
  27708: 0,
  27709: 0,
  27710: 0,
  27711: 0,
  27712: 0,
  27713: 0,
  27715: 0,
  27717: 0,
  27722: 0,
  27801: 0,
  27802: 0,
  27803: 0,
  27804: 0,
  27805: 0,
  27806: 0,
  27807: 0,
  27808: 0,
  27809: 0,
  27810: 0,
  27811: 0,
  27812: 0,
  27813: 0,
  27814: 0,
  27815: 0,
  27816: 0,
  27817: 0,
  27818: 0,
  27819: 0,
  27820: 0,
  27821: 0,
  27822: 0,
  27823: 0,
  27824: 0,
  27825: 0,
  27826: 0,
  27827: 0,
  27828: 0,
  27829: 0,
  27830: 0,
  27831: 0,
  27832: 0,
  27833: 0,
  27834: 0,
  27835: 0,
  27836: 0,
  27837: 0,
  27839: 0,
  27840: 0,
  27841: 0,
  27842: 0,
  27843: 0,
  27844: 0,
  27845: 0,
  27846: 0,
  27847: 0,
  27849: 0,
  27850: 0,
  27851: 0,
  27852: 0,
  27853: 0,
  27854: 0,
  27855: 0,
  27856: 0,
  27857: 0,
  27858: 0,
  27860: 0,
  27861: 0,
  27862: 0,
  27863: 0,
  27864: 0,
  27865: 0,
  27866: 0,
  27867: 0,
  27868: 0,
  27869: 0,
  27870: 0,
  27871: 0,
  27872: 0,
  27873: 0,
  27874: 0,
  27875: 0,
  27876: 0,
  27877: 0,
  27878: 0,
  27879: 0,
  27880: 0,
  27881: 0,
  27882: 0,
  27883: 0,
  27884: 0,
  27885: 0,
  27886: 0,
  27887: 0,
  27888: 0,
  27889: 0,
  27890: 0,
  27891: 0,
  27892: 0,
  27893: 0,
  27894: 0,
  27895: 0,
  27896: 0,
  27897: 0,
  27906: 0,
  27907: 0,
  27909: 0,
  27910: 0,
  27915: 0,
  27916: 0,
  27917: 0,
  27919: 0,
  27920: 0,
  27921: 0,
  27922: 0,
  27923: 0,
  27924: 0,
  27925: 0,
  27926: 0,
  27927: 0,
  27928: 0,
  27929: 0,
  27930: 0,
  27932: 0,
  27935: 0,
  27936: 0,
  27937: 0,
  27938: 0,
  27939: 0,
  27941: 0,
  27942: 0,
  27943: 0,
  27944: 0,
  27946: 0,
  27947: 0,
  27948: 0,
  27949: 0,
  27950: 0,
  27953: 0,
  27954: 0,
  27956: 0,
  27957: 0,
  27958: 0,
  27959: 0,
  27960: 0,
  27962: 0,
  27964: 0,
  27965: 0,
  27966: 0,
  27967: 0,
  27968: 0,
  27969: 0,
  27970: 0,
  27972: 0,
  27973: 0,
  27974: 0,
  27976: 0,
  27978: 0,
  27979: 0,
  27980: 0,
  27981: 0,
  27982: 0,
  27983: 0,
  27985: 0,
  27986: 0,
  28001: 0,
  28002: 0,
  28006: 0,
  28007: 0,
  28009: 0,
  28010: 0,
  28012: 0,
  28016: 0,
  28017: 0,
  28018: 0,
  28019: 0,
  28020: 0,
  28021: 0,
  28023: 0,
  28024: 0,
  28025: 0,
  28026: 0,
  28027: 0,
  28031: 0,
  28032: 0,
  28033: 0,
  28034: 0,
  28035: 0,
  28036: 0,
  28037: 0,
  28038: 0,
  28039: 0,
  28040: 0,
  28041: 0,
  28042: 0,
  28043: 0,
  28052: 0,
  28053: 0,
  28054: 0,
  28055: 0,
  28056: 0,
  28070: 0,
  28071: 0,
  28072: 0,
  28073: 0,
  28074: 0,
  28075: 0,
  28076: 0,
  28077: 0,
  28078: 0,
  28079: 0,
  28080: 0,
  28081: 0,
  28082: 0,
  28083: 0,
  28086: 0,
  28088: 0,
  28089: 0,
  28090: 0,
  28091: 0,
  28092: 0,
  28093: 0,
  28097: 0,
  28098: 0,
  28101: 0,
  28102: 0,
  28103: 0,
  28104: 0,
  28105: 0,
  28106: 0,
  28107: 0,
  28108: 0,
  28109: 0,
  28110: 0,
  28111: 0,
  28112: 0,
  28114: 0,
  28115: 0,
  28117: 0,
  28119: 0,
  28120: 0,
  28123: 0,
  28124: 0,
  28125: 0,
  28126: 0,
  28127: 0,
  28128: 0,
  28129: 0,
  28130: 0,
  28133: 0,
  28134: 0,
  28135: 0,
  28136: 0,
  28137: 0,
  28138: 0,
  28139: 0,
  28144: 0,
  28145: 0,
  28146: 0,
  28147: 0,
  28150: 0,
  28151: 0,
  28152: 0,
  28159: 0,
  28160: 0,
  28163: 0,
  28164: 0,
  28166: 0,
  28167: 0,
  28168: 0,
  28169: 0,
  28170: 0,
  28173: 0,
  28174: 0,
  28201: 0,
  28202: 0,
  28203: 0,
  28204: 0,
  28205: 0,
  28206: 0,
  28207: 0,
  28208: 0,
  28209: 0,
  28210: 0,
  28211: 0,
  28212: 0,
  28213: 0,
  28214: 0,
  28215: 0,
  28216: 0,
  28217: 0,
  28218: 0,
  28219: 0,
  28220: 0,
  28221: 0,
  28222: 0,
  28223: 0,
  28224: 0,
  28226: 0,
  28227: 0,
  28228: 0,
  28229: 0,
  28230: 0,
  28231: 0,
  28232: 0,
  28233: 0,
  28234: 0,
  28235: 0,
  28236: 0,
  28237: 0,
  28240: 0,
  28241: 0,
  28242: 0,
  28243: 0,
  28244: 0,
  28246: 0,
  28247: 0,
  28250: 0,
  28253: 0,
  28254: 0,
  28255: 0,
  28256: 0,
  28258: 0,
  28260: 0,
  28261: 0,
  28262: 0,
  28263: 0,
  28265: 0,
  28266: 0,
  28269: 0,
  28270: 0,
  28271: 0,
  28272: 0,
  28273: 0,
  28274: 0,
  28275: 0,
  28277: 0,
  28278: 0,
  28280: 0,
  28281: 0,
  28282: 0,
  28284: 0,
  28285: 0,
  28287: 0,
  28288: 0,
  28289: 0,
  28290: 0,
  28296: 0,
  28297: 0,
  28299: 0,
  28301: 0,
  28302: 0,
  28303: 0,
  28304: 0,
  28305: 0,
  28306: 0,
  28307: 0,
  28308: 0,
  28309: 0,
  28310: 0,
  28311: 0,
  28312: 0,
  28314: 0,
  28315: 0,
  28318: 0,
  28319: 0,
  28320: 0,
  28323: 0,
  28325: 0,
  28326: 0,
  28327: 0,
  28328: 0,
  28329: 0,
  28330: 0,
  28331: 0,
  28332: 0,
  28333: 0,
  28334: 0,
  28335: 0,
  28337: 0,
  28338: 0,
  28339: 0,
  28340: 0,
  28341: 0,
  28342: 0,
  28343: 0,
  28344: 0,
  28345: 0,
  28347: 0,
  28348: 0,
  28349: 0,
  28350: 0,
  28351: 0,
  28352: 0,
  28353: 0,
  28355: 0,
  28356: 0,
  28357: 0,
  28358: 0,
  28359: 0,
  28360: 0,
  28361: 0,
  28362: 0,
  28363: 0,
  28364: 0,
  28365: 0,
  28366: 0,
  28367: 0,
  28368: 0,
  28369: 0,
  28370: 0,
  28371: 0,
  28372: 0,
  28373: 0,
  28374: 0,
  28375: 0,
  28376: 0,
  28377: 0,
  28378: 0,
  28379: 0,
  28380: 0,
  28382: 0,
  28383: 0,
  28384: 0,
  28385: 0,
  28386: 0,
  28387: 0,
  28388: 0,
  28390: 0,
  28391: 0,
  28392: 0,
  28393: 0,
  28394: 0,
  28395: 0,
  28396: 0,
  28398: 0,
  28399: 0,
  28401: 0,
  28402: 0,
  28403: 0,
  28404: 0,
  28405: 0,
  28406: 0,
  28407: 0,
  28408: 0,
  28409: 0,
  28410: 0,
  28411: 0,
  28412: 0,
  28420: 0,
  28421: 0,
  28422: 0,
  28423: 0,
  28424: 0,
  28425: 0,
  28428: 0,
  28429: 0,
  28430: 0,
  28431: 0,
  28432: 0,
  28433: 0,
  28434: 0,
  28435: 0,
  28436: 0,
  28438: 0,
  28439: 0,
  28441: 0,
  28442: 0,
  28443: 0,
  28444: 0,
  28445: 0,
  28446: 0,
  28447: 0,
  28448: 0,
  28449: 0,
  28450: 0,
  28451: 0,
  28452: 0,
  28453: 0,
  28454: 0,
  28455: 0,
  28456: 0,
  28457: 0,
  28458: 0,
  28459: 0,
  28460: 0,
  28461: 0,
  28462: 0,
  28463: 0,
  28464: 0,
  28465: 0,
  28466: 0,
  28467: 0,
  28468: 0,
  28469: 0,
  28470: 0,
  28472: 0,
  28478: 0,
  28479: 0,
  28480: 0,
  28501: 0,
  28502: 0,
  28503: 0,
  28504: 0,
  28508: 0,
  28509: 0,
  28510: 0,
  28511: 0,
  28512: 0,
  28513: 0,
  28515: 0,
  28516: 0,
  28518: 0,
  28519: 0,
  28520: 0,
  28521: 0,
  28522: 0,
  28523: 0,
  28524: 0,
  28525: 0,
  28526: 0,
  28527: 0,
  28528: 0,
  28529: 0,
  28530: 0,
  28531: 0,
  28532: 0,
  28533: 0,
  28537: 0,
  28538: 0,
  28539: 0,
  28540: 0,
  28541: 0,
  28542: 0,
  28543: 0,
  28544: 0,
  28545: 0,
  28546: 0,
  28547: 0,
  28551: 0,
  28552: 0,
  28553: 0,
  28554: 0,
  28555: 0,
  28556: 0,
  28557: 0,
  28560: 0,
  28561: 0,
  28562: 0,
  28563: 0,
  28564: 0,
  28570: 0,
  28571: 0,
  28572: 0,
  28573: 0,
  28574: 0,
  28575: 0,
  28577: 0,
  28578: 0,
  28579: 0,
  28580: 0,
  28581: 0,
  28582: 0,
  28583: 0,
  28584: 0,
  28585: 0,
  28586: 0,
  28587: 0,
  28589: 0,
  28590: 0,
  28594: 0,
  28601: 0,
  28602: 0,
  28603: 0,
  28604: 0,
  28605: 0,
  28606: 0,
  28607: 0,
  28608: 0,
  28609: 0,
  28610: 0,
  28611: 0,
  28612: 0,
  28613: 0,
  28615: 0,
  28616: 0,
  28617: 0,
  28618: 0,
  28619: 0,
  28621: 0,
  28622: 0,
  28623: 0,
  28624: 0,
  28625: 0,
  28626: 0,
  28627: 0,
  28628: 0,
  28629: 0,
  28630: 0,
  28631: 0,
  28633: 0,
  28634: 0,
  28635: 0,
  28636: 0,
  28637: 0,
  28638: 0,
  28640: 0,
  28641: 0,
  28642: 0,
  28643: 0,
  28644: 0,
  28645: 0,
  28646: 0,
  28647: 0,
  28649: 0,
  28650: 0,
  28651: 0,
  28652: 0,
  28653: 0,
  28654: 0,
  28655: 0,
  28656: 0,
  28657: 0,
  28658: 0,
  28659: 0,
  28660: 0,
  28661: 0,
  28662: 0,
  28663: 0,
  28664: 0,
  28665: 0,
  28666: 0,
  28667: 0,
  28668: 0,
  28669: 0,
  28670: 0,
  28671: 0,
  28672: 0,
  28673: 0,
  28674: 0,
  28675: 0,
  28676: 0,
  28677: 0,
  28678: 0,
  28679: 0,
  28680: 0,
  28681: 0,
  28682: 0,
  28683: 0,
  28684: 0,
  28685: 0,
  28687: 0,
  28688: 0,
  28689: 0,
  28690: 0,
  28691: 0,
  28692: 0,
  28693: 0,
  28694: 0,
  28697: 0,
  28698: 0,
  28699: 0,
  28701: 0,
  28702: 0,
  28704: 0,
  28705: 0,
  28707: 0,
  28708: 0,
  28709: 0,
  28710: 0,
  28711: 0,
  28712: 0,
  28713: 0,
  28714: 0,
  28715: 0,
  28716: 0,
  28717: 0,
  28718: 0,
  28719: 0,
  28720: 0,
  28721: 0,
  28722: 0,
  28723: 0,
  28724: 0,
  28725: 0,
  28726: 0,
  28727: 0,
  28728: 0,
  28729: 0,
  28730: 0,
  28731: 0,
  28732: 0,
  28733: 0,
  28734: 0,
  28735: 0,
  28736: 0,
  28737: 0,
  28738: 0,
  28739: 0,
  28740: 0,
  28741: 0,
  28742: 0,
  28743: 0,
  28744: 0,
  28745: 0,
  28746: 0,
  28747: 0,
  28748: 0,
  28749: 0,
  28750: 0,
  28751: 0,
  28752: 0,
  28753: 0,
  28754: 0,
  28755: 0,
  28756: 0,
  28757: 0,
  28758: 0,
  28759: 0,
  28760: 0,
  28761: 0,
  28762: 0,
  28763: 0,
  28765: 0,
  28766: 0,
  28768: 0,
  28770: 0,
  28771: 0,
  28772: 0,
  28773: 0,
  28774: 0,
  28775: 0,
  28776: 0,
  28777: 0,
  28778: 0,
  28779: 0,
  28781: 0,
  28782: 0,
  28783: 0,
  28784: 0,
  28785: 0,
  28786: 0,
  28787: 0,
  28788: 0,
  28789: 0,
  28790: 0,
  28791: 0,
  28792: 0,
  28793: 0,
  28801: 0,
  28802: 0,
  28803: 0,
  28804: 0,
  28805: 0,
  28806: 0,
  28810: 0,
  28813: 0,
  28814: 0,
  28815: 0,
  28816: 0,
  28901: 0,
  28902: 0,
  28903: 0,
  28904: 0,
  28905: 0,
  28906: 0,
  28909: 0,
  29001: 0,
  29002: 0,
  29003: 0,
  29006: 0,
  29009: 0,
  29010: 0,
  29014: 0,
  29015: 0,
  29016: 0,
  29018: 0,
  29020: 0,
  29021: 0,
  29030: 0,
  29031: 0,
  29032: 0,
  29033: 0,
  29036: 0,
  29037: 0,
  29038: 0,
  29039: 0,
  29040: 0,
  29041: 0,
  29042: 0,
  29044: 0,
  29045: 0,
  29046: 0,
  29047: 0,
  29048: 0,
  29051: 0,
  29052: 0,
  29053: 0,
  29054: 0,
  29055: 0,
  29056: 0,
  29058: 0,
  29059: 0,
  29061: 0,
  29062: 0,
  29063: 0,
  29065: 0,
  29067: 0,
  29069: 0,
  29070: 0,
  29071: 0,
  29072: 0,
  29073: 0,
  29074: 0,
  29075: 0,
  29078: 0,
  29079: 0,
  29080: 0,
  29081: 0,
  29082: 0,
  29101: 0,
  29102: 0,
  29104: 0,
  29105: 0,
  29106: 0,
  29107: 0,
  29108: 0,
  29111: 0,
  29112: 0,
  29113: 0,
  29114: 0,
  29115: 0,
  29116: 0,
  29117: 0,
  29118: 0,
  29122: 0,
  29123: 0,
  29125: 0,
  29126: 0,
  29127: 0,
  29128: 0,
  29129: 0,
  29130: 0,
  29132: 0,
  29133: 0,
  29135: 0,
  29137: 0,
  29138: 0,
  29142: 0,
  29143: 0,
  29145: 0,
  29146: 0,
  29147: 0,
  29148: 0,
  29150: 0,
  29151: 0,
  29152: 0,
  29153: 0,
  29154: 0,
  29160: 0,
  29161: 0,
  29162: 0,
  29163: 0,
  29164: 0,
  29166: 0,
  29168: 0,
  29169: 0,
  29170: 0,
  29171: 0,
  29172: 0,
  29175: 0,
  29176: 0,
  29177: 0,
  29178: 0,
  29180: 0,
  29201: 0,
  29202: 0,
  29203: 0,
  29204: 0,
  29205: 0,
  29206: 0,
  29207: 0,
  29208: 0,
  29209: 0,
  29210: 0,
  29211: 0,
  29212: 0,
  29214: 0,
  29215: 0,
  29216: 0,
  29217: 0,
  29218: 0,
  29219: 0,
  29220: 0,
  29221: 0,
  29222: 0,
  29223: 0,
  29224: 0,
  29225: 0,
  29226: 0,
  29227: 0,
  29228: 0,
  29229: 0,
  29230: 0,
  29240: 0,
  29250: 0,
  29260: 0,
  29290: 0,
  29292: 0,
  29301: 0,
  29302: 0,
  29303: 0,
  29304: 0,
  29305: 0,
  29306: 0,
  29307: 0,
  29316: 0,
  29318: 0,
  29319: 0,
  29320: 0,
  29321: 0,
  29322: 0,
  29323: 0,
  29324: 0,
  29325: 0,
  29329: 0,
  29330: 0,
  29331: 0,
  29332: 0,
  29333: 0,
  29334: 0,
  29335: 0,
  29336: 0,
  29338: 0,
  29340: 0,
  29341: 0,
  29342: 0,
  29346: 0,
  29348: 0,
  29349: 0,
  29351: 0,
  29353: 0,
  29355: 0,
  29356: 0,
  29360: 0,
  29364: 0,
  29365: 0,
  29368: 0,
  29369: 0,
  29370: 0,
  29372: 0,
  29373: 0,
  29374: 0,
  29375: 0,
  29376: 0,
  29377: 0,
  29378: 0,
  29379: 0,
  29384: 0,
  29385: 0,
  29386: 0,
  29388: 0,
  29390: 0,
  29391: 0,
  29395: 0,
  29401: 0,
  29402: 0,
  29403: 0,
  29404: 0,
  29405: 0,
  29406: 0,
  29407: 0,
  29409: 0,
  29410: 0,
  29412: 0,
  29413: 0,
  29414: 0,
  29415: 0,
  29416: 0,
  29417: 0,
  29418: 0,
  29419: 0,
  29420: 0,
  29422: 0,
  29423: 0,
  29424: 0,
  29425: 0,
  29426: 0,
  29429: 0,
  29430: 0,
  29431: 0,
  29432: 0,
  29433: 0,
  29434: 0,
  29435: 0,
  29436: 0,
  29437: 0,
  29438: 0,
  29439: 0,
  29440: 0,
  29442: 0,
  29445: 0,
  29446: 0,
  29447: 0,
  29448: 0,
  29449: 0,
  29450: 0,
  29451: 0,
  29452: 0,
  29453: 0,
  29455: 0,
  29456: 0,
  29457: 0,
  29458: 0,
  29461: 0,
  29464: 0,
  29465: 0,
  29466: 0,
  29468: 0,
  29469: 0,
  29470: 0,
  29471: 0,
  29472: 0,
  29474: 0,
  29475: 0,
  29476: 0,
  29477: 0,
  29479: 0,
  29481: 0,
  29482: 0,
  29483: 0,
  29484: 0,
  29485: 0,
  29487: 0,
  29488: 0,
  29492: 0,
  29493: 0,
  29501: 0,
  29502: 0,
  29503: 0,
  29504: 0,
  29505: 0,
  29506: 0,
  29510: 0,
  29511: 0,
  29512: 0,
  29516: 0,
  29518: 0,
  29519: 0,
  29520: 0,
  29525: 0,
  29526: 0,
  29527: 0,
  29528: 0,
  29530: 0,
  29532: 0,
  29536: 0,
  29540: 0,
  29541: 0,
  29542: 0,
  29543: 0,
  29544: 0,
  29545: 0,
  29546: 0,
  29547: 0,
  29550: 0,
  29551: 0,
  29554: 0,
  29555: 0,
  29556: 0,
  29560: 0,
  29563: 0,
  29564: 0,
  29565: 0,
  29566: 0,
  29567: 0,
  29568: 0,
  29569: 0,
  29570: 0,
  29571: 0,
  29572: 0,
  29573: 0,
  29574: 0,
  29575: 0,
  29576: 0,
  29577: 0,
  29578: 0,
  29579: 0,
  29580: 0,
  29581: 0,
  29582: 0,
  29583: 0,
  29584: 0,
  29585: 0,
  29587: 0,
  29588: 0,
  29589: 0,
  29590: 0,
  29591: 0,
  29592: 0,
  29593: 0,
  29594: 0,
  29596: 0,
  29597: 0,
  29598: 0,
  29601: 0,
  29602: 0,
  29603: 0,
  29604: 0,
  29605: 0,
  29606: 0,
  29607: 0,
  29608: 0,
  29609: 0,
  29610: 0,
  29611: 0,
  29612: 0,
  29613: 0,
  29614: 0,
  29615: 0,
  29616: 0,
  29617: 0,
  29620: 0,
  29621: 0,
  29622: 0,
  29623: 0,
  29624: 0,
  29625: 0,
  29626: 0,
  29627: 0,
  29628: 0,
  29630: 0,
  29631: 0,
  29632: 0,
  29633: 0,
  29634: 0,
  29635: 0,
  29636: 0,
  29638: 0,
  29639: 0,
  29640: 0,
  29641: 0,
  29642: 0,
  29643: 0,
  29644: 0,
  29645: 0,
  29646: 0,
  29647: 0,
  29648: 0,
  29649: 0,
  29650: 0,
  29651: 0,
  29652: 0,
  29653: 0,
  29654: 0,
  29655: 0,
  29656: 0,
  29657: 0,
  29658: 0,
  29659: 0,
  29661: 0,
  29662: 0,
  29664: 0,
  29665: 0,
  29666: 0,
  29667: 0,
  29669: 0,
  29670: 0,
  29671: 0,
  29672: 0,
  29673: 0,
  29675: 0,
  29676: 0,
  29677: 0,
  29678: 0,
  29679: 0,
  29680: 0,
  29681: 0,
  29682: 0,
  29683: 0,
  29684: 0,
  29685: 0,
  29686: 0,
  29687: 0,
  29688: 0,
  29689: 0,
  29690: 0,
  29691: 0,
  29692: 0,
  29693: 0,
  29695: 0,
  29696: 0,
  29697: 0,
  29698: 0,
  29702: 0,
  29703: 0,
  29704: 0,
  29706: 0,
  29707: 0,
  29708: 0,
  29709: 0,
  29710: 0,
  29712: 0,
  29714: 0,
  29715: 0,
  29716: 0,
  29717: 0,
  29718: 0,
  29720: 0,
  29721: 0,
  29722: 0,
  29724: 0,
  29726: 0,
  29727: 0,
  29728: 0,
  29729: 0,
  29730: 0,
  29731: 0,
  29732: 0,
  29733: 0,
  29734: 0,
  29741: 0,
  29742: 0,
  29743: 0,
  29744: 0,
  29745: 0,
  29801: 0,
  29802: 0,
  29803: 0,
  29804: 0,
  29805: 0,
  29808: 0,
  29809: 0,
  29810: 0,
  29812: 0,
  29813: 0,
  29816: 0,
  29817: 0,
  29819: 0,
  29821: 0,
  29822: 0,
  29824: 0,
  29826: 0,
  29827: 0,
  29828: 0,
  29829: 0,
  29831: 0,
  29832: 0,
  29834: 0,
  29835: 0,
  29836: 0,
  29838: 0,
  29839: 0,
  29840: 0,
  29841: 0,
  29842: 0,
  29843: 0,
  29844: 0,
  29845: 0,
  29846: 0,
  29847: 0,
  29848: 0,
  29849: 0,
  29850: 0,
  29851: 0,
  29853: 0,
  29856: 0,
  29860: 0,
  29861: 0,
  29899: 0,
  29901: 0,
  29902: 0,
  29903: 0,
  29904: 0,
  29905: 0,
  29906: 0,
  29907: 0,
  29909: 0,
  29910: 0,
  29911: 0,
  29912: 0,
  29913: 0,
  29914: 0,
  29915: 0,
  29916: 0,
  29918: 0,
  29920: 0,
  29921: 0,
  29922: 0,
  29923: 0,
  29924: 0,
  29925: 0,
  29926: 0,
  29927: 0,
  29928: 0,
  29929: 0,
  29931: 0,
  29932: 0,
  29933: 0,
  29934: 0,
  29935: 0,
  29936: 0,
  29938: 0,
  29939: 0,
  29940: 0,
  29941: 0,
  29943: 0,
  29944: 0,
  29945: 0,
  30002: 0,
  30003: 0,
  30004: 0,
  30005: 0,
  30006: 0,
  30007: 0,
  30008: 0,
  30009: 0,
  30010: 0,
  30011: 0,
  30012: 0,
  30013: 0,
  30014: 0,
  30015: 0,
  30016: 0,
  30017: 0,
  30018: 0,
  30019: 0,
  30021: 0,
  30022: 0,
  30023: 0,
  30024: 0,
  30025: 0,
  30026: 0,
  30028: 0,
  30029: 0,
  30030: 0,
  30031: 0,
  30032: 0,
  30033: 0,
  30034: 0,
  30035: 0,
  30036: 0,
  30037: 0,
  30038: 0,
  30039: 0,
  30040: 0,
  30041: 0,
  30042: 0,
  30043: 0,
  30044: 0,
  30045: 0,
  30046: 0,
  30047: 0,
  30048: 0,
  30049: 0,
  30052: 0,
  30054: 0,
  30055: 0,
  30056: 0,
  30058: 0,
  30060: 0,
  30061: 0,
  30062: 0,
  30063: 0,
  30064: 0,
  30065: 0,
  30066: 0,
  30067: 0,
  30068: 0,
  30069: 0,
  30070: 0,
  30071: 0,
  30072: 0,
  30073: 0,
  30074: 0,
  30075: 0,
  30076: 0,
  30077: 0,
  30078: 0,
  30079: 0,
  30080: 0,
  30081: 0,
  30082: 0,
  30083: 0,
  30084: 0,
  30085: 0,
  30086: 0,
  30087: 0,
  30088: 0,
  30090: 0,
  30091: 0,
  30092: 0,
  30093: 0,
  30094: 0,
  30095: 0,
  30096: 0,
  30097: 0,
  30098: 0,
  30099: 0,
  30101: 0,
  30102: 0,
  30103: 0,
  30104: 0,
  30105: 0,
  30106: 0,
  30107: 0,
  30108: 0,
  30109: 0,
  30110: 0,
  30111: 0,
  30112: 0,
  30113: 0,
  30114: 0,
  30115: 0,
  30116: 0,
  30117: 0,
  30118: 0,
  30119: 0,
  30120: 0,
  30121: 0,
  30122: 0,
  30123: 0,
  30124: 0,
  30125: 0,
  30126: 0,
  30127: 0,
  30129: 0,
  30132: 0,
  30133: 0,
  30134: 0,
  30135: 0,
  30137: 0,
  30138: 0,
  30139: 0,
  30140: 0,
  30141: 0,
  30142: 0,
  30143: 0,
  30144: 0,
  30145: 0,
  30146: 0,
  30147: 0,
  30148: 0,
  30149: 0,
  30150: 0,
  30151: 0,
  30152: 0,
  30153: 0,
  30154: 0,
  30156: 0,
  30157: 0,
  30160: 0,
  30161: 0,
  30162: 0,
  30163: 0,
  30164: 0,
  30165: 0,
  30168: 0,
  30169: 0,
  30170: 0,
  30171: 0,
  30172: 0,
  30173: 0,
  30175: 0,
  30176: 0,
  30177: 0,
  30178: 0,
  30179: 0,
  30180: 0,
  30182: 0,
  30183: 0,
  30184: 0,
  30185: 0,
  30187: 0,
  30188: 0,
  30189: 0,
  30204: 0,
  30205: 0,
  30206: 0,
  30212: 0,
  30213: 0,
  30214: 0,
  30215: 0,
  30216: 0,
  30217: 0,
  30218: 0,
  30219: 0,
  30220: 0,
  30222: 0,
  30223: 0,
  30224: 0,
  30228: 0,
  30229: 0,
  30230: 0,
  30232: 0,
  30233: 0,
  30234: 0,
  30236: 0,
  30237: 0,
  30238: 0,
  30240: 0,
  30241: 0,
  30248: 0,
  30250: 0,
  30251: 0,
  30252: 0,
  30253: 0,
  30256: 0,
  30257: 0,
  30258: 0,
  30259: 0,
  30260: 0,
  30261: 0,
  30263: 0,
  30264: 0,
  30265: 0,
  30266: 0,
  30268: 0,
  30269: 0,
  30270: 0,
  30271: 0,
  30272: 0,
  30273: 0,
  30274: 0,
  30275: 0,
  30276: 0,
  30277: 0,
  30281: 0,
  30284: 0,
  30285: 0,
  30286: 0,
  30287: 0,
  30288: 0,
  30289: 0,
  30290: 0,
  30291: 0,
  30292: 0,
  30293: 0,
  30294: 0,
  30295: 0,
  30296: 0,
  30297: 0,
  30298: 0,
  30301: 0,
  30302: 0,
  30303: 0,
  30304: 0,
  30305: 0,
  30306: 0,
  30307: 0,
  30308: 0,
  30309: 0,
  30310: 0,
  30311: 0,
  30312: 0,
  30313: 0,
  30314: 0,
  30315: 0,
  30316: 0,
  30317: 0,
  30318: 0,
  30319: 0,
  30320: 0,
  30321: 0,
  30322: 0,
  30324: 0,
  30325: 0,
  30326: 0,
  30327: 0,
  30328: 0,
  30329: 0,
  30330: 0,
  30331: 0,
  30332: 0,
  30333: 0,
  30334: 0,
  30336: 0,
  30337: 0,
  30338: 0,
  30339: 0,
  30340: 0,
  30341: 0,
  30342: 0,
  30343: 0,
  30344: 0,
  30345: 0,
  30346: 0,
  30347: 0,
  30348: 0,
  30349: 0,
  30350: 0,
  30353: 0,
  30354: 0,
  30355: 0,
  30356: 0,
  30357: 0,
  30358: 0,
  30359: 0,
  30360: 0,
  30361: 0,
  30362: 0,
  30363: 0,
  30364: 0,
  30366: 0,
  30368: 0,
  30369: 0,
  30370: 0,
  30371: 0,
  30374: 0,
  30375: 0,
  30376: 0,
  30377: 0,
  30378: 0,
  30379: 0,
  30380: 0,
  30384: 0,
  30385: 0,
  30386: 0,
  30387: 0,
  30388: 0,
  30389: 0,
  30390: 0,
  30392: 0,
  30394: 0,
  30396: 0,
  30398: 0,
  30399: 0,
  30401: 0,
  30410: 0,
  30411: 0,
  30412: 0,
  30413: 0,
  30414: 0,
  30415: 0,
  30417: 0,
  30420: 0,
  30421: 0,
  30423: 0,
  30424: 0,
  30425: 0,
  30426: 0,
  30427: 0,
  30428: 0,
  30429: 0,
  30434: 0,
  30436: 0,
  30438: 0,
  30439: 0,
  30441: 0,
  30442: 0,
  30445: 0,
  30446: 0,
  30447: 0,
  30448: 0,
  30449: 0,
  30450: 0,
  30451: 0,
  30452: 0,
  30453: 0,
  30454: 0,
  30455: 0,
  30456: 0,
  30457: 0,
  30458: 0,
  30459: 0,
  30460: 0,
  30461: 0,
  30464: 0,
  30467: 0,
  30470: 0,
  30471: 0,
  30473: 0,
  30474: 0,
  30475: 0,
  30477: 0,
  30499: 0,
  30501: 0,
  30502: 0,
  30503: 0,
  30504: 0,
  30506: 0,
  30507: 0,
  30510: 0,
  30511: 0,
  30512: 0,
  30513: 0,
  30514: 0,
  30515: 0,
  30516: 0,
  30517: 0,
  30518: 0,
  30519: 0,
  30520: 0,
  30521: 0,
  30522: 0,
  30523: 0,
  30525: 0,
  30527: 0,
  30528: 0,
  30529: 0,
  30530: 0,
  30531: 0,
  30533: 0,
  30534: 0,
  30535: 0,
  30536: 0,
  30537: 0,
  30538: 0,
  30539: 0,
  30540: 0,
  30541: 0,
  30542: 0,
  30543: 0,
  30544: 0,
  30545: 0,
  30546: 0,
  30547: 0,
  30548: 0,
  30549: 0,
  30552: 0,
  30553: 0,
  30554: 0,
  30555: 0,
  30557: 0,
  30558: 0,
  30559: 0,
  30560: 0,
  30562: 0,
  30563: 0,
  30564: 0,
  30565: 0,
  30566: 0,
  30567: 0,
  30568: 0,
  30571: 0,
  30572: 0,
  30573: 0,
  30575: 0,
  30576: 0,
  30577: 0,
  30580: 0,
  30581: 0,
  30582: 0,
  30596: 0,
  30597: 0,
  30598: 0,
  30599: 0,
  30601: 0,
  30602: 0,
  30603: 0,
  30604: 0,
  30605: 0,
  30606: 0,
  30607: 0,
  30608: 0,
  30609: 0,
  30612: 0,
  30619: 0,
  30620: 0,
  30621: 0,
  30622: 0,
  30623: 0,
  30624: 0,
  30625: 0,
  30627: 0,
  30628: 0,
  30629: 0,
  30630: 0,
  30631: 0,
  30633: 0,
  30634: 0,
  30635: 0,
  30638: 0,
  30639: 0,
  30641: 0,
  30642: 0,
  30643: 0,
  30645: 0,
  30646: 0,
  30647: 0,
  30648: 0,
  30650: 0,
  30655: 0,
  30656: 0,
  30660: 0,
  30662: 0,
  30663: 0,
  30664: 0,
  30665: 0,
  30666: 0,
  30667: 0,
  30668: 0,
  30669: 0,
  30671: 0,
  30673: 0,
  30677: 0,
  30678: 0,
  30680: 0,
  30683: 0,
  30701: 0,
  30703: 0,
  30705: 0,
  30707: 0,
  30708: 0,
  30710: 0,
  30711: 0,
  30719: 0,
  30720: 0,
  30721: 0,
  30722: 0,
  30724: 0,
  30725: 0,
  30726: 0,
  30728: 0,
  30730: 0,
  30731: 0,
  30732: 0,
  30733: 0,
  30734: 0,
  30735: 0,
  30736: 0,
  30738: 0,
  30739: 0,
  30740: 0,
  30741: 0,
  30742: 0,
  30746: 0,
  30747: 0,
  30750: 0,
  30751: 0,
  30752: 0,
  30753: 0,
  30755: 0,
  30756: 0,
  30757: 0,
  30802: 0,
  30803: 0,
  30805: 0,
  30806: 0,
  30807: 0,
  30808: 0,
  30809: 0,
  30810: 0,
  30811: 0,
  30812: 0,
  30813: 0,
  30814: 0,
  30815: 0,
  30816: 0,
  30817: 0,
  30818: 0,
  30819: 0,
  30820: 0,
  30821: 0,
  30822: 0,
  30823: 0,
  30824: 0,
  30828: 0,
  30830: 0,
  30833: 0,
  30901: 0,
  30903: 0,
  30904: 0,
  30905: 0,
  30906: 0,
  30907: 0,
  30909: 0,
  30910: 0,
  30911: 0,
  30912: 0,
  30913: 0,
  30914: 0,
  30916: 0,
  30917: 0,
  30919: 0,
  30999: 0,
  31001: 0,
  31002: 0,
  31003: 0,
  31004: 0,
  31005: 0,
  31006: 0,
  31007: 0,
  31008: 0,
  31009: 0,
  31010: 0,
  31011: 0,
  31012: 0,
  31013: 0,
  31014: 0,
  31015: 0,
  31016: 0,
  31017: 0,
  31018: 0,
  31019: 0,
  31020: 0,
  31021: 0,
  31022: 0,
  31023: 0,
  31024: 0,
  31025: 0,
  31026: 0,
  31027: 0,
  31028: 0,
  31029: 0,
  31030: 0,
  31031: 0,
  31032: 0,
  31033: 0,
  31034: 0,
  31035: 0,
  31036: 0,
  31037: 0,
  31038: 0,
  31039: 0,
  31040: 0,
  31041: 0,
  31042: 0,
  31044: 0,
  31045: 0,
  31046: 0,
  31047: 0,
  31049: 0,
  31050: 0,
  31051: 0,
  31052: 0,
  31054: 0,
  31055: 0,
  31057: 0,
  31058: 0,
  31059: 0,
  31060: 0,
  31061: 0,
  31062: 0,
  31063: 0,
  31064: 0,
  31065: 0,
  31066: 0,
  31067: 0,
  31068: 0,
  31069: 0,
  31070: 0,
  31071: 0,
  31072: 0,
  31075: 0,
  31076: 0,
  31077: 0,
  31078: 0,
  31079: 0,
  31081: 0,
  31082: 0,
  31083: 0,
  31084: 0,
  31085: 0,
  31086: 0,
  31087: 0,
  31088: 0,
  31089: 0,
  31090: 0,
  31091: 0,
  31092: 0,
  31093: 0,
  31094: 0,
  31095: 0,
  31096: 0,
  31097: 0,
  31098: 0,
  31099: 0,
  31106: 0,
  31107: 0,
  31119: 0,
  31120: 0,
  31126: 0,
  31131: 0,
  31132: 0,
  31136: 0,
  31139: 0,
  31141: 0,
  31145: 0,
  31146: 0,
  31150: 0,
  31156: 0,
  31169: 0,
  31191: 0,
  31192: 0,
  31193: 0,
  31195: 0,
  31196: 0,
  31197: 0,
  31198: 0,
  31199: 0,
  31201: 0,
  31202: 0,
  31203: 0,
  31204: 0,
  31205: 0,
  31206: 0,
  31207: 0,
  31208: 0,
  31209: 0,
  31210: 0,
  31211: 0,
  31212: 0,
  31213: 0,
  31216: 0,
  31217: 0,
  31220: 0,
  31221: 0,
  31294: 0,
  31295: 0,
  31296: 0,
  31297: 0,
  31298: 0,
  31299: 0,
  31301: 0,
  31302: 0,
  31303: 0,
  31304: 0,
  31305: 0,
  31307: 0,
  31308: 0,
  31309: 0,
  31310: 0,
  31312: 0,
  31313: 0,
  31314: 0,
  31315: 0,
  31316: 0,
  31318: 0,
  31319: 0,
  31320: 0,
  31321: 0,
  31322: 0,
  31323: 0,
  31324: 0,
  31326: 0,
  31327: 0,
  31328: 0,
  31329: 0,
  31331: 0,
  31333: 0,
  31401: 0,
  31402: 0,
  31403: 0,
  31404: 0,
  31405: 0,
  31406: 0,
  31407: 0,
  31408: 0,
  31409: 0,
  31410: 0,
  31411: 0,
  31412: 0,
  31414: 0,
  31415: 0,
  31416: 0,
  31418: 0,
  31419: 0,
  31420: 0,
  31421: 0,
  31498: 0,
  31499: 0,
  31501: 0,
  31502: 0,
  31503: 0,
  31510: 0,
  31512: 0,
  31513: 0,
  31515: 0,
  31516: 0,
  31518: 0,
  31519: 0,
  31520: 0,
  31521: 0,
  31522: 0,
  31523: 0,
  31524: 0,
  31525: 0,
  31527: 0,
  31532: 0,
  31533: 0,
  31534: 0,
  31535: 0,
  31537: 0,
  31539: 0,
  31542: 0,
  31543: 0,
  31544: 0,
  31545: 0,
  31546: 0,
  31547: 0,
  31548: 0,
  31549: 0,
  31550: 0,
  31551: 0,
  31552: 0,
  31553: 0,
  31554: 0,
  31555: 0,
  31556: 0,
  31557: 0,
  31558: 0,
  31560: 0,
  31561: 0,
  31562: 0,
  31563: 0,
  31564: 0,
  31565: 0,
  31566: 0,
  31567: 0,
  31568: 0,
  31569: 0,
  31598: 0,
  31599: 0,
  31601: 0,
  31602: 0,
  31603: 0,
  31604: 0,
  31605: 0,
  31606: 0,
  31620: 0,
  31622: 0,
  31623: 0,
  31624: 0,
  31625: 0,
  31626: 0,
  31627: 0,
  31629: 0,
  31630: 0,
  31631: 0,
  31632: 0,
  31634: 0,
  31635: 0,
  31636: 0,
  31637: 0,
  31638: 0,
  31639: 0,
  31641: 0,
  31642: 0,
  31643: 0,
  31645: 0,
  31647: 0,
  31648: 0,
  31649: 0,
  31650: 0,
  31698: 0,
  31699: 0,
  31701: 0,
  31702: 0,
  31703: 0,
  31704: 0,
  31705: 0,
  31706: 0,
  31707: 0,
  31708: 0,
  31709: 0,
  31710: 0,
  31711: 0,
  31712: 0,
  31714: 0,
  31716: 0,
  31719: 0,
  31720: 0,
  31721: 0,
  31722: 0,
  31727: 0,
  31730: 0,
  31733: 0,
  31735: 0,
  31738: 0,
  31739: 0,
  31743: 0,
  31744: 0,
  31747: 0,
  31749: 0,
  31750: 0,
  31753: 0,
  31756: 0,
  31757: 0,
  31758: 0,
  31760: 0,
  31763: 0,
  31764: 0,
  31765: 0,
  31768: 0,
  31769: 0,
  31771: 0,
  31772: 0,
  31773: 0,
  31774: 0,
  31775: 0,
  31776: 0,
  31778: 0,
  31779: 0,
  31780: 0,
  31781: 0,
  31782: 0,
  31783: 0,
  31784: 0,
  31787: 0,
  31788: 0,
  31789: 0,
  31790: 0,
  31791: 0,
  31792: 0,
  31793: 0,
  31794: 0,
  31795: 0,
  31796: 0,
  31798: 0,
  31799: 0,
  31801: 0,
  31803: 0,
  31804: 0,
  31805: 0,
  31806: 0,
  31807: 0,
  31808: 0,
  31810: 0,
  31811: 0,
  31812: 0,
  31814: 0,
  31815: 0,
  31816: 0,
  31820: 0,
  31821: 0,
  31822: 0,
  31823: 0,
  31824: 0,
  31825: 0,
  31826: 0,
  31827: 0,
  31829: 0,
  31830: 0,
  31831: 0,
  31832: 0,
  31833: 0,
  31836: 0,
  31900: 0,
  31901: 0,
  31902: 0,
  31903: 0,
  31904: 0,
  31905: 0,
  31906: 0,
  31907: 0,
  31908: 0,
  31909: 0,
  31914: 0,
  31917: 0,
  31993: 0,
  31994: 0,
  31995: 0,
  31997: 0,
  31998: 0,
  31999: 0,
  32003: 0,
  32004: 0,
  32006: 0,
  32007: 0,
  32008: 0,
  32009: 0,
  32011: 0,
  32013: 0,
  32024: 0,
  32025: 0,
  32026: 0,
  32030: 0,
  32033: 0,
  32034: 0,
  32035: 0,
  32038: 0,
  32040: 0,
  32041: 0,
  32042: 0,
  32043: 0,
  32044: 0,
  32046: 0,
  32050: 0,
  32052: 0,
  32053: 0,
  32054: 0,
  32055: 0,
  32056: 0,
  32058: 0,
  32059: 0,
  32060: 0,
  32061: 0,
  32062: 0,
  32063: 0,
  32064: 0,
  32065: 0,
  32066: 0,
  32067: 0,
  32068: 0,
  32071: 0,
  32072: 0,
  32073: 0,
  32079: 0,
  32080: 0,
  32081: 0,
  32082: 0,
  32083: 0,
  32084: 0,
  32085: 0,
  32086: 0,
  32087: 0,
  32091: 0,
  32092: 0,
  32094: 0,
  32095: 0,
  32096: 0,
  32097: 0,
  32099: 0,
  32102: 0,
  32105: 0,
  32110: 0,
  32111: 0,
  32112: 0,
  32113: 0,
  32114: 0,
  32115: 0,
  32116: 0,
  32117: 0,
  32118: 0,
  32119: 0,
  32120: 0,
  32121: 0,
  32122: 0,
  32123: 0,
  32124: 0,
  32125: 0,
  32126: 0,
  32127: 0,
  32128: 0,
  32129: 0,
  32130: 0,
  32131: 0,
  32132: 0,
  32133: 0,
  32134: 0,
  32135: 0,
  32136: 0,
  32137: 0,
  32138: 0,
  32139: 0,
  32140: 0,
  32141: 0,
  32142: 0,
  32143: 0,
  32145: 0,
  32147: 0,
  32148: 0,
  32149: 0,
  32151: 0,
  32157: 0,
  32158: 0,
  32159: 0,
  32160: 0,
  32162: 0,
  32163: 0,
  32164: 0,
  32168: 0,
  32169: 0,
  32170: 0,
  32173: 0,
  32174: 0,
  32175: 0,
  32176: 0,
  32177: 0,
  32178: 0,
  32179: 0,
  32180: 0,
  32181: 0,
  32182: 0,
  32183: 0,
  32185: 0,
  32187: 0,
  32189: 0,
  32190: 0,
  32192: 0,
  32193: 0,
  32195: 0,
  32198: 0,
  32201: 0,
  32202: 0,
  32203: 0,
  32204: 0,
  32205: 0,
  32206: 0,
  32207: 0,
  32208: 0,
  32209: 0,
  32210: 0,
  32211: 0,
  32212: 0,
  32214: 0,
  32215: 0,
  32216: 0,
  32217: 0,
  32218: 0,
  32219: 0,
  32220: 0,
  32221: 0,
  32222: 0,
  32223: 0,
  32224: 0,
  32225: 0,
  32226: 0,
  32227: 0,
  32228: 0,
  32229: 0,
  32230: 0,
  32231: 0,
  32232: 0,
  32233: 0,
  32234: 0,
  32235: 0,
  32236: 0,
  32237: 0,
  32238: 0,
  32239: 0,
  32240: 0,
  32241: 0,
  32244: 0,
  32245: 0,
  32246: 0,
  32247: 0,
  32250: 0,
  32254: 0,
  32255: 0,
  32256: 0,
  32257: 0,
  32258: 0,
  32260: 0,
  32266: 0,
  32267: 0,
  32276: 0,
  32290: 0,
  32301: 0,
  32302: 0,
  32303: 0,
  32304: 0,
  32305: 0,
  32306: 0,
  32307: 0,
  32308: 0,
  32309: 0,
  32310: 0,
  32311: 0,
  32312: 0,
  32313: 0,
  32314: 0,
  32315: 0,
  32316: 0,
  32317: 0,
  32318: 0,
  32320: 0,
  32321: 0,
  32322: 0,
  32323: 0,
  32324: 0,
  32326: 0,
  32327: 0,
  32328: 0,
  32329: 0,
  32330: 0,
  32331: 0,
  32332: 0,
  32333: 0,
  32334: 0,
  32335: 0,
  32336: 0,
  32337: 0,
  32340: 0,
  32341: 0,
  32343: 0,
  32344: 0,
  32345: 0,
  32346: 0,
  32347: 0,
  32348: 0,
  32350: 0,
  32351: 0,
  32352: 0,
  32353: 0,
  32355: 0,
  32356: 0,
  32357: 0,
  32358: 0,
  32359: 0,
  32360: 0,
  32361: 0,
  32362: 0,
  32395: 0,
  32399: 0,
  32401: 1,
  32402: 1,
  32403: 1,
  32404: 1,
  32405: 1,
  32406: 1,
  32407: 1,
  32408: 1,
  32409: 1,
  32410: 1,
  32411: 1,
  32412: 1,
  32413: 1,
  32417: 1,
  32420: 1,
  32421: 1,
  32422: 1,
  32423: 1,
  32424: 1,
  32425: 1,
  32426: 1,
  32427: 1,
  32428: 1,
  32430: 1,
  32431: 1,
  32432: 1,
  32433: 1,
  32434: 1,
  32435: 1,
  32437: 1,
  32438: 1,
  32439: 1,
  32440: 1,
  32442: 1,
  32443: 1,
  32444: 1,
  32445: 1,
  32446: 1,
  32447: 1,
  32448: 1,
  32449: 1,
  32454: 1,
  32455: 1,
  32456: 0,
  32457: 0,
  32459: 1,
  32460: 1,
  32461: 1,
  32462: 1,
  32464: 1,
  32465: 1,
  32466: 1,
  32501: 1,
  32502: 1,
  32503: 1,
  32504: 1,
  32505: 1,
  32506: 1,
  32507: 1,
  32508: 1,
  32509: 1,
  32511: 1,
  32512: 1,
  32513: 1,
  32514: 1,
  32516: 1,
  32520: 1,
  32521: 1,
  32522: 1,
  32523: 1,
  32524: 1,
  32526: 1,
  32530: 1,
  32531: 1,
  32533: 1,
  32534: 1,
  32535: 1,
  32536: 1,
  32537: 1,
  32538: 1,
  32539: 1,
  32540: 1,
  32541: 1,
  32542: 1,
  32544: 1,
  32547: 1,
  32548: 1,
  32549: 1,
  32550: 1,
  32559: 1,
  32560: 1,
  32561: 1,
  32562: 1,
  32563: 1,
  32564: 1,
  32565: 1,
  32566: 1,
  32567: 1,
  32568: 1,
  32569: 1,
  32570: 1,
  32571: 1,
  32572: 1,
  32573: 1,
  32574: 1,
  32575: 1,
  32576: 1,
  32577: 1,
  32578: 1,
  32579: 1,
  32580: 1,
  32581: 1,
  32582: 1,
  32583: 1,
  32588: 1,
  32589: 1,
  32590: 1,
  32591: 1,
  32592: 1,
  32593: 1,
  32594: 1,
  32595: 1,
  32596: 1,
  32597: 1,
  32598: 1,
  32601: 0,
  32602: 0,
  32603: 0,
  32604: 0,
  32605: 0,
  32606: 0,
  32607: 0,
  32608: 0,
  32609: 0,
  32610: 0,
  32611: 0,
  32612: 0,
  32613: 0,
  32614: 0,
  32615: 0,
  32616: 0,
  32617: 0,
  32618: 0,
  32619: 0,
  32621: 0,
  32622: 0,
  32625: 0,
  32626: 0,
  32627: 0,
  32628: 0,
  32631: 0,
  32633: 0,
  32634: 0,
  32635: 0,
  32639: 0,
  32640: 0,
  32641: 0,
  32643: 0,
  32644: 0,
  32648: 0,
  32653: 0,
  32654: 0,
  32655: 0,
  32656: 0,
  32658: 0,
  32662: 0,
  32663: 0,
  32664: 0,
  32666: 0,
  32667: 0,
  32668: 0,
  32669: 0,
  32680: 0,
  32681: 0,
  32683: 0,
  32686: 0,
  32692: 0,
  32693: 0,
  32694: 0,
  32696: 0,
  32697: 0,
  32701: 0,
  32702: 0,
  32703: 0,
  32704: 0,
  32706: 0,
  32707: 0,
  32708: 0,
  32709: 0,
  32710: 0,
  32712: 0,
  32713: 0,
  32714: 0,
  32715: 0,
  32716: 0,
  32718: 0,
  32719: 0,
  32720: 0,
  32721: 0,
  32722: 0,
  32723: 0,
  32724: 0,
  32725: 0,
  32726: 0,
  32727: 0,
  32728: 0,
  32730: 0,
  32732: 0,
  32733: 0,
  32735: 0,
  32736: 0,
  32738: 0,
  32739: 0,
  32744: 0,
  32745: 0,
  32746: 0,
  32747: 0,
  32750: 0,
  32751: 0,
  32752: 0,
  32753: 0,
  32754: 0,
  32756: 0,
  32757: 0,
  32759: 0,
  32762: 0,
  32763: 0,
  32764: 0,
  32765: 0,
  32766: 0,
  32767: 0,
  32768: 0,
  32771: 0,
  32772: 0,
  32773: 0,
  32774: 0,
  32775: 0,
  32776: 0,
  32777: 0,
  32778: 0,
  32779: 0,
  32780: 0,
  32781: 0,
  32782: 0,
  32783: 0,
  32784: 0,
  32789: 0,
  32790: 0,
  32791: 0,
  32792: 0,
  32793: 0,
  32794: 0,
  32795: 0,
  32796: 0,
  32798: 0,
  32799: 0,
  32801: 0,
  32802: 0,
  32803: 0,
  32804: 0,
  32805: 0,
  32806: 0,
  32807: 0,
  32808: 0,
  32809: 0,
  32810: 0,
  32811: 0,
  32812: 0,
  32814: 0,
  32815: 0,
  32816: 0,
  32817: 0,
  32818: 0,
  32819: 0,
  32820: 0,
  32821: 0,
  32822: 0,
  32824: 0,
  32825: 0,
  32826: 0,
  32827: 0,
  32828: 0,
  32829: 0,
  32830: 0,
  32831: 0,
  32832: 0,
  32833: 0,
  32834: 0,
  32835: 0,
  32836: 0,
  32837: 0,
  32839: 0,
  32853: 0,
  32854: 0,
  32855: 0,
  32856: 0,
  32857: 0,
  32858: 0,
  32859: 0,
  32860: 0,
  32861: 0,
  32862: 0,
  32867: 0,
  32868: 0,
  32869: 0,
  32872: 0,
  32877: 0,
  32878: 0,
  32885: 0,
  32886: 0,
  32887: 0,
  32890: 0,
  32891: 0,
  32893: 0,
  32896: 0,
  32897: 0,
  32898: 0,
  32899: 0,
  32901: 0,
  32902: 0,
  32903: 0,
  32904: 0,
  32905: 0,
  32906: 0,
  32907: 0,
  32908: 0,
  32909: 0,
  32910: 0,
  32911: 0,
  32912: 0,
  32919: 0,
  32920: 0,
  32922: 0,
  32923: 0,
  32924: 0,
  32925: 0,
  32926: 0,
  32927: 0,
  32931: 0,
  32932: 0,
  32934: 0,
  32935: 0,
  32936: 0,
  32937: 0,
  32940: 0,
  32941: 0,
  32948: 0,
  32949: 0,
  32950: 0,
  32951: 0,
  32952: 0,
  32953: 0,
  32954: 0,
  32955: 0,
  32956: 0,
  32957: 0,
  32958: 0,
  32959: 0,
  32960: 0,
  32961: 0,
  32962: 0,
  32963: 0,
  32964: 0,
  32965: 0,
  32966: 0,
  32967: 0,
  32968: 0,
  32969: 0,
  32970: 0,
  32971: 0,
  32976: 0,
  32978: 0,
  33001: 0,
  33002: 0,
  33004: 0,
  33008: 0,
  33009: 0,
  33010: 0,
  33011: 0,
  33012: 0,
  33013: 0,
  33014: 0,
  33015: 0,
  33016: 0,
  33017: 0,
  33018: 0,
  33019: 0,
  33020: 0,
  33021: 0,
  33022: 0,
  33023: 0,
  33024: 0,
  33025: 0,
  33026: 0,
  33027: 0,
  33028: 0,
  33029: 0,
  33030: 0,
  33031: 0,
  33032: 0,
  33033: 0,
  33034: 0,
  33035: 0,
  33036: 0,
  33037: 0,
  33039: 0,
  33040: 0,
  33041: 0,
  33042: 0,
  33043: 0,
  33044: 0,
  33045: 0,
  33050: 0,
  33051: 0,
  33052: 0,
  33054: 0,
  33055: 0,
  33056: 0,
  33060: 0,
  33061: 0,
  33062: 0,
  33063: 0,
  33064: 0,
  33065: 0,
  33066: 0,
  33067: 0,
  33068: 0,
  33069: 0,
  33070: 0,
  33071: 0,
  33072: 0,
  33073: 0,
  33074: 0,
  33075: 0,
  33076: 0,
  33077: 0,
  33081: 0,
  33082: 0,
  33083: 0,
  33084: 0,
  33090: 0,
  33092: 0,
  33093: 0,
  33097: 0,
  33101: 0,
  33102: 0,
  33107: 0,
  33109: 0,
  33110: 0,
  33111: 0,
  33112: 0,
  33114: 0,
  33116: 0,
  33119: 0,
  33121: 0,
  33122: 0,
  33124: 0,
  33125: 0,
  33126: 0,
  33127: 0,
  33128: 0,
  33129: 0,
  33130: 0,
  33131: 0,
  33132: 0,
  33133: 0,
  33134: 0,
  33135: 0,
  33136: 0,
  33137: 0,
  33138: 0,
  33139: 0,
  33140: 0,
  33141: 0,
  33142: 0,
  33143: 0,
  33144: 0,
  33145: 0,
  33146: 0,
  33147: 0,
  33148: 0,
  33149: 0,
  33150: 0,
  33151: 0,
  33152: 0,
  33153: 0,
  33154: 0,
  33155: 0,
  33156: 0,
  33157: 0,
  33158: 0,
  33159: 0,
  33160: 0,
  33161: 0,
  33162: 0,
  33163: 0,
  33164: 0,
  33165: 0,
  33166: 0,
  33167: 0,
  33168: 0,
  33169: 0,
  33170: 0,
  33172: 0,
  33173: 0,
  33174: 0,
  33175: 0,
  33176: 0,
  33177: 0,
  33178: 0,
  33179: 0,
  33180: 0,
  33181: 0,
  33182: 0,
  33183: 0,
  33184: 0,
  33185: 0,
  33186: 0,
  33187: 0,
  33188: 0,
  33189: 0,
  33190: 0,
  33192: 0,
  33193: 0,
  33194: 0,
  33195: 0,
  33196: 0,
  33197: 0,
  33199: 0,
  33222: 0,
  33231: 0,
  33233: 0,
  33234: 0,
  33238: 0,
  33239: 0,
  33242: 0,
  33243: 0,
  33245: 0,
  33247: 0,
  33255: 0,
  33256: 0,
  33257: 0,
  33261: 0,
  33265: 0,
  33266: 0,
  33269: 0,
  33280: 0,
  33283: 0,
  33296: 0,
  33299: 0,
  33301: 0,
  33302: 0,
  33303: 0,
  33304: 0,
  33305: 0,
  33306: 0,
  33307: 0,
  33308: 0,
  33309: 0,
  33310: 0,
  33311: 0,
  33312: 0,
  33313: 0,
  33314: 0,
  33315: 0,
  33316: 0,
  33317: 0,
  33318: 0,
  33319: 0,
  33320: 0,
  33321: 0,
  33322: 0,
  33323: 0,
  33324: 0,
  33325: 0,
  33326: 0,
  33327: 0,
  33328: 0,
  33329: 0,
  33330: 0,
  33331: 0,
  33332: 0,
  33334: 0,
  33335: 0,
  33336: 0,
  33337: 0,
  33338: 0,
  33339: 0,
  33340: 0,
  33345: 0,
  33346: 0,
  33348: 0,
  33349: 0,
  33351: 0,
  33355: 0,
  33359: 0,
  33388: 0,
  33394: 0,
  33401: 0,
  33402: 0,
  33403: 0,
  33404: 0,
  33405: 0,
  33406: 0,
  33407: 0,
  33408: 0,
  33409: 0,
  33410: 0,
  33411: 0,
  33412: 0,
  33413: 0,
  33414: 0,
  33415: 0,
  33416: 0,
  33417: 0,
  33418: 0,
  33419: 0,
  33420: 0,
  33421: 0,
  33422: 0,
  33424: 0,
  33425: 0,
  33426: 0,
  33427: 0,
  33428: 0,
  33429: 0,
  33430: 0,
  33431: 0,
  33432: 0,
  33433: 0,
  33434: 0,
  33435: 0,
  33436: 0,
  33437: 0,
  33438: 0,
  33439: 0,
  33440: 0,
  33441: 0,
  33442: 0,
  33443: 0,
  33444: 0,
  33445: 0,
  33446: 0,
  33447: 0,
  33448: 0,
  33449: 0,
  33454: 0,
  33455: 0,
  33458: 0,
  33459: 0,
  33460: 0,
  33461: 0,
  33462: 0,
  33463: 0,
  33464: 0,
  33465: 0,
  33466: 0,
  33467: 0,
  33468: 0,
  33469: 0,
  33470: 0,
  33471: 0,
  33472: 0,
  33473: 0,
  33474: 0,
  33475: 0,
  33476: 0,
  33477: 0,
  33478: 0,
  33480: 0,
  33481: 0,
  33482: 0,
  33483: 0,
  33484: 0,
  33486: 0,
  33487: 0,
  33488: 0,
  33493: 0,
  33496: 0,
  33497: 0,
  33498: 0,
  33499: 0,
  33503: 0,
  33508: 0,
  33509: 0,
  33510: 0,
  33511: 0,
  33513: 0,
  33514: 0,
  33521: 0,
  33523: 0,
  33524: 0,
  33525: 0,
  33526: 0,
  33527: 0,
  33530: 0,
  33534: 0,
  33537: 0,
  33538: 0,
  33539: 0,
  33540: 0,
  33541: 0,
  33542: 0,
  33543: 0,
  33544: 0,
  33545: 0,
  33547: 0,
  33548: 0,
  33549: 0,
  33550: 0,
  33556: 0,
  33558: 0,
  33559: 0,
  33563: 0,
  33564: 0,
  33565: 0,
  33566: 0,
  33567: 0,
  33568: 0,
  33569: 0,
  33570: 0,
  33571: 0,
  33572: 0,
  33573: 0,
  33574: 0,
  33575: 0,
  33576: 0,
  33578: 0,
  33579: 0,
  33583: 0,
  33584: 0,
  33585: 0,
  33586: 0,
  33587: 0,
  33592: 0,
  33593: 0,
  33594: 0,
  33595: 0,
  33596: 0,
  33597: 0,
  33598: 0,
  33601: 0,
  33602: 0,
  33603: 0,
  33604: 0,
  33605: 0,
  33606: 0,
  33607: 0,
  33608: 0,
  33609: 0,
  33610: 0,
  33611: 0,
  33612: 0,
  33613: 0,
  33614: 0,
  33615: 0,
  33616: 0,
  33617: 0,
  33618: 0,
  33619: 0,
  33620: 0,
  33621: 0,
  33622: 0,
  33623: 0,
  33624: 0,
  33625: 0,
  33626: 0,
  33629: 0,
  33630: 0,
  33631: 0,
  33633: 0,
  33634: 0,
  33635: 0,
  33637: 0,
  33646: 0,
  33647: 0,
  33650: 0,
  33651: 0,
  33655: 0,
  33660: 0,
  33661: 0,
  33662: 0,
  33663: 0,
  33672: 0,
  33673: 0,
  33674: 0,
  33675: 0,
  33677: 0,
  33679: 0,
  33680: 0,
  33681: 0,
  33682: 0,
  33684: 0,
  33685: 0,
  33686: 0,
  33687: 0,
  33688: 0,
  33689: 0,
  33690: 0,
  33694: 0,
  33697: 0,
  33701: 0,
  33702: 0,
  33703: 0,
  33704: 0,
  33705: 0,
  33706: 0,
  33707: 0,
  33708: 0,
  33709: 0,
  33710: 0,
  33711: 0,
  33712: 0,
  33713: 0,
  33714: 0,
  33715: 0,
  33716: 0,
  33728: 0,
  33729: 0,
  33730: 0,
  33731: 0,
  33732: 0,
  33733: 0,
  33734: 0,
  33736: 0,
  33737: 0,
  33738: 0,
  33740: 0,
  33741: 0,
  33742: 0,
  33743: 0,
  33744: 0,
  33747: 0,
  33755: 0,
  33756: 0,
  33757: 0,
  33758: 0,
  33759: 0,
  33760: 0,
  33761: 0,
  33762: 0,
  33763: 0,
  33764: 0,
  33765: 0,
  33766: 0,
  33767: 0,
  33769: 0,
  33770: 0,
  33771: 0,
  33772: 0,
  33773: 0,
  33774: 0,
  33775: 0,
  33776: 0,
  33777: 0,
  33778: 0,
  33779: 0,
  33780: 0,
  33781: 0,
  33782: 0,
  33784: 0,
  33785: 0,
  33786: 0,
  33801: 0,
  33802: 0,
  33803: 0,
  33804: 0,
  33805: 0,
  33806: 0,
  33807: 0,
  33809: 0,
  33810: 0,
  33811: 0,
  33812: 0,
  33813: 0,
  33815: 0,
  33820: 0,
  33823: 0,
  33825: 0,
  33826: 0,
  33827: 0,
  33830: 0,
  33831: 0,
  33834: 0,
  33835: 0,
  33836: 0,
  33837: 0,
  33838: 0,
  33839: 0,
  33840: 0,
  33841: 0,
  33843: 0,
  33844: 0,
  33845: 0,
  33846: 0,
  33847: 0,
  33848: 0,
  33849: 0,
  33850: 0,
  33851: 0,
  33852: 0,
  33853: 0,
  33854: 0,
  33855: 0,
  33856: 0,
  33857: 0,
  33858: 0,
  33859: 0,
  33860: 0,
  33862: 0,
  33863: 0,
  33865: 0,
  33867: 0,
  33868: 0,
  33870: 0,
  33871: 0,
  33872: 0,
  33873: 0,
  33875: 0,
  33876: 0,
  33877: 0,
  33880: 0,
  33881: 0,
  33882: 0,
  33883: 0,
  33884: 0,
  33885: 0,
  33888: 0,
  33890: 0,
  33896: 0,
  33897: 0,
  33898: 0,
  33900: 0,
  33901: 0,
  33902: 0,
  33903: 0,
  33904: 0,
  33905: 0,
  33906: 0,
  33907: 0,
  33908: 0,
  33909: 0,
  33910: 0,
  33911: 0,
  33912: 0,
  33913: 0,
  33914: 0,
  33915: 0,
  33916: 0,
  33917: 0,
  33918: 0,
  33919: 0,
  33920: 0,
  33921: 0,
  33922: 0,
  33924: 0,
  33927: 0,
  33928: 0,
  33929: 0,
  33930: 0,
  33931: 0,
  33932: 0,
  33935: 0,
  33936: 0,
  33938: 0,
  33944: 0,
  33945: 0,
  33946: 0,
  33947: 0,
  33948: 0,
  33949: 0,
  33950: 0,
  33951: 0,
  33952: 0,
  33953: 0,
  33954: 0,
  33955: 0,
  33956: 0,
  33957: 0,
  33960: 0,
  33965: 0,
  33966: 0,
  33967: 0,
  33970: 0,
  33971: 0,
  33972: 0,
  33973: 0,
  33974: 0,
  33975: 0,
  33976: 0,
  33980: 0,
  33981: 0,
  33982: 0,
  33983: 0,
  33990: 0,
  33991: 0,
  33993: 0,
  33994: 0,
  34101: 0,
  34102: 0,
  34103: 0,
  34104: 0,
  34105: 0,
  34106: 0,
  34107: 0,
  34108: 0,
  34109: 0,
  34110: 0,
  34112: 0,
  34113: 0,
  34114: 0,
  34116: 0,
  34117: 0,
  34119: 0,
  34120: 0,
  34130: 0,
  34133: 0,
  34134: 0,
  34135: 0,
  34136: 0,
  34137: 0,
  34138: 0,
  34139: 0,
  34140: 0,
  34141: 0,
  34142: 0,
  34143: 0,
  34145: 0,
  34146: 0,
  34201: 0,
  34202: 0,
  34203: 0,
  34204: 0,
  34205: 0,
  34206: 0,
  34207: 0,
  34208: 0,
  34209: 0,
  34210: 0,
  34211: 0,
  34212: 0,
  34215: 0,
  34216: 0,
  34217: 0,
  34218: 0,
  34219: 0,
  34220: 0,
  34221: 0,
  34222: 0,
  34223: 0,
  34224: 0,
  34228: 0,
  34229: 0,
  34230: 0,
  34231: 0,
  34232: 0,
  34233: 0,
  34234: 0,
  34235: 0,
  34236: 0,
  34237: 0,
  34238: 0,
  34239: 0,
  34240: 0,
  34241: 0,
  34242: 0,
  34243: 0,
  34250: 0,
  34251: 0,
  34260: 0,
  34264: 0,
  34265: 0,
  34266: 0,
  34267: 0,
  34268: 0,
  34269: 0,
  34270: 0,
  34272: 0,
  34274: 0,
  34275: 0,
  34276: 0,
  34277: 0,
  34278: 0,
  34280: 0,
  34281: 0,
  34282: 0,
  34284: 0,
  34285: 0,
  34286: 0,
  34287: 0,
  34288: 0,
  34289: 0,
  34290: 0,
  34291: 0,
  34292: 0,
  34293: 0,
  34295: 0,
  34420: 0,
  34421: 0,
  34423: 0,
  34428: 0,
  34429: 0,
  34430: 0,
  34431: 0,
  34432: 0,
  34433: 0,
  34434: 0,
  34436: 0,
  34442: 0,
  34445: 0,
  34446: 0,
  34447: 0,
  34448: 0,
  34449: 0,
  34450: 0,
  34451: 0,
  34452: 0,
  34453: 0,
  34460: 0,
  34461: 0,
  34464: 0,
  34465: 0,
  34470: 0,
  34471: 0,
  34472: 0,
  34473: 0,
  34474: 0,
  34475: 0,
  34476: 0,
  34477: 0,
  34478: 0,
  34479: 0,
  34480: 0,
  34481: 0,
  34482: 0,
  34483: 0,
  34484: 0,
  34487: 0,
  34488: 0,
  34489: 0,
  34491: 0,
  34492: 0,
  34498: 0,
  34601: 0,
  34602: 0,
  34603: 0,
  34604: 0,
  34605: 0,
  34606: 0,
  34607: 0,
  34608: 0,
  34609: 0,
  34610: 0,
  34611: 0,
  34613: 0,
  34614: 0,
  34635: 0,
  34636: 0,
  34637: 0,
  34638: 0,
  34639: 0,
  34652: 0,
  34653: 0,
  34654: 0,
  34655: 0,
  34656: 0,
  34660: 0,
  34661: 0,
  34667: 0,
  34668: 0,
  34669: 0,
  34673: 0,
  34674: 0,
  34677: 0,
  34679: 0,
  34680: 0,
  34681: 0,
  34682: 0,
  34683: 0,
  34684: 0,
  34685: 0,
  34688: 0,
  34689: 0,
  34690: 0,
  34691: 0,
  34692: 0,
  34695: 0,
  34697: 0,
  34698: 0,
  34705: 0,
  34711: 0,
  34712: 0,
  34713: 0,
  34714: 0,
  34715: 0,
  34729: 0,
  34731: 0,
  34734: 0,
  34736: 0,
  34737: 0,
  34739: 0,
  34740: 0,
  34741: 0,
  34742: 0,
  34743: 0,
  34744: 0,
  34745: 0,
  34746: 0,
  34747: 0,
  34748: 0,
  34749: 0,
  34753: 0,
  34755: 0,
  34756: 0,
  34758: 0,
  34759: 0,
  34760: 0,
  34761: 0,
  34762: 0,
  34769: 0,
  34770: 0,
  34771: 0,
  34772: 0,
  34773: 0,
  34777: 0,
  34778: 0,
  34785: 0,
  34787: 0,
  34788: 0,
  34789: 0,
  34797: 0,
  34945: 0,
  34946: 0,
  34947: 0,
  34948: 0,
  34949: 0,
  34950: 0,
  34951: 0,
  34952: 0,
  34953: 0,
  34954: 0,
  34956: 0,
  34957: 0,
  34958: 0,
  34972: 0,
  34973: 0,
  34974: 0,
  34979: 0,
  34981: 0,
  34982: 0,
  34983: 0,
  34984: 0,
  34985: 0,
  34986: 0,
  34987: 0,
  34988: 0,
  34990: 0,
  34991: 0,
  34992: 0,
  34994: 0,
  34995: 0,
  34996: 0,
  34997: 0,
  35004: 1,
  35005: 1,
  35006: 1,
  35007: 1,
  35010: 1,
  35011: 1,
  35013: 1,
  35014: 1,
  35015: 1,
  35016: 1,
  35019: 1,
  35020: 1,
  35021: 1,
  35022: 1,
  35023: 1,
  35031: 1,
  35032: 1,
  35033: 1,
  35034: 1,
  35035: 1,
  35036: 1,
  35038: 1,
  35040: 1,
  35041: 1,
  35042: 1,
  35043: 1,
  35044: 1,
  35045: 1,
  35046: 1,
  35048: 1,
  35049: 1,
  35051: 1,
  35052: 1,
  35053: 1,
  35054: 1,
  35055: 1,
  35056: 1,
  35057: 1,
  35058: 1,
  35060: 1,
  35061: 1,
  35062: 1,
  35063: 1,
  35064: 1,
  35068: 1,
  35070: 1,
  35071: 1,
  35072: 1,
  35073: 1,
  35074: 1,
  35077: 1,
  35078: 1,
  35079: 1,
  35080: 1,
  35082: 1,
  35083: 1,
  35085: 1,
  35087: 1,
  35089: 1,
  35091: 1,
  35094: 1,
  35096: 1,
  35097: 1,
  35098: 1,
  35111: 1,
  35112: 1,
  35114: 1,
  35115: 1,
  35116: 1,
  35117: 1,
  35118: 1,
  35119: 1,
  35120: 1,
  35121: 1,
  35123: 1,
  35124: 1,
  35125: 1,
  35126: 1,
  35127: 1,
  35128: 1,
  35130: 1,
  35131: 1,
  35133: 1,
  35135: 1,
  35136: 1,
  35137: 1,
  35139: 1,
  35142: 1,
  35143: 1,
  35144: 1,
  35146: 1,
  35147: 1,
  35148: 1,
  35149: 1,
  35150: 1,
  35151: 1,
  35160: 1,
  35161: 1,
  35171: 1,
  35172: 1,
  35173: 1,
  35175: 1,
  35176: 1,
  35178: 1,
  35179: 1,
  35180: 1,
  35181: 1,
  35182: 1,
  35183: 1,
  35184: 1,
  35185: 1,
  35186: 1,
  35187: 1,
  35188: 1,
  35201: 1,
  35202: 1,
  35203: 1,
  35204: 1,
  35205: 1,
  35206: 1,
  35207: 1,
  35208: 1,
  35209: 1,
  35210: 1,
  35211: 1,
  35212: 1,
  35213: 1,
  35214: 1,
  35215: 1,
  35216: 1,
  35217: 1,
  35218: 1,
  35219: 1,
  35220: 1,
  35221: 1,
  35222: 1,
  35223: 1,
  35224: 1,
  35225: 1,
  35226: 1,
  35228: 1,
  35229: 1,
  35230: 1,
  35231: 1,
  35232: 1,
  35233: 1,
  35234: 1,
  35235: 1,
  35236: 1,
  35237: 1,
  35238: 1,
  35240: 1,
  35242: 1,
  35243: 1,
  35244: 1,
  35245: 1,
  35246: 1,
  35249: 1,
  35253: 1,
  35254: 1,
  35255: 1,
  35259: 1,
  35260: 1,
  35261: 1,
  35263: 1,
  35266: 1,
  35277: 1,
  35278: 1,
  35279: 1,
  35280: 1,
  35281: 1,
  35282: 1,
  35283: 1,
  35285: 1,
  35286: 1,
  35287: 1,
  35288: 1,
  35289: 1,
  35290: 1,
  35291: 1,
  35292: 1,
  35293: 1,
  35294: 1,
  35295: 1,
  35296: 1,
  35297: 1,
  35298: 1,
  35299: 1,
  35401: 1,
  35402: 1,
  35403: 1,
  35404: 1,
  35405: 1,
  35406: 1,
  35407: 1,
  35440: 1,
  35441: 1,
  35442: 1,
  35443: 1,
  35444: 1,
  35446: 1,
  35447: 1,
  35448: 1,
  35449: 1,
  35452: 1,
  35453: 1,
  35456: 1,
  35457: 1,
  35458: 1,
  35459: 1,
  35460: 1,
  35461: 1,
  35462: 1,
  35463: 1,
  35464: 1,
  35466: 1,
  35468: 1,
  35469: 1,
  35470: 1,
  35471: 1,
  35473: 1,
  35474: 1,
  35475: 1,
  35476: 1,
  35477: 1,
  35478: 1,
  35480: 1,
  35481: 1,
  35482: 1,
  35485: 1,
  35486: 1,
  35487: 1,
  35490: 1,
  35491: 1,
  35501: 1,
  35502: 1,
  35503: 1,
  35504: 1,
  35540: 1,
  35541: 1,
  35542: 1,
  35543: 1,
  35544: 1,
  35545: 1,
  35546: 1,
  35548: 1,
  35549: 1,
  35550: 1,
  35551: 1,
  35552: 1,
  35553: 1,
  35554: 1,
  35555: 1,
  35559: 1,
  35560: 1,
  35563: 1,
  35564: 1,
  35565: 1,
  35570: 1,
  35571: 1,
  35572: 1,
  35573: 1,
  35574: 1,
  35575: 1,
  35576: 1,
  35577: 1,
  35578: 1,
  35579: 1,
  35580: 1,
  35581: 1,
  35582: 1,
  35584: 1,
  35585: 1,
  35586: 1,
  35587: 1,
  35592: 1,
  35593: 1,
  35594: 1,
  35601: 1,
  35602: 1,
  35603: 1,
  35609: 1,
  35610: 1,
  35611: 1,
  35612: 1,
  35613: 1,
  35614: 1,
  35617: 1,
  35618: 1,
  35619: 1,
  35620: 1,
  35621: 1,
  35622: 1,
  35630: 1,
  35631: 1,
  35632: 1,
  35633: 1,
  35634: 1,
  35640: 1,
  35643: 1,
  35645: 1,
  35646: 1,
  35647: 1,
  35648: 1,
  35649: 1,
  35650: 1,
  35651: 1,
  35652: 1,
  35653: 1,
  35654: 1,
  35660: 1,
  35661: 1,
  35662: 1,
  35670: 1,
  35671: 1,
  35672: 1,
  35673: 1,
  35674: 1,
  35677: 1,
  35699: 1,
  35739: 1,
  35740: 1,
  35741: 1,
  35742: 1,
  35744: 1,
  35745: 1,
  35746: 1,
  35747: 1,
  35748: 1,
  35749: 1,
  35750: 1,
  35751: 1,
  35752: 1,
  35754: 1,
  35755: 1,
  35756: 1,
  35757: 1,
  35758: 1,
  35759: 1,
  35760: 1,
  35761: 1,
  35762: 1,
  35763: 1,
  35764: 1,
  35765: 1,
  35766: 1,
  35767: 1,
  35768: 1,
  35769: 1,
  35771: 1,
  35772: 1,
  35773: 1,
  35774: 1,
  35775: 1,
  35776: 1,
  35801: 1,
  35802: 1,
  35803: 1,
  35804: 1,
  35805: 1,
  35806: 1,
  35807: 1,
  35808: 1,
  35809: 1,
  35810: 1,
  35811: 1,
  35812: 1,
  35813: 1,
  35814: 1,
  35815: 1,
  35816: 1,
  35824: 1,
  35893: 1,
  35894: 1,
  35895: 1,
  35896: 1,
  35897: 1,
  35898: 1,
  35899: 1,
  35901: 1,
  35902: 1,
  35903: 1,
  35904: 1,
  35905: 1,
  35906: 1,
  35907: 1,
  35950: 1,
  35951: 1,
  35952: 1,
  35953: 1,
  35954: 1,
  35956: 1,
  35957: 1,
  35958: 1,
  35959: 1,
  35960: 1,
  35961: 1,
  35962: 1,
  35963: 1,
  35964: 1,
  35966: 1,
  35967: 1,
  35968: 1,
  35971: 1,
  35972: 1,
  35973: 1,
  35974: 1,
  35975: 1,
  35976: 1,
  35978: 1,
  35979: 1,
  35980: 1,
  35981: 1,
  35983: 1,
  35984: 1,
  35986: 1,
  35987: 1,
  35988: 1,
  35989: 1,
  35990: 1,
  36003: 1,
  36005: 1,
  36006: 1,
  36008: 1,
  36009: 1,
  36010: 1,
  36013: 1,
  36015: 1,
  36016: 1,
  36017: 1,
  36020: 1,
  36022: 1,
  36023: 1,
  36024: 1,
  36025: 1,
  36026: 1,
  36027: 1,
  36028: 1,
  36029: 1,
  36030: 1,
  36031: 1,
  36032: 1,
  36033: 1,
  36034: 1,
  36035: 1,
  36036: 1,
  36037: 1,
  36038: 1,
  36039: 1,
  36040: 1,
  36041: 1,
  36042: 1,
  36043: 1,
  36045: 1,
  36046: 1,
  36047: 1,
  36048: 1,
  36049: 1,
  36051: 1,
  36052: 1,
  36053: 1,
  36054: 1,
  36057: 1,
  36061: 1,
  36062: 1,
  36064: 1,
  36065: 1,
  36066: 1,
  36067: 1,
  36068: 1,
  36069: 1,
  36071: 1,
  36072: 1,
  36075: 1,
  36078: 1,
  36079: 1,
  36080: 1,
  36081: 1,
  36082: 1,
  36083: 1,
  36087: 1,
  36088: 1,
  36089: 1,
  36091: 1,
  36092: 1,
  36093: 1,
  36101: 1,
  36102: 1,
  36103: 1,
  36104: 1,
  36105: 1,
  36106: 1,
  36107: 1,
  36108: 1,
  36109: 1,
  36110: 1,
  36111: 1,
  36112: 1,
  36113: 1,
  36114: 1,
  36115: 1,
  36116: 1,
  36117: 1,
  36118: 1,
  36119: 1,
  36120: 1,
  36121: 1,
  36123: 1,
  36124: 1,
  36125: 1,
  36130: 1,
  36131: 1,
  36132: 1,
  36133: 1,
  36134: 1,
  36135: 1,
  36140: 1,
  36141: 1,
  36142: 1,
  36177: 1,
  36191: 1,
  36201: 1,
  36202: 1,
  36203: 1,
  36204: 1,
  36205: 1,
  36206: 1,
  36207: 1,
  36210: 1,
  36250: 1,
  36251: 1,
  36253: 1,
  36254: 1,
  36255: 1,
  36256: 1,
  36257: 1,
  36258: 1,
  36260: 1,
  36261: 1,
  36262: 1,
  36263: 1,
  36264: 1,
  36265: 1,
  36266: 1,
  36267: 1,
  36268: 1,
  36269: 1,
  36271: 1,
  36272: 1,
  36273: 1,
  36274: 1,
  36275: 1,
  36276: 1,
  36277: 1,
  36278: 1,
  36279: 1,
  36280: 1,
  36301: 1,
  36302: 1,
  36303: 1,
  36304: 1,
  36305: 1,
  36310: 1,
  36311: 1,
  36312: 1,
  36313: 1,
  36314: 1,
  36316: 1,
  36317: 1,
  36318: 1,
  36319: 1,
  36320: 1,
  36321: 1,
  36322: 1,
  36323: 1,
  36330: 1,
  36331: 1,
  36340: 1,
  36343: 1,
  36344: 1,
  36345: 1,
  36346: 1,
  36349: 1,
  36350: 1,
  36351: 1,
  36352: 1,
  36353: 1,
  36360: 1,
  36361: 1,
  36362: 1,
  36370: 1,
  36371: 1,
  36373: 1,
  36374: 1,
  36375: 1,
  36376: 1,
  36401: 1,
  36420: 1,
  36421: 1,
  36425: 1,
  36426: 1,
  36427: 1,
  36429: 1,
  36432: 1,
  36435: 1,
  36436: 1,
  36439: 1,
  36441: 1,
  36442: 1,
  36444: 1,
  36445: 1,
  36446: 1,
  36449: 1,
  36451: 1,
  36453: 1,
  36454: 1,
  36455: 1,
  36456: 1,
  36457: 1,
  36458: 1,
  36460: 1,
  36461: 1,
  36462: 1,
  36467: 1,
  36471: 1,
  36473: 1,
  36474: 1,
  36475: 1,
  36476: 1,
  36477: 1,
  36480: 1,
  36481: 1,
  36482: 1,
  36483: 1,
  36501: 1,
  36502: 1,
  36503: 1,
  36504: 1,
  36505: 1,
  36507: 1,
  36509: 1,
  36511: 1,
  36512: 1,
  36513: 1,
  36515: 1,
  36518: 1,
  36521: 1,
  36522: 1,
  36523: 1,
  36524: 1,
  36525: 1,
  36526: 1,
  36527: 1,
  36528: 1,
  36529: 1,
  36530: 1,
  36532: 1,
  36533: 1,
  36535: 1,
  36536: 1,
  36538: 1,
  36539: 1,
  36540: 1,
  36541: 1,
  36542: 1,
  36544: 1,
  36545: 1,
  36547: 1,
  36548: 1,
  36549: 1,
  36550: 1,
  36551: 1,
  36553: 1,
  36555: 1,
  36556: 1,
  36558: 1,
  36559: 1,
  36560: 1,
  36561: 1,
  36562: 1,
  36564: 1,
  36567: 1,
  36568: 1,
  36569: 1,
  36570: 1,
  36571: 1,
  36572: 1,
  36575: 1,
  36576: 1,
  36577: 1,
  36578: 1,
  36579: 1,
  36580: 1,
  36581: 1,
  36582: 1,
  36583: 1,
  36584: 1,
  36585: 1,
  36587: 1,
  36590: 1,
  36601: 1,
  36602: 1,
  36603: 1,
  36604: 1,
  36605: 1,
  36606: 1,
  36607: 1,
  36608: 1,
  36609: 1,
  36610: 1,
  36611: 1,
  36612: 1,
  36613: 1,
  36614: 1,
  36615: 1,
  36616: 1,
  36617: 1,
  36618: 1,
  36619: 1,
  36621: 1,
  36622: 1,
  36623: 1,
  36625: 1,
  36626: 1,
  36628: 1,
  36630: 1,
  36631: 1,
  36633: 1,
  36640: 1,
  36641: 1,
  36644: 1,
  36652: 1,
  36660: 1,
  36663: 1,
  36670: 1,
  36671: 1,
  36675: 1,
  36685: 1,
  36688: 1,
  36689: 1,
  36690: 1,
  36691: 1,
  36693: 1,
  36695: 1,
  36701: 1,
  36702: 1,
  36703: 1,
  36720: 1,
  36721: 1,
  36722: 1,
  36723: 1,
  36726: 1,
  36727: 1,
  36728: 1,
  36732: 1,
  36736: 1,
  36738: 1,
  36740: 1,
  36741: 1,
  36742: 1,
  36744: 1,
  36745: 1,
  36748: 1,
  36749: 1,
  36750: 1,
  36751: 1,
  36752: 1,
  36753: 1,
  36754: 1,
  36756: 1,
  36758: 1,
  36759: 1,
  36761: 1,
  36762: 1,
  36763: 1,
  36764: 1,
  36765: 1,
  36766: 1,
  36767: 1,
  36768: 1,
  36769: 1,
  36773: 1,
  36775: 1,
  36776: 1,
  36782: 1,
  36783: 1,
  36784: 1,
  36785: 1,
  36786: 1,
  36790: 1,
  36792: 1,
  36793: 1,
  36801: 1,
  36802: 1,
  36803: 1,
  36804: 1,
  36830: 1,
  36831: 1,
  36832: 1,
  36849: 1,
  36850: 1,
  36851: 1,
  36852: 1,
  36853: 1,
  36854: 1,
  36855: 1,
  36856: 1,
  36858: 1,
  36859: 1,
  36860: 1,
  36861: 1,
  36862: 1,
  36863: 1,
  36865: 1,
  36866: 1,
  36867: 1,
  36868: 1,
  36869: 1,
  36870: 1,
  36871: 1,
  36872: 1,
  36874: 1,
  36875: 1,
  36877: 1,
  36879: 1,
  36901: 1,
  36904: 1,
  36906: 1,
  36907: 1,
  36908: 1,
  36910: 1,
  36912: 1,
  36913: 1,
  36915: 1,
  36916: 1,
  36919: 1,
  36921: 1,
  36922: 1,
  36925: 1,
  37010: 1,
  37011: 1,
  37012: 1,
  37013: 1,
  37014: 1,
  37015: 1,
  37016: 1,
  37018: 1,
  37019: 1,
  37020: 1,
  37022: 1,
  37023: 1,
  37024: 1,
  37025: 1,
  37026: 1,
  37027: 1,
  37028: 1,
  37029: 1,
  37030: 1,
  37031: 1,
  37032: 1,
  37033: 1,
  37034: 1,
  37035: 1,
  37036: 1,
  37037: 1,
  37040: 1,
  37041: 1,
  37042: 1,
  37043: 1,
  37044: 1,
  37046: 1,
  37047: 1,
  37048: 1,
  37049: 1,
  37050: 1,
  37051: 1,
  37052: 1,
  37055: 1,
  37056: 1,
  37057: 1,
  37058: 1,
  37059: 1,
  37060: 1,
  37061: 1,
  37062: 1,
  37063: 1,
  37064: 1,
  37065: 1,
  37066: 1,
  37067: 1,
  37068: 1,
  37069: 1,
  37070: 1,
  37071: 1,
  37072: 1,
  37073: 1,
  37074: 1,
  37075: 1,
  37076: 1,
  37077: 1,
  37078: 1,
  37079: 1,
  37080: 1,
  37082: 1,
  37083: 1,
  37085: 1,
  37086: 1,
  37087: 1,
  37088: 1,
  37089: 1,
  37090: 1,
  37091: 1,
  37095: 1,
  37096: 1,
  37097: 1,
  37098: 1,
  37101: 1,
  37110: 1,
  37111: 1,
  37115: 1,
  37116: 1,
  37118: 1,
  37119: 1,
  37121: 1,
  37122: 1,
  37127: 1,
  37128: 1,
  37129: 1,
  37130: 1,
  37131: 1,
  37132: 1,
  37133: 1,
  37134: 1,
  37135: 1,
  37136: 1,
  37137: 1,
  37138: 1,
  37140: 1,
  37141: 1,
  37142: 1,
  37143: 1,
  37144: 1,
  37145: 1,
  37146: 1,
  37148: 1,
  37149: 1,
  37150: 1,
  37151: 1,
  37152: 1,
  37153: 1,
  37155: 1,
  37160: 1,
  37161: 1,
  37162: 1,
  37165: 1,
  37166: 1,
  37167: 1,
  37171: 1,
  37172: 1,
  37174: 1,
  37175: 1,
  37178: 1,
  37179: 1,
  37180: 1,
  37181: 1,
  37183: 1,
  37184: 1,
  37185: 1,
  37186: 1,
  37187: 1,
  37188: 1,
  37189: 1,
  37190: 1,
  37191: 1,
  37201: 1,
  37202: 1,
  37203: 1,
  37204: 1,
  37205: 1,
  37206: 1,
  37207: 1,
  37208: 1,
  37209: 1,
  37210: 1,
  37211: 1,
  37212: 1,
  37213: 1,
  37214: 1,
  37215: 1,
  37216: 1,
  37217: 1,
  37218: 1,
  37219: 1,
  37220: 1,
  37221: 1,
  37222: 1,
  37224: 1,
  37227: 1,
  37228: 1,
  37229: 1,
  37230: 1,
  37232: 1,
  37234: 1,
  37235: 1,
  37236: 1,
  37237: 1,
  37238: 1,
  37239: 1,
  37240: 1,
  37241: 1,
  37242: 1,
  37243: 1,
  37244: 1,
  37245: 1,
  37246: 1,
  37247: 1,
  37248: 1,
  37249: 1,
  37250: 1,
  37301: 1,
  37302: 0,
  37303: 0,
  37304: 0,
  37305: 1,
  37306: 1,
  37307: 0,
  37308: 0,
  37309: 0,
  37310: 0,
  37311: 0,
  37312: 0,
  37313: 1,
  37314: 0,
  37315: 0,
  37316: 0,
  37317: 0,
  37318: 1,
  37320: 0,
  37321: 0,
  37322: 0,
  37323: 0,
  37324: 1,
  37325: 0,
  37326: 0,
  37327: 1,
  37328: 1,
  37329: 0,
  37330: 1,
  37331: 0,
  37332: 0,
  37333: 0,
  37334: 1,
  37335: 1,
  37336: 0,
  37337: 0,
  37338: 1,
  37339: 1,
  37340: 1,
  37341: 0,
  37342: 1,
  37343: 0,
  37345: 1,
  37347: 1,
  37348: 1,
  37349: 1,
  37350: 0,
  37351: 0,
  37352: 1,
  37353: 0,
  37354: 0,
  37355: 1,
  37356: 1,
  37357: 1,
  37359: 1,
  37360: 1,
  37361: 0,
  37362: 0,
  37363: 0,
  37364: 0,
  37365: 1,
  37366: 1,
  37367: 1,
  37369: 0,
  37370: 0,
  37371: 0,
  37373: 0,
  37374: 1,
  37375: 1,
  37376: 1,
  37377: 0,
  37378: 1,
  37379: 0,
  37380: 1,
  37381: 0,
  37382: 1,
  37383: 1,
  37384: 0,
  37385: 0,
  37387: 1,
  37388: 1,
  37389: 1,
  37391: 0,
  37394: 1,
  37396: 1,
  37397: 1,
  37398: 1,
  37401: 0,
  37402: 0,
  37403: 0,
  37404: 0,
  37405: 0,
  37406: 0,
  37407: 0,
  37408: 0,
  37409: 0,
  37410: 0,
  37411: 0,
  37412: 0,
  37414: 0,
  37415: 0,
  37416: 0,
  37419: 0,
  37421: 0,
  37422: 0,
  37424: 0,
  37450: 0,
  37501: 1,
  37544: 1,
  37601: 0,
  37602: 0,
  37604: 0,
  37605: 0,
  37614: 0,
  37615: 0,
  37616: 0,
  37617: 0,
  37618: 0,
  37620: 0,
  37621: 0,
  37625: 0,
  37640: 0,
  37641: 0,
  37642: 0,
  37643: 0,
  37644: 0,
  37645: 0,
  37650: 0,
  37656: 0,
  37657: 0,
  37658: 0,
  37659: 0,
  37660: 0,
  37662: 0,
  37663: 0,
  37664: 0,
  37665: 0,
  37669: 0,
  37680: 0,
  37681: 0,
  37682: 0,
  37683: 0,
  37684: 0,
  37686: 0,
  37687: 0,
  37688: 0,
  37690: 0,
  37691: 0,
  37692: 0,
  37694: 0,
  37699: 0,
  37701: 0,
  37705: 0,
  37707: 0,
  37708: 0,
  37709: 0,
  37710: 0,
  37711: 0,
  37713: 0,
  37714: 0,
  37715: 0,
  37716: 0,
  37717: 0,
  37719: 0,
  37721: 0,
  37722: 0,
  37723: 1,
  37724: 0,
  37725: 0,
  37726: 0,
  37727: 0,
  37729: 0,
  37730: 0,
  37731: 0,
  37732: 0,
  37733: 0,
  37737: 0,
  37738: 0,
  37742: 0,
  37743: 0,
  37744: 0,
  37745: 0,
  37748: 0,
  37752: 0,
  37753: 0,
  37754: 0,
  37755: 0,
  37756: 0,
  37757: 0,
  37760: 0,
  37762: 0,
  37763: 0,
  37764: 0,
  37765: 0,
  37766: 0,
  37769: 0,
  37770: 0,
  37771: 0,
  37772: 0,
  37773: 0,
  37774: 0,
  37777: 0,
  37778: 0,
  37779: 0,
  37801: 0,
  37802: 0,
  37803: 0,
  37804: 0,
  37806: 0,
  37807: 0,
  37809: 0,
  37810: 0,
  37811: 0,
  37813: 0,
  37814: 0,
  37815: 0,
  37816: 0,
  37818: 0,
  37819: 0,
  37820: 0,
  37821: 0,
  37822: 0,
  37824: 0,
  37825: 0,
  37826: 0,
  37828: 0,
  37829: 0,
  37830: 0,
  37831: 0,
  37840: 0,
  37841: 0,
  37843: 0,
  37845: 0,
  37846: 0,
  37847: 0,
  37848: 0,
  37849: 0,
  37851: 0,
  37852: 0,
  37853: 0,
  37854: 0,
  37857: 0,
  37860: 0,
  37861: 0,
  37862: 0,
  37863: 0,
  37864: 0,
  37865: 0,
  37866: 0,
  37867: 0,
  37868: 0,
  37869: 0,
  37870: 0,
  37871: 0,
  37872: 0,
  37873: 0,
  37874: 0,
  37876: 0,
  37877: 0,
  37878: 0,
  37879: 0,
  37880: 0,
  37881: 0,
  37882: 0,
  37885: 0,
  37886: 0,
  37887: 0,
  37888: 0,
  37890: 0,
  37891: 0,
  37892: 0,
  37901: 0,
  37902: 0,
  37909: 0,
  37912: 0,
  37914: 0,
  37915: 0,
  37916: 0,
  37917: 0,
  37918: 0,
  37919: 0,
  37920: 0,
  37921: 0,
  37922: 0,
  37923: 0,
  37924: 0,
  37927: 0,
  37928: 0,
  37929: 0,
  37930: 0,
  37931: 0,
  37932: 0,
  37933: 0,
  37934: 0,
  37938: 0,
  37939: 0,
  37940: 0,
  37950: 0,
  37955: 0,
  37990: 0,
  37995: 0,
  37996: 0,
  37997: 0,
  37998: 0,
  38001: 1,
  38002: 1,
  38004: 1,
  38006: 1,
  38007: 1,
  38008: 1,
  38010: 1,
  38011: 1,
  38012: 1,
  38014: 1,
  38015: 1,
  38016: 1,
  38017: 1,
  38018: 1,
  38019: 1,
  38021: 1,
  38023: 1,
  38024: 1,
  38025: 1,
  38027: 1,
  38028: 1,
  38029: 1,
  38030: 1,
  38034: 1,
  38036: 1,
  38037: 1,
  38039: 1,
  38040: 1,
  38041: 1,
  38042: 1,
  38044: 1,
  38045: 1,
  38046: 1,
  38047: 1,
  38048: 1,
  38049: 1,
  38050: 1,
  38052: 1,
  38053: 1,
  38054: 1,
  38055: 1,
  38057: 1,
  38058: 1,
  38059: 1,
  38060: 1,
  38061: 1,
  38063: 1,
  38066: 1,
  38067: 1,
  38068: 1,
  38069: 1,
  38070: 1,
  38071: 1,
  38074: 1,
  38075: 1,
  38076: 1,
  38077: 1,
  38079: 1,
  38080: 1,
  38083: 1,
  38088: 1,
  38101: 1,
  38103: 1,
  38104: 1,
  38105: 1,
  38106: 1,
  38107: 1,
  38108: 1,
  38109: 1,
  38110: 1,
  38111: 1,
  38112: 1,
  38113: 1,
  38114: 1,
  38115: 1,
  38116: 1,
  38117: 1,
  38118: 1,
  38119: 1,
  38120: 1,
  38122: 1,
  38124: 1,
  38125: 1,
  38126: 1,
  38127: 1,
  38128: 1,
  38129: 1,
  38130: 1,
  38131: 1,
  38132: 1,
  38133: 1,
  38134: 1,
  38135: 1,
  38136: 1,
  38137: 1,
  38138: 1,
  38139: 1,
  38140: 1,
  38141: 1,
  38142: 1,
  38143: 1,
  38145: 1,
  38146: 1,
  38147: 1,
  38148: 1,
  38150: 1,
  38151: 1,
  38152: 1,
  38157: 1,
  38159: 1,
  38161: 1,
  38163: 1,
  38165: 1,
  38166: 1,
  38167: 1,
  38168: 1,
  38173: 1,
  38174: 1,
  38175: 1,
  38177: 1,
  38181: 1,
  38182: 1,
  38183: 1,
  38184: 1,
  38186: 1,
  38187: 1,
  38188: 1,
  38190: 1,
  38193: 1,
  38194: 1,
  38195: 1,
  38197: 1,
  38201: 1,
  38220: 1,
  38221: 1,
  38222: 1,
  38223: 1,
  38224: 1,
  38225: 1,
  38226: 1,
  38229: 1,
  38230: 1,
  38231: 1,
  38232: 1,
  38233: 1,
  38235: 1,
  38236: 1,
  38237: 1,
  38238: 1,
  38240: 1,
  38241: 1,
  38242: 1,
  38251: 1,
  38253: 1,
  38254: 1,
  38255: 1,
  38256: 1,
  38257: 1,
  38258: 1,
  38259: 1,
  38260: 1,
  38261: 1,
  38271: 1,
  38281: 1,
  38301: 1,
  38302: 1,
  38303: 1,
  38305: 1,
  38308: 1,
  38310: 1,
  38311: 1,
  38313: 1,
  38314: 1,
  38315: 1,
  38316: 1,
  38317: 1,
  38318: 1,
  38320: 1,
  38321: 1,
  38324: 1,
  38326: 1,
  38327: 1,
  38328: 1,
  38329: 1,
  38330: 1,
  38331: 1,
  38332: 1,
  38333: 1,
  38334: 1,
  38336: 1,
  38337: 1,
  38338: 1,
  38339: 1,
  38340: 1,
  38341: 1,
  38342: 1,
  38343: 1,
  38344: 1,
  38345: 1,
  38346: 1,
  38347: 1,
  38348: 1,
  38351: 1,
  38352: 1,
  38355: 1,
  38356: 1,
  38357: 1,
  38358: 1,
  38359: 1,
  38361: 1,
  38362: 1,
  38363: 1,
  38365: 1,
  38366: 1,
  38367: 1,
  38368: 1,
  38369: 1,
  38370: 1,
  38371: 1,
  38372: 1,
  38374: 1,
  38375: 1,
  38376: 1,
  38377: 1,
  38378: 1,
  38379: 1,
  38380: 1,
  38381: 1,
  38382: 1,
  38387: 1,
  38388: 1,
  38389: 1,
  38390: 1,
  38391: 1,
  38392: 1,
  38393: 1,
  38401: 1,
  38402: 1,
  38425: 1,
  38449: 1,
  38450: 1,
  38451: 1,
  38452: 1,
  38453: 1,
  38454: 1,
  38455: 1,
  38456: 1,
  38457: 1,
  38459: 1,
  38460: 1,
  38461: 1,
  38462: 1,
  38463: 1,
  38464: 1,
  38468: 1,
  38469: 1,
  38471: 1,
  38472: 1,
  38473: 1,
  38474: 1,
  38475: 1,
  38476: 1,
  38477: 1,
  38478: 1,
  38481: 1,
  38482: 1,
  38483: 1,
  38485: 1,
  38486: 1,
  38487: 1,
  38488: 1,
  38501: 1,
  38502: 1,
  38503: 1,
  38504: 1,
  38505: 1,
  38506: 1,
  38541: 1,
  38542: 1,
  38543: 1,
  38544: 1,
  38545: 1,
  38547: 1,
  38548: 1,
  38549: 1,
  38550: 1,
  38551: 1,
  38552: 1,
  38553: 1,
  38554: 1,
  38555: 1,
  38556: 1,
  38557: 1,
  38558: 1,
  38559: 1,
  38560: 1,
  38562: 1,
  38563: 1,
  38564: 1,
  38565: 1,
  38567: 1,
  38568: 1,
  38569: 1,
  38570: 1,
  38571: 1,
  38572: 1,
  38573: 1,
  38574: 1,
  38575: 1,
  38577: 1,
  38578: 1,
  38579: 1,
  38580: 1,
  38581: 1,
  38582: 1,
  38583: 1,
  38585: 1,
  38587: 1,
  38588: 1,
  38589: 1,
  38601: 1,
  38602: 1,
  38603: 1,
  38606: 1,
  38609: 1,
  38610: 1,
  38611: 1,
  38614: 1,
  38617: 1,
  38618: 1,
  38619: 1,
  38620: 1,
  38621: 1,
  38622: 1,
  38623: 1,
  38625: 1,
  38626: 1,
  38627: 1,
  38628: 1,
  38629: 1,
  38630: 1,
  38631: 1,
  38632: 1,
  38633: 1,
  38634: 1,
  38635: 1,
  38637: 1,
  38638: 1,
  38639: 1,
  38641: 1,
  38642: 1,
  38643: 1,
  38644: 1,
  38645: 1,
  38646: 1,
  38647: 1,
  38649: 1,
  38650: 1,
  38651: 1,
  38652: 1,
  38654: 1,
  38655: 1,
  38658: 1,
  38659: 1,
  38661: 1,
  38663: 1,
  38664: 1,
  38665: 1,
  38666: 1,
  38668: 1,
  38669: 1,
  38670: 1,
  38671: 1,
  38672: 1,
  38673: 1,
  38674: 1,
  38675: 1,
  38676: 1,
  38677: 1,
  38679: 1,
  38680: 1,
  38683: 1,
  38685: 1,
  38686: 1,
  38701: 1,
  38702: 1,
  38703: 1,
  38704: 1,
  38720: 1,
  38721: 1,
  38722: 1,
  38723: 1,
  38725: 1,
  38726: 1,
  38730: 1,
  38731: 1,
  38732: 1,
  38733: 1,
  38736: 1,
  38737: 1,
  38738: 1,
  38739: 1,
  38740: 1,
  38744: 1,
  38745: 1,
  38746: 1,
  38748: 1,
  38749: 1,
  38751: 1,
  38753: 1,
  38754: 1,
  38756: 1,
  38758: 1,
  38759: 1,
  38760: 1,
  38761: 1,
  38762: 1,
  38764: 1,
  38765: 1,
  38767: 1,
  38768: 1,
  38769: 1,
  38771: 1,
  38772: 1,
  38773: 1,
  38774: 1,
  38776: 1,
  38778: 1,
  38780: 1,
  38781: 1,
  38782: 1,
  38801: 1,
  38802: 1,
  38803: 1,
  38804: 1,
  38820: 1,
  38821: 1,
  38824: 1,
  38825: 1,
  38826: 1,
  38827: 1,
  38828: 1,
  38829: 1,
  38833: 1,
  38834: 1,
  38835: 1,
  38838: 1,
  38839: 1,
  38841: 1,
  38843: 1,
  38844: 1,
  38846: 1,
  38847: 1,
  38848: 1,
  38849: 1,
  38850: 1,
  38851: 1,
  38852: 1,
  38854: 1,
  38855: 1,
  38856: 1,
  38857: 1,
  38858: 1,
  38859: 1,
  38860: 1,
  38862: 1,
  38863: 1,
  38864: 1,
  38865: 1,
  38866: 1,
  38868: 1,
  38869: 1,
  38870: 1,
  38871: 1,
  38873: 1,
  38874: 1,
  38875: 1,
  38876: 1,
  38877: 1,
  38878: 1,
  38879: 1,
  38880: 1,
  38901: 1,
  38902: 1,
  38912: 1,
  38913: 1,
  38914: 1,
  38915: 1,
  38916: 1,
  38917: 1,
  38920: 1,
  38921: 1,
  38922: 1,
  38923: 1,
  38924: 1,
  38925: 1,
  38926: 1,
  38927: 1,
  38928: 1,
  38929: 1,
  38930: 1,
  38935: 1,
  38940: 1,
  38941: 1,
  38943: 1,
  38944: 1,
  38945: 1,
  38946: 1,
  38947: 1,
  38948: 1,
  38949: 1,
  38950: 1,
  38951: 1,
  38952: 1,
  38953: 1,
  38954: 1,
  38955: 1,
  38957: 1,
  38958: 1,
  38959: 1,
  38960: 1,
  38961: 1,
  38962: 1,
  38963: 1,
  38964: 1,
  38965: 1,
  38966: 1,
  38967: 1,
  39038: 1,
  39039: 1,
  39040: 1,
  39041: 1,
  39042: 1,
  39043: 1,
  39044: 1,
  39045: 1,
  39046: 1,
  39047: 1,
  39051: 1,
  39054: 1,
  39056: 1,
  39057: 1,
  39058: 1,
  39059: 1,
  39060: 1,
  39061: 1,
  39062: 1,
  39063: 1,
  39066: 1,
  39067: 1,
  39069: 1,
  39071: 1,
  39072: 1,
  39073: 1,
  39074: 1,
  39077: 1,
  39080: 1,
  39081: 1,
  39082: 1,
  39083: 1,
  39086: 1,
  39087: 1,
  39088: 1,
  39090: 1,
  39092: 1,
  39094: 1,
  39095: 1,
  39096: 1,
  39097: 1,
  39098: 1,
  39107: 1,
  39108: 1,
  39109: 1,
  39110: 1,
  39111: 1,
  39112: 1,
  39113: 1,
  39114: 1,
  39115: 1,
  39116: 1,
  39117: 1,
  39119: 1,
  39120: 1,
  39121: 1,
  39122: 1,
  39130: 1,
  39140: 1,
  39144: 1,
  39145: 1,
  39146: 1,
  39148: 1,
  39149: 1,
  39150: 1,
  39151: 1,
  39152: 1,
  39153: 1,
  39154: 1,
  39156: 1,
  39157: 1,
  39158: 1,
  39159: 1,
  39160: 1,
  39161: 1,
  39162: 1,
  39163: 1,
  39165: 1,
  39166: 1,
  39167: 1,
  39168: 1,
  39169: 1,
  39170: 1,
  39171: 1,
  39173: 1,
  39174: 1,
  39175: 1,
  39176: 1,
  39177: 1,
  39179: 1,
  39180: 1,
  39181: 1,
  39182: 1,
  39183: 1,
  39189: 1,
  39190: 1,
  39191: 1,
  39192: 1,
  39193: 1,
  39194: 1,
  39201: 1,
  39202: 1,
  39203: 1,
  39204: 1,
  39205: 1,
  39206: 1,
  39207: 1,
  39208: 1,
  39209: 1,
  39210: 1,
  39211: 1,
  39212: 1,
  39213: 1,
  39215: 1,
  39216: 1,
  39217: 1,
  39218: 1,
  39225: 1,
  39232: 1,
  39235: 1,
  39236: 1,
  39250: 1,
  39269: 1,
  39271: 1,
  39272: 1,
  39282: 1,
  39283: 1,
  39284: 1,
  39286: 1,
  39288: 1,
  39289: 1,
  39296: 1,
  39298: 1,
  39301: 1,
  39302: 1,
  39303: 1,
  39304: 1,
  39305: 1,
  39307: 1,
  39309: 1,
  39320: 1,
  39322: 1,
  39323: 1,
  39324: 1,
  39327: 1,
  39328: 1,
  39330: 1,
  39332: 1,
  39335: 1,
  39336: 1,
  39337: 1,
  39338: 1,
  39339: 1,
  39341: 1,
  39342: 1,
  39345: 1,
  39346: 1,
  39347: 1,
  39348: 1,
  39350: 1,
  39352: 1,
  39354: 1,
  39355: 1,
  39356: 1,
  39358: 1,
  39359: 1,
  39360: 1,
  39361: 1,
  39362: 1,
  39363: 1,
  39364: 1,
  39365: 1,
  39366: 1,
  39367: 1,
  39401: 1,
  39402: 1,
  39403: 1,
  39404: 1,
  39406: 1,
  39407: 1,
  39421: 1,
  39422: 1,
  39423: 1,
  39425: 1,
  39426: 1,
  39427: 1,
  39428: 1,
  39429: 1,
  39436: 1,
  39437: 1,
  39439: 1,
  39440: 1,
  39441: 1,
  39442: 1,
  39443: 1,
  39451: 1,
  39452: 1,
  39455: 1,
  39456: 1,
  39457: 1,
  39459: 1,
  39460: 1,
  39461: 1,
  39462: 1,
  39463: 1,
  39464: 1,
  39465: 1,
  39466: 1,
  39470: 1,
  39474: 1,
  39475: 1,
  39476: 1,
  39477: 1,
  39478: 1,
  39479: 1,
  39480: 1,
  39481: 1,
  39482: 1,
  39483: 1,
  39501: 1,
  39502: 1,
  39503: 1,
  39505: 1,
  39506: 1,
  39507: 1,
  39520: 1,
  39521: 1,
  39522: 1,
  39525: 1,
  39529: 1,
  39530: 1,
  39531: 1,
  39532: 1,
  39533: 1,
  39534: 1,
  39535: 1,
  39540: 1,
  39552: 1,
  39553: 1,
  39555: 1,
  39556: 1,
  39558: 1,
  39560: 1,
  39561: 1,
  39562: 1,
  39563: 1,
  39564: 1,
  39565: 1,
  39566: 1,
  39567: 1,
  39568: 1,
  39569: 1,
  39571: 1,
  39572: 1,
  39573: 1,
  39574: 1,
  39576: 1,
  39577: 1,
  39581: 1,
  39595: 1,
  39601: 1,
  39602: 1,
  39603: 1,
  39629: 1,
  39630: 1,
  39631: 1,
  39632: 1,
  39633: 1,
  39635: 1,
  39638: 1,
  39641: 1,
  39643: 1,
  39645: 1,
  39647: 1,
  39648: 1,
  39649: 1,
  39652: 1,
  39653: 1,
  39654: 1,
  39656: 1,
  39657: 1,
  39661: 1,
  39662: 1,
  39663: 1,
  39664: 1,
  39665: 1,
  39666: 1,
  39667: 1,
  39668: 1,
  39669: 1,
  39701: 1,
  39702: 1,
  39703: 1,
  39704: 1,
  39705: 1,
  39710: 1,
  39730: 1,
  39735: 1,
  39736: 1,
  39737: 1,
  39739: 1,
  39740: 1,
  39741: 1,
  39743: 1,
  39744: 1,
  39745: 1,
  39746: 1,
  39747: 1,
  39750: 1,
  39751: 1,
  39752: 1,
  39753: 1,
  39754: 1,
  39755: 1,
  39756: 1,
  39759: 1,
  39760: 1,
  39762: 1,
  39766: 1,
  39767: 1,
  39769: 1,
  39771: 1,
  39772: 1,
  39773: 1,
  39776: 1,
  39813: 0,
  39815: 0,
  39817: 0,
  39819: 0,
  39823: 0,
  39824: 0,
  39825: 0,
  39826: 0,
  39827: 0,
  39828: 0,
  39829: 0,
  39832: 0,
  39834: 0,
  39836: 0,
  39837: 0,
  39840: 0,
  39841: 0,
  39842: 0,
  39845: 0,
  39846: 0,
  39851: 0,
  39852: 0,
  39854: 0,
  39859: 0,
  39861: 0,
  39862: 0,
  39866: 0,
  39867: 0,
  39870: 0,
  39877: 0,
  39885: 0,
  39886: 0,
  39897: 0,
  39901: 0,
  40003: 4,
  40004: 4,
  40006: 4,
  40007: 4,
  40008: 4,
  40009: 0,
  40010: 4,
  40011: 0,
  40012: 4,
  40013: 0,
  40014: 4,
  40018: 4,
  40019: 4,
  40020: 4,
  40022: 4,
  40023: 4,
  40025: 4,
  40026: 4,
  40027: 4,
  40031: 4,
  40032: 4,
  40033: 4,
  40037: 4,
  40040: 4,
  40041: 4,
  40045: 4,
  40046: 0,
  40047: 4,
  40048: 4,
  40049: 4,
  40050: 4,
  40051: 0,
  40052: 0,
  40055: 0,
  40056: 4,
  40057: 0,
  40058: 4,
  40059: 0,
  40060: 4,
  40061: 4,
  40062: 4,
  40063: 4,
  40065: 4,
  40066: 4,
  40067: 4,
  40068: 4,
  40069: 4,
  40070: 4,
  40071: 0,
  40075: 4,
  40076: 0,
  40077: 4,
  40078: 4,
  40104: 4,
  40107: 4,
  40108: 4,
  40109: 4,
  40110: 4,
  40111: 4,
  40115: 4,
  40117: 4,
  40118: 4,
  40119: 1,
  40121: 4,
  40122: 4,
  40129: 4,
  40140: 4,
  40142: 4,
  40143: 4,
  40144: 4,
  40145: 4,
  40146: 4,
  40150: 0,
  40152: 4,
  40153: 4,
  40155: 4,
  40157: 4,
  40159: 4,
  40160: 4,
  40161: 4,
  40162: 4,
  40164: 4,
  40165: 4,
  40170: 4,
  40171: 4,
  40175: 0,
  40176: 4,
  40177: 0,
  40178: 4,
  40201: 4,
  40202: 4,
  40203: 4,
  40204: 4,
  40205: 4,
  40206: 4,
  40207: 4,
  40208: 4,
  40209: 4,
  40210: 4,
  40211: 4,
  40212: 4,
  40213: 4,
  40214: 4,
  40215: 4,
  40216: 4,
  40217: 4,
  40218: 4,
  40219: 4,
  40220: 4,
  40221: 4,
  40222: 4,
  40223: 4,
  40224: 4,
  40225: 4,
  40228: 4,
  40229: 4,
  40231: 4,
  40232: 4,
  40233: 4,
  40241: 4,
  40242: 4,
  40243: 4,
  40245: 4,
  40250: 4,
  40251: 4,
  40252: 4,
  40253: 4,
  40255: 4,
  40256: 4,
  40257: 4,
  40258: 4,
  40259: 4,
  40261: 4,
  40266: 4,
  40268: 4,
  40269: 4,
  40270: 4,
  40272: 4,
  40280: 4,
  40281: 4,
  40282: 4,
  40283: 4,
  40285: 4,
  40287: 4,
  40289: 4,
  40290: 4,
  40291: 4,
  40292: 4,
  40293: 4,
  40294: 4,
  40295: 4,
  40296: 4,
  40297: 4,
  40298: 4,
  40299: 4,
  40310: 4,
  40311: 0,
  40312: 4,
  40313: 4,
  40316: 4,
  40317: 4,
  40319: 4,
  40320: 4,
  40322: 4,
  40324: 4,
  40328: 0,
  40329: 4,
  40330: 0,
  40334: 4,
  40336: 0,
  40337: 4,
  40339: 4,
  40340: 4,
  40342: 0,
  40346: 4,
  40347: 4,
  40348: 4,
  40350: 4,
  40351: 0,
  40353: 0,
  40355: 4,
  40356: 4,
  40357: 4,
  40358: 4,
  40359: 4,
  40360: 4,
  40361: 4,
  40362: 4,
  40363: 4,
  40366: 4,
  40370: 0,
  40371: 4,
  40372: 4,
  40374: 4,
  40376: 4,
  40379: 0,
  40380: 4,
  40383: 4,
  40384: 4,
  40385: 4,
  40386: 4,
  40387: 4,
  40390: 4,
  40391: 4,
  40392: 4,
  40402: 4,
  40403: 4,
  40404: 4,
  40405: 4,
  40409: 4,
  40410: 4,
  40419: 0,
  40421: 4,
  40422: 4,
  40423: 4,
  40434: 4,
  40437: 0,
  40440: 4,
  40442: 0,
  40444: 4,
  40445: 4,
  40446: 4,
  40447: 0,
  40448: 4,
  40452: 4,
  40456: 4,
  40460: 4,
  40461: 0,
  40464: 4,
  40467: 4,
  40468: 4,
  40472: 4,
  40473: 4,
  40475: 4,
  40476: 4,
  40481: 4,
  40484: 0,
  40486: 4,
  40488: 4,
  40489: 0,
  40492: 4,
  40495: 4,
  40502: 4,
  40503: 4,
  40504: 4,
  40505: 4,
  40506: 4,
  40507: 4,
  40508: 4,
  40509: 4,
  40510: 4,
  40511: 4,
  40512: 4,
  40513: 4,
  40514: 4,
  40515: 4,
  40516: 4,
  40517: 4,
  40522: 4,
  40523: 4,
  40524: 4,
  40526: 4,
  40533: 4,
  40536: 4,
  40544: 4,
  40546: 4,
  40550: 4,
  40555: 4,
  40574: 4,
  40575: 4,
  40576: 4,
  40577: 4,
  40578: 4,
  40579: 4,
  40580: 4,
  40581: 4,
  40582: 4,
  40583: 4,
  40584: 4,
  40585: 4,
  40586: 4,
  40587: 4,
  40588: 4,
  40589: 4,
  40590: 4,
  40591: 4,
  40592: 4,
  40593: 4,
  40594: 4,
  40595: 4,
  40596: 4,
  40598: 4,
  40601: 4,
  40602: 4,
  40603: 4,
  40604: 4,
  40618: 4,
  40619: 4,
  40620: 4,
  40621: 4,
  40622: 4,
  40701: 4,
  40702: 4,
  40724: 4,
  40729: 0,
  40730: 4,
  40734: 4,
  40737: 4,
  40740: 4,
  40741: 4,
  40742: 4,
  40743: 4,
  40744: 4,
  40745: 4,
  40751: 4,
  40754: 4,
  40755: 4,
  40759: 4,
  40763: 4,
  40769: 4,
  40771: 4,
  40801: 4,
  40803: 4,
  40806: 4,
  40807: 4,
  40808: 4,
  40810: 4,
  40813: 4,
  40815: 4,
  40816: 4,
  40818: 4,
  40819: 4,
  40820: 4,
  40823: 0,
  40824: 4,
  40826: 4,
  40827: 4,
  40828: 4,
  40829: 4,
  40830: 4,
  40831: 4,
  40840: 0,
  40843: 4,
  40844: 4,
  40845: 4,
  40847: 4,
  40849: 4,
  40854: 4,
  40855: 4,
  40856: 4,
  40858: 4,
  40862: 4,
  40863: 4,
  40865: 4,
  40868: 4,
  40870: 4,
  40873: 4,
  40874: 4,
  40902: 4,
  40903: 4,
  40906: 4,
  40913: 4,
  40914: 4,
  40915: 4,
  40921: 4,
  40923: 4,
  40927: 4,
  40930: 4,
  40931: 4,
  40932: 4,
  40935: 4,
  40939: 0,
  40940: 0,
  40941: 4,
  40943: 4,
  40944: 4,
  40946: 4,
  40949: 4,
  40951: 4,
  40953: 4,
  40955: 4,
  40958: 4,
  40962: 0,
  40964: 4,
  40965: 4,
  40972: 4,
  40977: 4,
  40979: 4,
  40981: 4,
  40982: 4,
  40983: 0,
  40988: 4,
  40995: 4,
  40997: 4,
  40999: 4,
  41001: 4,
  41002: 4,
  41003: 0,
  41004: 4,
  41005: 4,
  41006: 4,
  41007: 0,
  41008: 4,
  41010: 0,
  41011: 4,
  41012: 4,
  41014: 4,
  41015: 4,
  41016: 4,
  41017: 4,
  41018: 4,
  41019: 4,
  41022: 4,
  41030: 0,
  41031: 4,
  41033: 4,
  41034: 4,
  41035: 0,
  41037: 4,
  41039: 4,
  41040: 4,
  41041: 4,
  41042: 4,
  41043: 4,
  41044: 4,
  41045: 4,
  41046: 0,
  41048: 4,
  41049: 4,
  41051: 0,
  41052: 4,
  41053: 4,
  41054: 4,
  41055: 4,
  41056: 4,
  41059: 4,
  41061: 4,
  41062: 4,
  41063: 4,
  41064: 4,
  41065: 4,
  41071: 4,
  41072: 4,
  41073: 4,
  41074: 4,
  41075: 4,
  41076: 4,
  41080: 4,
  41081: 4,
  41083: 4,
  41085: 4,
  41086: 0,
  41091: 4,
  41092: 0,
  41093: 4,
  41094: 0,
  41095: 4,
  41096: 4,
  41097: 4,
  41098: 4,
  41099: 4,
  41101: 4,
  41102: 4,
  41105: 4,
  41114: 4,
  41121: 4,
  41124: 4,
  41128: 4,
  41129: 0,
  41132: 0,
  41135: 4,
  41137: 4,
  41139: 4,
  41141: 0,
  41142: 4,
  41143: 4,
  41144: 4,
  41146: 4,
  41149: 4,
  41156: 4,
  41159: 4,
  41160: 4,
  41164: 4,
  41166: 4,
  41168: 0,
  41169: 4,
  41171: 4,
  41173: 4,
  41174: 4,
  41175: 4,
  41179: 4,
  41180: 4,
  41181: 4,
  41183: 4,
  41189: 4,
  41201: 4,
  41203: 4,
  41204: 4,
  41214: 4,
  41216: 4,
  41219: 0,
  41222: 4,
  41224: 4,
  41226: 4,
  41230: 4,
  41231: 4,
  41232: 4,
  41234: 4,
  41238: 4,
  41240: 4,
  41250: 4,
  41254: 0,
  41255: 4,
  41256: 4,
  41257: 4,
  41260: 4,
  41262: 4,
  41263: 4,
  41264: 4,
  41265: 4,
  41267: 4,
  41268: 4,
  41271: 4,
  41274: 4,
  41301: 0,
  41307: 4,
  41310: 4,
  41311: 0,
  41313: 4,
  41314: 0,
  41317: 4,
  41332: 0,
  41333: 4,
  41338: 4,
  41339: 0,
  41342: 4,
  41344: 4,
  41347: 4,
  41348: 4,
  41351: 4,
  41352: 4,
  41360: 4,
  41362: 4,
  41364: 4,
  41365: 0,
  41366: 4,
  41367: 4,
  41368: 4,
  41385: 4,
  41386: 0,
  41390: 4,
  41397: 4,
  41408: 4,
  41410: 4,
  41413: 4,
  41419: 4,
  41421: 4,
  41422: 4,
  41425: 0,
  41426: 4,
  41433: 4,
  41451: 4,
  41459: 4,
  41464: 4,
  41465: 0,
  41472: 0,
  41477: 4,
  41501: 4,
  41502: 4,
  41503: 4,
  41512: 4,
  41513: 4,
  41514: 4,
  41517: 4,
  41519: 4,
  41520: 4,
  41522: 4,
  41524: 4,
  41526: 4,
  41527: 4,
  41528: 4,
  41531: 4,
  41534: 4,
  41535: 4,
  41537: 0,
  41538: 4,
  41539: 4,
  41540: 4,
  41542: 4,
  41543: 4,
  41544: 4,
  41546: 4,
  41547: 4,
  41548: 4,
  41549: 4,
  41553: 4,
  41554: 4,
  41555: 4,
  41557: 4,
  41558: 4,
  41559: 4,
  41560: 4,
  41561: 4,
  41562: 4,
  41563: 4,
  41564: 4,
  41566: 4,
  41567: 4,
  41568: 4,
  41571: 4,
  41572: 4,
  41601: 4,
  41602: 4,
  41603: 4,
  41604: 4,
  41605: 4,
  41606: 4,
  41607: 4,
  41612: 4,
  41615: 4,
  41616: 4,
  41619: 4,
  41621: 4,
  41622: 4,
  41630: 4,
  41631: 4,
  41632: 4,
  41635: 4,
  41636: 4,
  41640: 4,
  41642: 4,
  41643: 4,
  41645: 4,
  41647: 4,
  41649: 4,
  41650: 4,
  41651: 4,
  41653: 4,
  41655: 4,
  41659: 4,
  41660: 4,
  41663: 4,
  41666: 4,
  41667: 4,
  41669: 4,
  41701: 4,
  41702: 4,
  41712: 4,
  41713: 4,
  41714: 4,
  41719: 4,
  41721: 4,
  41722: 0,
  41723: 4,
  41725: 4,
  41727: 4,
  41729: 4,
  41730: 4,
  41731: 0,
  41735: 4,
  41736: 4,
  41739: 4,
  41740: 4,
  41743: 4,
  41745: 0,
  41746: 4,
  41747: 4,
  41749: 4,
  41751: 4,
  41754: 4,
  41759: 4,
  41760: 4,
  41762: 4,
  41763: 4,
  41764: 4,
  41766: 4,
  41772: 4,
  41773: 0,
  41774: 4,
  41775: 4,
  41776: 4,
  41777: 4,
  41778: 4,
  41804: 4,
  41810: 4,
  41812: 4,
  41815: 4,
  41817: 4,
  41819: 4,
  41821: 4,
  41822: 4,
  41824: 4,
  41825: 4,
  41826: 4,
  41828: 4,
  41831: 4,
  41832: 4,
  41833: 4,
  41834: 4,
  41835: 4,
  41836: 4,
  41837: 4,
  41838: 4,
  41839: 4,
  41840: 4,
  41843: 4,
  41844: 4,
  41845: 4,
  41847: 4,
  41848: 4,
  41849: 4,
  41855: 4,
  41858: 4,
  41859: 4,
  41861: 4,
  41862: 0,
  42001: 4,
  42002: 4,
  42003: 4,
  42020: 4,
  42021: 4,
  42022: 4,
  42023: 4,
  42024: 4,
  42025: 4,
  42027: 4,
  42028: 4,
  42029: 4,
  42031: 4,
  42032: 4,
  42033: 4,
  42035: 1,
  42036: 4,
  42037: 4,
  42038: 4,
  42039: 1,
  42040: 4,
  42041: 1,
  42044: 4,
  42045: 4,
  42047: 4,
  42048: 4,
  42049: 4,
  42050: 4,
  42051: 4,
  42053: 1,
  42054: 4,
  42055: 4,
  42056: 4,
  42058: 4,
  42060: 4,
  42061: 4,
  42063: 4,
  42064: 4,
  42066: 4,
  42069: 4,
  42070: 4,
  42071: 1,
  42076: 4,
  42078: 4,
  42079: 4,
  42081: 4,
  42082: 1,
  42083: 4,
  42084: 4,
  42085: 4,
  42086: 4,
  42087: 4,
  42088: 4,
  42101: 4,
  42102: 4,
  42103: 4,
  42104: 4,
  42120: 4,
  42122: 4,
  42123: 4,
  42124: 4,
  42127: 4,
  42128: 4,
  42129: 1,
  42130: 4,
  42131: 4,
  42133: 1,
  42134: 4,
  42135: 4,
  42140: 4,
  42141: 4,
  42142: 4,
  42150: 4,
  42151: 4,
  42152: 4,
  42153: 4,
  42154: 4,
  42156: 4,
  42157: 4,
  42159: 4,
  42160: 1,
  42163: 4,
  42164: 4,
  42166: 1,
  42167: 4,
  42170: 1,
  42171: 1,
  42201: 4,
  42202: 4,
  42203: 4,
  42204: 4,
  42206: 4,
  42207: 4,
  42209: 4,
  42210: 4,
  42211: 4,
  42214: 1,
  42215: 1,
  42216: 4,
  42217: 4,
  42219: 4,
  42220: 4,
  42221: 4,
  42223: 1,
  42232: 1,
  42234: 4,
  42235: 4,
  42236: 1,
  42240: 4,
  42241: 4,
  42251: 4,
  42252: 4,
  42254: 4,
  42256: 1,
  42257: 4,
  42259: 4,
  42261: 4,
  42262: 4,
  42265: 1,
  42266: 4,
  42267: 4,
  42270: 4,
  42273: 4,
  42274: 4,
  42275: 1,
  42276: 4,
  42280: 4,
  42283: 4,
  42285: 4,
  42286: 1,
  42287: 4,
  42288: 4,
  42301: 4,
  42302: 4,
  42303: 4,
  42304: 4,
  42320: 4,
  42321: 4,
  42322: 4,
  42323: 4,
  42324: 4,
  42325: 4,
  42326: 4,
  42327: 1,
  42328: 4,
  42330: 1,
  42332: 4,
  42333: 4,
  42334: 4,
  42337: 4,
  42338: 4,
  42339: 4,
  42343: 4,
  42344: 4,
  42345: 4,
  42347: 4,
  42348: 1,
  42349: 4,
  42350: 4,
  42351: 1,
  42352: 4,
  42354: 4,
  42355: 4,
  42356: 4,
  42361: 4,
  42364: 4,
  42366: 4,
  42367: 4,
  42368: 1,
  42369: 4,
  42370: 4,
  42371: 4,
  42372: 1,
  42374: 4,
  42375: 4,
  42376: 1,
  42377: 4,
  42378: 1,
  42402: 4,
  42403: 4,
  42404: 4,
  42406: 4,
  42408: 1,
  42409: 4,
  42410: 4,
  42411: 4,
  42413: 4,
  42419: 4,
  42420: 4,
  42431: 4,
  42436: 4,
  42437: 1,
  42440: 4,
  42441: 4,
  42442: 4,
  42444: 4,
  42445: 1,
  42450: 4,
  42451: 4,
  42452: 4,
  42453: 4,
  42455: 4,
  42456: 1,
  42457: 4,
  42458: 4,
  42459: 1,
  42460: 4,
  42461: 4,
  42462: 4,
  42463: 4,
  42464: 4,
  42501: 4,
  42502: 4,
  42503: 4,
  42516: 4,
  42518: 0,
  42519: 4,
  42528: 0,
  42533: 4,
  42539: 4,
  42541: 4,
  42544: 4,
  42553: 4,
  42558: 4,
  42564: 4,
  42565: 4,
  42566: 4,
  42567: 4,
  42602: 4,
  42603: 1,
  42629: 4,
  42631: 4,
  42633: 22,
  42634: 4,
  42635: 4,
  42638: 4,
  42642: 1,
  42647: 4,
  42649: 4,
  42653: 4,
  42701: 4,
  42702: 4,
  42711: 4,
  42712: 1,
  42713: 4,
  42715: 4,
  42716: 0,
  42717: 1,
  42718: 4,
  42719: 4,
  42720: 4,
  42721: 1,
  42722: 4,
  42724: 4,
  42726: 1,
  42728: 1,
  42729: 1,
  42731: 1,
  42732: 4,
  42733: 0,
  42735: 4,
  42740: 4,
  42741: 4,
  42742: 4,
  42743: 4,
  42746: 4,
  42748: 4,
  42749: 1,
  42753: 4,
  42754: 4,
  42755: 4,
  42757: 1,
  42758: 4,
  42759: 4,
  42762: 4,
  42764: 1,
  42765: 4,
  42776: 0,
  42782: 4,
  42783: 4,
  42784: 0,
  42786: 4,
  42788: 4,
  43001: 0,
  43002: 0,
  43003: 0,
  43004: 0,
  43005: 0,
  43006: 0,
  43007: 0,
  43008: 0,
  43009: 0,
  43010: 0,
  43011: 0,
  43013: 0,
  43014: 0,
  43015: 0,
  43016: 0,
  43017: 0,
  43018: 0,
  43019: 0,
  43021: 0,
  43022: 0,
  43023: 0,
  43025: 0,
  43026: 0,
  43027: 0,
  43028: 0,
  43029: 0,
  43030: 0,
  43031: 0,
  43032: 0,
  43033: 0,
  43035: 0,
  43036: 0,
  43037: 0,
  43040: 0,
  43041: 0,
  43044: 0,
  43045: 0,
  43046: 0,
  43047: 0,
  43048: 0,
  43050: 0,
  43054: 0,
  43055: 0,
  43056: 0,
  43058: 0,
  43060: 0,
  43061: 0,
  43062: 0,
  43064: 0,
  43065: 0,
  43066: 0,
  43067: 0,
  43068: 0,
  43069: 0,
  43070: 0,
  43071: 0,
  43072: 0,
  43073: 0,
  43074: 0,
  43076: 0,
  43077: 0,
  43078: 0,
  43080: 0,
  43081: 0,
  43082: 0,
  43083: 0,
  43084: 0,
  43085: 0,
  43086: 0,
  43093: 0,
  43098: 0,
  43101: 0,
  43102: 0,
  43103: 0,
  43105: 0,
  43106: 0,
  43107: 0,
  43109: 0,
  43110: 0,
  43111: 0,
  43112: 0,
  43113: 0,
  43115: 0,
  43116: 0,
  43117: 0,
  43119: 0,
  43123: 0,
  43125: 0,
  43126: 0,
  43127: 0,
  43128: 0,
  43130: 0,
  43135: 0,
  43136: 0,
  43137: 0,
  43138: 0,
  43140: 0,
  43142: 0,
  43143: 0,
  43144: 0,
  43145: 0,
  43146: 0,
  43147: 0,
  43148: 0,
  43149: 0,
  43150: 0,
  43151: 0,
  43152: 0,
  43153: 0,
  43154: 0,
  43155: 0,
  43156: 0,
  43157: 0,
  43158: 0,
  43160: 0,
  43162: 0,
  43163: 0,
  43164: 0,
  43194: 0,
  43195: 0,
  43196: 0,
  43198: 0,
  43199: 0,
  43201: 0,
  43202: 0,
  43203: 0,
  43204: 0,
  43205: 0,
  43206: 0,
  43207: 0,
  43209: 0,
  43210: 0,
  43211: 0,
  43212: 0,
  43213: 0,
  43214: 0,
  43215: 0,
  43216: 0,
  43217: 0,
  43218: 0,
  43219: 0,
  43220: 0,
  43221: 0,
  43222: 0,
  43223: 0,
  43224: 0,
  43226: 0,
  43227: 0,
  43228: 0,
  43229: 0,
  43230: 0,
  43231: 0,
  43232: 0,
  43234: 0,
  43235: 0,
  43236: 0,
  43240: 0,
  43251: 0,
  43260: 0,
  43265: 0,
  43266: 0,
  43268: 0,
  43270: 0,
  43271: 0,
  43272: 0,
  43279: 0,
  43287: 0,
  43291: 0,
  43299: 0,
  43301: 0,
  43302: 0,
  43306: 0,
  43307: 0,
  43310: 0,
  43311: 0,
  43314: 0,
  43315: 0,
  43316: 0,
  43317: 0,
  43318: 0,
  43319: 0,
  43320: 0,
  43321: 0,
  43322: 0,
  43323: 0,
  43324: 0,
  43325: 0,
  43326: 0,
  43330: 0,
  43331: 0,
  43332: 0,
  43333: 0,
  43334: 0,
  43335: 0,
  43336: 0,
  43337: 0,
  43338: 0,
  43340: 0,
  43341: 0,
  43342: 0,
  43343: 0,
  43344: 0,
  43345: 0,
  43346: 0,
  43347: 0,
  43348: 0,
  43349: 0,
  43350: 0,
  43351: 0,
  43356: 0,
  43357: 0,
  43358: 0,
  43359: 0,
  43360: 0,
  43402: 0,
  43403: 0,
  43406: 0,
  43407: 0,
  43408: 0,
  43410: 0,
  43412: 0,
  43413: 0,
  43414: 0,
  43416: 0,
  43420: 0,
  43430: 0,
  43431: 0,
  43432: 0,
  43433: 0,
  43434: 0,
  43435: 0,
  43436: 0,
  43437: 0,
  43438: 0,
  43439: 0,
  43440: 0,
  43441: 0,
  43442: 0,
  43443: 0,
  43445: 0,
  43446: 0,
  43447: 0,
  43449: 0,
  43450: 0,
  43451: 0,
  43452: 0,
  43456: 0,
  43457: 0,
  43458: 0,
  43460: 0,
  43462: 0,
  43463: 0,
  43464: 0,
  43465: 0,
  43466: 0,
  43467: 0,
  43468: 0,
  43469: 0,
  43501: 0,
  43502: 0,
  43504: 0,
  43505: 0,
  43506: 0,
  43510: 0,
  43511: 0,
  43512: 0,
  43515: 0,
  43516: 0,
  43517: 0,
  43518: 0,
  43519: 0,
  43520: 0,
  43521: 0,
  43522: 0,
  43523: 0,
  43524: 0,
  43525: 0,
  43526: 0,
  43527: 0,
  43528: 0,
  43529: 0,
  43530: 0,
  43531: 0,
  43532: 0,
  43533: 0,
  43534: 0,
  43535: 0,
  43536: 0,
  43537: 0,
  43540: 0,
  43541: 0,
  43542: 0,
  43543: 0,
  43545: 0,
  43547: 0,
  43548: 0,
  43549: 0,
  43550: 0,
  43551: 0,
  43552: 0,
  43553: 0,
  43554: 0,
  43555: 0,
  43556: 0,
  43557: 0,
  43558: 0,
  43560: 0,
  43565: 0,
  43566: 0,
  43567: 0,
  43569: 0,
  43570: 0,
  43571: 0,
  43601: 0,
  43602: 0,
  43603: 0,
  43604: 0,
  43605: 0,
  43606: 0,
  43607: 0,
  43608: 0,
  43609: 0,
  43610: 0,
  43611: 0,
  43612: 0,
  43613: 0,
  43614: 0,
  43615: 0,
  43616: 0,
  43617: 0,
  43618: 0,
  43619: 0,
  43620: 0,
  43623: 0,
  43624: 0,
  43635: 0,
  43652: 0,
  43654: 0,
  43656: 0,
  43657: 0,
  43659: 0,
  43660: 0,
  43661: 0,
  43666: 0,
  43667: 0,
  43681: 0,
  43682: 0,
  43697: 0,
  43699: 0,
  43701: 0,
  43702: 0,
  43711: 0,
  43713: 0,
  43716: 0,
  43717: 0,
  43718: 0,
  43719: 0,
  43720: 0,
  43721: 0,
  43722: 0,
  43723: 0,
  43724: 0,
  43725: 0,
  43727: 0,
  43728: 0,
  43730: 0,
  43731: 0,
  43732: 0,
  43733: 0,
  43734: 0,
  43735: 0,
  43736: 0,
  43738: 0,
  43739: 0,
  43740: 0,
  43746: 0,
  43747: 0,
  43748: 0,
  43749: 0,
  43750: 0,
  43752: 0,
  43754: 0,
  43755: 0,
  43756: 0,
  43757: 0,
  43758: 0,
  43759: 0,
  43760: 0,
  43761: 0,
  43762: 0,
  43764: 0,
  43766: 0,
  43767: 0,
  43768: 0,
  43771: 0,
  43772: 0,
  43773: 0,
  43777: 0,
  43778: 0,
  43779: 0,
  43780: 0,
  43782: 0,
  43783: 0,
  43786: 0,
  43787: 0,
  43788: 0,
  43789: 0,
  43791: 0,
  43793: 0,
  43802: 0,
  43803: 0,
  43804: 0,
  43805: 0,
  43811: 0,
  43812: 0,
  43821: 0,
  43822: 0,
  43824: 0,
  43828: 0,
  43830: 0,
  43832: 0,
  43836: 0,
  43837: 0,
  43840: 0,
  43842: 0,
  43843: 0,
  43844: 0,
  43845: 0,
  43901: 0,
  43902: 0,
  43903: 0,
  43905: 0,
  43906: 0,
  43907: 0,
  43908: 0,
  43909: 0,
  43910: 0,
  43912: 0,
  43913: 0,
  43914: 0,
  43915: 0,
  43916: 0,
  43917: 0,
  43920: 0,
  43925: 0,
  43926: 0,
  43927: 0,
  43928: 0,
  43930: 0,
  43931: 0,
  43932: 0,
  43933: 0,
  43934: 0,
  43935: 0,
  43937: 0,
  43938: 0,
  43939: 0,
  43940: 0,
  43941: 0,
  43942: 0,
  43943: 0,
  43944: 0,
  43945: 0,
  43946: 0,
  43947: 0,
  43948: 0,
  43950: 0,
  43951: 0,
  43952: 0,
  43953: 0,
  43961: 0,
  43962: 0,
  43963: 0,
  43964: 0,
  43967: 0,
  43968: 0,
  43970: 0,
  43971: 0,
  43972: 0,
  43973: 0,
  43974: 0,
  43976: 0,
  43977: 0,
  43981: 0,
  43983: 0,
  43984: 0,
  43985: 0,
  43986: 0,
  43988: 0,
  44001: 0,
  44003: 0,
  44004: 0,
  44005: 0,
  44010: 0,
  44011: 0,
  44012: 0,
  44017: 0,
  44021: 0,
  44022: 0,
  44023: 0,
  44024: 0,
  44026: 0,
  44028: 0,
  44030: 0,
  44032: 0,
  44033: 0,
  44035: 0,
  44036: 0,
  44039: 0,
  44040: 0,
  44041: 0,
  44044: 0,
  44045: 0,
  44046: 0,
  44047: 0,
  44048: 0,
  44049: 0,
  44050: 0,
  44052: 0,
  44053: 0,
  44054: 0,
  44055: 0,
  44056: 0,
  44057: 0,
  44060: 0,
  44061: 0,
  44062: 0,
  44064: 0,
  44065: 0,
  44067: 0,
  44068: 0,
  44070: 0,
  44072: 0,
  44073: 0,
  44074: 0,
  44076: 0,
  44077: 0,
  44080: 0,
  44081: 0,
  44082: 0,
  44084: 0,
  44085: 0,
  44086: 0,
  44087: 0,
  44088: 0,
  44089: 0,
  44090: 0,
  44092: 0,
  44093: 0,
  44094: 0,
  44095: 0,
  44096: 0,
  44097: 0,
  44099: 0,
  44101: 0,
  44102: 0,
  44103: 0,
  44104: 0,
  44105: 0,
  44106: 0,
  44107: 0,
  44108: 0,
  44109: 0,
  44110: 0,
  44111: 0,
  44112: 0,
  44113: 0,
  44114: 0,
  44115: 0,
  44116: 0,
  44117: 0,
  44118: 0,
  44119: 0,
  44120: 0,
  44121: 0,
  44122: 0,
  44124: 0,
  44125: 0,
  44126: 0,
  44127: 0,
  44128: 0,
  44129: 0,
  44130: 0,
  44131: 0,
  44132: 0,
  44133: 0,
  44134: 0,
  44135: 0,
  44136: 0,
  44137: 0,
  44138: 0,
  44139: 0,
  44140: 0,
  44141: 0,
  44142: 0,
  44143: 0,
  44144: 0,
  44145: 0,
  44146: 0,
  44147: 0,
  44149: 0,
  44178: 0,
  44181: 0,
  44185: 0,
  44188: 0,
  44189: 0,
  44190: 0,
  44191: 0,
  44192: 0,
  44193: 0,
  44194: 0,
  44195: 0,
  44197: 0,
  44198: 0,
  44199: 0,
  44201: 0,
  44202: 0,
  44203: 0,
  44210: 0,
  44211: 0,
  44212: 0,
  44214: 0,
  44215: 0,
  44216: 0,
  44217: 0,
  44221: 0,
  44222: 0,
  44223: 0,
  44224: 0,
  44230: 0,
  44231: 0,
  44232: 0,
  44233: 0,
  44234: 0,
  44235: 0,
  44236: 0,
  44237: 0,
  44240: 0,
  44241: 0,
  44242: 0,
  44243: 0,
  44250: 0,
  44251: 0,
  44253: 0,
  44254: 0,
  44255: 0,
  44256: 0,
  44258: 0,
  44260: 0,
  44262: 0,
  44264: 0,
  44265: 0,
  44266: 0,
  44270: 0,
  44272: 0,
  44273: 0,
  44274: 0,
  44275: 0,
  44276: 0,
  44278: 0,
  44280: 0,
  44281: 0,
  44282: 0,
  44285: 0,
  44286: 0,
  44287: 0,
  44288: 0,
  44301: 0,
  44302: 0,
  44303: 0,
  44304: 0,
  44305: 0,
  44306: 0,
  44307: 0,
  44308: 0,
  44309: 0,
  44310: 0,
  44311: 0,
  44312: 0,
  44313: 0,
  44314: 0,
  44315: 0,
  44316: 0,
  44317: 0,
  44319: 0,
  44320: 0,
  44321: 0,
  44322: 0,
  44325: 0,
  44326: 0,
  44328: 0,
  44333: 0,
  44334: 0,
  44372: 0,
  44393: 0,
  44396: 0,
  44398: 0,
  44399: 0,
  44401: 0,
  44402: 0,
  44403: 0,
  44404: 0,
  44405: 0,
  44406: 0,
  44408: 0,
  44410: 0,
  44411: 0,
  44412: 0,
  44413: 0,
  44415: 0,
  44416: 0,
  44417: 0,
  44418: 0,
  44420: 0,
  44422: 0,
  44423: 0,
  44424: 0,
  44425: 0,
  44427: 0,
  44428: 0,
  44429: 0,
  44430: 0,
  44431: 0,
  44432: 0,
  44436: 0,
  44437: 0,
  44438: 0,
  44439: 0,
  44440: 0,
  44441: 0,
  44442: 0,
  44443: 0,
  44444: 0,
  44445: 0,
  44446: 0,
  44449: 0,
  44450: 0,
  44451: 0,
  44452: 0,
  44453: 0,
  44454: 0,
  44455: 0,
  44460: 0,
  44470: 0,
  44471: 0,
  44473: 0,
  44481: 0,
  44482: 0,
  44483: 0,
  44484: 0,
  44485: 0,
  44486: 0,
  44487: 0,
  44488: 0,
  44490: 0,
  44491: 0,
  44492: 0,
  44493: 0,
  44501: 0,
  44502: 0,
  44503: 0,
  44504: 0,
  44505: 0,
  44506: 0,
  44507: 0,
  44509: 0,
  44510: 0,
  44511: 0,
  44512: 0,
  44513: 0,
  44514: 0,
  44515: 0,
  44555: 0,
  44598: 0,
  44599: 0,
  44601: 0,
  44606: 0,
  44607: 0,
  44608: 0,
  44609: 0,
  44610: 0,
  44611: 0,
  44612: 0,
  44613: 0,
  44614: 0,
  44615: 0,
  44617: 0,
  44618: 0,
  44619: 0,
  44620: 0,
  44621: 0,
  44622: 0,
  44624: 0,
  44625: 0,
  44626: 0,
  44627: 0,
  44628: 0,
  44629: 0,
  44630: 0,
  44631: 0,
  44632: 0,
  44633: 0,
  44634: 0,
  44636: 0,
  44637: 0,
  44638: 0,
  44639: 0,
  44640: 0,
  44641: 0,
  44643: 0,
  44644: 0,
  44645: 0,
  44646: 0,
  44647: 0,
  44648: 0,
  44650: 0,
  44651: 0,
  44652: 0,
  44653: 0,
  44654: 0,
  44656: 0,
  44657: 0,
  44659: 0,
  44660: 0,
  44661: 0,
  44662: 0,
  44663: 0,
  44665: 0,
  44666: 0,
  44667: 0,
  44669: 0,
  44670: 0,
  44671: 0,
  44672: 0,
  44675: 0,
  44676: 0,
  44677: 0,
  44678: 0,
  44679: 0,
  44680: 0,
  44681: 0,
  44682: 0,
  44683: 0,
  44685: 0,
  44687: 0,
  44688: 0,
  44689: 0,
  44690: 0,
  44691: 0,
  44693: 0,
  44695: 0,
  44697: 0,
  44699: 0,
  44701: 0,
  44702: 0,
  44703: 0,
  44704: 0,
  44705: 0,
  44706: 0,
  44707: 0,
  44708: 0,
  44709: 0,
  44710: 0,
  44711: 0,
  44712: 0,
  44714: 0,
  44718: 0,
  44720: 0,
  44721: 0,
  44730: 0,
  44735: 0,
  44750: 0,
  44760: 0,
  44767: 0,
  44798: 0,
  44799: 0,
  44802: 0,
  44804: 0,
  44805: 0,
  44807: 0,
  44809: 0,
  44811: 0,
  44813: 0,
  44814: 0,
  44815: 0,
  44816: 0,
  44817: 0,
  44818: 0,
  44820: 0,
  44822: 0,
  44824: 0,
  44825: 0,
  44826: 0,
  44827: 0,
  44828: 0,
  44830: 0,
  44833: 0,
  44836: 0,
  44837: 0,
  44838: 0,
  44839: 0,
  44840: 0,
  44841: 0,
  44842: 0,
  44843: 0,
  44844: 0,
  44845: 0,
  44846: 0,
  44847: 0,
  44848: 0,
  44849: 0,
  44850: 0,
  44851: 0,
  44853: 0,
  44854: 0,
  44855: 0,
  44856: 0,
  44857: 0,
  44859: 0,
  44860: 0,
  44861: 0,
  44862: 0,
  44864: 0,
  44865: 0,
  44866: 0,
  44867: 0,
  44870: 0,
  44871: 0,
  44874: 0,
  44875: 0,
  44878: 0,
  44880: 0,
  44881: 0,
  44882: 0,
  44883: 0,
  44887: 0,
  44888: 0,
  44889: 0,
  44890: 0,
  44901: 0,
  44902: 0,
  44903: 0,
  44904: 0,
  44905: 0,
  44906: 0,
  44907: 0,
  44999: 0,
  45001: 0,
  45002: 0,
  45003: 0,
  45004: 0,
  45005: 0,
  45011: 0,
  45012: 0,
  45013: 0,
  45014: 0,
  45015: 0,
  45018: 0,
  45025: 0,
  45026: 0,
  45030: 0,
  45032: 0,
  45033: 0,
  45034: 0,
  45036: 0,
  45039: 0,
  45040: 0,
  45041: 0,
  45042: 0,
  45043: 0,
  45044: 0,
  45050: 0,
  45051: 0,
  45052: 0,
  45053: 0,
  45054: 0,
  45055: 0,
  45056: 0,
  45061: 0,
  45062: 0,
  45063: 0,
  45064: 0,
  45065: 0,
  45066: 0,
  45067: 0,
  45068: 0,
  45069: 0,
  45070: 0,
  45071: 0,
  45073: 0,
  45099: 0,
  45101: 0,
  45102: 0,
  45103: 0,
  45105: 0,
  45106: 0,
  45107: 0,
  45110: 0,
  45111: 0,
  45112: 0,
  45113: 0,
  45114: 0,
  45115: 0,
  45118: 0,
  45119: 0,
  45120: 0,
  45121: 0,
  45122: 0,
  45123: 0,
  45130: 0,
  45131: 0,
  45132: 0,
  45133: 0,
  45135: 0,
  45138: 0,
  45140: 0,
  45142: 0,
  45144: 0,
  45145: 0,
  45146: 0,
  45147: 0,
  45148: 0,
  45150: 0,
  45152: 0,
  45153: 0,
  45154: 0,
  45155: 0,
  45156: 0,
  45157: 0,
  45158: 0,
  45159: 0,
  45160: 0,
  45162: 0,
  45164: 0,
  45165: 0,
  45166: 0,
  45167: 0,
  45168: 0,
  45169: 0,
  45171: 0,
  45172: 0,
  45174: 0,
  45176: 0,
  45177: 0,
  45201: 0,
  45202: 0,
  45203: 0,
  45204: 0,
  45205: 0,
  45206: 0,
  45207: 0,
  45208: 0,
  45209: 0,
  45210: 0,
  45211: 0,
  45212: 0,
  45213: 0,
  45214: 0,
  45215: 0,
  45216: 0,
  45217: 0,
  45218: 0,
  45219: 0,
  45220: 0,
  45221: 0,
  45222: 0,
  45223: 0,
  45224: 0,
  45225: 0,
  45226: 0,
  45227: 0,
  45228: 0,
  45229: 0,
  45230: 0,
  45231: 0,
  45232: 0,
  45233: 0,
  45234: 0,
  45235: 0,
  45236: 0,
  45237: 0,
  45238: 0,
  45239: 0,
  45240: 0,
  45241: 0,
  45242: 0,
  45243: 0,
  45244: 0,
  45245: 0,
  45246: 0,
  45247: 0,
  45248: 0,
  45249: 0,
  45250: 0,
  45251: 0,
  45252: 0,
  45253: 0,
  45254: 0,
  45255: 0,
  45258: 0,
  45262: 0,
  45263: 0,
  45264: 0,
  45267: 0,
  45268: 0,
  45269: 0,
  45270: 0,
  45271: 0,
  45273: 0,
  45274: 0,
  45275: 0,
  45277: 0,
  45280: 0,
  45296: 0,
  45298: 0,
  45299: 0,
  45301: 0,
  45302: 0,
  45303: 0,
  45304: 0,
  45305: 0,
  45306: 0,
  45307: 0,
  45308: 0,
  45309: 0,
  45310: 0,
  45311: 0,
  45312: 0,
  45314: 0,
  45315: 0,
  45316: 0,
  45317: 0,
  45318: 0,
  45319: 0,
  45320: 0,
  45321: 0,
  45322: 0,
  45323: 0,
  45324: 0,
  45325: 0,
  45326: 0,
  45327: 0,
  45328: 0,
  45330: 0,
  45331: 0,
  45332: 0,
  45333: 0,
  45334: 0,
  45335: 0,
  45336: 0,
  45337: 0,
  45338: 0,
  45339: 0,
  45340: 0,
  45341: 0,
  45342: 0,
  45343: 0,
  45344: 0,
  45345: 0,
  45346: 0,
  45347: 0,
  45348: 0,
  45349: 0,
  45350: 0,
  45351: 0,
  45352: 0,
  45353: 0,
  45354: 0,
  45356: 0,
  45358: 0,
  45359: 0,
  45360: 0,
  45361: 0,
  45362: 0,
  45363: 0,
  45365: 0,
  45367: 0,
  45368: 0,
  45369: 0,
  45370: 0,
  45371: 0,
  45372: 0,
  45373: 0,
  45374: 0,
  45377: 0,
  45378: 0,
  45380: 0,
  45381: 0,
  45382: 0,
  45383: 0,
  45384: 0,
  45385: 0,
  45387: 0,
  45388: 0,
  45389: 0,
  45390: 5,
  45400: 0,
  45401: 0,
  45402: 0,
  45403: 0,
  45404: 0,
  45405: 0,
  45406: 0,
  45407: 0,
  45408: 0,
  45409: 0,
  45410: 0,
  45412: 0,
  45413: 0,
  45414: 0,
  45415: 0,
  45416: 0,
  45417: 0,
  45418: 0,
  45419: 0,
  45420: 0,
  45422: 0,
  45423: 0,
  45424: 0,
  45426: 0,
  45427: 0,
  45428: 0,
  45429: 0,
  45430: 0,
  45431: 0,
  45432: 0,
  45433: 0,
  45434: 0,
  45435: 0,
  45437: 0,
  45439: 0,
  45440: 0,
  45441: 0,
  45448: 0,
  45449: 0,
  45454: 0,
  45458: 0,
  45459: 0,
  45463: 0,
  45469: 0,
  45470: 0,
  45475: 0,
  45479: 0,
  45481: 0,
  45482: 0,
  45490: 0,
  45501: 0,
  45502: 0,
  45503: 0,
  45504: 0,
  45505: 0,
  45506: 0,
  45601: 0,
  45612: 0,
  45613: 0,
  45614: 0,
  45616: 0,
  45617: 0,
  45618: 0,
  45619: 0,
  45620: 0,
  45621: 0,
  45622: 0,
  45623: 0,
  45624: 0,
  45628: 0,
  45629: 0,
  45630: 0,
  45631: 0,
  45633: 0,
  45634: 0,
  45636: 0,
  45638: 0,
  45640: 0,
  45642: 0,
  45643: 0,
  45644: 0,
  45645: 0,
  45646: 0,
  45647: 0,
  45648: 0,
  45650: 0,
  45651: 0,
  45652: 0,
  45653: 0,
  45654: 0,
  45656: 0,
  45657: 0,
  45658: 0,
  45659: 0,
  45660: 0,
  45661: 0,
  45662: 0,
  45663: 0,
  45669: 0,
  45671: 0,
  45672: 0,
  45673: 0,
  45674: 0,
  45675: 0,
  45677: 0,
  45678: 0,
  45679: 0,
  45680: 0,
  45681: 0,
  45682: 0,
  45683: 0,
  45684: 0,
  45685: 0,
  45686: 0,
  45687: 0,
  45688: 0,
  45690: 0,
  45692: 0,
  45693: 0,
  45694: 0,
  45695: 0,
  45696: 0,
  45697: 0,
  45698: 0,
  45699: 0,
  45701: 0,
  45710: 0,
  45711: 0,
  45712: 0,
  45713: 0,
  45714: 0,
  45715: 0,
  45716: 0,
  45717: 0,
  45719: 0,
  45720: 0,
  45721: 0,
  45723: 0,
  45724: 0,
  45727: 0,
  45729: 0,
  45732: 0,
  45734: 0,
  45735: 0,
  45739: 0,
  45740: 0,
  45741: 0,
  45742: 0,
  45743: 0,
  45744: 0,
  45745: 0,
  45746: 0,
  45750: 0,
  45760: 0,
  45761: 0,
  45764: 0,
  45766: 0,
  45767: 0,
  45768: 0,
  45769: 0,
  45770: 0,
  45771: 0,
  45772: 0,
  45773: 0,
  45775: 0,
  45776: 0,
  45777: 0,
  45778: 0,
  45779: 0,
  45780: 0,
  45782: 0,
  45783: 0,
  45784: 0,
  45786: 0,
  45787: 0,
  45788: 0,
  45789: 0,
  45801: 0,
  45802: 0,
  45804: 0,
  45805: 0,
  45806: 0,
  45807: 0,
  45808: 0,
  45809: 0,
  45810: 0,
  45812: 0,
  45813: 0,
  45814: 0,
  45815: 0,
  45816: 0,
  45817: 0,
  45819: 0,
  45820: 0,
  45821: 0,
  45822: 0,
  45826: 0,
  45827: 0,
  45828: 0,
  45830: 0,
  45831: 0,
  45832: 0,
  45833: 0,
  45835: 0,
  45836: 0,
  45837: 0,
  45838: 0,
  45839: 0,
  45840: 0,
  45841: 0,
  45843: 0,
  45844: 0,
  45845: 0,
  45846: 0,
  45848: 0,
  45849: 0,
  45850: 0,
  45851: 0,
  45853: 0,
  45854: 0,
  45855: 0,
  45856: 0,
  45858: 0,
  45859: 0,
  45860: 0,
  45861: 0,
  45862: 0,
  45863: 0,
  45864: 0,
  45865: 0,
  45866: 0,
  45867: 0,
  45868: 0,
  45869: 0,
  45870: 0,
  45871: 0,
  45872: 0,
  45873: 0,
  45874: 0,
  45875: 0,
  45876: 0,
  45877: 0,
  45879: 0,
  45880: 0,
  45881: 0,
  45882: 0,
  45883: 0,
  45884: 0,
  45885: 0,
  45886: 0,
  45887: 0,
  45888: 0,
  45889: 0,
  45890: 0,
  45891: 0,
  45893: 0,
  45894: 0,
  45895: 0,
  45896: 0,
  45897: 0,
  45898: 0,
  45899: 0,
  45944: 0,
  45950: 0,
  45999: 0,
  46001: 5,
  46011: 5,
  46012: 5,
  46013: 5,
  46014: 5,
  46015: 5,
  46016: 5,
  46017: 5,
  46018: 5,
  46030: 5,
  46031: 5,
  46032: 5,
  46033: 5,
  46034: 5,
  46035: 5,
  46036: 0,
  46037: 5,
  46038: 5,
  46039: 5,
  46040: 0,
  46041: 5,
  46044: 5,
  46045: 5,
  46047: 5,
  46048: 5,
  46049: 5,
  46050: 5,
  46051: 5,
  46052: 5,
  46055: 0,
  46056: 5,
  46057: 5,
  46058: 5,
  46060: 5,
  46061: 5,
  46062: 5,
  46063: 5,
  46064: 0,
  46065: 0,
  46067: 5,
  46068: 5,
  46069: 0,
  46070: 5,
  46071: 5,
  46072: 5,
  46074: 5,
  46075: 5,
  46076: 5,
  46077: 5,
  46082: 5,
  46085: 5,
  46102: 5,
  46103: 5,
  46104: 5,
  46105: 5,
  46106: 5,
  46107: 5,
  46110: 5,
  46111: 5,
  46112: 0,
  46113: 0,
  46115: 5,
  46117: 5,
  46118: 5,
  46120: 5,
  46121: 0,
  46122: 5,
  46123: 5,
  46124: 0,
  46125: 5,
  46126: 5,
  46127: 5,
  46128: 5,
  46129: 5,
  46130: 0,
  46131: 5,
  46133: 0,
  46135: 5,
  46140: 5,
  46142: 5,
  46143: 5,
  46144: 5,
  46146: 5,
  46147: 5,
  46148: 0,
  46149: 5,
  46150: 5,
  46151: 5,
  46154: 5,
  46155: 5,
  46156: 5,
  46157: 5,
  46158: 0,
  46160: 0,
  46161: 5,
  46162: 5,
  46163: 5,
  46164: 0,
  46165: 5,
  46166: 5,
  46167: 5,
  46168: 5,
  46170: 5,
  46171: 5,
  46172: 5,
  46173: 5,
  46175: 5,
  46176: 5,
  46180: 0,
  46181: 0,
  46182: 5,
  46183: 5,
  46184: 5,
  46186: 0,
  46201: 5,
  46202: 5,
  46203: 5,
  46204: 5,
  46205: 5,
  46206: 5,
  46207: 5,
  46208: 5,
  46209: 5,
  46211: 5,
  46214: 5,
  46216: 5,
  46217: 5,
  46218: 5,
  46219: 5,
  46220: 5,
  46221: 5,
  46222: 5,
  46223: 5,
  46224: 5,
  46225: 5,
  46226: 5,
  46227: 5,
  46228: 5,
  46229: 5,
  46230: 5,
  46231: 5,
  46234: 5,
  46235: 5,
  46236: 5,
  46237: 5,
  46239: 5,
  46240: 5,
  46241: 5,
  46242: 5,
  46244: 5,
  46247: 5,
  46249: 5,
  46250: 5,
  46251: 5,
  46253: 5,
  46254: 5,
  46255: 5,
  46256: 5,
  46259: 5,
  46260: 5,
  46262: 5,
  46266: 5,
  46268: 5,
  46274: 5,
  46275: 5,
  46277: 5,
  46278: 5,
  46280: 5,
  46282: 5,
  46283: 5,
  46285: 5,
  46290: 5,
  46291: 5,
  46295: 5,
  46296: 5,
  46298: 5,
  46301: 5,
  46302: 5,
  46303: 5,
  46304: 5,
  46307: 5,
  46308: 5,
  46310: 5,
  46311: 5,
  46312: 5,
  46319: 5,
  46320: 5,
  46321: 5,
  46322: 5,
  46323: 5,
  46324: 5,
  46325: 5,
  46327: 5,
  46340: 5,
  46341: 1,
  46342: 5,
  46345: 5,
  46346: 5,
  46347: 5,
  46348: 5,
  46349: 5,
  46350: 5,
  46352: 5,
  46355: 5,
  46356: 5,
  46360: 5,
  46361: 5,
  46365: 5,
  46366: 11,
  46368: 5,
  46371: 5,
  46372: 5,
  46373: 5,
  46374: 1,
  46375: 5,
  46376: 5,
  46377: 5,
  46379: 5,
  46380: 5,
  46381: 5,
  46382: 5,
  46383: 5,
  46384: 5,
  46385: 5,
  46390: 5,
  46391: 5,
  46392: 5,
  46393: 5,
  46394: 5,
  46401: 5,
  46402: 5,
  46403: 5,
  46404: 5,
  46405: 5,
  46407: 5,
  46409: 5,
  46410: 5,
  46411: 5,
  46501: 5,
  46502: 5,
  46504: 5,
  46506: 0,
  46507: 5,
  46508: 5,
  46510: 5,
  46511: 0,
  46513: 5,
  46514: 5,
  46515: 5,
  46516: 5,
  46517: 5,
  46524: 5,
  46526: 5,
  46527: 5,
  46528: 5,
  46530: 5,
  46531: 11,
  46532: 1,
  46534: 11,
  46536: 5,
  46537: 5,
  46538: 5,
  46539: 5,
  46540: 5,
  46542: 5,
  46543: 5,
  46544: 5,
  46545: 5,
  46546: 5,
  46550: 0,
  46552: 1,
  46553: 5,
  46554: 5,
  46555: 5,
  46556: 5,
  46561: 5,
  46562: 0,
  46563: 5,
  46565: 5,
  46566: 5,
  46567: 5,
  46570: 5,
  46571: 5,
  46572: 5,
  46573: 5,
  46574: 0,
  46580: 5,
  46581: 5,
  46582: 5,
  46590: 5,
  46595: 5,
  46601: 5,
  46604: 5,
  46612: 5,
  46613: 5,
  46614: 5,
  46615: 5,
  46616: 5,
  46617: 5,
  46619: 5,
  46620: 5,
  46624: 5,
  46626: 5,
  46628: 5,
  46629: 5,
  46634: 5,
  46635: 5,
  46637: 5,
  46660: 5,
  46680: 5,
  46699: 5,
  46701: 5,
  46702: 5,
  46703: 5,
  46704: 5,
  46705: 0,
  46706: 5,
  46710: 5,
  46711: 5,
  46713: 5,
  46714: 5,
  46720: 5,
  46721: 5,
  46723: 0,
  46725: 0,
  46730: 5,
  46731: 5,
  46732: 0,
  46733: 5,
  46737: 5,
  46738: 5,
  46740: 5,
  46741: 5,
  46742: 5,
  46743: 5,
  46745: 5,
  46746: 5,
  46747: 0,
  46748: 5,
  46750: 5,
  46755: 5,
  46759: 5,
  46760: 5,
  46761: 0,
  46763: 5,
  46764: 5,
  46765: 5,
  46766: 5,
  46767: 0,
  46769: 5,
  46770: 0,
  46771: 5,
  46772: 5,
  46773: 5,
  46774: 5,
  46776: 0,
  46777: 5,
  46778: 5,
  46779: 5,
  46780: 5,
  46781: 5,
  46782: 5,
  46783: 0,
  46784: 5,
  46785: 5,
  46786: 5,
  46787: 5,
  46788: 0,
  46789: 5,
  46791: 5,
  46792: 0,
  46793: 5,
  46794: 5,
  46795: 5,
  46796: 5,
  46797: 5,
  46798: 5,
  46799: 5,
  46801: 5,
  46802: 5,
  46803: 5,
  46804: 5,
  46805: 5,
  46806: 5,
  46807: 5,
  46808: 5,
  46809: 5,
  46814: 5,
  46815: 5,
  46816: 5,
  46818: 5,
  46819: 5,
  46825: 5,
  46835: 5,
  46845: 5,
  46850: 5,
  46851: 5,
  46852: 5,
  46853: 5,
  46854: 5,
  46855: 5,
  46856: 5,
  46857: 5,
  46858: 5,
  46859: 5,
  46860: 5,
  46861: 5,
  46862: 5,
  46863: 5,
  46864: 5,
  46865: 5,
  46866: 5,
  46867: 5,
  46868: 5,
  46869: 5,
  46885: 5,
  46895: 5,
  46896: 5,
  46897: 5,
  46898: 5,
  46899: 5,
  46901: 5,
  46902: 5,
  46903: 5,
  46904: 5,
  46910: 0,
  46911: 5,
  46912: 5,
  46913: 5,
  46914: 5,
  46915: 5,
  46916: 5,
  46917: 5,
  46919: 0,
  46920: 5,
  46921: 5,
  46922: 5,
  46923: 5,
  46926: 5,
  46928: 5,
  46929: 0,
  46930: 5,
  46931: 5,
  46932: 5,
  46933: 5,
  46935: 5,
  46936: 5,
  46937: 5,
  46938: 5,
  46939: 5,
  46940: 0,
  46941: 5,
  46942: 5,
  46943: 5,
  46945: 5,
  46946: 5,
  46947: 5,
  46950: 0,
  46951: 5,
  46952: 5,
  46953: 5,
  46957: 5,
  46958: 5,
  46959: 5,
  46960: 0,
  46961: 5,
  46962: 5,
  46965: 5,
  46967: 5,
  46968: 11,
  46970: 0,
  46971: 5,
  46974: 5,
  46975: 5,
  46977: 5,
  46978: 5,
  46979: 5,
  46980: 5,
  46982: 0,
  46984: 5,
  46985: 12,
  46986: 5,
  46987: 5,
  46988: 5,
  46989: 5,
  46990: 5,
  46991: 0,
  46992: 5,
  46994: 5,
  46995: 5,
  46996: 12,
  46998: 5,
  47001: 0,
  47003: 5,
  47006: 0,
  47010: 5,
  47011: 13,
  47012: 5,
  47016: 5,
  47017: 5,
  47018: 0,
  47019: 13,
  47020: 13,
  47021: 5,
  47022: 5,
  47023: 5,
  47024: 5,
  47025: 5,
  47030: 5,
  47031: 5,
  47032: 5,
  47033: 5,
  47034: 5,
  47035: 5,
  47036: 5,
  47037: 5,
  47038: 13,
  47039: 5,
  47040: 0,
  47041: 0,
  47042: 5,
  47043: 13,
  47060: 0,
  47102: 5,
  47104: 5,
  47106: 0,
  47107: 5,
  47108: 5,
  47110: 5,
  47111: 5,
  47112: 5,
  47114: 5,
  47115: 5,
  47116: 14,
  47117: 5,
  47118: 0,
  47119: 5,
  47120: 5,
  47122: 0,
  47123: 14,
  47124: 5,
  47125: 0,
  47126: 5,
  47129: 5,
  47130: 5,
  47131: 5,
  47132: 5,
  47133: 5,
  47134: 5,
  47135: 5,
  47136: 5,
  47137: 14,
  47138: 0,
  47139: 5,
  47140: 0,
  47141: 5,
  47142: 5,
  47143: 5,
  47144: 5,
  47145: 14,
  47146: 5,
  47147: 0,
  47150: 5,
  47151: 5,
  47160: 5,
  47161: 5,
  47162: 5,
  47163: 5,
  47164: 5,
  47165: 5,
  47166: 5,
  47167: 5,
  47170: 0,
  47172: 5,
  47174: 14,
  47175: 14,
  47177: 0,
  47190: 5,
  47199: 5,
  47201: 5,
  47202: 5,
  47203: 5,
  47220: 5,
  47223: 5,
  47224: 0,
  47225: 5,
  47226: 5,
  47227: 5,
  47228: 5,
  47229: 5,
  47230: 0,
  47231: 5,
  47232: 0,
  47234: 5,
  47235: 0,
  47236: 5,
  47240: 5,
  47243: 5,
  47244: 0,
  47245: 5,
  47246: 5,
  47247: 5,
  47249: 5,
  47250: 0,
  47260: 5,
  47261: 5,
  47263: 5,
  47264: 0,
  47265: 5,
  47270: 5,
  47272: 0,
  47273: 5,
  47274: 5,
  47280: 5,
  47281: 0,
  47282: 5,
  47283: 5,
  47302: 5,
  47303: 5,
  47304: 5,
  47305: 5,
  47306: 5,
  47307: 5,
  47308: 5,
  47320: 5,
  47322: 5,
  47324: 5,
  47325: 0,
  47326: 5,
  47327: 5,
  47330: 5,
  47331: 5,
  47334: 5,
  47335: 5,
  47336: 0,
  47337: 5,
  47338: 5,
  47339: 5,
  47340: 5,
  47341: 5,
  47342: 5,
  47344: 5,
  47345: 5,
  47346: 5,
  47348: 5,
  47351: 5,
  47352: 0,
  47353: 5,
  47354: 0,
  47355: 5,
  47356: 5,
  47357: 5,
  47358: 5,
  47359: 0,
  47360: 5,
  47361: 5,
  47362: 5,
  47366: 5,
  47367: 5,
  47368: 0,
  47369: 5,
  47370: 5,
  47371: 5,
  47373: 0,
  47374: 5,
  47375: 5,
  47380: 5,
  47381: 5,
  47382: 5,
  47383: 5,
  47384: 0,
  47385: 5,
  47386: 5,
  47387: 5,
  47388: 5,
  47390: 5,
  47392: 5,
  47393: 5,
  47394: 5,
  47396: 5,
  47401: 5,
  47402: 5,
  47403: 5,
  47404: 5,
  47405: 5,
  47406: 5,
  47407: 5,
  47408: 5,
  47420: 5,
  47421: 5,
  47424: 5,
  47426: 5,
  47427: 5,
  47429: 5,
  47430: 5,
  47431: 5,
  47432: 0,
  47433: 0,
  47434: 5,
  47435: 5,
  47436: 0,
  47437: 5,
  47438: 0,
  47439: 5,
  47441: 5,
  47443: 5,
  47445: 5,
  47446: 5,
  47448: 0,
  47449: 5,
  47451: 5,
  47452: 5,
  47453: 5,
  47454: 5,
  47455: 5,
  47456: 0,
  47457: 15,
  47458: 5,
  47459: 5,
  47460: 5,
  47462: 5,
  47463: 5,
  47464: 5,
  47465: 5,
  47467: 5,
  47468: 0,
  47469: 5,
  47470: 5,
  47471: 5,
  47490: 5,
  47501: 15,
  47512: 15,
  47513: 0,
  47514: 16,
  47515: 16,
  47516: 15,
  47519: 15,
  47520: 16,
  47521: 15,
  47522: 15,
  47523: 1,
  47524: 15,
  47525: 16,
  47527: 15,
  47528: 15,
  47529: 15,
  47531: 5,
  47532: 0,
  47535: 15,
  47536: 5,
  47537: 1,
  47541: 15,
  47542: 15,
  47545: 15,
  47546: 15,
  47547: 15,
  47549: 15,
  47550: 5,
  47551: 16,
  47552: 5,
  47553: 0,
  47556: 5,
  47557: 15,
  47558: 15,
  47561: 15,
  47562: 15,
  47564: 17,
  47567: 17,
  47568: 15,
  47573: 15,
  47574: 16,
  47575: 15,
  47576: 16,
  47577: 1,
  47578: 15,
  47579: 5,
  47580: 15,
  47581: 15,
  47584: 17,
  47585: 17,
  47586: 16,
  47588: 16,
  47590: 17,
  47591: 15,
  47596: 15,
  47597: 15,
  47598: 17,
  47601: 1,
  47610: 5,
  47611: 5,
  47612: 5,
  47613: 5,
  47614: 5,
  47615: 5,
  47616: 5,
  47617: 5,
  47618: 5,
  47619: 5,
  47620: 5,
  47629: 5,
  47630: 5,
  47631: 5,
  47633: 5,
  47634: 5,
  47635: 5,
  47637: 5,
  47638: 5,
  47639: 1,
  47640: 1,
  47647: 5,
  47648: 5,
  47649: 5,
  47654: 5,
  47660: 1,
  47665: 5,
  47666: 5,
  47670: 5,
  47683: 5,
  47701: 5,
  47702: 5,
  47703: 5,
  47704: 5,
  47705: 5,
  47706: 5,
  47708: 5,
  47710: 5,
  47711: 5,
  47712: 5,
  47713: 5,
  47714: 5,
  47715: 5,
  47716: 5,
  47719: 5,
  47720: 5,
  47721: 5,
  47722: 5,
  47724: 5,
  47725: 5,
  47727: 5,
  47728: 5,
  47730: 5,
  47731: 5,
  47732: 5,
  47733: 5,
  47734: 5,
  47735: 5,
  47736: 5,
  47737: 5,
  47739: 5,
  47740: 5,
  47741: 5,
  47744: 5,
  47747: 5,
  47750: 5,
  47801: 5,
  47802: 5,
  47803: 5,
  47804: 5,
  47805: 5,
  47807: 5,
  47808: 5,
  47809: 5,
  47811: 5,
  47812: 5,
  47813: 5,
  47814: 5,
  47830: 5,
  47831: 5,
  47832: 5,
  47833: 0,
  47834: 0,
  47836: 5,
  47837: 0,
  47838: 5,
  47840: 5,
  47841: 5,
  47842: 0,
  47845: 5,
  47846: 5,
  47847: 5,
  47848: 5,
  47849: 5,
  47850: 5,
  47851: 5,
  47852: 5,
  47853: 5,
  47854: 5,
  47855: 5,
  47856: 5,
  47857: 5,
  47858: 0,
  47859: 5,
  47860: 5,
  47861: 5,
  47862: 5,
  47863: 5,
  47864: 5,
  47865: 5,
  47866: 5,
  47868: 0,
  47869: 5,
  47870: 5,
  47871: 5,
  47872: 5,
  47874: 0,
  47875: 5,
  47876: 5,
  47878: 5,
  47879: 5,
  47880: 5,
  47881: 5,
  47882: 5,
  47884: 5,
  47885: 5,
  47901: 5,
  47902: 5,
  47903: 5,
  47904: 5,
  47905: 5,
  47906: 5,
  47907: 5,
  47909: 5,
  47916: 5,
  47917: 0,
  47918: 0,
  47920: 5,
  47921: 5,
  47922: 5,
  47923: 5,
  47924: 5,
  47925: 5,
  47926: 0,
  47928: 5,
  47929: 5,
  47930: 5,
  47932: 0,
  47933: 5,
  47934: 5,
  47935: 5,
  47936: 5,
  47937: 5,
  47938: 5,
  47939: 5,
  47940: 5,
  47941: 5,
  47942: 5,
  47943: 1,
  47944: 5,
  47946: 12,
  47948: 1,
  47949: 5,
  47950: 5,
  47951: 5,
  47952: 0,
  47954: 5,
  47955: 5,
  47957: 12,
  47958: 5,
  47959: 5,
  47960: 0,
  47962: 5,
  47963: 5,
  47964: 5,
  47965: 5,
  47966: 5,
  47967: 5,
  47968: 5,
  47969: 5,
  47970: 0,
  47971: 5,
  47974: 5,
  47975: 5,
  47977: 5,
  47978: 5,
  47980: 5,
  47981: 5,
  47982: 5,
  47983: 5,
  47984: 5,
  47986: 5,
  47987: 5,
  47988: 5,
  47989: 5,
  47990: 5,
  47991: 5,
  47992: 5,
  47993: 5,
  47994: 5,
  47995: 5,
  47996: 5,
  47997: 5,
  48001: 6,
  48002: 6,
  48003: 6,
  48004: 6,
  48005: 6,
  48006: 6,
  48007: 6,
  48009: 6,
  48012: 6,
  48014: 6,
  48015: 6,
  48017: 6,
  48021: 6,
  48022: 6,
  48023: 6,
  48025: 6,
  48026: 6,
  48027: 6,
  48028: 6,
  48030: 6,
  48032: 6,
  48033: 6,
  48034: 6,
  48035: 6,
  48036: 6,
  48037: 6,
  48038: 6,
  48039: 6,
  48040: 6,
  48041: 0,
  48042: 6,
  48043: 6,
  48044: 6,
  48045: 6,
  48046: 6,
  48047: 6,
  48048: 6,
  48049: 6,
  48050: 6,
  48051: 6,
  48054: 6,
  48059: 6,
  48060: 6,
  48061: 6,
  48062: 6,
  48063: 6,
  48064: 6,
  48065: 6,
  48066: 6,
  48067: 6,
  48068: 6,
  48069: 6,
  48070: 6,
  48071: 6,
  48072: 6,
  48073: 6,
  48074: 6,
  48075: 6,
  48076: 6,
  48079: 6,
  48080: 6,
  48081: 6,
  48082: 6,
  48083: 6,
  48084: 6,
  48085: 6,
  48086: 6,
  48088: 6,
  48089: 6,
  48090: 6,
  48091: 6,
  48092: 6,
  48093: 6,
  48094: 6,
  48095: 6,
  48096: 6,
  48097: 6,
  48098: 6,
  48099: 6,
  48101: 6,
  48102: 6,
  48103: 6,
  48104: 6,
  48105: 6,
  48106: 6,
  48107: 6,
  48108: 6,
  48109: 6,
  48110: 6,
  48111: 6,
  48112: 6,
  48113: 6,
  48114: 6,
  48115: 6,
  48116: 6,
  48117: 6,
  48118: 6,
  48120: 6,
  48121: 6,
  48122: 6,
  48123: 6,
  48124: 6,
  48125: 6,
  48126: 6,
  48127: 6,
  48128: 6,
  48130: 6,
  48131: 6,
  48133: 6,
  48134: 6,
  48135: 6,
  48136: 6,
  48137: 6,
  48138: 6,
  48139: 6,
  48140: 6,
  48141: 6,
  48143: 6,
  48144: 6,
  48145: 6,
  48146: 6,
  48150: 6,
  48151: 6,
  48152: 6,
  48153: 6,
  48154: 6,
  48157: 6,
  48158: 6,
  48159: 6,
  48160: 0,
  48161: 6,
  48162: 6,
  48164: 6,
  48165: 6,
  48166: 6,
  48167: 6,
  48168: 6,
  48169: 6,
  48170: 0,
  48173: 6,
  48174: 6,
  48175: 6,
  48176: 6,
  48177: 6,
  48178: 0,
  48179: 6,
  48180: 6,
  48182: 6,
  48183: 6,
  48184: 6,
  48185: 6,
  48186: 6,
  48187: 6,
  48188: 6,
  48189: 6,
  48190: 6,
  48191: 0,
  48192: 6,
  48193: 6,
  48195: 6,
  48197: 6,
  48198: 6,
  48201: 6,
  48202: 6,
  48203: 6,
  48204: 6,
  48205: 6,
  48206: 6,
  48207: 6,
  48208: 6,
  48209: 6,
  48210: 6,
  48211: 6,
  48212: 6,
  48213: 6,
  48214: 6,
  48215: 6,
  48216: 6,
  48217: 6,
  48218: 6,
  48219: 6,
  48220: 6,
  48221: 6,
  48222: 6,
  48223: 6,
  48224: 6,
  48225: 6,
  48226: 6,
  48227: 6,
  48228: 6,
  48229: 6,
  48230: 6,
  48231: 6,
  48232: 6,
  48233: 6,
  48234: 6,
  48235: 6,
  48236: 6,
  48237: 6,
  48238: 6,
  48239: 6,
  48240: 6,
  48242: 6,
  48243: 6,
  48244: 6,
  48255: 6,
  48260: 6,
  48264: 6,
  48265: 6,
  48266: 6,
  48267: 6,
  48268: 6,
  48269: 6,
  48272: 6,
  48275: 6,
  48277: 6,
  48278: 6,
  48279: 6,
  48288: 6,
  48301: 6,
  48302: 6,
  48303: 6,
  48304: 6,
  48306: 6,
  48307: 6,
  48308: 6,
  48309: 6,
  48310: 6,
  48311: 6,
  48312: 6,
  48313: 6,
  48314: 6,
  48315: 6,
  48316: 6,
  48317: 6,
  48318: 6,
  48320: 6,
  48321: 6,
  48322: 6,
  48323: 6,
  48324: 6,
  48325: 6,
  48327: 6,
  48328: 6,
  48329: 6,
  48330: 6,
  48331: 6,
  48332: 6,
  48333: 6,
  48334: 6,
  48335: 6,
  48336: 6,
  48340: 6,
  48341: 6,
  48342: 6,
  48343: 6,
  48346: 6,
  48347: 6,
  48348: 6,
  48350: 6,
  48353: 6,
  48356: 6,
  48357: 6,
  48359: 6,
  48360: 6,
  48361: 6,
  48362: 6,
  48363: 6,
  48366: 6,
  48367: 6,
  48370: 6,
  48371: 6,
  48374: 6,
  48375: 6,
  48376: 6,
  48377: 6,
  48380: 6,
  48381: 6,
  48382: 6,
  48383: 6,
  48386: 6,
  48387: 6,
  48390: 6,
  48391: 6,
  48393: 6,
  48397: 6,
  48398: 6,
  48401: 6,
  48410: 6,
  48411: 6,
  48412: 6,
  48413: 6,
  48414: 6,
  48415: 6,
  48416: 0,
  48417: 6,
  48418: 6,
  48419: 6,
  48420: 6,
  48421: 6,
  48422: 6,
  48423: 6,
  48426: 6,
  48427: 6,
  48428: 6,
  48429: 0,
  48430: 0,
  48432: 6,
  48433: 6,
  48434: 6,
  48435: 6,
  48436: 6,
  48437: 6,
  48438: 0,
  48439: 6,
  48440: 6,
  48441: 6,
  48442: 6,
  48444: 6,
  48445: 6,
  48446: 6,
  48450: 6,
  48451: 0,
  48453: 6,
  48454: 6,
  48455: 6,
  48456: 6,
  48457: 0,
  48458: 6,
  48460: 0,
  48461: 6,
  48462: 6,
  48463: 6,
  48464: 6,
  48465: 6,
  48466: 6,
  48467: 6,
  48468: 6,
  48469: 6,
  48470: 6,
  48471: 6,
  48472: 6,
  48473: 6,
  48475: 0,
  48476: 6,
  48480: 6,
  48501: 6,
  48502: 6,
  48503: 6,
  48504: 6,
  48505: 6,
  48506: 6,
  48507: 6,
  48509: 6,
  48519: 6,
  48529: 6,
  48550: 6,
  48551: 6,
  48552: 6,
  48553: 6,
  48554: 6,
  48555: 6,
  48556: 6,
  48557: 6,
  48559: 6,
  48601: 6,
  48602: 6,
  48603: 6,
  48604: 6,
  48605: 6,
  48606: 6,
  48607: 6,
  48608: 6,
  48609: 6,
  48610: 0,
  48611: 6,
  48612: 6,
  48613: 6,
  48614: 6,
  48615: 0,
  48616: 6,
  48617: 0,
  48618: 6,
  48619: 0,
  48620: 6,
  48621: 6,
  48622: 0,
  48623: 0,
  48624: 0,
  48625: 6,
  48626: 6,
  48627: 6,
  48628: 6,
  48629: 6,
  48630: 6,
  48631: 6,
  48632: 0,
  48633: 6,
  48634: 6,
  48635: 6,
  48636: 6,
  48637: 0,
  48638: 6,
  48640: 6,
  48641: 6,
  48642: 6,
  48647: 6,
  48649: 6,
  48650: 0,
  48651: 6,
  48652: 6,
  48653: 0,
  48654: 6,
  48655: 6,
  48656: 6,
  48657: 6,
  48658: 6,
  48659: 6,
  48661: 6,
  48662: 6,
  48663: 6,
  48667: 6,
  48670: 6,
  48674: 6,
  48686: 6,
  48701: 6,
  48703: 6,
  48705: 6,
  48706: 6,
  48707: 6,
  48708: 6,
  48710: 6,
  48720: 6,
  48721: 6,
  48722: 6,
  48723: 6,
  48724: 6,
  48725: 6,
  48726: 0,
  48727: 6,
  48728: 6,
  48729: 6,
  48730: 6,
  48731: 6,
  48732: 6,
  48733: 6,
  48734: 6,
  48735: 6,
  48736: 6,
  48737: 6,
  48738: 6,
  48739: 6,
  48740: 6,
  48741: 6,
  48742: 6,
  48743: 6,
  48744: 0,
  48745: 6,
  48746: 6,
  48747: 6,
  48748: 6,
  48749: 6,
  48750: 0,
  48754: 6,
  48755: 6,
  48756: 6,
  48757: 0,
  48758: 6,
  48759: 6,
  48760: 0,
  48761: 0,
  48762: 6,
  48763: 6,
  48764: 6,
  48765: 6,
  48766: 6,
  48767: 6,
  48768: 6,
  48769: 6,
  48770: 6,
  48787: 6,
  48801: 6,
  48802: 6,
  48804: 6,
  48805: 6,
  48806: 6,
  48807: 0,
  48808: 6,
  48809: 0,
  48811: 6,
  48812: 6,
  48813: 6,
  48815: 6,
  48816: 6,
  48817: 6,
  48818: 6,
  48819: 6,
  48820: 6,
  48821: 6,
  48822: 6,
  48823: 6,
  48824: 6,
  48825: 6,
  48826: 6,
  48827: 0,
  48829: 6,
  48830: 6,
  48831: 0,
  48832: 6,
  48833: 6,
  48834: 0,
  48835: 6,
  48836: 6,
  48837: 6,
  48838: 6,
  48840: 6,
  48841: 0,
  48842: 6,
  48843: 6,
  48844: 6,
  48845: 0,
  48846: 6,
  48847: 6,
  48848: 0,
  48849: 0,
  48850: 0,
  48851: 6,
  48852: 6,
  48853: 6,
  48854: 6,
  48855: 6,
  48856: 6,
  48857: 6,
  48858: 6,
  48859: 6,
  48860: 6,
  48861: 6,
  48862: 6,
  48863: 6,
  48864: 6,
  48865: 6,
  48866: 0,
  48867: 6,
  48870: 6,
  48871: 6,
  48872: 0,
  48873: 6,
  48874: 6,
  48875: 6,
  48876: 6,
  48877: 0,
  48878: 6,
  48879: 6,
  48880: 0,
  48881: 6,
  48882: 6,
  48883: 0,
  48884: 6,
  48885: 6,
  48886: 6,
  48887: 6,
  48888: 6,
  48889: 6,
  48890: 0,
  48891: 6,
  48892: 0,
  48893: 6,
  48894: 6,
  48895: 6,
  48896: 6,
  48897: 6,
  48901: 6,
  48906: 6,
  48907: 6,
  48908: 6,
  48909: 6,
  48910: 6,
  48911: 6,
  48912: 6,
  48913: 6,
  48915: 6,
  48916: 6,
  48917: 6,
  48918: 6,
  48919: 6,
  48921: 6,
  48922: 6,
  48924: 6,
  48929: 6,
  48930: 6,
  48933: 6,
  48937: 6,
  48950: 6,
  48951: 6,
  48956: 6,
  48980: 6,
  49001: 6,
  49002: 6,
  49003: 6,
  49004: 6,
  49005: 6,
  49006: 6,
  49007: 6,
  49008: 6,
  49009: 6,
  49010: 6,
  49011: 6,
  49012: 6,
  49013: 6,
  49014: 6,
  49015: 6,
  49016: 6,
  49017: 6,
  49018: 6,
  49019: 6,
  49020: 6,
  49021: 0,
  49022: 6,
  49023: 6,
  49024: 6,
  49026: 6,
  49027: 6,
  49028: 6,
  49029: 6,
  49030: 6,
  49031: 6,
  49032: 6,
  49033: 6,
  49034: 0,
  49035: 6,
  49036: 6,
  49037: 6,
  49038: 6,
  49039: 6,
  49040: 6,
  49041: 6,
  49042: 6,
  49043: 6,
  49045: 6,
  49046: 6,
  49047: 0,
  49048: 6,
  49050: 6,
  49051: 6,
  49052: 6,
  49053: 6,
  49055: 6,
  49056: 6,
  49057: 6,
  49058: 6,
  49060: 0,
  49061: 6,
  49062: 6,
  49063: 6,
  49064: 6,
  49065: 6,
  49066: 6,
  49067: 0,
  49068: 6,
  49069: 6,
  49070: 6,
  49071: 6,
  49072: 6,
  49073: 6,
  49074: 6,
  49075: 6,
  49076: 0,
  49077: 6,
  49078: 6,
  49079: 6,
  49080: 6,
  49081: 6,
  49082: 6,
  49083: 6,
  49084: 6,
  49085: 6,
  49087: 6,
  49088: 6,
  49089: 6,
  49090: 0,
  49091: 6,
  49092: 6,
  49093: 6,
  49094: 0,
  49095: 6,
  49096: 6,
  49097: 6,
  49098: 6,
  49099: 0,
  49101: 6,
  49102: 6,
  49103: 6,
  49104: 6,
  49106: 6,
  49107: 6,
  49111: 6,
  49112: 6,
  49113: 6,
  49115: 6,
  49116: 6,
  49117: 6,
  49119: 6,
  49120: 6,
  49121: 6,
  49125: 6,
  49126: 6,
  49127: 6,
  49128: 6,
  49129: 6,
  49130: 6,
  49201: 6,
  49202: 6,
  49203: 6,
  49204: 6,
  49220: 6,
  49221: 6,
  49224: 0,
  49227: 6,
  49228: 6,
  49229: 6,
  49230: 0,
  49232: 6,
  49233: 6,
  49234: 6,
  49235: 6,
  49236: 0,
  49237: 6,
  49238: 6,
  49239: 6,
  49240: 0,
  49241: 6,
  49242: 6,
  49245: 6,
  49246: 6,
  49247: 0,
  49248: 6,
  49249: 6,
  49250: 6,
  49251: 6,
  49252: 6,
  49253: 6,
  49254: 6,
  49255: 0,
  49256: 6,
  49257: 6,
  49258: 6,
  49259: 6,
  49261: 6,
  49262: 6,
  49263: 6,
  49264: 6,
  49265: 6,
  49266: 6,
  49267: 0,
  49268: 6,
  49269: 6,
  49270: 6,
  49271: 6,
  49272: 6,
  49274: 6,
  49275: 6,
  49276: 6,
  49277: 6,
  49278: 6,
  49279: 6,
  49280: 6,
  49281: 6,
  49282: 6,
  49283: 6,
  49284: 0,
  49285: 6,
  49286: 6,
  49287: 6,
  49288: 6,
  49289: 6,
  49301: 6,
  49302: 6,
  49303: 6,
  49304: 6,
  49305: 6,
  49306: 6,
  49307: 0,
  49309: 6,
  49310: 0,
  49311: 6,
  49312: 6,
  49314: 6,
  49315: 0,
  49316: 6,
  49317: 6,
  49318: 6,
  49319: 6,
  49320: 6,
  49321: 6,
  49322: 6,
  49323: 6,
  49325: 0,
  49326: 6,
  49327: 6,
  49328: 6,
  49329: 6,
  49330: 6,
  49331: 6,
  49332: 6,
  49333: 6,
  49335: 6,
  49336: 6,
  49337: 6,
  49338: 0,
  49339: 6,
  49340: 0,
  49341: 6,
  49342: 6,
  49343: 0,
  49344: 6,
  49345: 6,
  49346: 6,
  49347: 6,
  49348: 6,
  49349: 6,
  49351: 6,
  49355: 6,
  49356: 6,
  49357: 6,
  49401: 6,
  49402: 6,
  49403: 6,
  49404: 6,
  49405: 6,
  49406: 6,
  49408: 6,
  49409: 6,
  49410: 6,
  49411: 6,
  49412: 6,
  49413: 6,
  49415: 6,
  49416: 6,
  49417: 6,
  49418: 6,
  49419: 6,
  49420: 6,
  49421: 0,
  49422: 6,
  49423: 6,
  49424: 6,
  49425: 6,
  49426: 6,
  49427: 6,
  49428: 6,
  49429: 6,
  49430: 6,
  49431: 6,
  49434: 6,
  49435: 6,
  49436: 6,
  49437: 6,
  49440: 6,
  49441: 6,
  49442: 6,
  49443: 6,
  49444: 6,
  49445: 6,
  49446: 6,
  49448: 6,
  49449: 0,
  49450: 6,
  49451: 0,
  49452: 6,
  49453: 6,
  49454: 6,
  49455: 6,
  49456: 6,
  49457: 6,
  49458: 6,
  49459: 6,
  49460: 6,
  49461: 6,
  49463: 6,
  49464: 6,
  49468: 6,
  49501: 6,
  49502: 6,
  49503: 6,
  49504: 6,
  49505: 6,
  49506: 6,
  49507: 6,
  49508: 6,
  49509: 6,
  49510: 6,
  49512: 6,
  49514: 6,
  49515: 6,
  49516: 6,
  49518: 6,
  49519: 6,
  49523: 6,
  49525: 6,
  49528: 6,
  49530: 6,
  49534: 6,
  49544: 6,
  49546: 6,
  49548: 6,
  49550: 6,
  49555: 6,
  49560: 6,
  49588: 6,
  49599: 6,
  49601: 6,
  49610: 6,
  49611: 6,
  49612: 6,
  49613: 0,
  49614: 6,
  49615: 6,
  49616: 6,
  49617: 6,
  49618: 6,
  49619: 6,
  49620: 0,
  49621: 6,
  49622: 6,
  49623: 6,
  49625: 6,
  49626: 6,
  49627: 6,
  49628: 6,
  49629: 6,
  49630: 6,
  49631: 0,
  49632: 6,
  49633: 0,
  49634: 6,
  49635: 6,
  49636: 6,
  49637: 6,
  49638: 0,
  49639: 6,
  49640: 6,
  49642: 6,
  49643: 0,
  49644: 6,
  49645: 6,
  49646: 6,
  49648: 6,
  49649: 0,
  49650: 6,
  49651: 6,
  49653: 6,
  49654: 6,
  49655: 0,
  49656: 6,
  49657: 6,
  49659: 0,
  49660: 6,
  49663: 0,
  49664: 6,
  49665: 0,
  49666: 6,
  49667: 6,
  49668: 6,
  49670: 6,
  49673: 6,
  49674: 6,
  49675: 6,
  49676: 0,
  49677: 6,
  49679: 6,
  49680: 6,
  49682: 6,
  49683: 0,
  49684: 6,
  49685: 6,
  49686: 6,
  49688: 6,
  49689: 0,
  49690: 0,
  49696: 6,
  49701: 6,
  49705: 6,
  49706: 0,
  49707: 0,
  49709: 6,
  49710: 6,
  49711: 6,
  49712: 6,
  49713: 6,
  49715: 6,
  49716: 0,
  49717: 6,
  49718: 6,
  49719: 6,
  49720: 6,
  49721: 6,
  49722: 6,
  49723: 6,
  49724: 6,
  49725: 6,
  49726: 6,
  49727: 0,
  49728: 6,
  49729: 6,
  49730: 0,
  49733: 0,
  49734: 6,
  49735: 6,
  49736: 6,
  49737: 6,
  49738: 6,
  49739: 6,
  49740: 6,
  49743: 6,
  49744: 6,
  49745: 6,
  49746: 6,
  49747: 6,
  49748: 6,
  49749: 6,
  49751: 0,
  49752: 6,
  49753: 6,
  49755: 0,
  49756: 0,
  49757: 6,
  49759: 6,
  49760: 6,
  49761: 6,
  49762: 6,
  49764: 6,
  49765: 0,
  49766: 6,
  49768: 6,
  49769: 6,
  49770: 6,
  49774: 6,
  49775: 6,
  49776: 0,
  49777: 6,
  49778: 6,
  49779: 6,
  49780: 6,
  49781: 6,
  49782: 6,
  49783: 6,
  49784: 6,
  49785: 6,
  49786: 6,
  49788: 6,
  49790: 6,
  49791: 6,
  49792: 6,
  49793: 6,
  49795: 6,
  49796: 6,
  49797: 6,
  49799: 6,
  49801: 18,
  49802: 18,
  49805: 6,
  49806: 6,
  49807: 0,
  49808: 6,
  49812: 18,
  49814: 6,
  49815: 18,
  49816: 6,
  49817: 6,
  49818: 6,
  49819: 6,
  49820: 6,
  49821: 18,
  49822: 6,
  49825: 6,
  49826: 6,
  49827: 6,
  49829: 6,
  49831: 18,
  49833: 6,
  49834: 18,
  49835: 6,
  49836: 6,
  49837: 6,
  49838: 6,
  49839: 6,
  49840: 6,
  49841: 6,
  49845: 18,
  49847: 18,
  49848: 18,
  49849: 6,
  49852: 18,
  49853: 6,
  49854: 6,
  49855: 6,
  49858: 18,
  49861: 0,
  49862: 6,
  49863: 18,
  49864: 6,
  49865: 6,
  49866: 6,
  49868: 6,
  49870: 18,
  49871: 6,
  49872: 6,
  49873: 18,
  49874: 18,
  49876: 18,
  49877: 18,
  49878: 0,
  49879: 6,
  49880: 0,
  49881: 18,
  49883: 6,
  49884: 6,
  49885: 0,
  49886: 18,
  49887: 18,
  49891: 6,
  49892: 1,
  49893: 18,
  49894: 6,
  49895: 6,
  49896: 18,
  49901: 6,
  49902: 18,
  49903: 18,
  49905: 6,
  49908: 6,
  49910: 6,
  49911: 18,
  49912: 6,
  49913: 0,
  49915: 18,
  49916: 6,
  49917: 6,
  49918: 6,
  49919: 6,
  49920: 18,
  49921: 6,
  49922: 6,
  49925: 6,
  49927: 18,
  49929: 6,
  49930: 6,
  49931: 6,
  49934: 6,
  49935: 18,
  49938: 18,
  49942: 6,
  49945: 6,
  49946: 6,
  49947: 18,
  49948: 0,
  49950: 6,
  49952: 6,
  49953: 6,
  49955: 6,
  49958: 0,
  49959: 18,
  49960: 6,
  49961: 6,
  49962: 6,
  49963: 6,
  49964: 18,
  49965: 6,
  49967: 0,
  49968: 18,
  49969: 18,
  49970: 6,
  49971: 6,
  50001: 1,
  50002: 1,
  50003: 1,
  50005: 1,
  50006: 1,
  50007: 1,
  50008: 1,
  50009: 1,
  50010: 1,
  50011: 1,
  50012: 1,
  50013: 1,
  50014: 1,
  50020: 1,
  50021: 1,
  50022: 1,
  50023: 1,
  50025: 1,
  50026: 1,
  50027: 1,
  50028: 1,
  50029: 1,
  50031: 1,
  50032: 1,
  50033: 1,
  50034: 1,
  50035: 1,
  50036: 1,
  50037: 1,
  50038: 1,
  50039: 1,
  50040: 1,
  50041: 1,
  50042: 1,
  50043: 1,
  50044: 1,
  50046: 1,
  50047: 1,
  50048: 1,
  50049: 1,
  50050: 1,
  50051: 1,
  50052: 1,
  50054: 1,
  50055: 1,
  50056: 1,
  50057: 1,
  50058: 1,
  50059: 1,
  50060: 1,
  50061: 1,
  50062: 1,
  50063: 1,
  50064: 1,
  50065: 1,
  50066: 1,
  50067: 1,
  50068: 1,
  50069: 1,
  50070: 1,
  50071: 1,
  50072: 1,
  50073: 1,
  50074: 1,
  50075: 1,
  50076: 1,
  50078: 1,
  50099: 1,
  50101: 1,
  50102: 1,
  50103: 1,
  50104: 1,
  50105: 1,
  50106: 1,
  50107: 1,
  50108: 1,
  50109: 1,
  50110: 1,
  50111: 1,
  50112: 1,
  50115: 1,
  50116: 1,
  50117: 1,
  50118: 1,
  50119: 1,
  50120: 1,
  50122: 1,
  50123: 1,
  50124: 1,
  50125: 1,
  50126: 1,
  50127: 1,
  50128: 1,
  50129: 1,
  50130: 1,
  50131: 1,
  50132: 1,
  50133: 1,
  50134: 1,
  50135: 1,
  50136: 1,
  50137: 1,
  50138: 1,
  50139: 1,
  50140: 1,
  50141: 1,
  50142: 1,
  50143: 1,
  50144: 1,
  50145: 1,
  50146: 1,
  50147: 1,
  50148: 1,
  50149: 1,
  50150: 1,
  50151: 1,
  50152: 1,
  50153: 1,
  50154: 1,
  50155: 1,
  50156: 1,
  50157: 1,
  50158: 1,
  50160: 1,
  50161: 1,
  50162: 1,
  50163: 1,
  50164: 1,
  50165: 1,
  50166: 1,
  50167: 1,
  50168: 1,
  50169: 1,
  50170: 1,
  50171: 1,
  50173: 1,
  50174: 1,
  50177: 1,
  50197: 1,
  50198: 1,
  50201: 1,
  50206: 1,
  50207: 1,
  50208: 1,
  50210: 1,
  50211: 1,
  50212: 1,
  50213: 1,
  50214: 1,
  50216: 1,
  50217: 1,
  50218: 1,
  50219: 1,
  50220: 1,
  50222: 1,
  50223: 1,
  50225: 1,
  50226: 1,
  50227: 1,
  50228: 1,
  50229: 1,
  50230: 1,
  50231: 1,
  50232: 1,
  50233: 1,
  50234: 1,
  50235: 1,
  50236: 1,
  50237: 1,
  50238: 1,
  50239: 1,
  50240: 1,
  50241: 1,
  50242: 1,
  50243: 1,
  50244: 1,
  50246: 1,
  50247: 1,
  50248: 1,
  50249: 1,
  50250: 1,
  50251: 1,
  50252: 1,
  50254: 1,
  50255: 1,
  50256: 1,
  50257: 1,
  50258: 1,
  50259: 1,
  50261: 1,
  50262: 1,
  50263: 1,
  50264: 1,
  50265: 1,
  50266: 1,
  50268: 1,
  50269: 1,
  50271: 1,
  50272: 1,
  50273: 1,
  50274: 1,
  50275: 1,
  50276: 1,
  50277: 1,
  50278: 1,
  50301: 1,
  50302: 1,
  50303: 1,
  50304: 1,
  50305: 1,
  50306: 1,
  50307: 1,
  50308: 1,
  50309: 1,
  50310: 1,
  50311: 1,
  50312: 1,
  50313: 1,
  50314: 1,
  50315: 1,
  50316: 1,
  50317: 1,
  50318: 1,
  50319: 1,
  50320: 1,
  50321: 1,
  50322: 1,
  50323: 1,
  50324: 1,
  50325: 1,
  50327: 1,
  50328: 1,
  50329: 1,
  50330: 1,
  50331: 1,
  50332: 1,
  50333: 1,
  50334: 1,
  50335: 1,
  50336: 1,
  50338: 1,
  50339: 1,
  50340: 1,
  50347: 1,
  50350: 1,
  50359: 1,
  50360: 1,
  50361: 1,
  50362: 1,
  50363: 1,
  50364: 1,
  50367: 1,
  50368: 1,
  50369: 1,
  50380: 1,
  50381: 1,
  50391: 1,
  50392: 1,
  50393: 1,
  50394: 1,
  50395: 1,
  50396: 1,
  50397: 1,
  50398: 1,
  50401: 1,
  50402: 1,
  50420: 1,
  50421: 1,
  50423: 1,
  50424: 1,
  50426: 1,
  50427: 1,
  50428: 1,
  50430: 1,
  50431: 1,
  50432: 1,
  50433: 1,
  50434: 1,
  50435: 1,
  50436: 1,
  50438: 1,
  50439: 1,
  50440: 1,
  50441: 1,
  50444: 1,
  50446: 1,
  50447: 1,
  50448: 1,
  50449: 1,
  50450: 1,
  50451: 1,
  50452: 1,
  50453: 1,
  50454: 1,
  50455: 1,
  50456: 1,
  50457: 1,
  50458: 1,
  50459: 1,
  50460: 1,
  50461: 1,
  50464: 1,
  50465: 1,
  50466: 1,
  50467: 1,
  50468: 1,
  50469: 1,
  50470: 1,
  50471: 1,
  50472: 1,
  50473: 1,
  50475: 1,
  50476: 1,
  50477: 1,
  50478: 1,
  50479: 1,
  50480: 1,
  50481: 1,
  50482: 1,
  50483: 1,
  50484: 1,
  50501: 1,
  50510: 1,
  50511: 1,
  50514: 1,
  50515: 1,
  50516: 1,
  50517: 1,
  50518: 1,
  50519: 1,
  50520: 1,
  50521: 1,
  50522: 1,
  50523: 1,
  50524: 1,
  50525: 1,
  50526: 1,
  50527: 1,
  50528: 1,
  50529: 1,
  50530: 1,
  50531: 1,
  50532: 1,
  50533: 1,
  50535: 1,
  50536: 1,
  50538: 1,
  50539: 1,
  50540: 1,
  50541: 1,
  50542: 1,
  50543: 1,
  50544: 1,
  50545: 1,
  50546: 1,
  50548: 1,
  50551: 1,
  50552: 1,
  50554: 1,
  50556: 1,
  50557: 1,
  50558: 1,
  50559: 1,
  50560: 1,
  50561: 1,
  50562: 1,
  50563: 1,
  50565: 1,
  50566: 1,
  50567: 1,
  50568: 1,
  50569: 1,
  50570: 1,
  50571: 1,
  50573: 1,
  50574: 1,
  50575: 1,
  50576: 1,
  50577: 1,
  50578: 1,
  50579: 1,
  50581: 1,
  50582: 1,
  50583: 1,
  50585: 1,
  50586: 1,
  50588: 1,
  50590: 1,
  50591: 1,
  50592: 1,
  50593: 1,
  50594: 1,
  50595: 1,
  50597: 1,
  50598: 1,
  50599: 1,
  50601: 1,
  50602: 1,
  50603: 1,
  50604: 1,
  50605: 1,
  50606: 1,
  50607: 1,
  50608: 1,
  50609: 1,
  50611: 1,
  50612: 1,
  50613: 1,
  50614: 1,
  50616: 1,
  50619: 1,
  50620: 1,
  50621: 1,
  50622: 1,
  50623: 1,
  50624: 1,
  50625: 1,
  50626: 1,
  50627: 1,
  50628: 1,
  50629: 1,
  50630: 1,
  50631: 1,
  50632: 1,
  50633: 1,
  50634: 1,
  50635: 1,
  50636: 1,
  50638: 1,
  50641: 1,
  50642: 1,
  50643: 1,
  50644: 1,
  50645: 1,
  50647: 1,
  50648: 1,
  50649: 1,
  50650: 1,
  50651: 1,
  50652: 1,
  50653: 1,
  50654: 1,
  50655: 1,
  50657: 1,
  50658: 1,
  50659: 1,
  50660: 1,
  50661: 1,
  50662: 1,
  50664: 1,
  50665: 1,
  50666: 1,
  50667: 1,
  50668: 1,
  50669: 1,
  50670: 1,
  50671: 1,
  50672: 1,
  50673: 1,
  50674: 1,
  50675: 1,
  50676: 1,
  50677: 1,
  50680: 1,
  50681: 1,
  50682: 1,
  50701: 1,
  50702: 1,
  50703: 1,
  50704: 1,
  50706: 1,
  50707: 1,
  50799: 1,
  50801: 1,
  50830: 1,
  50831: 1,
  50833: 1,
  50835: 1,
  50836: 1,
  50837: 1,
  50839: 1,
  50840: 1,
  50841: 1,
  50842: 1,
  50843: 1,
  50845: 1,
  50846: 1,
  50847: 1,
  50848: 1,
  50849: 1,
  50851: 1,
  50853: 1,
  50854: 1,
  50857: 1,
  50858: 1,
  50859: 1,
  50860: 1,
  50861: 1,
  50862: 1,
  50863: 1,
  50864: 1,
  50936: 1,
  50940: 1,
  50947: 1,
  50950: 1,
  50980: 1,
  50981: 1,
  51001: 1,
  51002: 1,
  51003: 1,
  51004: 1,
  51005: 1,
  51006: 1,
  51007: 1,
  51008: 1,
  51009: 1,
  51010: 1,
  51011: 1,
  51012: 1,
  51014: 1,
  51015: 1,
  51016: 1,
  51018: 1,
  51019: 1,
  51020: 1,
  51022: 1,
  51023: 1,
  51024: 1,
  51025: 1,
  51026: 1,
  51027: 1,
  51028: 1,
  51029: 1,
  51030: 1,
  51031: 1,
  51033: 1,
  51034: 1,
  51035: 1,
  51036: 1,
  51037: 1,
  51038: 1,
  51039: 1,
  51040: 1,
  51041: 1,
  51044: 1,
  51045: 1,
  51046: 1,
  51047: 1,
  51048: 1,
  51049: 1,
  51050: 1,
  51051: 1,
  51052: 1,
  51053: 1,
  51054: 1,
  51055: 1,
  51056: 1,
  51058: 1,
  51060: 1,
  51061: 1,
  51062: 1,
  51063: 1,
  51101: 1,
  51102: 1,
  51103: 1,
  51104: 1,
  51105: 1,
  51106: 1,
  51108: 1,
  51109: 1,
  51111: 1,
  51201: 1,
  51230: 1,
  51231: 1,
  51232: 1,
  51234: 1,
  51235: 1,
  51237: 1,
  51238: 1,
  51239: 1,
  51240: 1,
  51241: 1,
  51242: 1,
  51243: 1,
  51244: 1,
  51245: 1,
  51246: 1,
  51247: 1,
  51248: 1,
  51249: 1,
  51250: 1,
  51301: 1,
  51331: 1,
  51333: 1,
  51334: 1,
  51338: 1,
  51340: 1,
  51341: 1,
  51342: 1,
  51343: 1,
  51344: 1,
  51345: 1,
  51346: 1,
  51347: 1,
  51349: 1,
  51350: 1,
  51351: 1,
  51354: 1,
  51355: 1,
  51357: 1,
  51358: 1,
  51360: 1,
  51363: 1,
  51364: 1,
  51365: 1,
  51366: 1,
  51401: 1,
  51430: 1,
  51431: 1,
  51432: 1,
  51433: 1,
  51436: 1,
  51439: 1,
  51440: 1,
  51441: 1,
  51442: 1,
  51443: 1,
  51444: 1,
  51445: 1,
  51446: 1,
  51447: 1,
  51448: 1,
  51449: 1,
  51450: 1,
  51451: 1,
  51452: 1,
  51453: 1,
  51454: 1,
  51455: 1,
  51458: 1,
  51459: 1,
  51460: 1,
  51461: 1,
  51462: 1,
  51463: 1,
  51465: 1,
  51466: 1,
  51467: 1,
  51501: 1,
  51502: 1,
  51503: 1,
  51510: 1,
  51520: 1,
  51521: 1,
  51523: 1,
  51525: 1,
  51526: 1,
  51527: 1,
  51528: 1,
  51529: 1,
  51530: 1,
  51531: 1,
  51532: 1,
  51533: 1,
  51534: 1,
  51535: 1,
  51536: 1,
  51537: 1,
  51540: 1,
  51541: 1,
  51542: 1,
  51543: 1,
  51544: 1,
  51545: 1,
  51546: 1,
  51548: 1,
  51549: 1,
  51550: 1,
  51551: 1,
  51552: 1,
  51553: 1,
  51554: 1,
  51555: 1,
  51556: 1,
  51557: 1,
  51558: 1,
  51559: 1,
  51560: 1,
  51561: 1,
  51562: 1,
  51563: 1,
  51564: 1,
  51565: 1,
  51566: 1,
  51570: 1,
  51571: 1,
  51572: 1,
  51573: 1,
  51575: 1,
  51576: 1,
  51577: 1,
  51578: 1,
  51579: 1,
  51591: 1,
  51593: 1,
  51601: 1,
  51602: 1,
  51603: 1,
  51630: 1,
  51631: 1,
  51632: 1,
  51636: 1,
  51637: 1,
  51638: 1,
  51639: 1,
  51640: 1,
  51645: 1,
  51646: 1,
  51647: 1,
  51648: 1,
  51649: 1,
  51650: 1,
  51651: 1,
  51652: 1,
  51653: 1,
  51654: 1,
  51656: 1,
  52001: 1,
  52002: 1,
  52003: 1,
  52004: 1,
  52030: 1,
  52031: 1,
  52032: 1,
  52033: 1,
  52035: 1,
  52036: 1,
  52037: 1,
  52038: 1,
  52039: 1,
  52040: 1,
  52041: 1,
  52042: 1,
  52043: 1,
  52044: 1,
  52045: 1,
  52046: 1,
  52047: 1,
  52048: 1,
  52049: 1,
  52050: 1,
  52052: 1,
  52053: 1,
  52054: 1,
  52056: 1,
  52057: 1,
  52060: 1,
  52064: 1,
  52065: 1,
  52066: 1,
  52068: 1,
  52069: 1,
  52070: 1,
  52071: 1,
  52072: 1,
  52073: 1,
  52074: 1,
  52075: 1,
  52076: 1,
  52077: 1,
  52078: 1,
  52079: 1,
  52099: 1,
  52101: 1,
  52132: 1,
  52133: 1,
  52134: 1,
  52135: 1,
  52136: 1,
  52140: 1,
  52141: 1,
  52142: 1,
  52144: 1,
  52146: 1,
  52147: 1,
  52149: 1,
  52151: 1,
  52154: 1,
  52155: 1,
  52156: 1,
  52157: 1,
  52158: 1,
  52160: 1,
  52161: 1,
  52162: 1,
  52163: 1,
  52164: 1,
  52165: 1,
  52166: 1,
  52168: 1,
  52169: 1,
  52170: 1,
  52171: 1,
  52172: 1,
  52175: 1,
  52201: 1,
  52202: 1,
  52203: 1,
  52204: 1,
  52205: 1,
  52206: 1,
  52207: 1,
  52208: 1,
  52209: 1,
  52210: 1,
  52211: 1,
  52212: 1,
  52213: 1,
  52214: 1,
  52215: 1,
  52216: 1,
  52217: 1,
  52218: 1,
  52219: 1,
  52220: 1,
  52221: 1,
  52222: 1,
  52223: 1,
  52224: 1,
  52225: 1,
  52226: 1,
  52227: 1,
  52228: 1,
  52229: 1,
  52231: 1,
  52232: 1,
  52233: 1,
  52235: 1,
  52236: 1,
  52237: 1,
  52240: 1,
  52241: 1,
  52242: 1,
  52243: 1,
  52244: 1,
  52245: 1,
  52246: 1,
  52247: 1,
  52248: 1,
  52249: 1,
  52251: 1,
  52252: 1,
  52253: 1,
  52254: 1,
  52255: 1,
  52257: 1,
  52301: 1,
  52302: 1,
  52305: 1,
  52306: 1,
  52307: 1,
  52308: 1,
  52309: 1,
  52310: 1,
  52312: 1,
  52313: 1,
  52314: 1,
  52315: 1,
  52316: 1,
  52317: 1,
  52318: 1,
  52319: 1,
  52320: 1,
  52321: 1,
  52322: 1,
  52323: 1,
  52324: 1,
  52325: 1,
  52326: 1,
  52327: 1,
  52328: 1,
  52329: 1,
  52330: 1,
  52332: 1,
  52333: 1,
  52334: 1,
  52335: 1,
  52336: 1,
  52337: 1,
  52338: 1,
  52339: 1,
  52340: 1,
  52341: 1,
  52342: 1,
  52344: 1,
  52345: 1,
  52346: 1,
  52347: 1,
  52348: 1,
  52349: 1,
  52350: 1,
  52351: 1,
  52352: 1,
  52353: 1,
  52354: 1,
  52355: 1,
  52356: 1,
  52358: 1,
  52359: 1,
  52361: 1,
  52362: 1,
  52401: 1,
  52402: 1,
  52403: 1,
  52404: 1,
  52405: 1,
  52406: 1,
  52407: 1,
  52408: 1,
  52409: 1,
  52410: 1,
  52411: 1,
  52497: 1,
  52499: 1,
  52501: 1,
  52530: 1,
  52531: 1,
  52533: 1,
  52534: 1,
  52535: 1,
  52536: 1,
  52537: 1,
  52538: 1,
  52540: 1,
  52542: 1,
  52543: 1,
  52544: 1,
  52548: 1,
  52549: 1,
  52550: 1,
  52551: 1,
  52552: 1,
  52553: 1,
  52554: 1,
  52555: 1,
  52556: 1,
  52557: 1,
  52560: 1,
  52561: 1,
  52562: 1,
  52563: 1,
  52565: 1,
  52566: 1,
  52567: 1,
  52568: 1,
  52569: 1,
  52570: 1,
  52571: 1,
  52572: 1,
  52573: 1,
  52574: 1,
  52576: 1,
  52577: 1,
  52580: 1,
  52581: 1,
  52583: 1,
  52584: 1,
  52585: 1,
  52586: 1,
  52588: 1,
  52590: 1,
  52591: 1,
  52593: 1,
  52594: 1,
  52595: 1,
  52601: 1,
  52619: 1,
  52620: 1,
  52621: 1,
  52623: 1,
  52624: 1,
  52625: 1,
  52626: 1,
  52627: 1,
  52630: 1,
  52631: 1,
  52632: 1,
  52635: 1,
  52637: 1,
  52638: 1,
  52639: 1,
  52640: 1,
  52641: 1,
  52642: 1,
  52644: 1,
  52645: 1,
  52646: 1,
  52647: 1,
  52648: 1,
  52649: 1,
  52650: 1,
  52651: 1,
  52652: 1,
  52653: 1,
  52654: 1,
  52655: 1,
  52656: 1,
  52657: 1,
  52658: 1,
  52659: 1,
  52660: 1,
  52701: 1,
  52720: 1,
  52721: 1,
  52722: 1,
  52726: 1,
  52727: 1,
  52728: 1,
  52729: 1,
  52730: 1,
  52731: 1,
  52732: 1,
  52733: 1,
  52734: 1,
  52736: 1,
  52737: 1,
  52738: 1,
  52739: 1,
  52742: 1,
  52745: 1,
  52746: 1,
  52747: 1,
  52748: 1,
  52749: 1,
  52750: 1,
  52751: 1,
  52752: 1,
  52753: 1,
  52754: 1,
  52755: 1,
  52756: 1,
  52757: 1,
  52758: 1,
  52759: 1,
  52760: 1,
  52761: 1,
  52765: 1,
  52766: 1,
  52767: 1,
  52768: 1,
  52769: 1,
  52771: 1,
  52772: 1,
  52773: 1,
  52774: 1,
  52776: 1,
  52777: 1,
  52778: 1,
  52801: 1,
  52802: 1,
  52803: 1,
  52804: 1,
  52805: 1,
  52806: 1,
  52807: 1,
  52808: 1,
  52809: 1,
  53001: 1,
  53002: 1,
  53003: 1,
  53004: 1,
  53005: 1,
  53006: 1,
  53007: 1,
  53008: 1,
  53010: 1,
  53011: 1,
  53012: 1,
  53013: 1,
  53014: 1,
  53015: 1,
  53016: 1,
  53017: 1,
  53018: 1,
  53019: 1,
  53020: 1,
  53021: 1,
  53022: 1,
  53023: 1,
  53024: 1,
  53026: 1,
  53027: 1,
  53029: 1,
  53031: 1,
  53032: 1,
  53033: 1,
  53034: 1,
  53035: 1,
  53036: 1,
  53037: 1,
  53038: 1,
  53039: 1,
  53040: 1,
  53042: 1,
  53044: 1,
  53045: 1,
  53046: 1,
  53047: 1,
  53048: 1,
  53049: 1,
  53050: 1,
  53051: 1,
  53052: 1,
  53056: 1,
  53057: 1,
  53058: 1,
  53059: 1,
  53060: 1,
  53061: 1,
  53062: 1,
  53063: 1,
  53064: 1,
  53065: 1,
  53066: 1,
  53069: 1,
  53070: 1,
  53072: 1,
  53073: 1,
  53074: 1,
  53075: 1,
  53076: 1,
  53078: 1,
  53079: 1,
  53080: 1,
  53081: 1,
  53082: 1,
  53083: 1,
  53085: 1,
  53086: 1,
  53088: 1,
  53089: 1,
  53090: 1,
  53091: 1,
  53092: 1,
  53093: 1,
  53094: 1,
  53095: 1,
  53097: 1,
  53098: 1,
  53099: 1,
  53101: 1,
  53102: 1,
  53103: 1,
  53104: 1,
  53105: 1,
  53108: 1,
  53109: 1,
  53110: 1,
  53114: 1,
  53115: 1,
  53118: 1,
  53119: 1,
  53120: 1,
  53121: 1,
  53122: 1,
  53125: 1,
  53126: 1,
  53127: 1,
  53128: 1,
  53129: 1,
  53130: 1,
  53132: 1,
  53137: 1,
  53138: 1,
  53139: 1,
  53140: 1,
  53141: 1,
  53142: 1,
  53143: 1,
  53144: 1,
  53146: 1,
  53147: 1,
  53148: 1,
  53149: 1,
  53150: 1,
  53151: 1,
  53152: 1,
  53153: 1,
  53154: 1,
  53156: 1,
  53157: 1,
  53158: 1,
  53159: 1,
  53167: 1,
  53168: 1,
  53170: 1,
  53171: 1,
  53172: 1,
  53176: 1,
  53177: 1,
  53178: 1,
  53179: 1,
  53181: 1,
  53182: 1,
  53183: 1,
  53184: 1,
  53185: 1,
  53186: 1,
  53187: 1,
  53188: 1,
  53189: 1,
  53190: 1,
  53191: 1,
  53192: 1,
  53194: 1,
  53195: 1,
  53199: 1,
  53201: 1,
  53202: 1,
  53203: 1,
  53204: 1,
  53205: 1,
  53206: 1,
  53207: 1,
  53208: 1,
  53209: 1,
  53210: 1,
  53211: 1,
  53212: 1,
  53213: 1,
  53214: 1,
  53215: 1,
  53216: 1,
  53217: 1,
  53218: 1,
  53219: 1,
  53220: 1,
  53221: 1,
  53222: 1,
  53223: 1,
  53224: 1,
  53225: 1,
  53226: 1,
  53227: 1,
  53228: 1,
  53233: 1,
  53234: 1,
  53235: 1,
  53237: 1,
  53244: 1,
  53259: 1,
  53263: 1,
  53267: 1,
  53268: 1,
  53270: 1,
  53274: 1,
  53277: 1,
  53278: 1,
  53280: 1,
  53281: 1,
  53284: 1,
  53285: 1,
  53288: 1,
  53290: 1,
  53293: 1,
  53295: 1,
  53401: 1,
  53402: 1,
  53403: 1,
  53404: 1,
  53405: 1,
  53406: 1,
  53407: 1,
  53408: 1,
  53490: 1,
  53501: 1,
  53502: 1,
  53503: 1,
  53504: 1,
  53505: 1,
  53506: 1,
  53507: 1,
  53508: 1,
  53510: 1,
  53511: 1,
  53512: 1,
  53515: 1,
  53516: 1,
  53517: 1,
  53518: 1,
  53520: 1,
  53521: 1,
  53522: 1,
  53523: 1,
  53525: 1,
  53526: 1,
  53527: 1,
  53528: 1,
  53529: 1,
  53530: 1,
  53531: 1,
  53532: 1,
  53533: 1,
  53534: 1,
  53535: 1,
  53536: 1,
  53537: 1,
  53538: 1,
  53540: 1,
  53541: 1,
  53542: 1,
  53543: 1,
  53544: 1,
  53545: 1,
  53546: 1,
  53547: 1,
  53548: 1,
  53549: 1,
  53550: 1,
  53551: 1,
  53553: 1,
  53554: 1,
  53555: 1,
  53556: 1,
  53557: 1,
  53558: 1,
  53559: 1,
  53560: 1,
  53561: 1,
  53562: 1,
  53563: 1,
  53565: 1,
  53566: 1,
  53569: 1,
  53570: 1,
  53571: 1,
  53572: 1,
  53573: 1,
  53574: 1,
  53575: 1,
  53576: 1,
  53577: 1,
  53578: 1,
  53579: 1,
  53580: 1,
  53581: 1,
  53582: 1,
  53583: 1,
  53584: 1,
  53585: 1,
  53586: 1,
  53587: 1,
  53588: 1,
  53589: 1,
  53590: 1,
  53591: 1,
  53593: 1,
  53594: 1,
  53595: 1,
  53596: 1,
  53597: 1,
  53598: 1,
  53599: 1,
  53701: 1,
  53702: 1,
  53703: 1,
  53704: 1,
  53705: 1,
  53706: 1,
  53707: 1,
  53708: 1,
  53711: 1,
  53713: 1,
  53714: 1,
  53715: 1,
  53716: 1,
  53717: 1,
  53718: 1,
  53719: 1,
  53725: 1,
  53726: 1,
  53744: 1,
  53774: 1,
  53777: 1,
  53778: 1,
  53779: 1,
  53782: 1,
  53783: 1,
  53784: 1,
  53785: 1,
  53786: 1,
  53788: 1,
  53789: 1,
  53790: 1,
  53791: 1,
  53792: 1,
  53793: 1,
  53794: 1,
  53801: 1,
  53802: 1,
  53803: 1,
  53804: 1,
  53805: 1,
  53806: 1,
  53807: 1,
  53808: 1,
  53809: 1,
  53810: 1,
  53811: 1,
  53812: 1,
  53813: 1,
  53816: 1,
  53817: 1,
  53818: 1,
  53820: 1,
  53821: 1,
  53824: 1,
  53825: 1,
  53826: 1,
  53827: 1,
  53901: 1,
  53910: 1,
  53911: 1,
  53913: 1,
  53916: 1,
  53917: 1,
  53919: 1,
  53920: 1,
  53922: 1,
  53923: 1,
  53924: 1,
  53925: 1,
  53926: 1,
  53927: 1,
  53928: 1,
  53929: 1,
  53930: 1,
  53931: 1,
  53932: 1,
  53933: 1,
  53934: 1,
  53935: 1,
  53936: 1,
  53937: 1,
  53939: 1,
  53940: 1,
  53941: 1,
  53942: 1,
  53943: 1,
  53944: 1,
  53946: 1,
  53947: 1,
  53948: 1,
  53949: 1,
  53950: 1,
  53951: 1,
  53952: 1,
  53953: 1,
  53954: 1,
  53955: 1,
  53956: 1,
  53957: 1,
  53958: 1,
  53959: 1,
  53960: 1,
  53961: 1,
  53962: 1,
  53963: 1,
  53964: 1,
  53965: 1,
  53968: 1,
  53969: 1,
  54001: 1,
  54002: 1,
  54003: 1,
  54004: 1,
  54005: 1,
  54006: 1,
  54007: 1,
  54009: 1,
  54010: 1,
  54011: 1,
  54013: 1,
  54014: 1,
  54015: 1,
  54016: 1,
  54017: 1,
  54020: 1,
  54021: 1,
  54022: 1,
  54023: 1,
  54024: 1,
  54025: 1,
  54026: 1,
  54027: 1,
  54028: 1,
  54082: 1,
  54101: 1,
  54102: 1,
  54103: 1,
  54104: 1,
  54106: 1,
  54107: 1,
  54110: 1,
  54111: 1,
  54112: 1,
  54113: 1,
  54114: 1,
  54115: 1,
  54119: 1,
  54120: 1,
  54121: 1,
  54123: 1,
  54124: 1,
  54125: 1,
  54126: 1,
  54127: 1,
  54128: 1,
  54129: 1,
  54130: 1,
  54131: 1,
  54135: 1,
  54136: 1,
  54137: 1,
  54138: 1,
  54139: 1,
  54140: 1,
  54141: 1,
  54143: 1,
  54149: 1,
  54150: 1,
  54151: 1,
  54152: 1,
  54153: 1,
  54154: 1,
  54155: 1,
  54156: 1,
  54157: 1,
  54159: 1,
  54160: 1,
  54161: 1,
  54162: 1,
  54165: 1,
  54166: 1,
  54169: 1,
  54170: 1,
  54171: 1,
  54173: 1,
  54174: 1,
  54175: 1,
  54177: 1,
  54180: 1,
  54182: 1,
  54201: 1,
  54202: 1,
  54204: 1,
  54205: 1,
  54207: 1,
  54208: 1,
  54209: 1,
  54210: 1,
  54211: 1,
  54212: 1,
  54213: 1,
  54214: 1,
  54215: 1,
  54216: 1,
  54217: 1,
  54220: 1,
  54221: 1,
  54226: 1,
  54227: 1,
  54228: 1,
  54229: 1,
  54230: 1,
  54232: 1,
  54234: 1,
  54235: 1,
  54240: 1,
  54241: 1,
  54245: 1,
  54246: 1,
  54247: 1,
  54301: 1,
  54302: 1,
  54303: 1,
  54304: 1,
  54305: 1,
  54306: 1,
  54307: 1,
  54308: 1,
  54311: 1,
  54313: 1,
  54324: 1,
  54344: 1,
  54401: 1,
  54402: 1,
  54403: 1,
  54404: 1,
  54405: 1,
  54406: 1,
  54407: 1,
  54408: 1,
  54409: 1,
  54410: 1,
  54411: 1,
  54412: 1,
  54413: 1,
  54414: 1,
  54415: 1,
  54416: 1,
  54417: 1,
  54418: 1,
  54420: 1,
  54421: 1,
  54422: 1,
  54423: 1,
  54424: 1,
  54425: 1,
  54426: 1,
  54427: 1,
  54428: 1,
  54429: 1,
  54430: 1,
  54432: 1,
  54433: 1,
  54434: 1,
  54435: 1,
  54436: 1,
  54437: 1,
  54439: 1,
  54440: 1,
  54441: 1,
  54442: 1,
  54443: 1,
  54446: 1,
  54447: 1,
  54448: 1,
  54449: 1,
  54450: 1,
  54451: 1,
  54452: 1,
  54454: 1,
  54455: 1,
  54456: 1,
  54457: 1,
  54458: 1,
  54459: 1,
  54460: 1,
  54462: 1,
  54463: 1,
  54464: 1,
  54465: 1,
  54466: 1,
  54467: 1,
  54469: 1,
  54470: 1,
  54471: 1,
  54472: 1,
  54473: 1,
  54474: 1,
  54475: 1,
  54476: 1,
  54479: 1,
  54480: 1,
  54481: 1,
  54482: 1,
  54484: 1,
  54485: 1,
  54486: 1,
  54487: 1,
  54488: 1,
  54489: 1,
  54490: 1,
  54491: 1,
  54492: 1,
  54493: 1,
  54494: 1,
  54495: 1,
  54498: 1,
  54499: 1,
  54501: 1,
  54511: 1,
  54512: 1,
  54513: 1,
  54514: 1,
  54515: 1,
  54517: 1,
  54519: 1,
  54520: 1,
  54521: 1,
  54524: 1,
  54525: 1,
  54526: 1,
  54527: 1,
  54529: 1,
  54530: 1,
  54531: 1,
  54532: 1,
  54534: 1,
  54536: 1,
  54537: 1,
  54538: 1,
  54539: 1,
  54540: 1,
  54541: 1,
  54542: 1,
  54543: 1,
  54545: 1,
  54546: 1,
  54547: 1,
  54548: 1,
  54550: 1,
  54552: 1,
  54554: 1,
  54555: 1,
  54556: 1,
  54557: 1,
  54558: 1,
  54559: 1,
  54560: 1,
  54561: 1,
  54562: 1,
  54563: 1,
  54564: 1,
  54565: 1,
  54566: 1,
  54568: 1,
  54601: 1,
  54602: 1,
  54603: 1,
  54610: 1,
  54611: 1,
  54612: 1,
  54613: 1,
  54614: 1,
  54615: 1,
  54616: 1,
  54618: 1,
  54619: 1,
  54620: 1,
  54621: 1,
  54622: 1,
  54623: 1,
  54624: 1,
  54625: 1,
  54626: 1,
  54627: 1,
  54628: 1,
  54629: 1,
  54630: 1,
  54631: 1,
  54632: 1,
  54634: 1,
  54635: 1,
  54636: 1,
  54637: 1,
  54638: 1,
  54639: 1,
  54640: 1,
  54641: 1,
  54642: 1,
  54643: 1,
  54644: 1,
  54645: 1,
  54646: 1,
  54648: 1,
  54649: 1,
  54650: 1,
  54651: 1,
  54652: 1,
  54653: 1,
  54654: 1,
  54655: 1,
  54656: 1,
  54657: 1,
  54658: 1,
  54659: 1,
  54660: 1,
  54661: 1,
  54662: 1,
  54664: 1,
  54665: 1,
  54666: 1,
  54667: 1,
  54669: 1,
  54670: 1,
  54701: 1,
  54702: 1,
  54703: 1,
  54720: 1,
  54721: 1,
  54722: 1,
  54723: 1,
  54724: 1,
  54725: 1,
  54726: 1,
  54727: 1,
  54728: 1,
  54729: 1,
  54730: 1,
  54731: 1,
  54732: 1,
  54733: 1,
  54734: 1,
  54735: 1,
  54736: 1,
  54737: 1,
  54738: 1,
  54739: 1,
  54740: 1,
  54741: 1,
  54742: 1,
  54743: 1,
  54745: 1,
  54746: 1,
  54747: 1,
  54748: 1,
  54749: 1,
  54750: 1,
  54751: 1,
  54754: 1,
  54755: 1,
  54756: 1,
  54757: 1,
  54758: 1,
  54759: 1,
  54760: 1,
  54761: 1,
  54762: 1,
  54763: 1,
  54764: 1,
  54765: 1,
  54766: 1,
  54767: 1,
  54768: 1,
  54769: 1,
  54770: 1,
  54771: 1,
  54772: 1,
  54773: 1,
  54774: 1,
  54801: 1,
  54805: 1,
  54806: 1,
  54810: 1,
  54812: 1,
  54813: 1,
  54814: 1,
  54816: 1,
  54817: 1,
  54818: 1,
  54819: 1,
  54820: 1,
  54821: 1,
  54822: 1,
  54824: 1,
  54826: 1,
  54827: 1,
  54828: 1,
  54829: 1,
  54830: 1,
  54832: 1,
  54834: 1,
  54835: 1,
  54836: 1,
  54837: 1,
  54838: 1,
  54839: 1,
  54840: 1,
  54841: 1,
  54842: 1,
  54843: 1,
  54844: 1,
  54845: 1,
  54846: 1,
  54847: 1,
  54848: 1,
  54849: 1,
  54850: 1,
  54853: 1,
  54854: 1,
  54855: 1,
  54856: 1,
  54857: 1,
  54858: 1,
  54859: 1,
  54861: 1,
  54862: 1,
  54864: 1,
  54865: 1,
  54867: 1,
  54868: 1,
  54870: 1,
  54871: 1,
  54872: 1,
  54873: 1,
  54874: 1,
  54875: 1,
  54876: 1,
  54880: 1,
  54888: 1,
  54889: 1,
  54890: 1,
  54891: 1,
  54893: 1,
  54895: 1,
  54896: 1,
  54901: 1,
  54902: 1,
  54903: 1,
  54904: 1,
  54906: 1,
  54909: 1,
  54911: 1,
  54912: 1,
  54913: 1,
  54914: 1,
  54915: 1,
  54919: 1,
  54921: 1,
  54922: 1,
  54923: 1,
  54926: 1,
  54927: 1,
  54928: 1,
  54929: 1,
  54931: 1,
  54932: 1,
  54933: 1,
  54934: 1,
  54935: 1,
  54936: 1,
  54937: 1,
  54940: 1,
  54941: 1,
  54942: 1,
  54943: 1,
  54944: 1,
  54945: 1,
  54946: 1,
  54947: 1,
  54948: 1,
  54949: 1,
  54950: 1,
  54952: 1,
  54956: 1,
  54957: 1,
  54960: 1,
  54961: 1,
  54962: 1,
  54963: 1,
  54964: 1,
  54965: 1,
  54966: 1,
  54967: 1,
  54968: 1,
  54969: 1,
  54970: 1,
  54971: 1,
  54974: 1,
  54975: 1,
  54976: 1,
  54977: 1,
  54978: 1,
  54979: 1,
  54980: 1,
  54981: 1,
  54982: 1,
  54983: 1,
  54984: 1,
  54985: 1,
  54986: 1,
  54990: 1,
  55001: 1,
  55002: 1,
  55003: 1,
  55005: 1,
  55006: 1,
  55007: 1,
  55008: 1,
  55009: 1,
  55010: 1,
  55011: 1,
  55012: 1,
  55013: 1,
  55014: 1,
  55016: 1,
  55017: 1,
  55018: 1,
  55019: 1,
  55020: 1,
  55021: 1,
  55024: 1,
  55025: 1,
  55026: 1,
  55027: 1,
  55029: 1,
  55030: 1,
  55031: 1,
  55032: 1,
  55033: 1,
  55036: 1,
  55037: 1,
  55038: 1,
  55040: 1,
  55041: 1,
  55042: 1,
  55043: 1,
  55044: 1,
  55045: 1,
  55046: 1,
  55047: 1,
  55049: 1,
  55051: 1,
  55052: 1,
  55053: 1,
  55054: 1,
  55055: 1,
  55056: 1,
  55057: 1,
  55060: 1,
  55063: 1,
  55065: 1,
  55066: 1,
  55067: 1,
  55068: 1,
  55069: 1,
  55070: 1,
  55071: 1,
  55072: 1,
  55073: 1,
  55074: 1,
  55075: 1,
  55076: 1,
  55077: 1,
  55078: 1,
  55079: 1,
  55080: 1,
  55082: 1,
  55083: 1,
  55084: 1,
  55085: 1,
  55087: 1,
  55088: 1,
  55089: 1,
  55090: 1,
  55092: 1,
  55101: 1,
  55102: 1,
  55103: 1,
  55104: 1,
  55105: 1,
  55106: 1,
  55107: 1,
  55108: 1,
  55109: 1,
  55110: 1,
  55111: 1,
  55112: 1,
  55113: 1,
  55114: 1,
  55115: 1,
  55116: 1,
  55117: 1,
  55118: 1,
  55119: 1,
  55120: 1,
  55121: 1,
  55122: 1,
  55123: 1,
  55124: 1,
  55125: 1,
  55126: 1,
  55127: 1,
  55128: 1,
  55129: 1,
  55130: 1,
  55133: 1,
  55144: 1,
  55145: 1,
  55146: 1,
  55150: 1,
  55155: 1,
  55161: 1,
  55164: 1,
  55165: 1,
  55166: 1,
  55168: 1,
  55169: 1,
  55170: 1,
  55171: 1,
  55172: 1,
  55175: 1,
  55177: 1,
  55182: 1,
  55187: 1,
  55188: 1,
  55190: 1,
  55191: 1,
  55199: 1,
  55301: 1,
  55302: 1,
  55303: 1,
  55304: 1,
  55305: 1,
  55306: 1,
  55307: 1,
  55308: 1,
  55309: 1,
  55310: 1,
  55311: 1,
  55312: 1,
  55313: 1,
  55314: 1,
  55315: 1,
  55316: 1,
  55317: 1,
  55318: 1,
  55319: 1,
  55320: 1,
  55321: 1,
  55322: 1,
  55323: 1,
  55324: 1,
  55325: 1,
  55327: 1,
  55328: 1,
  55329: 1,
  55330: 1,
  55331: 1,
  55332: 1,
  55333: 1,
  55334: 1,
  55335: 1,
  55336: 1,
  55337: 1,
  55338: 1,
  55339: 1,
  55340: 1,
  55341: 1,
  55342: 1,
  55343: 1,
  55344: 1,
  55345: 1,
  55346: 1,
  55347: 1,
  55348: 1,
  55349: 1,
  55350: 1,
  55352: 1,
  55353: 1,
  55354: 1,
  55355: 1,
  55356: 1,
  55357: 1,
  55358: 1,
  55359: 1,
  55360: 1,
  55361: 1,
  55362: 1,
  55363: 1,
  55364: 1,
  55365: 1,
  55366: 1,
  55367: 1,
  55368: 1,
  55369: 1,
  55370: 1,
  55371: 1,
  55372: 1,
  55373: 1,
  55374: 1,
  55375: 1,
  55376: 1,
  55377: 1,
  55378: 1,
  55379: 1,
  55380: 1,
  55381: 1,
  55382: 1,
  55383: 1,
  55384: 1,
  55385: 1,
  55386: 1,
  55387: 1,
  55388: 1,
  55389: 1,
  55390: 1,
  55391: 1,
  55392: 1,
  55393: 1,
  55394: 1,
  55395: 1,
  55396: 1,
  55397: 1,
  55398: 1,
  55399: 1,
  55400: 1,
  55401: 1,
  55402: 1,
  55403: 1,
  55404: 1,
  55405: 1,
  55406: 1,
  55407: 1,
  55408: 1,
  55409: 1,
  55410: 1,
  55411: 1,
  55412: 1,
  55413: 1,
  55414: 1,
  55415: 1,
  55416: 1,
  55417: 1,
  55418: 1,
  55419: 1,
  55420: 1,
  55421: 1,
  55422: 1,
  55423: 1,
  55424: 1,
  55425: 1,
  55426: 1,
  55427: 1,
  55428: 1,
  55429: 1,
  55430: 1,
  55431: 1,
  55432: 1,
  55433: 1,
  55434: 1,
  55435: 1,
  55436: 1,
  55437: 1,
  55438: 1,
  55439: 1,
  55440: 1,
  55441: 1,
  55442: 1,
  55443: 1,
  55444: 1,
  55445: 1,
  55446: 1,
  55447: 1,
  55448: 1,
  55449: 1,
  55450: 1,
  55454: 1,
  55455: 1,
  55458: 1,
  55459: 1,
  55460: 1,
  55467: 1,
  55468: 1,
  55470: 1,
  55472: 1,
  55473: 1,
  55474: 1,
  55478: 1,
  55479: 1,
  55480: 1,
  55483: 1,
  55484: 1,
  55485: 1,
  55486: 1,
  55487: 1,
  55488: 1,
  55550: 1,
  55551: 1,
  55552: 1,
  55553: 1,
  55554: 1,
  55555: 1,
  55556: 1,
  55557: 1,
  55558: 1,
  55559: 1,
  55560: 1,
  55561: 1,
  55562: 1,
  55563: 1,
  55564: 1,
  55565: 1,
  55566: 1,
  55567: 1,
  55568: 1,
  55569: 1,
  55570: 1,
  55571: 1,
  55572: 1,
  55573: 1,
  55574: 1,
  55575: 1,
  55576: 1,
  55577: 1,
  55578: 1,
  55579: 1,
  55580: 1,
  55581: 1,
  55582: 1,
  55583: 1,
  55584: 1,
  55585: 1,
  55586: 1,
  55587: 1,
  55588: 1,
  55589: 1,
  55590: 1,
  55591: 1,
  55592: 1,
  55593: 1,
  55594: 1,
  55595: 1,
  55596: 1,
  55597: 1,
  55598: 1,
  55599: 1,
  55601: 1,
  55602: 1,
  55603: 1,
  55604: 1,
  55605: 1,
  55606: 1,
  55607: 1,
  55609: 1,
  55612: 1,
  55613: 1,
  55614: 1,
  55615: 1,
  55616: 1,
  55701: 1,
  55702: 1,
  55703: 1,
  55704: 1,
  55705: 1,
  55706: 1,
  55707: 1,
  55708: 1,
  55709: 1,
  55710: 1,
  55711: 1,
  55712: 1,
  55713: 1,
  55716: 1,
  55717: 1,
  55718: 1,
  55719: 1,
  55720: 1,
  55721: 1,
  55722: 1,
  55723: 1,
  55724: 1,
  55725: 1,
  55726: 1,
  55730: 1,
  55731: 1,
  55732: 1,
  55733: 1,
  55734: 1,
  55735: 1,
  55736: 1,
  55738: 1,
  55741: 1,
  55742: 1,
  55744: 1,
  55745: 1,
  55746: 1,
  55747: 1,
  55748: 1,
  55749: 1,
  55750: 1,
  55751: 1,
  55752: 1,
  55753: 1,
  55756: 1,
  55757: 1,
  55758: 1,
  55760: 1,
  55763: 1,
  55764: 1,
  55765: 1,
  55766: 1,
  55767: 1,
  55768: 1,
  55769: 1,
  55771: 1,
  55772: 1,
  55775: 1,
  55777: 1,
  55779: 1,
  55780: 1,
  55781: 1,
  55782: 1,
  55783: 1,
  55784: 1,
  55785: 1,
  55786: 1,
  55787: 1,
  55790: 1,
  55791: 1,
  55792: 1,
  55793: 1,
  55795: 1,
  55796: 1,
  55797: 1,
  55798: 1,
  55801: 1,
  55802: 1,
  55803: 1,
  55804: 1,
  55805: 1,
  55806: 1,
  55807: 1,
  55808: 1,
  55810: 1,
  55811: 1,
  55812: 1,
  55814: 1,
  55815: 1,
  55816: 1,
  55901: 1,
  55902: 1,
  55903: 1,
  55904: 1,
  55905: 1,
  55906: 1,
  55909: 1,
  55910: 1,
  55912: 1,
  55917: 1,
  55918: 1,
  55919: 1,
  55920: 1,
  55921: 1,
  55922: 1,
  55923: 1,
  55924: 1,
  55925: 1,
  55926: 1,
  55927: 1,
  55929: 1,
  55931: 1,
  55932: 1,
  55933: 1,
  55934: 1,
  55935: 1,
  55936: 1,
  55939: 1,
  55940: 1,
  55941: 1,
  55942: 1,
  55943: 1,
  55944: 1,
  55945: 1,
  55946: 1,
  55947: 1,
  55949: 1,
  55950: 1,
  55951: 1,
  55952: 1,
  55953: 1,
  55954: 1,
  55955: 1,
  55956: 1,
  55957: 1,
  55959: 1,
  55960: 1,
  55961: 1,
  55962: 1,
  55963: 1,
  55964: 1,
  55965: 1,
  55967: 1,
  55968: 1,
  55969: 1,
  55970: 1,
  55971: 1,
  55972: 1,
  55973: 1,
  55974: 1,
  55975: 1,
  55976: 1,
  55977: 1,
  55979: 1,
  55981: 1,
  55982: 1,
  55983: 1,
  55985: 1,
  55987: 1,
  55988: 1,
  55990: 1,
  55991: 1,
  55992: 1,
  56001: 1,
  56002: 1,
  56003: 1,
  56006: 1,
  56007: 1,
  56009: 1,
  56010: 1,
  56011: 1,
  56013: 1,
  56014: 1,
  56016: 1,
  56017: 1,
  56019: 1,
  56020: 1,
  56021: 1,
  56022: 1,
  56023: 1,
  56024: 1,
  56025: 1,
  56026: 1,
  56027: 1,
  56028: 1,
  56029: 1,
  56030: 1,
  56031: 1,
  56032: 1,
  56033: 1,
  56034: 1,
  56035: 1,
  56036: 1,
  56037: 1,
  56039: 1,
  56041: 1,
  56042: 1,
  56043: 1,
  56044: 1,
  56045: 1,
  56046: 1,
  56047: 1,
  56048: 1,
  56050: 1,
  56051: 1,
  56052: 1,
  56054: 1,
  56055: 1,
  56056: 1,
  56057: 1,
  56058: 1,
  56060: 1,
  56062: 1,
  56063: 1,
  56065: 1,
  56068: 1,
  56069: 1,
  56071: 1,
  56072: 1,
  56073: 1,
  56074: 1,
  56075: 1,
  56078: 1,
  56080: 1,
  56081: 1,
  56082: 1,
  56083: 1,
  56084: 1,
  56085: 1,
  56087: 1,
  56088: 1,
  56089: 1,
  56090: 1,
  56091: 1,
  56093: 1,
  56096: 1,
  56097: 1,
  56098: 1,
  56101: 1,
  56110: 1,
  56111: 1,
  56113: 1,
  56114: 1,
  56115: 1,
  56116: 1,
  56117: 1,
  56118: 1,
  56119: 1,
  56120: 1,
  56121: 1,
  56122: 1,
  56123: 1,
  56125: 1,
  56127: 1,
  56128: 1,
  56129: 1,
  56131: 1,
  56132: 1,
  56134: 1,
  56136: 1,
  56137: 1,
  56138: 1,
  56139: 1,
  56140: 1,
  56141: 1,
  56142: 1,
  56143: 1,
  56144: 1,
  56145: 1,
  56146: 1,
  56147: 1,
  56149: 1,
  56150: 1,
  56151: 1,
  56152: 1,
  56153: 1,
  56155: 1,
  56156: 1,
  56157: 1,
  56158: 1,
  56159: 1,
  56160: 1,
  56161: 1,
  56162: 1,
  56164: 1,
  56165: 1,
  56166: 1,
  56167: 1,
  56168: 1,
  56169: 1,
  56170: 1,
  56171: 1,
  56172: 1,
  56173: 1,
  56174: 1,
  56175: 1,
  56176: 1,
  56177: 1,
  56178: 1,
  56180: 1,
  56181: 1,
  56183: 1,
  56185: 1,
  56186: 1,
  56187: 1,
  56201: 1,
  56207: 1,
  56208: 1,
  56209: 1,
  56210: 1,
  56211: 1,
  56212: 1,
  56214: 1,
  56215: 1,
  56216: 1,
  56218: 1,
  56219: 1,
  56220: 1,
  56221: 1,
  56222: 1,
  56223: 1,
  56224: 1,
  56225: 1,
  56226: 1,
  56227: 1,
  56228: 1,
  56229: 1,
  56230: 1,
  56231: 1,
  56232: 1,
  56235: 1,
  56236: 1,
  56237: 1,
  56239: 1,
  56240: 1,
  56241: 1,
  56243: 1,
  56244: 1,
  56245: 1,
  56248: 1,
  56249: 1,
  56251: 1,
  56252: 1,
  56253: 1,
  56255: 1,
  56256: 1,
  56257: 1,
  56258: 1,
  56260: 1,
  56262: 1,
  56263: 1,
  56264: 1,
  56265: 1,
  56266: 1,
  56267: 1,
  56270: 1,
  56271: 1,
  56273: 1,
  56274: 1,
  56276: 1,
  56277: 1,
  56278: 1,
  56279: 1,
  56280: 1,
  56281: 1,
  56282: 1,
  56283: 1,
  56284: 1,
  56285: 1,
  56287: 1,
  56288: 1,
  56289: 1,
  56291: 1,
  56292: 1,
  56293: 1,
  56294: 1,
  56295: 1,
  56296: 1,
  56297: 1,
  56301: 1,
  56302: 1,
  56303: 1,
  56304: 1,
  56307: 1,
  56308: 1,
  56309: 1,
  56310: 1,
  56311: 1,
  56312: 1,
  56313: 1,
  56314: 1,
  56315: 1,
  56316: 1,
  56317: 1,
  56318: 1,
  56319: 1,
  56320: 1,
  56321: 1,
  56323: 1,
  56324: 1,
  56325: 1,
  56326: 1,
  56327: 1,
  56328: 1,
  56329: 1,
  56330: 1,
  56331: 1,
  56332: 1,
  56333: 1,
  56334: 1,
  56335: 1,
  56336: 1,
  56338: 1,
  56339: 1,
  56340: 1,
  56341: 1,
  56342: 1,
  56343: 1,
  56344: 1,
  56345: 1,
  56347: 1,
  56349: 1,
  56350: 1,
  56352: 1,
  56353: 1,
  56354: 1,
  56355: 1,
  56356: 1,
  56357: 1,
  56358: 1,
  56359: 1,
  56360: 1,
  56361: 1,
  56362: 1,
  56363: 1,
  56364: 1,
  56367: 1,
  56368: 1,
  56369: 1,
  56371: 1,
  56372: 1,
  56373: 1,
  56374: 1,
  56375: 1,
  56376: 1,
  56377: 1,
  56378: 1,
  56379: 1,
  56381: 1,
  56382: 1,
  56384: 1,
  56385: 1,
  56386: 1,
  56387: 1,
  56388: 1,
  56389: 1,
  56393: 1,
  56395: 1,
  56396: 1,
  56397: 1,
  56398: 1,
  56399: 1,
  56401: 1,
  56425: 1,
  56430: 1,
  56431: 1,
  56433: 1,
  56434: 1,
  56435: 1,
  56436: 1,
  56437: 1,
  56438: 1,
  56440: 1,
  56441: 1,
  56442: 1,
  56443: 1,
  56444: 1,
  56446: 1,
  56447: 1,
  56448: 1,
  56449: 1,
  56450: 1,
  56452: 1,
  56453: 1,
  56455: 1,
  56456: 1,
  56458: 1,
  56459: 1,
  56461: 1,
  56464: 1,
  56465: 1,
  56466: 1,
  56467: 1,
  56468: 1,
  56469: 1,
  56470: 1,
  56472: 1,
  56473: 1,
  56474: 1,
  56475: 1,
  56477: 1,
  56478: 1,
  56479: 1,
  56481: 1,
  56482: 1,
  56484: 1,
  56501: 1,
  56502: 1,
  56510: 1,
  56511: 1,
  56514: 1,
  56515: 1,
  56516: 1,
  56517: 1,
  56518: 1,
  56519: 1,
  56520: 1,
  56521: 1,
  56522: 1,
  56523: 1,
  56524: 1,
  56525: 1,
  56527: 1,
  56528: 1,
  56529: 1,
  56531: 1,
  56533: 1,
  56534: 1,
  56535: 1,
  56536: 1,
  56537: 1,
  56538: 1,
  56540: 1,
  56541: 1,
  56542: 1,
  56543: 1,
  56544: 1,
  56545: 1,
  56546: 1,
  56547: 1,
  56548: 1,
  56549: 1,
  56550: 1,
  56551: 1,
  56552: 1,
  56553: 1,
  56554: 1,
  56556: 1,
  56557: 1,
  56560: 1,
  56561: 1,
  56562: 1,
  56563: 1,
  56565: 1,
  56566: 1,
  56567: 1,
  56568: 1,
  56569: 1,
  56570: 1,
  56571: 1,
  56572: 1,
  56573: 1,
  56574: 1,
  56575: 1,
  56576: 1,
  56577: 1,
  56578: 1,
  56579: 1,
  56580: 1,
  56581: 1,
  56583: 1,
  56584: 1,
  56585: 1,
  56586: 1,
  56587: 1,
  56588: 1,
  56589: 1,
  56590: 1,
  56591: 1,
  56592: 1,
  56593: 1,
  56594: 1,
  56601: 1,
  56619: 1,
  56621: 1,
  56623: 1,
  56626: 1,
  56627: 1,
  56628: 1,
  56629: 1,
  56630: 1,
  56631: 1,
  56633: 1,
  56634: 1,
  56636: 1,
  56637: 1,
  56639: 1,
  56641: 1,
  56644: 1,
  56646: 1,
  56647: 1,
  56649: 1,
  56650: 1,
  56651: 1,
  56652: 1,
  56653: 1,
  56654: 1,
  56655: 1,
  56657: 1,
  56658: 1,
  56659: 1,
  56660: 1,
  56661: 1,
  56662: 1,
  56663: 1,
  56666: 1,
  56667: 1,
  56668: 1,
  56669: 1,
  56670: 1,
  56671: 1,
  56672: 1,
  56673: 1,
  56676: 1,
  56678: 1,
  56679: 1,
  56680: 1,
  56681: 1,
  56682: 1,
  56683: 1,
  56684: 1,
  56685: 1,
  56686: 1,
  56687: 1,
  56688: 1,
  56701: 1,
  56710: 1,
  56711: 1,
  56713: 1,
  56714: 1,
  56715: 1,
  56716: 1,
  56720: 1,
  56721: 1,
  56722: 1,
  56723: 1,
  56724: 1,
  56725: 1,
  56726: 1,
  56727: 1,
  56728: 1,
  56729: 1,
  56731: 1,
  56732: 1,
  56733: 1,
  56734: 1,
  56735: 1,
  56736: 1,
  56737: 1,
  56738: 1,
  56740: 1,
  56741: 1,
  56742: 1,
  56744: 1,
  56748: 1,
  56750: 1,
  56751: 1,
  56754: 1,
  56755: 1,
  56756: 1,
  56757: 1,
  56758: 1,
  56759: 1,
  56760: 1,
  56761: 1,
  56762: 1,
  56763: 1,
  56901: 0,
  56902: 0,
  56904: 0,
  56915: 0,
  56920: 0,
  56933: 0,
  56944: 0,
  56945: 0,
  56950: 0,
  56965: 0,
  56972: 0,
  57001: 1,
  57002: 1,
  57003: 1,
  57004: 1,
  57005: 1,
  57006: 1,
  57007: 1,
  57010: 1,
  57012: 1,
  57013: 1,
  57014: 1,
  57015: 1,
  57017: 1,
  57018: 1,
  57020: 1,
  57021: 1,
  57022: 1,
  57024: 1,
  57025: 1,
  57026: 1,
  57027: 1,
  57028: 1,
  57029: 1,
  57030: 1,
  57031: 1,
  57032: 1,
  57033: 1,
  57034: 1,
  57035: 1,
  57036: 1,
  57037: 1,
  57038: 1,
  57039: 1,
  57040: 1,
  57041: 1,
  57042: 1,
  57043: 1,
  57044: 1,
  57045: 1,
  57046: 1,
  57047: 1,
  57048: 1,
  57049: 1,
  57050: 1,
  57051: 1,
  57052: 1,
  57053: 1,
  57054: 1,
  57055: 1,
  57056: 1,
  57057: 1,
  57058: 1,
  57059: 1,
  57061: 1,
  57062: 1,
  57063: 1,
  57064: 1,
  57065: 1,
  57066: 1,
  57067: 1,
  57068: 1,
  57069: 1,
  57070: 1,
  57071: 1,
  57072: 1,
  57073: 1,
  57075: 1,
  57076: 1,
  57077: 1,
  57078: 1,
  57079: 1,
  57101: 1,
  57103: 1,
  57104: 1,
  57105: 1,
  57106: 1,
  57107: 1,
  57108: 1,
  57109: 1,
  57110: 1,
  57117: 1,
  57118: 1,
  57186: 1,
  57188: 1,
  57189: 1,
  57192: 1,
  57193: 1,
  57194: 1,
  57195: 1,
  57196: 1,
  57197: 1,
  57198: 1,
  57201: 1,
  57212: 1,
  57213: 1,
  57214: 1,
  57216: 1,
  57217: 1,
  57218: 1,
  57219: 1,
  57220: 1,
  57221: 1,
  57224: 1,
  57225: 1,
  57226: 1,
  57227: 1,
  57231: 1,
  57232: 1,
  57233: 1,
  57234: 1,
  57235: 1,
  57236: 1,
  57237: 1,
  57238: 1,
  57239: 1,
  57241: 1,
  57242: 1,
  57243: 1,
  57245: 1,
  57246: 1,
  57247: 1,
  57248: 1,
  57249: 1,
  57251: 1,
  57252: 1,
  57253: 1,
  57255: 1,
  57256: 1,
  57257: 1,
  57258: 1,
  57259: 1,
  57260: 1,
  57261: 1,
  57262: 1,
  57263: 1,
  57264: 1,
  57265: 1,
  57266: 1,
  57268: 1,
  57269: 1,
  57270: 1,
  57271: 1,
  57272: 1,
  57273: 1,
  57274: 1,
  57276: 1,
  57278: 1,
  57279: 1,
  57301: 1,
  57311: 1,
  57312: 1,
  57313: 1,
  57314: 1,
  57315: 1,
  57317: 1,
  57319: 1,
  57321: 1,
  57322: 1,
  57323: 1,
  57324: 1,
  57325: 1,
  57326: 1,
  57328: 1,
  57329: 1,
  57330: 1,
  57331: 1,
  57332: 1,
  57334: 1,
  57335: 1,
  57337: 1,
  57339: 1,
  57340: 1,
  57341: 1,
  57342: 1,
  57344: 1,
  57345: 1,
  57346: 1,
  57348: 1,
  57349: 1,
  57350: 1,
  57353: 1,
  57354: 1,
  57355: 1,
  57356: 1,
  57358: 1,
  57359: 1,
  57361: 1,
  57362: 1,
  57363: 1,
  57364: 1,
  57365: 1,
  57366: 1,
  57367: 1,
  57368: 1,
  57369: 1,
  57370: 1,
  57371: 1,
  57373: 1,
  57374: 1,
  57375: 1,
  57376: 1,
  57379: 1,
  57380: 1,
  57381: 1,
  57382: 1,
  57383: 1,
  57384: 1,
  57385: 1,
  57386: 1,
  57399: 1,
  57401: 1,
  57402: 1,
  57420: 1,
  57421: 1,
  57422: 1,
  57424: 1,
  57426: 1,
  57427: 1,
  57428: 1,
  57429: 1,
  57430: 1,
  57432: 1,
  57433: 1,
  57434: 1,
  57435: 1,
  57436: 1,
  57437: 1,
  57438: 1,
  57439: 1,
  57440: 1,
  57441: 1,
  57442: 1,
  57445: 1,
  57446: 1,
  57448: 1,
  57449: 1,
  57450: 1,
  57451: 1,
  57452: 1,
  57454: 1,
  57455: 1,
  57456: 1,
  57457: 1,
  57460: 1,
  57461: 1,
  57465: 1,
  57466: 1,
  57467: 1,
  57468: 1,
  57469: 1,
  57470: 1,
  57471: 1,
  57472: 1,
  57473: 1,
  57474: 1,
  57475: 1,
  57476: 1,
  57477: 1,
  57479: 1,
  57481: 1,
  57501: 1,
  57520: 1,
  57521: 2,
  57522: 1,
  57523: 1,
  57528: 1,
  57529: 1,
  57531: 1,
  57532: 1,
  57533: 1,
  57534: 1,
  57536: 1,
  57537: 2,
  57538: 1,
  57540: 1,
  57541: 1,
  57542: 1,
  57543: 2,
  57544: 1,
  57547: 2,
  57548: 1,
  57551: 2,
  57552: 2,
  57553: 2,
  57555: 2,
  57559: 1,
  57560: 2,
  57562: 2,
  57563: 2,
  57564: 1,
  57566: 2,
  57567: 2,
  57568: 1,
  57569: 1,
  57570: 2,
  57571: 1,
  57572: 2,
  57574: 2,
  57576: 1,
  57577: 2,
  57579: 2,
  57580: 1,
  57584: 1,
  57585: 2,
  57601: 1,
  57620: 2,
  57621: 2,
  57622: 2,
  57623: 2,
  57625: 2,
  57626: 2,
  57630: 2,
  57631: 1,
  57632: 1,
  57633: 2,
  57634: 2,
  57636: 2,
  57638: 2,
  57639: 2,
  57640: 2,
  57641: 2,
  57642: 2,
  57644: 2,
  57645: 2,
  57646: 1,
  57648: 1,
  57649: 2,
  57650: 2,
  57651: 2,
  57652: 2,
  57656: 2,
  57657: 2,
  57658: 2,
  57659: 2,
  57660: 2,
  57661: 2,
  57701: 2,
  57702: 2,
  57703: 2,
  57706: 2,
  57709: 2,
  57714: 2,
  57716: 2,
  57717: 2,
  57718: 2,
  57719: 2,
  57720: 2,
  57722: 2,
  57724: 2,
  57725: 2,
  57730: 2,
  57735: 2,
  57736: 2,
  57737: 2,
  57738: 2,
  57741: 2,
  57744: 2,
  57745: 2,
  57747: 2,
  57748: 2,
  57751: 2,
  57752: 2,
  57754: 2,
  57755: 2,
  57756: 2,
  57758: 2,
  57759: 2,
  57760: 2,
  57761: 2,
  57762: 2,
  57763: 2,
  57764: 2,
  57766: 2,
  57767: 2,
  57769: 2,
  57770: 2,
  57772: 2,
  57773: 2,
  57775: 2,
  57776: 2,
  57777: 2,
  57779: 2,
  57780: 2,
  57782: 2,
  57783: 2,
  57785: 2,
  57787: 2,
  57788: 2,
  57790: 2,
  57791: 2,
  57792: 2,
  57793: 2,
  57794: 2,
  57799: 2,
  58001: 1,
  58002: 1,
  58004: 1,
  58005: 1,
  58006: 1,
  58007: 1,
  58008: 1,
  58009: 1,
  58011: 1,
  58012: 1,
  58013: 1,
  58015: 1,
  58016: 1,
  58017: 1,
  58018: 1,
  58021: 1,
  58027: 1,
  58029: 1,
  58030: 1,
  58031: 1,
  58032: 1,
  58033: 1,
  58035: 1,
  58036: 1,
  58038: 1,
  58040: 1,
  58041: 1,
  58042: 1,
  58043: 1,
  58045: 1,
  58046: 1,
  58047: 1,
  58048: 1,
  58049: 1,
  58051: 1,
  58052: 1,
  58053: 1,
  58054: 1,
  58056: 1,
  58057: 1,
  58058: 1,
  58059: 1,
  58060: 1,
  58061: 1,
  58062: 1,
  58063: 1,
  58064: 1,
  58065: 1,
  58067: 1,
  58068: 1,
  58069: 1,
  58071: 1,
  58072: 1,
  58074: 1,
  58075: 1,
  58076: 1,
  58077: 1,
  58078: 1,
  58079: 1,
  58081: 1,
  58102: 1,
  58103: 1,
  58104: 1,
  58105: 1,
  58106: 1,
  58107: 1,
  58108: 1,
  58109: 1,
  58121: 1,
  58122: 1,
  58123: 1,
  58124: 1,
  58125: 1,
  58126: 1,
  58201: 1,
  58202: 1,
  58203: 1,
  58204: 1,
  58205: 1,
  58206: 1,
  58207: 1,
  58208: 1,
  58210: 1,
  58212: 1,
  58214: 1,
  58216: 1,
  58218: 1,
  58219: 1,
  58220: 1,
  58222: 1,
  58223: 1,
  58224: 1,
  58225: 1,
  58227: 1,
  58228: 1,
  58229: 1,
  58230: 1,
  58231: 1,
  58233: 1,
  58235: 1,
  58236: 1,
  58237: 1,
  58238: 1,
  58239: 1,
  58240: 1,
  58241: 1,
  58243: 1,
  58244: 1,
  58249: 1,
  58250: 1,
  58251: 1,
  58254: 1,
  58255: 1,
  58256: 1,
  58257: 1,
  58258: 1,
  58259: 1,
  58260: 1,
  58261: 1,
  58262: 1,
  58265: 1,
  58266: 1,
  58267: 1,
  58269: 1,
  58270: 1,
  58271: 1,
  58272: 1,
  58273: 1,
  58274: 1,
  58275: 1,
  58276: 1,
  58277: 1,
  58278: 1,
  58281: 1,
  58282: 1,
  58301: 1,
  58310: 1,
  58311: 1,
  58313: 1,
  58316: 1,
  58317: 1,
  58318: 1,
  58319: 1,
  58321: 1,
  58323: 1,
  58324: 1,
  58325: 1,
  58327: 1,
  58329: 1,
  58330: 1,
  58331: 1,
  58332: 1,
  58335: 1,
  58337: 1,
  58338: 1,
  58339: 1,
  58341: 1,
  58343: 1,
  58344: 1,
  58345: 1,
  58346: 1,
  58348: 1,
  58351: 1,
  58352: 1,
  58353: 1,
  58355: 1,
  58356: 1,
  58357: 1,
  58359: 1,
  58361: 1,
  58362: 1,
  58363: 1,
  58365: 1,
  58366: 1,
  58367: 1,
  58368: 1,
  58369: 1,
  58370: 1,
  58372: 1,
  58374: 1,
  58377: 1,
  58379: 1,
  58380: 1,
  58381: 1,
  58382: 1,
  58384: 1,
  58385: 1,
  58386: 1,
  58401: 1,
  58402: 1,
  58405: 1,
  58413: 1,
  58415: 1,
  58416: 1,
  58418: 1,
  58420: 1,
  58421: 1,
  58422: 1,
  58423: 1,
  58424: 1,
  58425: 1,
  58426: 1,
  58428: 1,
  58429: 1,
  58430: 1,
  58431: 1,
  58433: 1,
  58436: 1,
  58438: 1,
  58439: 1,
  58440: 1,
  58441: 1,
  58442: 1,
  58443: 1,
  58444: 1,
  58445: 1,
  58448: 1,
  58451: 1,
  58452: 1,
  58454: 1,
  58455: 1,
  58456: 1,
  58458: 1,
  58460: 1,
  58461: 1,
  58463: 1,
  58464: 1,
  58466: 1,
  58467: 1,
  58472: 1,
  58474: 1,
  58475: 1,
  58476: 1,
  58477: 1,
  58478: 1,
  58479: 1,
  58480: 1,
  58481: 1,
  58482: 1,
  58483: 1,
  58484: 1,
  58486: 1,
  58487: 1,
  58488: 1,
  58490: 1,
  58492: 1,
  58494: 1,
  58495: 1,
  58496: 1,
  58497: 1,
  58501: 1,
  58502: 1,
  58503: 1,
  58504: 1,
  58505: 1,
  58506: 1,
  58507: 1,
  58520: 2,
  58521: 1,
  58523: 2,
  58524: 1,
  58528: 2,
  58529: 2,
  58530: 23,
  58531: 1,
  58532: 1,
  58533: 2,
  58535: 2,
  58538: 2,
  58540: 1,
  58541: 2,
  58542: 1,
  58544: 1,
  58545: 2,
  58549: 1,
  58552: 1,
  58554: 2,
  58558: 1,
  58559: 1,
  58560: 1,
  58561: 1,
  58562: 2,
  58563: 2,
  58564: 2,
  58565: 1,
  58566: 2,
  58568: 2,
  58569: 2,
  58570: 2,
  58571: 2,
  58572: 1,
  58573: 1,
  58575: 1,
  58576: 1,
  58577: 1,
  58579: 1,
  58580: 2,
  58581: 1,
  58601: 2,
  58602: 2,
  58620: 2,
  58621: 2,
  58622: 2,
  58623: 2,
  58625: 2,
  58626: 2,
  58627: 2,
  58630: 2,
  58631: 2,
  58632: 2,
  58634: 2,
  58636: 2,
  58638: 2,
  58639: 2,
  58640: 2,
  58641: 2,
  58642: 2,
  58643: 2,
  58644: 2,
  58645: 2,
  58646: 2,
  58647: 2,
  58649: 2,
  58650: 2,
  58651: 2,
  58652: 2,
  58653: 2,
  58654: 2,
  58655: 2,
  58656: 2,
  58701: 1,
  58702: 1,
  58703: 1,
  58704: 1,
  58705: 1,
  58707: 1,
  58710: 1,
  58711: 1,
  58712: 1,
  58713: 1,
  58716: 1,
  58718: 1,
  58721: 1,
  58722: 1,
  58723: 1,
  58725: 1,
  58727: 1,
  58730: 1,
  58731: 1,
  58733: 1,
  58734: 1,
  58735: 1,
  58736: 1,
  58737: 1,
  58740: 1,
  58741: 1,
  58744: 1,
  58746: 1,
  58747: 1,
  58748: 1,
  58750: 1,
  58752: 1,
  58755: 1,
  58756: 1,
  58757: 1,
  58758: 1,
  58759: 1,
  58760: 1,
  58761: 1,
  58762: 1,
  58763: 1,
  58765: 1,
  58768: 1,
  58769: 1,
  58770: 1,
  58771: 1,
  58772: 1,
  58773: 1,
  58775: 1,
  58776: 1,
  58778: 1,
  58779: 1,
  58781: 1,
  58782: 1,
  58783: 1,
  58784: 1,
  58785: 1,
  58787: 1,
  58788: 1,
  58789: 1,
  58790: 1,
  58792: 1,
  58793: 1,
  58794: 1,
  58795: 1,
  58801: 1,
  58802: 1,
  58830: 1,
  58831: 1,
  58833: 1,
  58835: 1,
  58838: 1,
  58843: 1,
  58844: 1,
  58845: 1,
  58847: 1,
  58849: 1,
  58852: 1,
  58853: 1,
  58854: 1,
  58856: 1,
  59001: 2,
  59003: 2,
  59004: 2,
  59006: 2,
  59007: 2,
  59008: 2,
  59010: 2,
  59011: 2,
  59012: 2,
  59013: 2,
  59014: 2,
  59015: 2,
  59016: 2,
  59018: 2,
  59019: 2,
  59020: 2,
  59022: 2,
  59024: 2,
  59025: 2,
  59026: 2,
  59027: 2,
  59028: 2,
  59029: 2,
  59030: 2,
  59031: 2,
  59032: 2,
  59033: 2,
  59034: 2,
  59035: 2,
  59036: 2,
  59037: 2,
  59038: 2,
  59039: 2,
  59041: 2,
  59043: 2,
  59044: 2,
  59046: 2,
  59047: 2,
  59050: 2,
  59052: 2,
  59053: 2,
  59054: 2,
  59055: 2,
  59057: 2,
  59058: 2,
  59059: 2,
  59061: 2,
  59062: 2,
  59063: 2,
  59064: 2,
  59065: 2,
  59066: 2,
  59067: 2,
  59068: 2,
  59069: 2,
  59070: 2,
  59071: 2,
  59072: 2,
  59073: 2,
  59074: 2,
  59075: 2,
  59076: 2,
  59077: 2,
  59078: 2,
  59079: 2,
  59081: 2,
  59082: 2,
  59083: 2,
  59084: 2,
  59085: 2,
  59086: 2,
  59087: 2,
  59088: 2,
  59089: 2,
  59101: 2,
  59102: 2,
  59103: 2,
  59104: 2,
  59105: 2,
  59106: 2,
  59107: 2,
  59108: 2,
  59111: 2,
  59112: 2,
  59114: 2,
  59115: 2,
  59116: 2,
  59117: 2,
  59201: 2,
  59211: 2,
  59212: 2,
  59213: 2,
  59214: 2,
  59215: 2,
  59217: 2,
  59218: 2,
  59219: 2,
  59221: 2,
  59222: 2,
  59223: 2,
  59225: 2,
  59226: 2,
  59230: 2,
  59231: 2,
  59240: 2,
  59241: 2,
  59242: 2,
  59243: 2,
  59244: 2,
  59247: 2,
  59248: 2,
  59250: 2,
  59252: 2,
  59253: 2,
  59254: 2,
  59255: 2,
  59256: 2,
  59257: 2,
  59258: 2,
  59259: 2,
  59260: 2,
  59261: 2,
  59262: 2,
  59263: 2,
  59270: 2,
  59273: 2,
  59274: 2,
  59275: 2,
  59276: 2,
  59301: 2,
  59311: 2,
  59312: 2,
  59313: 2,
  59314: 2,
  59315: 2,
  59316: 2,
  59317: 2,
  59318: 2,
  59319: 2,
  59322: 2,
  59323: 2,
  59324: 2,
  59326: 2,
  59327: 2,
  59330: 2,
  59332: 2,
  59333: 2,
  59336: 2,
  59337: 2,
  59338: 2,
  59339: 2,
  59341: 2,
  59343: 2,
  59344: 2,
  59345: 2,
  59347: 2,
  59349: 2,
  59351: 2,
  59353: 2,
  59354: 2,
  59401: 2,
  59402: 2,
  59403: 2,
  59404: 2,
  59405: 2,
  59406: 2,
  59410: 2,
  59411: 2,
  59412: 2,
  59414: 2,
  59416: 2,
  59417: 2,
  59418: 2,
  59419: 2,
  59420: 2,
  59421: 2,
  59422: 2,
  59424: 2,
  59425: 2,
  59427: 2,
  59430: 2,
  59432: 2,
  59433: 2,
  59434: 2,
  59435: 2,
  59436: 2,
  59440: 2,
  59441: 2,
  59442: 2,
  59443: 2,
  59444: 2,
  59445: 2,
  59446: 2,
  59447: 2,
  59448: 2,
  59450: 2,
  59451: 2,
  59452: 2,
  59453: 2,
  59454: 2,
  59456: 2,
  59457: 2,
  59460: 2,
  59461: 2,
  59462: 2,
  59463: 2,
  59464: 2,
  59465: 2,
  59466: 2,
  59467: 2,
  59468: 2,
  59469: 2,
  59471: 2,
  59472: 2,
  59474: 2,
  59477: 2,
  59479: 2,
  59480: 2,
  59482: 2,
  59483: 2,
  59484: 2,
  59485: 2,
  59486: 2,
  59487: 2,
  59489: 2,
  59501: 2,
  59520: 2,
  59521: 2,
  59522: 2,
  59523: 2,
  59524: 2,
  59525: 2,
  59526: 2,
  59527: 2,
  59528: 2,
  59529: 2,
  59530: 2,
  59531: 2,
  59532: 2,
  59535: 2,
  59537: 2,
  59538: 2,
  59540: 2,
  59542: 2,
  59544: 2,
  59545: 2,
  59546: 2,
  59547: 2,
  59601: 2,
  59602: 2,
  59604: 2,
  59620: 2,
  59623: 2,
  59624: 2,
  59625: 2,
  59626: 2,
  59631: 2,
  59632: 2,
  59633: 2,
  59634: 2,
  59635: 2,
  59636: 2,
  59638: 2,
  59639: 2,
  59640: 2,
  59641: 2,
  59642: 2,
  59643: 2,
  59644: 2,
  59645: 2,
  59647: 2,
  59648: 2,
  59701: 2,
  59702: 2,
  59703: 2,
  59707: 2,
  59710: 2,
  59711: 2,
  59713: 2,
  59714: 2,
  59715: 2,
  59716: 2,
  59717: 2,
  59718: 2,
  59719: 2,
  59720: 2,
  59721: 2,
  59722: 2,
  59724: 2,
  59725: 2,
  59727: 2,
  59728: 2,
  59729: 2,
  59730: 2,
  59731: 2,
  59732: 2,
  59733: 2,
  59735: 2,
  59736: 2,
  59739: 2,
  59740: 2,
  59741: 2,
  59743: 2,
  59745: 2,
  59746: 2,
  59747: 2,
  59748: 2,
  59749: 2,
  59750: 2,
  59751: 2,
  59752: 2,
  59754: 2,
  59755: 2,
  59756: 2,
  59758: 2,
  59759: 2,
  59760: 2,
  59761: 2,
  59762: 2,
  59771: 2,
  59772: 2,
  59773: 2,
  59801: 2,
  59802: 2,
  59803: 2,
  59804: 2,
  59806: 2,
  59807: 2,
  59808: 2,
  59812: 2,
  59820: 2,
  59821: 2,
  59823: 2,
  59824: 2,
  59825: 2,
  59826: 2,
  59827: 2,
  59828: 2,
  59829: 2,
  59830: 2,
  59831: 2,
  59832: 2,
  59833: 2,
  59834: 2,
  59835: 2,
  59837: 2,
  59840: 2,
  59841: 2,
  59842: 2,
  59843: 2,
  59844: 2,
  59845: 2,
  59846: 2,
  59847: 2,
  59848: 2,
  59851: 2,
  59853: 2,
  59854: 2,
  59855: 2,
  59856: 2,
  59858: 2,
  59859: 2,
  59860: 2,
  59863: 2,
  59864: 2,
  59865: 2,
  59866: 2,
  59867: 2,
  59868: 2,
  59870: 2,
  59871: 2,
  59872: 2,
  59873: 2,
  59874: 2,
  59875: 2,
  59901: 2,
  59902: 2,
  59903: 2,
  59904: 2,
  59910: 2,
  59911: 2,
  59912: 2,
  59913: 2,
  59914: 2,
  59915: 2,
  59916: 2,
  59917: 2,
  59918: 2,
  59919: 2,
  59920: 2,
  59921: 2,
  59922: 2,
  59923: 2,
  59925: 2,
  59926: 2,
  59927: 2,
  59928: 2,
  59929: 2,
  59930: 2,
  59931: 2,
  59932: 2,
  59933: 2,
  59934: 2,
  59935: 2,
  59936: 2,
  59937: 2,
  60001: 1,
  60002: 1,
  60004: 1,
  60005: 1,
  60006: 1,
  60007: 1,
  60008: 1,
  60009: 1,
  60010: 1,
  60011: 1,
  60012: 1,
  60013: 1,
  60014: 1,
  60015: 1,
  60016: 1,
  60017: 1,
  60018: 1,
  60019: 1,
  60020: 1,
  60021: 1,
  60022: 1,
  60025: 1,
  60026: 1,
  60029: 1,
  60030: 1,
  60031: 1,
  60033: 1,
  60034: 1,
  60035: 1,
  60037: 1,
  60038: 1,
  60039: 1,
  60040: 1,
  60041: 1,
  60042: 1,
  60043: 1,
  60044: 1,
  60045: 1,
  60046: 1,
  60047: 1,
  60048: 1,
  60049: 1,
  60050: 1,
  60051: 1,
  60053: 1,
  60055: 1,
  60056: 1,
  60060: 1,
  60061: 1,
  60062: 1,
  60064: 1,
  60065: 1,
  60067: 1,
  60068: 1,
  60069: 1,
  60070: 1,
  60071: 1,
  60072: 1,
  60073: 1,
  60074: 1,
  60075: 1,
  60076: 1,
  60077: 1,
  60078: 1,
  60079: 1,
  60081: 1,
  60082: 1,
  60083: 1,
  60084: 1,
  60085: 1,
  60086: 1,
  60087: 1,
  60088: 1,
  60089: 1,
  60090: 1,
  60091: 1,
  60092: 1,
  60093: 1,
  60094: 1,
  60095: 1,
  60096: 1,
  60097: 1,
  60098: 1,
  60099: 1,
  60101: 1,
  60102: 1,
  60103: 1,
  60104: 1,
  60105: 1,
  60106: 1,
  60107: 1,
  60108: 1,
  60109: 1,
  60110: 1,
  60111: 1,
  60112: 1,
  60113: 1,
  60115: 1,
  60116: 1,
  60117: 1,
  60118: 1,
  60119: 1,
  60120: 1,
  60121: 1,
  60122: 1,
  60123: 1,
  60124: 1,
  60125: 1,
  60126: 1,
  60128: 1,
  60129: 1,
  60130: 1,
  60131: 1,
  60132: 1,
  60133: 1,
  60134: 1,
  60135: 1,
  60136: 1,
  60137: 1,
  60138: 1,
  60139: 1,
  60140: 1,
  60141: 1,
  60142: 1,
  60143: 1,
  60144: 1,
  60145: 1,
  60146: 1,
  60147: 1,
  60148: 1,
  60150: 1,
  60151: 1,
  60152: 1,
  60153: 1,
  60154: 1,
  60155: 1,
  60156: 1,
  60157: 1,
  60159: 1,
  60160: 1,
  60161: 1,
  60162: 1,
  60163: 1,
  60164: 1,
  60165: 1,
  60168: 1,
  60169: 1,
  60170: 1,
  60172: 1,
  60173: 1,
  60174: 1,
  60175: 1,
  60176: 1,
  60177: 1,
  60178: 1,
  60179: 1,
  60180: 1,
  60181: 1,
  60183: 1,
  60184: 1,
  60185: 1,
  60186: 1,
  60187: 1,
  60188: 1,
  60189: 1,
  60190: 1,
  60191: 1,
  60192: 1,
  60193: 1,
  60194: 1,
  60195: 1,
  60196: 1,
  60197: 1,
  60199: 1,
  60201: 1,
  60202: 1,
  60203: 1,
  60204: 1,
  60208: 1,
  60209: 1,
  60290: 1,
  60296: 1,
  60297: 1,
  60301: 1,
  60302: 1,
  60303: 1,
  60304: 1,
  60305: 1,
  60398: 1,
  60399: 1,
  60401: 1,
  60402: 1,
  60403: 1,
  60404: 1,
  60406: 1,
  60407: 1,
  60408: 1,
  60409: 1,
  60410: 1,
  60411: 1,
  60412: 1,
  60415: 1,
  60416: 1,
  60417: 1,
  60419: 1,
  60420: 1,
  60421: 1,
  60422: 1,
  60423: 1,
  60424: 1,
  60425: 1,
  60426: 1,
  60428: 1,
  60429: 1,
  60430: 1,
  60432: 1,
  60433: 1,
  60434: 1,
  60435: 1,
  60436: 1,
  60437: 1,
  60438: 1,
  60439: 1,
  60440: 1,
  60441: 1,
  60442: 1,
  60443: 1,
  60444: 1,
  60445: 1,
  60446: 1,
  60447: 1,
  60448: 1,
  60449: 1,
  60450: 1,
  60451: 1,
  60452: 1,
  60453: 1,
  60454: 1,
  60455: 1,
  60456: 1,
  60457: 1,
  60458: 1,
  60459: 1,
  60460: 1,
  60461: 1,
  60462: 1,
  60463: 1,
  60464: 1,
  60465: 1,
  60466: 1,
  60467: 1,
  60468: 1,
  60469: 1,
  60470: 1,
  60471: 1,
  60472: 1,
  60473: 1,
  60474: 1,
  60475: 1,
  60476: 1,
  60477: 1,
  60478: 1,
  60479: 1,
  60480: 1,
  60481: 1,
  60482: 1,
  60483: 1,
  60484: 1,
  60487: 1,
  60490: 1,
  60491: 1,
  60499: 1,
  60501: 1,
  60502: 1,
  60503: 1,
  60504: 1,
  60505: 1,
  60506: 1,
  60507: 1,
  60510: 1,
  60511: 1,
  60512: 1,
  60513: 1,
  60514: 1,
  60515: 1,
  60516: 1,
  60517: 1,
  60518: 1,
  60519: 1,
  60520: 1,
  60521: 1,
  60522: 1,
  60523: 1,
  60525: 1,
  60526: 1,
  60527: 1,
  60530: 1,
  60531: 1,
  60532: 1,
  60534: 1,
  60536: 1,
  60537: 1,
  60538: 1,
  60539: 1,
  60540: 1,
  60541: 1,
  60542: 1,
  60543: 1,
  60544: 1,
  60545: 1,
  60546: 1,
  60548: 1,
  60549: 1,
  60550: 1,
  60551: 1,
  60552: 1,
  60553: 1,
  60554: 1,
  60555: 1,
  60556: 1,
  60557: 1,
  60558: 1,
  60559: 1,
  60560: 1,
  60561: 1,
  60563: 1,
  60564: 1,
  60565: 1,
  60566: 1,
  60567: 1,
  60568: 1,
  60570: 1,
  60572: 1,
  60585: 1,
  60586: 1,
  60597: 1,
  60598: 1,
  60599: 1,
  60601: 1,
  60602: 1,
  60603: 1,
  60605: 1,
  60606: 1,
  60607: 1,
  60608: 1,
  60610: 1,
  60611: 1,
  60612: 1,
  60613: 1,
  60614: 1,
  60615: 1,
  60616: 1,
  60618: 1,
  60619: 1,
  60620: 1,
  60621: 1,
  60622: 1,
  60623: 1,
  60625: 1,
  60626: 1,
  60628: 1,
  60629: 1,
  60630: 1,
  60632: 1,
  60633: 1,
  60634: 1,
  60636: 1,
  60637: 1,
  60638: 1,
  60639: 1,
  60640: 1,
  60641: 1,
  60642: 1,
  60643: 1,
  60644: 1,
  60645: 1,
  60646: 1,
  60647: 1,
  60649: 1,
  60651: 1,
  60652: 1,
  60653: 1,
  60654: 1,
  60655: 1,
  60656: 1,
  60657: 1,
  60659: 1,
  60660: 1,
  60661: 1,
  60663: 1,
  60664: 1,
  60665: 1,
  60666: 1,
  60667: 1,
  60668: 1,
  60669: 1,
  60670: 1,
  60671: 1,
  60672: 1,
  60673: 1,
  60674: 1,
  60675: 1,
  60677: 1,
  60678: 1,
  60679: 1,
  60680: 1,
  60681: 1,
  60682: 1,
  60683: 1,
  60684: 1,
  60685: 1,
  60686: 1,
  60687: 1,
  60688: 1,
  60689: 1,
  60690: 1,
  60691: 1,
  60693: 1,
  60694: 1,
  60695: 1,
  60696: 1,
  60697: 1,
  60699: 1,
  60706: 1,
  60707: 1,
  60712: 1,
  60714: 1,
  60803: 1,
  60804: 1,
  60805: 1,
  60827: 1,
  60901: 1,
  60902: 1,
  60910: 1,
  60911: 1,
  60912: 1,
  60913: 1,
  60914: 1,
  60915: 1,
  60917: 1,
  60918: 1,
  60919: 1,
  60920: 1,
  60921: 1,
  60922: 1,
  60924: 1,
  60926: 1,
  60927: 1,
  60928: 1,
  60929: 1,
  60930: 1,
  60931: 1,
  60932: 1,
  60933: 1,
  60934: 1,
  60935: 1,
  60936: 1,
  60938: 1,
  60939: 1,
  60940: 1,
  60941: 1,
  60942: 1,
  60944: 1,
  60945: 1,
  60946: 1,
  60948: 1,
  60949: 1,
  60950: 1,
  60951: 1,
  60952: 1,
  60953: 1,
  60954: 1,
  60955: 1,
  60956: 1,
  60957: 1,
  60958: 1,
  60959: 1,
  60960: 1,
  60961: 1,
  60962: 1,
  60963: 1,
  60964: 1,
  60966: 1,
  60967: 1,
  60969: 1,
  60970: 1,
  60973: 1,
  60974: 1,
  61001: 1,
  61006: 1,
  61007: 1,
  61010: 1,
  61011: 1,
  61012: 1,
  61013: 1,
  61014: 1,
  61015: 1,
  61016: 1,
  61018: 1,
  61019: 1,
  61020: 1,
  61021: 1,
  61024: 1,
  61028: 1,
  61030: 1,
  61031: 1,
  61036: 1,
  61037: 1,
  61038: 1,
  61039: 1,
  61041: 1,
  61042: 1,
  61046: 1,
  61048: 1,
  61049: 1,
  61050: 1,
  61051: 1,
  61052: 1,
  61053: 1,
  61054: 1,
  61057: 1,
  61058: 1,
  61059: 1,
  61060: 1,
  61061: 1,
  61062: 1,
  61063: 1,
  61064: 1,
  61065: 1,
  61067: 1,
  61068: 1,
  61070: 1,
  61071: 1,
  61072: 1,
  61073: 1,
  61074: 1,
  61075: 1,
  61077: 1,
  61078: 1,
  61079: 1,
  61080: 1,
  61081: 1,
  61084: 1,
  61085: 1,
  61087: 1,
  61088: 1,
  61089: 1,
  61091: 1,
  61101: 1,
  61102: 1,
  61103: 1,
  61104: 1,
  61105: 1,
  61106: 1,
  61107: 1,
  61108: 1,
  61109: 1,
  61110: 1,
  61111: 1,
  61112: 1,
  61114: 1,
  61115: 1,
  61125: 1,
  61126: 1,
  61130: 1,
  61131: 1,
  61132: 1,
  61201: 1,
  61204: 1,
  61230: 1,
  61231: 1,
  61232: 1,
  61233: 1,
  61234: 1,
  61235: 1,
  61236: 1,
  61237: 1,
  61238: 1,
  61239: 1,
  61240: 1,
  61241: 1,
  61242: 1,
  61243: 1,
  61244: 1,
  61250: 1,
  61251: 1,
  61252: 1,
  61254: 1,
  61256: 1,
  61257: 1,
  61258: 1,
  61259: 1,
  61260: 1,
  61261: 1,
  61262: 1,
  61263: 1,
  61264: 1,
  61265: 1,
  61266: 1,
  61270: 1,
  61272: 1,
  61273: 1,
  61274: 1,
  61275: 1,
  61276: 1,
  61277: 1,
  61278: 1,
  61279: 1,
  61281: 1,
  61282: 1,
  61283: 1,
  61284: 1,
  61285: 1,
  61299: 1,
  61301: 1,
  61310: 1,
  61311: 1,
  61312: 1,
  61313: 1,
  61314: 1,
  61315: 1,
  61316: 1,
  61317: 1,
  61318: 1,
  61319: 1,
  61320: 1,
  61321: 1,
  61322: 1,
  61323: 1,
  61324: 1,
  61325: 1,
  61326: 1,
  61327: 1,
  61328: 1,
  61329: 1,
  61330: 1,
  61331: 1,
  61332: 1,
  61333: 1,
  61334: 1,
  61335: 1,
  61336: 1,
  61337: 1,
  61338: 1,
  61340: 1,
  61341: 1,
  61342: 1,
  61344: 1,
  61345: 1,
  61346: 1,
  61348: 1,
  61349: 1,
  61350: 1,
  61353: 1,
  61354: 1,
  61356: 1,
  61358: 1,
  61359: 1,
  61360: 1,
  61361: 1,
  61364: 1,
  61367: 1,
  61368: 1,
  61369: 1,
  61370: 1,
  61371: 1,
  61372: 1,
  61373: 1,
  61374: 1,
  61376: 1,
  61377: 1,
  61378: 1,
  61379: 1,
  61401: 1,
  61402: 1,
  61410: 1,
  61411: 1,
  61412: 1,
  61413: 1,
  61414: 1,
  61415: 1,
  61416: 1,
  61417: 1,
  61418: 1,
  61420: 1,
  61421: 1,
  61422: 1,
  61423: 1,
  61424: 1,
  61425: 1,
  61426: 1,
  61427: 1,
  61428: 1,
  61430: 1,
  61431: 1,
  61432: 1,
  61433: 1,
  61434: 1,
  61435: 1,
  61436: 1,
  61437: 1,
  61438: 1,
  61439: 1,
  61440: 1,
  61441: 1,
  61442: 1,
  61443: 1,
  61447: 1,
  61448: 1,
  61449: 1,
  61450: 1,
  61451: 1,
  61452: 1,
  61453: 1,
  61454: 1,
  61455: 1,
  61458: 1,
  61459: 1,
  61460: 1,
  61462: 1,
  61465: 1,
  61466: 1,
  61467: 1,
  61468: 1,
  61469: 1,
  61470: 1,
  61471: 1,
  61472: 1,
  61473: 1,
  61474: 1,
  61475: 1,
  61476: 1,
  61477: 1,
  61478: 1,
  61479: 1,
  61480: 1,
  61482: 1,
  61483: 1,
  61484: 1,
  61485: 1,
  61486: 1,
  61488: 1,
  61489: 1,
  61490: 1,
  61491: 1,
  61501: 1,
  61516: 1,
  61517: 1,
  61519: 1,
  61520: 1,
  61523: 1,
  61524: 1,
  61525: 1,
  61526: 1,
  61528: 1,
  61529: 1,
  61530: 1,
  61531: 1,
  61532: 1,
  61533: 1,
  61534: 1,
  61535: 1,
  61536: 1,
  61537: 1,
  61539: 1,
  61540: 1,
  61541: 1,
  61542: 1,
  61543: 1,
  61544: 1,
  61545: 1,
  61546: 1,
  61547: 1,
  61548: 1,
  61550: 1,
  61552: 1,
  61553: 1,
  61554: 1,
  61555: 1,
  61558: 1,
  61559: 1,
  61560: 1,
  61561: 1,
  61562: 1,
  61563: 1,
  61564: 1,
  61565: 1,
  61567: 1,
  61568: 1,
  61569: 1,
  61570: 1,
  61571: 1,
  61572: 1,
  61601: 1,
  61602: 1,
  61603: 1,
  61604: 1,
  61605: 1,
  61606: 1,
  61607: 1,
  61610: 1,
  61611: 1,
  61612: 1,
  61613: 1,
  61614: 1,
  61615: 1,
  61616: 1,
  61625: 1,
  61628: 1,
  61629: 1,
  61630: 1,
  61632: 1,
  61633: 1,
  61634: 1,
  61635: 1,
  61636: 1,
  61637: 1,
  61638: 1,
  61639: 1,
  61640: 1,
  61641: 1,
  61643: 1,
  61644: 1,
  61650: 1,
  61651: 1,
  61652: 1,
  61653: 1,
  61654: 1,
  61655: 1,
  61656: 1,
  61701: 1,
  61702: 1,
  61704: 1,
  61705: 1,
  61709: 1,
  61710: 1,
  61720: 1,
  61721: 1,
  61722: 1,
  61723: 1,
  61724: 1,
  61725: 1,
  61726: 1,
  61727: 1,
  61728: 1,
  61729: 1,
  61730: 1,
  61731: 1,
  61732: 1,
  61733: 1,
  61734: 1,
  61735: 1,
  61736: 1,
  61737: 1,
  61738: 1,
  61739: 1,
  61740: 1,
  61741: 1,
  61742: 1,
  61743: 1,
  61744: 1,
  61745: 1,
  61747: 1,
  61748: 1,
  61749: 1,
  61750: 1,
  61751: 1,
  61752: 1,
  61753: 1,
  61754: 1,
  61755: 1,
  61756: 1,
  61758: 1,
  61759: 1,
  61760: 1,
  61761: 1,
  61764: 1,
  61769: 1,
  61770: 1,
  61771: 1,
  61772: 1,
  61773: 1,
  61774: 1,
  61775: 1,
  61776: 1,
  61777: 1,
  61778: 1,
  61790: 1,
  61791: 1,
  61799: 1,
  61801: 1,
  61802: 1,
  61803: 1,
  61810: 1,
  61811: 1,
  61812: 1,
  61813: 1,
  61814: 1,
  61815: 1,
  61816: 1,
  61817: 1,
  61818: 1,
  61820: 1,
  61821: 1,
  61822: 1,
  61824: 1,
  61825: 1,
  61826: 1,
  61830: 1,
  61831: 1,
  61832: 1,
  61833: 1,
  61834: 1,
  61839: 1,
  61840: 1,
  61841: 1,
  61842: 1,
  61843: 1,
  61844: 1,
  61845: 1,
  61846: 1,
  61847: 1,
  61848: 1,
  61849: 1,
  61850: 1,
  61851: 1,
  61852: 1,
  61853: 1,
  61854: 1,
  61855: 1,
  61856: 1,
  61857: 1,
  61858: 1,
  61859: 1,
  61862: 1,
  61863: 1,
  61864: 1,
  61865: 1,
  61866: 1,
  61870: 1,
  61871: 1,
  61872: 1,
  61873: 1,
  61874: 1,
  61875: 1,
  61877: 1,
  61878: 1,
  61880: 1,
  61882: 1,
  61884: 1,
  61910: 1,
  61911: 1,
  61912: 1,
  61913: 1,
  61914: 1,
  61917: 1,
  61919: 1,
  61920: 1,
  61924: 1,
  61925: 1,
  61928: 1,
  61929: 1,
  61930: 1,
  61931: 1,
  61932: 1,
  61933: 1,
  61936: 1,
  61938: 1,
  61940: 1,
  61941: 1,
  61942: 1,
  61943: 1,
  61944: 1,
  61951: 1,
  61953: 1,
  61955: 1,
  61956: 1,
  61957: 1,
  62001: 1,
  62002: 1,
  62006: 1,
  62009: 1,
  62010: 1,
  62011: 1,
  62012: 1,
  62013: 1,
  62014: 1,
  62015: 1,
  62016: 1,
  62017: 1,
  62018: 1,
  62019: 1,
  62021: 1,
  62022: 1,
  62023: 1,
  62024: 1,
  62025: 1,
  62026: 1,
  62027: 1,
  62028: 1,
  62030: 1,
  62031: 1,
  62032: 1,
  62033: 1,
  62034: 1,
  62035: 1,
  62036: 1,
  62037: 1,
  62040: 1,
  62044: 1,
  62045: 1,
  62046: 1,
  62047: 1,
  62048: 1,
  62049: 1,
  62051: 1,
  62053: 1,
  62054: 1,
  62056: 1,
  62058: 1,
  62059: 1,
  62060: 1,
  62061: 1,
  62062: 1,
  62063: 1,
  62065: 1,
  62067: 1,
  62069: 1,
  62070: 1,
  62071: 1,
  62074: 1,
  62075: 1,
  62076: 1,
  62077: 1,
  62078: 1,
  62079: 1,
  62080: 1,
  62081: 1,
  62082: 1,
  62083: 1,
  62085: 1,
  62087: 1,
  62088: 1,
  62089: 1,
  62090: 1,
  62091: 1,
  62092: 1,
  62093: 1,
  62094: 1,
  62097: 1,
  62098: 1,
  62201: 1,
  62202: 1,
  62203: 1,
  62204: 1,
  62205: 1,
  62206: 1,
  62207: 1,
  62208: 1,
  62214: 1,
  62215: 1,
  62216: 1,
  62217: 1,
  62218: 1,
  62219: 1,
  62220: 1,
  62221: 1,
  62222: 1,
  62223: 1,
  62224: 1,
  62225: 1,
  62226: 1,
  62230: 1,
  62231: 1,
  62232: 1,
  62233: 1,
  62234: 1,
  62236: 1,
  62237: 1,
  62238: 1,
  62239: 1,
  62241: 1,
  62242: 1,
  62243: 1,
  62244: 1,
  62245: 1,
  62246: 1,
  62247: 1,
  62248: 1,
  62249: 1,
  62250: 1,
  62252: 1,
  62253: 1,
  62254: 1,
  62255: 1,
  62256: 1,
  62257: 1,
  62258: 1,
  62260: 1,
  62261: 1,
  62262: 1,
  62264: 1,
  62265: 1,
  62268: 1,
  62269: 1,
  62271: 1,
  62272: 1,
  62273: 1,
  62274: 1,
  62275: 1,
  62277: 1,
  62278: 1,
  62279: 1,
  62280: 1,
  62281: 1,
  62282: 1,
  62284: 1,
  62285: 1,
  62286: 1,
  62288: 1,
  62289: 1,
  62292: 1,
  62293: 1,
  62294: 1,
  62295: 1,
  62297: 1,
  62298: 1,
  62301: 1,
  62305: 1,
  62306: 1,
  62310: 1,
  62311: 1,
  62312: 1,
  62313: 1,
  62314: 1,
  62316: 1,
  62319: 1,
  62320: 1,
  62321: 1,
  62323: 1,
  62324: 1,
  62325: 1,
  62326: 1,
  62329: 1,
  62330: 1,
  62334: 1,
  62336: 1,
  62338: 1,
  62339: 1,
  62340: 1,
  62341: 1,
  62343: 1,
  62344: 1,
  62345: 1,
  62346: 1,
  62347: 1,
  62348: 1,
  62349: 1,
  62351: 1,
  62352: 1,
  62353: 1,
  62354: 1,
  62355: 1,
  62356: 1,
  62357: 1,
  62358: 1,
  62359: 1,
  62360: 1,
  62361: 1,
  62362: 1,
  62363: 1,
  62365: 1,
  62366: 1,
  62367: 1,
  62370: 1,
  62373: 1,
  62374: 1,
  62375: 1,
  62376: 1,
  62378: 1,
  62379: 1,
  62380: 1,
  62401: 1,
  62410: 1,
  62411: 1,
  62413: 1,
  62414: 1,
  62415: 1,
  62417: 1,
  62418: 1,
  62419: 1,
  62420: 1,
  62421: 1,
  62422: 1,
  62423: 1,
  62424: 1,
  62425: 1,
  62426: 1,
  62427: 1,
  62428: 1,
  62431: 1,
  62432: 1,
  62433: 1,
  62434: 1,
  62435: 1,
  62436: 1,
  62438: 1,
  62439: 1,
  62440: 1,
  62441: 1,
  62442: 1,
  62443: 1,
  62444: 1,
  62445: 1,
  62446: 1,
  62447: 1,
  62448: 1,
  62449: 1,
  62450: 1,
  62451: 1,
  62452: 1,
  62454: 1,
  62458: 1,
  62459: 1,
  62460: 1,
  62461: 1,
  62462: 1,
  62463: 1,
  62464: 1,
  62465: 1,
  62466: 1,
  62467: 1,
  62468: 1,
  62469: 1,
  62471: 1,
  62473: 1,
  62474: 1,
  62475: 1,
  62476: 1,
  62477: 1,
  62478: 1,
  62479: 1,
  62480: 1,
  62481: 1,
  62501: 1,
  62510: 1,
  62512: 1,
  62513: 1,
  62514: 1,
  62515: 1,
  62517: 1,
  62518: 1,
  62519: 1,
  62520: 1,
  62521: 1,
  62522: 1,
  62523: 1,
  62524: 1,
  62525: 1,
  62526: 1,
  62530: 1,
  62531: 1,
  62532: 1,
  62533: 1,
  62534: 1,
  62535: 1,
  62536: 1,
  62537: 1,
  62538: 1,
  62539: 1,
  62540: 1,
  62541: 1,
  62543: 1,
  62544: 1,
  62545: 1,
  62546: 1,
  62547: 1,
  62548: 1,
  62549: 1,
  62550: 1,
  62551: 1,
  62553: 1,
  62554: 1,
  62555: 1,
  62556: 1,
  62557: 1,
  62558: 1,
  62560: 1,
  62561: 1,
  62563: 1,
  62565: 1,
  62567: 1,
  62568: 1,
  62570: 1,
  62571: 1,
  62572: 1,
  62573: 1,
  62601: 1,
  62610: 1,
  62611: 1,
  62612: 1,
  62613: 1,
  62615: 1,
  62617: 1,
  62618: 1,
  62621: 1,
  62622: 1,
  62624: 1,
  62625: 1,
  62626: 1,
  62627: 1,
  62628: 1,
  62629: 1,
  62630: 1,
  62631: 1,
  62633: 1,
  62634: 1,
  62635: 1,
  62638: 1,
  62639: 1,
  62640: 1,
  62642: 1,
  62643: 1,
  62644: 1,
  62649: 1,
  62650: 1,
  62651: 1,
  62655: 1,
  62656: 1,
  62659: 1,
  62660: 1,
  62661: 1,
  62662: 1,
  62663: 1,
  62664: 1,
  62665: 1,
  62666: 1,
  62667: 1,
  62668: 1,
  62670: 1,
  62671: 1,
  62672: 1,
  62673: 1,
  62674: 1,
  62675: 1,
  62677: 1,
  62681: 1,
  62682: 1,
  62683: 1,
  62684: 1,
  62688: 1,
  62690: 1,
  62691: 1,
  62692: 1,
  62693: 1,
  62694: 1,
  62695: 1,
  62701: 1,
  62702: 1,
  62703: 1,
  62704: 1,
  62705: 1,
  62706: 1,
  62707: 1,
  62708: 1,
  62711: 1,
  62712: 1,
  62713: 1,
  62715: 1,
  62716: 1,
  62719: 1,
  62721: 1,
  62722: 1,
  62723: 1,
  62726: 1,
  62736: 1,
  62739: 1,
  62746: 1,
  62756: 1,
  62757: 1,
  62761: 1,
  62762: 1,
  62763: 1,
  62764: 1,
  62765: 1,
  62766: 1,
  62767: 1,
  62769: 1,
  62776: 1,
  62777: 1,
  62781: 1,
  62786: 1,
  62791: 1,
  62794: 1,
  62796: 1,
  62801: 1,
  62803: 1,
  62805: 1,
  62806: 1,
  62807: 1,
  62808: 1,
  62809: 1,
  62810: 1,
  62811: 1,
  62812: 1,
  62814: 1,
  62815: 1,
  62816: 1,
  62817: 1,
  62818: 1,
  62819: 1,
  62820: 1,
  62821: 1,
  62822: 1,
  62823: 1,
  62824: 1,
  62825: 1,
  62827: 1,
  62828: 1,
  62829: 1,
  62830: 1,
  62831: 1,
  62832: 1,
  62833: 1,
  62834: 1,
  62835: 1,
  62836: 1,
  62837: 1,
  62838: 1,
  62839: 1,
  62840: 1,
  62841: 1,
  62842: 1,
  62844: 1,
  62845: 1,
  62846: 1,
  62847: 1,
  62848: 1,
  62849: 1,
  62850: 1,
  62851: 1,
  62852: 1,
  62853: 1,
  62854: 1,
  62855: 1,
  62856: 1,
  62857: 1,
  62858: 1,
  62859: 1,
  62860: 1,
  62861: 1,
  62862: 1,
  62863: 1,
  62864: 1,
  62865: 1,
  62866: 1,
  62867: 1,
  62868: 1,
  62869: 1,
  62870: 1,
  62871: 1,
  62872: 1,
  62874: 1,
  62875: 1,
  62876: 1,
  62877: 1,
  62878: 1,
  62879: 1,
  62880: 1,
  62881: 1,
  62882: 1,
  62883: 1,
  62884: 1,
  62885: 1,
  62886: 1,
  62887: 1,
  62888: 1,
  62889: 1,
  62890: 1,
  62891: 1,
  62892: 1,
  62893: 1,
  62894: 1,
  62895: 1,
  62896: 1,
  62897: 1,
  62898: 1,
  62899: 1,
  62901: 1,
  62902: 1,
  62903: 1,
  62905: 1,
  62906: 1,
  62907: 1,
  62908: 1,
  62909: 1,
  62910: 1,
  62912: 1,
  62914: 1,
  62915: 1,
  62916: 1,
  62917: 1,
  62918: 1,
  62919: 1,
  62920: 1,
  62921: 1,
  62922: 1,
  62923: 1,
  62924: 1,
  62926: 1,
  62927: 1,
  62928: 1,
  62930: 1,
  62931: 1,
  62932: 1,
  62933: 1,
  62934: 1,
  62935: 1,
  62938: 1,
  62939: 1,
  62940: 1,
  62941: 1,
  62942: 1,
  62943: 1,
  62944: 1,
  62946: 1,
  62947: 1,
  62948: 1,
  62949: 1,
  62950: 1,
  62951: 1,
  62952: 1,
  62953: 1,
  62954: 1,
  62955: 1,
  62956: 1,
  62957: 1,
  62958: 1,
  62959: 1,
  62960: 1,
  62961: 1,
  62962: 1,
  62963: 1,
  62964: 1,
  62965: 1,
  62966: 1,
  62967: 1,
  62969: 1,
  62970: 1,
  62971: 1,
  62972: 1,
  62973: 1,
  62974: 1,
  62975: 1,
  62976: 1,
  62977: 1,
  62979: 1,
  62982: 1,
  62983: 1,
  62984: 1,
  62985: 1,
  62987: 1,
  62988: 1,
  62990: 1,
  62992: 1,
  62993: 1,
  62994: 1,
  62995: 1,
  62996: 1,
  62997: 1,
  62998: 1,
  62999: 1,
  63001: 1,
  63005: 1,
  63006: 1,
  63010: 1,
  63011: 1,
  63012: 1,
  63013: 1,
  63014: 1,
  63015: 1,
  63016: 1,
  63017: 1,
  63019: 1,
  63020: 1,
  63021: 1,
  63022: 1,
  63023: 1,
  63024: 1,
  63025: 1,
  63026: 1,
  63028: 1,
  63030: 1,
  63031: 1,
  63032: 1,
  63033: 1,
  63034: 1,
  63036: 1,
  63037: 1,
  63038: 1,
  63039: 1,
  63040: 1,
  63041: 1,
  63042: 1,
  63043: 1,
  63044: 1,
  63045: 1,
  63047: 1,
  63048: 1,
  63049: 1,
  63050: 1,
  63051: 1,
  63052: 1,
  63053: 1,
  63055: 1,
  63056: 1,
  63057: 1,
  63060: 1,
  63061: 1,
  63065: 1,
  63066: 1,
  63068: 1,
  63069: 1,
  63070: 1,
  63071: 1,
  63072: 1,
  63073: 1,
  63074: 1,
  63077: 1,
  63079: 1,
  63080: 1,
  63084: 1,
  63087: 1,
  63088: 1,
  63089: 1,
  63090: 1,
  63091: 1,
  63099: 1,
  63101: 1,
  63102: 1,
  63103: 1,
  63104: 1,
  63105: 1,
  63106: 1,
  63107: 1,
  63108: 1,
  63109: 1,
  63110: 1,
  63111: 1,
  63112: 1,
  63113: 1,
  63114: 1,
  63115: 1,
  63116: 1,
  63117: 1,
  63118: 1,
  63119: 1,
  63120: 1,
  63121: 1,
  63122: 1,
  63123: 1,
  63124: 1,
  63125: 1,
  63126: 1,
  63127: 1,
  63128: 1,
  63129: 1,
  63130: 1,
  63131: 1,
  63132: 1,
  63133: 1,
  63134: 1,
  63135: 1,
  63136: 1,
  63137: 1,
  63138: 1,
  63139: 1,
  63140: 1,
  63141: 1,
  63143: 1,
  63144: 1,
  63145: 1,
  63146: 1,
  63147: 1,
  63150: 1,
  63151: 1,
  63155: 1,
  63156: 1,
  63157: 1,
  63158: 1,
  63160: 1,
  63163: 1,
  63164: 1,
  63166: 1,
  63167: 1,
  63169: 1,
  63171: 1,
  63177: 1,
  63178: 1,
  63179: 1,
  63180: 1,
  63182: 1,
  63188: 1,
  63190: 1,
  63195: 1,
  63196: 1,
  63197: 1,
  63198: 1,
  63199: 1,
  63301: 1,
  63302: 1,
  63303: 1,
  63304: 1,
  63330: 1,
  63332: 1,
  63333: 1,
  63334: 1,
  63336: 1,
  63338: 1,
  63339: 1,
  63341: 1,
  63342: 1,
  63343: 1,
  63344: 1,
  63345: 1,
  63346: 1,
  63347: 1,
  63348: 1,
  63349: 1,
  63350: 1,
  63351: 1,
  63352: 1,
  63353: 1,
  63357: 1,
  63359: 1,
  63361: 1,
  63362: 1,
  63363: 1,
  63365: 1,
  63366: 1,
  63367: 1,
  63368: 1,
  63369: 1,
  63370: 1,
  63373: 1,
  63376: 1,
  63377: 1,
  63378: 1,
  63379: 1,
  63381: 1,
  63382: 1,
  63383: 1,
  63384: 1,
  63385: 1,
  63386: 1,
  63387: 1,
  63388: 1,
  63389: 1,
  63390: 1,
  63401: 1,
  63430: 1,
  63431: 1,
  63432: 1,
  63433: 1,
  63434: 1,
  63435: 1,
  63436: 1,
  63437: 1,
  63438: 1,
  63439: 1,
  63440: 1,
  63441: 1,
  63442: 1,
  63443: 1,
  63445: 1,
  63446: 1,
  63447: 1,
  63448: 1,
  63450: 1,
  63451: 1,
  63452: 1,
  63453: 1,
  63454: 1,
  63456: 1,
  63457: 1,
  63458: 1,
  63459: 1,
  63460: 1,
  63461: 1,
  63462: 1,
  63463: 1,
  63464: 1,
  63465: 1,
  63466: 1,
  63467: 1,
  63468: 1,
  63469: 1,
  63471: 1,
  63472: 1,
  63473: 1,
  63474: 1,
  63501: 1,
  63530: 1,
  63531: 1,
  63532: 1,
  63533: 1,
  63534: 1,
  63535: 1,
  63536: 1,
  63537: 1,
  63538: 1,
  63539: 1,
  63540: 1,
  63541: 1,
  63543: 1,
  63544: 1,
  63545: 1,
  63546: 1,
  63547: 1,
  63548: 1,
  63549: 1,
  63551: 1,
  63552: 1,
  63555: 1,
  63556: 1,
  63557: 1,
  63558: 1,
  63559: 1,
  63560: 1,
  63561: 1,
  63563: 1,
  63565: 1,
  63566: 1,
  63567: 1,
  63601: 1,
  63620: 1,
  63621: 1,
  63622: 1,
  63623: 1,
  63624: 1,
  63625: 1,
  63626: 1,
  63627: 1,
  63628: 1,
  63629: 1,
  63630: 1,
  63631: 1,
  63632: 1,
  63633: 1,
  63636: 1,
  63637: 1,
  63638: 1,
  63640: 1,
  63645: 1,
  63648: 1,
  63650: 1,
  63651: 1,
  63653: 1,
  63654: 1,
  63655: 1,
  63656: 1,
  63660: 1,
  63661: 1,
  63662: 1,
  63663: 1,
  63664: 1,
  63665: 1,
  63666: 1,
  63670: 1,
  63673: 1,
  63674: 1,
  63675: 1,
  63701: 1,
  63702: 1,
  63703: 1,
  63705: 1,
  63730: 1,
  63732: 1,
  63735: 1,
  63736: 1,
  63737: 1,
  63738: 1,
  63739: 1,
  63740: 1,
  63742: 1,
  63743: 1,
  63744: 1,
  63745: 1,
  63746: 1,
  63747: 1,
  63748: 1,
  63750: 1,
  63751: 1,
  63752: 1,
  63755: 1,
  63758: 1,
  63760: 1,
  63763: 1,
  63764: 1,
  63766: 1,
  63767: 1,
  63769: 1,
  63770: 1,
  63771: 1,
  63772: 1,
  63774: 1,
  63775: 1,
  63776: 1,
  63779: 1,
  63780: 1,
  63781: 1,
  63782: 1,
  63783: 1,
  63784: 1,
  63785: 1,
  63787: 1,
  63801: 1,
  63820: 1,
  63821: 1,
  63822: 1,
  63823: 1,
  63824: 1,
  63825: 1,
  63826: 1,
  63827: 1,
  63828: 1,
  63829: 1,
  63830: 1,
  63833: 1,
  63834: 1,
  63837: 1,
  63839: 1,
  63840: 1,
  63841: 1,
  63845: 1,
  63846: 1,
  63847: 1,
  63848: 1,
  63849: 1,
  63850: 1,
  63851: 1,
  63852: 1,
  63853: 1,
  63855: 1,
  63857: 1,
  63860: 1,
  63862: 1,
  63863: 1,
  63866: 1,
  63867: 1,
  63868: 1,
  63869: 1,
  63870: 1,
  63873: 1,
  63874: 1,
  63875: 1,
  63876: 1,
  63877: 1,
  63878: 1,
  63879: 1,
  63880: 1,
  63881: 1,
  63882: 1,
  63901: 1,
  63902: 1,
  63931: 1,
  63932: 1,
  63933: 1,
  63934: 1,
  63935: 1,
  63936: 1,
  63937: 1,
  63938: 1,
  63939: 1,
  63940: 1,
  63941: 1,
  63942: 1,
  63943: 1,
  63944: 1,
  63945: 1,
  63950: 1,
  63951: 1,
  63952: 1,
  63953: 1,
  63954: 1,
  63955: 1,
  63956: 1,
  63957: 1,
  63960: 1,
  63961: 1,
  63962: 1,
  63963: 1,
  63964: 1,
  63965: 1,
  63966: 1,
  63967: 1,
  64001: 1,
  64002: 1,
  64011: 1,
  64012: 1,
  64013: 1,
  64014: 1,
  64015: 1,
  64016: 1,
  64017: 1,
  64018: 1,
  64019: 1,
  64020: 1,
  64021: 1,
  64022: 1,
  64024: 1,
  64028: 1,
  64029: 1,
  64030: 1,
  64034: 1,
  64035: 1,
  64036: 1,
  64037: 1,
  64040: 1,
  64048: 1,
  64050: 1,
  64051: 1,
  64052: 1,
  64053: 1,
  64054: 1,
  64055: 1,
  64056: 1,
  64057: 1,
  64058: 1,
  64060: 1,
  64061: 1,
  64062: 1,
  64063: 1,
  64064: 1,
  64065: 1,
  64066: 1,
  64067: 1,
  64068: 1,
  64069: 1,
  64070: 1,
  64071: 1,
  64072: 1,
  64073: 1,
  64074: 1,
  64075: 1,
  64076: 1,
  64077: 1,
  64078: 1,
  64079: 1,
  64080: 1,
  64081: 1,
  64082: 1,
  64083: 1,
  64084: 1,
  64085: 1,
  64086: 1,
  64087: 1,
  64088: 1,
  64089: 1,
  64090: 1,
  64092: 1,
  64093: 1,
  64096: 1,
  64097: 1,
  64098: 1,
  64101: 1,
  64102: 1,
  64105: 1,
  64106: 1,
  64108: 1,
  64109: 1,
  64110: 1,
  64111: 1,
  64112: 1,
  64113: 1,
  64114: 1,
  64116: 1,
  64117: 1,
  64118: 1,
  64119: 1,
  64120: 1,
  64121: 1,
  64123: 1,
  64124: 1,
  64125: 1,
  64126: 1,
  64127: 1,
  64128: 1,
  64129: 1,
  64130: 1,
  64131: 1,
  64132: 1,
  64133: 1,
  64134: 1,
  64136: 1,
  64137: 1,
  64138: 1,
  64139: 1,
  64141: 1,
  64142: 1,
  64144: 1,
  64145: 1,
  64146: 1,
  64147: 1,
  64148: 1,
  64149: 1,
  64150: 1,
  64151: 1,
  64152: 1,
  64153: 1,
  64154: 1,
  64155: 1,
  64156: 1,
  64157: 1,
  64158: 1,
  64160: 1,
  64161: 1,
  64163: 1,
  64164: 1,
  64165: 1,
  64166: 1,
  64167: 1,
  64168: 1,
  64170: 1,
  64171: 1,
  64172: 1,
  64173: 1,
  64179: 1,
  64180: 1,
  64183: 1,
  64184: 1,
  64185: 1,
  64187: 1,
  64188: 1,
  64189: 1,
  64190: 1,
  64191: 1,
  64192: 1,
  64193: 1,
  64194: 1,
  64195: 1,
  64196: 1,
  64197: 1,
  64198: 1,
  64199: 1,
  64401: 1,
  64402: 1,
  64420: 1,
  64421: 1,
  64422: 1,
  64423: 1,
  64424: 1,
  64426: 1,
  64427: 1,
  64428: 1,
  64429: 1,
  64430: 1,
  64431: 1,
  64432: 1,
  64433: 1,
  64434: 1,
  64436: 1,
  64437: 1,
  64438: 1,
  64439: 1,
  64440: 1,
  64441: 1,
  64442: 1,
  64443: 1,
  64444: 1,
  64445: 1,
  64446: 1,
  64447: 1,
  64448: 1,
  64449: 1,
  64451: 1,
  64453: 1,
  64454: 1,
  64455: 1,
  64456: 1,
  64457: 1,
  64458: 1,
  64459: 1,
  64461: 1,
  64463: 1,
  64465: 1,
  64466: 1,
  64467: 1,
  64468: 1,
  64469: 1,
  64470: 1,
  64471: 1,
  64473: 1,
  64474: 1,
  64475: 1,
  64476: 1,
  64477: 1,
  64478: 1,
  64479: 1,
  64480: 1,
  64481: 1,
  64482: 1,
  64483: 1,
  64484: 1,
  64485: 1,
  64486: 1,
  64487: 1,
  64489: 1,
  64490: 1,
  64491: 1,
  64492: 1,
  64493: 1,
  64494: 1,
  64496: 1,
  64497: 1,
  64498: 1,
  64499: 1,
  64501: 1,
  64502: 1,
  64503: 1,
  64504: 1,
  64505: 1,
  64506: 1,
  64507: 1,
  64508: 1,
  64601: 1,
  64620: 1,
  64622: 1,
  64623: 1,
  64624: 1,
  64625: 1,
  64628: 1,
  64630: 1,
  64631: 1,
  64632: 1,
  64633: 1,
  64635: 1,
  64636: 1,
  64637: 1,
  64638: 1,
  64639: 1,
  64640: 1,
  64641: 1,
  64642: 1,
  64643: 1,
  64644: 1,
  64645: 1,
  64646: 1,
  64647: 1,
  64648: 1,
  64649: 1,
  64650: 1,
  64651: 1,
  64652: 1,
  64653: 1,
  64654: 1,
  64655: 1,
  64656: 1,
  64657: 1,
  64658: 1,
  64659: 1,
  64660: 1,
  64661: 1,
  64664: 1,
  64667: 1,
  64668: 1,
  64670: 1,
  64671: 1,
  64672: 1,
  64673: 1,
  64674: 1,
  64676: 1,
  64679: 1,
  64680: 1,
  64681: 1,
  64682: 1,
  64683: 1,
  64686: 1,
  64688: 1,
  64689: 1,
  64701: 1,
  64720: 1,
  64722: 1,
  64723: 1,
  64724: 1,
  64725: 1,
  64726: 1,
  64728: 1,
  64730: 1,
  64733: 1,
  64734: 1,
  64735: 1,
  64738: 1,
  64739: 1,
  64740: 1,
  64741: 1,
  64742: 1,
  64743: 1,
  64744: 1,
  64745: 1,
  64746: 1,
  64747: 1,
  64748: 1,
  64750: 1,
  64752: 1,
  64755: 1,
  64756: 1,
  64759: 1,
  64761: 1,
  64762: 1,
  64763: 1,
  64765: 1,
  64766: 1,
  64767: 1,
  64769: 1,
  64770: 1,
  64771: 1,
  64772: 1,
  64776: 1,
  64777: 1,
  64778: 1,
  64779: 1,
  64780: 1,
  64781: 1,
  64783: 1,
  64784: 1,
  64788: 1,
  64789: 1,
  64790: 1,
  64801: 1,
  64802: 1,
  64803: 1,
  64804: 1,
  64830: 1,
  64831: 1,
  64832: 1,
  64833: 1,
  64834: 1,
  64835: 1,
  64836: 1,
  64840: 1,
  64841: 1,
  64842: 1,
  64843: 1,
  64844: 1,
  64847: 1,
  64848: 1,
  64849: 1,
  64850: 1,
  64853: 1,
  64854: 1,
  64855: 1,
  64856: 1,
  64857: 1,
  64858: 1,
  64859: 1,
  64861: 1,
  64862: 1,
  64863: 1,
  64864: 1,
  64865: 1,
  64866: 1,
  64867: 1,
  64868: 1,
  64869: 1,
  64870: 1,
  64873: 1,
  64874: 1,
  64944: 1,
  64999: 1,
  65001: 1,
  65010: 1,
  65011: 1,
  65013: 1,
  65014: 1,
  65016: 1,
  65017: 1,
  65018: 1,
  65020: 1,
  65022: 1,
  65023: 1,
  65024: 1,
  65025: 1,
  65026: 1,
  65031: 1,
  65032: 1,
  65034: 1,
  65035: 1,
  65036: 1,
  65037: 1,
  65038: 1,
  65039: 1,
  65040: 1,
  65041: 1,
  65042: 1,
  65043: 1,
  65046: 1,
  65047: 1,
  65048: 1,
  65049: 1,
  65050: 1,
  65051: 1,
  65052: 1,
  65053: 1,
  65054: 1,
  65055: 1,
  65058: 1,
  65059: 1,
  65061: 1,
  65062: 1,
  65063: 1,
  65064: 1,
  65065: 1,
  65066: 1,
  65067: 1,
  65068: 1,
  65069: 1,
  65072: 1,
  65074: 1,
  65075: 1,
  65076: 1,
  65077: 1,
  65078: 1,
  65079: 1,
  65080: 1,
  65081: 1,
  65082: 1,
  65083: 1,
  65084: 1,
  65085: 1,
  65101: 1,
  65102: 1,
  65103: 1,
  65104: 1,
  65105: 1,
  65106: 1,
  65107: 1,
  65108: 1,
  65109: 1,
  65110: 1,
  65111: 1,
  65201: 1,
  65202: 1,
  65203: 1,
  65205: 1,
  65211: 1,
  65212: 1,
  65215: 1,
  65216: 1,
  65217: 1,
  65218: 1,
  65230: 1,
  65231: 1,
  65232: 1,
  65233: 1,
  65236: 1,
  65237: 1,
  65239: 1,
  65240: 1,
  65243: 1,
  65244: 1,
  65246: 1,
  65247: 1,
  65248: 1,
  65250: 1,
  65251: 1,
  65254: 1,
  65255: 1,
  65256: 1,
  65257: 1,
  65258: 1,
  65260: 1,
  65261: 1,
  65262: 1,
  65263: 1,
  65264: 1,
  65265: 1,
  65270: 1,
  65274: 1,
  65275: 1,
  65276: 1,
  65278: 1,
  65279: 1,
  65280: 1,
  65281: 1,
  65282: 1,
  65283: 1,
  65284: 1,
  65285: 1,
  65286: 1,
  65287: 1,
  65299: 1,
  65301: 1,
  65302: 1,
  65305: 1,
  65320: 1,
  65321: 1,
  65322: 1,
  65323: 1,
  65324: 1,
  65325: 1,
  65326: 1,
  65327: 1,
  65329: 1,
  65330: 1,
  65332: 1,
  65333: 1,
  65334: 1,
  65335: 1,
  65336: 1,
  65337: 1,
  65338: 1,
  65339: 1,
  65340: 1,
  65344: 1,
  65345: 1,
  65347: 1,
  65348: 1,
  65349: 1,
  65350: 1,
  65351: 1,
  65354: 1,
  65355: 1,
  65360: 1,
  65401: 1,
  65402: 1,
  65409: 1,
  65436: 1,
  65438: 1,
  65439: 1,
  65440: 1,
  65441: 1,
  65443: 1,
  65444: 1,
  65446: 1,
  65449: 1,
  65452: 1,
  65453: 1,
  65456: 1,
  65457: 1,
  65459: 1,
  65461: 1,
  65462: 1,
  65463: 1,
  65464: 1,
  65466: 1,
  65468: 1,
  65470: 1,
  65473: 1,
  65479: 1,
  65483: 1,
  65484: 1,
  65486: 1,
  65501: 1,
  65529: 1,
  65532: 1,
  65534: 1,
  65535: 1,
  65536: 1,
  65541: 1,
  65542: 1,
  65543: 1,
  65546: 1,
  65548: 1,
  65550: 1,
  65552: 1,
  65555: 1,
  65556: 1,
  65557: 1,
  65559: 1,
  65560: 1,
  65564: 1,
  65565: 1,
  65566: 1,
  65567: 1,
  65570: 1,
  65571: 1,
  65572: 1,
  65580: 1,
  65582: 1,
  65583: 1,
  65584: 1,
  65586: 1,
  65588: 1,
  65589: 1,
  65590: 1,
  65591: 1,
  65601: 1,
  65603: 1,
  65604: 1,
  65605: 1,
  65606: 1,
  65607: 1,
  65608: 1,
  65609: 1,
  65610: 1,
  65611: 1,
  65612: 1,
  65613: 1,
  65614: 1,
  65615: 1,
  65616: 1,
  65617: 1,
  65618: 1,
  65619: 1,
  65620: 1,
  65622: 1,
  65623: 1,
  65624: 1,
  65625: 1,
  65626: 1,
  65627: 1,
  65629: 1,
  65630: 1,
  65631: 1,
  65632: 1,
  65633: 1,
  65634: 1,
  65635: 1,
  65636: 1,
  65637: 1,
  65638: 1,
  65640: 1,
  65641: 1,
  65644: 1,
  65645: 1,
  65646: 1,
  65647: 1,
  65648: 1,
  65649: 1,
  65650: 1,
  65652: 1,
  65653: 1,
  65654: 1,
  65655: 1,
  65656: 1,
  65657: 1,
  65658: 1,
  65660: 1,
  65661: 1,
  65662: 1,
  65663: 1,
  65664: 1,
  65666: 1,
  65667: 1,
  65668: 1,
  65669: 1,
  65672: 1,
  65673: 1,
  65674: 1,
  65675: 1,
  65676: 1,
  65679: 1,
  65680: 1,
  65681: 1,
  65682: 1,
  65685: 1,
  65686: 1,
  65688: 1,
  65689: 1,
  65690: 1,
  65692: 1,
  65701: 1,
  65702: 1,
  65704: 1,
  65705: 1,
  65706: 1,
  65707: 1,
  65708: 1,
  65710: 1,
  65711: 1,
  65712: 1,
  65713: 1,
  65714: 1,
  65715: 1,
  65717: 1,
  65720: 1,
  65721: 1,
  65722: 1,
  65723: 1,
  65724: 1,
  65725: 1,
  65726: 1,
  65727: 1,
  65728: 1,
  65729: 1,
  65730: 1,
  65731: 1,
  65732: 1,
  65733: 1,
  65734: 1,
  65735: 1,
  65737: 1,
  65738: 1,
  65739: 1,
  65740: 1,
  65741: 1,
  65742: 1,
  65744: 1,
  65745: 1,
  65746: 1,
  65747: 1,
  65752: 1,
  65753: 1,
  65754: 1,
  65755: 1,
  65756: 1,
  65757: 1,
  65759: 1,
  65760: 1,
  65761: 1,
  65762: 1,
  65764: 1,
  65765: 1,
  65766: 1,
  65767: 1,
  65768: 1,
  65769: 1,
  65770: 1,
  65771: 1,
  65772: 1,
  65773: 1,
  65774: 1,
  65775: 1,
  65776: 1,
  65777: 1,
  65778: 1,
  65779: 1,
  65781: 1,
  65783: 1,
  65784: 1,
  65785: 1,
  65786: 1,
  65787: 1,
  65788: 1,
  65789: 1,
  65790: 1,
  65791: 1,
  65793: 1,
  65801: 1,
  65802: 1,
  65803: 1,
  65804: 1,
  65805: 1,
  65806: 1,
  65807: 1,
  65808: 1,
  65809: 1,
  65810: 1,
  65814: 1,
  65817: 1,
  65890: 1,
  65897: 1,
  65898: 1,
  65899: 1,
  66002: 1,
  66006: 1,
  66007: 1,
  66008: 1,
  66010: 1,
  66012: 1,
  66013: 1,
  66014: 1,
  66015: 1,
  66016: 1,
  66017: 1,
  66018: 1,
  66019: 1,
  66020: 1,
  66021: 1,
  66023: 1,
  66024: 1,
  66025: 1,
  66026: 1,
  66027: 1,
  66030: 1,
  66031: 1,
  66032: 1,
  66033: 1,
  66035: 1,
  66036: 1,
  66039: 1,
  66040: 1,
  66041: 1,
  66042: 1,
  66043: 1,
  66044: 1,
  66045: 1,
  66046: 1,
  66047: 1,
  66048: 1,
  66049: 1,
  66050: 1,
  66051: 1,
  66052: 1,
  66053: 1,
  66054: 1,
  66056: 1,
  66058: 1,
  66060: 1,
  66061: 1,
  66062: 1,
  66063: 1,
  66064: 1,
  66066: 1,
  66067: 1,
  66070: 1,
  66071: 1,
  66072: 1,
  66073: 1,
  66075: 1,
  66076: 1,
  66077: 1,
  66078: 1,
  66079: 1,
  66080: 1,
  66083: 1,
  66085: 1,
  66086: 1,
  66087: 1,
  66088: 1,
  66090: 1,
  66091: 1,
  66092: 1,
  66093: 1,
  66094: 1,
  66095: 1,
  66097: 1,
  66101: 1,
  66102: 1,
  66103: 1,
  66104: 1,
  66105: 1,
  66106: 1,
  66109: 1,
  66110: 1,
  66111: 1,
  66112: 1,
  66113: 1,
  66115: 1,
  66117: 1,
  66118: 1,
  66119: 1,
  66160: 1,
  66201: 1,
  66202: 1,
  66203: 1,
  66204: 1,
  66205: 1,
  66206: 1,
  66207: 1,
  66208: 1,
  66209: 1,
  66210: 1,
  66211: 1,
  66212: 1,
  66213: 1,
  66214: 1,
  66215: 1,
  66216: 1,
  66217: 1,
  66218: 1,
  66219: 1,
  66220: 1,
  66221: 1,
  66222: 1,
  66223: 1,
  66224: 1,
  66225: 1,
  66226: 1,
  66227: 1,
  66250: 1,
  66251: 1,
  66276: 1,
  66279: 1,
  66282: 1,
  66283: 1,
  66285: 1,
  66286: 1,
  66401: 1,
  66402: 1,
  66403: 1,
  66404: 1,
  66406: 1,
  66407: 1,
  66408: 1,
  66409: 1,
  66411: 1,
  66412: 1,
  66413: 1,
  66414: 1,
  66415: 1,
  66416: 1,
  66417: 1,
  66418: 1,
  66419: 1,
  66420: 1,
  66422: 1,
  66423: 1,
  66424: 1,
  66425: 1,
  66426: 1,
  66427: 1,
  66428: 1,
  66429: 1,
  66431: 1,
  66432: 1,
  66434: 1,
  66436: 1,
  66438: 1,
  66439: 1,
  66440: 1,
  66441: 1,
  66442: 1,
  66449: 1,
  66451: 1,
  66501: 1,
  66502: 1,
  66503: 1,
  66506: 1,
  66507: 1,
  66508: 1,
  66509: 1,
  66510: 1,
  66514: 1,
  66515: 1,
  66516: 1,
  66517: 1,
  66518: 1,
  66520: 1,
  66521: 1,
  66522: 1,
  66524: 1,
  66526: 1,
  66527: 1,
  66528: 1,
  66531: 1,
  66533: 1,
  66535: 1,
  66536: 1,
  66537: 1,
  66538: 1,
  66539: 1,
  66540: 1,
  66541: 1,
  66543: 1,
  66544: 1,
  66546: 1,
  66549: 1,
  66550: 1,
  66552: 1,
  66554: 1,
  66555: 1,
  66601: 1,
  66603: 1,
  66604: 1,
  66605: 1,
  66606: 1,
  66607: 1,
  66608: 1,
  66609: 1,
  66610: 1,
  66611: 1,
  66612: 1,
  66614: 1,
  66615: 1,
  66616: 1,
  66617: 1,
  66618: 1,
  66619: 1,
  66620: 1,
  66621: 1,
  66622: 1,
  66624: 1,
  66625: 1,
  66626: 1,
  66628: 1,
  66629: 1,
  66634: 1,
  66636: 1,
  66637: 1,
  66638: 1,
  66642: 1,
  66647: 1,
  66652: 1,
  66653: 1,
  66658: 1,
  66667: 1,
  66675: 1,
  66683: 1,
  66686: 1,
  66692: 1,
  66699: 1,
  66701: 1,
  66710: 1,
  66711: 1,
  66712: 1,
  66713: 1,
  66714: 1,
  66716: 1,
  66717: 1,
  66720: 1,
  66724: 1,
  66725: 1,
  66728: 1,
  66732: 1,
  66733: 1,
  66734: 1,
  66735: 1,
  66736: 1,
  66738: 1,
  66739: 1,
  66740: 1,
  66741: 1,
  66742: 1,
  66743: 1,
  66746: 1,
  66748: 1,
  66749: 1,
  66751: 1,
  66753: 1,
  66754: 1,
  66755: 1,
  66756: 1,
  66757: 1,
  66758: 1,
  66759: 1,
  66760: 1,
  66761: 1,
  66762: 1,
  66763: 1,
  66767: 1,
  66769: 1,
  66770: 1,
  66771: 1,
  66772: 1,
  66773: 1,
  66775: 1,
  66776: 1,
  66777: 1,
  66778: 1,
  66779: 1,
  66780: 1,
  66781: 1,
  66782: 1,
  66783: 1,
  66801: 1,
  66830: 1,
  66833: 1,
  66834: 1,
  66835: 1,
  66838: 1,
  66839: 1,
  66840: 1,
  66842: 1,
  66843: 1,
  66845: 1,
  66846: 1,
  66849: 1,
  66850: 1,
  66851: 1,
  66852: 1,
  66853: 1,
  66854: 1,
  66855: 1,
  66856: 1,
  66857: 1,
  66858: 1,
  66859: 1,
  66860: 1,
  66861: 1,
  66862: 1,
  66863: 1,
  66864: 1,
  66865: 1,
  66866: 1,
  66868: 1,
  66869: 1,
  66870: 1,
  66871: 1,
  66872: 1,
  66873: 1,
  66901: 1,
  66930: 1,
  66932: 1,
  66933: 1,
  66935: 1,
  66936: 1,
  66937: 1,
  66938: 1,
  66939: 1,
  66940: 1,
  66941: 1,
  66942: 1,
  66943: 1,
  66944: 1,
  66945: 1,
  66946: 1,
  66948: 1,
  66949: 1,
  66951: 1,
  66952: 1,
  66953: 1,
  66955: 1,
  66956: 1,
  66958: 1,
  66959: 1,
  66960: 1,
  66961: 1,
  66962: 1,
  66963: 1,
  66964: 1,
  66966: 1,
  66967: 1,
  66968: 1,
  66970: 1,
  67001: 1,
  67002: 1,
  67003: 1,
  67004: 1,
  67005: 1,
  67008: 1,
  67009: 1,
  67010: 1,
  67012: 1,
  67013: 1,
  67016: 1,
  67017: 1,
  67018: 1,
  67019: 1,
  67020: 1,
  67021: 1,
  67022: 1,
  67023: 1,
  67024: 1,
  67025: 1,
  67026: 1,
  67028: 1,
  67029: 1,
  67030: 1,
  67031: 1,
  67035: 1,
  67036: 1,
  67037: 1,
  67038: 1,
  67039: 1,
  67041: 1,
  67042: 1,
  67045: 1,
  67047: 1,
  67049: 1,
  67050: 1,
  67051: 1,
  67052: 1,
  67053: 1,
  67054: 1,
  67055: 1,
  67056: 1,
  67057: 1,
  67058: 1,
  67059: 1,
  67060: 1,
  67061: 1,
  67062: 1,
  67063: 1,
  67065: 1,
  67066: 1,
  67067: 1,
  67068: 1,
  67070: 1,
  67071: 1,
  67072: 1,
  67073: 1,
  67074: 1,
  67101: 1,
  67102: 1,
  67103: 1,
  67104: 1,
  67105: 1,
  67106: 1,
  67107: 1,
  67108: 1,
  67109: 1,
  67110: 1,
  67111: 1,
  67112: 1,
  67114: 1,
  67117: 1,
  67118: 1,
  67119: 1,
  67120: 1,
  67122: 1,
  67123: 1,
  67124: 1,
  67127: 1,
  67128: 1,
  67131: 1,
  67132: 1,
  67133: 1,
  67134: 1,
  67135: 1,
  67137: 1,
  67138: 1,
  67140: 1,
  67142: 1,
  67143: 1,
  67144: 1,
  67146: 1,
  67147: 1,
  67149: 1,
  67150: 1,
  67151: 1,
  67152: 1,
  67154: 1,
  67155: 1,
  67156: 1,
  67159: 1,
  67201: 1,
  67202: 1,
  67203: 1,
  67204: 1,
  67205: 1,
  67206: 1,
  67207: 1,
  67208: 1,
  67209: 1,
  67210: 1,
  67211: 1,
  67212: 1,
  67213: 1,
  67214: 1,
  67215: 1,
  67216: 1,
  67217: 1,
  67218: 1,
  67219: 1,
  67220: 1,
  67221: 1,
  67223: 1,
  67226: 1,
  67227: 1,
  67228: 1,
  67230: 1,
  67231: 1,
  67232: 1,
  67233: 1,
  67235: 1,
  67236: 1,
  67251: 1,
  67256: 1,
  67257: 1,
  67259: 1,
  67260: 1,
  67275: 1,
  67276: 1,
  67277: 1,
  67278: 1,
  67301: 1,
  67330: 1,
  67332: 1,
  67333: 1,
  67334: 1,
  67335: 1,
  67336: 1,
  67337: 1,
  67340: 1,
  67341: 1,
  67342: 1,
  67344: 1,
  67345: 1,
  67346: 1,
  67347: 1,
  67349: 1,
  67351: 1,
  67352: 1,
  67353: 1,
  67354: 1,
  67355: 1,
  67356: 1,
  67357: 1,
  67360: 1,
  67361: 1,
  67363: 1,
  67364: 1,
  67401: 1,
  67402: 1,
  67410: 1,
  67416: 1,
  67417: 1,
  67418: 1,
  67420: 1,
  67422: 1,
  67423: 1,
  67425: 1,
  67427: 1,
  67428: 1,
  67430: 1,
  67431: 1,
  67432: 1,
  67436: 1,
  67437: 1,
  67438: 1,
  67439: 1,
  67441: 1,
  67442: 1,
  67443: 1,
  67444: 1,
  67445: 1,
  67446: 1,
  67447: 1,
  67448: 1,
  67449: 1,
  67450: 1,
  67451: 1,
  67452: 1,
  67454: 1,
  67455: 1,
  67456: 1,
  67457: 1,
  67458: 1,
  67459: 1,
  67460: 1,
  67464: 1,
  67466: 1,
  67467: 1,
  67468: 1,
  67470: 1,
  67473: 1,
  67474: 1,
  67475: 1,
  67476: 1,
  67478: 1,
  67480: 1,
  67481: 1,
  67482: 1,
  67483: 1,
  67484: 1,
  67485: 1,
  67487: 1,
  67490: 1,
  67491: 1,
  67492: 1,
  67501: 1,
  67502: 1,
  67504: 1,
  67505: 1,
  67510: 1,
  67511: 1,
  67512: 1,
  67513: 1,
  67514: 1,
  67515: 1,
  67516: 1,
  67518: 1,
  67519: 1,
  67520: 1,
  67521: 1,
  67522: 1,
  67523: 1,
  67524: 1,
  67525: 1,
  67526: 1,
  67529: 1,
  67530: 1,
  67543: 1,
  67544: 1,
  67545: 1,
  67546: 1,
  67547: 1,
  67548: 1,
  67550: 1,
  67552: 1,
  67553: 1,
  67554: 1,
  67556: 1,
  67557: 1,
  67559: 1,
  67560: 1,
  67561: 1,
  67563: 1,
  67564: 1,
  67565: 1,
  67566: 1,
  67567: 1,
  67568: 1,
  67570: 1,
  67572: 1,
  67573: 1,
  67574: 1,
  67575: 1,
  67576: 1,
  67578: 1,
  67579: 1,
  67581: 1,
  67583: 1,
  67584: 1,
  67585: 1,
  67601: 1,
  67621: 1,
  67622: 1,
  67623: 1,
  67625: 1,
  67626: 1,
  67627: 1,
  67628: 1,
  67629: 1,
  67631: 1,
  67632: 1,
  67634: 1,
  67635: 1,
  67637: 1,
  67638: 1,
  67639: 1,
  67640: 1,
  67642: 1,
  67643: 1,
  67644: 1,
  67645: 1,
  67646: 1,
  67647: 1,
  67648: 1,
  67649: 1,
  67650: 1,
  67651: 1,
  67653: 1,
  67654: 1,
  67656: 1,
  67657: 1,
  67658: 1,
  67659: 1,
  67660: 1,
  67661: 1,
  67663: 1,
  67664: 1,
  67665: 1,
  67667: 1,
  67669: 1,
  67671: 1,
  67672: 1,
  67673: 1,
  67674: 1,
  67675: 1,
  67701: 1,
  67730: 1,
  67731: 1,
  67732: 1,
  67733: 2,
  67734: 1,
  67735: 2,
  67736: 1,
  67737: 1,
  67738: 1,
  67739: 1,
  67740: 1,
  67741: 2,
  67743: 1,
  67744: 1,
  67745: 1,
  67747: 1,
  67748: 1,
  67749: 1,
  67751: 1,
  67752: 1,
  67753: 1,
  67756: 1,
  67757: 1,
  67758: 2,
  67761: 2,
  67762: 2,
  67764: 1,
  67801: 1,
  67831: 1,
  67834: 1,
  67835: 1,
  67836: 2,
  67837: 1,
  67838: 1,
  67839: 1,
  67840: 1,
  67841: 1,
  67842: 1,
  67843: 1,
  67844: 1,
  67846: 1,
  67849: 1,
  67850: 1,
  67851: 1,
  67853: 1,
  67854: 1,
  67855: 1,
  67857: 2,
  67859: 1,
  67860: 1,
  67861: 1,
  67862: 1,
  67863: 1,
  67864: 1,
  67865: 1,
  67867: 1,
  67868: 1,
  67869: 1,
  67870: 1,
  67871: 1,
  67876: 1,
  67877: 1,
  67878: 2,
  67879: 2,
  67880: 1,
  67882: 1,
  67901: 1,
  67905: 1,
  67950: 1,
  67951: 1,
  67952: 1,
  67953: 1,
  67954: 1,
  68001: 1,
  68002: 1,
  68003: 1,
  68004: 1,
  68005: 1,
  68007: 1,
  68008: 1,
  68009: 1,
  68010: 1,
  68014: 1,
  68015: 1,
  68016: 1,
  68017: 1,
  68018: 1,
  68019: 1,
  68020: 1,
  68022: 1,
  68023: 1,
  68025: 1,
  68026: 1,
  68028: 1,
  68029: 1,
  68030: 1,
  68031: 1,
  68033: 1,
  68034: 1,
  68036: 1,
  68037: 1,
  68038: 1,
  68039: 1,
  68040: 1,
  68041: 1,
  68042: 1,
  68044: 1,
  68045: 1,
  68046: 1,
  68047: 1,
  68048: 1,
  68050: 1,
  68055: 1,
  68056: 1,
  68057: 1,
  68058: 1,
  68059: 1,
  68061: 1,
  68062: 1,
  68063: 1,
  68064: 1,
  68065: 1,
  68066: 1,
  68067: 1,
  68068: 1,
  68069: 1,
  68070: 1,
  68071: 1,
  68072: 1,
  68073: 1,
  68101: 1,
  68102: 1,
  68103: 1,
  68104: 1,
  68105: 1,
  68106: 1,
  68107: 1,
  68108: 1,
  68109: 1,
  68110: 1,
  68111: 1,
  68112: 1,
  68113: 1,
  68114: 1,
  68116: 1,
  68117: 1,
  68118: 1,
  68119: 1,
  68120: 1,
  68122: 1,
  68123: 1,
  68124: 1,
  68127: 1,
  68128: 1,
  68130: 1,
  68131: 1,
  68132: 1,
  68133: 1,
  68134: 1,
  68135: 1,
  68136: 1,
  68137: 1,
  68138: 1,
  68139: 1,
  68142: 1,
  68144: 1,
  68145: 1,
  68147: 1,
  68152: 1,
  68154: 1,
  68155: 1,
  68157: 1,
  68164: 1,
  68172: 1,
  68175: 1,
  68176: 1,
  68178: 1,
  68179: 1,
  68180: 1,
  68181: 1,
  68182: 1,
  68183: 1,
  68197: 1,
  68198: 1,
  68301: 1,
  68303: 1,
  68304: 1,
  68305: 1,
  68307: 1,
  68309: 1,
  68310: 1,
  68313: 1,
  68314: 1,
  68315: 1,
  68316: 1,
  68317: 1,
  68318: 1,
  68319: 1,
  68320: 1,
  68321: 1,
  68322: 1,
  68323: 1,
  68324: 1,
  68325: 1,
  68326: 1,
  68327: 1,
  68328: 1,
  68329: 1,
  68330: 1,
  68331: 1,
  68332: 1,
  68333: 1,
  68335: 1,
  68336: 1,
  68337: 1,
  68338: 1,
  68339: 1,
  68340: 1,
  68341: 1,
  68342: 1,
  68343: 1,
  68344: 1,
  68345: 1,
  68346: 1,
  68347: 1,
  68348: 1,
  68349: 1,
  68350: 1,
  68351: 1,
  68352: 1,
  68354: 1,
  68355: 1,
  68357: 1,
  68358: 1,
  68359: 1,
  68360: 1,
  68361: 1,
  68362: 1,
  68364: 1,
  68365: 1,
  68366: 1,
  68367: 1,
  68368: 1,
  68370: 1,
  68371: 1,
  68372: 1,
  68375: 1,
  68376: 1,
  68377: 1,
  68378: 1,
  68379: 1,
  68380: 1,
  68381: 1,
  68382: 1,
  68401: 1,
  68402: 1,
  68403: 1,
  68404: 1,
  68405: 1,
  68406: 1,
  68407: 1,
  68409: 1,
  68410: 1,
  68413: 1,
  68414: 1,
  68415: 1,
  68416: 1,
  68417: 1,
  68418: 1,
  68419: 1,
  68420: 1,
  68421: 1,
  68422: 1,
  68423: 1,
  68424: 1,
  68428: 1,
  68429: 1,
  68430: 1,
  68431: 1,
  68433: 1,
  68434: 1,
  68436: 1,
  68437: 1,
  68438: 1,
  68439: 1,
  68440: 1,
  68441: 1,
  68442: 1,
  68443: 1,
  68444: 1,
  68445: 1,
  68446: 1,
  68447: 1,
  68448: 1,
  68450: 1,
  68452: 1,
  68453: 1,
  68454: 1,
  68455: 1,
  68456: 1,
  68457: 1,
  68458: 1,
  68460: 1,
  68461: 1,
  68462: 1,
  68463: 1,
  68464: 1,
  68465: 1,
  68466: 1,
  68467: 1,
  68501: 1,
  68502: 1,
  68503: 1,
  68504: 1,
  68505: 1,
  68506: 1,
  68507: 1,
  68508: 1,
  68509: 1,
  68510: 1,
  68512: 1,
  68514: 1,
  68516: 1,
  68517: 1,
  68520: 1,
  68521: 1,
  68522: 1,
  68523: 1,
  68524: 1,
  68526: 1,
  68527: 1,
  68528: 1,
  68529: 1,
  68531: 1,
  68532: 1,
  68542: 1,
  68583: 1,
  68588: 1,
  68601: 1,
  68602: 1,
  68620: 1,
  68621: 1,
  68622: 1,
  68623: 1,
  68624: 1,
  68626: 1,
  68627: 1,
  68628: 1,
  68629: 1,
  68631: 1,
  68632: 1,
  68633: 1,
  68634: 1,
  68635: 1,
  68636: 1,
  68637: 1,
  68638: 1,
  68640: 1,
  68641: 1,
  68642: 1,
  68643: 1,
  68644: 1,
  68647: 1,
  68648: 1,
  68649: 1,
  68651: 1,
  68652: 1,
  68653: 1,
  68654: 1,
  68655: 1,
  68658: 1,
  68659: 1,
  68660: 1,
  68661: 1,
  68662: 1,
  68663: 1,
  68664: 1,
  68665: 1,
  68666: 1,
  68667: 1,
  68669: 1,
  68701: 1,
  68702: 1,
  68710: 1,
  68711: 1,
  68713: 1,
  68714: 1,
  68715: 1,
  68716: 1,
  68717: 1,
  68718: 1,
  68719: 1,
  68720: 1,
  68722: 1,
  68723: 1,
  68724: 1,
  68725: 1,
  68726: 1,
  68727: 1,
  68728: 1,
  68729: 1,
  68730: 1,
  68731: 1,
  68732: 1,
  68733: 1,
  68734: 1,
  68735: 1,
  68736: 1,
  68738: 1,
  68739: 1,
  68740: 1,
  68741: 1,
  68742: 1,
  68743: 1,
  68745: 1,
  68746: 1,
  68747: 1,
  68748: 1,
  68749: 1,
  68751: 1,
  68752: 1,
  68753: 1,
  68755: 1,
  68756: 1,
  68757: 1,
  68758: 1,
  68759: 1,
  68760: 1,
  68761: 1,
  68763: 1,
  68764: 1,
  68765: 1,
  68766: 1,
  68767: 1,
  68768: 1,
  68769: 1,
  68770: 1,
  68771: 1,
  68773: 1,
  68774: 1,
  68776: 1,
  68777: 1,
  68778: 1,
  68779: 1,
  68780: 1,
  68781: 1,
  68783: 1,
  68784: 1,
  68785: 1,
  68786: 1,
  68787: 1,
  68788: 1,
  68789: 1,
  68790: 1,
  68791: 1,
  68792: 1,
  68801: 1,
  68802: 1,
  68803: 1,
  68810: 1,
  68812: 1,
  68813: 1,
  68814: 1,
  68815: 1,
  68816: 1,
  68817: 1,
  68818: 1,
  68819: 1,
  68820: 1,
  68821: 1,
  68822: 1,
  68823: 1,
  68824: 1,
  68825: 1,
  68826: 1,
  68827: 1,
  68828: 1,
  68831: 1,
  68832: 1,
  68833: 1,
  68834: 1,
  68835: 1,
  68836: 1,
  68837: 1,
  68838: 1,
  68840: 1,
  68841: 1,
  68842: 1,
  68843: 1,
  68844: 1,
  68845: 1,
  68846: 1,
  68847: 1,
  68848: 1,
  68849: 1,
  68850: 1,
  68852: 1,
  68853: 1,
  68854: 1,
  68855: 1,
  68856: 1,
  68858: 1,
  68859: 1,
  68860: 1,
  68861: 1,
  68862: 1,
  68863: 1,
  68864: 1,
  68865: 1,
  68866: 1,
  68869: 1,
  68870: 1,
  68871: 1,
  68872: 1,
  68873: 1,
  68874: 1,
  68875: 1,
  68876: 1,
  68878: 1,
  68879: 1,
  68881: 1,
  68882: 1,
  68883: 1,
  68901: 1,
  68902: 1,
  68920: 1,
  68922: 1,
  68923: 1,
  68924: 1,
  68925: 1,
  68926: 1,
  68927: 1,
  68928: 1,
  68929: 1,
  68930: 1,
  68932: 1,
  68933: 1,
  68934: 1,
  68935: 1,
  68936: 1,
  68937: 1,
  68938: 1,
  68939: 1,
  68940: 1,
  68941: 1,
  68942: 1,
  68943: 1,
  68944: 1,
  68945: 1,
  68946: 1,
  68947: 1,
  68948: 1,
  68949: 1,
  68950: 1,
  68952: 1,
  68954: 1,
  68955: 1,
  68956: 1,
  68957: 1,
  68958: 1,
  68959: 1,
  68960: 1,
  68961: 1,
  68964: 1,
  68966: 1,
  68967: 1,
  68969: 1,
  68970: 1,
  68971: 1,
  68972: 1,
  68973: 1,
  68974: 1,
  68975: 1,
  68976: 1,
  68977: 1,
  68978: 1,
  68979: 1,
  68980: 1,
  68981: 1,
  68982: 1,
  69001: 1,
  69020: 1,
  69021: 2,
  69022: 1,
  69023: 2,
  69024: 1,
  69025: 1,
  69026: 1,
  69027: 2,
  69028: 1,
  69029: 1,
  69030: 2,
  69032: 1,
  69033: 2,
  69034: 1,
  69036: 1,
  69037: 2,
  69038: 1,
  69039: 1,
  69040: 1,
  69041: 2,
  69042: 1,
  69043: 1,
  69044: 1,
  69045: 2,
  69046: 1,
  69101: 1,
  69103: 1,
  69120: 1,
  69121: 2,
  69122: 2,
  69123: 1,
  69125: 2,
  69127: 2,
  69128: 2,
  69129: 2,
  69130: 1,
  69131: 2,
  69132: 1,
  69133: 2,
  69134: 2,
  69135: 1,
  69138: 1,
  69140: 2,
  69141: 2,
  69142: 1,
  69143: 1,
  69144: 2,
  69145: 2,
  69146: 2,
  69147: 2,
  69148: 2,
  69149: 2,
  69150: 2,
  69151: 1,
  69152: 2,
  69153: 2,
  69154: 2,
  69155: 2,
  69156: 2,
  69157: 1,
  69160: 2,
  69161: 1,
  69162: 2,
  69163: 1,
  69165: 1,
  69166: 1,
  69167: 1,
  69168: 2,
  69169: 1,
  69170: 1,
  69171: 1,
  69190: 2,
  69201: 1,
  69210: 1,
  69211: 2,
  69212: 1,
  69214: 1,
  69216: 2,
  69217: 1,
  69218: 2,
  69219: 2,
  69220: 1,
  69221: 1,
  69301: 2,
  69331: 2,
  69333: 2,
  69334: 2,
  69335: 2,
  69336: 2,
  69337: 2,
  69339: 2,
  69340: 2,
  69341: 2,
  69343: 2,
  69345: 2,
  69346: 2,
  69347: 2,
  69348: 2,
  69350: 2,
  69351: 2,
  69352: 2,
  69353: 2,
  69354: 2,
  69355: 2,
  69356: 2,
  69357: 2,
  69358: 2,
  69360: 2,
  69361: 2,
  69363: 2,
  69365: 2,
  69366: 2,
  69367: 2,
  70001: 1,
  70002: 1,
  70003: 1,
  70004: 1,
  70005: 1,
  70006: 1,
  70009: 1,
  70010: 1,
  70011: 1,
  70030: 1,
  70031: 1,
  70032: 1,
  70033: 1,
  70036: 1,
  70037: 1,
  70038: 1,
  70039: 1,
  70040: 1,
  70041: 1,
  70043: 1,
  70044: 1,
  70047: 1,
  70049: 1,
  70050: 1,
  70051: 1,
  70052: 1,
  70053: 1,
  70054: 1,
  70055: 1,
  70056: 1,
  70057: 1,
  70058: 1,
  70059: 1,
  70060: 1,
  70062: 1,
  70063: 1,
  70064: 1,
  70065: 1,
  70067: 1,
  70068: 1,
  70069: 1,
  70070: 1,
  70071: 1,
  70072: 1,
  70073: 1,
  70075: 1,
  70076: 1,
  70078: 1,
  70079: 1,
  70080: 1,
  70081: 1,
  70082: 1,
  70083: 1,
  70084: 1,
  70085: 1,
  70086: 1,
  70087: 1,
  70090: 1,
  70091: 1,
  70092: 1,
  70093: 1,
  70094: 1,
  70096: 1,
  70097: 1,
  70112: 1,
  70113: 1,
  70114: 1,
  70115: 1,
  70116: 1,
  70117: 1,
  70118: 1,
  70119: 1,
  70121: 1,
  70122: 1,
  70123: 1,
  70124: 1,
  70125: 1,
  70126: 1,
  70127: 1,
  70128: 1,
  70129: 1,
  70130: 1,
  70131: 1,
  70139: 1,
  70140: 1,
  70141: 1,
  70142: 1,
  70143: 1,
  70145: 1,
  70146: 1,
  70148: 1,
  70149: 1,
  70150: 1,
  70151: 1,
  70152: 1,
  70153: 1,
  70154: 1,
  70156: 1,
  70157: 1,
  70158: 1,
  70159: 1,
  70160: 1,
  70161: 1,
  70162: 1,
  70163: 1,
  70164: 1,
  70165: 1,
  70166: 1,
  70167: 1,
  70170: 1,
  70172: 1,
  70174: 1,
  70175: 1,
  70176: 1,
  70177: 1,
  70178: 1,
  70179: 1,
  70181: 1,
  70182: 1,
  70183: 1,
  70184: 1,
  70185: 1,
  70186: 1,
  70187: 1,
  70189: 1,
  70190: 1,
  70195: 1,
  70301: 1,
  70302: 1,
  70310: 1,
  70339: 1,
  70340: 1,
  70341: 1,
  70342: 1,
  70343: 1,
  70344: 1,
  70345: 1,
  70346: 1,
  70352: 1,
  70353: 1,
  70354: 1,
  70355: 1,
  70356: 1,
  70357: 1,
  70358: 1,
  70359: 1,
  70360: 1,
  70361: 1,
  70363: 1,
  70364: 1,
  70371: 1,
  70372: 1,
  70373: 1,
  70374: 1,
  70375: 1,
  70377: 1,
  70380: 1,
  70381: 1,
  70390: 1,
  70391: 1,
  70392: 1,
  70393: 1,
  70394: 1,
  70395: 1,
  70397: 1,
  70401: 1,
  70402: 1,
  70403: 1,
  70404: 1,
  70420: 1,
  70421: 1,
  70422: 1,
  70426: 1,
  70427: 1,
  70429: 1,
  70431: 1,
  70433: 1,
  70434: 1,
  70435: 1,
  70436: 1,
  70437: 1,
  70438: 1,
  70441: 1,
  70442: 1,
  70443: 1,
  70444: 1,
  70445: 1,
  70446: 1,
  70447: 1,
  70448: 1,
  70449: 1,
  70450: 1,
  70451: 1,
  70452: 1,
  70453: 1,
  70454: 1,
  70455: 1,
  70456: 1,
  70457: 1,
  70458: 1,
  70459: 1,
  70460: 1,
  70461: 1,
  70462: 1,
  70463: 1,
  70464: 1,
  70465: 1,
  70466: 1,
  70467: 1,
  70469: 1,
  70470: 1,
  70471: 1,
  70500: 1,
  70501: 1,
  70502: 1,
  70503: 1,
  70504: 1,
  70505: 1,
  70506: 1,
  70507: 1,
  70508: 1,
  70509: 1,
  70510: 1,
  70511: 1,
  70512: 1,
  70513: 1,
  70514: 1,
  70515: 1,
  70516: 1,
  70517: 1,
  70518: 1,
  70519: 1,
  70520: 1,
  70521: 1,
  70522: 1,
  70523: 1,
  70524: 1,
  70525: 1,
  70526: 1,
  70527: 1,
  70528: 1,
  70529: 1,
  70531: 1,
  70532: 1,
  70533: 1,
  70534: 1,
  70535: 1,
  70537: 1,
  70538: 1,
  70540: 1,
  70541: 1,
  70542: 1,
  70543: 1,
  70544: 1,
  70546: 1,
  70548: 1,
  70549: 1,
  70550: 1,
  70551: 1,
  70552: 1,
  70554: 1,
  70555: 1,
  70556: 1,
  70558: 1,
  70559: 1,
  70560: 1,
  70562: 1,
  70563: 1,
  70569: 1,
  70570: 1,
  70571: 1,
  70575: 1,
  70576: 1,
  70577: 1,
  70578: 1,
  70580: 1,
  70581: 1,
  70582: 1,
  70583: 1,
  70584: 1,
  70585: 1,
  70586: 1,
  70589: 1,
  70591: 1,
  70592: 1,
  70593: 1,
  70595: 1,
  70596: 1,
  70598: 1,
  70601: 1,
  70602: 1,
  70605: 1,
  70606: 1,
  70607: 1,
  70609: 1,
  70611: 1,
  70612: 1,
  70615: 1,
  70616: 1,
  70629: 1,
  70630: 1,
  70631: 1,
  70632: 1,
  70633: 1,
  70634: 1,
  70637: 1,
  70638: 1,
  70639: 1,
  70640: 1,
  70643: 1,
  70644: 1,
  70645: 1,
  70646: 1,
  70647: 1,
  70648: 1,
  70650: 1,
  70651: 1,
  70652: 1,
  70653: 1,
  70654: 1,
  70655: 1,
  70656: 1,
  70657: 1,
  70658: 1,
  70659: 1,
  70660: 1,
  70661: 1,
  70662: 1,
  70663: 1,
  70664: 1,
  70665: 1,
  70668: 1,
  70669: 1,
  70704: 1,
  70706: 1,
  70707: 1,
  70710: 1,
  70711: 1,
  70712: 1,
  70714: 1,
  70715: 1,
  70718: 1,
  70719: 1,
  70721: 1,
  70722: 1,
  70723: 1,
  70725: 1,
  70726: 1,
  70727: 1,
  70728: 1,
  70729: 1,
  70730: 1,
  70732: 1,
  70733: 1,
  70734: 1,
  70736: 1,
  70737: 1,
  70738: 1,
  70739: 1,
  70740: 1,
  70743: 1,
  70744: 1,
  70747: 1,
  70748: 1,
  70749: 1,
  70750: 1,
  70752: 1,
  70753: 1,
  70754: 1,
  70755: 1,
  70756: 1,
  70757: 1,
  70759: 1,
  70760: 1,
  70761: 1,
  70762: 1,
  70763: 1,
  70764: 1,
  70765: 1,
  70767: 1,
  70769: 1,
  70770: 1,
  70772: 1,
  70773: 1,
  70774: 1,
  70775: 1,
  70776: 1,
  70777: 1,
  70778: 1,
  70780: 1,
  70782: 1,
  70783: 1,
  70784: 1,
  70785: 1,
  70786: 1,
  70787: 1,
  70788: 1,
  70789: 1,
  70791: 1,
  70792: 1,
  70801: 1,
  70802: 1,
  70803: 1,
  70804: 1,
  70805: 1,
  70806: 1,
  70807: 1,
  70808: 1,
  70809: 1,
  70810: 1,
  70811: 1,
  70812: 1,
  70813: 1,
  70814: 1,
  70815: 1,
  70816: 1,
  70817: 1,
  70818: 1,
  70819: 1,
  70820: 1,
  70821: 1,
  70822: 1,
  70823: 1,
  70825: 1,
  70826: 1,
  70827: 1,
  70831: 1,
  70833: 1,
  70835: 1,
  70836: 1,
  70837: 1,
  70873: 1,
  70874: 1,
  70879: 1,
  70883: 1,
  70884: 1,
  70891: 1,
  70892: 1,
  70893: 1,
  70894: 1,
  70895: 1,
  70896: 1,
  70898: 1,
  71001: 1,
  71002: 1,
  71003: 1,
  71004: 1,
  71006: 1,
  71007: 1,
  71008: 1,
  71009: 1,
  71016: 1,
  71018: 1,
  71019: 1,
  71021: 1,
  71023: 1,
  71024: 1,
  71025: 1,
  71027: 1,
  71028: 1,
  71029: 1,
  71030: 1,
  71031: 1,
  71032: 1,
  71033: 1,
  71034: 1,
  71036: 1,
  71037: 1,
  71038: 1,
  71039: 1,
  71040: 1,
  71043: 1,
  71044: 1,
  71045: 1,
  71046: 1,
  71047: 1,
  71048: 1,
  71049: 1,
  71050: 1,
  71051: 1,
  71052: 1,
  71055: 1,
  71058: 1,
  71060: 1,
  71061: 1,
  71063: 1,
  71064: 1,
  71065: 1,
  71066: 1,
  71067: 1,
  71068: 1,
  71069: 1,
  71070: 1,
  71071: 1,
  71072: 1,
  71073: 1,
  71075: 1,
  71078: 1,
  71079: 1,
  71080: 1,
  71082: 1,
  71101: 1,
  71102: 1,
  71103: 1,
  71104: 1,
  71105: 1,
  71106: 1,
  71107: 1,
  71108: 1,
  71109: 1,
  71110: 1,
  71111: 1,
  71112: 1,
  71113: 1,
  71115: 1,
  71118: 1,
  71119: 1,
  71120: 1,
  71129: 1,
  71130: 1,
  71133: 1,
  71134: 1,
  71135: 1,
  71136: 1,
  71137: 1,
  71138: 1,
  71148: 1,
  71149: 1,
  71150: 1,
  71151: 1,
  71152: 1,
  71153: 1,
  71154: 1,
  71156: 1,
  71161: 1,
  71162: 1,
  71163: 1,
  71164: 1,
  71165: 1,
  71166: 1,
  71171: 1,
  71172: 1,
  71201: 1,
  71202: 1,
  71203: 1,
  71207: 1,
  71208: 1,
  71209: 1,
  71210: 1,
  71211: 1,
  71212: 1,
  71213: 1,
  71217: 1,
  71218: 1,
  71219: 1,
  71220: 1,
  71221: 1,
  71222: 1,
  71223: 1,
  71225: 1,
  71226: 1,
  71227: 1,
  71229: 1,
  71230: 1,
  71232: 1,
  71233: 1,
  71234: 1,
  71235: 1,
  71237: 1,
  71238: 1,
  71240: 1,
  71241: 1,
  71242: 1,
  71243: 1,
  71245: 1,
  71247: 1,
  71249: 1,
  71250: 1,
  71251: 1,
  71253: 1,
  71254: 1,
  71256: 1,
  71259: 1,
  71260: 1,
  71261: 1,
  71263: 1,
  71264: 1,
  71266: 1,
  71268: 1,
  71269: 1,
  71270: 1,
  71272: 1,
  71273: 1,
  71275: 1,
  71276: 1,
  71277: 1,
  71279: 1,
  71280: 1,
  71281: 1,
  71282: 1,
  71284: 1,
  71286: 1,
  71291: 1,
  71292: 1,
  71294: 1,
  71295: 1,
  71301: 1,
  71302: 1,
  71303: 1,
  71306: 1,
  71307: 1,
  71309: 1,
  71315: 1,
  71316: 1,
  71320: 1,
  71322: 1,
  71323: 1,
  71324: 1,
  71325: 1,
  71326: 1,
  71327: 1,
  71328: 1,
  71329: 1,
  71330: 1,
  71331: 1,
  71333: 1,
  71334: 1,
  71336: 1,
  71339: 1,
  71340: 1,
  71341: 1,
  71342: 1,
  71343: 1,
  71345: 1,
  71346: 1,
  71348: 1,
  71350: 1,
  71351: 1,
  71353: 1,
  71354: 1,
  71355: 1,
  71356: 1,
  71357: 1,
  71358: 1,
  71359: 1,
  71360: 1,
  71361: 1,
  71362: 1,
  71363: 1,
  71365: 1,
  71366: 1,
  71367: 1,
  71368: 1,
  71369: 1,
  71371: 1,
  71373: 1,
  71375: 1,
  71377: 1,
  71378: 1,
  71401: 1,
  71403: 1,
  71404: 1,
  71405: 1,
  71406: 1,
  71407: 1,
  71409: 1,
  71410: 1,
  71411: 1,
  71414: 1,
  71415: 1,
  71416: 1,
  71417: 1,
  71418: 1,
  71419: 1,
  71422: 1,
  71423: 1,
  71424: 1,
  71425: 1,
  71426: 1,
  71427: 1,
  71428: 1,
  71429: 1,
  71430: 1,
  71431: 1,
  71432: 1,
  71433: 1,
  71434: 1,
  71435: 1,
  71438: 1,
  71439: 1,
  71440: 1,
  71441: 1,
  71443: 1,
  71446: 1,
  71447: 1,
  71448: 1,
  71449: 1,
  71450: 1,
  71452: 1,
  71454: 1,
  71455: 1,
  71456: 1,
  71457: 1,
  71458: 1,
  71459: 1,
  71460: 1,
  71461: 1,
  71462: 1,
  71463: 1,
  71465: 1,
  71466: 1,
  71467: 1,
  71468: 1,
  71469: 1,
  71471: 1,
  71472: 1,
  71473: 1,
  71474: 1,
  71475: 1,
  71477: 1,
  71479: 1,
  71480: 1,
  71483: 1,
  71485: 1,
  71486: 1,
  71496: 1,
  71497: 1,
  71601: 1,
  71602: 1,
  71603: 1,
  71611: 1,
  71612: 1,
  71613: 1,
  71630: 1,
  71631: 1,
  71635: 1,
  71638: 1,
  71639: 1,
  71640: 1,
  71642: 1,
  71643: 1,
  71644: 1,
  71646: 1,
  71647: 1,
  71651: 1,
  71652: 1,
  71653: 1,
  71654: 1,
  71655: 1,
  71656: 1,
  71657: 1,
  71658: 1,
  71659: 1,
  71660: 1,
  71661: 1,
  71662: 1,
  71663: 1,
  71665: 1,
  71666: 1,
  71667: 1,
  71670: 1,
  71671: 1,
  71674: 1,
  71675: 1,
  71676: 1,
  71677: 1,
  71678: 1,
  71701: 1,
  71711: 1,
  71720: 1,
  71721: 1,
  71722: 1,
  71724: 1,
  71725: 1,
  71726: 1,
  71728: 1,
  71730: 1,
  71731: 1,
  71740: 1,
  71742: 1,
  71743: 1,
  71744: 1,
  71745: 1,
  71747: 1,
  71748: 1,
  71749: 1,
  71750: 1,
  71751: 1,
  71752: 1,
  71753: 1,
  71754: 1,
  71758: 1,
  71759: 1,
  71762: 1,
  71763: 1,
  71764: 1,
  71765: 1,
  71766: 1,
  71768: 1,
  71770: 1,
  71772: 1,
  71801: 1,
  71802: 1,
  71820: 1,
  71822: 1,
  71823: 1,
  71825: 1,
  71826: 1,
  71827: 1,
  71828: 1,
  71831: 1,
  71832: 1,
  71833: 1,
  71834: 1,
  71835: 1,
  71836: 1,
  71837: 1,
  71838: 1,
  71839: 1,
  71840: 1,
  71841: 1,
  71842: 1,
  71844: 1,
  71845: 1,
  71846: 1,
  71847: 1,
  71851: 1,
  71852: 1,
  71853: 1,
  71854: 1,
  71855: 1,
  71857: 1,
  71858: 1,
  71859: 1,
  71860: 1,
  71861: 1,
  71862: 1,
  71864: 1,
  71865: 1,
  71866: 1,
  71901: 1,
  71902: 1,
  71903: 1,
  71909: 1,
  71910: 1,
  71913: 1,
  71914: 1,
  71920: 1,
  71921: 1,
  71922: 1,
  71923: 1,
  71929: 1,
  71932: 1,
  71933: 1,
  71935: 1,
  71937: 1,
  71940: 1,
  71941: 1,
  71942: 1,
  71943: 1,
  71944: 1,
  71945: 1,
  71949: 1,
  71950: 1,
  71951: 1,
  71952: 1,
  71953: 1,
  71956: 1,
  71957: 1,
  71958: 1,
  71959: 1,
  71960: 1,
  71961: 1,
  71962: 1,
  71964: 1,
  71965: 1,
  71966: 1,
  71968: 1,
  71969: 1,
  71970: 1,
  71971: 1,
  71972: 1,
  71973: 1,
  71998: 1,
  71999: 1,
  72001: 1,
  72002: 1,
  72003: 1,
  72004: 1,
  72005: 1,
  72006: 1,
  72007: 1,
  72010: 1,
  72011: 1,
  72012: 1,
  72013: 1,
  72014: 1,
  72015: 1,
  72016: 1,
  72017: 1,
  72018: 1,
  72019: 1,
  72020: 1,
  72021: 1,
  72022: 1,
  72023: 1,
  72024: 1,
  72025: 1,
  72026: 1,
  72027: 1,
  72028: 1,
  72029: 1,
  72030: 1,
  72031: 1,
  72032: 1,
  72033: 1,
  72034: 1,
  72035: 1,
  72036: 1,
  72037: 1,
  72038: 1,
  72039: 1,
  72040: 1,
  72041: 1,
  72042: 1,
  72043: 1,
  72044: 1,
  72045: 1,
  72046: 1,
  72047: 1,
  72048: 1,
  72051: 1,
  72052: 1,
  72053: 1,
  72055: 1,
  72057: 1,
  72058: 1,
  72059: 1,
  72060: 1,
  72061: 1,
  72063: 1,
  72064: 1,
  72065: 1,
  72066: 1,
  72067: 1,
  72068: 1,
  72069: 1,
  72070: 1,
  72072: 1,
  72073: 1,
  72074: 1,
  72075: 1,
  72076: 1,
  72078: 1,
  72079: 1,
  72080: 1,
  72081: 1,
  72082: 1,
  72083: 1,
  72084: 1,
  72085: 1,
  72086: 1,
  72087: 1,
  72088: 1,
  72089: 1,
  72099: 1,
  72101: 1,
  72102: 1,
  72103: 1,
  72104: 1,
  72105: 1,
  72106: 1,
  72107: 1,
  72108: 1,
  72110: 1,
  72111: 1,
  72112: 1,
  72113: 1,
  72114: 1,
  72115: 1,
  72116: 1,
  72117: 1,
  72118: 1,
  72119: 1,
  72120: 1,
  72121: 1,
  72122: 1,
  72123: 1,
  72124: 1,
  72125: 1,
  72126: 1,
  72127: 1,
  72128: 1,
  72129: 1,
  72130: 1,
  72131: 1,
  72132: 1,
  72133: 1,
  72134: 1,
  72135: 1,
  72136: 1,
  72137: 1,
  72139: 1,
  72140: 1,
  72141: 1,
  72142: 1,
  72143: 1,
  72145: 1,
  72149: 1,
  72150: 1,
  72152: 1,
  72153: 1,
  72156: 1,
  72157: 1,
  72158: 1,
  72160: 1,
  72164: 1,
  72165: 1,
  72166: 1,
  72167: 1,
  72168: 1,
  72169: 1,
  72170: 1,
  72173: 1,
  72175: 1,
  72176: 1,
  72178: 1,
  72179: 1,
  72180: 1,
  72181: 1,
  72182: 1,
  72183: 1,
  72189: 1,
  72190: 1,
  72198: 1,
  72199: 1,
  72201: 1,
  72202: 1,
  72203: 1,
  72204: 1,
  72205: 1,
  72206: 1,
  72207: 1,
  72209: 1,
  72210: 1,
  72211: 1,
  72212: 1,
  72214: 1,
  72215: 1,
  72216: 1,
  72217: 1,
  72219: 1,
  72221: 1,
  72222: 1,
  72223: 1,
  72225: 1,
  72227: 1,
  72231: 1,
  72260: 1,
  72295: 1,
  72301: 1,
  72303: 1,
  72310: 1,
  72311: 1,
  72312: 1,
  72313: 1,
  72315: 1,
  72316: 1,
  72319: 1,
  72320: 1,
  72321: 1,
  72322: 1,
  72324: 1,
  72325: 1,
  72326: 1,
  72327: 1,
  72328: 1,
  72329: 1,
  72330: 1,
  72331: 1,
  72332: 1,
  72333: 1,
  72335: 1,
  72336: 1,
  72338: 1,
  72339: 1,
  72340: 1,
  72341: 1,
  72342: 1,
  72346: 1,
  72347: 1,
  72348: 1,
  72350: 1,
  72351: 1,
  72352: 1,
  72353: 1,
  72354: 1,
  72355: 1,
  72358: 1,
  72359: 1,
  72360: 1,
  72364: 1,
  72365: 1,
  72366: 1,
  72367: 1,
  72368: 1,
  72369: 1,
  72370: 1,
  72372: 1,
  72373: 1,
  72374: 1,
  72376: 1,
  72377: 1,
  72379: 1,
  72383: 1,
  72384: 1,
  72386: 1,
  72387: 1,
  72389: 1,
  72390: 1,
  72391: 1,
  72392: 1,
  72394: 1,
  72395: 1,
  72396: 1,
  72401: 1,
  72402: 1,
  72403: 1,
  72404: 1,
  72410: 1,
  72411: 1,
  72412: 1,
  72413: 1,
  72414: 1,
  72415: 1,
  72416: 1,
  72417: 1,
  72419: 1,
  72421: 1,
  72422: 1,
  72424: 1,
  72425: 1,
  72426: 1,
  72427: 1,
  72428: 1,
  72429: 1,
  72430: 1,
  72431: 1,
  72432: 1,
  72433: 1,
  72434: 1,
  72435: 1,
  72436: 1,
  72437: 1,
  72438: 1,
  72439: 1,
  72440: 1,
  72441: 1,
  72442: 1,
  72443: 1,
  72444: 1,
  72445: 1,
  72447: 1,
  72449: 1,
  72450: 1,
  72451: 1,
  72453: 1,
  72454: 1,
  72455: 1,
  72456: 1,
  72457: 1,
  72458: 1,
  72459: 1,
  72460: 1,
  72461: 1,
  72462: 1,
  72464: 1,
  72465: 1,
  72466: 1,
  72467: 1,
  72469: 1,
  72470: 1,
  72471: 1,
  72472: 1,
  72473: 1,
  72474: 1,
  72475: 1,
  72476: 1,
  72478: 1,
  72479: 1,
  72482: 1,
  72501: 1,
  72503: 1,
  72512: 1,
  72513: 1,
  72515: 1,
  72517: 1,
  72519: 1,
  72520: 1,
  72521: 1,
  72522: 1,
  72523: 1,
  72524: 1,
  72525: 1,
  72526: 1,
  72527: 1,
  72528: 1,
  72529: 1,
  72530: 1,
  72531: 1,
  72532: 1,
  72533: 1,
  72534: 1,
  72536: 1,
  72537: 1,
  72538: 1,
  72539: 1,
  72540: 1,
  72542: 1,
  72543: 1,
  72544: 1,
  72545: 1,
  72546: 1,
  72550: 1,
  72553: 1,
  72554: 1,
  72555: 1,
  72556: 1,
  72560: 1,
  72561: 1,
  72562: 1,
  72564: 1,
  72565: 1,
  72566: 1,
  72567: 1,
  72568: 1,
  72569: 1,
  72571: 1,
  72572: 1,
  72573: 1,
  72575: 1,
  72576: 1,
  72577: 1,
  72578: 1,
  72579: 1,
  72581: 1,
  72583: 1,
  72584: 1,
  72585: 1,
  72587: 1,
  72601: 1,
  72602: 1,
  72611: 1,
  72613: 1,
  72615: 1,
  72616: 1,
  72617: 1,
  72619: 1,
  72623: 1,
  72624: 1,
  72626: 1,
  72628: 1,
  72629: 1,
  72630: 1,
  72631: 1,
  72632: 1,
  72633: 1,
  72634: 1,
  72635: 1,
  72636: 1,
  72638: 1,
  72639: 1,
  72640: 1,
  72641: 1,
  72642: 1,
  72644: 1,
  72645: 1,
  72648: 1,
  72650: 1,
  72651: 1,
  72653: 1,
  72654: 1,
  72655: 1,
  72657: 1,
  72658: 1,
  72659: 1,
  72660: 1,
  72661: 1,
  72662: 1,
  72663: 1,
  72666: 1,
  72668: 1,
  72669: 1,
  72670: 1,
  72672: 1,
  72675: 1,
  72677: 1,
  72679: 1,
  72680: 1,
  72682: 1,
  72683: 1,
  72685: 1,
  72686: 1,
  72687: 1,
  72701: 1,
  72702: 1,
  72703: 1,
  72704: 1,
  72711: 1,
  72712: 1,
  72714: 1,
  72715: 1,
  72716: 1,
  72717: 1,
  72718: 1,
  72719: 1,
  72721: 1,
  72722: 1,
  72727: 1,
  72728: 1,
  72729: 1,
  72730: 1,
  72732: 1,
  72733: 1,
  72734: 1,
  72735: 1,
  72736: 1,
  72737: 1,
  72738: 1,
  72739: 1,
  72740: 1,
  72741: 1,
  72742: 1,
  72744: 1,
  72745: 1,
  72747: 1,
  72749: 1,
  72751: 1,
  72752: 1,
  72753: 1,
  72756: 1,
  72757: 1,
  72758: 1,
  72760: 1,
  72761: 1,
  72762: 1,
  72764: 1,
  72765: 1,
  72766: 1,
  72768: 1,
  72769: 1,
  72770: 1,
  72773: 1,
  72774: 1,
  72776: 1,
  72801: 1,
  72802: 1,
  72811: 1,
  72812: 1,
  72820: 1,
  72821: 1,
  72823: 1,
  72824: 1,
  72826: 1,
  72827: 1,
  72828: 1,
  72829: 1,
  72830: 1,
  72832: 1,
  72833: 1,
  72834: 1,
  72835: 1,
  72837: 1,
  72838: 1,
  72839: 1,
  72840: 1,
  72841: 1,
  72842: 1,
  72843: 1,
  72845: 1,
  72846: 1,
  72847: 1,
  72851: 1,
  72852: 1,
  72853: 1,
  72854: 1,
  72855: 1,
  72856: 1,
  72857: 1,
  72858: 1,
  72860: 1,
  72863: 1,
  72865: 1,
  72901: 1,
  72902: 1,
  72903: 1,
  72904: 1,
  72905: 1,
  72906: 1,
  72908: 1,
  72913: 1,
  72914: 1,
  72916: 1,
  72917: 1,
  72918: 1,
  72919: 1,
  72921: 1,
  72923: 1,
  72924: 1,
  72926: 1,
  72927: 1,
  72928: 1,
  72930: 1,
  72932: 1,
  72933: 1,
  72934: 1,
  72935: 1,
  72936: 1,
  72937: 1,
  72938: 1,
  72940: 1,
  72941: 1,
  72943: 1,
  72944: 1,
  72945: 1,
  72946: 1,
  72947: 1,
  72948: 1,
  72949: 1,
  72950: 1,
  72951: 1,
  72952: 1,
  72955: 1,
  72956: 1,
  72957: 1,
  72958: 1,
  72959: 1,
  73001: 1,
  73002: 1,
  73003: 1,
  73004: 1,
  73005: 1,
  73006: 1,
  73007: 1,
  73008: 1,
  73009: 1,
  73010: 1,
  73011: 1,
  73012: 1,
  73013: 1,
  73014: 1,
  73015: 1,
  73016: 1,
  73017: 1,
  73018: 1,
  73019: 1,
  73020: 1,
  73021: 1,
  73022: 1,
  73023: 1,
  73024: 1,
  73025: 1,
  73026: 1,
  73027: 1,
  73028: 1,
  73029: 1,
  73030: 1,
  73031: 1,
  73032: 1,
  73033: 1,
  73034: 1,
  73036: 1,
  73038: 1,
  73039: 1,
  73040: 1,
  73041: 1,
  73042: 1,
  73043: 1,
  73044: 1,
  73045: 1,
  73047: 1,
  73048: 1,
  73049: 1,
  73050: 1,
  73051: 1,
  73052: 1,
  73053: 1,
  73054: 1,
  73055: 1,
  73056: 1,
  73057: 1,
  73058: 1,
  73059: 1,
  73061: 1,
  73062: 1,
  73063: 1,
  73064: 1,
  73065: 1,
  73066: 1,
  73067: 1,
  73068: 1,
  73069: 1,
  73070: 1,
  73071: 1,
  73072: 1,
  73073: 1,
  73074: 1,
  73075: 1,
  73077: 1,
  73078: 1,
  73079: 1,
  73080: 1,
  73082: 1,
  73083: 1,
  73084: 1,
  73085: 1,
  73086: 1,
  73089: 1,
  73090: 1,
  73092: 1,
  73093: 1,
  73094: 1,
  73095: 1,
  73096: 1,
  73097: 1,
  73098: 1,
  73099: 1,
  73101: 1,
  73102: 1,
  73103: 1,
  73104: 1,
  73105: 1,
  73106: 1,
  73107: 1,
  73108: 1,
  73109: 1,
  73110: 1,
  73111: 1,
  73112: 1,
  73113: 1,
  73114: 1,
  73115: 1,
  73116: 1,
  73117: 1,
  73118: 1,
  73119: 1,
  73120: 1,
  73121: 1,
  73122: 1,
  73123: 1,
  73124: 1,
  73125: 1,
  73126: 1,
  73127: 1,
  73128: 1,
  73129: 1,
  73130: 1,
  73131: 1,
  73132: 1,
  73134: 1,
  73135: 1,
  73136: 1,
  73137: 1,
  73139: 1,
  73140: 1,
  73141: 1,
  73142: 1,
  73143: 1,
  73144: 1,
  73145: 1,
  73146: 1,
  73147: 1,
  73148: 1,
  73149: 1,
  73150: 1,
  73151: 1,
  73152: 1,
  73153: 1,
  73154: 1,
  73155: 1,
  73156: 1,
  73157: 1,
  73159: 1,
  73160: 1,
  73162: 1,
  73163: 1,
  73164: 1,
  73165: 1,
  73167: 1,
  73169: 1,
  73170: 1,
  73172: 1,
  73173: 1,
  73178: 1,
  73179: 1,
  73184: 1,
  73185: 1,
  73189: 1,
  73190: 1,
  73193: 1,
  73194: 1,
  73195: 1,
  73196: 1,
  73197: 1,
  73198: 1,
  73199: 1,
  73301: 1,
  73344: 1,
  73401: 1,
  73402: 1,
  73403: 1,
  73425: 1,
  73430: 1,
  73432: 1,
  73433: 1,
  73434: 1,
  73435: 1,
  73436: 1,
  73437: 1,
  73438: 1,
  73439: 1,
  73440: 1,
  73441: 1,
  73442: 1,
  73443: 1,
  73444: 1,
  73446: 1,
  73447: 1,
  73448: 1,
  73449: 1,
  73450: 1,
  73453: 1,
  73455: 1,
  73456: 1,
  73458: 1,
  73459: 1,
  73460: 1,
  73461: 1,
  73463: 1,
  73476: 1,
  73481: 1,
  73487: 1,
  73488: 1,
  73491: 1,
  73501: 1,
  73502: 1,
  73503: 1,
  73505: 1,
  73506: 1,
  73507: 1,
  73520: 1,
  73521: 1,
  73522: 1,
  73523: 1,
  73526: 1,
  73527: 1,
  73528: 1,
  73529: 1,
  73530: 1,
  73531: 1,
  73532: 1,
  73533: 1,
  73534: 1,
  73536: 1,
  73537: 1,
  73538: 1,
  73539: 1,
  73540: 1,
  73541: 1,
  73542: 1,
  73543: 1,
  73544: 1,
  73546: 1,
  73547: 1,
  73548: 1,
  73549: 1,
  73550: 1,
  73551: 1,
  73552: 1,
  73553: 1,
  73554: 1,
  73555: 1,
  73556: 1,
  73557: 1,
  73558: 1,
  73559: 1,
  73560: 1,
  73561: 1,
  73562: 1,
  73564: 1,
  73565: 1,
  73566: 1,
  73567: 1,
  73568: 1,
  73569: 1,
  73570: 1,
  73571: 1,
  73572: 1,
  73573: 1,
  73601: 1,
  73620: 1,
  73622: 1,
  73624: 1,
  73625: 1,
  73626: 1,
  73627: 1,
  73628: 1,
  73632: 1,
  73638: 1,
  73639: 1,
  73641: 1,
  73642: 1,
  73644: 1,
  73645: 1,
  73646: 1,
  73647: 1,
  73648: 1,
  73650: 1,
  73651: 1,
  73654: 1,
  73655: 1,
  73658: 1,
  73659: 1,
  73660: 1,
  73661: 1,
  73662: 1,
  73663: 1,
  73664: 1,
  73666: 1,
  73667: 1,
  73668: 1,
  73669: 1,
  73673: 1,
  73701: 1,
  73702: 1,
  73703: 1,
  73705: 1,
  73706: 1,
  73716: 1,
  73717: 1,
  73718: 1,
  73719: 1,
  73720: 1,
  73722: 1,
  73724: 1,
  73726: 1,
  73727: 1,
  73728: 1,
  73729: 1,
  73730: 1,
  73731: 1,
  73733: 1,
  73734: 1,
  73735: 1,
  73736: 1,
  73737: 1,
  73738: 1,
  73739: 1,
  73741: 1,
  73742: 1,
  73743: 1,
  73744: 1,
  73746: 1,
  73747: 1,
  73749: 1,
  73750: 1,
  73753: 1,
  73754: 1,
  73755: 1,
  73756: 1,
  73757: 1,
  73758: 1,
  73759: 1,
  73760: 1,
  73761: 1,
  73762: 1,
  73763: 1,
  73764: 1,
  73766: 1,
  73768: 1,
  73770: 1,
  73771: 1,
  73772: 1,
  73773: 1,
  73801: 1,
  73802: 1,
  73832: 1,
  73834: 1,
  73835: 1,
  73838: 1,
  73840: 1,
  73841: 1,
  73842: 1,
  73843: 1,
  73844: 1,
  73847: 1,
  73848: 1,
  73851: 1,
  73852: 1,
  73853: 1,
  73855: 1,
  73857: 1,
  73858: 1,
  73859: 1,
  73860: 1,
  73901: 1,
  73931: 1,
  73932: 1,
  73933: 1,
  73937: 1,
  73938: 1,
  73939: 1,
  73942: 1,
  73944: 1,
  73945: 1,
  73946: 1,
  73947: 1,
  73949: 1,
  73950: 1,
  73951: 1,
  74001: 1,
  74002: 1,
  74003: 1,
  74004: 1,
  74005: 1,
  74006: 1,
  74008: 1,
  74009: 1,
  74010: 1,
  74011: 1,
  74012: 1,
  74013: 1,
  74014: 1,
  74015: 1,
  74016: 1,
  74017: 1,
  74018: 1,
  74019: 1,
  74020: 1,
  74021: 1,
  74022: 1,
  74023: 1,
  74026: 1,
  74027: 1,
  74028: 1,
  74029: 1,
  74030: 1,
  74031: 1,
  74032: 1,
  74033: 1,
  74034: 1,
  74035: 1,
  74036: 1,
  74037: 1,
  74038: 1,
  74039: 1,
  74041: 1,
  74042: 1,
  74043: 1,
  74044: 1,
  74045: 1,
  74046: 1,
  74047: 1,
  74048: 1,
  74050: 1,
  74051: 1,
  74052: 1,
  74053: 1,
  74054: 1,
  74055: 1,
  74056: 1,
  74058: 1,
  74059: 1,
  74060: 1,
  74061: 1,
  74062: 1,
  74063: 1,
  74066: 1,
  74067: 1,
  74068: 1,
  74070: 1,
  74071: 1,
  74072: 1,
  74073: 1,
  74074: 1,
  74075: 1,
  74076: 1,
  74077: 1,
  74078: 1,
  74079: 1,
  74080: 1,
  74081: 1,
  74082: 1,
  74083: 1,
  74084: 1,
  74085: 1,
  74101: 1,
  74102: 1,
  74103: 1,
  74104: 1,
  74105: 1,
  74106: 1,
  74107: 1,
  74108: 1,
  74110: 1,
  74112: 1,
  74114: 1,
  74115: 1,
  74116: 1,
  74117: 1,
  74119: 1,
  74120: 1,
  74121: 1,
  74126: 1,
  74127: 1,
  74128: 1,
  74129: 1,
  74130: 1,
  74131: 1,
  74132: 1,
  74133: 1,
  74134: 1,
  74135: 1,
  74136: 1,
  74137: 1,
  74141: 1,
  74145: 1,
  74146: 1,
  74147: 1,
  74148: 1,
  74149: 1,
  74150: 1,
  74152: 1,
  74153: 1,
  74155: 1,
  74156: 1,
  74157: 1,
  74158: 1,
  74159: 1,
  74169: 1,
  74170: 1,
  74171: 1,
  74172: 1,
  74182: 1,
  74183: 1,
  74184: 1,
  74186: 1,
  74187: 1,
  74189: 1,
  74192: 1,
  74193: 1,
  74194: 1,
  74301: 1,
  74330: 1,
  74331: 1,
  74332: 1,
  74333: 1,
  74335: 1,
  74337: 1,
  74338: 1,
  74339: 1,
  74340: 1,
  74342: 1,
  74343: 1,
  74344: 1,
  74345: 1,
  74346: 1,
  74347: 1,
  74349: 1,
  74350: 1,
  74352: 1,
  74354: 1,
  74355: 1,
  74358: 1,
  74359: 1,
  74360: 1,
  74361: 1,
  74362: 1,
  74363: 1,
  74364: 1,
  74365: 1,
  74366: 1,
  74367: 1,
  74368: 1,
  74369: 1,
  74370: 1,
  74401: 1,
  74402: 1,
  74403: 1,
  74421: 1,
  74422: 1,
  74423: 1,
  74425: 1,
  74426: 1,
  74427: 1,
  74428: 1,
  74429: 1,
  74430: 1,
  74431: 1,
  74432: 1,
  74434: 1,
  74435: 1,
  74436: 1,
  74437: 1,
  74438: 1,
  74439: 1,
  74440: 1,
  74441: 1,
  74442: 1,
  74444: 1,
  74445: 1,
  74446: 1,
  74447: 1,
  74450: 1,
  74451: 1,
  74452: 1,
  74454: 1,
  74455: 1,
  74456: 1,
  74457: 1,
  74458: 1,
  74459: 1,
  74460: 1,
  74461: 1,
  74462: 1,
  74463: 1,
  74464: 1,
  74465: 1,
  74467: 1,
  74468: 1,
  74469: 1,
  74470: 1,
  74471: 1,
  74472: 1,
  74477: 1,
  74501: 1,
  74502: 1,
  74521: 1,
  74522: 1,
  74523: 1,
  74525: 1,
  74528: 1,
  74529: 1,
  74530: 1,
  74531: 1,
  74533: 1,
  74534: 1,
  74535: 1,
  74536: 1,
  74538: 1,
  74540: 1,
  74542: 1,
  74543: 1,
  74545: 1,
  74546: 1,
  74547: 1,
  74549: 1,
  74552: 1,
  74553: 1,
  74554: 1,
  74555: 1,
  74556: 1,
  74557: 1,
  74558: 1,
  74559: 1,
  74560: 1,
  74561: 1,
  74562: 1,
  74563: 1,
  74565: 1,
  74567: 1,
  74569: 1,
  74570: 1,
  74571: 1,
  74572: 1,
  74574: 1,
  74576: 1,
  74577: 1,
  74578: 1,
  74601: 1,
  74602: 1,
  74604: 1,
  74630: 1,
  74631: 1,
  74632: 1,
  74633: 1,
  74636: 1,
  74637: 1,
  74640: 1,
  74641: 1,
  74643: 1,
  74644: 1,
  74646: 1,
  74647: 1,
  74650: 1,
  74651: 1,
  74652: 1,
  74653: 1,
  74701: 1,
  74702: 1,
  74720: 1,
  74721: 1,
  74722: 1,
  74723: 1,
  74724: 1,
  74726: 1,
  74727: 1,
  74728: 1,
  74729: 1,
  74730: 1,
  74731: 1,
  74733: 1,
  74734: 1,
  74735: 1,
  74736: 1,
  74737: 1,
  74738: 1,
  74740: 1,
  74741: 1,
  74743: 1,
  74745: 1,
  74747: 1,
  74748: 1,
  74750: 1,
  74752: 1,
  74753: 1,
  74754: 1,
  74755: 1,
  74756: 1,
  74759: 1,
  74760: 1,
  74761: 1,
  74764: 1,
  74766: 1,
  74801: 1,
  74802: 1,
  74804: 1,
  74818: 1,
  74820: 1,
  74821: 1,
  74824: 1,
  74825: 1,
  74826: 1,
  74827: 1,
  74829: 1,
  74830: 1,
  74831: 1,
  74832: 1,
  74833: 1,
  74834: 1,
  74836: 1,
  74837: 1,
  74839: 1,
  74840: 1,
  74842: 1,
  74843: 1,
  74844: 1,
  74845: 1,
  74848: 1,
  74849: 1,
  74850: 1,
  74851: 1,
  74852: 1,
  74854: 1,
  74855: 1,
  74856: 1,
  74857: 1,
  74859: 1,
  74860: 1,
  74864: 1,
  74865: 1,
  74866: 1,
  74867: 1,
  74868: 1,
  74869: 1,
  74871: 1,
  74872: 1,
  74873: 1,
  74875: 1,
  74878: 1,
  74880: 1,
  74881: 1,
  74883: 1,
  74884: 1,
  74901: 1,
  74902: 1,
  74930: 1,
  74931: 1,
  74932: 1,
  74935: 1,
  74936: 1,
  74937: 1,
  74939: 1,
  74940: 1,
  74941: 1,
  74942: 1,
  74943: 1,
  74944: 1,
  74945: 1,
  74946: 1,
  74947: 1,
  74948: 1,
  74949: 1,
  74951: 1,
  74953: 1,
  74954: 1,
  74955: 1,
  74956: 1,
  74957: 1,
  74959: 1,
  74960: 1,
  74962: 1,
  74963: 1,
  74964: 1,
  74965: 1,
  74966: 1,
  75001: 1,
  75002: 1,
  75006: 1,
  75007: 1,
  75008: 1,
  75009: 1,
  75010: 1,
  75011: 1,
  75013: 1,
  75014: 1,
  75015: 1,
  75016: 1,
  75017: 1,
  75019: 1,
  75020: 1,
  75021: 1,
  75022: 1,
  75023: 1,
  75024: 1,
  75025: 1,
  75026: 1,
  75027: 1,
  75028: 1,
  75029: 1,
  75030: 1,
  75032: 1,
  75033: 1,
  75034: 1,
  75035: 1,
  75037: 1,
  75038: 1,
  75039: 1,
  75040: 1,
  75041: 1,
  75042: 1,
  75043: 1,
  75044: 1,
  75045: 1,
  75046: 1,
  75047: 1,
  75048: 1,
  75049: 1,
  75050: 1,
  75051: 1,
  75052: 1,
  75053: 1,
  75054: 1,
  75056: 1,
  75057: 1,
  75058: 1,
  75060: 1,
  75061: 1,
  75062: 1,
  75063: 1,
  75065: 1,
  75067: 1,
  75068: 1,
  75069: 1,
  75070: 1,
  75071: 1,
  75074: 1,
  75075: 1,
  75076: 1,
  75077: 1,
  75078: 1,
  75080: 1,
  75081: 1,
  75082: 1,
  75083: 1,
  75085: 1,
  75086: 1,
  75087: 1,
  75088: 1,
  75089: 1,
  75090: 1,
  75091: 1,
  75092: 1,
  75093: 1,
  75094: 1,
  75097: 1,
  75098: 1,
  75099: 1,
  75101: 1,
  75102: 1,
  75103: 1,
  75104: 1,
  75105: 1,
  75106: 1,
  75109: 1,
  75110: 1,
  75114: 1,
  75115: 1,
  75116: 1,
  75117: 1,
  75118: 1,
  75119: 1,
  75120: 1,
  75121: 1,
  75123: 1,
  75124: 1,
  75125: 1,
  75126: 1,
  75127: 1,
  75132: 1,
  75134: 1,
  75135: 1,
  75137: 1,
  75138: 1,
  75140: 1,
  75141: 1,
  75142: 1,
  75143: 1,
  75144: 1,
  75146: 1,
  75147: 1,
  75148: 1,
  75149: 1,
  75150: 1,
  75151: 1,
  75152: 1,
  75153: 1,
  75154: 1,
  75155: 1,
  75156: 1,
  75157: 1,
  75158: 1,
  75159: 1,
  75160: 1,
  75161: 1,
  75163: 1,
  75164: 1,
  75165: 1,
  75166: 1,
  75167: 1,
  75168: 1,
  75169: 1,
  75172: 1,
  75173: 1,
  75180: 1,
  75181: 1,
  75182: 1,
  75185: 1,
  75187: 1,
  75189: 1,
  75201: 1,
  75202: 1,
  75203: 1,
  75204: 1,
  75205: 1,
  75206: 1,
  75207: 1,
  75208: 1,
  75209: 1,
  75210: 1,
  75211: 1,
  75212: 1,
  75214: 1,
  75215: 1,
  75216: 1,
  75217: 1,
  75218: 1,
  75219: 1,
  75220: 1,
  75221: 1,
  75222: 1,
  75223: 1,
  75224: 1,
  75225: 1,
  75226: 1,
  75227: 1,
  75228: 1,
  75229: 1,
  75230: 1,
  75231: 1,
  75232: 1,
  75233: 1,
  75234: 1,
  75235: 1,
  75236: 1,
  75237: 1,
  75238: 1,
  75239: 1,
  75240: 1,
  75241: 1,
  75242: 1,
  75243: 1,
  75244: 1,
  75245: 1,
  75246: 1,
  75247: 1,
  75248: 1,
  75249: 1,
  75250: 1,
  75251: 1,
  75252: 1,
  75253: 1,
  75254: 1,
  75258: 1,
  75260: 1,
  75261: 1,
  75262: 1,
  75263: 1,
  75264: 1,
  75265: 1,
  75266: 1,
  75267: 1,
  75270: 1,
  75275: 1,
  75277: 1,
  75283: 1,
  75284: 1,
  75285: 1,
  75286: 1,
  75287: 1,
  75295: 1,
  75301: 1,
  75303: 1,
  75310: 1,
  75312: 1,
  75313: 1,
  75315: 1,
  75320: 1,
  75323: 1,
  75326: 1,
  75334: 1,
  75336: 1,
  75339: 1,
  75340: 1,
  75342: 1,
  75343: 1,
  75344: 1,
  75346: 1,
  75353: 1,
  75354: 1,
  75355: 1,
  75356: 1,
  75357: 1,
  75358: 1,
  75359: 1,
  75360: 1,
  75363: 1,
  75364: 1,
  75367: 1,
  75368: 1,
  75369: 1,
  75370: 1,
  75371: 1,
  75372: 1,
  75373: 1,
  75374: 1,
  75376: 1,
  75378: 1,
  75379: 1,
  75380: 1,
  75381: 1,
  75382: 1,
  75386: 1,
  75387: 1,
  75388: 1,
  75389: 1,
  75390: 1,
  75391: 1,
  75392: 1,
  75393: 1,
  75394: 1,
  75395: 1,
  75396: 1,
  75397: 1,
  75398: 1,
  75401: 1,
  75402: 1,
  75403: 1,
  75404: 1,
  75407: 1,
  75409: 1,
  75410: 1,
  75411: 1,
  75412: 1,
  75413: 1,
  75414: 1,
  75415: 1,
  75416: 1,
  75417: 1,
  75418: 1,
  75420: 1,
  75421: 1,
  75422: 1,
  75423: 1,
  75424: 1,
  75425: 1,
  75426: 1,
  75428: 1,
  75429: 1,
  75431: 1,
  75432: 1,
  75433: 1,
  75434: 1,
  75435: 1,
  75436: 1,
  75437: 1,
  75438: 1,
  75439: 1,
  75440: 1,
  75441: 1,
  75442: 1,
  75443: 1,
  75444: 1,
  75446: 1,
  75447: 1,
  75448: 1,
  75449: 1,
  75450: 1,
  75451: 1,
  75452: 1,
  75453: 1,
  75454: 1,
  75455: 1,
  75456: 1,
  75457: 1,
  75458: 1,
  75459: 1,
  75460: 1,
  75461: 1,
  75462: 1,
  75468: 1,
  75469: 1,
  75470: 1,
  75471: 1,
  75472: 1,
  75473: 1,
  75474: 1,
  75475: 1,
  75476: 1,
  75477: 1,
  75478: 1,
  75479: 1,
  75480: 1,
  75481: 1,
  75482: 1,
  75483: 1,
  75485: 1,
  75486: 1,
  75487: 1,
  75488: 1,
  75489: 1,
  75490: 1,
  75491: 1,
  75492: 1,
  75493: 1,
  75494: 1,
  75495: 1,
  75496: 1,
  75497: 1,
  75501: 1,
  75503: 1,
  75504: 1,
  75505: 1,
  75507: 1,
  75550: 1,
  75551: 1,
  75554: 1,
  75555: 1,
  75556: 1,
  75558: 1,
  75559: 1,
  75560: 1,
  75561: 1,
  75562: 1,
  75563: 1,
  75564: 1,
  75565: 1,
  75566: 1,
  75567: 1,
  75568: 1,
  75569: 1,
  75570: 1,
  75571: 1,
  75572: 1,
  75573: 1,
  75574: 1,
  75599: 1,
  75601: 1,
  75602: 1,
  75603: 1,
  75604: 1,
  75605: 1,
  75606: 1,
  75607: 1,
  75608: 1,
  75615: 1,
  75630: 1,
  75631: 1,
  75633: 1,
  75636: 1,
  75637: 1,
  75638: 1,
  75639: 1,
  75640: 1,
  75641: 1,
  75642: 1,
  75643: 1,
  75644: 1,
  75645: 1,
  75647: 1,
  75650: 1,
  75651: 1,
  75652: 1,
  75653: 1,
  75654: 1,
  75656: 1,
  75657: 1,
  75658: 1,
  75659: 1,
  75660: 1,
  75661: 1,
  75662: 1,
  75663: 1,
  75666: 1,
  75667: 1,
  75668: 1,
  75669: 1,
  75670: 1,
  75671: 1,
  75672: 1,
  75680: 1,
  75681: 1,
  75682: 1,
  75683: 1,
  75684: 1,
  75685: 1,
  75686: 1,
  75687: 1,
  75688: 1,
  75689: 1,
  75691: 1,
  75692: 1,
  75693: 1,
  75694: 1,
  75701: 1,
  75702: 1,
  75703: 1,
  75704: 1,
  75705: 1,
  75706: 1,
  75707: 1,
  75708: 1,
  75709: 1,
  75710: 1,
  75711: 1,
  75712: 1,
  75713: 1,
  75750: 1,
  75751: 1,
  75752: 1,
  75754: 1,
  75755: 1,
  75756: 1,
  75757: 1,
  75758: 1,
  75759: 1,
  75760: 1,
  75762: 1,
  75763: 1,
  75764: 1,
  75765: 1,
  75766: 1,
  75770: 1,
  75771: 1,
  75772: 1,
  75773: 1,
  75778: 1,
  75779: 1,
  75780: 1,
  75782: 1,
  75783: 1,
  75784: 1,
  75785: 1,
  75788: 1,
  75789: 1,
  75790: 1,
  75791: 1,
  75792: 1,
  75797: 1,
  75798: 1,
  75799: 1,
  75801: 1,
  75802: 1,
  75803: 1,
  75831: 1,
  75832: 1,
  75833: 1,
  75834: 1,
  75835: 1,
  75838: 1,
  75839: 1,
  75840: 1,
  75844: 1,
  75845: 1,
  75846: 1,
  75847: 1,
  75848: 1,
  75849: 1,
  75850: 1,
  75851: 1,
  75852: 1,
  75853: 1,
  75855: 1,
  75856: 1,
  75858: 1,
  75859: 1,
  75860: 1,
  75861: 1,
  75862: 1,
  75865: 1,
  75880: 1,
  75882: 1,
  75884: 1,
  75886: 1,
  75901: 1,
  75902: 1,
  75903: 1,
  75904: 1,
  75915: 1,
  75925: 1,
  75926: 1,
  75928: 1,
  75929: 1,
  75930: 1,
  75931: 1,
  75932: 1,
  75933: 1,
  75934: 1,
  75935: 1,
  75936: 1,
  75937: 1,
  75938: 1,
  75939: 1,
  75941: 1,
  75942: 1,
  75943: 1,
  75944: 1,
  75946: 1,
  75947: 1,
  75948: 1,
  75949: 1,
  75951: 1,
  75954: 1,
  75956: 1,
  75958: 1,
  75959: 1,
  75960: 1,
  75961: 1,
  75962: 1,
  75963: 1,
  75964: 1,
  75965: 1,
  75966: 1,
  75968: 1,
  75969: 1,
  75972: 1,
  75973: 1,
  75974: 1,
  75975: 1,
  75976: 1,
  75977: 1,
  75978: 1,
  75979: 1,
  75980: 1,
  75990: 1,
  76001: 1,
  76002: 1,
  76003: 1,
  76004: 1,
  76005: 1,
  76006: 1,
  76007: 1,
  76008: 1,
  76009: 1,
  76010: 1,
  76011: 1,
  76012: 1,
  76013: 1,
  76014: 1,
  76015: 1,
  76016: 1,
  76017: 1,
  76018: 1,
  76019: 1,
  76020: 1,
  76021: 1,
  76022: 1,
  76023: 1,
  76028: 1,
  76031: 1,
  76033: 1,
  76034: 1,
  76035: 1,
  76036: 1,
  76039: 1,
  76040: 1,
  76041: 1,
  76043: 1,
  76044: 1,
  76048: 1,
  76049: 1,
  76050: 1,
  76051: 1,
  76052: 1,
  76053: 1,
  76054: 1,
  76055: 1,
  76058: 1,
  76059: 1,
  76060: 1,
  76061: 1,
  76063: 1,
  76064: 1,
  76065: 1,
  76066: 1,
  76067: 1,
  76068: 1,
  76070: 1,
  76071: 1,
  76073: 1,
  76077: 1,
  76078: 1,
  76082: 1,
  76084: 1,
  76085: 1,
  76086: 1,
  76087: 1,
  76088: 1,
  76092: 1,
  76093: 1,
  76094: 1,
  76095: 1,
  76096: 1,
  76097: 1,
  76098: 1,
  76099: 1,
  76101: 1,
  76102: 1,
  76103: 1,
  76104: 1,
  76105: 1,
  76106: 1,
  76107: 1,
  76108: 1,
  76109: 1,
  76110: 1,
  76111: 1,
  76112: 1,
  76113: 1,
  76114: 1,
  76115: 1,
  76116: 1,
  76117: 1,
  76118: 1,
  76119: 1,
  76120: 1,
  76121: 1,
  76122: 1,
  76123: 1,
  76124: 1,
  76126: 1,
  76127: 1,
  76129: 1,
  76130: 1,
  76131: 1,
  76132: 1,
  76133: 1,
  76134: 1,
  76135: 1,
  76136: 1,
  76137: 1,
  76140: 1,
  76147: 1,
  76148: 1,
  76150: 1,
  76155: 1,
  76161: 1,
  76162: 1,
  76163: 1,
  76164: 1,
  76166: 1,
  76177: 1,
  76178: 1,
  76179: 1,
  76180: 1,
  76181: 1,
  76182: 1,
  76185: 1,
  76191: 1,
  76192: 1,
  76193: 1,
  76195: 1,
  76196: 1,
  76197: 1,
  76198: 1,
  76199: 1,
  76201: 1,
  76202: 1,
  76203: 1,
  76204: 1,
  76205: 1,
  76206: 1,
  76207: 1,
  76208: 1,
  76209: 1,
  76210: 1,
  76225: 1,
  76226: 1,
  76227: 1,
  76228: 1,
  76230: 1,
  76233: 1,
  76234: 1,
  76238: 1,
  76239: 1,
  76240: 1,
  76241: 1,
  76244: 1,
  76245: 1,
  76246: 1,
  76247: 1,
  76248: 1,
  76249: 1,
  76250: 1,
  76251: 1,
  76252: 1,
  76253: 1,
  76255: 1,
  76258: 1,
  76259: 1,
  76261: 1,
  76262: 1,
  76263: 1,
  76264: 1,
  76265: 1,
  76266: 1,
  76267: 1,
  76268: 1,
  76270: 1,
  76271: 1,
  76272: 1,
  76273: 1,
  76299: 1,
  76301: 1,
  76302: 1,
  76305: 1,
  76306: 1,
  76307: 1,
  76308: 1,
  76309: 1,
  76310: 1,
  76311: 1,
  76351: 1,
  76352: 1,
  76354: 1,
  76357: 1,
  76360: 1,
  76363: 1,
  76364: 1,
  76365: 1,
  76366: 1,
  76367: 1,
  76369: 1,
  76370: 1,
  76371: 1,
  76372: 1,
  76373: 1,
  76374: 1,
  76377: 1,
  76379: 1,
  76380: 1,
  76384: 1,
  76385: 1,
  76388: 1,
  76389: 1,
  76401: 1,
  76402: 1,
  76424: 1,
  76426: 1,
  76427: 1,
  76429: 1,
  76430: 1,
  76431: 1,
  76432: 1,
  76433: 1,
  76435: 1,
  76436: 1,
  76437: 1,
  76439: 1,
  76442: 1,
  76443: 1,
  76444: 1,
  76445: 1,
  76446: 1,
  76448: 1,
  76449: 1,
  76450: 1,
  76452: 1,
  76453: 1,
  76454: 1,
  76455: 1,
  76457: 1,
  76458: 1,
  76459: 1,
  76460: 1,
  76461: 1,
  76462: 1,
  76463: 1,
  76464: 1,
  76465: 1,
  76466: 1,
  76467: 1,
  76468: 1,
  76469: 1,
  76470: 1,
  76471: 1,
  76472: 1,
  76474: 1,
  76475: 1,
  76476: 1,
  76481: 1,
  76483: 1,
  76484: 1,
  76485: 1,
  76486: 1,
  76487: 1,
  76490: 1,
  76491: 1,
  76501: 1,
  76502: 1,
  76503: 1,
  76504: 1,
  76505: 1,
  76508: 1,
  76511: 1,
  76513: 1,
  76518: 1,
  76519: 1,
  76520: 1,
  76522: 1,
  76523: 1,
  76524: 1,
  76525: 1,
  76526: 1,
  76527: 1,
  76528: 1,
  76530: 1,
  76531: 1,
  76533: 1,
  76534: 1,
  76537: 1,
  76538: 1,
  76539: 1,
  76540: 1,
  76541: 1,
  76542: 1,
  76543: 1,
  76544: 1,
  76545: 1,
  76546: 1,
  76547: 1,
  76548: 1,
  76549: 1,
  76550: 1,
  76554: 1,
  76556: 1,
  76557: 1,
  76558: 1,
  76559: 1,
  76561: 1,
  76564: 1,
  76565: 1,
  76566: 1,
  76567: 1,
  76569: 1,
  76570: 1,
  76571: 1,
  76573: 1,
  76574: 1,
  76577: 1,
  76578: 1,
  76579: 1,
  76596: 1,
  76597: 1,
  76598: 1,
  76599: 1,
  76621: 1,
  76622: 1,
  76623: 1,
  76624: 1,
  76626: 1,
  76627: 1,
  76628: 1,
  76629: 1,
  76630: 1,
  76631: 1,
  76632: 1,
  76633: 1,
  76634: 1,
  76635: 1,
  76636: 1,
  76637: 1,
  76638: 1,
  76639: 1,
  76640: 1,
  76641: 1,
  76642: 1,
  76643: 1,
  76644: 1,
  76645: 1,
  76648: 1,
  76649: 1,
  76650: 1,
  76651: 1,
  76652: 1,
  76653: 1,
  76654: 1,
  76655: 1,
  76656: 1,
  76657: 1,
  76660: 1,
  76661: 1,
  76664: 1,
  76665: 1,
  76666: 1,
  76667: 1,
  76670: 1,
  76671: 1,
  76673: 1,
  76675: 1,
  76676: 1,
  76678: 1,
  76679: 1,
  76680: 1,
  76681: 1,
  76682: 1,
  76684: 1,
  76685: 1,
  76686: 1,
  76687: 1,
  76689: 1,
  76690: 1,
  76691: 1,
  76692: 1,
  76693: 1,
  76701: 1,
  76702: 1,
  76703: 1,
  76704: 1,
  76705: 1,
  76706: 1,
  76707: 1,
  76708: 1,
  76710: 1,
  76711: 1,
  76712: 1,
  76714: 1,
  76715: 1,
  76716: 1,
  76795: 1,
  76797: 1,
  76798: 1,
  76799: 1,
  76801: 1,
  76802: 1,
  76803: 1,
  76804: 1,
  76820: 1,
  76821: 1,
  76823: 1,
  76824: 1,
  76825: 1,
  76827: 1,
  76828: 1,
  76831: 1,
  76832: 1,
  76834: 1,
  76836: 1,
  76837: 1,
  76841: 1,
  76842: 1,
  76844: 1,
  76845: 1,
  76848: 1,
  76849: 1,
  76852: 1,
  76853: 1,
  76854: 1,
  76855: 1,
  76856: 1,
  76857: 1,
  76858: 1,
  76859: 1,
  76861: 1,
  76862: 1,
  76864: 1,
  76865: 1,
  76866: 1,
  76867: 1,
  76869: 1,
  76870: 1,
  76871: 1,
  76872: 1,
  76873: 1,
  76874: 1,
  76875: 1,
  76877: 1,
  76878: 1,
  76880: 1,
  76882: 1,
  76883: 1,
  76884: 1,
  76885: 1,
  76886: 1,
  76887: 1,
  76888: 1,
  76890: 1,
  76901: 1,
  76902: 1,
  76903: 1,
  76904: 1,
  76905: 1,
  76906: 1,
  76908: 1,
  76909: 1,
  76930: 1,
  76932: 1,
  76933: 1,
  76934: 1,
  76935: 1,
  76936: 1,
  76937: 1,
  76939: 1,
  76940: 1,
  76941: 1,
  76943: 1,
  76945: 1,
  76949: 1,
  76950: 1,
  76951: 1,
  76953: 1,
  76955: 1,
  76957: 1,
  76958: 1,
  77001: 1,
  77002: 1,
  77003: 1,
  77004: 1,
  77005: 1,
  77006: 1,
  77007: 1,
  77008: 1,
  77009: 1,
  77010: 1,
  77011: 1,
  77012: 1,
  77013: 1,
  77014: 1,
  77015: 1,
  77016: 1,
  77017: 1,
  77018: 1,
  77019: 1,
  77020: 1,
  77021: 1,
  77022: 1,
  77023: 1,
  77024: 1,
  77025: 1,
  77026: 1,
  77027: 1,
  77028: 1,
  77029: 1,
  77030: 1,
  77031: 1,
  77032: 1,
  77033: 1,
  77034: 1,
  77035: 1,
  77036: 1,
  77037: 1,
  77038: 1,
  77039: 1,
  77040: 1,
  77041: 1,
  77042: 1,
  77043: 1,
  77044: 1,
  77045: 1,
  77046: 1,
  77047: 1,
  77048: 1,
  77049: 1,
  77050: 1,
  77051: 1,
  77052: 1,
  77053: 1,
  77054: 1,
  77055: 1,
  77056: 1,
  77057: 1,
  77058: 1,
  77059: 1,
  77060: 1,
  77061: 1,
  77062: 1,
  77063: 1,
  77064: 1,
  77065: 1,
  77066: 1,
  77067: 1,
  77068: 1,
  77069: 1,
  77070: 1,
  77071: 1,
  77072: 1,
  77073: 1,
  77074: 1,
  77075: 1,
  77076: 1,
  77077: 1,
  77078: 1,
  77079: 1,
  77080: 1,
  77081: 1,
  77082: 1,
  77083: 1,
  77084: 1,
  77085: 1,
  77086: 1,
  77087: 1,
  77088: 1,
  77089: 1,
  77090: 1,
  77091: 1,
  77092: 1,
  77093: 1,
  77094: 1,
  77095: 1,
  77096: 1,
  77097: 1,
  77098: 1,
  77099: 1,
  77201: 1,
  77202: 1,
  77203: 1,
  77204: 1,
  77205: 1,
  77206: 1,
  77207: 1,
  77208: 1,
  77209: 1,
  77210: 1,
  77212: 1,
  77213: 1,
  77215: 1,
  77216: 1,
  77217: 1,
  77218: 1,
  77219: 1,
  77220: 1,
  77221: 1,
  77222: 1,
  77223: 1,
  77224: 1,
  77225: 1,
  77226: 1,
  77227: 1,
  77228: 1,
  77229: 1,
  77230: 1,
  77231: 1,
  77233: 1,
  77234: 1,
  77235: 1,
  77236: 1,
  77237: 1,
  77238: 1,
  77240: 1,
  77242: 1,
  77243: 1,
  77244: 1,
  77245: 1,
  77246: 1,
  77247: 1,
  77248: 1,
  77249: 1,
  77250: 1,
  77251: 1,
  77252: 1,
  77253: 1,
  77254: 1,
  77255: 1,
  77256: 1,
  77257: 1,
  77258: 1,
  77259: 1,
  77260: 1,
  77261: 1,
  77262: 1,
  77263: 1,
  77265: 1,
  77266: 1,
  77267: 1,
  77268: 1,
  77269: 1,
  77270: 1,
  77271: 1,
  77272: 1,
  77273: 1,
  77274: 1,
  77275: 1,
  77276: 1,
  77277: 1,
  77278: 1,
  77279: 1,
  77280: 1,
  77281: 1,
  77282: 1,
  77284: 1,
  77285: 1,
  77286: 1,
  77287: 1,
  77288: 1,
  77289: 1,
  77290: 1,
  77291: 1,
  77292: 1,
  77293: 1,
  77294: 1,
  77296: 1,
  77297: 1,
  77298: 1,
  77299: 1,
  77301: 1,
  77302: 1,
  77303: 1,
  77304: 1,
  77305: 1,
  77306: 1,
  77315: 1,
  77316: 1,
  77318: 1,
  77320: 1,
  77325: 1,
  77326: 1,
  77327: 1,
  77328: 1,
  77331: 1,
  77332: 1,
  77333: 1,
  77334: 1,
  77335: 1,
  77336: 1,
  77337: 1,
  77338: 1,
  77339: 1,
  77340: 1,
  77341: 1,
  77342: 1,
  77343: 1,
  77344: 1,
  77345: 1,
  77346: 1,
  77347: 1,
  77348: 1,
  77349: 1,
  77350: 1,
  77351: 1,
  77353: 1,
  77354: 1,
  77355: 1,
  77356: 1,
  77357: 1,
  77358: 1,
  77359: 1,
  77360: 1,
  77362: 1,
  77363: 1,
  77364: 1,
  77365: 1,
  77367: 1,
  77368: 1,
  77369: 1,
  77371: 1,
  77372: 1,
  77373: 1,
  77374: 1,
  77375: 1,
  77376: 1,
  77377: 1,
  77378: 1,
  77379: 1,
  77380: 1,
  77381: 1,
  77382: 1,
  77383: 1,
  77384: 1,
  77385: 1,
  77386: 1,
  77387: 1,
  77388: 1,
  77389: 1,
  77391: 1,
  77393: 1,
  77396: 1,
  77399: 1,
  77401: 1,
  77402: 1,
  77404: 1,
  77406: 1,
  77407: 1,
  77410: 1,
  77411: 1,
  77412: 1,
  77413: 1,
  77414: 1,
  77415: 1,
  77417: 1,
  77418: 1,
  77419: 1,
  77420: 1,
  77422: 1,
  77423: 1,
  77426: 1,
  77428: 1,
  77429: 1,
  77430: 1,
  77431: 1,
  77432: 1,
  77433: 1,
  77434: 1,
  77435: 1,
  77436: 1,
  77437: 1,
  77440: 1,
  77441: 1,
  77442: 1,
  77443: 1,
  77444: 1,
  77445: 1,
  77446: 1,
  77447: 1,
  77448: 1,
  77449: 1,
  77450: 1,
  77451: 1,
  77452: 1,
  77453: 1,
  77454: 1,
  77455: 1,
  77456: 1,
  77457: 1,
  77458: 1,
  77459: 1,
  77460: 1,
  77461: 1,
  77463: 1,
  77464: 1,
  77465: 1,
  77466: 1,
  77467: 1,
  77468: 1,
  77469: 1,
  77470: 1,
  77471: 1,
  77473: 1,
  77474: 1,
  77475: 1,
  77476: 1,
  77477: 1,
  77478: 1,
  77479: 1,
  77480: 1,
  77481: 1,
  77482: 1,
  77483: 1,
  77484: 1,
  77485: 1,
  77486: 1,
  77487: 1,
  77488: 1,
  77489: 1,
  77491: 1,
  77492: 1,
  77493: 1,
  77494: 1,
  77496: 1,
  77497: 1,
  77498: 1,
  77501: 1,
  77502: 1,
  77503: 1,
  77504: 1,
  77505: 1,
  77506: 1,
  77507: 1,
  77508: 1,
  77510: 1,
  77511: 1,
  77512: 1,
  77514: 1,
  77515: 1,
  77516: 1,
  77517: 1,
  77518: 1,
  77519: 1,
  77520: 1,
  77521: 1,
  77522: 1,
  77523: 1,
  77530: 1,
  77531: 1,
  77532: 1,
  77533: 1,
  77534: 1,
  77535: 1,
  77536: 1,
  77538: 1,
  77539: 1,
  77541: 1,
  77542: 1,
  77545: 1,
  77546: 1,
  77547: 1,
  77549: 1,
  77550: 1,
  77551: 1,
  77552: 1,
  77553: 1,
  77554: 1,
  77555: 1,
  77560: 1,
  77561: 1,
  77562: 1,
  77563: 1,
  77564: 1,
  77565: 1,
  77566: 1,
  77568: 1,
  77571: 1,
  77572: 1,
  77573: 1,
  77574: 1,
  77575: 1,
  77577: 1,
  77578: 1,
  77580: 1,
  77581: 1,
  77582: 1,
  77583: 1,
  77584: 1,
  77585: 1,
  77586: 1,
  77587: 1,
  77588: 1,
  77590: 1,
  77591: 1,
  77592: 1,
  77597: 1,
  77598: 1,
  77611: 1,
  77612: 1,
  77613: 1,
  77614: 1,
  77615: 1,
  77616: 1,
  77617: 1,
  77619: 1,
  77622: 1,
  77623: 1,
  77624: 1,
  77625: 1,
  77626: 1,
  77627: 1,
  77629: 1,
  77630: 1,
  77631: 1,
  77632: 1,
  77639: 1,
  77640: 1,
  77641: 1,
  77642: 1,
  77643: 1,
  77650: 1,
  77651: 1,
  77655: 1,
  77656: 1,
  77657: 1,
  77659: 1,
  77660: 1,
  77661: 1,
  77662: 1,
  77663: 1,
  77664: 1,
  77665: 1,
  77670: 1,
  77701: 1,
  77702: 1,
  77703: 1,
  77704: 1,
  77705: 1,
  77706: 1,
  77707: 1,
  77708: 1,
  77709: 1,
  77710: 1,
  77713: 1,
  77720: 1,
  77725: 1,
  77726: 1,
  77801: 1,
  77802: 1,
  77803: 1,
  77805: 1,
  77806: 1,
  77807: 1,
  77808: 1,
  77830: 1,
  77831: 1,
  77833: 1,
  77834: 1,
  77835: 1,
  77836: 1,
  77837: 1,
  77838: 1,
  77840: 1,
  77841: 1,
  77842: 1,
  77843: 1,
  77844: 1,
  77845: 1,
  77850: 1,
  77852: 1,
  77853: 1,
  77855: 1,
  77856: 1,
  77857: 1,
  77859: 1,
  77861: 1,
  77862: 1,
  77863: 1,
  77864: 1,
  77865: 1,
  77866: 1,
  77867: 1,
  77868: 1,
  77869: 1,
  77870: 1,
  77871: 1,
  77872: 1,
  77873: 1,
  77875: 1,
  77876: 1,
  77878: 1,
  77879: 1,
  77880: 1,
  77881: 1,
  77882: 1,
  77901: 1,
  77902: 1,
  77903: 1,
  77904: 1,
  77905: 1,
  77950: 1,
  77951: 1,
  77954: 1,
  77957: 1,
  77960: 1,
  77961: 1,
  77962: 1,
  77963: 1,
  77964: 1,
  77967: 1,
  77968: 1,
  77969: 1,
  77970: 1,
  77971: 1,
  77973: 1,
  77974: 1,
  77975: 1,
  77976: 1,
  77977: 1,
  77978: 1,
  77979: 1,
  77982: 1,
  77983: 1,
  77984: 1,
  77986: 1,
  77987: 1,
  77988: 1,
  77989: 1,
  77990: 1,
  77991: 1,
  77993: 1,
  77994: 1,
  77995: 1,
  78001: 1,
  78002: 1,
  78003: 1,
  78004: 1,
  78005: 1,
  78006: 1,
  78007: 1,
  78008: 1,
  78009: 1,
  78010: 1,
  78011: 1,
  78012: 1,
  78013: 1,
  78014: 1,
  78015: 1,
  78016: 1,
  78017: 1,
  78019: 1,
  78021: 1,
  78022: 1,
  78023: 1,
  78024: 1,
  78025: 1,
  78026: 1,
  78027: 1,
  78028: 1,
  78029: 1,
  78039: 1,
  78040: 1,
  78041: 1,
  78042: 1,
  78043: 1,
  78044: 1,
  78045: 1,
  78046: 1,
  78049: 1,
  78050: 1,
  78052: 1,
  78054: 1,
  78055: 1,
  78056: 1,
  78057: 1,
  78058: 1,
  78059: 1,
  78060: 1,
  78061: 1,
  78062: 1,
  78063: 1,
  78064: 1,
  78065: 1,
  78066: 1,
  78067: 1,
  78069: 1,
  78070: 1,
  78071: 1,
  78072: 1,
  78073: 1,
  78074: 1,
  78075: 1,
  78076: 1,
  78101: 1,
  78102: 1,
  78104: 1,
  78107: 1,
  78108: 1,
  78109: 1,
  78111: 1,
  78112: 1,
  78113: 1,
  78114: 1,
  78115: 1,
  78116: 1,
  78117: 1,
  78118: 1,
  78119: 1,
  78121: 1,
  78122: 1,
  78123: 1,
  78124: 1,
  78125: 1,
  78130: 1,
  78131: 1,
  78132: 1,
  78133: 1,
  78135: 1,
  78140: 1,
  78141: 1,
  78142: 1,
  78143: 1,
  78144: 1,
  78145: 1,
  78146: 1,
  78147: 1,
  78148: 1,
  78150: 1,
  78151: 1,
  78152: 1,
  78154: 1,
  78155: 1,
  78156: 1,
  78159: 1,
  78160: 1,
  78161: 1,
  78162: 1,
  78163: 1,
  78164: 1,
  78201: 1,
  78202: 1,
  78203: 1,
  78204: 1,
  78205: 1,
  78206: 1,
  78207: 1,
  78208: 1,
  78209: 1,
  78210: 1,
  78211: 1,
  78212: 1,
  78213: 1,
  78214: 1,
  78215: 1,
  78216: 1,
  78217: 1,
  78218: 1,
  78219: 1,
  78220: 1,
  78221: 1,
  78222: 1,
  78223: 1,
  78224: 1,
  78225: 1,
  78226: 1,
  78227: 1,
  78228: 1,
  78229: 1,
  78230: 1,
  78231: 1,
  78232: 1,
  78233: 1,
  78234: 1,
  78235: 1,
  78236: 1,
  78237: 1,
  78238: 1,
  78239: 1,
  78240: 1,
  78241: 1,
  78242: 1,
  78243: 1,
  78244: 1,
  78245: 1,
  78246: 1,
  78247: 1,
  78248: 1,
  78249: 1,
  78250: 1,
  78251: 1,
  78252: 1,
  78253: 1,
  78254: 1,
  78255: 1,
  78256: 1,
  78257: 1,
  78258: 1,
  78259: 1,
  78260: 1,
  78261: 1,
  78262: 1,
  78263: 1,
  78264: 1,
  78265: 1,
  78266: 1,
  78268: 1,
  78269: 1,
  78270: 1,
  78275: 1,
  78278: 1,
  78279: 1,
  78280: 1,
  78283: 1,
  78284: 1,
  78285: 1,
  78286: 1,
  78287: 1,
  78288: 1,
  78289: 1,
  78291: 1,
  78292: 1,
  78293: 1,
  78294: 1,
  78295: 1,
  78296: 1,
  78297: 1,
  78298: 1,
  78299: 1,
  78330: 1,
  78332: 1,
  78333: 1,
  78335: 1,
  78336: 1,
  78338: 1,
  78339: 1,
  78340: 1,
  78341: 1,
  78342: 1,
  78343: 1,
  78344: 1,
  78347: 1,
  78349: 1,
  78350: 1,
  78351: 1,
  78352: 1,
  78353: 1,
  78355: 1,
  78357: 1,
  78358: 1,
  78359: 1,
  78360: 1,
  78361: 1,
  78362: 1,
  78363: 1,
  78364: 1,
  78368: 1,
  78369: 1,
  78370: 1,
  78371: 1,
  78372: 1,
  78373: 1,
  78374: 1,
  78375: 1,
  78376: 1,
  78377: 1,
  78379: 1,
  78380: 1,
  78381: 1,
  78382: 1,
  78383: 1,
  78384: 1,
  78385: 1,
  78387: 1,
  78389: 1,
  78390: 1,
  78391: 1,
  78393: 1,
  78401: 1,
  78402: 1,
  78403: 1,
  78404: 1,
  78405: 1,
  78406: 1,
  78407: 1,
  78408: 1,
  78409: 1,
  78410: 1,
  78411: 1,
  78412: 1,
  78413: 1,
  78414: 1,
  78415: 1,
  78416: 1,
  78417: 1,
  78418: 1,
  78419: 1,
  78426: 1,
  78427: 1,
  78460: 1,
  78461: 1,
  78463: 1,
  78465: 1,
  78466: 1,
  78467: 1,
  78468: 1,
  78469: 1,
  78470: 1,
  78471: 1,
  78472: 1,
  78473: 1,
  78474: 1,
  78475: 1,
  78476: 1,
  78477: 1,
  78478: 1,
  78480: 1,
  78501: 1,
  78502: 1,
  78503: 1,
  78504: 1,
  78505: 1,
  78516: 1,
  78520: 1,
  78521: 1,
  78522: 1,
  78523: 1,
  78526: 1,
  78535: 1,
  78536: 1,
  78537: 1,
  78538: 1,
  78539: 1,
  78540: 1,
  78541: 1,
  78542: 1,
  78543: 1,
  78545: 1,
  78547: 1,
  78548: 1,
  78549: 1,
  78550: 1,
  78551: 1,
  78552: 1,
  78553: 1,
  78557: 1,
  78558: 1,
  78559: 1,
  78560: 1,
  78561: 1,
  78562: 1,
  78563: 1,
  78564: 1,
  78565: 1,
  78566: 1,
  78567: 1,
  78568: 1,
  78569: 1,
  78570: 1,
  78572: 1,
  78573: 1,
  78574: 1,
  78575: 1,
  78576: 1,
  78577: 1,
  78578: 1,
  78579: 1,
  78580: 1,
  78582: 1,
  78583: 1,
  78584: 1,
  78585: 1,
  78586: 1,
  78588: 1,
  78589: 1,
  78590: 1,
  78591: 1,
  78592: 1,
  78593: 1,
  78594: 1,
  78595: 1,
  78596: 1,
  78597: 1,
  78598: 1,
  78599: 1,
  78602: 1,
  78604: 1,
  78605: 1,
  78606: 1,
  78607: 1,
  78608: 1,
  78609: 1,
  78610: 1,
  78611: 1,
  78612: 1,
  78613: 1,
  78614: 1,
  78615: 1,
  78616: 1,
  78617: 1,
  78618: 1,
  78619: 1,
  78620: 1,
  78621: 1,
  78622: 1,
  78623: 1,
  78624: 1,
  78626: 1,
  78627: 1,
  78628: 1,
  78629: 1,
  78630: 1,
  78631: 1,
  78632: 1,
  78633: 1,
  78634: 1,
  78635: 1,
  78636: 1,
  78638: 1,
  78639: 1,
  78640: 1,
  78641: 1,
  78642: 1,
  78643: 1,
  78644: 1,
  78645: 1,
  78646: 1,
  78648: 1,
  78650: 1,
  78651: 1,
  78652: 1,
  78653: 1,
  78654: 1,
  78655: 1,
  78656: 1,
  78657: 1,
  78658: 1,
  78659: 1,
  78660: 1,
  78661: 1,
  78662: 1,
  78663: 1,
  78664: 1,
  78665: 1,
  78666: 1,
  78667: 1,
  78669: 1,
  78670: 1,
  78671: 1,
  78672: 1,
  78673: 1,
  78674: 1,
  78675: 1,
  78676: 1,
  78677: 1,
  78680: 1,
  78681: 1,
  78682: 1,
  78683: 1,
  78691: 1,
  78701: 1,
  78702: 1,
  78703: 1,
  78704: 1,
  78705: 1,
  78708: 1,
  78709: 1,
  78710: 1,
  78711: 1,
  78712: 1,
  78713: 1,
  78714: 1,
  78715: 1,
  78716: 1,
  78717: 1,
  78718: 1,
  78719: 1,
  78720: 1,
  78721: 1,
  78722: 1,
  78723: 1,
  78724: 1,
  78725: 1,
  78726: 1,
  78727: 1,
  78728: 1,
  78729: 1,
  78730: 1,
  78731: 1,
  78732: 1,
  78733: 1,
  78734: 1,
  78735: 1,
  78736: 1,
  78737: 1,
  78738: 1,
  78739: 1,
  78741: 1,
  78742: 1,
  78744: 1,
  78745: 1,
  78746: 1,
  78747: 1,
  78748: 1,
  78749: 1,
  78750: 1,
  78751: 1,
  78752: 1,
  78753: 1,
  78754: 1,
  78755: 1,
  78756: 1,
  78757: 1,
  78758: 1,
  78759: 1,
  78760: 1,
  78761: 1,
  78762: 1,
  78763: 1,
  78764: 1,
  78765: 1,
  78766: 1,
  78767: 1,
  78768: 1,
  78769: 1,
  78772: 1,
  78773: 1,
  78774: 1,
  78778: 1,
  78779: 1,
  78780: 1,
  78781: 1,
  78783: 1,
  78785: 1,
  78786: 1,
  78788: 1,
  78789: 1,
  78798: 1,
  78799: 1,
  78801: 1,
  78802: 1,
  78827: 1,
  78828: 1,
  78829: 1,
  78830: 1,
  78832: 1,
  78833: 1,
  78834: 1,
  78836: 1,
  78837: 1,
  78838: 1,
  78839: 1,
  78840: 1,
  78841: 1,
  78842: 1,
  78843: 1,
  78847: 1,
  78850: 1,
  78851: 1,
  78852: 1,
  78853: 1,
  78860: 1,
  78861: 1,
  78870: 1,
  78871: 1,
  78872: 1,
  78873: 1,
  78877: 1,
  78879: 1,
  78880: 1,
  78881: 1,
  78883: 1,
  78884: 1,
  78885: 1,
  78886: 1,
  78931: 1,
  78932: 1,
  78933: 1,
  78934: 1,
  78935: 1,
  78938: 1,
  78940: 1,
  78941: 1,
  78942: 1,
  78943: 1,
  78944: 1,
  78945: 1,
  78946: 1,
  78947: 1,
  78948: 1,
  78949: 1,
  78950: 1,
  78951: 1,
  78952: 1,
  78953: 1,
  78954: 1,
  78956: 1,
  78957: 1,
  78959: 1,
  78960: 1,
  78961: 1,
  78962: 1,
  78963: 1,
  79001: 1,
  79002: 1,
  79003: 1,
  79005: 1,
  79007: 1,
  79008: 1,
  79009: 1,
  79010: 1,
  79011: 1,
  79012: 1,
  79013: 1,
  79014: 1,
  79015: 1,
  79016: 1,
  79018: 1,
  79019: 1,
  79021: 1,
  79022: 1,
  79024: 1,
  79025: 1,
  79027: 1,
  79029: 1,
  79031: 1,
  79032: 1,
  79033: 1,
  79034: 1,
  79035: 1,
  79036: 1,
  79039: 1,
  79040: 1,
  79041: 1,
  79042: 1,
  79043: 1,
  79044: 1,
  79045: 1,
  79046: 1,
  79051: 1,
  79052: 1,
  79053: 1,
  79054: 1,
  79056: 1,
  79057: 1,
  79058: 1,
  79059: 1,
  79061: 1,
  79062: 1,
  79063: 1,
  79064: 1,
  79065: 1,
  79066: 1,
  79068: 1,
  79070: 1,
  79072: 1,
  79073: 1,
  79077: 1,
  79078: 1,
  79079: 1,
  79080: 1,
  79081: 1,
  79082: 1,
  79083: 1,
  79084: 1,
  79085: 1,
  79086: 1,
  79087: 1,
  79088: 1,
  79091: 1,
  79092: 1,
  79093: 1,
  79094: 1,
  79095: 1,
  79096: 1,
  79097: 1,
  79098: 1,
  79101: 1,
  79102: 1,
  79103: 1,
  79104: 1,
  79105: 1,
  79106: 1,
  79107: 1,
  79108: 1,
  79109: 1,
  79110: 1,
  79111: 1,
  79114: 1,
  79116: 1,
  79117: 1,
  79118: 1,
  79119: 1,
  79120: 1,
  79121: 1,
  79123: 1,
  79124: 1,
  79159: 1,
  79163: 1,
  79166: 1,
  79167: 1,
  79168: 1,
  79171: 1,
  79172: 1,
  79174: 1,
  79178: 1,
  79182: 1,
  79185: 1,
  79187: 1,
  79189: 1,
  79201: 1,
  79220: 1,
  79221: 1,
  79223: 1,
  79225: 1,
  79226: 1,
  79227: 1,
  79229: 1,
  79230: 1,
  79231: 1,
  79232: 1,
  79233: 1,
  79234: 1,
  79235: 1,
  79236: 1,
  79237: 1,
  79239: 1,
  79240: 1,
  79241: 1,
  79243: 1,
  79244: 1,
  79245: 1,
  79247: 1,
  79248: 1,
  79250: 1,
  79251: 1,
  79252: 1,
  79255: 1,
  79256: 1,
  79257: 1,
  79258: 1,
  79259: 1,
  79261: 1,
  79311: 1,
  79312: 1,
  79313: 1,
  79314: 1,
  79316: 1,
  79320: 1,
  79322: 1,
  79323: 1,
  79324: 1,
  79325: 1,
  79326: 1,
  79329: 1,
  79330: 1,
  79331: 1,
  79336: 1,
  79338: 1,
  79339: 1,
  79342: 1,
  79343: 1,
  79344: 1,
  79345: 1,
  79346: 1,
  79347: 1,
  79350: 1,
  79351: 1,
  79353: 1,
  79355: 1,
  79356: 1,
  79357: 1,
  79358: 1,
  79359: 1,
  79360: 1,
  79363: 1,
  79364: 1,
  79366: 1,
  79367: 1,
  79369: 1,
  79370: 1,
  79371: 1,
  79372: 1,
  79373: 1,
  79376: 1,
  79377: 1,
  79378: 1,
  79379: 1,
  79380: 1,
  79381: 1,
  79382: 1,
  79383: 1,
  79401: 1,
  79402: 1,
  79403: 1,
  79404: 1,
  79405: 1,
  79406: 1,
  79407: 1,
  79408: 1,
  79409: 1,
  79410: 1,
  79411: 1,
  79412: 1,
  79413: 1,
  79414: 1,
  79415: 1,
  79416: 1,
  79423: 1,
  79424: 1,
  79430: 1,
  79452: 1,
  79453: 1,
  79457: 1,
  79464: 1,
  79490: 1,
  79491: 1,
  79493: 1,
  79499: 1,
  79501: 1,
  79502: 1,
  79503: 1,
  79504: 1,
  79505: 1,
  79506: 1,
  79508: 1,
  79510: 1,
  79511: 1,
  79512: 1,
  79516: 1,
  79517: 1,
  79518: 1,
  79519: 1,
  79520: 1,
  79521: 1,
  79525: 1,
  79526: 1,
  79527: 1,
  79528: 1,
  79529: 1,
  79530: 1,
  79532: 1,
  79533: 1,
  79534: 1,
  79535: 1,
  79536: 1,
  79537: 1,
  79538: 1,
  79539: 1,
  79540: 1,
  79541: 1,
  79543: 1,
  79544: 1,
  79545: 1,
  79546: 1,
  79547: 1,
  79549: 1,
  79550: 1,
  79553: 1,
  79556: 1,
  79560: 1,
  79561: 1,
  79562: 1,
  79563: 1,
  79565: 1,
  79566: 1,
  79567: 1,
  79601: 1,
  79602: 1,
  79603: 1,
  79604: 1,
  79605: 1,
  79606: 1,
  79607: 1,
  79608: 1,
  79697: 1,
  79698: 1,
  79699: 1,
  79701: 1,
  79702: 1,
  79703: 1,
  79704: 1,
  79705: 1,
  79706: 1,
  79707: 1,
  79708: 1,
  79710: 1,
  79711: 1,
  79712: 1,
  79713: 1,
  79714: 1,
  79718: 1,
  79719: 1,
  79720: 1,
  79721: 1,
  79730: 1,
  79731: 1,
  79733: 1,
  79734: 1,
  79735: 1,
  79738: 1,
  79739: 1,
  79740: 1,
  79741: 1,
  79742: 1,
  79743: 1,
  79744: 1,
  79745: 1,
  79748: 1,
  79749: 1,
  79752: 1,
  79754: 1,
  79755: 1,
  79756: 1,
  79758: 1,
  79759: 1,
  79760: 1,
  79761: 1,
  79762: 1,
  79763: 1,
  79764: 1,
  79765: 1,
  79766: 1,
  79768: 1,
  79769: 1,
  79770: 1,
  79772: 1,
  79776: 1,
  79777: 1,
  79778: 1,
  79780: 1,
  79781: 1,
  79782: 1,
  79783: 1,
  79785: 1,
  79786: 1,
  79788: 1,
  79789: 1,
  79821: 2,
  79830: 1,
  79831: 1,
  79832: 1,
  79834: 1,
  79835: 2,
  79836: 2,
  79837: 2,
  79838: 2,
  79839: 2,
  79842: 1,
  79843: 1,
  79845: 1,
  79846: 1,
  79847: 1,
  79848: 1,
  79849: 2,
  79851: 2,
  79852: 1,
  79853: 2,
  79854: 1,
  79855: 1,
  79901: 2,
  79902: 2,
  79903: 2,
  79904: 2,
  79905: 2,
  79906: 2,
  79907: 2,
  79908: 2,
  79910: 2,
  79911: 2,
  79912: 2,
  79913: 2,
  79914: 2,
  79915: 2,
  79916: 2,
  79917: 2,
  79918: 2,
  79920: 2,
  79922: 2,
  79923: 2,
  79924: 2,
  79925: 2,
  79926: 2,
  79927: 2,
  79928: 2,
  79929: 2,
  79930: 2,
  79931: 2,
  79932: 2,
  79934: 2,
  79935: 2,
  79936: 2,
  79937: 2,
  79938: 2,
  79940: 2,
  79941: 2,
  79942: 2,
  79943: 2,
  79944: 2,
  79945: 2,
  79946: 2,
  79947: 2,
  79948: 2,
  79949: 2,
  79950: 2,
  79951: 2,
  79952: 2,
  79953: 2,
  79954: 2,
  79955: 2,
  79958: 2,
  79960: 2,
  79961: 2,
  79966: 2,
  79968: 2,
  79973: 2,
  79974: 2,
  79975: 2,
  79976: 2,
  79977: 2,
  79978: 2,
  79980: 2,
  79982: 2,
  79983: 2,
  79984: 2,
  79985: 2,
  79986: 2,
  79987: 2,
  79988: 2,
  79989: 2,
  79990: 2,
  79991: 2,
  79992: 2,
  79993: 2,
  79994: 2,
  79995: 2,
  79996: 2,
  79997: 2,
  79998: 2,
  79999: 2,
  80001: 2,
  80002: 2,
  80003: 2,
  80004: 2,
  80005: 2,
  80006: 2,
  80007: 2,
  80010: 2,
  80011: 2,
  80012: 2,
  80013: 2,
  80014: 2,
  80015: 2,
  80016: 2,
  80017: 2,
  80018: 2,
  80019: 2,
  80020: 2,
  80021: 2,
  80022: 2,
  80023: 2,
  80024: 2,
  80025: 2,
  80026: 2,
  80027: 2,
  80028: 2,
  80030: 2,
  80031: 2,
  80033: 2,
  80034: 2,
  80035: 2,
  80036: 2,
  80037: 2,
  80038: 2,
  80040: 2,
  80041: 2,
  80042: 2,
  80044: 2,
  80045: 2,
  80046: 2,
  80047: 2,
  80101: 2,
  80102: 2,
  80103: 2,
  80104: 2,
  80105: 2,
  80106: 2,
  80107: 2,
  80108: 2,
  80109: 2,
  80110: 2,
  80111: 2,
  80112: 2,
  80113: 2,
  80116: 2,
  80117: 2,
  80118: 2,
  80120: 2,
  80121: 2,
  80122: 2,
  80123: 2,
  80124: 2,
  80125: 2,
  80126: 2,
  80127: 2,
  80128: 2,
  80129: 2,
  80130: 2,
  80131: 2,
  80132: 2,
  80133: 2,
  80134: 2,
  80135: 2,
  80136: 2,
  80137: 2,
  80138: 2,
  80150: 2,
  80151: 2,
  80154: 2,
  80155: 2,
  80160: 2,
  80161: 2,
  80162: 2,
  80163: 2,
  80165: 2,
  80166: 2,
  80201: 2,
  80202: 2,
  80203: 2,
  80204: 2,
  80205: 2,
  80206: 2,
  80207: 2,
  80208: 2,
  80209: 2,
  80210: 2,
  80211: 2,
  80212: 2,
  80214: 2,
  80215: 2,
  80216: 2,
  80217: 2,
  80218: 2,
  80219: 2,
  80220: 2,
  80221: 2,
  80222: 2,
  80223: 2,
  80224: 2,
  80225: 2,
  80226: 2,
  80227: 2,
  80228: 2,
  80229: 2,
  80230: 2,
  80231: 2,
  80232: 2,
  80233: 2,
  80234: 2,
  80235: 2,
  80236: 2,
  80237: 2,
  80238: 2,
  80239: 2,
  80241: 2,
  80243: 2,
  80244: 2,
  80246: 2,
  80247: 2,
  80248: 2,
  80249: 2,
  80250: 2,
  80251: 2,
  80252: 2,
  80255: 2,
  80256: 2,
  80257: 2,
  80259: 2,
  80260: 2,
  80261: 2,
  80262: 2,
  80263: 2,
  80264: 2,
  80265: 2,
  80266: 2,
  80270: 2,
  80271: 2,
  80273: 2,
  80274: 2,
  80275: 2,
  80279: 2,
  80280: 2,
  80281: 2,
  80285: 2,
  80290: 2,
  80291: 2,
  80292: 2,
  80293: 2,
  80294: 2,
  80295: 2,
  80299: 2,
  80301: 2,
  80302: 2,
  80303: 2,
  80304: 2,
  80305: 2,
  80306: 2,
  80307: 2,
  80308: 2,
  80309: 2,
  80310: 2,
  80314: 2,
  80321: 2,
  80322: 2,
  80323: 2,
  80328: 2,
  80329: 2,
  80401: 2,
  80402: 2,
  80403: 2,
  80419: 2,
  80420: 2,
  80421: 2,
  80422: 2,
  80423: 2,
  80424: 2,
  80425: 2,
  80426: 2,
  80427: 2,
  80428: 2,
  80429: 2,
  80430: 2,
  80432: 2,
  80433: 2,
  80434: 2,
  80435: 2,
  80436: 2,
  80437: 2,
  80438: 2,
  80439: 2,
  80440: 2,
  80442: 2,
  80443: 2,
  80444: 2,
  80446: 2,
  80447: 2,
  80448: 2,
  80449: 2,
  80451: 2,
  80452: 2,
  80453: 2,
  80454: 2,
  80455: 2,
  80456: 2,
  80457: 2,
  80459: 2,
  80461: 2,
  80463: 2,
  80465: 2,
  80466: 2,
  80467: 2,
  80468: 2,
  80469: 2,
  80470: 2,
  80471: 2,
  80473: 2,
  80474: 2,
  80475: 2,
  80476: 2,
  80477: 2,
  80478: 2,
  80479: 2,
  80480: 2,
  80481: 2,
  80482: 2,
  80483: 2,
  80487: 2,
  80488: 2,
  80497: 2,
  80498: 2,
  80501: 2,
  80502: 2,
  80503: 2,
  80504: 2,
  80510: 2,
  80511: 2,
  80512: 2,
  80513: 2,
  80514: 2,
  80515: 2,
  80516: 2,
  80517: 2,
  80520: 2,
  80521: 2,
  80522: 2,
  80523: 2,
  80524: 2,
  80525: 2,
  80526: 2,
  80527: 2,
  80528: 2,
  80530: 2,
  80532: 2,
  80533: 2,
  80534: 2,
  80535: 2,
  80536: 2,
  80537: 2,
  80538: 2,
  80539: 2,
  80540: 2,
  80541: 2,
  80542: 2,
  80543: 2,
  80544: 2,
  80545: 2,
  80546: 2,
  80547: 2,
  80549: 2,
  80550: 2,
  80551: 2,
  80553: 2,
  80601: 2,
  80602: 2,
  80603: 2,
  80610: 2,
  80611: 2,
  80612: 2,
  80614: 2,
  80615: 2,
  80620: 2,
  80621: 2,
  80622: 2,
  80623: 2,
  80624: 2,
  80631: 2,
  80632: 2,
  80633: 2,
  80634: 2,
  80638: 2,
  80639: 2,
  80640: 2,
  80642: 2,
  80643: 2,
  80644: 2,
  80645: 2,
  80646: 2,
  80648: 2,
  80649: 2,
  80650: 2,
  80651: 2,
  80652: 2,
  80653: 2,
  80654: 2,
  80701: 2,
  80705: 2,
  80720: 2,
  80721: 2,
  80722: 2,
  80723: 2,
  80726: 2,
  80727: 2,
  80728: 2,
  80729: 2,
  80731: 2,
  80732: 2,
  80733: 2,
  80734: 2,
  80735: 2,
  80736: 2,
  80737: 2,
  80740: 2,
  80741: 2,
  80742: 2,
  80743: 2,
  80744: 2,
  80745: 2,
  80746: 2,
  80747: 2,
  80749: 2,
  80750: 2,
  80751: 2,
  80754: 2,
  80755: 2,
  80757: 2,
  80758: 2,
  80759: 2,
  80801: 2,
  80802: 2,
  80804: 2,
  80805: 2,
  80807: 2,
  80808: 2,
  80809: 2,
  80810: 2,
  80812: 2,
  80813: 2,
  80814: 2,
  80815: 2,
  80816: 2,
  80817: 2,
  80818: 2,
  80819: 2,
  80820: 2,
  80821: 2,
  80822: 2,
  80823: 2,
  80824: 2,
  80825: 2,
  80826: 2,
  80827: 2,
  80828: 2,
  80829: 2,
  80830: 2,
  80831: 2,
  80832: 2,
  80833: 2,
  80834: 2,
  80835: 2,
  80836: 2,
  80840: 2,
  80841: 2,
  80860: 2,
  80861: 2,
  80862: 2,
  80863: 2,
  80864: 2,
  80866: 2,
  80901: 2,
  80902: 2,
  80903: 2,
  80904: 2,
  80905: 2,
  80906: 2,
  80907: 2,
  80908: 2,
  80909: 2,
  80910: 2,
  80911: 2,
  80912: 2,
  80913: 2,
  80914: 2,
  80915: 2,
  80916: 2,
  80917: 2,
  80918: 2,
  80919: 2,
  80920: 2,
  80921: 2,
  80922: 2,
  80923: 2,
  80924: 2,
  80925: 2,
  80926: 2,
  80927: 2,
  80928: 2,
  80929: 2,
  80930: 2,
  80931: 2,
  80932: 2,
  80933: 2,
  80934: 2,
  80935: 2,
  80936: 2,
  80937: 2,
  80938: 2,
  80939: 2,
  80940: 2,
  80941: 2,
  80942: 2,
  80943: 2,
  80944: 2,
  80945: 2,
  80946: 2,
  80947: 2,
  80949: 2,
  80950: 2,
  80951: 2,
  80960: 2,
  80962: 2,
  80970: 2,
  80977: 2,
  80995: 2,
  80997: 2,
  81001: 2,
  81002: 2,
  81003: 2,
  81004: 2,
  81005: 2,
  81006: 2,
  81007: 2,
  81008: 2,
  81009: 2,
  81010: 2,
  81011: 2,
  81012: 2,
  81019: 2,
  81020: 2,
  81021: 2,
  81022: 2,
  81023: 2,
  81024: 2,
  81025: 2,
  81027: 2,
  81029: 2,
  81030: 2,
  81033: 2,
  81034: 2,
  81036: 2,
  81038: 2,
  81039: 2,
  81040: 2,
  81041: 2,
  81043: 2,
  81044: 2,
  81045: 2,
  81046: 2,
  81047: 2,
  81049: 2,
  81050: 2,
  81052: 2,
  81054: 2,
  81055: 2,
  81057: 2,
  81058: 2,
  81059: 2,
  81062: 2,
  81063: 2,
  81064: 2,
  81067: 2,
  81069: 2,
  81071: 2,
  81073: 2,
  81076: 2,
  81077: 2,
  81081: 2,
  81082: 2,
  81084: 2,
  81087: 2,
  81089: 2,
  81090: 2,
  81091: 2,
  81092: 2,
  81101: 2,
  81102: 2,
  81120: 2,
  81121: 2,
  81122: 2,
  81123: 2,
  81124: 2,
  81125: 2,
  81126: 2,
  81127: 2,
  81128: 2,
  81129: 2,
  81130: 2,
  81131: 2,
  81132: 2,
  81133: 2,
  81134: 2,
  81135: 2,
  81136: 2,
  81137: 2,
  81138: 2,
  81140: 2,
  81141: 2,
  81143: 2,
  81144: 2,
  81146: 2,
  81147: 2,
  81148: 2,
  81149: 2,
  81151: 2,
  81152: 2,
  81153: 2,
  81154: 2,
  81155: 2,
  81157: 2,
  81201: 2,
  81210: 2,
  81211: 2,
  81212: 2,
  81215: 2,
  81220: 2,
  81221: 2,
  81222: 2,
  81223: 2,
  81224: 2,
  81225: 2,
  81226: 2,
  81227: 2,
  81228: 2,
  81230: 2,
  81231: 2,
  81232: 2,
  81233: 2,
  81235: 2,
  81236: 2,
  81237: 2,
  81239: 2,
  81240: 2,
  81241: 2,
  81242: 2,
  81243: 2,
  81244: 2,
  81246: 2,
  81247: 2,
  81248: 2,
  81251: 2,
  81252: 2,
  81253: 2,
  81290: 2,
  81301: 2,
  81302: 2,
  81303: 2,
  81320: 2,
  81321: 2,
  81323: 2,
  81324: 2,
  81325: 2,
  81326: 2,
  81327: 2,
  81328: 2,
  81329: 2,
  81330: 2,
  81331: 2,
  81332: 2,
  81334: 2,
  81335: 2,
  81401: 2,
  81402: 2,
  81403: 2,
  81410: 2,
  81411: 2,
  81413: 2,
  81414: 2,
  81415: 2,
  81416: 2,
  81418: 2,
  81419: 2,
  81420: 2,
  81422: 2,
  81423: 2,
  81424: 2,
  81425: 2,
  81426: 2,
  81427: 2,
  81428: 2,
  81429: 2,
  81430: 2,
  81431: 2,
  81432: 2,
  81433: 2,
  81434: 2,
  81435: 2,
  81501: 2,
  81502: 2,
  81503: 2,
  81504: 2,
  81505: 2,
  81506: 2,
  81507: 2,
  81520: 2,
  81521: 2,
  81522: 2,
  81523: 2,
  81524: 2,
  81525: 2,
  81526: 2,
  81527: 2,
  81601: 2,
  81602: 2,
  81610: 2,
  81611: 2,
  81612: 2,
  81615: 2,
  81620: 2,
  81621: 2,
  81623: 2,
  81624: 2,
  81625: 2,
  81626: 2,
  81630: 2,
  81631: 2,
  81632: 2,
  81633: 2,
  81635: 2,
  81636: 2,
  81637: 2,
  81638: 2,
  81639: 2,
  81640: 2,
  81641: 2,
  81642: 2,
  81643: 2,
  81645: 2,
  81646: 2,
  81647: 2,
  81648: 2,
  81649: 2,
  81650: 2,
  81652: 2,
  81653: 2,
  81654: 2,
  81655: 2,
  81656: 2,
  81657: 2,
  81658: 2,
  82001: 2,
  82002: 2,
  82003: 2,
  82005: 2,
  82006: 2,
  82007: 2,
  82008: 2,
  82009: 2,
  82010: 2,
  82050: 2,
  82051: 2,
  82052: 2,
  82053: 2,
  82054: 2,
  82055: 2,
  82058: 2,
  82059: 2,
  82060: 2,
  82061: 2,
  82063: 2,
  82070: 2,
  82071: 2,
  82072: 2,
  82073: 2,
  82081: 2,
  82082: 2,
  82083: 2,
  82084: 2,
  82190: 2,
  82201: 2,
  82210: 2,
  82212: 2,
  82213: 2,
  82214: 2,
  82215: 2,
  82217: 2,
  82218: 2,
  82219: 2,
  82221: 2,
  82222: 2,
  82223: 2,
  82224: 2,
  82225: 2,
  82227: 2,
  82229: 2,
  82240: 2,
  82242: 2,
  82243: 2,
  82244: 2,
  82301: 2,
  82310: 2,
  82321: 2,
  82322: 2,
  82323: 2,
  82324: 2,
  82325: 2,
  82327: 2,
  82329: 2,
  82331: 2,
  82332: 2,
  82334: 2,
  82335: 2,
  82336: 2,
  82401: 2,
  82410: 2,
  82411: 2,
  82412: 2,
  82414: 2,
  82420: 2,
  82421: 2,
  82422: 2,
  82423: 2,
  82426: 2,
  82428: 2,
  82430: 2,
  82431: 2,
  82432: 2,
  82433: 2,
  82434: 2,
  82435: 2,
  82440: 2,
  82441: 2,
  82442: 2,
  82443: 2,
  82450: 2,
  82501: 2,
  82510: 2,
  82512: 2,
  82513: 2,
  82514: 2,
  82515: 2,
  82516: 2,
  82520: 2,
  82523: 2,
  82524: 2,
  82601: 2,
  82602: 2,
  82604: 2,
  82605: 2,
  82609: 2,
  82615: 2,
  82620: 2,
  82630: 2,
  82633: 2,
  82635: 2,
  82636: 2,
  82637: 2,
  82638: 2,
  82639: 2,
  82640: 2,
  82642: 2,
  82643: 2,
  82644: 2,
  82646: 2,
  82648: 2,
  82649: 2,
  82701: 2,
  82710: 2,
  82711: 2,
  82712: 2,
  82713: 2,
  82714: 2,
  82715: 2,
  82716: 2,
  82717: 2,
  82718: 2,
  82720: 2,
  82721: 2,
  82723: 2,
  82725: 2,
  82727: 2,
  82729: 2,
  82730: 2,
  82731: 2,
  82732: 2,
  82801: 2,
  82831: 2,
  82832: 2,
  82833: 2,
  82834: 2,
  82835: 2,
  82836: 2,
  82837: 2,
  82838: 2,
  82839: 2,
  82840: 2,
  82842: 2,
  82844: 2,
  82845: 2,
  82901: 2,
  82902: 2,
  82922: 2,
  82923: 2,
  82925: 2,
  82929: 2,
  82930: 2,
  82931: 2,
  82932: 2,
  82933: 2,
  82934: 2,
  82935: 2,
  82936: 2,
  82937: 2,
  82938: 2,
  82939: 2,
  82941: 2,
  82942: 2,
  82943: 2,
  82944: 2,
  82945: 2,
  83001: 2,
  83002: 2,
  83011: 2,
  83012: 2,
  83013: 2,
  83014: 2,
  83025: 2,
  83101: 2,
  83110: 2,
  83111: 2,
  83112: 2,
  83113: 2,
  83114: 2,
  83115: 2,
  83116: 2,
  83118: 2,
  83119: 2,
  83120: 2,
  83121: 2,
  83122: 2,
  83123: 2,
  83124: 2,
  83126: 2,
  83127: 2,
  83128: 2,
  83201: 7,
  83202: 7,
  83203: 7,
  83204: 7,
  83205: 7,
  83206: 7,
  83209: 7,
  83210: 7,
  83211: 2,
  83212: 7,
  83213: 2,
  83214: 7,
  83215: 7,
  83217: 7,
  83218: 7,
  83220: 7,
  83221: 7,
  83223: 7,
  83226: 7,
  83227: 7,
  83228: 7,
  83229: 7,
  83230: 7,
  83232: 7,
  83233: 7,
  83234: 7,
  83235: 7,
  83236: 7,
  83237: 7,
  83238: 7,
  83239: 7,
  83241: 7,
  83243: 7,
  83244: 7,
  83245: 7,
  83246: 7,
  83250: 7,
  83251: 7,
  83252: 7,
  83253: 7,
  83254: 7,
  83255: 7,
  83256: 7,
  83261: 7,
  83262: 7,
  83263: 7,
  83271: 7,
  83272: 7,
  83274: 2,
  83276: 7,
  83277: 7,
  83278: 7,
  83281: 7,
  83283: 7,
  83285: 2,
  83286: 7,
  83287: 7,
  83301: 7,
  83302: 7,
  83303: 7,
  83311: 7,
  83312: 7,
  83313: 7,
  83314: 7,
  83316: 7,
  83318: 7,
  83320: 7,
  83321: 7,
  83322: 7,
  83323: 7,
  83324: 7,
  83325: 7,
  83327: 7,
  83328: 7,
  83330: 7,
  83332: 2,
  83333: 7,
  83334: 2,
  83335: 7,
  83336: 7,
  83337: 7,
  83338: 7,
  83340: 7,
  83341: 7,
  83342: 7,
  83343: 7,
  83344: 7,
  83346: 7,
  83347: 2,
  83348: 7,
  83349: 7,
  83350: 2,
  83352: 7,
  83353: 7,
  83354: 7,
  83355: 7,
  83401: 7,
  83402: 7,
  83403: 7,
  83404: 7,
  83405: 7,
  83406: 7,
  83414: 2,
  83415: 7,
  83420: 7,
  83421: 7,
  83422: 7,
  83423: 7,
  83424: 7,
  83425: 7,
  83427: 7,
  83428: 7,
  83429: 7,
  83431: 7,
  83433: 7,
  83434: 7,
  83435: 7,
  83436: 2,
  83438: 7,
  83440: 7,
  83441: 7,
  83442: 7,
  83443: 2,
  83444: 7,
  83445: 7,
  83446: 7,
  83447: 7,
  83448: 7,
  83449: 7,
  83450: 7,
  83451: 7,
  83452: 7,
  83454: 7,
  83455: 7,
  83460: 7,
  83462: 7,
  83463: 7,
  83464: 7,
  83465: 7,
  83466: 7,
  83467: 7,
  83468: 7,
  83469: 7,
  83501: 3,
  83520: 3,
  83522: 3,
  83523: 3,
  83524: 3,
  83525: 3,
  83526: 3,
  83530: 3,
  83531: 3,
  83533: 3,
  83535: 3,
  83536: 3,
  83537: 3,
  83539: 3,
  83540: 3,
  83541: 3,
  83542: 3,
  83543: 3,
  83544: 3,
  83545: 3,
  83546: 3,
  83547: 2,
  83548: 3,
  83549: 3,
  83552: 3,
  83553: 3,
  83554: 3,
  83555: 3,
  83601: 7,
  83602: 7,
  83604: 7,
  83605: 7,
  83606: 7,
  83607: 7,
  83610: 7,
  83611: 7,
  83612: 7,
  83615: 7,
  83616: 7,
  83617: 7,
  83619: 7,
  83622: 7,
  83623: 7,
  83624: 7,
  83626: 7,
  83627: 7,
  83628: 7,
  83629: 7,
  83630: 7,
  83631: 7,
  83632: 7,
  83633: 7,
  83634: 7,
  83635: 7,
  83636: 7,
  83637: 7,
  83638: 7,
  83639: 7,
  83641: 7,
  83642: 7,
  83643: 7,
  83644: 7,
  83645: 7,
  83646: 7,
  83647: 7,
  83648: 7,
  83650: 7,
  83651: 7,
  83652: 7,
  83653: 7,
  83654: 7,
  83655: 7,
  83656: 7,
  83657: 7,
  83660: 2,
  83661: 7,
  83666: 7,
  83669: 7,
  83670: 7,
  83671: 3,
  83672: 7,
  83676: 7,
  83677: 7,
  83680: 7,
  83686: 7,
  83687: 7,
  83701: 7,
  83702: 7,
  83703: 7,
  83704: 7,
  83705: 7,
  83706: 7,
  83707: 7,
  83708: 7,
  83709: 7,
  83711: 7,
  83712: 7,
  83713: 7,
  83714: 7,
  83715: 7,
  83716: 7,
  83717: 7,
  83719: 7,
  83720: 7,
  83721: 7,
  83722: 7,
  83724: 7,
  83725: 7,
  83726: 7,
  83727: 7,
  83728: 7,
  83729: 7,
  83730: 7,
  83731: 7,
  83732: 7,
  83733: 7,
  83735: 7,
  83756: 7,
  83757: 7,
  83799: 7,
  83801: 3,
  83802: 3,
  83803: 3,
  83804: 3,
  83805: 3,
  83806: 3,
  83808: 3,
  83809: 3,
  83810: 3,
  83811: 3,
  83812: 3,
  83813: 3,
  83814: 3,
  83815: 3,
  83816: 3,
  83821: 3,
  83822: 3,
  83823: 3,
  83824: 3,
  83825: 3,
  83826: 3,
  83827: 3,
  83830: 3,
  83832: 3,
  83833: 3,
  83834: 3,
  83835: 3,
  83836: 3,
  83837: 3,
  83839: 3,
  83840: 3,
  83841: 3,
  83842: 3,
  83843: 3,
  83844: 3,
  83845: 3,
  83846: 3,
  83847: 3,
  83848: 3,
  83849: 3,
  83850: 3,
  83851: 3,
  83852: 3,
  83853: 3,
  83854: 3,
  83855: 3,
  83856: 3,
  83857: 3,
  83858: 3,
  83860: 3,
  83861: 3,
  83864: 3,
  83865: 3,
  83866: 3,
  83867: 3,
  83868: 3,
  83869: 3,
  83870: 3,
  83871: 3,
  83872: 3,
  83873: 3,
  83874: 3,
  83876: 3,
  83877: 3,
  83888: 3,
  84001: 2,
  84002: 2,
  84003: 2,
  84004: 2,
  84005: 2,
  84006: 2,
  84007: 2,
  84008: 2,
  84010: 2,
  84011: 2,
  84013: 2,
  84014: 2,
  84015: 2,
  84016: 2,
  84017: 2,
  84018: 2,
  84020: 2,
  84021: 2,
  84022: 2,
  84023: 2,
  84024: 2,
  84025: 2,
  84026: 2,
  84027: 2,
  84028: 2,
  84029: 2,
  84030: 2,
  84031: 2,
  84032: 2,
  84033: 2,
  84034: 2,
  84035: 2,
  84036: 2,
  84037: 2,
  84038: 2,
  84039: 2,
  84040: 2,
  84041: 2,
  84042: 2,
  84043: 2,
  84044: 2,
  84045: 2,
  84046: 2,
  84047: 2,
  84049: 2,
  84050: 2,
  84051: 2,
  84052: 2,
  84053: 2,
  84054: 2,
  84055: 2,
  84056: 2,
  84057: 2,
  84058: 2,
  84059: 2,
  84060: 2,
  84061: 2,
  84062: 2,
  84063: 2,
  84064: 2,
  84065: 2,
  84066: 2,
  84067: 2,
  84068: 2,
  84069: 2,
  84070: 2,
  84071: 2,
  84072: 2,
  84073: 2,
  84074: 2,
  84075: 2,
  84076: 2,
  84078: 2,
  84079: 2,
  84080: 2,
  84081: 2,
  84082: 2,
  84083: 2,
  84084: 2,
  84085: 2,
  84086: 2,
  84087: 2,
  84088: 2,
  84089: 2,
  84090: 2,
  84091: 2,
  84092: 2,
  84093: 2,
  84094: 2,
  84095: 2,
  84096: 2,
  84097: 2,
  84098: 2,
  84101: 2,
  84102: 2,
  84103: 2,
  84104: 2,
  84105: 2,
  84106: 2,
  84107: 2,
  84108: 2,
  84109: 2,
  84110: 2,
  84111: 2,
  84112: 2,
  84113: 2,
  84114: 2,
  84115: 2,
  84116: 2,
  84117: 2,
  84118: 2,
  84119: 2,
  84120: 2,
  84121: 2,
  84122: 2,
  84123: 2,
  84124: 2,
  84125: 2,
  84126: 2,
  84127: 2,
  84128: 2,
  84130: 2,
  84131: 2,
  84132: 2,
  84133: 2,
  84134: 2,
  84136: 2,
  84138: 2,
  84139: 2,
  84141: 2,
  84143: 2,
  84144: 2,
  84145: 2,
  84147: 2,
  84148: 2,
  84150: 2,
  84151: 2,
  84152: 2,
  84153: 2,
  84157: 2,
  84158: 2,
  84165: 2,
  84170: 2,
  84171: 2,
  84180: 2,
  84184: 2,
  84189: 2,
  84190: 2,
  84199: 2,
  84201: 2,
  84244: 2,
  84301: 2,
  84302: 2,
  84304: 2,
  84305: 2,
  84306: 2,
  84307: 2,
  84308: 2,
  84309: 2,
  84310: 2,
  84311: 2,
  84312: 2,
  84313: 2,
  84314: 2,
  84315: 2,
  84316: 2,
  84317: 2,
  84318: 2,
  84319: 2,
  84320: 2,
  84321: 2,
  84322: 2,
  84323: 2,
  84324: 2,
  84325: 2,
  84326: 2,
  84327: 2,
  84328: 2,
  84329: 2,
  84330: 2,
  84331: 2,
  84332: 2,
  84333: 2,
  84334: 2,
  84335: 2,
  84336: 2,
  84337: 2,
  84338: 2,
  84339: 2,
  84340: 2,
  84341: 2,
  84401: 2,
  84402: 2,
  84403: 2,
  84404: 2,
  84405: 2,
  84407: 2,
  84408: 2,
  84409: 2,
  84412: 2,
  84414: 2,
  84415: 2,
  84501: 2,
  84510: 2,
  84511: 2,
  84512: 2,
  84513: 2,
  84515: 2,
  84516: 2,
  84518: 2,
  84520: 2,
  84521: 2,
  84522: 2,
  84523: 2,
  84525: 2,
  84526: 2,
  84527: 2,
  84528: 2,
  84529: 2,
  84530: 2,
  84531: 2,
  84532: 2,
  84533: 2,
  84534: 2,
  84535: 2,
  84536: 2,
  84537: 2,
  84539: 2,
  84540: 2,
  84542: 2,
  84601: 2,
  84602: 2,
  84603: 2,
  84604: 2,
  84605: 2,
  84606: 2,
  84620: 2,
  84621: 2,
  84622: 2,
  84623: 2,
  84624: 2,
  84626: 2,
  84627: 2,
  84628: 2,
  84629: 2,
  84630: 2,
  84631: 2,
  84632: 2,
  84633: 2,
  84634: 2,
  84635: 2,
  84636: 2,
  84637: 2,
  84638: 2,
  84639: 2,
  84640: 2,
  84642: 2,
  84643: 2,
  84644: 2,
  84645: 2,
  84646: 2,
  84647: 2,
  84648: 2,
  84649: 2,
  84650: 2,
  84651: 2,
  84652: 2,
  84653: 2,
  84654: 2,
  84655: 2,
  84656: 2,
  84657: 2,
  84660: 2,
  84662: 2,
  84663: 2,
  84664: 2,
  84665: 2,
  84667: 2,
  84701: 2,
  84710: 2,
  84711: 2,
  84712: 2,
  84713: 2,
  84714: 2,
  84715: 2,
  84716: 2,
  84717: 2,
  84718: 2,
  84719: 2,
  84720: 2,
  84721: 2,
  84722: 2,
  84723: 2,
  84724: 2,
  84725: 2,
  84726: 2,
  84728: 2,
  84729: 2,
  84730: 2,
  84731: 2,
  84732: 2,
  84733: 2,
  84734: 2,
  84735: 2,
  84736: 2,
  84737: 2,
  84738: 2,
  84739: 2,
  84740: 2,
  84741: 2,
  84742: 2,
  84743: 2,
  84744: 2,
  84745: 2,
  84746: 2,
  84747: 2,
  84749: 2,
  84750: 2,
  84751: 2,
  84752: 2,
  84753: 2,
  84754: 2,
  84755: 2,
  84756: 2,
  84757: 2,
  84758: 2,
  84759: 2,
  84760: 2,
  84761: 2,
  84762: 2,
  84763: 2,
  84764: 2,
  84765: 2,
  84766: 2,
  84767: 2,
  84770: 2,
  84771: 2,
  84772: 2,
  84773: 2,
  84774: 2,
  84775: 2,
  84776: 2,
  84779: 2,
  84780: 2,
  84781: 2,
  84782: 2,
  84783: 2,
  84784: 2,
  84790: 2,
  84791: 2,
  85001: 8,
  85002: 8,
  85003: 8,
  85004: 8,
  85005: 8,
  85006: 8,
  85007: 8,
  85008: 8,
  85009: 8,
  85010: 8,
  85011: 8,
  85012: 8,
  85013: 8,
  85014: 8,
  85015: 8,
  85016: 8,
  85017: 8,
  85018: 8,
  85019: 8,
  85020: 8,
  85021: 8,
  85022: 8,
  85023: 8,
  85024: 8,
  85025: 8,
  85026: 8,
  85027: 8,
  85028: 8,
  85029: 8,
  85030: 8,
  85031: 8,
  85032: 8,
  85033: 8,
  85034: 8,
  85035: 8,
  85036: 8,
  85037: 8,
  85038: 8,
  85039: 8,
  85040: 8,
  85041: 8,
  85042: 8,
  85043: 8,
  85044: 8,
  85045: 8,
  85046: 8,
  85048: 8,
  85050: 8,
  85051: 8,
  85053: 8,
  85054: 8,
  85055: 8,
  85060: 8,
  85061: 8,
  85062: 8,
  85063: 8,
  85064: 8,
  85065: 8,
  85066: 8,
  85067: 8,
  85068: 8,
  85069: 8,
  85070: 8,
  85071: 8,
  85072: 8,
  85073: 8,
  85074: 8,
  85075: 8,
  85076: 8,
  85077: 8,
  85078: 8,
  85079: 8,
  85080: 8,
  85082: 8,
  85083: 8,
  85085: 8,
  85086: 8,
  85087: 8,
  85096: 8,
  85097: 8,
  85098: 8,
  85099: 8,
  85117: 8,
  85118: 8,
  85119: 8,
  85120: 8,
  85121: 8,
  85122: 8,
  85123: 8,
  85127: 8,
  85128: 8,
  85130: 8,
  85131: 8,
  85132: 8,
  85135: 8,
  85137: 8,
  85138: 8,
  85139: 8,
  85140: 8,
  85141: 8,
  85142: 8,
  85143: 8,
  85145: 8,
  85147: 8,
  85172: 8,
  85173: 8,
  85178: 8,
  85190: 8,
  85191: 8,
  85192: 8,
  85193: 8,
  85194: 8,
  85201: 8,
  85202: 8,
  85203: 8,
  85204: 8,
  85205: 8,
  85206: 8,
  85207: 8,
  85208: 8,
  85209: 8,
  85210: 8,
  85211: 8,
  85212: 8,
  85213: 8,
  85214: 8,
  85215: 8,
  85216: 8,
  85217: 8,
  85218: 8,
  85219: 8,
  85220: 8,
  85221: 8,
  85222: 8,
  85223: 8,
  85224: 8,
  85225: 8,
  85226: 8,
  85227: 8,
  85228: 8,
  85230: 8,
  85231: 8,
  85232: 8,
  85233: 8,
  85234: 8,
  85235: 8,
  85236: 8,
  85237: 8,
  85238: 8,
  85239: 8,
  85240: 8,
  85241: 8,
  85242: 8,
  85243: 8,
  85244: 8,
  85245: 8,
  85246: 8,
  85247: 8,
  85248: 8,
  85249: 8,
  85250: 8,
  85251: 8,
  85252: 8,
  85253: 8,
  85254: 8,
  85255: 8,
  85256: 8,
  85257: 8,
  85258: 8,
  85259: 8,
  85260: 8,
  85261: 8,
  85262: 8,
  85263: 8,
  85264: 8,
  85266: 8,
  85267: 8,
  85268: 8,
  85269: 8,
  85271: 8,
  85272: 8,
  85273: 8,
  85274: 8,
  85275: 8,
  85277: 8,
  85278: 8,
  85279: 8,
  85280: 8,
  85281: 8,
  85282: 8,
  85283: 8,
  85284: 8,
  85285: 8,
  85286: 8,
  85287: 8,
  85289: 8,
  85290: 8,
  85291: 8,
  85292: 8,
  85293: 8,
  85294: 8,
  85295: 8,
  85296: 8,
  85297: 8,
  85298: 8,
  85299: 8,
  85301: 8,
  85302: 8,
  85303: 8,
  85304: 8,
  85305: 8,
  85306: 8,
  85307: 8,
  85308: 8,
  85309: 8,
  85310: 8,
  85311: 8,
  85312: 8,
  85313: 8,
  85318: 8,
  85320: 8,
  85321: 8,
  85322: 8,
  85323: 8,
  85324: 8,
  85325: 8,
  85326: 8,
  85327: 8,
  85328: 8,
  85329: 8,
  85331: 8,
  85332: 8,
  85333: 8,
  85334: 8,
  85335: 8,
  85336: 8,
  85337: 8,
  85338: 8,
  85339: 8,
  85340: 8,
  85341: 8,
  85342: 8,
  85343: 8,
  85344: 8,
  85345: 8,
  85346: 8,
  85347: 8,
  85348: 8,
  85349: 8,
  85350: 8,
  85351: 8,
  85352: 8,
  85353: 8,
  85354: 8,
  85355: 8,
  85356: 2,
  85357: 8,
  85358: 8,
  85359: 8,
  85360: 8,
  85361: 8,
  85362: 8,
  85363: 8,
  85364: 8,
  85365: 8,
  85366: 8,
  85367: 8,
  85369: 8,
  85371: 8,
  85372: 8,
  85373: 8,
  85374: 8,
  85375: 8,
  85376: 8,
  85377: 8,
  85378: 8,
  85379: 8,
  85380: 8,
  85381: 8,
  85382: 8,
  85383: 8,
  85385: 8,
  85387: 8,
  85388: 8,
  85390: 8,
  85392: 8,
  85395: 8,
  85396: 8,
  85501: 8,
  85502: 8,
  85530: 8,
  85531: 8,
  85532: 8,
  85533: 8,
  85534: 8,
  85535: 8,
  85536: 8,
  85539: 2,
  85540: 8,
  85541: 8,
  85542: 8,
  85543: 8,
  85544: 8,
  85545: 8,
  85546: 8,
  85547: 8,
  85548: 8,
  85550: 8,
  85551: 8,
  85552: 8,
  85553: 8,
  85554: 8,
  85601: 8,
  85602: 2,
  85603: 8,
  85605: 8,
  85606: 8,
  85607: 8,
  85608: 8,
  85609: 8,
  85610: 8,
  85611: 8,
  85613: 8,
  85614: 8,
  85615: 8,
  85616: 8,
  85617: 8,
  85618: 8,
  85619: 8,
  85620: 8,
  85621: 8,
  85622: 8,
  85623: 8,
  85624: 8,
  85625: 8,
  85626: 8,
  85627: 8,
  85628: 8,
  85629: 8,
  85630: 8,
  85631: 8,
  85632: 8,
  85633: 8,
  85634: 8,
  85635: 8,
  85636: 8,
  85637: 2,
  85638: 8,
  85639: 8,
  85640: 8,
  85641: 8,
  85643: 8,
  85644: 8,
  85645: 2,
  85646: 8,
  85648: 8,
  85650: 8,
  85652: 8,
  85653: 8,
  85654: 8,
  85655: 8,
  85658: 8,
  85662: 8,
  85670: 8,
  85671: 8,
  85701: 8,
  85702: 8,
  85703: 8,
  85704: 8,
  85705: 8,
  85706: 8,
  85707: 8,
  85708: 8,
  85709: 8,
  85710: 8,
  85711: 8,
  85712: 8,
  85713: 8,
  85714: 8,
  85715: 8,
  85716: 8,
  85717: 8,
  85718: 8,
  85719: 8,
  85720: 8,
  85721: 8,
  85722: 8,
  85723: 8,
  85724: 8,
  85725: 8,
  85726: 8,
  85728: 8,
  85730: 8,
  85731: 8,
  85732: 8,
  85733: 8,
  85734: 8,
  85735: 8,
  85736: 8,
  85737: 8,
  85738: 8,
  85739: 8,
  85740: 8,
  85741: 8,
  85742: 8,
  85743: 8,
  85744: 8,
  85745: 8,
  85746: 8,
  85747: 8,
  85748: 8,
  85749: 8,
  85750: 8,
  85751: 8,
  85752: 8,
  85754: 8,
  85755: 8,
  85756: 8,
  85757: 8,
  85775: 8,
  85777: 8,
  85901: 19,
  85902: 19,
  85911: 19,
  85912: 19,
  85920: 19,
  85922: 8,
  85923: 19,
  85924: 19,
  85925: 19,
  85926: 19,
  85927: 19,
  85928: 19,
  85929: 19,
  85930: 19,
  85931: 8,
  85932: 19,
  85933: 19,
  85934: 19,
  85935: 19,
  85936: 19,
  85937: 19,
  85938: 19,
  85939: 19,
  85940: 19,
  85941: 19,
  85942: 19,
  86001: 8,
  86002: 8,
  86003: 8,
  86004: 8,
  86011: 8,
  86015: 8,
  86016: 8,
  86017: 8,
  86018: 8,
  86020: 2,
  86021: 2,
  86022: 2,
  86023: 8,
  86024: 2,
  86025: 19,
  86028: 19,
  86029: 19,
  86030: 19,
  86031: 19,
  86032: 19,
  86033: 19,
  86034: 19,
  86035: 2,
  86036: 2,
  86038: 2,
  86039: 19,
  86040: 2,
  86042: 19,
  86043: 19,
  86044: 2,
  86045: 2,
  86046: 2,
  86047: 19,
  86052: 8,
  86053: 2,
  86054: 19,
  86301: 8,
  86302: 8,
  86303: 8,
  86304: 8,
  86305: 8,
  86312: 8,
  86313: 8,
  86314: 8,
  86315: 8,
  86320: 8,
  86321: 8,
  86322: 8,
  86323: 8,
  86324: 8,
  86325: 8,
  86326: 8,
  86327: 8,
  86329: 8,
  86330: 8,
  86331: 8,
  86332: 8,
  86333: 8,
  86334: 8,
  86335: 8,
  86336: 8,
  86337: 8,
  86338: 8,
  86339: 8,
  86340: 8,
  86341: 8,
  86342: 8,
  86343: 8,
  86351: 8,
  86401: 8,
  86402: 8,
  86403: 8,
  86404: 8,
  86405: 8,
  86406: 8,
  86409: 8,
  86411: 8,
  86412: 8,
  86413: 8,
  86426: 8,
  86427: 8,
  86429: 8,
  86430: 8,
  86431: 8,
  86432: 8,
  86433: 8,
  86434: 2,
  86435: 2,
  86436: 8,
  86437: 8,
  86438: 8,
  86439: 8,
  86440: 8,
  86441: 8,
  86442: 8,
  86443: 8,
  86444: 8,
  86445: 8,
  86446: 8,
  86502: 19,
  86503: 19,
  86504: 19,
  86505: 19,
  86506: 19,
  86507: 19,
  86508: 19,
  86510: 19,
  86511: 19,
  86512: 19,
  86514: 19,
  86515: 19,
  86520: 19,
  86535: 19,
  86538: 19,
  86540: 19,
  86544: 19,
  86545: 19,
  86547: 19,
  86555: 8,
  86556: 19,
  87001: 2,
  87002: 2,
  87004: 2,
  87005: 2,
  87006: 2,
  87007: 2,
  87008: 2,
  87009: 2,
  87010: 2,
  87011: 2,
  87012: 2,
  87013: 2,
  87014: 2,
  87015: 2,
  87016: 2,
  87017: 2,
  87018: 2,
  87020: 2,
  87021: 2,
  87022: 2,
  87023: 2,
  87024: 2,
  87025: 2,
  87026: 2,
  87027: 2,
  87028: 2,
  87029: 2,
  87031: 2,
  87032: 2,
  87034: 2,
  87035: 2,
  87036: 2,
  87037: 2,
  87038: 2,
  87040: 2,
  87041: 2,
  87042: 2,
  87043: 2,
  87044: 2,
  87045: 2,
  87046: 2,
  87047: 2,
  87048: 2,
  87049: 2,
  87051: 2,
  87052: 2,
  87053: 2,
  87056: 2,
  87059: 2,
  87060: 2,
  87061: 2,
  87062: 2,
  87063: 2,
  87064: 2,
  87068: 2,
  87070: 2,
  87072: 2,
  87083: 2,
  87101: 2,
  87102: 2,
  87103: 2,
  87104: 2,
  87105: 2,
  87106: 2,
  87107: 2,
  87108: 2,
  87109: 2,
  87110: 2,
  87111: 2,
  87112: 2,
  87113: 2,
  87114: 2,
  87115: 2,
  87116: 2,
  87117: 2,
  87118: 2,
  87119: 2,
  87120: 2,
  87121: 2,
  87122: 2,
  87123: 2,
  87124: 2,
  87125: 2,
  87131: 2,
  87144: 2,
  87151: 2,
  87153: 2,
  87154: 2,
  87158: 2,
  87165: 2,
  87174: 2,
  87176: 2,
  87181: 2,
  87184: 2,
  87185: 2,
  87187: 2,
  87190: 2,
  87191: 2,
  87192: 2,
  87193: 2,
  87194: 2,
  87195: 2,
  87196: 2,
  87197: 2,
  87198: 2,
  87199: 2,
  87301: 2,
  87302: 2,
  87305: 2,
  87310: 2,
  87311: 2,
  87312: 2,
  87313: 2,
  87315: 2,
  87316: 2,
  87317: 2,
  87319: 2,
  87320: 2,
  87321: 2,
  87322: 2,
  87323: 2,
  87325: 2,
  87326: 2,
  87327: 2,
  87328: 2,
  87347: 2,
  87357: 2,
  87364: 2,
  87365: 2,
  87375: 2,
  87401: 2,
  87402: 2,
  87410: 2,
  87412: 2,
  87413: 2,
  87415: 2,
  87416: 2,
  87417: 2,
  87418: 2,
  87419: 2,
  87420: 2,
  87421: 2,
  87455: 2,
  87461: 2,
  87499: 2,
  87500: 2,
  87501: 2,
  87502: 2,
  87503: 2,
  87504: 2,
  87505: 2,
  87506: 2,
  87507: 2,
  87508: 2,
  87509: 2,
  87510: 2,
  87511: 2,
  87512: 2,
  87513: 2,
  87514: 2,
  87515: 2,
  87516: 2,
  87517: 2,
  87518: 2,
  87519: 2,
  87520: 2,
  87521: 2,
  87522: 2,
  87523: 2,
  87524: 2,
  87525: 2,
  87527: 2,
  87528: 2,
  87529: 2,
  87530: 2,
  87531: 2,
  87532: 2,
  87533: 2,
  87535: 2,
  87537: 2,
  87538: 2,
  87539: 2,
  87540: 2,
  87543: 2,
  87544: 2,
  87545: 2,
  87548: 2,
  87549: 2,
  87551: 2,
  87552: 2,
  87553: 2,
  87554: 2,
  87556: 2,
  87557: 2,
  87558: 2,
  87560: 2,
  87562: 2,
  87564: 2,
  87565: 2,
  87566: 2,
  87567: 2,
  87569: 2,
  87571: 2,
  87573: 2,
  87574: 2,
  87575: 2,
  87576: 2,
  87577: 2,
  87578: 2,
  87579: 2,
  87580: 2,
  87581: 2,
  87582: 2,
  87583: 2,
  87592: 2,
  87594: 2,
  87701: 2,
  87710: 2,
  87711: 2,
  87712: 2,
  87713: 2,
  87714: 2,
  87715: 2,
  87718: 2,
  87722: 2,
  87723: 2,
  87724: 2,
  87728: 2,
  87729: 2,
  87730: 2,
  87731: 2,
  87732: 2,
  87733: 2,
  87734: 2,
  87735: 2,
  87736: 2,
  87740: 2,
  87742: 2,
  87743: 2,
  87745: 2,
  87746: 2,
  87747: 2,
  87749: 2,
  87750: 2,
  87752: 2,
  87753: 2,
  87801: 2,
  87820: 2,
  87821: 2,
  87823: 2,
  87824: 2,
  87825: 2,
  87827: 2,
  87828: 2,
  87829: 2,
  87830: 2,
  87831: 2,
  87832: 2,
  87901: 2,
  87930: 2,
  87931: 2,
  87933: 2,
  87935: 2,
  87936: 2,
  87937: 2,
  87939: 2,
  87940: 2,
  87941: 2,
  87942: 2,
  87943: 2,
  88001: 2,
  88002: 2,
  88003: 2,
  88004: 2,
  88005: 2,
  88006: 2,
  88007: 2,
  88008: 2,
  88009: 2,
  88011: 2,
  88012: 2,
  88013: 2,
  88020: 2,
  88021: 2,
  88022: 2,
  88023: 2,
  88024: 2,
  88025: 2,
  88026: 2,
  88027: 2,
  88028: 2,
  88029: 2,
  88030: 2,
  88031: 2,
  88032: 2,
  88033: 2,
  88034: 2,
  88036: 2,
  88038: 2,
  88039: 2,
  88040: 2,
  88041: 2,
  88042: 2,
  88043: 2,
  88044: 2,
  88045: 2,
  88046: 2,
  88047: 2,
  88048: 2,
  88049: 2,
  88051: 2,
  88052: 2,
  88053: 2,
  88054: 2,
  88055: 2,
  88056: 2,
  88058: 2,
  88061: 2,
  88062: 2,
  88063: 2,
  88065: 2,
  88072: 2,
  88081: 2,
  88101: 2,
  88102: 2,
  88103: 2,
  88112: 2,
  88113: 2,
  88114: 2,
  88115: 2,
  88116: 2,
  88118: 2,
  88119: 2,
  88120: 2,
  88121: 2,
  88122: 2,
  88123: 2,
  88124: 2,
  88125: 2,
  88126: 2,
  88130: 2,
  88132: 2,
  88133: 2,
  88134: 2,
  88135: 2,
  88136: 2,
  88201: 2,
  88202: 2,
  88203: 2,
  88210: 2,
  88211: 2,
  88213: 2,
  88220: 2,
  88221: 2,
  88230: 2,
  88231: 2,
  88232: 2,
  88240: 2,
  88241: 2,
  88242: 2,
  88244: 2,
  88250: 2,
  88252: 2,
  88253: 2,
  88254: 2,
  88255: 2,
  88256: 2,
  88260: 2,
  88262: 2,
  88263: 2,
  88264: 2,
  88265: 2,
  88267: 2,
  88268: 2,
  88301: 2,
  88311: 2,
  88312: 2,
  88314: 2,
  88316: 2,
  88317: 2,
  88321: 2,
  88323: 2,
  88324: 2,
  88330: 2,
  88336: 2,
  88337: 2,
  88338: 2,
  88339: 2,
  88340: 2,
  88341: 2,
  88342: 2,
  88343: 2,
  88344: 2,
  88345: 2,
  88346: 2,
  88347: 2,
  88348: 2,
  88349: 2,
  88350: 2,
  88351: 2,
  88352: 2,
  88353: 2,
  88354: 2,
  88355: 2,
  88401: 2,
  88410: 2,
  88411: 2,
  88414: 2,
  88415: 2,
  88416: 2,
  88417: 2,
  88418: 2,
  88419: 2,
  88421: 2,
  88422: 2,
  88424: 2,
  88426: 2,
  88427: 2,
  88430: 2,
  88431: 2,
  88433: 2,
  88434: 2,
  88435: 2,
  88436: 2,
  88437: 2,
  88439: 2,
  88510: 2,
  88511: 2,
  88512: 2,
  88513: 2,
  88514: 2,
  88515: 2,
  88516: 2,
  88517: 2,
  88518: 2,
  88519: 2,
  88520: 2,
  88521: 2,
  88523: 2,
  88524: 2,
  88525: 2,
  88526: 2,
  88527: 2,
  88528: 2,
  88529: 2,
  88530: 2,
  88531: 2,
  88532: 2,
  88533: 2,
  88534: 2,
  88535: 2,
  88536: 2,
  88538: 2,
  88539: 2,
  88540: 2,
  88541: 2,
  88542: 2,
  88543: 2,
  88544: 2,
  88545: 2,
  88546: 2,
  88547: 2,
  88548: 2,
  88549: 2,
  88550: 2,
  88553: 2,
  88554: 2,
  88555: 2,
  88556: 2,
  88557: 2,
  88558: 2,
  88559: 2,
  88560: 2,
  88561: 2,
  88562: 2,
  88563: 2,
  88565: 2,
  88566: 2,
  88567: 2,
  88568: 2,
  88569: 2,
  88570: 2,
  88571: 2,
  88572: 2,
  88573: 2,
  88574: 2,
  88575: 2,
  88576: 2,
  88577: 2,
  88578: 2,
  88579: 2,
  88580: 2,
  88581: 2,
  88582: 2,
  88583: 2,
  88584: 2,
  88585: 2,
  88586: 2,
  88587: 2,
  88588: 2,
  88589: 2,
  88590: 2,
  88595: 2,
  88901: 3,
  88905: 3,
  89001: 3,
  89002: 3,
  89003: 3,
  89004: 3,
  89005: 3,
  89006: 3,
  89007: 3,
  89008: 3,
  89009: 3,
  89010: 3,
  89011: 3,
  89012: 3,
  89013: 3,
  89014: 3,
  89015: 3,
  89016: 3,
  89017: 3,
  89018: 3,
  89019: 3,
  89020: 3,
  89021: 3,
  89022: 3,
  89023: 3,
  89024: 3,
  89025: 3,
  89026: 3,
  89027: 3,
  89028: 3,
  89029: 3,
  89030: 3,
  89031: 3,
  89032: 3,
  89033: 3,
  89034: 3,
  89036: 3,
  89037: 3,
  89039: 3,
  89040: 3,
  89041: 3,
  89042: 3,
  89043: 3,
  89044: 3,
  89045: 3,
  89046: 3,
  89047: 3,
  89048: 3,
  89049: 3,
  89052: 3,
  89053: 3,
  89054: 3,
  89060: 3,
  89061: 3,
  89067: 3,
  89070: 3,
  89074: 3,
  89077: 3,
  89081: 3,
  89084: 3,
  89085: 3,
  89086: 3,
  89087: 3,
  89101: 3,
  89102: 3,
  89103: 3,
  89104: 3,
  89105: 3,
  89106: 3,
  89107: 3,
  89108: 3,
  89109: 3,
  89110: 3,
  89111: 3,
  89112: 3,
  89113: 3,
  89114: 3,
  89115: 3,
  89116: 3,
  89117: 3,
  89118: 3,
  89119: 3,
  89120: 3,
  89121: 3,
  89122: 3,
  89123: 3,
  89124: 3,
  89125: 3,
  89126: 3,
  89127: 3,
  89128: 3,
  89129: 3,
  89130: 3,
  89131: 3,
  89132: 3,
  89133: 3,
  89134: 3,
  89135: 3,
  89136: 3,
  89137: 3,
  89138: 3,
  89139: 3,
  89140: 3,
  89141: 3,
  89142: 3,
  89143: 3,
  89144: 3,
  89145: 3,
  89146: 3,
  89147: 3,
  89148: 3,
  89149: 3,
  89150: 3,
  89151: 3,
  89152: 3,
  89153: 3,
  89154: 3,
  89155: 3,
  89156: 3,
  89157: 3,
  89158: 3,
  89159: 3,
  89160: 3,
  89161: 3,
  89162: 3,
  89163: 3,
  89164: 3,
  89165: 3,
  89166: 3,
  89169: 3,
  89170: 3,
  89173: 3,
  89177: 3,
  89178: 3,
  89179: 3,
  89180: 3,
  89183: 3,
  89185: 3,
  89191: 3,
  89193: 3,
  89195: 3,
  89199: 3,
  89301: 3,
  89310: 3,
  89311: 3,
  89314: 3,
  89315: 3,
  89316: 3,
  89317: 3,
  89318: 3,
  89319: 3,
  89402: 3,
  89403: 3,
  89404: 3,
  89405: 3,
  89406: 3,
  89407: 3,
  89408: 3,
  89409: 3,
  89410: 3,
  89411: 3,
  89412: 3,
  89413: 3,
  89414: 3,
  89415: 3,
  89418: 3,
  89419: 3,
  89420: 3,
  89421: 3,
  89422: 3,
  89423: 3,
  89424: 3,
  89425: 3,
  89426: 3,
  89427: 3,
  89428: 3,
  89429: 3,
  89430: 3,
  89431: 3,
  89432: 3,
  89433: 3,
  89434: 3,
  89435: 3,
  89438: 3,
  89439: 3,
  89440: 3,
  89441: 3,
  89444: 3,
  89446: 3,
  89447: 3,
  89448: 3,
  89450: 3,
  89451: 3,
  89452: 3,
  89460: 3,
  89496: 3,
  89501: 3,
  89502: 3,
  89503: 3,
  89504: 3,
  89505: 3,
  89506: 3,
  89507: 3,
  89508: 3,
  89509: 3,
  89510: 3,
  89511: 3,
  89512: 3,
  89513: 3,
  89515: 3,
  89519: 3,
  89520: 3,
  89521: 3,
  89523: 3,
  89533: 3,
  89555: 3,
  89570: 3,
  89595: 3,
  89599: 3,
  89701: 3,
  89702: 3,
  89703: 3,
  89704: 3,
  89705: 3,
  89706: 3,
  89711: 3,
  89712: 3,
  89713: 3,
  89714: 3,
  89721: 3,
  89801: 3,
  89802: 3,
  89803: 3,
  89815: 3,
  89820: 3,
  89821: 3,
  89822: 3,
  89823: 3,
  89824: 3,
  89825: 3,
  89826: 3,
  89828: 3,
  89830: 3,
  89831: 3,
  89832: 3,
  89833: 3,
  89834: 3,
  89835: 3,
  89883: 3,
  90001: 3,
  90002: 3,
  90003: 3,
  90004: 3,
  90005: 3,
  90006: 3,
  90007: 3,
  90008: 3,
  90009: 3,
  90010: 3,
  90011: 3,
  90012: 3,
  90013: 3,
  90014: 3,
  90015: 3,
  90016: 3,
  90017: 3,
  90018: 3,
  90019: 3,
  90020: 3,
  90021: 3,
  90022: 3,
  90023: 3,
  90024: 3,
  90025: 3,
  90026: 3,
  90027: 3,
  90028: 3,
  90029: 3,
  90030: 3,
  90031: 3,
  90032: 3,
  90033: 3,
  90034: 3,
  90035: 3,
  90036: 3,
  90037: 3,
  90038: 3,
  90039: 3,
  90040: 3,
  90041: 3,
  90042: 3,
  90043: 3,
  90044: 3,
  90045: 3,
  90046: 3,
  90047: 3,
  90048: 3,
  90049: 3,
  90050: 3,
  90051: 3,
  90052: 3,
  90053: 3,
  90054: 3,
  90055: 3,
  90056: 3,
  90057: 3,
  90058: 3,
  90059: 3,
  90060: 3,
  90061: 3,
  90062: 3,
  90063: 3,
  90064: 3,
  90065: 3,
  90066: 3,
  90067: 3,
  90068: 3,
  90069: 3,
  90070: 3,
  90071: 3,
  90072: 3,
  90073: 3,
  90074: 3,
  90075: 3,
  90076: 3,
  90077: 3,
  90078: 3,
  90079: 3,
  90080: 3,
  90081: 3,
  90082: 3,
  90083: 3,
  90084: 3,
  90086: 3,
  90087: 3,
  90088: 3,
  90089: 3,
  90090: 3,
  90094: 3,
  90095: 3,
  90096: 3,
  90097: 3,
  90099: 3,
  90101: 3,
  90102: 3,
  90103: 3,
  90174: 3,
  90185: 3,
  90189: 3,
  90201: 3,
  90202: 3,
  90209: 3,
  90210: 3,
  90211: 3,
  90212: 3,
  90213: 3,
  90220: 3,
  90221: 3,
  90222: 3,
  90223: 3,
  90224: 3,
  90230: 3,
  90231: 3,
  90232: 3,
  90233: 3,
  90239: 3,
  90240: 3,
  90241: 3,
  90242: 3,
  90245: 3,
  90247: 3,
  90248: 3,
  90249: 3,
  90250: 3,
  90251: 3,
  90254: 3,
  90255: 3,
  90260: 3,
  90261: 3,
  90262: 3,
  90263: 3,
  90264: 3,
  90265: 3,
  90266: 3,
  90267: 3,
  90270: 3,
  90272: 3,
  90274: 3,
  90275: 3,
  90277: 3,
  90278: 3,
  90280: 3,
  90290: 3,
  90291: 3,
  90292: 3,
  90293: 3,
  90294: 3,
  90295: 3,
  90296: 3,
  90301: 3,
  90302: 3,
  90303: 3,
  90304: 3,
  90305: 3,
  90306: 3,
  90307: 3,
  90308: 3,
  90309: 3,
  90310: 3,
  90311: 3,
  90312: 3,
  90313: 3,
  90397: 3,
  90398: 3,
  90401: 3,
  90402: 3,
  90403: 3,
  90404: 3,
  90405: 3,
  90406: 3,
  90408: 3,
  90409: 3,
  90410: 3,
  90411: 3,
  90501: 3,
  90502: 3,
  90503: 3,
  90504: 3,
  90505: 3,
  90506: 3,
  90507: 3,
  90508: 3,
  90509: 3,
  90510: 3,
  90601: 3,
  90602: 3,
  90603: 3,
  90604: 3,
  90605: 3,
  90606: 3,
  90607: 3,
  90608: 3,
  90609: 3,
  90610: 3,
  90612: 3,
  90620: 3,
  90621: 3,
  90622: 3,
  90623: 3,
  90624: 3,
  90630: 3,
  90631: 3,
  90632: 3,
  90633: 3,
  90637: 3,
  90638: 3,
  90639: 3,
  90640: 3,
  90650: 3,
  90651: 3,
  90652: 3,
  90659: 3,
  90660: 3,
  90661: 3,
  90662: 3,
  90665: 3,
  90670: 3,
  90671: 3,
  90680: 3,
  90701: 3,
  90702: 3,
  90703: 3,
  90704: 3,
  90707: 3,
  90710: 3,
  90711: 3,
  90712: 3,
  90713: 3,
  90714: 3,
  90715: 3,
  90716: 3,
  90717: 3,
  90720: 3,
  90721: 3,
  90723: 3,
  90731: 3,
  90732: 3,
  90733: 3,
  90734: 3,
  90740: 3,
  90742: 3,
  90743: 3,
  90744: 3,
  90745: 3,
  90746: 3,
  90747: 3,
  90748: 3,
  90749: 3,
  90755: 3,
  90801: 3,
  90802: 3,
  90803: 3,
  90804: 3,
  90805: 3,
  90806: 3,
  90807: 3,
  90808: 3,
  90809: 3,
  90810: 3,
  90813: 3,
  90814: 3,
  90815: 3,
  90822: 3,
  90831: 3,
  90832: 3,
  90833: 3,
  90834: 3,
  90835: 3,
  90842: 3,
  90844: 3,
  90845: 3,
  90847: 3,
  90848: 3,
  90888: 3,
  90895: 3,
  90899: 3,
  91001: 3,
  91003: 3,
  91006: 3,
  91007: 3,
  91008: 3,
  91009: 3,
  91010: 3,
  91011: 3,
  91012: 3,
  91016: 3,
  91017: 3,
  91020: 3,
  91021: 3,
  91023: 3,
  91024: 3,
  91025: 3,
  91030: 3,
  91031: 3,
  91040: 3,
  91041: 3,
  91042: 3,
  91043: 3,
  91046: 3,
  91066: 3,
  91077: 3,
  91101: 3,
  91102: 3,
  91103: 3,
  91104: 3,
  91105: 3,
  91106: 3,
  91107: 3,
  91108: 3,
  91109: 3,
  91110: 3,
  91114: 3,
  91115: 3,
  91116: 3,
  91117: 3,
  91118: 3,
  91121: 3,
  91123: 3,
  91124: 3,
  91125: 3,
  91126: 3,
  91129: 3,
  91131: 3,
  91175: 3,
  91182: 3,
  91184: 3,
  91185: 3,
  91186: 3,
  91187: 3,
  91188: 3,
  91189: 3,
  91191: 3,
  91199: 3,
  91201: 3,
  91202: 3,
  91203: 3,
  91204: 3,
  91205: 3,
  91206: 3,
  91207: 3,
  91208: 3,
  91209: 3,
  91210: 3,
  91214: 3,
  91221: 3,
  91222: 3,
  91224: 3,
  91225: 3,
  91226: 3,
  91301: 3,
  91302: 3,
  91303: 3,
  91304: 3,
  91305: 3,
  91306: 3,
  91307: 3,
  91308: 3,
  91309: 3,
  91310: 3,
  91311: 3,
  91312: 3,
  91313: 3,
  91316: 3,
  91319: 3,
  91320: 3,
  91321: 3,
  91322: 3,
  91324: 3,
  91325: 3,
  91326: 3,
  91327: 3,
  91328: 3,
  91329: 3,
  91330: 3,
  91331: 3,
  91333: 3,
  91334: 3,
  91335: 3,
  91337: 3,
  91340: 3,
  91341: 3,
  91342: 3,
  91343: 3,
  91344: 3,
  91345: 3,
  91346: 3,
  91350: 3,
  91351: 3,
  91352: 3,
  91353: 3,
  91354: 3,
  91355: 3,
  91356: 3,
  91357: 3,
  91358: 3,
  91359: 3,
  91360: 3,
  91361: 3,
  91362: 3,
  91363: 3,
  91364: 3,
  91365: 3,
  91367: 3,
  91371: 3,
  91372: 3,
  91376: 3,
  91377: 3,
  91380: 3,
  91381: 3,
  91382: 3,
  91383: 3,
  91384: 3,
  91385: 3,
  91386: 3,
  91387: 3,
  91388: 3,
  91390: 3,
  91392: 3,
  91393: 3,
  91394: 3,
  91395: 3,
  91396: 3,
  91399: 3,
  91401: 3,
  91402: 3,
  91403: 3,
  91404: 3,
  91405: 3,
  91406: 3,
  91407: 3,
  91408: 3,
  91409: 3,
  91410: 3,
  91411: 3,
  91412: 3,
  91413: 3,
  91416: 3,
  91423: 3,
  91426: 3,
  91436: 3,
  91470: 3,
  91482: 3,
  91495: 3,
  91496: 3,
  91497: 3,
  91499: 3,
  91501: 3,
  91502: 3,
  91503: 3,
  91504: 3,
  91505: 3,
  91506: 3,
  91507: 3,
  91508: 3,
  91510: 3,
  91521: 3,
  91522: 3,
  91523: 3,
  91526: 3,
  91601: 3,
  91602: 3,
  91603: 3,
  91604: 3,
  91605: 3,
  91606: 3,
  91607: 3,
  91608: 3,
  91609: 3,
  91610: 3,
  91611: 3,
  91612: 3,
  91614: 3,
  91615: 3,
  91616: 3,
  91617: 3,
  91618: 3,
  91701: 3,
  91702: 3,
  91706: 3,
  91708: 3,
  91709: 3,
  91710: 3,
  91711: 3,
  91714: 3,
  91715: 3,
  91716: 3,
  91722: 3,
  91723: 3,
  91724: 3,
  91729: 3,
  91730: 3,
  91731: 3,
  91732: 3,
  91733: 3,
  91734: 3,
  91735: 3,
  91737: 3,
  91739: 3,
  91740: 3,
  91741: 3,
  91743: 3,
  91744: 3,
  91745: 3,
  91746: 3,
  91747: 3,
  91748: 3,
  91749: 3,
  91750: 3,
  91752: 3,
  91754: 3,
  91755: 3,
  91756: 3,
  91758: 3,
  91759: 3,
  91761: 3,
  91762: 3,
  91763: 3,
  91764: 3,
  91765: 3,
  91766: 3,
  91767: 3,
  91768: 3,
  91769: 3,
  91770: 3,
  91771: 3,
  91772: 3,
  91773: 3,
  91775: 3,
  91776: 3,
  91778: 3,
  91780: 3,
  91784: 3,
  91785: 3,
  91786: 3,
  91788: 3,
  91789: 3,
  91790: 3,
  91791: 3,
  91792: 3,
  91793: 3,
  91795: 3,
  91797: 3,
  91798: 3,
  91799: 3,
  91801: 3,
  91802: 3,
  91803: 3,
  91804: 3,
  91841: 3,
  91896: 3,
  91899: 3,
  91901: 3,
  91902: 3,
  91903: 3,
  91905: 3,
  91906: 3,
  91908: 3,
  91909: 3,
  91910: 3,
  91911: 3,
  91912: 3,
  91913: 3,
  91914: 3,
  91915: 3,
  91916: 3,
  91917: 3,
  91921: 3,
  91931: 3,
  91932: 3,
  91933: 3,
  91934: 3,
  91935: 3,
  91941: 3,
  91942: 3,
  91943: 3,
  91944: 3,
  91945: 3,
  91946: 3,
  91947: 3,
  91948: 3,
  91950: 3,
  91951: 3,
  91962: 3,
  91963: 3,
  91976: 3,
  91977: 3,
  91978: 3,
  91979: 3,
  91980: 3,
  91987: 3,
  91990: 3,
  92003: 3,
  92004: 3,
  92007: 3,
  92008: 3,
  92009: 3,
  92010: 3,
  92011: 3,
  92013: 3,
  92014: 3,
  92018: 3,
  92019: 3,
  92020: 3,
  92023: 3,
  92024: 3,
  92025: 3,
  92026: 3,
  92027: 3,
  92028: 3,
  92029: 3,
  92030: 3,
  92033: 3,
  92036: 3,
  92037: 3,
  92038: 3,
  92039: 3,
  92040: 3,
  92046: 3,
  92049: 3,
  92051: 3,
  92052: 3,
  92054: 3,
  92055: 3,
  92056: 3,
  92057: 3,
  92058: 3,
  92059: 3,
  92060: 3,
  92061: 3,
  92064: 3,
  92065: 3,
  92066: 3,
  92067: 3,
  92068: 3,
  92069: 3,
  92070: 3,
  92071: 3,
  92072: 3,
  92074: 3,
  92075: 3,
  92078: 3,
  92079: 3,
  92081: 3,
  92082: 3,
  92083: 3,
  92084: 3,
  92085: 3,
  92086: 3,
  92091: 3,
  92092: 3,
  92093: 3,
  92101: 3,
  92103: 3,
  92104: 3,
  92106: 3,
  92108: 3,
  92109: 3,
  92110: 3,
  92111: 3,
  92112: 3,
  92113: 3,
  92114: 3,
  92115: 3,
  92116: 3,
  92117: 3,
  92118: 3,
  92119: 3,
  92120: 3,
  92121: 3,
  92122: 3,
  92123: 3,
  92124: 3,
  92126: 3,
  92127: 3,
  92128: 3,
  92129: 3,
  92130: 3,
  92131: 3,
  92132: 3,
  92133: 3,
  92134: 3,
  92135: 3,
  92136: 3,
  92137: 3,
  92138: 3,
  92139: 3,
  92140: 3,
  92143: 3,
  92145: 3,
  92147: 3,
  92149: 3,
  92150: 3,
  92152: 3,
  92153: 3,
  92154: 3,
  92155: 3,
  92158: 3,
  92160: 3,
  92162: 3,
  92164: 3,
  92165: 3,
  92166: 3,
  92167: 3,
  92169: 3,
  92170: 3,
  92171: 3,
  92172: 3,
  92173: 3,
  92174: 3,
  92175: 3,
  92176: 3,
  92177: 3,
  92178: 3,
  92179: 3,
  92182: 3,
  92184: 3,
  92186: 3,
  92187: 3,
  92190: 3,
  92191: 3,
  92192: 3,
  92193: 3,
  92194: 3,
  92195: 3,
  92196: 3,
  92197: 3,
  92198: 3,
  92199: 3,
  92201: 3,
  92202: 3,
  92203: 3,
  92210: 3,
  92211: 3,
  92220: 3,
  92222: 3,
  92223: 3,
  92225: 3,
  92226: 3,
  92227: 3,
  92230: 3,
  92231: 3,
  92232: 3,
  92233: 3,
  92234: 3,
  92235: 3,
  92236: 3,
  92239: 3,
  92240: 3,
  92241: 3,
  92242: 3,
  92243: 3,
  92244: 3,
  92247: 3,
  92248: 3,
  92249: 3,
  92250: 3,
  92251: 3,
  92252: 3,
  92253: 3,
  92254: 3,
  92255: 3,
  92256: 3,
  92257: 3,
  92258: 3,
  92259: 3,
  92260: 3,
  92261: 3,
  92262: 3,
  92263: 3,
  92264: 3,
  92266: 3,
  92267: 3,
  92268: 3,
  92270: 3,
  92273: 3,
  92274: 3,
  92275: 3,
  92276: 3,
  92277: 3,
  92278: 3,
  92280: 3,
  92281: 3,
  92282: 3,
  92283: 3,
  92284: 3,
  92285: 3,
  92286: 3,
  92292: 3,
  92301: 3,
  92304: 3,
  92305: 3,
  92307: 3,
  92308: 3,
  92309: 3,
  92310: 3,
  92311: 3,
  92312: 3,
  92313: 3,
  92314: 3,
  92315: 3,
  92316: 3,
  92317: 3,
  92318: 3,
  92320: 3,
  92321: 3,
  92322: 3,
  92323: 3,
  92324: 3,
  92325: 3,
  92326: 3,
  92327: 3,
  92328: 3,
  92329: 3,
  92331: 3,
  92332: 3,
  92333: 3,
  92334: 3,
  92335: 3,
  92336: 3,
  92337: 3,
  92338: 3,
  92339: 3,
  92340: 3,
  92341: 3,
  92342: 3,
  92344: 3,
  92345: 3,
  92346: 3,
  92347: 3,
  92350: 3,
  92352: 3,
  92354: 3,
  92356: 3,
  92357: 3,
  92358: 3,
  92359: 3,
  92363: 3,
  92364: 3,
  92365: 3,
  92366: 3,
  92368: 3,
  92369: 3,
  92371: 3,
  92372: 3,
  92373: 3,
  92374: 3,
  92375: 3,
  92376: 3,
  92377: 3,
  92378: 3,
  92382: 3,
  92384: 3,
  92385: 3,
  92386: 3,
  92389: 3,
  92391: 3,
  92392: 3,
  92393: 3,
  92394: 3,
  92395: 3,
  92397: 3,
  92398: 3,
  92399: 3,
  92401: 3,
  92402: 3,
  92403: 3,
  92404: 3,
  92405: 3,
  92406: 3,
  92407: 3,
  92408: 3,
  92410: 3,
  92411: 3,
  92412: 3,
  92413: 3,
  92414: 3,
  92415: 3,
  92418: 3,
  92420: 3,
  92423: 3,
  92424: 3,
  92427: 3,
  92501: 3,
  92502: 3,
  92503: 3,
  92504: 3,
  92505: 3,
  92506: 3,
  92507: 3,
  92508: 3,
  92509: 3,
  92513: 3,
  92514: 3,
  92515: 3,
  92516: 3,
  92517: 3,
  92518: 3,
  92519: 3,
  92521: 3,
  92522: 3,
  92530: 3,
  92531: 3,
  92532: 3,
  92536: 3,
  92539: 3,
  92543: 3,
  92544: 3,
  92545: 3,
  92546: 3,
  92548: 3,
  92549: 3,
  92551: 3,
  92552: 3,
  92553: 3,
  92554: 3,
  92555: 3,
  92556: 3,
  92557: 3,
  92561: 3,
  92562: 3,
  92563: 3,
  92564: 3,
  92567: 3,
  92570: 3,
  92571: 3,
  92572: 3,
  92581: 3,
  92582: 3,
  92583: 3,
  92584: 3,
  92585: 3,
  92586: 3,
  92587: 3,
  92589: 3,
  92590: 3,
  92591: 3,
  92592: 3,
  92593: 3,
  92595: 3,
  92596: 3,
  92599: 3,
  92602: 3,
  92603: 3,
  92604: 3,
  92605: 3,
  92606: 3,
  92607: 3,
  92609: 3,
  92610: 3,
  92612: 3,
  92614: 3,
  92615: 3,
  92616: 3,
  92617: 3,
  92618: 3,
  92619: 3,
  92620: 3,
  92623: 3,
  92624: 3,
  92625: 3,
  92626: 3,
  92627: 3,
  92628: 3,
  92629: 3,
  92630: 3,
  92637: 3,
  92646: 3,
  92647: 3,
  92648: 3,
  92649: 3,
  92650: 3,
  92651: 3,
  92652: 3,
  92653: 3,
  92654: 3,
  92655: 3,
  92656: 3,
  92657: 3,
  92658: 3,
  92659: 3,
  92660: 3,
  92661: 3,
  92662: 3,
  92663: 3,
  92672: 3,
  92673: 3,
  92674: 3,
  92675: 3,
  92676: 3,
  92677: 3,
  92678: 3,
  92679: 3,
  92683: 3,
  92684: 3,
  92685: 3,
  92688: 3,
  92690: 3,
  92691: 3,
  92692: 3,
  92693: 3,
  92694: 3,
  92697: 3,
  92698: 3,
  92701: 3,
  92702: 3,
  92703: 3,
  92704: 3,
  92705: 3,
  92706: 3,
  92707: 3,
  92708: 3,
  92709: 3,
  92710: 3,
  92711: 3,
  92712: 3,
  92725: 3,
  92728: 3,
  92735: 3,
  92780: 3,
  92781: 3,
  92782: 3,
  92799: 3,
  92801: 3,
  92802: 3,
  92803: 3,
  92804: 3,
  92805: 3,
  92806: 3,
  92807: 3,
  92808: 3,
  92809: 3,
  92811: 3,
  92812: 3,
  92814: 3,
  92815: 3,
  92816: 3,
  92817: 3,
  92821: 3,
  92822: 3,
  92823: 3,
  92825: 3,
  92831: 3,
  92832: 3,
  92833: 3,
  92834: 3,
  92835: 3,
  92836: 3,
  92837: 3,
  92838: 3,
  92840: 3,
  92841: 3,
  92842: 3,
  92843: 3,
  92844: 3,
  92845: 3,
  92846: 3,
  92850: 3,
  92856: 3,
  92857: 3,
  92859: 3,
  92860: 3,
  92861: 3,
  92862: 3,
  92863: 3,
  92864: 3,
  92865: 3,
  92866: 3,
  92867: 3,
  92868: 3,
  92869: 3,
  92870: 3,
  92871: 3,
  92877: 3,
  92878: 3,
  92879: 3,
  92880: 3,
  92881: 3,
  92882: 3,
  92883: 3,
  92885: 3,
  92886: 3,
  92887: 3,
  92899: 3,
  93001: 3,
  93002: 3,
  93003: 3,
  93004: 3,
  93005: 3,
  93006: 3,
  93007: 3,
  93009: 3,
  93010: 3,
  93011: 3,
  93012: 3,
  93013: 3,
  93014: 3,
  93015: 3,
  93016: 3,
  93020: 3,
  93021: 3,
  93022: 3,
  93023: 3,
  93024: 3,
  93030: 3,
  93031: 3,
  93032: 3,
  93033: 3,
  93034: 3,
  93035: 3,
  93036: 3,
  93040: 3,
  93041: 3,
  93042: 3,
  93043: 3,
  93044: 3,
  93060: 3,
  93061: 3,
  93062: 3,
  93063: 3,
  93064: 3,
  93065: 3,
  93066: 3,
  93067: 3,
  93093: 3,
  93099: 3,
  93101: 3,
  93102: 3,
  93103: 3,
  93105: 3,
  93106: 3,
  93107: 3,
  93108: 3,
  93109: 3,
  93110: 3,
  93111: 3,
  93116: 3,
  93117: 3,
  93118: 3,
  93120: 3,
  93121: 3,
  93130: 3,
  93140: 3,
  93150: 3,
  93160: 3,
  93190: 3,
  93199: 3,
  93201: 3,
  93202: 3,
  93203: 3,
  93204: 3,
  93205: 3,
  93206: 3,
  93207: 3,
  93208: 3,
  93210: 3,
  93212: 3,
  93215: 3,
  93216: 3,
  93218: 3,
  93219: 3,
  93220: 3,
  93221: 3,
  93222: 3,
  93223: 3,
  93224: 3,
  93225: 3,
  93226: 3,
  93227: 3,
  93230: 3,
  93232: 3,
  93234: 3,
  93235: 3,
  93237: 3,
  93238: 3,
  93239: 3,
  93240: 3,
  93241: 3,
  93242: 3,
  93243: 3,
  93244: 3,
  93245: 3,
  93246: 3,
  93247: 3,
  93249: 3,
  93250: 3,
  93251: 3,
  93252: 3,
  93254: 3,
  93255: 3,
  93256: 3,
  93257: 3,
  93258: 3,
  93260: 3,
  93261: 3,
  93262: 3,
  93263: 3,
  93265: 3,
  93266: 3,
  93267: 3,
  93268: 3,
  93270: 3,
  93271: 3,
  93272: 3,
  93274: 3,
  93275: 3,
  93276: 3,
  93277: 3,
  93278: 3,
  93279: 3,
  93280: 3,
  93282: 3,
  93283: 3,
  93285: 3,
  93286: 3,
  93287: 3,
  93290: 3,
  93291: 3,
  93292: 3,
  93301: 3,
  93302: 3,
  93303: 3,
  93304: 3,
  93305: 3,
  93306: 3,
  93307: 3,
  93308: 3,
  93309: 3,
  93311: 3,
  93312: 3,
  93313: 3,
  93314: 3,
  93380: 3,
  93381: 3,
  93382: 3,
  93383: 3,
  93384: 3,
  93385: 3,
  93386: 3,
  93387: 3,
  93388: 3,
  93389: 3,
  93390: 3,
  93401: 3,
  93402: 3,
  93403: 3,
  93405: 3,
  93406: 3,
  93407: 3,
  93408: 3,
  93409: 3,
  93410: 3,
  93412: 3,
  93420: 3,
  93421: 3,
  93422: 3,
  93423: 3,
  93424: 3,
  93426: 3,
  93427: 3,
  93428: 3,
  93429: 3,
  93430: 3,
  93432: 3,
  93433: 3,
  93434: 3,
  93435: 3,
  93436: 3,
  93437: 3,
  93438: 3,
  93440: 3,
  93441: 3,
  93442: 3,
  93443: 3,
  93444: 3,
  93445: 3,
  93446: 3,
  93447: 3,
  93448: 3,
  93449: 3,
  93450: 3,
  93451: 3,
  93452: 3,
  93453: 3,
  93454: 3,
  93455: 3,
  93456: 3,
  93457: 3,
  93458: 3,
  93460: 3,
  93461: 3,
  93463: 3,
  93464: 3,
  93465: 3,
  93475: 3,
  93483: 3,
  93501: 3,
  93502: 3,
  93504: 3,
  93505: 3,
  93510: 3,
  93512: 3,
  93513: 3,
  93514: 3,
  93515: 3,
  93516: 3,
  93517: 3,
  93518: 3,
  93519: 3,
  93522: 3,
  93523: 3,
  93524: 3,
  93526: 3,
  93527: 3,
  93528: 3,
  93529: 3,
  93530: 3,
  93531: 3,
  93532: 3,
  93534: 3,
  93535: 3,
  93536: 3,
  93539: 3,
  93541: 3,
  93542: 3,
  93543: 3,
  93544: 3,
  93545: 3,
  93546: 3,
  93549: 3,
  93550: 3,
  93551: 3,
  93552: 3,
  93553: 3,
  93554: 3,
  93555: 3,
  93556: 3,
  93558: 3,
  93560: 3,
  93561: 3,
  93562: 3,
  93563: 3,
  93581: 3,
  93584: 3,
  93586: 3,
  93590: 3,
  93591: 3,
  93592: 3,
  93596: 3,
  93599: 3,
  93601: 3,
  93602: 3,
  93603: 3,
  93604: 3,
  93605: 3,
  93606: 3,
  93607: 3,
  93608: 3,
  93609: 3,
  93610: 3,
  93611: 3,
  93612: 3,
  93613: 3,
  93614: 3,
  93615: 3,
  93616: 3,
  93618: 3,
  93619: 3,
  93621: 3,
  93622: 3,
  93623: 3,
  93624: 3,
  93626: 3,
  93627: 3,
  93628: 3,
  93631: 3,
  93633: 3,
  93634: 3,
  93635: 3,
  93636: 3,
  93637: 3,
  93638: 3,
  93639: 3,
  93640: 3,
  93641: 3,
  93642: 3,
  93643: 3,
  93644: 3,
  93645: 3,
  93646: 3,
  93647: 3,
  93648: 3,
  93649: 3,
  93650: 3,
  93651: 3,
  93652: 3,
  93653: 3,
  93654: 3,
  93656: 3,
  93657: 3,
  93660: 3,
  93661: 3,
  93662: 3,
  93664: 3,
  93665: 3,
  93666: 3,
  93667: 3,
  93668: 3,
  93669: 3,
  93670: 3,
  93673: 3,
  93675: 3,
  93701: 3,
  93702: 3,
  93703: 3,
  93704: 3,
  93705: 3,
  93706: 3,
  93707: 3,
  93708: 3,
  93709: 3,
  93710: 3,
  93711: 3,
  93712: 3,
  93714: 3,
  93715: 3,
  93716: 3,
  93717: 3,
  93718: 3,
  93720: 3,
  93721: 3,
  93722: 3,
  93723: 3,
  93724: 3,
  93725: 3,
  93726: 3,
  93727: 3,
  93728: 3,
  93729: 3,
  93730: 3,
  93737: 3,
  93740: 3,
  93741: 3,
  93744: 3,
  93745: 3,
  93747: 3,
  93750: 3,
  93755: 3,
  93760: 3,
  93761: 3,
  93762: 3,
  93764: 3,
  93765: 3,
  93771: 3,
  93772: 3,
  93773: 3,
  93774: 3,
  93775: 3,
  93776: 3,
  93777: 3,
  93778: 3,
  93779: 3,
  93780: 3,
  93784: 3,
  93786: 3,
  93790: 3,
  93791: 3,
  93792: 3,
  93793: 3,
  93794: 3,
  93844: 3,
  93888: 3,
  93901: 3,
  93902: 3,
  93905: 3,
  93906: 3,
  93907: 3,
  93908: 3,
  93912: 3,
  93915: 3,
  93920: 3,
  93921: 3,
  93922: 3,
  93923: 3,
  93924: 3,
  93925: 3,
  93926: 3,
  93927: 3,
  93928: 3,
  93930: 3,
  93932: 3,
  93933: 3,
  93940: 3,
  93942: 3,
  93943: 3,
  93944: 3,
  93950: 3,
  93953: 3,
  93954: 3,
  93955: 3,
  93960: 3,
  93962: 3,
  94002: 3,
  94003: 3,
  94005: 3,
  94010: 3,
  94011: 3,
  94012: 3,
  94013: 3,
  94014: 3,
  94015: 3,
  94016: 3,
  94017: 3,
  94018: 3,
  94019: 3,
  94020: 3,
  94021: 3,
  94022: 3,
  94023: 3,
  94024: 3,
  94025: 3,
  94026: 3,
  94027: 3,
  94028: 3,
  94029: 3,
  94030: 3,
  94031: 3,
  94035: 3,
  94037: 3,
  94038: 3,
  94039: 3,
  94040: 3,
  94041: 3,
  94042: 3,
  94043: 3,
  94044: 3,
  94045: 3,
  94059: 3,
  94060: 3,
  94061: 3,
  94062: 3,
  94063: 3,
  94064: 3,
  94065: 3,
  94066: 3,
  94067: 3,
  94070: 3,
  94071: 3,
  94074: 3,
  94080: 3,
  94083: 3,
  94085: 3,
  94086: 3,
  94087: 3,
  94088: 3,
  94089: 3,
  94090: 3,
  94096: 3,
  94098: 3,
  94099: 3,
  94101: 3,
  94102: 3,
  94103: 3,
  94104: 3,
  94105: 3,
  94106: 3,
  94107: 3,
  94108: 3,
  94109: 3,
  94110: 3,
  94111: 3,
  94112: 3,
  94114: 3,
  94115: 3,
  94116: 3,
  94117: 3,
  94118: 3,
  94119: 3,
  94120: 3,
  94121: 3,
  94122: 3,
  94123: 3,
  94124: 3,
  94125: 3,
  94126: 3,
  94127: 3,
  94128: 3,
  94129: 3,
  94130: 3,
  94131: 3,
  94132: 3,
  94133: 3,
  94134: 3,
  94135: 3,
  94136: 3,
  94137: 3,
  94138: 3,
  94139: 3,
  94140: 3,
  94141: 3,
  94142: 3,
  94143: 3,
  94144: 3,
  94145: 3,
  94146: 3,
  94147: 3,
  94150: 3,
  94151: 3,
  94152: 3,
  94153: 3,
  94154: 3,
  94155: 3,
  94156: 3,
  94157: 3,
  94158: 3,
  94159: 3,
  94160: 3,
  94161: 3,
  94162: 3,
  94163: 3,
  94164: 3,
  94165: 3,
  94166: 3,
  94167: 3,
  94168: 3,
  94169: 3,
  94170: 3,
  94171: 3,
  94172: 3,
  94175: 3,
  94177: 3,
  94188: 3,
  94199: 3,
  94203: 3,
  94204: 3,
  94205: 3,
  94206: 3,
  94207: 3,
  94208: 3,
  94209: 3,
  94211: 3,
  94229: 3,
  94230: 3,
  94232: 3,
  94234: 3,
  94235: 3,
  94236: 3,
  94237: 3,
  94239: 3,
  94240: 3,
  94243: 3,
  94244: 3,
  94245: 3,
  94246: 3,
  94247: 3,
  94248: 3,
  94249: 3,
  94250: 3,
  94252: 3,
  94253: 3,
  94254: 3,
  94256: 3,
  94257: 3,
  94258: 3,
  94259: 3,
  94261: 3,
  94262: 3,
  94263: 3,
  94267: 3,
  94268: 3,
  94269: 3,
  94271: 3,
  94273: 3,
  94274: 3,
  94277: 3,
  94278: 3,
  94279: 3,
  94280: 3,
  94282: 3,
  94283: 3,
  94284: 3,
  94285: 3,
  94286: 3,
  94287: 3,
  94288: 3,
  94289: 3,
  94290: 3,
  94291: 3,
  94293: 3,
  94294: 3,
  94295: 3,
  94296: 3,
  94297: 3,
  94298: 3,
  94299: 3,
  94301: 3,
  94302: 3,
  94303: 3,
  94304: 3,
  94305: 3,
  94306: 3,
  94307: 3,
  94308: 3,
  94309: 3,
  94310: 3,
  94401: 3,
  94402: 3,
  94403: 3,
  94404: 3,
  94405: 3,
  94406: 3,
  94407: 3,
  94408: 3,
  94409: 3,
  94497: 3,
  94501: 3,
  94502: 3,
  94503: 3,
  94505: 3,
  94506: 3,
  94507: 3,
  94508: 3,
  94509: 3,
  94510: 3,
  94511: 3,
  94512: 3,
  94513: 3,
  94514: 3,
  94515: 3,
  94516: 3,
  94517: 3,
  94518: 3,
  94519: 3,
  94520: 3,
  94521: 3,
  94522: 3,
  94523: 3,
  94524: 3,
  94525: 3,
  94526: 3,
  94527: 3,
  94528: 3,
  94529: 3,
  94530: 3,
  94531: 3,
  94533: 3,
  94534: 3,
  94535: 3,
  94536: 3,
  94537: 3,
  94538: 3,
  94539: 3,
  94540: 3,
  94541: 3,
  94542: 3,
  94543: 3,
  94544: 3,
  94545: 3,
  94546: 3,
  94547: 3,
  94548: 3,
  94549: 3,
  94550: 3,
  94551: 3,
  94552: 3,
  94553: 3,
  94555: 3,
  94556: 3,
  94557: 3,
  94558: 3,
  94559: 3,
  94560: 3,
  94561: 3,
  94562: 3,
  94563: 3,
  94564: 3,
  94565: 3,
  94566: 3,
  94567: 3,
  94568: 3,
  94569: 3,
  94570: 3,
  94571: 3,
  94572: 3,
  94573: 3,
  94574: 3,
  94575: 3,
  94576: 3,
  94577: 3,
  94578: 3,
  94579: 3,
  94580: 3,
  94581: 3,
  94582: 3,
  94583: 3,
  94585: 3,
  94586: 3,
  94587: 3,
  94588: 3,
  94589: 3,
  94590: 3,
  94591: 3,
  94592: 3,
  94595: 3,
  94596: 3,
  94597: 3,
  94598: 3,
  94599: 3,
  94601: 3,
  94602: 3,
  94603: 3,
  94604: 3,
  94605: 3,
  94606: 3,
  94607: 3,
  94608: 3,
  94609: 3,
  94610: 3,
  94611: 3,
  94612: 3,
  94613: 3,
  94614: 3,
  94615: 3,
  94617: 3,
  94618: 3,
  94619: 3,
  94620: 3,
  94621: 3,
  94622: 3,
  94623: 3,
  94624: 3,
  94625: 3,
  94626: 3,
  94627: 3,
  94643: 3,
  94649: 3,
  94659: 3,
  94660: 3,
  94661: 3,
  94662: 3,
  94666: 3,
  94701: 3,
  94702: 3,
  94703: 3,
  94704: 3,
  94705: 3,
  94706: 3,
  94707: 3,
  94708: 3,
  94709: 3,
  94710: 3,
  94712: 3,
  94720: 3,
  94801: 3,
  94802: 3,
  94803: 3,
  94804: 3,
  94805: 3,
  94806: 3,
  94807: 3,
  94808: 3,
  94820: 3,
  94850: 3,
  94875: 3,
  94901: 3,
  94903: 3,
  94904: 3,
  94912: 3,
  94913: 3,
  94914: 3,
  94915: 3,
  94920: 3,
  94922: 3,
  94923: 3,
  94924: 3,
  94925: 3,
  94926: 3,
  94927: 3,
  94928: 3,
  94929: 3,
  94930: 3,
  94931: 3,
  94933: 3,
  94937: 3,
  94938: 3,
  94939: 3,
  94940: 3,
  94941: 3,
  94942: 3,
  94945: 3,
  94946: 3,
  94947: 3,
  94948: 3,
  94949: 3,
  94950: 3,
  94951: 3,
  94952: 3,
  94953: 3,
  94954: 3,
  94955: 3,
  94956: 3,
  94957: 3,
  94960: 3,
  94963: 3,
  94964: 3,
  94965: 3,
  94966: 3,
  94970: 3,
  94971: 3,
  94972: 3,
  94973: 3,
  94974: 3,
  94975: 3,
  94976: 3,
  94977: 3,
  94978: 3,
  94979: 3,
  94998: 3,
  94999: 3,
  95001: 3,
  95002: 3,
  95003: 3,
  95004: 3,
  95005: 3,
  95006: 3,
  95007: 3,
  95008: 3,
  95009: 3,
  95010: 3,
  95011: 3,
  95012: 3,
  95013: 3,
  95014: 3,
  95015: 3,
  95017: 3,
  95018: 3,
  95019: 3,
  95020: 3,
  95021: 3,
  95023: 3,
  95024: 3,
  95026: 3,
  95030: 3,
  95031: 3,
  95032: 3,
  95033: 3,
  95035: 3,
  95036: 3,
  95037: 3,
  95038: 3,
  95039: 3,
  95041: 3,
  95042: 3,
  95043: 3,
  95044: 3,
  95045: 3,
  95046: 3,
  95050: 3,
  95051: 3,
  95052: 3,
  95053: 3,
  95054: 3,
  95055: 3,
  95056: 3,
  95060: 3,
  95061: 3,
  95062: 3,
  95063: 3,
  95064: 3,
  95065: 3,
  95066: 3,
  95067: 3,
  95070: 3,
  95071: 3,
  95073: 3,
  95075: 3,
  95076: 3,
  95077: 3,
  95101: 3,
  95102: 3,
  95103: 3,
  95106: 3,
  95108: 3,
  95109: 3,
  95110: 3,
  95111: 3,
  95112: 3,
  95113: 3,
  95114: 3,
  95115: 3,
  95116: 3,
  95117: 3,
  95118: 3,
  95119: 3,
  95120: 3,
  95121: 3,
  95122: 3,
  95123: 3,
  95124: 3,
  95125: 3,
  95126: 3,
  95127: 3,
  95128: 3,
  95129: 3,
  95130: 3,
  95131: 3,
  95132: 3,
  95133: 3,
  95134: 3,
  95135: 3,
  95136: 3,
  95137: 3,
  95138: 3,
  95139: 3,
  95140: 3,
  95141: 3,
  95142: 3,
  95148: 3,
  95150: 3,
  95151: 3,
  95152: 3,
  95153: 3,
  95154: 3,
  95155: 3,
  95156: 3,
  95157: 3,
  95158: 3,
  95159: 3,
  95160: 3,
  95161: 3,
  95164: 3,
  95170: 3,
  95171: 3,
  95172: 3,
  95173: 3,
  95190: 3,
  95191: 3,
  95192: 3,
  95193: 3,
  95194: 3,
  95196: 3,
  95201: 3,
  95202: 3,
  95203: 3,
  95204: 3,
  95205: 3,
  95206: 3,
  95207: 3,
  95208: 3,
  95209: 3,
  95210: 3,
  95211: 3,
  95212: 3,
  95213: 3,
  95215: 3,
  95219: 3,
  95220: 3,
  95221: 3,
  95222: 3,
  95223: 3,
  95224: 3,
  95225: 3,
  95226: 3,
  95227: 3,
  95228: 3,
  95229: 3,
  95230: 3,
  95231: 3,
  95232: 3,
  95233: 3,
  95234: 3,
  95236: 3,
  95237: 3,
  95240: 3,
  95241: 3,
  95242: 3,
  95245: 3,
  95246: 3,
  95247: 3,
  95248: 3,
  95249: 3,
  95250: 3,
  95251: 3,
  95252: 3,
  95253: 3,
  95254: 3,
  95255: 3,
  95257: 3,
  95258: 3,
  95267: 3,
  95269: 3,
  95290: 3,
  95296: 3,
  95297: 3,
  95298: 3,
  95301: 3,
  95303: 3,
  95304: 3,
  95305: 3,
  95306: 3,
  95307: 3,
  95309: 3,
  95310: 3,
  95311: 3,
  95312: 3,
  95313: 3,
  95314: 3,
  95315: 3,
  95316: 3,
  95317: 3,
  95318: 3,
  95319: 3,
  95320: 3,
  95321: 3,
  95322: 3,
  95323: 3,
  95324: 3,
  95325: 3,
  95326: 3,
  95327: 3,
  95328: 3,
  95329: 3,
  95330: 3,
  95333: 3,
  95334: 3,
  95335: 3,
  95336: 3,
  95337: 3,
  95338: 3,
  95340: 3,
  95341: 3,
  95342: 3,
  95343: 3,
  95344: 3,
  95345: 3,
  95346: 3,
  95347: 3,
  95348: 3,
  95350: 3,
  95351: 3,
  95352: 3,
  95353: 3,
  95354: 3,
  95355: 3,
  95356: 3,
  95357: 3,
  95358: 3,
  95360: 3,
  95361: 3,
  95363: 3,
  95364: 3,
  95365: 3,
  95366: 3,
  95367: 3,
  95368: 3,
  95369: 3,
  95370: 3,
  95372: 3,
  95373: 3,
  95374: 3,
  95375: 3,
  95376: 3,
  95377: 3,
  95378: 3,
  95379: 3,
  95380: 3,
  95381: 3,
  95382: 3,
  95383: 3,
  95385: 3,
  95386: 3,
  95387: 3,
  95388: 3,
  95389: 3,
  95391: 3,
  95397: 3,
  95401: 3,
  95402: 3,
  95403: 3,
  95404: 3,
  95405: 3,
  95406: 3,
  95407: 3,
  95408: 3,
  95409: 3,
  95410: 3,
  95412: 3,
  95415: 3,
  95416: 3,
  95417: 3,
  95418: 3,
  95419: 3,
  95420: 3,
  95421: 3,
  95422: 3,
  95423: 3,
  95424: 3,
  95425: 3,
  95426: 3,
  95427: 3,
  95428: 3,
  95429: 3,
  95430: 3,
  95431: 3,
  95432: 3,
  95433: 3,
  95435: 3,
  95436: 3,
  95437: 3,
  95439: 3,
  95441: 3,
  95442: 3,
  95443: 3,
  95444: 3,
  95445: 3,
  95446: 3,
  95448: 3,
  95449: 3,
  95450: 3,
  95451: 3,
  95452: 3,
  95453: 3,
  95454: 3,
  95456: 3,
  95457: 3,
  95458: 3,
  95459: 3,
  95460: 3,
  95461: 3,
  95462: 3,
  95463: 3,
  95464: 3,
  95465: 3,
  95466: 3,
  95467: 3,
  95468: 3,
  95469: 3,
  95470: 3,
  95471: 3,
  95472: 3,
  95473: 3,
  95476: 3,
  95480: 3,
  95481: 3,
  95482: 3,
  95485: 3,
  95486: 3,
  95487: 3,
  95488: 3,
  95490: 3,
  95492: 3,
  95493: 3,
  95494: 3,
  95497: 3,
  95501: 3,
  95502: 3,
  95503: 3,
  95511: 3,
  95514: 3,
  95518: 3,
  95519: 3,
  95521: 3,
  95524: 3,
  95525: 3,
  95526: 3,
  95527: 3,
  95528: 3,
  95531: 3,
  95532: 3,
  95534: 3,
  95536: 3,
  95537: 3,
  95538: 3,
  95540: 3,
  95542: 3,
  95543: 3,
  95545: 3,
  95546: 3,
  95547: 3,
  95548: 3,
  95549: 3,
  95550: 3,
  95551: 3,
  95552: 3,
  95553: 3,
  95554: 3,
  95555: 3,
  95556: 3,
  95558: 3,
  95559: 3,
  95560: 3,
  95562: 3,
  95563: 3,
  95564: 3,
  95565: 3,
  95567: 3,
  95568: 3,
  95569: 3,
  95570: 3,
  95571: 3,
  95573: 3,
  95585: 3,
  95587: 3,
  95589: 3,
  95595: 3,
  95601: 3,
  95602: 3,
  95603: 3,
  95604: 3,
  95605: 3,
  95606: 3,
  95607: 3,
  95608: 3,
  95609: 3,
  95610: 3,
  95611: 3,
  95612: 3,
  95613: 3,
  95614: 3,
  95615: 3,
  95616: 3,
  95617: 3,
  95618: 3,
  95619: 3,
  95620: 3,
  95621: 3,
  95623: 3,
  95624: 3,
  95625: 3,
  95626: 3,
  95627: 3,
  95628: 3,
  95629: 3,
  95630: 3,
  95631: 3,
  95632: 3,
  95633: 3,
  95634: 3,
  95635: 3,
  95636: 3,
  95637: 3,
  95638: 3,
  95639: 3,
  95640: 3,
  95641: 3,
  95642: 3,
  95644: 3,
  95645: 3,
  95646: 3,
  95648: 3,
  95650: 3,
  95651: 3,
  95652: 3,
  95653: 3,
  95654: 3,
  95655: 3,
  95656: 3,
  95658: 3,
  95659: 3,
  95660: 3,
  95661: 3,
  95662: 3,
  95663: 3,
  95664: 3,
  95665: 3,
  95666: 3,
  95667: 3,
  95668: 3,
  95669: 3,
  95670: 3,
  95671: 3,
  95672: 3,
  95673: 3,
  95674: 3,
  95675: 3,
  95676: 3,
  95677: 3,
  95678: 3,
  95679: 3,
  95680: 3,
  95681: 3,
  95682: 3,
  95683: 3,
  95684: 3,
  95685: 3,
  95686: 3,
  95687: 3,
  95688: 3,
  95689: 3,
  95690: 3,
  95691: 3,
  95692: 3,
  95693: 3,
  95694: 3,
  95695: 3,
  95696: 3,
  95697: 3,
  95698: 3,
  95699: 3,
  95701: 3,
  95703: 3,
  95709: 3,
  95712: 3,
  95713: 3,
  95714: 3,
  95715: 3,
  95717: 3,
  95720: 3,
  95721: 3,
  95722: 3,
  95724: 3,
  95726: 3,
  95728: 3,
  95735: 3,
  95736: 3,
  95741: 3,
  95742: 3,
  95743: 3,
  95746: 3,
  95747: 3,
  95757: 3,
  95758: 3,
  95759: 3,
  95762: 3,
  95763: 3,
  95765: 3,
  95776: 3,
  95798: 3,
  95799: 3,
  95811: 3,
  95812: 3,
  95813: 3,
  95814: 3,
  95815: 3,
  95816: 3,
  95817: 3,
  95818: 3,
  95819: 3,
  95820: 3,
  95821: 3,
  95822: 3,
  95823: 3,
  95824: 3,
  95825: 3,
  95826: 3,
  95827: 3,
  95828: 3,
  95829: 3,
  95830: 3,
  95831: 3,
  95832: 3,
  95833: 3,
  95834: 3,
  95835: 3,
  95836: 3,
  95837: 3,
  95838: 3,
  95840: 3,
  95841: 3,
  95842: 3,
  95843: 3,
  95851: 3,
  95852: 3,
  95853: 3,
  95857: 3,
  95860: 3,
  95864: 3,
  95865: 3,
  95866: 3,
  95867: 3,
  95873: 3,
  95887: 3,
  95894: 3,
  95899: 3,
  95901: 3,
  95903: 3,
  95910: 3,
  95912: 3,
  95913: 3,
  95914: 3,
  95915: 3,
  95916: 3,
  95917: 3,
  95918: 3,
  95919: 3,
  95920: 3,
  95922: 3,
  95923: 3,
  95924: 3,
  95925: 3,
  95926: 3,
  95927: 3,
  95928: 3,
  95929: 3,
  95930: 3,
  95932: 3,
  95934: 3,
  95935: 3,
  95936: 3,
  95937: 3,
  95938: 3,
  95939: 3,
  95940: 3,
  95941: 3,
  95942: 3,
  95943: 3,
  95944: 3,
  95945: 3,
  95946: 3,
  95947: 3,
  95948: 3,
  95949: 3,
  95950: 3,
  95951: 3,
  95953: 3,
  95954: 3,
  95955: 3,
  95956: 3,
  95957: 3,
  95958: 3,
  95959: 3,
  95960: 3,
  95961: 3,
  95962: 3,
  95963: 3,
  95965: 3,
  95966: 3,
  95967: 3,
  95968: 3,
  95969: 3,
  95970: 3,
  95971: 3,
  95972: 3,
  95973: 3,
  95974: 3,
  95975: 3,
  95976: 3,
  95977: 3,
  95978: 3,
  95979: 3,
  95980: 3,
  95981: 3,
  95982: 3,
  95983: 3,
  95984: 3,
  95986: 3,
  95987: 3,
  95988: 3,
  95991: 3,
  95992: 3,
  95993: 3,
  96001: 3,
  96002: 3,
  96003: 3,
  96006: 3,
  96007: 3,
  96008: 3,
  96009: 3,
  96010: 3,
  96011: 3,
  96013: 3,
  96014: 3,
  96015: 3,
  96016: 3,
  96017: 3,
  96019: 3,
  96020: 3,
  96021: 3,
  96022: 3,
  96023: 3,
  96024: 3,
  96025: 3,
  96027: 3,
  96028: 3,
  96029: 3,
  96031: 3,
  96032: 3,
  96033: 3,
  96034: 3,
  96035: 3,
  96037: 3,
  96038: 3,
  96039: 3,
  96040: 3,
  96041: 3,
  96044: 3,
  96046: 3,
  96047: 3,
  96048: 3,
  96049: 3,
  96050: 3,
  96051: 3,
  96052: 3,
  96054: 3,
  96055: 3,
  96056: 3,
  96057: 3,
  96058: 3,
  96059: 3,
  96061: 3,
  96062: 3,
  96063: 3,
  96064: 3,
  96065: 3,
  96067: 3,
  96068: 3,
  96069: 3,
  96070: 3,
  96071: 3,
  96073: 3,
  96074: 3,
  96075: 3,
  96076: 3,
  96078: 3,
  96079: 3,
  96080: 3,
  96084: 3,
  96085: 3,
  96086: 3,
  96087: 3,
  96088: 3,
  96089: 3,
  96090: 3,
  96091: 3,
  96092: 3,
  96093: 3,
  96094: 3,
  96095: 3,
  96096: 3,
  96097: 3,
  96099: 3,
  96101: 3,
  96103: 3,
  96104: 3,
  96105: 3,
  96106: 3,
  96107: 3,
  96108: 3,
  96109: 3,
  96110: 3,
  96111: 3,
  96112: 3,
  96113: 3,
  96114: 3,
  96115: 3,
  96116: 3,
  96117: 3,
  96118: 3,
  96119: 3,
  96120: 3,
  96121: 3,
  96122: 3,
  96123: 3,
  96124: 3,
  96125: 3,
  96126: 3,
  96127: 3,
  96128: 3,
  96129: 3,
  96130: 3,
  96132: 3,
  96133: 3,
  96134: 3,
  96135: 3,
  96136: 3,
  96137: 3,
  96140: 3,
  96141: 3,
  96142: 3,
  96143: 3,
  96145: 3,
  96146: 3,
  96148: 3,
  96150: 3,
  96151: 3,
  96152: 3,
  96154: 3,
  96155: 3,
  96156: 3,
  96157: 3,
  96158: 3,
  96160: 3,
  96161: 3,
  96162: 3,
  96701: 10,
  96703: 10,
  96704: 10,
  96705: 10,
  96706: 10,
  96707: 10,
  96708: 10,
  96709: 10,
  96710: 10,
  96712: 10,
  96713: 10,
  96714: 10,
  96715: 10,
  96716: 10,
  96717: 10,
  96718: 10,
  96719: 10,
  96720: 10,
  96721: 10,
  96722: 10,
  96725: 10,
  96726: 10,
  96727: 10,
  96728: 10,
  96729: 10,
  96730: 10,
  96731: 10,
  96732: 10,
  96733: 10,
  96734: 10,
  96737: 10,
  96738: 10,
  96739: 10,
  96740: 10,
  96741: 10,
  96742: 10,
  96743: 10,
  96744: 10,
  96745: 10,
  96746: 10,
  96747: 10,
  96748: 10,
  96749: 10,
  96750: 10,
  96751: 10,
  96752: 10,
  96753: 10,
  96754: 10,
  96755: 10,
  96756: 10,
  96757: 10,
  96759: 10,
  96760: 10,
  96761: 10,
  96762: 10,
  96763: 10,
  96764: 10,
  96765: 10,
  96766: 10,
  96767: 10,
  96768: 10,
  96769: 10,
  96770: 10,
  96771: 10,
  96772: 10,
  96773: 10,
  96774: 10,
  96776: 10,
  96777: 10,
  96778: 10,
  96779: 10,
  96780: 10,
  96781: 10,
  96782: 10,
  96783: 10,
  96784: 10,
  96785: 10,
  96786: 10,
  96788: 10,
  96789: 10,
  96790: 10,
  96791: 10,
  96792: 10,
  96793: 10,
  96795: 10,
  96796: 10,
  96797: 10,
  96801: 10,
  96802: 10,
  96803: 10,
  96804: 10,
  96805: 10,
  96806: 10,
  96807: 10,
  96808: 10,
  96809: 10,
  96810: 10,
  96811: 10,
  96812: 10,
  96813: 10,
  96814: 10,
  96815: 10,
  96816: 10,
  96817: 10,
  96818: 10,
  96819: 10,
  96820: 10,
  96821: 10,
  96822: 10,
  96823: 10,
  96824: 10,
  96825: 10,
  96826: 10,
  96827: 10,
  96828: 10,
  96830: 10,
  96835: 10,
  96836: 10,
  96837: 10,
  96838: 10,
  96839: 10,
  96840: 10,
  96841: 10,
  96842: 10,
  96843: 10,
  96844: 10,
  96846: 10,
  96847: 10,
  96848: 10,
  96849: 10,
  96850: 10,
  96853: 10,
  96854: 10,
  96857: 10,
  96858: 10,
  96859: 10,
  96860: 10,
  96861: 10,
  96862: 10,
  96863: 10,
  97001: 3,
  97002: 3,
  97004: 3,
  97005: 3,
  97006: 3,
  97007: 3,
  97008: 3,
  97009: 3,
  97010: 3,
  97011: 3,
  97013: 3,
  97014: 3,
  97015: 3,
  97016: 3,
  97017: 3,
  97018: 3,
  97019: 3,
  97020: 3,
  97021: 3,
  97022: 3,
  97023: 3,
  97024: 3,
  97026: 3,
  97027: 3,
  97028: 3,
  97029: 3,
  97030: 3,
  97031: 3,
  97032: 3,
  97033: 3,
  97034: 3,
  97035: 3,
  97036: 3,
  97037: 3,
  97038: 3,
  97039: 3,
  97040: 3,
  97041: 3,
  97042: 3,
  97044: 3,
  97045: 3,
  97048: 3,
  97049: 3,
  97050: 3,
  97051: 3,
  97053: 3,
  97054: 3,
  97055: 3,
  97056: 3,
  97057: 3,
  97058: 3,
  97060: 3,
  97062: 3,
  97063: 3,
  97064: 3,
  97065: 3,
  97067: 3,
  97068: 3,
  97070: 3,
  97071: 3,
  97075: 3,
  97076: 3,
  97077: 3,
  97078: 3,
  97080: 3,
  97086: 3,
  97089: 3,
  97101: 3,
  97102: 3,
  97103: 3,
  97106: 3,
  97107: 3,
  97108: 3,
  97109: 3,
  97110: 3,
  97111: 3,
  97112: 3,
  97113: 3,
  97114: 3,
  97115: 3,
  97116: 3,
  97117: 3,
  97118: 3,
  97119: 3,
  97121: 3,
  97122: 3,
  97123: 3,
  97124: 3,
  97125: 3,
  97127: 3,
  97128: 3,
  97130: 3,
  97131: 3,
  97132: 3,
  97133: 3,
  97134: 3,
  97135: 3,
  97137: 3,
  97138: 3,
  97140: 3,
  97141: 3,
  97143: 3,
  97144: 3,
  97145: 3,
  97146: 3,
  97147: 3,
  97148: 3,
  97149: 3,
  97200: 3,
  97201: 3,
  97202: 3,
  97203: 3,
  97204: 3,
  97205: 3,
  97206: 3,
  97207: 3,
  97208: 3,
  97209: 3,
  97210: 3,
  97211: 3,
  97212: 3,
  97213: 3,
  97214: 3,
  97215: 3,
  97216: 3,
  97217: 3,
  97218: 3,
  97219: 3,
  97220: 3,
  97221: 3,
  97222: 3,
  97223: 3,
  97224: 3,
  97225: 3,
  97227: 3,
  97228: 3,
  97229: 3,
  97230: 3,
  97231: 3,
  97232: 3,
  97233: 3,
  97236: 3,
  97238: 3,
  97239: 3,
  97240: 3,
  97242: 3,
  97251: 3,
  97253: 3,
  97254: 3,
  97255: 3,
  97256: 3,
  97258: 3,
  97259: 3,
  97266: 3,
  97267: 3,
  97268: 3,
  97269: 3,
  97271: 3,
  97272: 3,
  97280: 3,
  97281: 3,
  97282: 3,
  97283: 3,
  97286: 3,
  97290: 3,
  97291: 3,
  97292: 3,
  97293: 3,
  97294: 3,
  97296: 3,
  97298: 3,
  97299: 3,
  97301: 3,
  97302: 3,
  97303: 3,
  97304: 3,
  97305: 3,
  97306: 3,
  97307: 3,
  97308: 3,
  97309: 3,
  97310: 3,
  97311: 3,
  97312: 3,
  97313: 3,
  97314: 3,
  97317: 3,
  97321: 3,
  97322: 3,
  97324: 3,
  97325: 3,
  97326: 3,
  97327: 3,
  97329: 3,
  97330: 3,
  97331: 3,
  97333: 3,
  97335: 3,
  97336: 3,
  97338: 3,
  97339: 3,
  97341: 3,
  97342: 3,
  97343: 3,
  97344: 3,
  97345: 3,
  97346: 3,
  97347: 3,
  97348: 3,
  97350: 3,
  97351: 3,
  97352: 3,
  97355: 3,
  97357: 3,
  97358: 3,
  97359: 3,
  97360: 3,
  97361: 3,
  97362: 3,
  97364: 3,
  97365: 3,
  97366: 3,
  97367: 3,
  97368: 3,
  97369: 3,
  97370: 3,
  97371: 3,
  97372: 3,
  97373: 3,
  97374: 3,
  97375: 3,
  97376: 3,
  97377: 3,
  97378: 3,
  97380: 3,
  97381: 3,
  97383: 3,
  97384: 3,
  97385: 3,
  97386: 3,
  97388: 3,
  97389: 3,
  97390: 3,
  97391: 3,
  97392: 3,
  97394: 3,
  97396: 3,
  97401: 3,
  97402: 3,
  97403: 3,
  97404: 3,
  97405: 3,
  97406: 3,
  97407: 3,
  97408: 3,
  97409: 3,
  97410: 3,
  97411: 3,
  97412: 3,
  97413: 3,
  97414: 3,
  97415: 3,
  97416: 3,
  97417: 3,
  97419: 3,
  97420: 3,
  97423: 3,
  97424: 3,
  97425: 3,
  97426: 3,
  97427: 3,
  97428: 3,
  97429: 3,
  97430: 3,
  97431: 3,
  97432: 3,
  97434: 3,
  97435: 3,
  97436: 3,
  97437: 3,
  97438: 3,
  97439: 3,
  97440: 3,
  97441: 3,
  97442: 3,
  97443: 3,
  97444: 3,
  97446: 3,
  97447: 3,
  97448: 3,
  97449: 3,
  97450: 3,
  97451: 3,
  97452: 3,
  97453: 3,
  97454: 3,
  97455: 3,
  97456: 3,
  97457: 3,
  97458: 3,
  97459: 3,
  97461: 3,
  97462: 3,
  97463: 3,
  97464: 3,
  97465: 3,
  97466: 3,
  97467: 3,
  97469: 3,
  97470: 3,
  97471: 3,
  97472: 3,
  97473: 3,
  97476: 3,
  97477: 3,
  97478: 3,
  97479: 3,
  97480: 3,
  97481: 3,
  97482: 3,
  97484: 3,
  97486: 3,
  97487: 3,
  97488: 3,
  97489: 3,
  97490: 3,
  97491: 3,
  97492: 3,
  97493: 3,
  97494: 3,
  97495: 3,
  97496: 3,
  97497: 3,
  97498: 3,
  97499: 3,
  97501: 3,
  97502: 3,
  97503: 3,
  97504: 3,
  97520: 3,
  97522: 3,
  97523: 3,
  97524: 3,
  97525: 3,
  97526: 3,
  97527: 3,
  97528: 3,
  97530: 3,
  97531: 3,
  97532: 3,
  97533: 3,
  97534: 3,
  97535: 3,
  97536: 3,
  97537: 3,
  97538: 3,
  97539: 3,
  97540: 3,
  97541: 3,
  97543: 3,
  97544: 3,
  97601: 3,
  97602: 3,
  97603: 3,
  97604: 3,
  97620: 3,
  97621: 3,
  97622: 3,
  97623: 3,
  97624: 3,
  97625: 3,
  97626: 3,
  97627: 3,
  97630: 3,
  97632: 3,
  97633: 3,
  97634: 3,
  97635: 3,
  97636: 3,
  97637: 3,
  97638: 3,
  97639: 3,
  97640: 3,
  97641: 3,
  97701: 3,
  97702: 3,
  97703: 3,
  97707: 3,
  97708: 3,
  97709: 3,
  97710: 3,
  97711: 3,
  97712: 3,
  97720: 3,
  97721: 3,
  97722: 3,
  97730: 3,
  97731: 3,
  97732: 3,
  97733: 3,
  97734: 3,
  97735: 3,
  97736: 3,
  97737: 3,
  97738: 3,
  97739: 3,
  97741: 3,
  97750: 3,
  97751: 3,
  97752: 3,
  97753: 3,
  97754: 3,
  97756: 3,
  97758: 3,
  97759: 3,
  97760: 3,
  97761: 3,
  97801: 3,
  97810: 3,
  97812: 3,
  97813: 3,
  97814: 3,
  97817: 3,
  97818: 3,
  97819: 3,
  97820: 3,
  97823: 3,
  97824: 3,
  97825: 3,
  97826: 3,
  97827: 3,
  97828: 3,
  97830: 3,
  97833: 3,
  97834: 3,
  97835: 3,
  97836: 3,
  97837: 3,
  97838: 3,
  97839: 3,
  97840: 3,
  97841: 3,
  97843: 3,
  97844: 3,
  97845: 3,
  97848: 3,
  97850: 3,
  97856: 3,
  97857: 3,
  97859: 3,
  97861: 3,
  97862: 3,
  97864: 3,
  97865: 3,
  97867: 3,
  97868: 3,
  97869: 3,
  97870: 3,
  97873: 3,
  97874: 3,
  97875: 3,
  97876: 3,
  97877: 3,
  97880: 3,
  97882: 3,
  97883: 3,
  97884: 3,
  97885: 3,
  97886: 3,
  97901: 3,
  97902: 3,
  97903: 3,
  97904: 3,
  97905: 3,
  97906: 3,
  97907: 3,
  97908: 3,
  97909: 3,
  97910: 3,
  97911: 3,
  97913: 3,
  97914: 3,
  97917: 3,
  97918: 3,
  97920: 3,
  98001: 3,
  98002: 3,
  98003: 3,
  98004: 3,
  98005: 3,
  98006: 3,
  98007: 3,
  98008: 3,
  98009: 3,
  98010: 3,
  98011: 3,
  98012: 3,
  98013: 3,
  98014: 3,
  98015: 3,
  98019: 3,
  98020: 3,
  98021: 3,
  98022: 3,
  98023: 3,
  98024: 3,
  98025: 3,
  98026: 3,
  98027: 3,
  98028: 3,
  98029: 3,
  98030: 3,
  98031: 3,
  98032: 3,
  98033: 3,
  98034: 3,
  98035: 3,
  98036: 3,
  98037: 3,
  98038: 3,
  98039: 3,
  98040: 3,
  98041: 3,
  98042: 3,
  98043: 3,
  98045: 3,
  98046: 3,
  98047: 3,
  98050: 3,
  98051: 3,
  98052: 3,
  98053: 3,
  98054: 3,
  98055: 3,
  98056: 3,
  98057: 3,
  98058: 3,
  98059: 3,
  98061: 3,
  98062: 3,
  98063: 3,
  98064: 3,
  98065: 3,
  98068: 3,
  98070: 3,
  98071: 3,
  98072: 3,
  98073: 3,
  98074: 3,
  98075: 3,
  98077: 3,
  98082: 3,
  98083: 3,
  98087: 3,
  98089: 3,
  98092: 3,
  98093: 3,
  98101: 3,
  98102: 3,
  98103: 3,
  98104: 3,
  98105: 3,
  98106: 3,
  98107: 3,
  98108: 3,
  98109: 3,
  98110: 3,
  98111: 3,
  98112: 3,
  98113: 3,
  98114: 3,
  98117: 3,
  98118: 3,
  98119: 3,
  98121: 3,
  98122: 3,
  98124: 3,
  98126: 3,
  98127: 3,
  98129: 3,
  98131: 3,
  98133: 3,
  98134: 3,
  98136: 3,
  98138: 3,
  98139: 3,
  98144: 3,
  98145: 3,
  98146: 3,
  98148: 3,
  98151: 3,
  98154: 3,
  98155: 3,
  98158: 3,
  98160: 3,
  98161: 3,
  98164: 3,
  98165: 3,
  98166: 3,
  98168: 3,
  98170: 3,
  98171: 3,
  98174: 3,
  98175: 3,
  98177: 3,
  98178: 3,
  98181: 3,
  98184: 3,
  98185: 3,
  98191: 3,
  98194: 3,
  98195: 3,
  98198: 3,
  98199: 3,
  98201: 3,
  98203: 3,
  98204: 3,
  98205: 3,
  98206: 3,
  98207: 3,
  98208: 3,
  98213: 3,
  98220: 3,
  98221: 3,
  98222: 3,
  98223: 3,
  98224: 3,
  98225: 3,
  98226: 3,
  98227: 3,
  98228: 3,
  98229: 3,
  98230: 3,
  98231: 3,
  98232: 3,
  98233: 3,
  98235: 3,
  98236: 3,
  98237: 3,
  98238: 3,
  98239: 3,
  98240: 3,
  98241: 3,
  98243: 3,
  98244: 3,
  98245: 3,
  98247: 3,
  98248: 3,
  98249: 3,
  98250: 3,
  98251: 3,
  98252: 3,
  98253: 3,
  98255: 3,
  98256: 3,
  98257: 3,
  98258: 3,
  98259: 3,
  98260: 3,
  98261: 3,
  98262: 3,
  98263: 3,
  98264: 3,
  98266: 3,
  98267: 3,
  98270: 3,
  98271: 3,
  98272: 3,
  98273: 3,
  98274: 3,
  98275: 3,
  98276: 3,
  98277: 3,
  98278: 3,
  98279: 3,
  98280: 3,
  98281: 3,
  98282: 3,
  98283: 3,
  98284: 3,
  98286: 3,
  98287: 3,
  98288: 3,
  98290: 3,
  98291: 3,
  98292: 3,
  98293: 3,
  98294: 3,
  98295: 3,
  98296: 3,
  98297: 3,
  98303: 3,
  98304: 3,
  98305: 3,
  98310: 3,
  98311: 3,
  98312: 3,
  98314: 3,
  98315: 3,
  98320: 3,
  98321: 3,
  98322: 3,
  98323: 3,
  98324: 3,
  98325: 3,
  98327: 3,
  98328: 3,
  98329: 3,
  98330: 3,
  98331: 3,
  98332: 3,
  98333: 3,
  98335: 3,
  98336: 3,
  98337: 3,
  98338: 3,
  98339: 3,
  98340: 3,
  98342: 3,
  98343: 3,
  98344: 3,
  98345: 3,
  98346: 3,
  98348: 3,
  98349: 3,
  98350: 3,
  98351: 3,
  98352: 3,
  98353: 3,
  98354: 3,
  98355: 3,
  98356: 3,
  98357: 3,
  98358: 3,
  98359: 3,
  98360: 3,
  98361: 3,
  98362: 3,
  98363: 3,
  98364: 3,
  98365: 3,
  98366: 3,
  98367: 3,
  98368: 3,
  98370: 3,
  98371: 3,
  98372: 3,
  98373: 3,
  98374: 3,
  98375: 3,
  98376: 3,
  98377: 3,
  98378: 3,
  98380: 3,
  98381: 3,
  98382: 3,
  98383: 3,
  98384: 3,
  98385: 3,
  98386: 3,
  98387: 3,
  98388: 3,
  98390: 3,
  98391: 3,
  98392: 3,
  98393: 3,
  98394: 3,
  98395: 3,
  98396: 3,
  98397: 3,
  98398: 3,
  98401: 3,
  98402: 3,
  98403: 3,
  98404: 3,
  98405: 3,
  98406: 3,
  98407: 3,
  98408: 3,
  98409: 3,
  98411: 3,
  98412: 3,
  98413: 3,
  98415: 3,
  98416: 3,
  98417: 3,
  98418: 3,
  98419: 3,
  98421: 3,
  98422: 3,
  98424: 3,
  98430: 3,
  98431: 3,
  98433: 3,
  98438: 3,
  98439: 3,
  98442: 3,
  98443: 3,
  98444: 3,
  98445: 3,
  98446: 3,
  98447: 3,
  98448: 3,
  98450: 3,
  98455: 3,
  98460: 3,
  98464: 3,
  98465: 3,
  98466: 3,
  98467: 3,
  98471: 3,
  98477: 3,
  98481: 3,
  98490: 3,
  98492: 3,
  98493: 3,
  98496: 3,
  98497: 3,
  98498: 3,
  98499: 3,
  98501: 3,
  98502: 3,
  98503: 3,
  98504: 3,
  98505: 3,
  98506: 3,
  98507: 3,
  98508: 3,
  98509: 3,
  98511: 3,
  98512: 3,
  98513: 3,
  98516: 3,
  98520: 3,
  98522: 3,
  98524: 3,
  98526: 3,
  98527: 3,
  98528: 3,
  98530: 3,
  98531: 3,
  98532: 3,
  98533: 3,
  98535: 3,
  98536: 3,
  98537: 3,
  98538: 3,
  98539: 3,
  98541: 3,
  98542: 3,
  98544: 3,
  98547: 3,
  98548: 3,
  98550: 3,
  98552: 3,
  98554: 3,
  98555: 3,
  98556: 3,
  98557: 3,
  98558: 3,
  98559: 3,
  98560: 3,
  98561: 3,
  98562: 3,
  98563: 3,
  98565: 3,
  98566: 3,
  98568: 3,
  98569: 3,
  98570: 3,
  98571: 3,
  98572: 3,
  98575: 3,
  98576: 3,
  98577: 3,
  98579: 3,
  98580: 3,
  98581: 3,
  98582: 3,
  98583: 3,
  98584: 3,
  98585: 3,
  98586: 3,
  98587: 3,
  98589: 3,
  98590: 3,
  98591: 3,
  98592: 3,
  98593: 3,
  98595: 3,
  98596: 3,
  98597: 3,
  98599: 3,
  98601: 3,
  98602: 3,
  98603: 3,
  98604: 3,
  98605: 3,
  98606: 3,
  98607: 3,
  98609: 3,
  98610: 3,
  98611: 3,
  98612: 3,
  98613: 3,
  98614: 3,
  98616: 3,
  98617: 3,
  98619: 3,
  98620: 3,
  98621: 3,
  98622: 3,
  98623: 3,
  98624: 3,
  98625: 3,
  98626: 3,
  98628: 3,
  98629: 3,
  98631: 3,
  98632: 3,
  98635: 3,
  98637: 3,
  98638: 3,
  98639: 3,
  98640: 3,
  98641: 3,
  98642: 3,
  98643: 3,
  98644: 3,
  98645: 3,
  98647: 3,
  98648: 3,
  98649: 3,
  98650: 3,
  98651: 3,
  98660: 3,
  98661: 3,
  98662: 3,
  98663: 3,
  98664: 3,
  98665: 3,
  98666: 3,
  98667: 3,
  98668: 3,
  98670: 3,
  98671: 3,
  98672: 3,
  98673: 3,
  98674: 3,
  98675: 3,
  98682: 3,
  98683: 3,
  98684: 3,
  98685: 3,
  98686: 3,
  98687: 3,
  98801: 3,
  98802: 3,
  98807: 3,
  98811: 3,
  98812: 3,
  98813: 3,
  98814: 3,
  98815: 3,
  98816: 3,
  98817: 3,
  98819: 3,
  98821: 3,
  98822: 3,
  98823: 3,
  98824: 3,
  98826: 3,
  98827: 3,
  98828: 3,
  98829: 3,
  98830: 3,
  98831: 3,
  98832: 3,
  98833: 3,
  98834: 3,
  98836: 3,
  98837: 3,
  98840: 3,
  98841: 3,
  98843: 3,
  98844: 3,
  98845: 3,
  98846: 3,
  98847: 3,
  98848: 3,
  98849: 3,
  98850: 3,
  98851: 3,
  98852: 3,
  98853: 3,
  98855: 3,
  98856: 3,
  98857: 3,
  98858: 3,
  98859: 3,
  98860: 3,
  98862: 3,
  98901: 3,
  98902: 3,
  98903: 3,
  98904: 3,
  98907: 3,
  98908: 3,
  98909: 3,
  98920: 3,
  98921: 3,
  98922: 3,
  98923: 3,
  98925: 3,
  98926: 3,
  98929: 3,
  98930: 3,
  98932: 3,
  98933: 3,
  98934: 3,
  98935: 3,
  98936: 3,
  98937: 3,
  98938: 3,
  98939: 3,
  98940: 3,
  98941: 3,
  98942: 3,
  98943: 3,
  98944: 3,
  98946: 3,
  98947: 3,
  98948: 3,
  98950: 3,
  98951: 3,
  98952: 3,
  98953: 3,
  99001: 3,
  99003: 3,
  99004: 3,
  99005: 3,
  99006: 3,
  99008: 3,
  99009: 3,
  99011: 3,
  99012: 3,
  99013: 3,
  99014: 3,
  99015: 3,
  99016: 3,
  99017: 3,
  99018: 3,
  99019: 3,
  99020: 3,
  99021: 3,
  99022: 3,
  99023: 3,
  99025: 3,
  99026: 3,
  99029: 3,
  99030: 3,
  99031: 3,
  99032: 3,
  99033: 3,
  99036: 3,
  99037: 3,
  99039: 3,
  99101: 3,
  99102: 3,
  99103: 3,
  99104: 3,
  99105: 3,
  99107: 3,
  99109: 3,
  99110: 3,
  99111: 3,
  99113: 3,
  99114: 3,
  99115: 3,
  99116: 3,
  99117: 3,
  99118: 3,
  99119: 3,
  99121: 3,
  99122: 3,
  99123: 3,
  99124: 3,
  99125: 3,
  99126: 3,
  99127: 3,
  99128: 3,
  99129: 3,
  99130: 3,
  99131: 3,
  99133: 3,
  99134: 3,
  99135: 3,
  99136: 3,
  99137: 3,
  99138: 3,
  99139: 3,
  99140: 3,
  99141: 3,
  99143: 3,
  99144: 3,
  99146: 3,
  99147: 3,
  99148: 3,
  99149: 3,
  99150: 3,
  99151: 3,
  99152: 3,
  99153: 3,
  99154: 3,
  99155: 3,
  99156: 3,
  99157: 3,
  99158: 3,
  99159: 3,
  99160: 3,
  99161: 3,
  99163: 3,
  99164: 3,
  99165: 3,
  99166: 3,
  99167: 3,
  99169: 3,
  99170: 3,
  99171: 3,
  99173: 3,
  99174: 3,
  99176: 3,
  99179: 3,
  99180: 3,
  99181: 3,
  99185: 3,
  99201: 3,
  99202: 3,
  99203: 3,
  99204: 3,
  99205: 3,
  99206: 3,
  99207: 3,
  99208: 3,
  99209: 3,
  99210: 3,
  99211: 3,
  99212: 3,
  99213: 3,
  99214: 3,
  99215: 3,
  99216: 3,
  99217: 3,
  99218: 3,
  99219: 3,
  99220: 3,
  99223: 3,
  99224: 3,
  99228: 3,
  99251: 3,
  99252: 3,
  99256: 3,
  99258: 3,
  99260: 3,
  99299: 3,
  99301: 3,
  99302: 3,
  99320: 3,
  99321: 3,
  99322: 3,
  99323: 3,
  99324: 3,
  99326: 3,
  99327: 3,
  99328: 3,
  99329: 3,
  99330: 3,
  99332: 3,
  99333: 3,
  99335: 3,
  99336: 3,
  99337: 3,
  99338: 3,
  99341: 3,
  99343: 3,
  99344: 3,
  99345: 3,
  99346: 3,
  99347: 3,
  99348: 3,
  99349: 3,
  99350: 3,
  99352: 3,
  99353: 3,
  99354: 3,
  99356: 3,
  99357: 3,
  99359: 3,
  99360: 3,
  99361: 3,
  99362: 3,
  99363: 3,
  99371: 3,
  99401: 3,
  99402: 3,
  99403: 3,
  99501: 9,
  99502: 9,
  99503: 9,
  99504: 9,
  99505: 9,
  99506: 9,
  99507: 9,
  99508: 9,
  99509: 9,
  99510: 9,
  99511: 9,
  99512: 9,
  99513: 9,
  99514: 9,
  99515: 9,
  99516: 9,
  99517: 9,
  99518: 9,
  99519: 9,
  99520: 9,
  99521: 9,
  99522: 9,
  99523: 9,
  99524: 9,
  99529: 9,
  99530: 9,
  99540: 9,
  99545: 9,
  99546: 9,
  99547: 9,
  99548: 9,
  99549: 9,
  99550: 9,
  99551: 9,
  99552: 9,
  99553: 9,
  99554: 20,
  99555: 9,
  99556: 9,
  99557: 9,
  99558: 9,
  99559: 9,
  99561: 9,
  99563: 20,
  99564: 9,
  99565: 9,
  99566: 9,
  99567: 9,
  99568: 9,
  99569: 9,
  99571: 9,
  99572: 9,
  99573: 9,
  99574: 9,
  99575: 9,
  99576: 9,
  99577: 9,
  99578: 9,
  99579: 9,
  99580: 9,
  99581: 20,
  99583: 9,
  99584: 20,
  99585: 20,
  99586: 9,
  99587: 9,
  99588: 9,
  99589: 9,
  99590: 9,
  99591: 9,
  99599: 9,
  99602: 9,
  99603: 9,
  99604: 20,
  99605: 9,
  99606: 9,
  99607: 9,
  99608: 9,
  99609: 9,
  99610: 9,
  99611: 9,
  99612: 9,
  99613: 9,
  99614: 9,
  99615: 9,
  99619: 9,
  99620: 20,
  99621: 9,
  99622: 9,
  99624: 9,
  99625: 9,
  99626: 9,
  99627: 9,
  99628: 9,
  99629: 9,
  99630: 9,
  99631: 9,
  99632: 20,
  99633: 9,
  99634: 9,
  99635: 9,
  99636: 9,
  99637: 9,
  99638: 9,
  99639: 9,
  99640: 9,
  99641: 9,
  99643: 9,
  99644: 9,
  99645: 9,
  99647: 9,
  99648: 9,
  99649: 9,
  99650: 20,
  99651: 9,
  99652: 9,
  99653: 9,
  99654: 9,
  99655: 9,
  99656: 9,
  99657: 20,
  99658: 20,
  99659: 20,
  99660: 9,
  99661: 9,
  99662: 20,
  99663: 9,
  99664: 9,
  99665: 9,
  99666: 20,
  99667: 9,
  99668: 9,
  99669: 9,
  99670: 9,
  99671: 20,
  99672: 9,
  99674: 9,
  99675: 9,
  99676: 9,
  99677: 9,
  99678: 9,
  99679: 9,
  99680: 9,
  99681: 9,
  99682: 9,
  99683: 9,
  99684: 20,
  99685: 9,
  99686: 9,
  99687: 9,
  99688: 9,
  99689: 24,
  99690: 9,
  99691: 9,
  99692: 9,
  99693: 9,
  99694: 9,
  99695: 9,
  99697: 9,
  99701: 9,
  99702: 9,
  99703: 9,
  99704: 9,
  99705: 9,
  99706: 9,
  99707: 9,
  99708: 9,
  99709: 9,
  99710: 9,
  99711: 9,
  99712: 9,
  99714: 9,
  99716: 9,
  99720: 9,
  99721: 9,
  99722: 9,
  99723: 9,
  99724: 9,
  99725: 9,
  99726: 9,
  99729: 9,
  99730: 9,
  99731: 9,
  99732: 9,
  99733: 9,
  99734: 9,
  99736: 20,
  99737: 9,
  99738: 9,
  99739: 20,
  99740: 9,
  99741: 9,
  99742: 20,
  99743: 9,
  99744: 9,
  99745: 9,
  99746: 9,
  99747: 9,
  99748: 9,
  99749: 20,
  99750: 20,
  99751: 20,
  99752: 20,
  99753: 20,
  99754: 9,
  99755: 9,
  99756: 9,
  99757: 9,
  99758: 9,
  99759: 9,
  99760: 9,
  99761: 20,
  99762: 20,
  99763: 20,
  99764: 9,
  99765: 9,
  99766: 9,
  99767: 9,
  99768: 9,
  99769: 20,
  99770: 20,
  99771: 20,
  99772: 20,
  99773: 20,
  99774: 9,
  99775: 9,
  99776: 9,
  99777: 9,
  99778: 20,
  99779: 9,
  99780: 9,
  99781: 9,
  99782: 9,
  99783: 20,
  99784: 20,
  99785: 20,
  99786: 20,
  99788: 9,
  99789: 9,
  99790: 9,
  99791: 9,
  99801: 21,
  99802: 21,
  99803: 21,
  99811: 21,
  99812: 21,
  99820: 9,
  99821: 21,
  99824: 21,
  99825: 21,
  99826: 21,
  99827: 21,
  99829: 21,
  99830: 21,
  99832: 21,
  99833: 21,
  99835: 21,
  99836: 21,
  99840: 21,
  99841: 21,
  99850: 21,
  99901: 21,
  99903: 21,
  99918: 21,
  99919: 21,
  99921: 21,
  99922: 21,
  99923: 21,
  99925: 21,
  99926: 21,
  99927: 21,
  99928: 21,
  99929: 9,
  99950: 21,
  '00501': 0,
  '00544': 0,
  '01001': 0,
  '01002': 0,
  '01003': 0,
  '01004': 0,
  '01005': 0,
  '01007': 0,
  '01008': 0,
  '01009': 0,
  '01010': 0,
  '01011': 0,
  '01012': 0,
  '01013': 0,
  '01014': 0,
  '01020': 0,
  '01021': 0,
  '01022': 0,
  '01026': 0,
  '01027': 0,
  '01028': 0,
  '01029': 0,
  '01030': 0,
  '01031': 0,
  '01032': 0,
  '01033': 0,
  '01034': 0,
  '01035': 0,
  '01036': 0,
  '01037': 0,
  '01038': 0,
  '01039': 0,
  '01040': 0,
  '01041': 0,
  '01050': 0,
  '01053': 0,
  '01054': 0,
  '01056': 0,
  '01057': 0,
  '01059': 0,
  '01060': 0,
  '01061': 0,
  '01062': 0,
  '01063': 0,
  '01066': 0,
  '01068': 0,
  '01069': 0,
  '01070': 0,
  '01071': 0,
  '01072': 0,
  '01073': 0,
  '01074': 0,
  '01075': 0,
  '01077': 0,
  '01079': 0,
  '01080': 0,
  '01081': 0,
  '01082': 0,
  '01083': 0,
  '01084': 0,
  '01085': 0,
  '01086': 0,
  '01088': 0,
  '01089': 0,
  '01090': 0,
  '01092': 0,
  '01093': 0,
  '01094': 0,
  '01095': 0,
  '01096': 0,
  '01097': 0,
  '01098': 0,
  '01101': 0,
  '01102': 0,
  '01103': 0,
  '01104': 0,
  '01105': 0,
  '01106': 0,
  '01107': 0,
  '01108': 0,
  '01109': 0,
  '01111': 0,
  '01114': 0,
  '01115': 0,
  '01116': 0,
  '01118': 0,
  '01119': 0,
  '01128': 0,
  '01129': 0,
  '01133': 0,
  '01138': 0,
  '01139': 0,
  '01144': 0,
  '01151': 0,
  '01152': 0,
  '01195': 0,
  '01199': 0,
  '01201': 0,
  '01202': 0,
  '01203': 0,
  '01220': 0,
  '01222': 0,
  '01223': 0,
  '01224': 0,
  '01225': 0,
  '01226': 0,
  '01227': 0,
  '01229': 0,
  '01230': 0,
  '01235': 0,
  '01236': 0,
  '01237': 0,
  '01238': 0,
  '01240': 0,
  '01242': 0,
  '01243': 0,
  '01244': 0,
  '01245': 0,
  '01247': 0,
  '01252': 0,
  '01253': 0,
  '01254': 0,
  '01255': 0,
  '01256': 0,
  '01257': 0,
  '01258': 0,
  '01259': 0,
  '01260': 0,
  '01262': 0,
  '01263': 0,
  '01264': 0,
  '01266': 0,
  '01267': 0,
  '01270': 0,
  '01301': 0,
  '01302': 0,
  '01330': 0,
  '01331': 0,
  '01337': 0,
  '01338': 0,
  '01339': 0,
  '01340': 0,
  '01341': 0,
  '01342': 0,
  '01343': 0,
  '01344': 0,
  '01346': 0,
  '01347': 0,
  '01349': 0,
  '01350': 0,
  '01351': 0,
  '01354': 0,
  '01355': 0,
  '01360': 0,
  '01364': 0,
  '01366': 0,
  '01367': 0,
  '01368': 0,
  '01370': 0,
  '01373': 0,
  '01375': 0,
  '01376': 0,
  '01378': 0,
  '01379': 0,
  '01380': 0,
  '01420': 0,
  '01430': 0,
  '01431': 0,
  '01432': 0,
  '01434': 0,
  '01436': 0,
  '01438': 0,
  '01440': 0,
  '01441': 0,
  '01450': 0,
  '01451': 0,
  '01452': 0,
  '01453': 0,
  '01460': 0,
  '01462': 0,
  '01463': 0,
  '01464': 0,
  '01467': 0,
  '01468': 0,
  '01469': 0,
  '01470': 0,
  '01471': 0,
  '01472': 0,
  '01473': 0,
  '01474': 0,
  '01475': 0,
  '01477': 0,
  '01501': 0,
  '01503': 0,
  '01504': 0,
  '01505': 0,
  '01506': 0,
  '01507': 0,
  '01508': 0,
  '01509': 0,
  '01510': 0,
  '01515': 0,
  '01516': 0,
  '01517': 0,
  '01518': 0,
  '01519': 0,
  '01520': 0,
  '01521': 0,
  '01522': 0,
  '01523': 0,
  '01524': 0,
  '01525': 0,
  '01526': 0,
  '01527': 0,
  '01529': 0,
  '01531': 0,
  '01532': 0,
  '01534': 0,
  '01535': 0,
  '01536': 0,
  '01537': 0,
  '01538': 0,
  '01540': 0,
  '01541': 0,
  '01542': 0,
  '01543': 0,
  '01545': 0,
  '01546': 0,
  '01550': 0,
  '01560': 0,
  '01561': 0,
  '01562': 0,
  '01564': 0,
  '01566': 0,
  '01568': 0,
  '01569': 0,
  '01570': 0,
  '01571': 0,
  '01580': 0,
  '01581': 0,
  '01582': 0,
  '01583': 0,
  '01585': 0,
  '01586': 0,
  '01588': 0,
  '01590': 0,
  '01601': 0,
  '01602': 0,
  '01603': 0,
  '01604': 0,
  '01605': 0,
  '01606': 0,
  '01607': 0,
  '01608': 0,
  '01609': 0,
  '01610': 0,
  '01611': 0,
  '01612': 0,
  '01613': 0,
  '01614': 0,
  '01615': 0,
  '01653': 0,
  '01654': 0,
  '01655': 0,
  '01701': 0,
  '01702': 0,
  '01703': 0,
  '01704': 0,
  '01705': 0,
  '01718': 0,
  '01719': 0,
  '01720': 0,
  '01721': 0,
  '01730': 0,
  '01731': 0,
  '01740': 0,
  '01741': 0,
  '01742': 0,
  '01745': 0,
  '01746': 0,
  '01747': 0,
  '01748': 0,
  '01749': 0,
  '01752': 0,
  '01754': 0,
  '01756': 0,
  '01757': 0,
  '01760': 0,
  '01770': 0,
  '01772': 0,
  '01773': 0,
  '01775': 0,
  '01776': 0,
  '01778': 0,
  '01784': 0,
  '01801': 0,
  '01803': 0,
  '01805': 0,
  '01806': 0,
  '01807': 0,
  '01808': 0,
  '01810': 0,
  '01812': 0,
  '01813': 0,
  '01815': 0,
  '01821': 0,
  '01822': 0,
  '01824': 0,
  '01826': 0,
  '01827': 0,
  '01830': 0,
  '01831': 0,
  '01832': 0,
  '01833': 0,
  '01834': 0,
  '01835': 0,
  '01840': 0,
  '01841': 0,
  '01842': 0,
  '01843': 0,
  '01844': 0,
  '01845': 0,
  '01850': 0,
  '01851': 0,
  '01852': 0,
  '01853': 0,
  '01854': 0,
  '01860': 0,
  '01862': 0,
  '01863': 0,
  '01864': 0,
  '01865': 0,
  '01866': 0,
  '01867': 0,
  '01876': 0,
  '01879': 0,
  '01880': 0,
  '01885': 0,
  '01886': 0,
  '01887': 0,
  '01888': 0,
  '01889': 0,
  '01890': 0,
  '01899': 0,
  '01901': 0,
  '01902': 0,
  '01903': 0,
  '01904': 0,
  '01905': 0,
  '01906': 0,
  '01907': 0,
  '01908': 0,
  '01910': 0,
  '01913': 0,
  '01915': 0,
  '01921': 0,
  '01922': 0,
  '01923': 0,
  '01929': 0,
  '01930': 0,
  '01931': 0,
  '01936': 0,
  '01937': 0,
  '01938': 0,
  '01940': 0,
  '01944': 0,
  '01945': 0,
  '01949': 0,
  '01950': 0,
  '01951': 0,
  '01952': 0,
  '01960': 0,
  '01961': 0,
  '01965': 0,
  '01966': 0,
  '01969': 0,
  '01970': 0,
  '01971': 0,
  '01982': 0,
  '01983': 0,
  '01984': 0,
  '01985': 0,
  '02018': 0,
  '02019': 0,
  '02020': 0,
  '02021': 0,
  '02025': 0,
  '02026': 0,
  '02027': 0,
  '02030': 0,
  '02031': 0,
  '02032': 0,
  '02035': 0,
  '02038': 0,
  '02040': 0,
  '02041': 0,
  '02043': 0,
  '02044': 0,
  '02045': 0,
  '02047': 0,
  '02048': 0,
  '02050': 0,
  '02051': 0,
  '02052': 0,
  '02053': 0,
  '02054': 0,
  '02055': 0,
  '02056': 0,
  '02059': 0,
  '02060': 0,
  '02061': 0,
  '02062': 0,
  '02065': 0,
  '02066': 0,
  '02067': 0,
  '02070': 0,
  '02071': 0,
  '02072': 0,
  '02081': 0,
  '02090': 0,
  '02093': 0,
  '02101': 0,
  '02102': 0,
  '02103': 0,
  '02104': 0,
  '02105': 0,
  '02106': 0,
  '02107': 0,
  '02108': 0,
  '02109': 0,
  '02110': 0,
  '02111': 0,
  '02112': 0,
  '02113': 0,
  '02114': 0,
  '02115': 0,
  '02116': 0,
  '02117': 0,
  '02118': 0,
  '02119': 0,
  '02120': 0,
  '02121': 0,
  '02122': 0,
  '02123': 0,
  '02124': 0,
  '02125': 0,
  '02126': 0,
  '02127': 0,
  '02128': 0,
  '02129': 0,
  '02130': 0,
  '02131': 0,
  '02132': 0,
  '02133': 0,
  '02134': 0,
  '02135': 0,
  '02136': 0,
  '02137': 0,
  '02138': 0,
  '02139': 0,
  '02140': 0,
  '02141': 0,
  '02142': 0,
  '02143': 0,
  '02144': 0,
  '02145': 0,
  '02148': 0,
  '02149': 0,
  '02150': 0,
  '02151': 0,
  '02152': 0,
  '02153': 0,
  '02155': 0,
  '02156': 0,
  '02163': 0,
  '02169': 0,
  '02170': 0,
  '02171': 0,
  '02176': 0,
  '02180': 0,
  '02184': 0,
  '02185': 0,
  '02186': 0,
  '02187': 0,
  '02188': 0,
  '02189': 0,
  '02190': 0,
  '02191': 0,
  '02196': 0,
  '02199': 0,
  '02201': 0,
  '02203': 0,
  '02204': 0,
  '02205': 0,
  '02206': 0,
  '02207': 0,
  '02208': 0,
  '02209': 0,
  '02210': 0,
  '02211': 0,
  '02212': 0,
  '02215': 0,
  '02216': 0,
  '02217': 0,
  '02222': 0,
  '02228': 0,
  '02238': 0,
  '02239': 0,
  '02241': 0,
  '02266': 0,
  '02269': 0,
  '02283': 0,
  '02284': 0,
  '02293': 0,
  '02295': 0,
  '02297': 0,
  '02298': 0,
  '02301': 0,
  '02302': 0,
  '02303': 0,
  '02304': 0,
  '02305': 0,
  '02322': 0,
  '02324': 0,
  '02325': 0,
  '02327': 0,
  '02330': 0,
  '02331': 0,
  '02332': 0,
  '02333': 0,
  '02334': 0,
  '02337': 0,
  '02338': 0,
  '02339': 0,
  '02340': 0,
  '02341': 0,
  '02343': 0,
  '02344': 0,
  '02345': 0,
  '02346': 0,
  '02347': 0,
  '02348': 0,
  '02349': 0,
  '02350': 0,
  '02351': 0,
  '02355': 0,
  '02356': 0,
  '02357': 0,
  '02358': 0,
  '02359': 0,
  '02360': 0,
  '02361': 0,
  '02362': 0,
  '02364': 0,
  '02366': 0,
  '02367': 0,
  '02368': 0,
  '02370': 0,
  '02375': 0,
  '02379': 0,
  '02381': 0,
  '02382': 0,
  '02420': 0,
  '02421': 0,
  '02445': 0,
  '02446': 0,
  '02447': 0,
  '02451': 0,
  '02452': 0,
  '02453': 0,
  '02454': 0,
  '02455': 0,
  '02456': 0,
  '02457': 0,
  '02458': 0,
  '02459': 0,
  '02460': 0,
  '02461': 0,
  '02462': 0,
  '02464': 0,
  '02465': 0,
  '02466': 0,
  '02467': 0,
  '02468': 0,
  '02471': 0,
  '02472': 0,
  '02474': 0,
  '02475': 0,
  '02476': 0,
  '02477': 0,
  '02478': 0,
  '02479': 0,
  '02481': 0,
  '02482': 0,
  '02492': 0,
  '02493': 0,
  '02494': 0,
  '02495': 0,
  '02532': 0,
  '02534': 0,
  '02535': 0,
  '02536': 0,
  '02537': 0,
  '02538': 0,
  '02539': 0,
  '02540': 0,
  '02541': 0,
  '02542': 0,
  '02543': 0,
  '02552': 0,
  '02553': 0,
  '02554': 0,
  '02556': 0,
  '02557': 0,
  '02558': 0,
  '02559': 0,
  '02561': 0,
  '02562': 0,
  '02563': 0,
  '02564': 0,
  '02565': 0,
  '02568': 0,
  '02571': 0,
  '02573': 0,
  '02574': 0,
  '02575': 0,
  '02576': 0,
  '02584': 0,
  '02601': 0,
  '02630': 0,
  '02631': 0,
  '02632': 0,
  '02633': 0,
  '02634': 0,
  '02635': 0,
  '02636': 0,
  '02637': 0,
  '02638': 0,
  '02639': 0,
  '02641': 0,
  '02642': 0,
  '02643': 0,
  '02644': 0,
  '02645': 0,
  '02646': 0,
  '02647': 0,
  '02648': 0,
  '02649': 0,
  '02650': 0,
  '02651': 0,
  '02652': 0,
  '02653': 0,
  '02655': 0,
  '02657': 0,
  '02659': 0,
  '02660': 0,
  '02661': 0,
  '02662': 0,
  '02663': 0,
  '02664': 0,
  '02666': 0,
  '02667': 0,
  '02668': 0,
  '02669': 0,
  '02670': 0,
  '02671': 0,
  '02672': 0,
  '02673': 0,
  '02675': 0,
  '02702': 0,
  '02703': 0,
  '02712': 0,
  '02713': 0,
  '02714': 0,
  '02715': 0,
  '02717': 0,
  '02718': 0,
  '02719': 0,
  '02720': 0,
  '02721': 0,
  '02722': 0,
  '02723': 0,
  '02724': 0,
  '02725': 0,
  '02726': 0,
  '02738': 0,
  '02739': 0,
  '02740': 0,
  '02741': 0,
  '02742': 0,
  '02743': 0,
  '02744': 0,
  '02745': 0,
  '02746': 0,
  '02747': 0,
  '02748': 0,
  '02760': 0,
  '02761': 0,
  '02762': 0,
  '02763': 0,
  '02764': 0,
  '02766': 0,
  '02767': 0,
  '02768': 0,
  '02769': 0,
  '02770': 0,
  '02771': 0,
  '02777': 0,
  '02779': 0,
  '02780': 0,
  '02783': 0,
  '02790': 0,
  '02791': 0,
  '02801': 0,
  '02802': 0,
  '02804': 0,
  '02806': 0,
  '02807': 0,
  '02808': 0,
  '02809': 0,
  '02812': 0,
  '02813': 0,
  '02814': 0,
  '02815': 0,
  '02816': 0,
  '02817': 0,
  '02818': 0,
  '02822': 0,
  '02823': 0,
  '02824': 0,
  '02825': 0,
  '02826': 0,
  '02827': 0,
  '02828': 0,
  '02829': 0,
  '02830': 0,
  '02831': 0,
  '02832': 0,
  '02833': 0,
  '02835': 0,
  '02836': 0,
  '02837': 0,
  '02838': 0,
  '02839': 0,
  '02840': 0,
  '02841': 0,
  '02842': 0,
  '02852': 0,
  '02854': 0,
  '02857': 0,
  '02858': 0,
  '02859': 0,
  '02860': 0,
  '02861': 0,
  '02862': 0,
  '02863': 0,
  '02864': 0,
  '02865': 0,
  '02871': 0,
  '02872': 0,
  '02873': 0,
  '02874': 0,
  '02875': 0,
  '02876': 0,
  '02877': 0,
  '02878': 0,
  '02879': 0,
  '02880': 0,
  '02881': 0,
  '02882': 0,
  '02883': 0,
  '02885': 0,
  '02886': 0,
  '02887': 0,
  '02888': 0,
  '02889': 0,
  '02891': 0,
  '02892': 0,
  '02893': 0,
  '02894': 0,
  '02895': 0,
  '02896': 0,
  '02898': 0,
  '02901': 0,
  '02902': 0,
  '02903': 0,
  '02904': 0,
  '02905': 0,
  '02906': 0,
  '02907': 0,
  '02908': 0,
  '02909': 0,
  '02910': 0,
  '02911': 0,
  '02912': 0,
  '02914': 0,
  '02915': 0,
  '02916': 0,
  '02917': 0,
  '02918': 0,
  '02919': 0,
  '02920': 0,
  '02921': 0,
  '02940': 0,
  '03031': 0,
  '03032': 0,
  '03033': 0,
  '03034': 0,
  '03036': 0,
  '03037': 0,
  '03038': 0,
  '03040': 0,
  '03041': 0,
  '03042': 0,
  '03043': 0,
  '03044': 0,
  '03045': 0,
  '03046': 0,
  '03047': 0,
  '03048': 0,
  '03049': 0,
  '03051': 0,
  '03052': 0,
  '03053': 0,
  '03054': 0,
  '03055': 0,
  '03057': 0,
  '03060': 0,
  '03061': 0,
  '03062': 0,
  '03063': 0,
  '03064': 0,
  '03070': 0,
  '03071': 0,
  '03073': 0,
  '03076': 0,
  '03077': 0,
  '03079': 0,
  '03082': 0,
  '03084': 0,
  '03086': 0,
  '03087': 0,
  '03101': 0,
  '03102': 0,
  '03103': 0,
  '03104': 0,
  '03105': 0,
  '03106': 0,
  '03107': 0,
  '03108': 0,
  '03109': 0,
  '03110': 0,
  '03111': 0,
  '03215': 0,
  '03216': 0,
  '03217': 0,
  '03218': 0,
  '03220': 0,
  '03221': 0,
  '03222': 0,
  '03223': 0,
  '03224': 0,
  '03225': 0,
  '03226': 0,
  '03227': 0,
  '03229': 0,
  '03230': 0,
  '03231': 0,
  '03233': 0,
  '03234': 0,
  '03235': 0,
  '03237': 0,
  '03238': 0,
  '03240': 0,
  '03241': 0,
  '03242': 0,
  '03243': 0,
  '03244': 0,
  '03245': 0,
  '03246': 0,
  '03247': 0,
  '03249': 0,
  '03251': 0,
  '03252': 0,
  '03253': 0,
  '03254': 0,
  '03255': 0,
  '03256': 0,
  '03257': 0,
  '03258': 0,
  '03259': 0,
  '03260': 0,
  '03261': 0,
  '03262': 0,
  '03263': 0,
  '03264': 0,
  '03266': 0,
  '03268': 0,
  '03269': 0,
  '03272': 0,
  '03273': 0,
  '03274': 0,
  '03275': 0,
  '03276': 0,
  '03278': 0,
  '03279': 0,
  '03280': 0,
  '03281': 0,
  '03282': 0,
  '03284': 0,
  '03285': 0,
  '03287': 0,
  '03289': 0,
  '03290': 0,
  '03291': 0,
  '03293': 0,
  '03298': 0,
  '03299': 0,
  '03301': 0,
  '03302': 0,
  '03303': 0,
  '03304': 0,
  '03305': 0,
  '03307': 0,
  '03431': 0,
  '03435': 0,
  '03440': 0,
  '03441': 0,
  '03442': 0,
  '03443': 0,
  '03444': 0,
  '03445': 0,
  '03446': 0,
  '03447': 0,
  '03448': 0,
  '03449': 0,
  '03450': 0,
  '03451': 0,
  '03452': 0,
  '03455': 0,
  '03456': 0,
  '03457': 0,
  '03458': 0,
  '03461': 0,
  '03462': 0,
  '03464': 0,
  '03465': 0,
  '03466': 0,
  '03467': 0,
  '03468': 0,
  '03469': 0,
  '03470': 0,
  '03561': 0,
  '03570': 0,
  '03574': 0,
  '03575': 0,
  '03576': 0,
  '03579': 0,
  '03580': 0,
  '03581': 0,
  '03582': 0,
  '03583': 0,
  '03584': 0,
  '03585': 0,
  '03586': 0,
  '03587': 0,
  '03588': 0,
  '03589': 0,
  '03590': 0,
  '03592': 0,
  '03593': 0,
  '03595': 0,
  '03597': 0,
  '03598': 0,
  '03601': 0,
  '03602': 0,
  '03603': 0,
  '03604': 0,
  '03605': 0,
  '03607': 0,
  '03608': 0,
  '03609': 0,
  '03740': 0,
  '03741': 0,
  '03743': 0,
  '03745': 0,
  '03746': 0,
  '03748': 0,
  '03749': 0,
  '03750': 0,
  '03751': 0,
  '03752': 0,
  '03753': 0,
  '03754': 0,
  '03755': 0,
  '03756': 0,
  '03765': 0,
  '03766': 0,
  '03768': 0,
  '03769': 0,
  '03770': 0,
  '03771': 0,
  '03773': 0,
  '03774': 0,
  '03777': 0,
  '03779': 0,
  '03780': 0,
  '03781': 0,
  '03782': 0,
  '03784': 0,
  '03785': 0,
  '03801': 0,
  '03802': 0,
  '03803': 0,
  '03804': 0,
  '03805': 0,
  '03809': 0,
  '03810': 0,
  '03811': 0,
  '03812': 0,
  '03813': 0,
  '03814': 0,
  '03815': 0,
  '03816': 0,
  '03817': 0,
  '03818': 0,
  '03819': 0,
  '03820': 0,
  '03821': 0,
  '03822': 0,
  '03823': 0,
  '03824': 0,
  '03825': 0,
  '03826': 0,
  '03827': 0,
  '03830': 0,
  '03832': 0,
  '03833': 0,
  '03835': 0,
  '03836': 0,
  '03837': 0,
  '03838': 0,
  '03839': 0,
  '03840': 0,
  '03841': 0,
  '03842': 0,
  '03843': 0,
  '03844': 0,
  '03845': 0,
  '03846': 0,
  '03847': 0,
  '03848': 0,
  '03849': 0,
  '03850': 0,
  '03851': 0,
  '03852': 0,
  '03853': 0,
  '03854': 0,
  '03855': 0,
  '03856': 0,
  '03857': 0,
  '03858': 0,
  '03859': 0,
  '03860': 0,
  '03861': 0,
  '03862': 0,
  '03864': 0,
  '03865': 0,
  '03866': 0,
  '03867': 0,
  '03868': 0,
  '03869': 0,
  '03870': 0,
  '03871': 0,
  '03872': 0,
  '03873': 0,
  '03874': 0,
  '03875': 0,
  '03878': 0,
  '03882': 0,
  '03883': 0,
  '03884': 0,
  '03885': 0,
  '03886': 0,
  '03887': 0,
  '03890': 0,
  '03894': 0,
  '03896': 0,
  '03897': 0,
  '03901': 0,
  '03902': 0,
  '03903': 0,
  '03904': 0,
  '03905': 0,
  '03906': 0,
  '03907': 0,
  '03908': 0,
  '03909': 0,
  '03910': 0,
  '03911': 0,
  '04001': 0,
  '04002': 0,
  '04003': 0,
  '04004': 0,
  '04005': 0,
  '04006': 0,
  '04007': 0,
  '04008': 0,
  '04009': 0,
  '04010': 0,
  '04011': 0,
  '04013': 0,
  '04014': 0,
  '04015': 0,
  '04016': 0,
  '04017': 0,
  '04019': 0,
  '04020': 0,
  '04021': 0,
  '04022': 0,
  '04024': 0,
  '04027': 0,
  '04028': 0,
  '04029': 0,
  '04030': 0,
  '04032': 0,
  '04033': 0,
  '04034': 0,
  '04037': 0,
  '04038': 0,
  '04039': 0,
  '04040': 0,
  '04041': 0,
  '04042': 0,
  '04043': 0,
  '04046': 0,
  '04047': 0,
  '04048': 0,
  '04049': 0,
  '04050': 0,
  '04051': 0,
  '04053': 0,
  '04054': 0,
  '04055': 0,
  '04056': 0,
  '04057': 0,
  '04061': 0,
  '04062': 0,
  '04063': 0,
  '04064': 0,
  '04066': 0,
  '04068': 0,
  '04069': 0,
  '04070': 0,
  '04071': 0,
  '04072': 0,
  '04073': 0,
  '04074': 0,
  '04075': 0,
  '04076': 0,
  '04077': 0,
  '04078': 0,
  '04079': 0,
  '04082': 0,
  '04083': 0,
  '04084': 0,
  '04085': 0,
  '04086': 0,
  '04087': 0,
  '04088': 0,
  '04090': 0,
  '04091': 0,
  '04092': 0,
  '04093': 0,
  '04094': 0,
  '04095': 0,
  '04096': 0,
  '04097': 0,
  '04098': 0,
  '04101': 0,
  '04102': 0,
  '04103': 0,
  '04104': 0,
  '04105': 0,
  '04106': 0,
  '04107': 0,
  '04108': 0,
  '04109': 0,
  '04110': 0,
  '04112': 0,
  '04116': 0,
  '04122': 0,
  '04123': 0,
  '04124': 0,
  '04210': 0,
  '04211': 0,
  '04212': 0,
  '04216': 0,
  '04217': 0,
  '04219': 0,
  '04220': 0,
  '04221': 0,
  '04222': 0,
  '04223': 0,
  '04224': 0,
  '04225': 0,
  '04226': 0,
  '04227': 0,
  '04228': 0,
  '04230': 0,
  '04231': 0,
  '04234': 0,
  '04236': 0,
  '04237': 0,
  '04238': 0,
  '04239': 0,
  '04240': 0,
  '04241': 0,
  '04243': 0,
  '04250': 0,
  '04252': 0,
  '04253': 0,
  '04254': 0,
  '04255': 0,
  '04256': 0,
  '04257': 0,
  '04258': 0,
  '04259': 0,
  '04260': 0,
  '04261': 0,
  '04262': 0,
  '04263': 0,
  '04265': 0,
  '04266': 0,
  '04267': 0,
  '04268': 0,
  '04270': 0,
  '04271': 0,
  '04274': 0,
  '04275': 0,
  '04276': 0,
  '04278': 0,
  '04280': 0,
  '04281': 0,
  '04282': 0,
  '04283': 0,
  '04284': 0,
  '04285': 0,
  '04286': 0,
  '04287': 0,
  '04288': 0,
  '04289': 0,
  '04290': 0,
  '04291': 0,
  '04292': 0,
  '04294': 0,
  '04330': 0,
  '04332': 0,
  '04333': 0,
  '04336': 0,
  '04338': 0,
  '04341': 0,
  '04342': 0,
  '04343': 0,
  '04344': 0,
  '04345': 0,
  '04346': 0,
  '04347': 0,
  '04348': 0,
  '04349': 0,
  '04350': 0,
  '04351': 0,
  '04352': 0,
  '04353': 0,
  '04354': 0,
  '04355': 0,
  '04357': 0,
  '04358': 0,
  '04359': 0,
  '04360': 0,
  '04363': 0,
  '04364': 0,
  '04401': 0,
  '04402': 0,
  '04406': 0,
  '04408': 0,
  '04410': 0,
  '04411': 0,
  '04412': 0,
  '04413': 0,
  '04414': 0,
  '04415': 0,
  '04416': 0,
  '04417': 0,
  '04418': 0,
  '04419': 0,
  '04420': 0,
  '04421': 0,
  '04422': 0,
  '04423': 0,
  '04424': 0,
  '04426': 0,
  '04427': 0,
  '04428': 0,
  '04429': 0,
  '04430': 0,
  '04431': 0,
  '04434': 0,
  '04435': 0,
  '04438': 0,
  '04441': 0,
  '04442': 0,
  '04443': 0,
  '04444': 0,
  '04448': 0,
  '04449': 0,
  '04450': 0,
  '04451': 0,
  '04453': 0,
  '04454': 0,
  '04455': 0,
  '04456': 0,
  '04457': 0,
  '04459': 0,
  '04460': 0,
  '04461': 0,
  '04462': 0,
  '04463': 0,
  '04464': 0,
  '04467': 0,
  '04468': 0,
  '04469': 0,
  '04471': 0,
  '04472': 0,
  '04473': 0,
  '04474': 0,
  '04475': 0,
  '04476': 0,
  '04478': 0,
  '04479': 0,
  '04481': 0,
  '04485': 0,
  '04487': 0,
  '04488': 0,
  '04489': 0,
  '04490': 0,
  '04491': 0,
  '04492': 0,
  '04493': 0,
  '04495': 0,
  '04496': 0,
  '04497': 0,
  '04530': 0,
  '04535': 0,
  '04536': 0,
  '04537': 0,
  '04538': 0,
  '04539': 0,
  '04541': 0,
  '04543': 0,
  '04544': 0,
  '04547': 0,
  '04548': 0,
  '04549': 0,
  '04551': 0,
  '04553': 0,
  '04554': 0,
  '04555': 0,
  '04556': 0,
  '04558': 0,
  '04562': 0,
  '04563': 0,
  '04564': 0,
  '04565': 0,
  '04567': 0,
  '04568': 0,
  '04570': 0,
  '04571': 0,
  '04572': 0,
  '04573': 0,
  '04574': 0,
  '04575': 0,
  '04576': 0,
  '04578': 0,
  '04579': 0,
  '04605': 0,
  '04606': 0,
  '04607': 0,
  '04609': 0,
  '04611': 0,
  '04612': 0,
  '04613': 0,
  '04614': 0,
  '04615': 0,
  '04616': 0,
  '04617': 0,
  '04619': 0,
  '04622': 0,
  '04623': 0,
  '04624': 0,
  '04625': 0,
  '04626': 0,
  '04627': 0,
  '04628': 0,
  '04629': 0,
  '04630': 0,
  '04631': 0,
  '04634': 0,
  '04635': 0,
  '04637': 0,
  '04640': 0,
  '04642': 0,
  '04643': 0,
  '04644': 0,
  '04645': 0,
  '04646': 0,
  '04648': 0,
  '04649': 0,
  '04650': 0,
  '04652': 0,
  '04653': 0,
  '04654': 0,
  '04655': 0,
  '04656': 0,
  '04657': 0,
  '04658': 0,
  '04660': 0,
  '04662': 0,
  '04664': 0,
  '04666': 0,
  '04667': 0,
  '04668': 0,
  '04669': 0,
  '04671': 0,
  '04672': 0,
  '04673': 0,
  '04674': 0,
  '04675': 0,
  '04676': 0,
  '04677': 0,
  '04679': 0,
  '04680': 0,
  '04681': 0,
  '04683': 0,
  '04684': 0,
  '04685': 0,
  '04686': 0,
  '04691': 0,
  '04693': 0,
  '04694': 0,
  '04730': 0,
  '04732': 0,
  '04733': 0,
  '04734': 0,
  '04735': 0,
  '04736': 0,
  '04737': 0,
  '04738': 0,
  '04739': 0,
  '04740': 0,
  '04741': 0,
  '04742': 0,
  '04743': 0,
  '04744': 0,
  '04745': 0,
  '04746': 0,
  '04747': 0,
  '04750': 0,
  '04751': 0,
  '04756': 0,
  '04757': 0,
  '04758': 0,
  '04759': 0,
  '04760': 0,
  '04761': 0,
  '04762': 0,
  '04763': 0,
  '04764': 0,
  '04765': 0,
  '04766': 0,
  '04768': 0,
  '04769': 0,
  '04770': 0,
  '04772': 0,
  '04773': 0,
  '04774': 0,
  '04775': 0,
  '04776': 0,
  '04777': 0,
  '04779': 0,
  '04780': 0,
  '04781': 0,
  '04783': 0,
  '04785': 0,
  '04786': 0,
  '04787': 0,
  '04788': 0,
  '04841': 0,
  '04843': 0,
  '04846': 0,
  '04847': 0,
  '04848': 0,
  '04849': 0,
  '04850': 0,
  '04851': 0,
  '04852': 0,
  '04853': 0,
  '04854': 0,
  '04855': 0,
  '04856': 0,
  '04857': 0,
  '04858': 0,
  '04859': 0,
  '04860': 0,
  '04861': 0,
  '04862': 0,
  '04863': 0,
  '04864': 0,
  '04865': 0,
  '04901': 0,
  '04903': 0,
  '04910': 0,
  '04911': 0,
  '04912': 0,
  '04915': 0,
  '04917': 0,
  '04918': 0,
  '04920': 0,
  '04921': 0,
  '04922': 0,
  '04923': 0,
  '04924': 0,
  '04925': 0,
  '04926': 0,
  '04927': 0,
  '04928': 0,
  '04929': 0,
  '04930': 0,
  '04932': 0,
  '04933': 0,
  '04935': 0,
  '04936': 0,
  '04937': 0,
  '04938': 0,
  '04939': 0,
  '04940': 0,
  '04941': 0,
  '04942': 0,
  '04943': 0,
  '04944': 0,
  '04945': 0,
  '04947': 0,
  '04949': 0,
  '04950': 0,
  '04951': 0,
  '04952': 0,
  '04953': 0,
  '04954': 0,
  '04955': 0,
  '04956': 0,
  '04957': 0,
  '04958': 0,
  '04961': 0,
  '04962': 0,
  '04963': 0,
  '04964': 0,
  '04965': 0,
  '04966': 0,
  '04967': 0,
  '04969': 0,
  '04970': 0,
  '04971': 0,
  '04972': 0,
  '04973': 0,
  '04974': 0,
  '04975': 0,
  '04976': 0,
  '04978': 0,
  '04979': 0,
  '04981': 0,
  '04982': 0,
  '04983': 0,
  '04984': 0,
  '04985': 0,
  '04986': 0,
  '04987': 0,
  '04988': 0,
  '04989': 0,
  '04992': 0,
  '05001': 0,
  '05009': 0,
  '05030': 0,
  '05031': 0,
  '05032': 0,
  '05033': 0,
  '05034': 0,
  '05035': 0,
  '05036': 0,
  '05037': 0,
  '05038': 0,
  '05039': 0,
  '05040': 0,
  '05041': 0,
  '05042': 0,
  '05043': 0,
  '05045': 0,
  '05046': 0,
  '05047': 0,
  '05048': 0,
  '05049': 0,
  '05050': 0,
  '05051': 0,
  '05052': 0,
  '05053': 0,
  '05054': 0,
  '05055': 0,
  '05056': 0,
  '05058': 0,
  '05059': 0,
  '05060': 0,
  '05061': 0,
  '05062': 0,
  '05065': 0,
  '05067': 0,
  '05068': 0,
  '05069': 0,
  '05070': 0,
  '05071': 0,
  '05072': 0,
  '05073': 0,
  '05074': 0,
  '05075': 0,
  '05076': 0,
  '05077': 0,
  '05079': 0,
  '05081': 0,
  '05083': 0,
  '05084': 0,
  '05085': 0,
  '05086': 0,
  '05088': 0,
  '05089': 0,
  '05091': 0,
  '05101': 0,
  '05141': 0,
  '05142': 0,
  '05143': 0,
  '05144': 0,
  '05146': 0,
  '05148': 0,
  '05149': 0,
  '05150': 0,
  '05151': 0,
  '05152': 0,
  '05153': 0,
  '05154': 0,
  '05155': 0,
  '05156': 0,
  '05158': 0,
  '05159': 0,
  '05161': 0,
  '05201': 0,
  '05250': 0,
  '05251': 0,
  '05252': 0,
  '05253': 0,
  '05254': 0,
  '05255': 0,
  '05257': 0,
  '05260': 0,
  '05261': 0,
  '05262': 0,
  '05301': 0,
  '05302': 0,
  '05303': 0,
  '05304': 0,
  '05340': 0,
  '05341': 0,
  '05342': 0,
  '05343': 0,
  '05344': 0,
  '05345': 0,
  '05346': 0,
  '05350': 0,
  '05351': 0,
  '05352': 0,
  '05353': 0,
  '05354': 0,
  '05355': 0,
  '05356': 0,
  '05357': 0,
  '05358': 0,
  '05359': 0,
  '05360': 0,
  '05361': 0,
  '05362': 0,
  '05363': 0,
  '05401': 0,
  '05402': 0,
  '05403': 0,
  '05404': 0,
  '05405': 0,
  '05406': 0,
  '05407': 0,
  '05408': 0,
  '05439': 0,
  '05440': 0,
  '05441': 0,
  '05442': 0,
  '05443': 0,
  '05444': 0,
  '05445': 0,
  '05446': 0,
  '05447': 0,
  '05448': 0,
  '05449': 0,
  '05450': 0,
  '05451': 0,
  '05452': 0,
  '05453': 0,
  '05454': 0,
  '05455': 0,
  '05456': 0,
  '05457': 0,
  '05458': 0,
  '05459': 0,
  '05460': 0,
  '05461': 0,
  '05462': 0,
  '05463': 0,
  '05464': 0,
  '05465': 0,
  '05466': 0,
  '05468': 0,
  '05469': 0,
  '05470': 0,
  '05471': 0,
  '05472': 0,
  '05473': 0,
  '05474': 0,
  '05476': 0,
  '05477': 0,
  '05478': 0,
  '05479': 0,
  '05481': 0,
  '05482': 0,
  '05483': 0,
  '05485': 0,
  '05486': 0,
  '05487': 0,
  '05488': 0,
  '05489': 0,
  '05490': 0,
  '05491': 0,
  '05492': 0,
  '05494': 0,
  '05495': 0,
  '05501': 0,
  '05544': 0,
  '05601': 0,
  '05602': 0,
  '05603': 0,
  '05604': 0,
  '05609': 0,
  '05620': 0,
  '05633': 0,
  '05640': 0,
  '05641': 0,
  '05647': 0,
  '05648': 0,
  '05649': 0,
  '05650': 0,
  '05651': 0,
  '05652': 0,
  '05653': 0,
  '05654': 0,
  '05655': 0,
  '05656': 0,
  '05657': 0,
  '05658': 0,
  '05660': 0,
  '05661': 0,
  '05662': 0,
  '05663': 0,
  '05664': 0,
  '05665': 0,
  '05666': 0,
  '05667': 0,
  '05669': 0,
  '05670': 0,
  '05671': 0,
  '05672': 0,
  '05674': 0,
  '05675': 0,
  '05676': 0,
  '05677': 0,
  '05678': 0,
  '05679': 0,
  '05680': 0,
  '05681': 0,
  '05682': 0,
  '05701': 0,
  '05702': 0,
  '05730': 0,
  '05731': 0,
  '05732': 0,
  '05733': 0,
  '05734': 0,
  '05735': 0,
  '05736': 0,
  '05737': 0,
  '05738': 0,
  '05739': 0,
  '05740': 0,
  '05741': 0,
  '05742': 0,
  '05743': 0,
  '05744': 0,
  '05745': 0,
  '05746': 0,
  '05747': 0,
  '05748': 0,
  '05750': 0,
  '05751': 0,
  '05753': 0,
  '05757': 0,
  '05758': 0,
  '05759': 0,
  '05760': 0,
  '05761': 0,
  '05762': 0,
  '05763': 0,
  '05764': 0,
  '05765': 0,
  '05766': 0,
  '05767': 0,
  '05768': 0,
  '05769': 0,
  '05770': 0,
  '05772': 0,
  '05773': 0,
  '05774': 0,
  '05775': 0,
  '05776': 0,
  '05777': 0,
  '05778': 0,
  '05819': 0,
  '05820': 0,
  '05821': 0,
  '05822': 0,
  '05823': 0,
  '05824': 0,
  '05825': 0,
  '05826': 0,
  '05827': 0,
  '05828': 0,
  '05829': 0,
  '05830': 0,
  '05832': 0,
  '05833': 0,
  '05836': 0,
  '05837': 0,
  '05838': 0,
  '05839': 0,
  '05840': 0,
  '05841': 0,
  '05842': 0,
  '05843': 0,
  '05845': 0,
  '05846': 0,
  '05847': 0,
  '05848': 0,
  '05849': 0,
  '05850': 0,
  '05851': 0,
  '05853': 0,
  '05855': 0,
  '05857': 0,
  '05858': 0,
  '05859': 0,
  '05860': 0,
  '05861': 0,
  '05862': 0,
  '05863': 0,
  '05866': 0,
  '05867': 0,
  '05868': 0,
  '05871': 0,
  '05872': 0,
  '05873': 0,
  '05874': 0,
  '05875': 0,
  '05901': 0,
  '05902': 0,
  '05903': 0,
  '05904': 0,
  '05905': 0,
  '05906': 0,
  '05907': 0,
  '06001': 0,
  '06002': 0,
  '06006': 0,
  '06010': 0,
  '06011': 0,
  '06013': 0,
  '06016': 0,
  '06018': 0,
  '06019': 0,
  '06020': 0,
  '06021': 0,
  '06022': 0,
  '06023': 0,
  '06024': 0,
  '06025': 0,
  '06026': 0,
  '06027': 0,
  '06028': 0,
  '06029': 0,
  '06030': 0,
  '06031': 0,
  '06032': 0,
  '06033': 0,
  '06034': 0,
  '06035': 0,
  '06037': 0,
  '06039': 0,
  '06040': 0,
  '06041': 0,
  '06042': 0,
  '06043': 0,
  '06045': 0,
  '06050': 0,
  '06051': 0,
  '06052': 0,
  '06053': 0,
  '06057': 0,
  '06058': 0,
  '06059': 0,
  '06060': 0,
  '06061': 0,
  '06062': 0,
  '06063': 0,
  '06064': 0,
  '06065': 0,
  '06066': 0,
  '06067': 0,
  '06068': 0,
  '06069': 0,
  '06070': 0,
  '06071': 0,
  '06072': 0,
  '06073': 0,
  '06074': 0,
  '06075': 0,
  '06076': 0,
  '06077': 0,
  '06078': 0,
  '06079': 0,
  '06080': 0,
  '06081': 0,
  '06082': 0,
  '06083': 0,
  '06084': 0,
  '06085': 0,
  '06087': 0,
  '06088': 0,
  '06089': 0,
  '06090': 0,
  '06091': 0,
  '06092': 0,
  '06093': 0,
  '06094': 0,
  '06095': 0,
  '06096': 0,
  '06098': 0,
  '06101': 0,
  '06102': 0,
  '06103': 0,
  '06104': 0,
  '06105': 0,
  '06106': 0,
  '06107': 0,
  '06108': 0,
  '06109': 0,
  '06110': 0,
  '06111': 0,
  '06112': 0,
  '06114': 0,
  '06115': 0,
  '06117': 0,
  '06118': 0,
  '06119': 0,
  '06120': 0,
  '06123': 0,
  '06126': 0,
  '06127': 0,
  '06128': 0,
  '06129': 0,
  '06131': 0,
  '06132': 0,
  '06133': 0,
  '06134': 0,
  '06137': 0,
  '06138': 0,
  '06140': 0,
  '06141': 0,
  '06142': 0,
  '06143': 0,
  '06144': 0,
  '06145': 0,
  '06146': 0,
  '06147': 0,
  '06150': 0,
  '06151': 0,
  '06152': 0,
  '06153': 0,
  '06154': 0,
  '06155': 0,
  '06156': 0,
  '06160': 0,
  '06161': 0,
  '06167': 0,
  '06176': 0,
  '06180': 0,
  '06183': 0,
  '06199': 0,
  '06226': 0,
  '06230': 0,
  '06231': 0,
  '06232': 0,
  '06233': 0,
  '06234': 0,
  '06235': 0,
  '06237': 0,
  '06238': 0,
  '06239': 0,
  '06241': 0,
  '06242': 0,
  '06243': 0,
  '06244': 0,
  '06245': 0,
  '06246': 0,
  '06247': 0,
  '06248': 0,
  '06249': 0,
  '06250': 0,
  '06251': 0,
  '06254': 0,
  '06255': 0,
  '06256': 0,
  '06258': 0,
  '06259': 0,
  '06260': 0,
  '06262': 0,
  '06263': 0,
  '06264': 0,
  '06265': 0,
  '06266': 0,
  '06267': 0,
  '06268': 0,
  '06269': 0,
  '06277': 0,
  '06278': 0,
  '06279': 0,
  '06280': 0,
  '06281': 0,
  '06282': 0,
  '06320': 0,
  '06330': 0,
  '06331': 0,
  '06332': 0,
  '06333': 0,
  '06334': 0,
  '06335': 0,
  '06336': 0,
  '06338': 0,
  '06339': 0,
  '06340': 0,
  '06349': 0,
  '06350': 0,
  '06351': 0,
  '06353': 0,
  '06354': 0,
  '06355': 0,
  '06357': 0,
  '06359': 0,
  '06360': 0,
  '06365': 0,
  '06370': 0,
  '06371': 0,
  '06372': 0,
  '06373': 0,
  '06374': 0,
  '06375': 0,
  '06376': 0,
  '06377': 0,
  '06378': 0,
  '06379': 0,
  '06380': 0,
  '06382': 0,
  '06383': 0,
  '06384': 0,
  '06385': 0,
  '06386': 0,
  '06387': 0,
  '06388': 0,
  '06389': 0,
  '06390': 0,
  '06401': 0,
  '06403': 0,
  '06404': 0,
  '06405': 0,
  '06408': 0,
  '06409': 0,
  '06410': 0,
  '06411': 0,
  '06412': 0,
  '06413': 0,
  '06414': 0,
  '06415': 0,
  '06416': 0,
  '06417': 0,
  '06418': 0,
  '06419': 0,
  '06420': 0,
  '06422': 0,
  '06423': 0,
  '06424': 0,
  '06426': 0,
  '06430': 0,
  '06431': 0,
  '06432': 0,
  '06436': 0,
  '06437': 0,
  '06438': 0,
  '06439': 0,
  '06440': 0,
  '06441': 0,
  '06442': 0,
  '06443': 0,
  '06444': 0,
  '06447': 0,
  '06450': 0,
  '06451': 0,
  '06454': 0,
  '06455': 0,
  '06456': 0,
  '06457': 0,
  '06459': 0,
  '06460': 0,
  '06461': 0,
  '06467': 0,
  '06468': 0,
  '06469': 0,
  '06470': 0,
  '06471': 0,
  '06472': 0,
  '06473': 0,
  '06474': 0,
  '06475': 0,
  '06477': 0,
  '06478': 0,
  '06479': 0,
  '06480': 0,
  '06481': 0,
  '06482': 0,
  '06483': 0,
  '06484': 0,
  '06487': 0,
  '06488': 0,
  '06489': 0,
  '06490': 0,
  '06491': 0,
  '06492': 0,
  '06493': 0,
  '06494': 0,
  '06495': 0,
  '06497': 0,
  '06498': 0,
  '06501': 0,
  '06502': 0,
  '06503': 0,
  '06504': 0,
  '06505': 0,
  '06506': 0,
  '06507': 0,
  '06508': 0,
  '06509': 0,
  '06510': 0,
  '06511': 0,
  '06512': 0,
  '06513': 0,
  '06514': 0,
  '06515': 0,
  '06516': 0,
  '06517': 0,
  '06518': 0,
  '06519': 0,
  '06520': 0,
  '06521': 0,
  '06524': 0,
  '06525': 0,
  '06530': 0,
  '06531': 0,
  '06532': 0,
  '06533': 0,
  '06534': 0,
  '06535': 0,
  '06536': 0,
  '06537': 0,
  '06538': 0,
  '06540': 0,
  '06601': 0,
  '06602': 0,
  '06604': 0,
  '06605': 0,
  '06606': 0,
  '06607': 0,
  '06608': 0,
  '06610': 0,
  '06611': 0,
  '06612': 0,
  '06614': 0,
  '06615': 0,
  '06650': 0,
  '06673': 0,
  '06699': 0,
  '06701': 0,
  '06702': 0,
  '06703': 0,
  '06704': 0,
  '06705': 0,
  '06706': 0,
  '06708': 0,
  '06710': 0,
  '06712': 0,
  '06716': 0,
  '06720': 0,
  '06721': 0,
  '06722': 0,
  '06723': 0,
  '06724': 0,
  '06725': 0,
  '06726': 0,
  '06749': 0,
  '06750': 0,
  '06751': 0,
  '06752': 0,
  '06753': 0,
  '06754': 0,
  '06755': 0,
  '06756': 0,
  '06757': 0,
  '06758': 0,
  '06759': 0,
  '06762': 0,
  '06763': 0,
  '06770': 0,
  '06776': 0,
  '06777': 0,
  '06778': 0,
  '06779': 0,
  '06781': 0,
  '06782': 0,
  '06783': 0,
  '06784': 0,
  '06785': 0,
  '06786': 0,
  '06787': 0,
  '06790': 0,
  '06791': 0,
  '06792': 0,
  '06793': 0,
  '06794': 0,
  '06795': 0,
  '06796': 0,
  '06798': 0,
  '06801': 0,
  '06804': 0,
  '06807': 0,
  '06810': 0,
  '06811': 0,
  '06812': 0,
  '06813': 0,
  '06814': 0,
  '06816': 0,
  '06817': 0,
  '06820': 0,
  '06824': 0,
  '06825': 0,
  '06828': 0,
  '06829': 0,
  '06830': 0,
  '06831': 0,
  '06832': 0,
  '06836': 0,
  '06838': 0,
  '06840': 0,
  '06842': 0,
  '06850': 0,
  '06851': 0,
  '06852': 0,
  '06853': 0,
  '06854': 0,
  '06855': 0,
  '06856': 0,
  '06857': 0,
  '06858': 0,
  '06859': 0,
  '06860': 0,
  '06870': 0,
  '06875': 0,
  '06876': 0,
  '06877': 0,
  '06878': 0,
  '06879': 0,
  '06880': 0,
  '06881': 0,
  '06883': 0,
  '06888': 0,
  '06889': 0,
  '06890': 0,
  '06896': 0,
  '06897': 0,
  '06901': 0,
  '06902': 0,
  '06903': 0,
  '06904': 0,
  '06905': 0,
  '06906': 0,
  '06907': 0,
  '06910': 0,
  '06911': 0,
  '06912': 0,
  '06913': 0,
  '06914': 0,
  '06920': 0,
  '06921': 0,
  '06922': 0,
  '06925': 0,
  '06926': 0,
  '06927': 0,
  '06928': 0,
  '07001': 0,
  '07002': 0,
  '07003': 0,
  '07004': 0,
  '07005': 0,
  '07006': 0,
  '07007': 0,
  '07008': 0,
  '07009': 0,
  '07010': 0,
  '07011': 0,
  '07012': 0,
  '07013': 0,
  '07014': 0,
  '07015': 0,
  '07016': 0,
  '07017': 0,
  '07018': 0,
  '07019': 0,
  '07020': 0,
  '07021': 0,
  '07022': 0,
  '07023': 0,
  '07024': 0,
  '07026': 0,
  '07027': 0,
  '07028': 0,
  '07029': 0,
  '07030': 0,
  '07031': 0,
  '07032': 0,
  '07033': 0,
  '07034': 0,
  '07035': 0,
  '07036': 0,
  '07039': 0,
  '07040': 0,
  '07041': 0,
  '07042': 0,
  '07043': 0,
  '07044': 0,
  '07045': 0,
  '07046': 0,
  '07047': 0,
  '07050': 0,
  '07051': 0,
  '07052': 0,
  '07054': 0,
  '07055': 0,
  '07057': 0,
  '07058': 0,
  '07059': 0,
  '07060': 0,
  '07061': 0,
  '07062': 0,
  '07063': 0,
  '07064': 0,
  '07065': 0,
  '07066': 0,
  '07067': 0,
  '07068': 0,
  '07069': 0,
  '07070': 0,
  '07071': 0,
  '07072': 0,
  '07073': 0,
  '07074': 0,
  '07075': 0,
  '07076': 0,
  '07077': 0,
  '07078': 0,
  '07079': 0,
  '07080': 0,
  '07081': 0,
  '07082': 0,
  '07083': 0,
  '07086': 0,
  '07087': 0,
  '07088': 0,
  '07090': 0,
  '07091': 0,
  '07092': 0,
  '07093': 0,
  '07094': 0,
  '07095': 0,
  '07096': 0,
  '07097': 0,
  '07099': 0,
  '07101': 0,
  '07102': 0,
  '07103': 0,
  '07104': 0,
  '07105': 0,
  '07106': 0,
  '07107': 0,
  '07108': 0,
  '07109': 0,
  '07110': 0,
  '07111': 0,
  '07112': 0,
  '07114': 0,
  '07175': 0,
  '07182': 0,
  '07184': 0,
  '07188': 0,
  '07189': 0,
  '07191': 0,
  '07192': 0,
  '07193': 0,
  '07194': 0,
  '07195': 0,
  '07197': 0,
  '07198': 0,
  '07199': 0,
  '07201': 0,
  '07202': 0,
  '07203': 0,
  '07204': 0,
  '07205': 0,
  '07206': 0,
  '07207': 0,
  '07208': 0,
  '07302': 0,
  '07303': 0,
  '07304': 0,
  '07305': 0,
  '07306': 0,
  '07307': 0,
  '07308': 0,
  '07309': 0,
  '07310': 0,
  '07311': 0,
  '07390': 0,
  '07395': 0,
  '07399': 0,
  '07401': 0,
  '07403': 0,
  '07405': 0,
  '07407': 0,
  '07410': 0,
  '07416': 0,
  '07417': 0,
  '07418': 0,
  '07419': 0,
  '07420': 0,
  '07421': 0,
  '07422': 0,
  '07423': 0,
  '07424': 0,
  '07428': 0,
  '07430': 0,
  '07432': 0,
  '07435': 0,
  '07436': 0,
  '07438': 0,
  '07439': 0,
  '07440': 0,
  '07442': 0,
  '07444': 0,
  '07446': 0,
  '07450': 0,
  '07451': 0,
  '07452': 0,
  '07456': 0,
  '07457': 0,
  '07458': 0,
  '07460': 0,
  '07461': 0,
  '07462': 0,
  '07463': 0,
  '07465': 0,
  '07470': 0,
  '07474': 0,
  '07477': 0,
  '07480': 0,
  '07481': 0,
  '07495': 0,
  '07498': 0,
  '07501': 0,
  '07502': 0,
  '07503': 0,
  '07504': 0,
  '07505': 0,
  '07506': 0,
  '07507': 0,
  '07508': 0,
  '07509': 0,
  '07510': 0,
  '07511': 0,
  '07512': 0,
  '07513': 0,
  '07514': 0,
  '07522': 0,
  '07524': 0,
  '07533': 0,
  '07538': 0,
  '07543': 0,
  '07544': 0,
  '07601': 0,
  '07602': 0,
  '07603': 0,
  '07604': 0,
  '07605': 0,
  '07606': 0,
  '07607': 0,
  '07608': 0,
  '07620': 0,
  '07621': 0,
  '07624': 0,
  '07626': 0,
  '07627': 0,
  '07628': 0,
  '07630': 0,
  '07631': 0,
  '07632': 0,
  '07640': 0,
  '07641': 0,
  '07642': 0,
  '07643': 0,
  '07644': 0,
  '07645': 0,
  '07646': 0,
  '07647': 0,
  '07648': 0,
  '07649': 0,
  '07650': 0,
  '07652': 0,
  '07653': 0,
  '07656': 0,
  '07657': 0,
  '07660': 0,
  '07661': 0,
  '07662': 0,
  '07663': 0,
  '07666': 0,
  '07670': 0,
  '07675': 0,
  '07676': 0,
  '07677': 0,
  '07699': 0,
  '07701': 0,
  '07702': 0,
  '07703': 0,
  '07704': 0,
  '07709': 0,
  '07710': 0,
  '07711': 0,
  '07712': 0,
  '07715': 0,
  '07716': 0,
  '07717': 0,
  '07718': 0,
  '07719': 0,
  '07720': 0,
  '07721': 0,
  '07722': 0,
  '07723': 0,
  '07724': 0,
  '07726': 0,
  '07727': 0,
  '07728': 0,
  '07730': 0,
  '07731': 0,
  '07732': 0,
  '07733': 0,
  '07734': 0,
  '07735': 0,
  '07737': 0,
  '07738': 0,
  '07739': 0,
  '07740': 0,
  '07746': 0,
  '07747': 0,
  '07748': 0,
  '07750': 0,
  '07751': 0,
  '07752': 0,
  '07753': 0,
  '07754': 0,
  '07755': 0,
  '07756': 0,
  '07757': 0,
  '07758': 0,
  '07760': 0,
  '07762': 0,
  '07763': 0,
  '07764': 0,
  '07765': 0,
  '07777': 0,
  '07799': 0,
  '07801': 0,
  '07802': 0,
  '07803': 0,
  '07806': 0,
  '07820': 0,
  '07821': 0,
  '07822': 0,
  '07823': 0,
  '07825': 0,
  '07826': 0,
  '07827': 0,
  '07828': 0,
  '07829': 0,
  '07830': 0,
  '07831': 0,
  '07832': 0,
  '07833': 0,
  '07834': 0,
  '07836': 0,
  '07837': 0,
  '07838': 0,
  '07839': 0,
  '07840': 0,
  '07842': 0,
  '07843': 0,
  '07844': 0,
  '07845': 0,
  '07846': 0,
  '07847': 0,
  '07848': 0,
  '07849': 0,
  '07850': 0,
  '07851': 0,
  '07852': 0,
  '07853': 0,
  '07855': 0,
  '07856': 0,
  '07857': 0,
  '07860': 0,
  '07863': 0,
  '07865': 0,
  '07866': 0,
  '07869': 0,
  '07870': 0,
  '07871': 0,
  '07874': 0,
  '07875': 0,
  '07876': 0,
  '07877': 0,
  '07878': 0,
  '07879': 0,
  '07880': 0,
  '07881': 0,
  '07882': 0,
  '07885': 0,
  '07890': 0,
  '07901': 0,
  '07902': 0,
  '07920': 0,
  '07921': 0,
  '07922': 0,
  '07924': 0,
  '07926': 0,
  '07927': 0,
  '07928': 0,
  '07930': 0,
  '07931': 0,
  '07932': 0,
  '07933': 0,
  '07934': 0,
  '07935': 0,
  '07936': 0,
  '07938': 0,
  '07939': 0,
  '07940': 0,
  '07945': 0,
  '07946': 0,
  '07950': 0,
  '07960': 0,
  '07961': 0,
  '07962': 0,
  '07963': 0,
  '07970': 0,
  '07974': 0,
  '07976': 0,
  '07977': 0,
  '07978': 0,
  '07979': 0,
  '07980': 0,
  '07981': 0,
  '07983': 0,
  '07999': 0,
  '08001': 0,
  '08002': 0,
  '08003': 0,
  '08004': 0,
  '08005': 0,
  '08006': 0,
  '08007': 0,
  '08008': 0,
  '08009': 0,
  '08010': 0,
  '08011': 0,
  '08012': 0,
  '08014': 0,
  '08015': 0,
  '08016': 0,
  '08018': 0,
  '08019': 0,
  '08020': 0,
  '08021': 0,
  '08022': 0,
  '08023': 0,
  '08025': 0,
  '08026': 0,
  '08027': 0,
  '08028': 0,
  '08029': 0,
  '08030': 0,
  '08031': 0,
  '08032': 0,
  '08033': 0,
  '08034': 0,
  '08035': 0,
  '08036': 0,
  '08037': 0,
  '08038': 0,
  '08039': 0,
  '08041': 0,
  '08042': 0,
  '08043': 0,
  '08045': 0,
  '08046': 0,
  '08048': 0,
  '08049': 0,
  '08050': 0,
  '08051': 0,
  '08052': 0,
  '08053': 0,
  '08054': 0,
  '08055': 0,
  '08056': 0,
  '08057': 0,
  '08059': 0,
  '08060': 0,
  '08061': 0,
  '08062': 0,
  '08063': 0,
  '08064': 0,
  '08065': 0,
  '08066': 0,
  '08067': 0,
  '08068': 0,
  '08069': 0,
  '08070': 0,
  '08071': 0,
  '08072': 0,
  '08073': 0,
  '08074': 0,
  '08075': 0,
  '08076': 0,
  '08077': 0,
  '08078': 0,
  '08079': 0,
  '08080': 0,
  '08081': 0,
  '08083': 0,
  '08084': 0,
  '08085': 0,
  '08086': 0,
  '08087': 0,
  '08088': 0,
  '08089': 0,
  '08090': 0,
  '08091': 0,
  '08092': 0,
  '08093': 0,
  '08094': 0,
  '08095': 0,
  '08096': 0,
  '08097': 0,
  '08098': 0,
  '08099': 0,
  '08100': 0,
  '08101': 0,
  '08102': 0,
  '08103': 0,
  '08104': 0,
  '08105': 0,
  '08106': 0,
  '08107': 0,
  '08108': 0,
  '08109': 0,
  '08110': 0,
  '08201': 0,
  '08202': 0,
  '08203': 0,
  '08204': 0,
  '08205': 0,
  '08210': 0,
  '08212': 0,
  '08213': 0,
  '08214': 0,
  '08215': 0,
  '08217': 0,
  '08218': 0,
  '08219': 0,
  '08220': 0,
  '08221': 0,
  '08223': 0,
  '08224': 0,
  '08225': 0,
  '08226': 0,
  '08230': 0,
  '08231': 0,
  '08232': 0,
  '08234': 0,
  '08240': 0,
  '08241': 0,
  '08242': 0,
  '08243': 0,
  '08244': 0,
  '08245': 0,
  '08246': 0,
  '08247': 0,
  '08248': 0,
  '08250': 0,
  '08251': 0,
  '08252': 0,
  '08260': 0,
  '08270': 0,
  '08302': 0,
  '08310': 0,
  '08311': 0,
  '08312': 0,
  '08313': 0,
  '08314': 0,
  '08315': 0,
  '08316': 0,
  '08317': 0,
  '08318': 0,
  '08319': 0,
  '08320': 0,
  '08321': 0,
  '08322': 0,
  '08323': 0,
  '08324': 0,
  '08326': 0,
  '08327': 0,
  '08328': 0,
  '08329': 0,
  '08330': 0,
  '08332': 0,
  '08340': 0,
  '08341': 0,
  '08342': 0,
  '08343': 0,
  '08344': 0,
  '08345': 0,
  '08346': 0,
  '08347': 0,
  '08348': 0,
  '08349': 0,
  '08350': 0,
  '08352': 0,
  '08353': 0,
  '08360': 0,
  '08361': 0,
  '08362': 0,
  '08400': 0,
  '08401': 0,
  '08402': 0,
  '08403': 0,
  '08404': 0,
  '08405': 0,
  '08406': 0,
  '08501': 0,
  '08502': 0,
  '08504': 0,
  '08505': 0,
  '08510': 0,
  '08511': 0,
  '08512': 0,
  '08514': 0,
  '08515': 0,
  '08518': 0,
  '08520': 0,
  '08525': 0,
  '08526': 0,
  '08527': 0,
  '08528': 0,
  '08530': 0,
  '08533': 0,
  '08534': 0,
  '08535': 0,
  '08536': 0,
  '08540': 0,
  '08541': 0,
  '08542': 0,
  '08543': 0,
  '08544': 0,
  '08550': 0,
  '08551': 0,
  '08553': 0,
  '08554': 0,
  '08555': 0,
  '08556': 0,
  '08557': 0,
  '08558': 0,
  '08559': 0,
  '08560': 0,
  '08561': 0,
  '08562': 0,
  '08570': 0,
  '08601': 0,
  '08602': 0,
  '08603': 0,
  '08604': 0,
  '08605': 0,
  '08606': 0,
  '08607': 0,
  '08608': 0,
  '08609': 0,
  '08610': 0,
  '08611': 0,
  '08618': 0,
  '08619': 0,
  '08620': 0,
  '08625': 0,
  '08628': 0,
  '08629': 0,
  '08638': 0,
  '08640': 0,
  '08641': 0,
  '08645': 0,
  '08646': 0,
  '08647': 0,
  '08648': 0,
  '08650': 0,
  '08666': 0,
  '08677': 0,
  '08690': 0,
  '08691': 0,
  '08695': 0,
  '08701': 0,
  '08720': 0,
  '08721': 0,
  '08722': 0,
  '08723': 0,
  '08724': 0,
  '08730': 0,
  '08731': 0,
  '08732': 0,
  '08733': 0,
  '08734': 0,
  '08735': 0,
  '08736': 0,
  '08738': 0,
  '08739': 0,
  '08740': 0,
  '08741': 0,
  '08742': 0,
  '08750': 0,
  '08751': 0,
  '08752': 0,
  '08753': 0,
  '08754': 0,
  '08755': 0,
  '08756': 0,
  '08757': 0,
  '08758': 0,
  '08759': 0,
  '08801': 0,
  '08802': 0,
  '08803': 0,
  '08804': 0,
  '08805': 0,
  '08807': 0,
  '08808': 0,
  '08809': 0,
  '08810': 0,
  '08812': 0,
  '08816': 0,
  '08817': 0,
  '08818': 0,
  '08820': 0,
  '08821': 0,
  '08822': 0,
  '08823': 0,
  '08824': 0,
  '08825': 0,
  '08826': 0,
  '08827': 0,
  '08828': 0,
  '08829': 0,
  '08830': 0,
  '08831': 0,
  '08832': 0,
  '08833': 0,
  '08834': 0,
  '08835': 0,
  '08836': 0,
  '08837': 0,
  '08840': 0,
  '08844': 0,
  '08846': 0,
  '08848': 0,
  '08850': 0,
  '08852': 0,
  '08853': 0,
  '08854': 0,
  '08855': 0,
  '08857': 0,
  '08858': 0,
  '08859': 0,
  '08861': 0,
  '08862': 0,
  '08863': 0,
  '08865': 0,
  '08867': 0,
  '08868': 0,
  '08869': 0,
  '08870': 0,
  '08871': 0,
  '08872': 0,
  '08873': 0,
  '08875': 0,
  '08876': 0,
  '08877': 0,
  '08878': 0,
  '08879': 0,
  '08880': 0,
  '08882': 0,
  '08884': 0,
  '08885': 0,
  '08886': 0,
  '08887': 0,
  '08888': 0,
  '08889': 0,
  '08890': 0,
  '08896': 0,
  '08899': 0,
  '08901': 0,
  '08902': 0,
  '08903': 0,
  '08904': 0,
  '08905': 0,
  '08906': 0,
  '08922': 0,
  '08933': 0,
  '08988': 0,
  '08989': 0,
};

export default zipcodeDatabase;
